var PT = Object.defineProperty;
var xd = (e) => {
  throw TypeError(e);
};
var OT = (e, t, n) => t in e ? PT(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var k = (e, t, n) => OT(e, typeof t != "symbol" ? t + "" : t, n), Cd = (e, t, n) => t.has(e) || xd("Cannot " + n);
var ws = (e, t, n) => (Cd(e, t, "read from private field"), n ? n.call(e) : t.get(e)), vs = (e, t, n) => t.has(e) ? xd("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Ns = (e, t, n, r) => (Cd(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import * as A from "react";
import Ze, { useMemo as ie, useReducer as DT, useLayoutEffect as rs, useRef as Ke, useState as de, useContext as ft, createContext as _t, useSyncExternalStore as LT, useDebugValue as MT, useEffect as xe, useCallback as ne, memo as he, Fragment as Sd, useId as HT, forwardRef as Je, createElement as Gu, Component as BT, useImperativeHandle as UT } from "react";
import "@winnin/ds-modal/styles.css";
import { Modal as ks } from "@winnin/ds-modal";
import { useTranslate as FT, useLanguage as jT } from "@winnin/i18n";
import * as Ka from "react-dom";
import $T from "react-dom";
import { featureFlagsClient as Id } from "@winnin/feature-flags";
import { CreatorCard as jr } from "@winnin/ds-creator-card";
import "@winnin/ds-creator-card/styles.css";
import { VideoCard as $r } from "@winnin/ds-video-card";
import "@winnin/ds-video-card/styles.css";
import { Icon as zT } from "@winnin/ds-icon";
import { ColumnsChart as VT, LineChart as YT, SyncMultipleDonut as GT } from "@winnin/ds-charts";
import { analyticsTracker as wd } from "@winnin/analytics";
import { useHistory as Vp, useLocation as WT } from "react-router-dom";
function Rr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bi = { exports: {} }, Rs = {};
var vd;
function qT() {
  if (vd) return Rs;
  vd = 1;
  var e = Ze, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, u, c) {
    var l, h = {}, m = null, p = null;
    c !== void 0 && (m = "" + c), u.key !== void 0 && (m = "" + u.key), u.ref !== void 0 && (p = u.ref);
    for (l in u) r.call(u, l) && !i.hasOwnProperty(l) && (h[l] = u[l]);
    if (o && o.defaultProps) for (l in u = o.defaultProps, u) h[l] === void 0 && (h[l] = u[l]);
    return { $$typeof: t, type: o, key: m, ref: p, props: h, _owner: s.current };
  }
  return Rs.Fragment = n, Rs.jsx = a, Rs.jsxs = a, Rs;
}
var Ps = {};
var Nd;
function KT() {
  return Nd || (Nd = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ze, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), s = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), c = /* @__PURE__ */ Symbol.for("react.suspense"), l = /* @__PURE__ */ Symbol.for("react.suspense_list"), h = /* @__PURE__ */ Symbol.for("react.memo"), m = /* @__PURE__ */ Symbol.for("react.lazy"), p = /* @__PURE__ */ Symbol.for("react.offscreen"), E = Symbol.iterator, g = "@@iterator";
    function _(N) {
      if (N === null || typeof N != "object")
        return null;
      var Q = E && N[E] || N[g];
      return typeof Q == "function" ? Q : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(N) {
      {
        for (var Q = arguments.length, se = new Array(Q > 1 ? Q - 1 : 0), ge = 1; ge < Q; ge++)
          se[ge - 1] = arguments[ge];
        C("error", N, se);
      }
    }
    function C(N, Q, se) {
      {
        var ge = b.ReactDebugCurrentFrame, $e = ge.getStackAddendum();
        $e !== "" && (Q += "%s", se = se.concat([$e]));
        var Ye = se.map(function(De) {
          return String(De);
        });
        Ye.unshift("Warning: " + Q), Function.prototype.apply.call(console[N], console, Ye);
      }
    }
    var R = !1, D = !1, I = !1, O = !1, U = !1, q;
    q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function P(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === r || N === i || U || N === s || N === c || N === l || O || N === p || R || D || I || typeof N == "object" && N !== null && (N.$$typeof === m || N.$$typeof === h || N.$$typeof === a || N.$$typeof === o || N.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === q || N.getModuleId !== void 0));
    }
    function z(N, Q, se) {
      var ge = N.displayName;
      if (ge)
        return ge;
      var $e = Q.displayName || Q.name || "";
      return $e !== "" ? se + "(" + $e + ")" : se;
    }
    function G(N) {
      return N.displayName || "Context";
    }
    function F(N) {
      if (N == null)
        return null;
      if (typeof N.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof N == "function")
        return N.displayName || N.name || null;
      if (typeof N == "string")
        return N;
      switch (N) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case o:
            var Q = N;
            return G(Q) + ".Consumer";
          case a:
            var se = N;
            return G(se._context) + ".Provider";
          case u:
            return z(N, N.render, "ForwardRef");
          case h:
            var ge = N.displayName || null;
            return ge !== null ? ge : F(N.type) || "Memo";
          case m: {
            var $e = N, Ye = $e._payload, De = $e._init;
            try {
              return F(De(Ye));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, H = 0, B, Y, $, Z, y, fe, Ce;
    function v() {
    }
    v.__reactDisabledLog = !0;
    function Se() {
      {
        if (H === 0) {
          B = console.log, Y = console.info, $ = console.warn, Z = console.error, y = console.group, fe = console.groupCollapsed, Ce = console.groupEnd;
          var N = {
            configurable: !0,
            enumerable: !0,
            value: v,
            writable: !0
          };
          Object.defineProperties(console, {
            info: N,
            log: N,
            warn: N,
            error: N,
            group: N,
            groupCollapsed: N,
            groupEnd: N
          });
        }
        H++;
      }
    }
    function _e() {
      {
        if (H--, H === 0) {
          var N = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, N, {
              value: B
            }),
            info: M({}, N, {
              value: Y
            }),
            warn: M({}, N, {
              value: $
            }),
            error: M({}, N, {
              value: Z
            }),
            group: M({}, N, {
              value: y
            }),
            groupCollapsed: M({}, N, {
              value: fe
            }),
            groupEnd: M({}, N, {
              value: Ce
            })
          });
        }
        H < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = b.ReactCurrentDispatcher, re;
    function Te(N, Q, se) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch ($e) {
            var ge = $e.stack.trim().match(/\n( *(at )?)/);
            re = ge && ge[1] || "";
          }
        return `
` + re + N;
      }
    }
    var ce = !1, ue;
    {
      var Ae = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new Ae();
    }
    function Pe(N, Q) {
      if (!N || ce)
        return "";
      {
        var se = ue.get(N);
        if (se !== void 0)
          return se;
      }
      var ge;
      ce = !0;
      var $e = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ye;
      Ye = pe.current, pe.current = null, Se();
      try {
        if (Q) {
          var De = function() {
            throw Error();
          };
          if (Object.defineProperty(De.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(De, []);
            } catch (wt) {
              ge = wt;
            }
            Reflect.construct(N, [], De);
          } else {
            try {
              De.call();
            } catch (wt) {
              ge = wt;
            }
            N.call(De.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (wt) {
            ge = wt;
          }
          N();
        }
      } catch (wt) {
        if (wt && ge && typeof wt.stack == "string") {
          for (var Oe = wt.stack.split(`
`), xt = ge.stack.split(`
`), et = Oe.length - 1, nt = xt.length - 1; et >= 1 && nt >= 0 && Oe[et] !== xt[nt]; )
            nt--;
          for (; et >= 1 && nt >= 0; et--, nt--)
            if (Oe[et] !== xt[nt]) {
              if (et !== 1 || nt !== 1)
                do
                  if (et--, nt--, nt < 0 || Oe[et] !== xt[nt]) {
                    var Vt = `
` + Oe[et].replace(" at new ", " at ");
                    return N.displayName && Vt.includes("<anonymous>") && (Vt = Vt.replace("<anonymous>", N.displayName)), typeof N == "function" && ue.set(N, Vt), Vt;
                  }
                while (et >= 1 && nt >= 0);
              break;
            }
        }
      } finally {
        ce = !1, pe.current = Ye, _e(), Error.prepareStackTrace = $e;
      }
      var Fr = N ? N.displayName || N.name : "", lr = Fr ? Te(Fr) : "";
      return typeof N == "function" && ue.set(N, lr), lr;
    }
    function qe(N, Q, se) {
      return Pe(N, !1);
    }
    function mt(N) {
      var Q = N.prototype;
      return !!(Q && Q.isReactComponent);
    }
    function Kt(N, Q, se) {
      if (N == null)
        return "";
      if (typeof N == "function")
        return Pe(N, mt(N));
      if (typeof N == "string")
        return Te(N);
      switch (N) {
        case c:
          return Te("Suspense");
        case l:
          return Te("SuspenseList");
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case u:
            return qe(N.render);
          case h:
            return Kt(N.type, Q, se);
          case m: {
            var ge = N, $e = ge._payload, Ye = ge._init;
            try {
              return Kt(Ye($e), Q, se);
            } catch {
            }
          }
        }
      return "";
    }
    var zt = Object.prototype.hasOwnProperty, An = {}, Li = b.ReactDebugCurrentFrame;
    function or(N) {
      if (N) {
        var Q = N._owner, se = Kt(N.type, N._source, Q ? Q.type : null);
        Li.setExtraStackFrame(se);
      } else
        Li.setExtraStackFrame(null);
    }
    function Mi(N, Q, se, ge, $e) {
      {
        var Ye = Function.call.bind(zt);
        for (var De in N)
          if (Ye(N, De)) {
            var Oe = void 0;
            try {
              if (typeof N[De] != "function") {
                var xt = Error((ge || "React class") + ": " + se + " type `" + De + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof N[De] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xt.name = "Invariant Violation", xt;
              }
              Oe = N[De](Q, De, ge, se, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (et) {
              Oe = et;
            }
            Oe && !(Oe instanceof Error) && (or($e), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ge || "React class", se, De, typeof Oe), or(null)), Oe instanceof Error && !(Oe.message in An) && (An[Oe.message] = !0, or($e), T("Failed %s type: %s", se, Oe.message), or(null));
          }
      }
    }
    var jo = Array.isArray;
    function Is(N) {
      return jo(N);
    }
    function $o(N) {
      {
        var Q = typeof Symbol == "function" && Symbol.toStringTag, se = Q && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return se;
      }
    }
    function zo(N) {
      try {
        return Hi(N), !1;
      } catch {
        return !0;
      }
    }
    function Hi(N) {
      return "" + N;
    }
    function V(N) {
      if (zo(N))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $o(N)), Hi(N);
    }
    var ee = b.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ve, je;
    function Ot(N) {
      if (zt.call(N, "ref")) {
        var Q = Object.getOwnPropertyDescriptor(N, "ref").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return N.ref !== void 0;
    }
    function yn(N) {
      if (zt.call(N, "key")) {
        var Q = Object.getOwnPropertyDescriptor(N, "key").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return N.key !== void 0;
    }
    function Qt(N, Q) {
      typeof N.ref == "string" && ee.current;
    }
    function ur(N, Q) {
      {
        var se = function() {
          ve || (ve = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        se.isReactWarning = !0, Object.defineProperty(N, "key", {
          get: se,
          configurable: !0
        });
      }
    }
    function cr(N, Q) {
      {
        var se = function() {
          je || (je = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        se.isReactWarning = !0, Object.defineProperty(N, "ref", {
          get: se,
          configurable: !0
        });
      }
    }
    var yt = function(N, Q, se, ge, $e, Ye, De) {
      var Oe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: N,
        key: Q,
        ref: se,
        props: De,
        // Record the component responsible for creating this element.
        _owner: Ye
      };
      return Oe._store = {}, Object.defineProperty(Oe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Oe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ge
      }), Object.defineProperty(Oe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $e
      }), Object.freeze && (Object.freeze(Oe.props), Object.freeze(Oe)), Oe;
    };
    function Ln(N, Q, se, ge, $e) {
      {
        var Ye, De = {}, Oe = null, xt = null;
        se !== void 0 && (V(se), Oe = "" + se), yn(Q) && (V(Q.key), Oe = "" + Q.key), Ot(Q) && (xt = Q.ref, Qt(Q, $e));
        for (Ye in Q)
          zt.call(Q, Ye) && !ye.hasOwnProperty(Ye) && (De[Ye] = Q[Ye]);
        if (N && N.defaultProps) {
          var et = N.defaultProps;
          for (Ye in et)
            De[Ye] === void 0 && (De[Ye] = et[Ye]);
        }
        if (Oe || xt) {
          var nt = typeof N == "function" ? N.displayName || N.name || "Unknown" : N;
          Oe && ur(De, nt), xt && cr(De, nt);
        }
        return yt(N, Oe, xt, $e, ge, ee.current, De);
      }
    }
    var Dt = b.ReactCurrentOwner, gd = b.ReactDebugCurrentFrame;
    function Ur(N) {
      if (N) {
        var Q = N._owner, se = Kt(N.type, N._source, Q ? Q.type : null);
        gd.setExtraStackFrame(se);
      } else
        gd.setExtraStackFrame(null);
    }
    var Vo;
    Vo = !1;
    function Yo(N) {
      return typeof N == "object" && N !== null && N.$$typeof === t;
    }
    function Ed() {
      {
        if (Dt.current) {
          var N = F(Dt.current.type);
          if (N)
            return `

Check the render method of \`` + N + "`.";
        }
        return "";
      }
    }
    function yT(N) {
      return "";
    }
    var bd = {};
    function xT(N) {
      {
        var Q = Ed();
        if (!Q) {
          var se = typeof N == "string" ? N : N.displayName || N.name;
          se && (Q = `

Check the top-level render call using <` + se + ">.");
        }
        return Q;
      }
    }
    function _d(N, Q) {
      {
        if (!N._store || N._store.validated || N.key != null)
          return;
        N._store.validated = !0;
        var se = xT(Q);
        if (bd[se])
          return;
        bd[se] = !0;
        var ge = "";
        N && N._owner && N._owner !== Dt.current && (ge = " It was passed a child from " + F(N._owner.type) + "."), Ur(N), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', se, ge), Ur(null);
      }
    }
    function Td(N, Q) {
      {
        if (typeof N != "object")
          return;
        if (Is(N))
          for (var se = 0; se < N.length; se++) {
            var ge = N[se];
            Yo(ge) && _d(ge, Q);
          }
        else if (Yo(N))
          N._store && (N._store.validated = !0);
        else if (N) {
          var $e = _(N);
          if (typeof $e == "function" && $e !== N.entries)
            for (var Ye = $e.call(N), De; !(De = Ye.next()).done; )
              Yo(De.value) && _d(De.value, Q);
        }
      }
    }
    function CT(N) {
      {
        var Q = N.type;
        if (Q == null || typeof Q == "string")
          return;
        var se;
        if (typeof Q == "function")
          se = Q.propTypes;
        else if (typeof Q == "object" && (Q.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Q.$$typeof === h))
          se = Q.propTypes;
        else
          return;
        if (se) {
          var ge = F(Q);
          Mi(se, N.props, "prop", ge, N);
        } else if (Q.PropTypes !== void 0 && !Vo) {
          Vo = !0;
          var $e = F(Q);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $e || "Unknown");
        }
        typeof Q.getDefaultProps == "function" && !Q.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ST(N) {
      {
        for (var Q = Object.keys(N.props), se = 0; se < Q.length; se++) {
          var ge = Q[se];
          if (ge !== "children" && ge !== "key") {
            Ur(N), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ge), Ur(null);
            break;
          }
        }
        N.ref !== null && (Ur(N), T("Invalid attribute `ref` supplied to `React.Fragment`."), Ur(null));
      }
    }
    var Ad = {};
    function yd(N, Q, se, ge, $e, Ye) {
      {
        var De = P(N);
        if (!De) {
          var Oe = "";
          (N === void 0 || typeof N == "object" && N !== null && Object.keys(N).length === 0) && (Oe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xt = yT();
          xt ? Oe += xt : Oe += Ed();
          var et;
          N === null ? et = "null" : Is(N) ? et = "array" : N !== void 0 && N.$$typeof === t ? (et = "<" + (F(N.type) || "Unknown") + " />", Oe = " Did you accidentally export a JSX literal instead of a component?") : et = typeof N, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", et, Oe);
        }
        var nt = Ln(N, Q, se, $e, Ye);
        if (nt == null)
          return nt;
        if (De) {
          var Vt = Q.children;
          if (Vt !== void 0)
            if (ge)
              if (Is(Vt)) {
                for (var Fr = 0; Fr < Vt.length; Fr++)
                  Td(Vt[Fr], N);
                Object.freeze && Object.freeze(Vt);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Td(Vt, N);
        }
        if (zt.call(Q, "key")) {
          var lr = F(N), wt = Object.keys(Q).filter(function(RT) {
            return RT !== "key";
          }), Go = wt.length > 0 ? "{key: someKey, " + wt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ad[lr + Go]) {
            var kT = wt.length > 0 ? "{" + wt.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Go, lr, kT, lr), Ad[lr + Go] = !0;
          }
        }
        return N === r ? ST(nt) : CT(nt), nt;
      }
    }
    function IT(N, Q, se) {
      return yd(N, Q, se, !0);
    }
    function wT(N, Q, se) {
      return yd(N, Q, se, !1);
    }
    var vT = wT, NT = IT;
    Ps.Fragment = r, Ps.jsx = vT, Ps.jsxs = NT;
  })()), Ps;
}
var kd;
function QT() {
  return kd || (kd = 1, process.env.NODE_ENV === "production" ? Bi.exports = qT() : Bi.exports = KT()), Bi.exports;
}
var d = QT();
function Rd(e) {
  const t = [];
  for (const n of e.effectTasks)
    try {
      n();
    } catch (r) {
      t.push(r);
    }
  if (t.length > 0) {
    if (t.length === 1)
      throw t[0];
    for (const n of t)
      console.error(n);
    throw new AggregateError(t, "Errors during commit");
  }
}
function Yp(e) {
  const t = [];
  for (const n of e.cells)
    if (n?.type === "effect" && (n.deps = null, n.cleanup))
      try {
        n.cleanup?.();
      } catch (r) {
        t.push(r);
      } finally {
        n.cleanup = void 0;
      }
  if (t.length > 0) {
    if (t.length === 1)
      throw t[0];
    for (const n of t)
      console.error(n);
    throw new AggregateError(t, "Errors during cleanup");
  }
}
const Nn = typeof process < "u" && (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test");
let Tr = null;
function XT(e, t) {
  e.currentIndex = 0;
  const n = Tr;
  Tr = e;
  try {
    if (t(), e.isFirstRender = !1, e.cells.length !== e.currentIndex)
      throw new Error(`Rendered ${e.currentIndex} hooks but expected ${e.cells.length}. Hooks must be called in the exact same order in every render.`);
  } finally {
    Tr = n;
  }
}
function qn() {
  if (!Tr)
    throw new Error("No resource fiber available");
  return Tr;
}
function JT(e) {
  return Nn ? Tr?.devStrictMode ? Tr.isFirstRender ? "child" : "root" : e ? "root" : null : null;
}
function ZT(e, t) {
  const n = e[Gp];
  if (!n)
    throw new Error("ResourceElement.type is not a valid Resource");
  return n(t);
}
const Gp = /* @__PURE__ */ Symbol("fnSymbol");
function ii(e, t, n = void 0, r = JT(!1)) {
  return {
    type: e,
    root: t,
    markDirty: n,
    devStrictMode: r,
    cells: [],
    currentIndex: 0,
    renderContext: void 0,
    isFirstRender: !0,
    isMounted: !1,
    isNeverMounted: !0
  };
}
function Zr(e) {
  if (!e.isMounted)
    throw new Error("Tried to unmount a fiber that is already unmounted");
  e.isMounted = !1, Yp(e);
}
function wn(e, t) {
  const n = {
    effectTasks: [],
    props: t,
    output: void 0
  };
  return XT(e, () => {
    e.renderContext = n;
    try {
      n.output = ZT(e.type, t);
    } finally {
      e.renderContext = void 0;
    }
  }), n;
}
function ss(e, t) {
  e.isMounted = !0, Nn && e.isNeverMounted && e.devStrictMode === "root" && (e.isNeverMounted = !1, Rd(t), Yp(e)), e.isNeverMounted = !1, Rd(t);
}
const Wp = (e) => ({
  version: 0,
  committedVersion: 0,
  dispatchUpdate: e,
  changelog: [],
  dirtyCells: []
}), Ca = (e) => {
  for (const t of e.dirtyCells)
    t.dirty = !1, t.queue.clear(), t.current = t.workInProgress;
  e.committedVersion = e.version, e.changelog.length = 0, e.dirtyCells.length = 0;
}, Ys = (e, t) => {
  const n = e.version > t;
  if (e.version = t, n) {
    for (const r of e.dirtyCells)
      r.dirty = !1, r.queue.clear(), r.workInProgress = r.current;
    if (e.dirtyCells.length = 0, t === e.committedVersion)
      e.changelog.length = 0;
    else {
      if (e.committedVersion > t)
        throw new Error("Version is less than committed version");
      for (; e.committedVersion + e.changelog.length > t; )
        e.changelog.pop();
      e.changelog.forEach((r) => r()), Ca(e);
    }
  }
}, Pd = (e, t) => {
  t.dirty || (t.dirty = !0, e.markDirty?.(), e.root.dirtyCells.push(t));
}, e1 = () => {
  if (!Nn)
    return null;
  const e = Ke(0), t = e.current === 0;
  return de(() => e.current++), e.current !== 2 ? null : t ? "child" : "root";
};
function t1(e) {
  const t = ie(() => Wp((o) => r(o)), []), [n, r] = DT((o, u) => (Ys(t, o), o + (u() ? 1 : 0)), 0);
  Ys(t, n);
  const s = e1(), i = ie(() => (e.key, ii(e.type, t, void 0, s)), [e.type, e.key, t, s]), a = wn(i, e.props);
  return rs(() => () => Zr(i), [i]), rs(() => {
    Ca(t), ss(i, a);
  }), a.output;
}
function Ue(e) {
  const t = (n) => ({
    type: t,
    props: n
  });
  return t[Gp] = e, t;
}
function kn(e, t) {
  return { ...t, key: e };
}
const qp = (e, t) => {
  const n = qn(), r = n.currentIndex++;
  if (!n.isFirstRender && r >= n.cells.length)
    throw new Error("Rendered more hooks than during the previous render. Hooks must be called in the exact same order in every render.");
  let s = n.cells[r];
  if (s || (s = t(), n.cells[r] = s), s.type !== e)
    throw new Error("Hook order changed between renders");
  return s;
}, n1 = (e) => {
  qn().renderContext.effectTasks.push(e);
}, r1 = (e, t) => {
  if (e.renderContext)
    throw new Error("Resource updated during render");
  if (e.isNeverMounted)
    throw new Error("Resource updated before mount");
  e.root.dispatchUpdate(() => {
    const n = t();
    return n ? (n(), e.root.changelog.push(n), !0) : !1;
  });
};
function Kp(e, t, n, r) {
  const s = qp("reducer", () => {
    const o = qn(), u = r ? r(n) : n;
    return Nn && o.devStrictMode && r && r(n), {
      type: "reducer",
      queue: /* @__PURE__ */ new Set(),
      dirty: !1,
      workInProgress: u,
      current: u,
      reducer: e,
      dispatch: (c) => {
        const l = {
          action: c,
          hasEagerState: !1,
          eagerState: void 0
        };
        r1(o, () => o.root.dirtyCells.length === 0 && !l.hasEagerState && (l.eagerState = e(s.workInProgress, c), l.hasEagerState = !0, Object.is(s.current, l.eagerState)) ? null : () => {
          Pd(o, s), s.queue.add(l);
        });
      }
    };
  }), i = qn(), a = e === s.reducer;
  s.reducer = e;
  for (const o of s.queue)
    (!o.hasEagerState || !a) && (o.eagerState = e(s.workInProgress, o.action), o.hasEagerState = !0), Nn && i.devStrictMode && e(s.workInProgress, o.action), s.workInProgress = o.eagerState;
  if (s.queue.clear(), t) {
    const o = t(s.workInProgress);
    Object.is(o, s.workInProgress) || (Pd(i, s), s.workInProgress = o);
  }
  return [s.workInProgress, s.dispatch];
}
function s1(e, t, n) {
  return Kp(e, void 0, t, n);
}
function i1(e, t, n, r) {
  return Kp(e, t, n, r);
}
const a1 = (e, t) => typeof t == "function" ? t(e) : t, o1 = (e) => typeof e == "function" ? e() : e;
function mn(e) {
  return s1(a1, e, o1);
}
const Qp = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!Object.is(e[n], t[n]))
      return !1;
  return !0;
}, u1 = () => ({
  type: "effect",
  cleanup: void 0,
  deps: null
  // null means the effect has never been run
});
function ht(e, t) {
  const n = qp("effect", u1);
  if (!(t && n.deps && Qp(n.deps, t))) {
    if (n.deps !== null && !!t != !!n.deps)
      throw new Error("tapEffect called with and without dependencies across re-renders");
    n1(() => {
      const r = [];
      try {
        n.cleanup?.();
      } catch (s) {
        r.push(s);
      } finally {
        n.cleanup = void 0;
      }
      try {
        const s = e();
        if (s !== void 0 && typeof s != "function")
          throw new Error(`An effect function must either return a cleanup function or nothing. Received: ${typeof s}`);
        n.cleanup = s;
      } catch (s) {
        r.push(s);
      }
      if (n.deps = t, r.length > 0) {
        if (r.length === 1)
          throw r[0];
        for (const s of r)
          console.error(s);
        throw new AggregateError(r, "Errors during commit");
      }
    });
  }
}
function Yn(e) {
  const [t] = mn(() => ({
    current: e
  }));
  return t;
}
function Ar(e, t) {
  const [n] = mn(e);
  return n;
}
const c1 = () => {
  throw new Error("Memo reducer should not be called");
}, Me = (e, t) => {
  const n = qn(), [r] = i1(c1, (s) => {
    if (s && Qp(s.deps, t))
      return s;
    const i = e();
    return Nn && n.devStrictMode && e(), { value: i, deps: t };
  }, null);
  return r.value;
}, Qa = (e, t) => Me(() => e, t);
function Hc(e) {
  const t = Yn(e);
  if (ht(() => {
    t.current = e;
  }), Nn) {
    const n = qn();
    return Qa(((...r) => {
      if (n.renderContext)
        throw new Error("tapEffectEvent cannot be called during render");
      return t.current(...r);
    }), [n]);
  }
  return t.current;
}
function Ft(e, t) {
  const n = qn(), r = Yn(0), s = Me(() => (e.key, ii(e.type, n.root, () => {
    r.current++, n.markDirty?.();
  })), [e.type, e.key, n]), i = t ? (
    // biome-ignore lint/correctness/useExhaustiveDependencies: user provided deps instead of prop identity
    Me(() => wn(s, e.props), [s, ...t, r.current])
  ) : wn(s, e.props);
  return ht(() => () => Zr(s), [s]), ht(() => {
    ss(s, i);
  }, [s, i]), i.output;
}
function Bc(e, t) {
  const n = Yn(0), r = n.current, s = Ar(qn), i = Ar(() => () => {
    n.current++, s.markDirty?.();
  }), a = Ar(() => /* @__PURE__ */ new Map()), o = t ? (
    // biome-ignore lint/correctness/useExhaustiveDependencies: library code
    Qa(e, t)
  ) : e, u = Me(() => {
    const c = o(), l = /* @__PURE__ */ new Set(), h = [];
    let m = 0;
    for (let p = 0; p < c.length; p++) {
      const E = c[p], g = E.key;
      if (g === void 0)
        throw new Error(`tapResources did not provide a key for array at index ${p}`);
      if (l.has(g))
        throw new Error(`Duplicate key ${g} in tapResources`);
      l.add(g);
      let _ = a.get(g);
      if (_)
        if (_.fiber.type !== E.type) {
          const b = ii(E.type, s.root, i), T = wn(b, E.props);
          _.next = [b, T], h.push(T.output);
        } else
          _.next = wn(_.fiber, E.props), h.push(_.next.output);
      else {
        const b = ii(E.type, s.root, i), T = wn(b, E.props);
        _ = {
          fiber: b,
          next: T
        }, m++, a.set(g, _), h.push(T.output);
      }
    }
    if (a.size > h.length - m)
      for (const p of a.keys())
        l.has(p) || (a.get(p).next = "delete");
    return h;
  }, [o, r]);
  return ht(() => () => {
    for (const c of a.keys()) {
      const l = a.get(c).fiber;
      Zr(l);
    }
  }, []), ht(() => {
    for (const [c, l] of a.entries())
      l.next === "delete" ? (l.fiber.isMounted && Zr(l.fiber), a.delete(c)) : Array.isArray(l.next) ? (Zr(l.fiber), l.fiber = l.next[0], ss(l.fiber, l.next[1])) : ss(l.fiber, l.next);
  }, [u]), u;
}
const l1 = 50;
let hn = {
  schedulers: /* @__PURE__ */ new Set([]),
  isScheduled: !1
};
class d1 {
  constructor(t) {
    k(this, "_task");
    k(this, "_isDirty", !1);
    this._task = t;
  }
  get isDirty() {
    return this._isDirty;
  }
  markDirty() {
    this._isDirty = !0, hn.schedulers.add(this), h1();
  }
  runTask() {
    this._isDirty = !1, this._task();
  }
}
const h1 = () => {
  hn.isScheduled || (hn.isScheduled = !0, f1());
}, Wu = () => {
  try {
    const e = [];
    let t = 0;
    for (const n of hn.schedulers)
      if (hn.schedulers.delete(n), !!n.isDirty) {
        if (t++, t > l1)
          throw new Error("Maximum update depth exceeded. This can happen when a resource repeatedly calls setState inside tapEffect.");
        try {
          n.runTask();
        } catch (r) {
          e.push(r);
        }
      }
    if (e.length > 0) {
      if (e.length === 1)
        throw e[0];
      for (const n of e)
        console.error(n);
      throw new AggregateError(e, "Errors occurred during flushSync");
    }
  } finally {
    hn.schedulers.clear(), hn.isScheduled = !1;
  }
}, f1 = (() => {
  if (typeof MessageChannel < "u") {
    const e = new MessageChannel();
    return e.port1.onmessage = Wu, () => e.port2.postMessage(null);
  }
  return () => setTimeout(Wu, 0);
})(), p1 = (e) => {
  const t = hn;
  hn = {
    schedulers: /* @__PURE__ */ new Set([]),
    isScheduled: !0
  };
  try {
    const n = e();
    return Wu(), n;
  } finally {
    hn = t;
  }
}, m1 = (e) => {
  const t = Ar(() => new d1(() => c(null))), n = Ar(() => []), r = Me(() => (e.key, ii(e.type, Wp((l) => {
    !t.isDirty && !l() || (n.push(l), t.markDirty());
  }))), [e.type, e.key]);
  Ys(r.root, r.root.committedVersion);
  const s = wn(r, e.props), i = Yn(!1), a = Yn(e.props), o = Yn(s.output), u = Ar(() => /* @__PURE__ */ new Set()), c = Hc((l) => {
    if (l === null && (Ys(r.root, 2), Ys(r.root, 1), n.forEach((h) => {
      Nn && r.devStrictMode && h(), h();
    }), Nn && r.devStrictMode && wn(r, a.current), l = wn(r, a.current)), t.isDirty)
      throw new Error("Scheduler is dirty, this should never happen");
    Ca(r.root), n.length = 0, i.current && ss(r, l), !(t.isDirty || o.current === l.output) && (o.current = l.output, u.forEach((h) => h()));
  });
  return ht(() => (i.current = !0, () => {
    i.current = !1, Zr(r);
  }), [r]), ht(() => {
    a.current = s.props, Ca(r.root), ss(r, s), !(t.isDirty || o.current === s.output) && (o.current = s.output, u.forEach((l) => l()));
  }), Me(() => ({
    getValue: () => o.current,
    subscribe: (l) => (u.add(l), () => u.delete(l))
  }), []);
}, Gs = /* @__PURE__ */ Symbol("tap.Context"), Xp = (e) => ({
  [Gs]: e
}), Jp = (e, t, n) => {
  const r = e[Gs];
  e[Gs] = t;
  try {
    return n();
  } finally {
    e[Gs] = r;
  }
}, Zp = (e) => e[Gs], qu = /* @__PURE__ */ Symbol("assistant-ui.store.clientIndex"), g1 = (e) => e[qu], em = Xp([]), Uc = () => Zp(em), E1 = (e, t) => {
  const n = Uc(), r = Me(() => [...n, e], [n, e]);
  return Jp(em, r, t);
}, b1 = /* @__PURE__ */ new Set(["$$typeof", "nodeType", "then"]), Xa = (e, t) => {
  if (e === Symbol.toStringTag)
    return t;
  if (typeof e != "symbol") {
    if (e === "toJSON")
      return () => t;
    if (!b1.has(e))
      return !1;
  }
};
class Fc {
  getOwnPropertyDescriptor(t, n) {
    const r = this.get(t, n);
    if (r !== void 0)
      return {
        value: r,
        writable: !1,
        enumerable: !0,
        configurable: !1
      };
  }
  set() {
    return !1;
  }
  setPrototypeOf() {
    return !1;
  }
  defineProperty() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !1;
  }
}
const tm = (e) => {
  const t = Ue(e);
  return (n) => {
    const r = t(n);
    return n.key === void 0 ? r : kn(n.key, r);
  };
}, Sa = /* @__PURE__ */ Symbol("assistant-ui.store.getValue"), _1 = (e) => {
  const t = e[Sa];
  if (!t)
    throw new Error("Client scope contains a non-client resource. Ensure your Derived get() returns a client created with tapClientResource(), not a plain resource.");
  return t.getState?.();
}, Od = /* @__PURE__ */ new Map();
function T1(e) {
  let t = Od.get(e);
  return t || (t = function(...n) {
    if (!this || typeof this != "object")
      throw new Error(`Method "${String(e)}" called without proper context. This may indicate the function was called incorrectly.`);
    const r = this[Sa];
    if (!r)
      throw new Error(`Method "${String(e)}" called on invalid client proxy. Ensure you are calling this method on a valid client instance.`);
    const s = r[e];
    if (!s)
      throw new Error(`Method "${String(e)}" is not implemented.`);
    if (typeof s != "function")
      throw new Error(`"${String(e)}" is not a function.`);
    return s(...n);
  }, Od.set(e, t)), t;
}
class A1 extends Fc {
  constructor(n, r) {
    super();
    k(this, "outputRef");
    k(this, "index");
    k(this, "boundFns");
    k(this, "cachedReceiver");
    this.outputRef = n, this.index = r;
  }
  get(n, r, s) {
    if (r === Sa)
      return this.outputRef.current;
    if (r === qu)
      return this.index;
    const i = Xa(r, "ClientProxy");
    if (i !== !1)
      return i;
    const a = this.outputRef.current[r];
    if (typeof a == "function") {
      this.cachedReceiver !== s && (this.boundFns = /* @__PURE__ */ new Map(), this.cachedReceiver = s);
      let o = this.boundFns.get(r);
      return o || (o = T1(r).bind(s), this.boundFns.set(r, o)), o;
    }
    return a;
  }
  ownKeys() {
    return Object.keys(this.outputRef.current);
  }
  has(n, r) {
    return r === Sa || r === qu ? !0 : r in this.outputRef.current;
  }
}
const nm = tm((e) => {
  const t = Yn(null), n = Uc().length, r = Me(() => new Proxy({}, new A1(t, n)), [n]), s = E1(r, () => Ft(e));
  t.current || (t.current = s), ht(() => {
    t.current = s;
  });
  const i = s.getState?.();
  return { methods: r, state: i, key: e.key };
}), Ja = (e) => Ft(nm(e)), Ws = /* @__PURE__ */ Symbol("assistant-ui.store.proxiedAssistantState"), Wo = (e) => e === "on" || e === "subscribe" || typeof e == "symbol", rm = (e) => {
  class t extends Fc {
    get(r, s) {
      const i = Xa(s, "AssistantState");
      if (i !== !1)
        return i;
      const a = s;
      if (!Wo(a))
        return _1(e[a]());
    }
    ownKeys() {
      return Object.keys(e).filter((r) => !Wo(r));
    }
    has(r, s) {
      return !Wo(s) && s in e;
    }
  }
  return new Proxy({}, new t());
}, y1 = (e) => e[Ws], Dd = () => () => {
}, sm = (e) => {
  const t = (() => {
    throw new Error(e);
  });
  return t.source = null, t.query = null, t;
};
class x1 extends Fc {
  get(t, n) {
    if (n === "subscribe" || n === "on")
      return Dd;
    if (n === Ws)
      return C1;
    const r = Xa(n, "DefaultAssistantClient");
    return r !== !1 ? r : sm("You are using a component or hook that requires an AuiProvider. Wrap your component in an <AuiProvider> component.");
  }
  ownKeys() {
    return ["subscribe", "on", Ws];
  }
  has(t, n) {
    return n === "subscribe" || n === "on" || n === Ws;
  }
}
const Za = new Proxy({}, new x1()), C1 = rm(Za), S1 = () => new Proxy({}, {
  get(e, t) {
    const n = Xa(t, "AssistantClient");
    return n !== !1 ? n : sm(`The current scope does not have a "${String(t)}" property.`);
  }
}), im = _t(Za), I1 = () => ft(im), Pr = ({ value: e, children: t }) => d.jsx(im.Provider, { value: e, children: t }), vn = Ue((e) => null), Ku = /* @__PURE__ */ Symbol("assistant-ui.transform-scopes");
function am(e, t) {
  const n = e;
  if (n[Ku])
    throw new Error("transformScopes is already attached to this resource");
  n[Ku] = t;
}
function w1(e) {
  return e[Ku];
}
function v1(e, t) {
  const n = { ...e }, r = /* @__PURE__ */ new Set();
  let s = !0;
  for (; s; ) {
    s = !1;
    for (const o of Object.values(n)) {
      if (o.type === vn || r.has(o.type))
        continue;
      r.add(o.type);
      const u = w1(o.type);
      if (u) {
        u(n, t), s = !0;
        break;
      }
    }
  }
  const i = {}, a = {};
  for (const [o, u] of Object.entries(n))
    u.type === vn ? a[o] = u : i[o] = u;
  return { rootClients: i, derivedClients: a };
}
const Ld = (e) => Me(() => e, [...Object.entries(e).flat()]), N1 = (e, t) => {
  const { rootClients: n, derivedClients: r } = v1(e, t);
  return {
    rootClients: Ld(n),
    derivedClients: Ld(r)
  };
}, om = (e) => typeof e == "string" ? { scope: e.split(".")[0], event: e } : { scope: e.scope, event: e.event }, k1 = Ue(() => Ar(() => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  return {
    on(r, s) {
      const i = s;
      if (r === "*")
        return t.add(i), () => t.delete(i);
      let a = e.get(r);
      return a || (a = /* @__PURE__ */ new Set(), e.set(r, a)), a.add(i), () => {
        a.delete(i), a.size === 0 && e.delete(r);
      };
    },
    emit(r, s, i) {
      const a = e.get(r);
      !a && t.size === 0 || queueMicrotask(() => {
        const o = [];
        if (a)
          for (const u of a)
            try {
              u(s, i);
            } catch (c) {
              o.push(c);
            }
        if (t.size > 0) {
          const u = { event: r, payload: s };
          for (const c of t)
            try {
              c(u, i);
            } catch (l) {
              o.push(l);
            }
        }
        if (o.length > 0) {
          if (o.length === 1)
            throw o[0];
          for (const u of o)
            console.error(u);
          throw new AggregateError(o, "Errors occurred during event emission");
        }
      });
    },
    subscribe(r) {
      return n.add(r), () => n.delete(r);
    },
    notifySubscribers() {
      for (const r of n)
        try {
          r();
        } catch (s) {
          console.error("NotificationManager: subscriber callback error", s);
        }
    }
  };
})), um = Xp(null), R1 = (e, t) => Jp(um, e, t), cm = () => {
  const e = Zp(um);
  if (!e)
    throw new Error("AssistantTapContext is not available");
  return e;
}, lm = () => cm().clientRef, jc = () => {
  const { emit: e } = cm(), t = Uc();
  return Hc((n, r) => {
    e(n, r, t);
  });
}, dm = (e) => Me(() => e, e), P1 = Ue(({ element: e, emit: t, clientRef: n }) => {
  const { methods: r, state: s } = R1({ clientRef: n, emit: t }, () => Ja(e));
  return Me(() => ({ state: s, methods: r }), [r, s]);
}), O1 = Ue(({ element: e, notifications: t, clientRef: n, name: r }) => {
  const s = m1(P1({ element: e, emit: t.emit, clientRef: n }));
  return ht(() => s.subscribe(t.notifySubscribers), [s, t]), Me(() => {
    const i = () => s.getValue().methods;
    return Object.defineProperties(i, {
      source: {
        value: "root",
        writable: !1
      },
      query: {
        value: {},
        writable: !1
      },
      name: {
        value: r,
        configurable: !0
      }
    }), i;
  }, [s, r]);
}), D1 = Ue(() => Me(() => ({
  clients: [],
  subscribe: void 0,
  on: void 0
}), [])), L1 = Ue(({ clients: e, clientRef: t }) => {
  const n = Ft(k1());
  ht(() => t.parent.subscribe(n.notifySubscribers), [t, n]);
  const r = dm(Bc(() => Object.keys(e).map((s) => kn(s, O1({
    element: e[s],
    notifications: n,
    clientRef: t,
    name: s
  }))), [e, n, t]));
  return Me(() => ({
    clients: r,
    subscribe: n.subscribe,
    on: function(s, i) {
      if (!this)
        throw new Error("const { on } = useAui() is not supported. Use aui.on() instead.");
      const { scope: a, event: o } = om(s);
      if (a !== "*" && this[a].source === null)
        throw new Error(`Scope "${a}" is not available. Use { scope: "*", event: "${o}" } to listen globally.`);
      const u = n.on(o, (l, h) => {
        if (a === "*") {
          i(l);
          return;
        }
        const m = this[a](), p = g1(m);
        m === h[p] && i(l);
      });
      if (a !== "*" && t.parent[a].source === null)
        return u;
      const c = t.parent.on(s, i);
      return () => {
        u(), c();
      };
    }
  }), [r, n, t]);
}), Md = (e, t, n) => {
  if ("source" in e && "query" in e)
    return e;
  if (n.dep === e)
    return n.meta;
  const r = e.getMeta(t.current);
  return n.meta = r, n.dep = e, r;
}, M1 = Ue(({ element: e, clientRef: t, name: n }) => {
  const r = Hc(() => e.props);
  return Me(() => {
    const s = () => r().get(t.current), i = {};
    return Object.defineProperties(s, {
      source: {
        get: () => Md(r(), t, i).source
      },
      query: {
        get: () => Md(r(), t, i).query
      },
      name: {
        value: n,
        configurable: !0
      }
    }), s;
  }, [t, n]);
}), H1 = Ue(({ clients: e, clientRef: t }) => dm(Bc(() => Object.keys(e).map((n) => kn(n, M1({
  element: e[n],
  clientRef: t,
  name: n
}))), [e, t]))), B1 = Ue(({ parent: e, clients: t }) => {
  const { rootClients: n, derivedClients: r } = N1(t, e), s = Yn({
    parent: e,
    current: null
  }).current;
  ht(() => {
    s.current = o;
  });
  const i = Ft(Object.keys(n).length > 0 ? L1({ clients: n, clientRef: s }) : D1()), a = Ft(H1({ clients: r, clientRef: s })), o = Me(() => {
    const u = e === Za ? S1() : e, c = Object.create(u);
    Object.assign(c, {
      subscribe: i.subscribe ?? e.subscribe,
      on: i.on ?? e.on,
      [Ws]: rm(c)
    });
    for (const l of i.clients)
      c[l.name] = l;
    for (const l of a)
      c[l.name] = l;
    return c;
  }, [e, i, a]);
  return s.current === null && (s.current = o), o;
});
function Re(e, { parent: t } = {
  parent: I1()
}) {
  if (e)
    return t1(B1({
      parent: t ?? Za,
      clients: e
    }));
  if (t === null)
    throw new Error("received null parent, this usage is not allowed");
  return t;
}
const J = (e) => {
  const t = Re(), n = y1(t), r = LT(t.subscribe, () => e(n), () => e(n));
  if (r === n)
    throw new Error("You tried to return the entire AssistantState. This is not supported due to technical limitations.");
  return MT(r), r;
}, U1 = Ze.createContext(!0);
function Hd() {
  throw new Error("A function wrapped in useEffectEvent can't be called during rendering.");
}
const F1 = "use" in Ze ? () => {
  try {
    return Ze.use(U1);
  } catch {
    return !1;
  }
} : () => !1;
function j1(e) {
  const t = Ze.useRef(Hd);
  return Ze.useInsertionEffect(() => {
    t.current = e;
  }, [e]), (...n) => {
    F1() && Hd();
    const r = t.current;
    return r(...n);
  };
}
const qo = (e, t) => {
  const n = Re(), r = j1(t), { scope: s, event: i } = om(e);
  xe(() => n.on({ scope: s, event: i }, r), [n, s, i, r]);
}, $1 = (e) => {
  const t = Re(), n = Ke(void 0);
  return J(() => (n.current === void 0 && (n.current = e(t)), n.current)), () => (n.current = void 0, e(t));
}, z1 = Object.freeze({});
function $c({ getItemState: e, children: t }) {
  const n = $1(e);
  return V1(t(n));
}
const V1 = (e) => {
  const t = typeof e == "object" && e != null && "type" in e ? e : null, n = t?.type, r = t?.key, s = typeof t?.props == "object" && t.props != null && Object.entries(t.props).length === 0 ? z1 : t?.props;
  return (
    // biome-ignore lint/correctness/useExhaustiveDependencies: optimization
    ie(() => t, [n, r, s]) ?? e
  );
}, Y1 = tm((e) => {
  if (e.key === void 0)
    throw new Error("tapClientResource: Element has no key");
  return Ft(nm(e));
});
function is(e, t) {
  const n = Bc(
    () => e().map((a) => Y1(a)),
    // biome-ignore lint/correctness/useExhaustiveDependencies: getElementsDeps is passed through from caller
    t
  ), r = Me(() => Object.keys(n), [n]), s = Me(() => n.reduce((a, o, u) => (a[o.key] = u, a), {}), [n]);
  return {
    state: Me(() => n.map((a) => a.state), [n]),
    get: (a) => {
      if ("index" in a) {
        if (a.index < 0 || a.index >= r.length)
          throw new Error(`tapClientLookup: Index ${a.index} out of bounds (length: ${r.length})`);
        return n[a.index].methods;
      }
      const o = s[a.key];
      if (o === void 0)
        throw new Error(`tapClientLookup: Key "${a.key}" not found`);
      return n[o].methods;
    }
  };
}
const Bd = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, l) => {
    const h = typeof c == "function" ? c(t) : c;
    if (!Object.is(h, t)) {
      const m = t;
      t = l ?? (typeof h != "object" || h === null) ? h : Object.assign({}, t, h), n.forEach((p) => p(t, m));
    }
  }, s = () => t, o = { setState: r, getState: s, getInitialState: () => u, subscribe: (c) => (n.add(c), () => n.delete(c)) }, u = t = e(r, s, o);
  return o;
}, G1 = ((e) => e ? Bd(e) : Bd), W1 = (e) => e;
function q1(e, t = W1) {
  const n = Ze.useSyncExternalStore(
    e.subscribe,
    Ze.useCallback(() => t(e.getState()), [e, t]),
    Ze.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return Ze.useDebugValue(n), n;
}
const Ud = (e) => {
  const t = G1(e), n = (r) => q1(t, r);
  return Object.assign(n, t), n;
}, as = ((e) => e ? Ud(e) : Ud), K1 = Ue((e) => ({
  getState: () => e
})), Q1 = Ue((e) => {
  const [t] = mn(() => ({
    suggestions: (e ?? []).map((s) => typeof s == "string" ? {
      title: s,
      label: "",
      prompt: s
    } : {
      title: s.title,
      label: s.label,
      prompt: s.prompt
    })
  })), n = is(() => t.suggestions.map((r, s) => kn(s, K1(r))), [t.suggestions]);
  return {
    getState: () => t,
    suggestion: ({ index: r }) => n.get({ index: r })
  };
}), X1 = Q1, J1 = Object.freeze({
  type: "complete"
}), Z1 = Ue(({ parts: e, getMessagePart: t }) => {
  const [n, r] = mn(!0), s = Me(() => e[e.length - 1]?.status ?? J1, [e]), i = Me(() => ({ parts: e, collapsed: n, status: s }), [e, n, s]);
  return {
    getState: () => i,
    setCollapsed: r,
    part: t
  };
}), eA = (e) => Array.from(e).map((n) => n.getModelContext()).sort((n, r) => (r.priority ?? 0) - (n.priority ?? 0)).reduce((n, r) => {
  if (r.system && (n.system ? n.system += `

${r.system}` : n.system = r.system), r.tools)
    for (const [s, i] of Object.entries(r.tools)) {
      const a = n.tools?.[s];
      if (a && a !== i)
        throw new Error(`You tried to define a tool with the name ${s}, but it already exists.`);
      n.tools || (n.tools = {}), n.tools[s] = i;
    }
  return r.config && (n.config = {
    ...n.config,
    ...r.config
  }), r.callSettings && (n.callSettings = {
    ...n.callSettings,
    ...r.callSettings
  }), n;
}, {});
class zc {
  constructor() {
    k(this, "_providers", /* @__PURE__ */ new Set());
    k(this, "_subscribers", /* @__PURE__ */ new Set());
  }
  getModelContext() {
    return eA(this._providers);
  }
  registerModelContextProvider(t) {
    this._providers.add(t);
    const n = t.subscribe?.(() => {
      this.notifySubscribers();
    });
    return this.notifySubscribers(), () => {
      this._providers.delete(t), n?.(), this.notifySubscribers();
    };
  }
  notifySubscribers() {
    for (const t of this._subscribers)
      t();
  }
  subscribe(t) {
    return this._subscribers.add(t), () => this._subscribers.delete(t);
  }
}
const tA = 1, hm = Ue(() => {
  const [e] = mn(() => ({ version: tA + 1 })), t = Me(() => new zc(), []);
  return {
    getState: () => e,
    getModelContext: () => t.getModelContext(),
    subscribe: (n) => t.subscribe(n),
    register: (n) => t.registerModelContextProvider(n)
  };
}), fm = Ue(({ toolkit: e }) => {
  const [t, n] = mn(() => ({
    tools: {}
  })), r = lm(), s = Qa((i, a) => (n((o) => ({
    ...o,
    tools: {
      ...o.tools,
      [i]: [...o.tools[i] ?? [], a]
    }
  })), () => {
    n((o) => ({
      ...o,
      tools: {
        ...o.tools,
        [i]: o.tools[i]?.filter((u) => u !== a) ?? []
      }
    }));
  }), []);
  return ht(() => {
    if (!e)
      return;
    const i = [];
    for (const [u, c] of Object.entries(e))
      c.render && i.push(s(u, c.render));
    const a = Object.entries(e).reduce((u, [c, l]) => {
      const { render: h, ...m } = l;
      return u[c] = m, u;
    }, {}), o = {
      getModelContext: () => ({
        tools: a
      })
    };
    return i.push(r.current.modelContext().register(o)), () => {
      i.forEach((u) => u());
    };
  }, [e, s, r]), {
    getState: () => t,
    setToolUI: s
  };
});
am(fm, (e, t) => {
  !e.modelContext && t.modelContext.source === null && (e.modelContext = hm());
});
const nA = Ue(() => {
  const [e, t] = mn(() => ({
    renderers: {}
  })), n = Qa((r, s) => (t((i) => ({
    ...i,
    renderers: {
      ...i.renderers,
      [r]: [...i.renderers[r] ?? [], s]
    }
  })), () => {
    t((i) => ({
      ...i,
      renderers: {
        ...i.renderers,
        [r]: i.renderers[r]?.filter((a) => a !== s) ?? []
      }
    }));
  }), []);
  return {
    getState: () => e,
    setDataUI: n
  };
}), Qu = {
  toResponse(e, t) {
    return new Response(Qu.toByteStream(e, t), {
      headers: t.headers ?? {}
    });
  },
  fromResponse(e, t) {
    return Qu.fromByteStream(e.body, t);
  },
  toByteStream(e, t) {
    return e.pipeThrough(t);
  },
  fromByteStream(e, t) {
    return e.pipeThrough(t);
  }
}, pm = function() {
  let e, t;
  const n = new Promise((r, s) => {
    e = r, t = s;
  });
  if (!e || !t)
    throw new Error("Failed to create promise");
  return { promise: n, resolve: e, reject: t };
}, rA = () => {
  const e = [];
  let t = !1, n, r;
  const s = (a) => {
    a.promise || (a.promise = a.reader.read().then(({ done: o, value: u }) => {
      a.promise = void 0, o ? (e.splice(e.indexOf(a), 1), t && e.length === 0 && n.close()) : n.enqueue(u), r?.resolve(), r = void 0;
    }).catch((o) => {
      console.error(o), e.forEach((u) => {
        u.reader.cancel();
      }), e.length = 0, n.error(o), r?.reject(o), r = void 0;
    }));
  };
  return {
    readable: new ReadableStream({
      start(a) {
        n = a;
      },
      pull() {
        return r = pm(), e.forEach((a) => {
          s(a);
        }), r.promise;
      },
      cancel() {
        e.forEach((a) => {
          a.reader.cancel();
        }), e.length = 0;
      }
    }),
    isSealed() {
      return t;
    },
    seal() {
      t = !0, e.length === 0 && n.close();
    },
    addStream(a) {
      if (t)
        throw new Error("Cannot add streams after the run callback has settled.");
      const o = { reader: a.getReader() };
      e.push(o), s(o);
    },
    enqueue(a) {
      this.addStream(new ReadableStream({
        start(o) {
          o.enqueue(a), o.close();
        }
      }));
    }
  };
};
class Fd {
  constructor(t) {
    k(this, "_controller");
    k(this, "_isClosed", !1);
    this._controller = t;
  }
  append(t) {
    return this._controller.enqueue({
      type: "text-delta",
      path: [],
      textDelta: t
    }), this;
  }
  close() {
    this._isClosed || (this._isClosed = !0, this._controller.enqueue({
      type: "part-finish",
      path: []
    }), this._controller.close());
  }
}
const mm = (e) => new ReadableStream({
  start(t) {
    return e.start?.(new Fd(t));
  },
  pull(t) {
    return e.pull?.(new Fd(t));
  },
  cancel(t) {
    return e.cancel?.(t);
  }
}), jd = () => {
  let e;
  return [mm({
    start(n) {
      e = n;
    }
  }), e];
};
class $d {
  constructor(t) {
    k(this, "_controller");
    k(this, "_isClosed", !1);
    k(this, "_mergeTask");
    k(this, "_argsTextController");
    this._controller = t;
    const n = mm({
      start: (s) => {
        this._argsTextController = s;
      }
    });
    let r = !1;
    this._mergeTask = n.pipeTo(new WritableStream({
      write: (s) => {
        switch (s.type) {
          case "text-delta":
            r = !0, this._controller.enqueue(s);
            break;
          case "part-finish":
            r || this._controller.enqueue({
              type: "text-delta",
              textDelta: "{}",
              path: []
            }), this._controller.enqueue({
              type: "tool-call-args-text-finish",
              path: []
            });
            break;
          default:
            throw new Error(`Unexpected chunk type: ${s.type}`);
        }
      }
    }));
  }
  get argsText() {
    return this._argsTextController;
  }
  async setResponse(t) {
    this._argsTextController.close(), await Promise.resolve(), this._controller.enqueue({
      type: "result",
      path: [],
      ...t.artifact !== void 0 ? { artifact: t.artifact } : {},
      result: t.result,
      isError: t.isError ?? !1,
      ...t.messages !== void 0 ? { messages: t.messages } : {}
    });
  }
  async close() {
    this._isClosed || (this._isClosed = !0, this._argsTextController.close(), await this._mergeTask, this._controller.enqueue({
      type: "part-finish",
      path: []
    }), this._controller.close());
  }
}
const sA = (e) => new ReadableStream({
  start(t) {
    return e.start?.(new $d(t));
  },
  pull(t) {
    return e.pull?.(new $d(t));
  },
  cancel(t) {
    return e.cancel?.(t);
  }
}), iA = () => {
  let e;
  return [sA({
    start(n) {
      e = n;
    }
  }), e];
};
class gm {
  constructor() {
    k(this, "value", -1);
  }
  up() {
    return ++this.value;
  }
}
class aA extends TransformStream {
  constructor(t) {
    super({
      transform(n, r) {
        r.enqueue({
          ...n,
          path: [t, ...n.path]
        });
      }
    });
  }
}
class MF extends TransformStream {
  constructor(t) {
    super({
      transform(n, r) {
        const { path: [s, ...i] } = n;
        if (t !== s)
          throw new Error(`Path mismatch: expected ${t}, got ${s}`);
        r.enqueue({
          ...n,
          path: i
        });
      }
    });
  }
}
class oA extends TransformStream {
  constructor(t) {
    const n = new gm(), r = /* @__PURE__ */ new Map();
    super({
      transform(s, i) {
        s.type === "part-start" && s.path.length === 0 && r.set(n.up(), t.up());
        const [a, ...o] = s.path;
        if (a === void 0) {
          i.enqueue(s);
          return;
        }
        const u = r.get(a);
        if (u === void 0)
          throw new Error("Path not found");
        i.enqueue({
          ...s,
          path: [u, ...o]
        });
      }
    });
  }
}
class uA extends TransformStream {
  constructor(t, n, r) {
    const [s, i] = dA();
    let a;
    super({
      start(o) {
        return a = s.pipeTo(new WritableStream({
          write(u) {
            o.enqueue(u);
          },
          abort(u) {
            o.error(u);
          },
          close() {
            o.terminate();
          }
        })).catch((u) => {
          o.error(u);
        }), t.start?.(i);
      },
      transform(o) {
        return t.transform?.(o, i);
      },
      async flush() {
        await t.flush?.(i), i.close(), await a;
      }
    }, n, r);
  }
}
class cA extends TransformStream {
  constructor(t) {
    super();
    const n = t(super.readable);
    Object.defineProperty(this, "readable", {
      value: n,
      writable: !1
    });
  }
}
let Em = (e, t = 21) => (n = t) => {
  let r = "", s = n | 0;
  for (; s--; )
    r += e[Math.random() * e.length | 0];
  return r;
};
const bm = Em("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7);
class Vc {
  constructor(t) {
    k(this, "_state");
    k(this, "_parentId");
    this._state = t || {
      merger: rA(),
      contentCounter: new gm()
    };
  }
  get __internal_isClosed() {
    return this._state.merger.isSealed();
  }
  __internal_getReadable() {
    return this._state.merger.readable;
  }
  __internal_subscribeToClose(t) {
    this._state.closeSubscriber = t;
  }
  _addPart(t, n) {
    this._state.append && (this._state.append.controller.close(), this._state.append = void 0), this.enqueue({
      type: "part-start",
      part: t,
      path: []
    }), this._state.merger.addStream(n.pipeThrough(new aA(this._state.contentCounter.value)));
  }
  merge(t) {
    this._state.merger.addStream(t.pipeThrough(new oA(this._state.contentCounter)));
  }
  appendText(t) {
    this._state.append?.kind !== "text" && (this._state.append = {
      kind: "text",
      controller: this.addTextPart()
    }), this._state.append.controller.append(t);
  }
  appendReasoning(t) {
    this._state.append?.kind !== "reasoning" && (this._state.append = {
      kind: "reasoning",
      controller: this.addReasoningPart()
    }), this._state.append.controller.append(t);
  }
  addTextPart() {
    const [t, n] = jd();
    return this._addPart({ type: "text" }, t), n;
  }
  addReasoningPart() {
    const [t, n] = jd();
    return this._addPart({ type: "reasoning" }, t), n;
  }
  addToolCallPart(t) {
    const n = typeof t == "string" ? { toolName: t } : t, r = n.toolName, s = n.toolCallId ?? bm(), [i, a] = iA();
    return this._addPart({
      type: "tool-call",
      toolName: r,
      toolCallId: s,
      ...this._parentId && { parentId: this._parentId }
    }, i), n.argsText !== void 0 && (a.argsText.append(n.argsText), a.argsText.close()), n.args !== void 0 && (a.argsText.append(JSON.stringify(n.args)), a.argsText.close()), n.response !== void 0 && a.setResponse(n.response), a;
  }
  appendSource(t) {
    this._addPart({ ...t, ...this._parentId && { parentId: this._parentId } }, new ReadableStream({
      start(n) {
        n.enqueue({
          type: "part-finish",
          path: []
        }), n.close();
      }
    }));
  }
  appendFile(t) {
    this._addPart(t, new ReadableStream({
      start(n) {
        n.enqueue({
          type: "part-finish",
          path: []
        }), n.close();
      }
    }));
  }
  enqueue(t) {
    this._state.merger.enqueue(t), t.type === "part-start" && t.path.length === 0 && this._state.contentCounter.up();
  }
  withParentId(t) {
    const n = new Vc(this._state);
    return n._parentId = t, n;
  }
  close() {
    this._state.append?.controller?.close(), this._state.merger.seal(), this._state.closeSubscriber?.();
  }
}
function lA(e) {
  const t = new Vc();
  return (async () => {
    try {
      await e(t);
    } catch (r) {
      throw t.__internal_isClosed || t.enqueue({
        type: "error",
        path: [],
        error: String(r)
      }), r;
    } finally {
      t.__internal_isClosed || t.close();
    }
  })(), t.__internal_getReadable();
}
function dA() {
  const { resolve: e, promise: t } = pm();
  let n;
  return [lA((s) => (n = s, n.__internal_subscribeToClose(e), t)), n];
}
var dr = { exports: {} }, zd;
function hA() {
  if (zd) return dr.exports;
  zd = 1;
  const e = typeof Buffer < "u", t = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/, n = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
  function r(o, u, c) {
    c == null && u !== null && typeof u == "object" && (c = u, u = void 0), e && Buffer.isBuffer(o) && (o = o.toString()), o && o.charCodeAt(0) === 65279 && (o = o.slice(1));
    const l = JSON.parse(o, u);
    if (l === null || typeof l != "object")
      return l;
    const h = c && c.protoAction || "error", m = c && c.constructorAction || "error";
    if (h === "ignore" && m === "ignore")
      return l;
    if (h !== "ignore" && m !== "ignore") {
      if (t.test(o) === !1 && n.test(o) === !1)
        return l;
    } else if (h !== "ignore" && m === "ignore") {
      if (t.test(o) === !1)
        return l;
    } else if (n.test(o) === !1)
      return l;
    return s(l, { protoAction: h, constructorAction: m, safe: c && c.safe });
  }
  function s(o, { protoAction: u = "error", constructorAction: c = "error", safe: l } = {}) {
    let h = [o];
    for (; h.length; ) {
      const m = h;
      h = [];
      for (const p of m) {
        if (u !== "ignore" && Object.prototype.hasOwnProperty.call(p, "__proto__")) {
          if (l === !0)
            return null;
          if (u === "error")
            throw new SyntaxError("Object contains forbidden prototype property");
          delete p.__proto__;
        }
        if (c !== "ignore" && Object.prototype.hasOwnProperty.call(p, "constructor") && p.constructor !== null && typeof p.constructor == "object" && Object.prototype.hasOwnProperty.call(p.constructor, "prototype")) {
          if (l === !0)
            return null;
          if (c === "error")
            throw new SyntaxError("Object contains forbidden prototype property");
          delete p.constructor;
        }
        for (const E in p) {
          const g = p[E];
          g && typeof g == "object" && h.push(g);
        }
      }
    }
    return o;
  }
  function i(o, u, c) {
    const { stackTraceLimit: l } = Error;
    Error.stackTraceLimit = 0;
    try {
      return r(o, u, c);
    } finally {
      Error.stackTraceLimit = l;
    }
  }
  function a(o, u) {
    const { stackTraceLimit: c } = Error;
    Error.stackTraceLimit = 0;
    try {
      return r(o, u, { safe: !0 });
    } catch {
      return;
    } finally {
      Error.stackTraceLimit = c;
    }
  }
  return dr.exports = i, dr.exports.default = i, dr.exports.parse = i, dr.exports.safeParse = a, dr.exports.scan = s, dr.exports;
}
var fA = hA();
const Vd = /* @__PURE__ */ Rr(fA);
function pA(e) {
  const t = ["ROOT"];
  let n = -1, r = null;
  const s = [];
  let i;
  function a() {
    i !== void 0 && (s.push(JSON.parse(`"${i}"`)), i = void 0);
  }
  function o(h, m, p) {
    switch (h) {
      case '"': {
        n = m, t.pop(), t.push(p), t.push("INSIDE_STRING"), a();
        break;
      }
      case "f":
      case "t":
      case "n": {
        n = m, r = m, t.pop(), t.push(p), t.push("INSIDE_LITERAL");
        break;
      }
      case "-": {
        t.pop(), t.push(p), t.push("INSIDE_NUMBER"), a();
        break;
      }
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9": {
        n = m, t.pop(), t.push(p), t.push("INSIDE_NUMBER"), a();
        break;
      }
      case "{": {
        n = m, t.pop(), t.push(p), t.push("INSIDE_OBJECT_START"), a();
        break;
      }
      case "[": {
        n = m, t.pop(), t.push(p), t.push("INSIDE_ARRAY_START"), a();
        break;
      }
    }
  }
  function u(h, m) {
    switch (h) {
      case ",": {
        t.pop(), t.push("INSIDE_OBJECT_AFTER_COMMA");
        break;
      }
      case "}": {
        n = m, t.pop(), i = s.pop();
        break;
      }
    }
  }
  function c(h, m) {
    switch (h) {
      case ",": {
        t.pop(), t.push("INSIDE_ARRAY_AFTER_COMMA"), i = (Number(i) + 1).toString();
        break;
      }
      case "]": {
        n = m, t.pop(), i = s.pop();
        break;
      }
    }
  }
  for (let h = 0; h < e.length; h++) {
    const m = e[h];
    switch (t[t.length - 1]) {
      case "ROOT":
        o(m, h, "FINISH");
        break;
      case "INSIDE_OBJECT_START": {
        switch (m) {
          case '"': {
            t.pop(), t.push("INSIDE_OBJECT_KEY"), i = "";
            break;
          }
          case "}": {
            n = h, t.pop(), i = s.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_COMMA": {
        m === '"' && (t.pop(), t.push("INSIDE_OBJECT_KEY"), i = "");
        break;
      }
      case "INSIDE_OBJECT_KEY": {
        switch (m) {
          case '"': {
            t.pop(), t.push("INSIDE_OBJECT_AFTER_KEY");
            break;
          }
          case "\\": {
            t.push("INSIDE_STRING_ESCAPE"), i += m;
            break;
          }
          default: {
            i += m;
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_KEY": {
        m === ":" && (t.pop(), t.push("INSIDE_OBJECT_BEFORE_VALUE"));
        break;
      }
      case "INSIDE_OBJECT_BEFORE_VALUE": {
        o(m, h, "INSIDE_OBJECT_AFTER_VALUE");
        break;
      }
      case "INSIDE_OBJECT_AFTER_VALUE": {
        u(m, h);
        break;
      }
      case "INSIDE_STRING": {
        switch (m) {
          case '"': {
            t.pop(), n = h, i = s.pop();
            break;
          }
          case "\\": {
            t.push("INSIDE_STRING_ESCAPE");
            break;
          }
          default:
            n = h;
        }
        break;
      }
      case "INSIDE_ARRAY_START": {
        m === "]" ? (n = h, t.pop(), i = s.pop()) : (n = h, i = "0", o(m, h, "INSIDE_ARRAY_AFTER_VALUE"));
        break;
      }
      case "INSIDE_ARRAY_AFTER_VALUE": {
        switch (m) {
          case ",": {
            t.pop(), t.push("INSIDE_ARRAY_AFTER_COMMA"), i = (Number(i) + 1).toString();
            break;
          }
          case "]": {
            n = h, t.pop(), i = s.pop();
            break;
          }
          default: {
            n = h;
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_COMMA": {
        o(m, h, "INSIDE_ARRAY_AFTER_VALUE");
        break;
      }
      case "INSIDE_STRING_ESCAPE": {
        t.pop(), t[t.length - 1] === "INSIDE_STRING" ? n = h : t[t.length - 1] === "INSIDE_OBJECT_KEY" && (i += m);
        break;
      }
      case "INSIDE_NUMBER": {
        switch (m) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9": {
            n = h;
            break;
          }
          case "e":
          case "E":
          case "-":
          case ".":
            break;
          case ",": {
            t.pop(), i = s.pop(), t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(m, h), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" && u(m, h);
            break;
          }
          case "}": {
            t.pop(), i = s.pop(), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" && u(m, h);
            break;
          }
          case "]": {
            t.pop(), i = s.pop(), t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(m, h);
            break;
          }
          default: {
            t.pop(), i = s.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_LITERAL": {
        const E = e.substring(r, h + 1);
        !"false".startsWith(E) && !"true".startsWith(E) && !"null".startsWith(E) ? (t.pop(), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" ? u(m, h) : t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(m, h)) : n = h;
        break;
      }
    }
  }
  let l = e.slice(0, n + 1);
  for (let h = t.length - 1; h >= 0; h--)
    switch (t[h]) {
      case "INSIDE_STRING": {
        l += '"';
        break;
      }
      case "INSIDE_OBJECT_KEY":
      case "INSIDE_OBJECT_AFTER_KEY":
      case "INSIDE_OBJECT_AFTER_COMMA":
      case "INSIDE_OBJECT_START":
      case "INSIDE_OBJECT_BEFORE_VALUE":
      case "INSIDE_OBJECT_AFTER_VALUE": {
        l += "}";
        break;
      }
      case "INSIDE_ARRAY_START":
      case "INSIDE_ARRAY_AFTER_COMMA":
      case "INSIDE_ARRAY_AFTER_VALUE": {
        l += "]";
        break;
      }
      case "INSIDE_LITERAL": {
        const p = e.substring(r, e.length);
        "true".startsWith(p) ? l += "true".slice(p.length) : "false".startsWith(p) ? l += "false".slice(p.length) : "null".startsWith(p) && (l += "null".slice(p.length));
      }
    }
  return [l, s];
}
const Ko = /* @__PURE__ */ Symbol("aui.parse-partial-json-object.meta"), eo = (e) => {
  if (e.length === 0)
    return {
      [Ko]: { state: "partial", partialPath: [] }
    };
  try {
    const t = Vd.parse(e);
    if (typeof t != "object" || t === null)
      throw new Error("argsText is expected to be an object");
    return t[Ko] = {
      state: "complete",
      partialPath: []
    }, t;
  } catch {
    try {
      const [t, n] = pA(e), r = Vd.parse(t);
      if (typeof r != "object" || r === null)
        throw new Error("argsText is expected to be an object");
      return r[Ko] = {
        state: "partial",
        partialPath: n
      }, r;
    } catch {
      return;
    }
  }
};
class qs {
  constructor(t = null) {
    k(this, "_state");
    this._state = t;
  }
  get state() {
    return this._state;
  }
  append(t) {
    this._state = t.reduce((n, r) => qs.apply(n, r), this._state);
  }
  static apply(t, n) {
    const r = n.type;
    switch (r) {
      case "set":
        return qs.updatePath(t, n.path, () => n.value);
      case "append-text":
        return qs.updatePath(t, n.path, (s) => {
          if (typeof s != "string")
            throw new Error(`Expected string at path [${n.path.join(", ")}]`);
          return s + n.value;
        });
      default: {
        const s = r;
        throw new Error(`Invalid operation type: ${s}`);
      }
    }
  }
  static updatePath(t, n, r) {
    if (n.length === 0)
      return r(t);
    if (t ?? (t = {}), typeof t != "object")
      throw new Error(`Invalid path: [${n.join(", ")}]`);
    const [s, ...i] = n;
    if (Array.isArray(t)) {
      const o = Number(s);
      if (Number.isNaN(o))
        throw new Error(`Expected array index at [${n.join(", ")}]`);
      if (o > t.length || o < 0)
        throw new Error("Insert array index out of bounds");
      const u = [...t];
      return u[o] = this.updatePath(u[o], i, r), u;
    }
    const a = { ...t };
    return a[s] = this.updatePath(a[s], i, r), a;
  }
}
class mA {
  constructor() {
    k(this, "_streamStartTime");
    k(this, "_firstTokenTime");
    k(this, "_totalChunks", 0);
    k(this, "_toolCallIds", /* @__PURE__ */ new Set());
    this._streamStartTime = Date.now();
  }
  recordChunk() {
    this._totalChunks++;
  }
  recordFirstToken() {
    this._firstTokenTime === void 0 && (this._firstTokenTime = Date.now());
  }
  recordToolCallStart(t) {
    this._toolCallIds.add(t);
  }
  getTiming(t, n) {
    const s = Date.now() - this._streamStartTime, i = t && t > 0 ? t : n ? Math.ceil(n.length / 4) : void 0, a = i && s > 0 ? i / s * 1e3 : void 0;
    return {
      streamStartTime: this._streamStartTime,
      ...this._firstTokenTime !== void 0 ? { firstTokenTime: this._firstTokenTime - this._streamStartTime } : void 0,
      totalStreamTime: s,
      ...i !== void 0 ? { tokenCount: i } : void 0,
      ...a !== void 0 ? { tokensPerSecond: a } : void 0,
      totalChunks: this._totalChunks,
      toolCallCount: this._toolCallIds.size
    };
  }
}
const gA = ({ unstable_state: e = null } = {}) => ({
  role: "assistant",
  status: { type: "running" },
  parts: [],
  get content() {
    return this.parts;
  },
  metadata: {
    unstable_state: e,
    unstable_data: [],
    unstable_annotations: [],
    steps: [],
    custom: {}
  }
}), to = (e, t, n) => {
  if (e.parts.length === 0)
    throw new Error("No parts available to update.");
  if (t.path.length !== 1)
    throw new Error("Nested paths are not supported yet.");
  const r = t.path[0], s = n(e.parts[r]);
  return {
    ...e,
    parts: [
      ...e.parts.slice(0, r),
      s,
      ...e.parts.slice(r + 1)
    ],
    get content() {
      return this.parts;
    }
  };
}, EA = (e, t) => {
  const n = t.part;
  if (n.type === "text" || n.type === "reasoning") {
    const r = {
      type: n.type,
      text: "",
      status: { type: "running" },
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "tool-call") {
    const r = {
      type: "tool-call",
      state: "partial-call",
      status: { type: "running", isArgsComplete: !1 },
      toolCallId: n.toolCallId,
      toolName: n.toolName,
      argsText: "",
      args: {},
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "source") {
    const r = {
      type: "source",
      sourceType: n.sourceType,
      id: n.id,
      url: n.url,
      ...n.title ? { title: n.title } : void 0,
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "file") {
    const r = {
      type: "file",
      mimeType: n.mimeType,
      data: n.data
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else
    throw new Error(`Unsupported part type: ${n.type}`);
}, bA = (e, t) => to(e, t, (n) => {
  if (n.type !== "tool-call")
    throw new Error("Last is not a tool call");
  return n.state !== "partial-call" ? n : {
    ...n,
    state: "call"
  };
}), _A = (e, t) => to(e, t, (n) => ({
  ...n,
  status: { type: "complete", reason: "unknown" }
})), TA = (e, t) => to(e, t, (n) => {
  if (n.type === "text" || n.type === "reasoning")
    return { ...n, text: n.text + t.textDelta };
  if (n.type === "tool-call") {
    const r = n.argsText + t.textDelta, s = eo(r) ?? n.args;
    return { ...n, argsText: r, args: s };
  } else
    throw new Error("text-delta received but part is neither text nor tool-call");
}), AA = (e, t) => to(e, t, (n) => {
  if (n.type === "tool-call")
    return {
      ...n,
      state: "result",
      ...t.artifact !== void 0 ? { artifact: t.artifact } : {},
      result: t.result,
      isError: t.isError ?? !1,
      ...t.messages !== void 0 ? { messages: t.messages } : {},
      status: { type: "complete", reason: "stop" }
    };
  throw new Error("Result chunk received but part is not a tool-call");
}), Yd = (e, t) => {
  if (e.status?.type === "incomplete" && e.status?.reason === "error")
    return e;
  const n = yA(t);
  return { ...e, status: n };
}, yA = (e) => e.finishReason === "tool-calls" ? {
  type: "requires-action",
  reason: "tool-calls"
} : e.finishReason === "stop" || e.finishReason === "unknown" ? {
  type: "complete",
  reason: e.finishReason
} : {
  type: "incomplete",
  reason: e.finishReason
}, xA = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    unstable_annotations: [
      ...e.metadata.unstable_annotations,
      ...t.annotations
    ]
  }
}), CA = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    unstable_data: [...e.metadata.unstable_data, ...t.data]
  }
}), SA = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    steps: [
      ...e.metadata.steps,
      { state: "started", messageId: t.messageId }
    ]
  }
}), IA = (e, t) => {
  const n = e.metadata.steps.slice(), r = n.length - 1;
  return n.length > 0 && n[r]?.state === "started" ? n[r] = {
    ...n[r],
    state: "finished",
    finishReason: t.finishReason,
    usage: t.usage,
    isContinued: t.isContinued
  } : n.push({
    state: "finished",
    messageId: bm(),
    finishReason: t.finishReason,
    usage: t.usage,
    isContinued: t.isContinued
  }), {
    ...e,
    metadata: {
      ...e.metadata,
      steps: n
    }
  };
}, wA = (e, t) => ({
  ...e,
  status: { type: "incomplete", reason: "error", error: t.error }
}), vA = (e, t) => {
  const n = new qs(e.metadata.unstable_state);
  return n.append(t.operations), {
    ...e,
    metadata: {
      ...e.metadata,
      unstable_state: n.state
    }
  };
}, Gd = (e, t) => {
  let n = 0;
  for (const s of t.metadata.steps)
    s.state === "finished" && s.usage && (n += s.usage.outputTokens);
  let r = "";
  for (const s of t.parts)
    (s.type === "text" || s.type === "reasoning") && (r += s.text);
  return e.getTiming(n > 0 ? n : void 0, r || void 0);
}, NA = (e) => {
  let t = !1;
  return () => {
    t || (t = !0, queueMicrotask(() => {
      t = !1, e();
    }));
  };
};
class kA extends TransformStream {
  constructor({ initialMessage: t, throttle: n, onError: r } = {}) {
    let s = t ?? gA();
    const i = new mA();
    let a;
    const o = n ? NA(() => {
      a?.enqueue(s);
    }) : () => {
      a?.enqueue(s);
    };
    super({
      start(u) {
        a = u;
      },
      transform(u) {
        i.recordChunk();
        const c = u.type;
        switch (c) {
          case "part-start":
            s = EA(s, u), u.part.type === "tool-call" && i.recordToolCallStart(u.part.toolCallId);
            break;
          case "tool-call-args-text-finish":
            s = bA(s, u);
            break;
          case "part-finish":
            s = _A(s, u);
            break;
          case "text-delta":
            s = TA(s, u), i.recordFirstToken();
            break;
          case "result":
            s = AA(s, u);
            break;
          case "message-finish":
            s = Yd(s, u);
            break;
          case "annotations":
            s = xA(s, u);
            break;
          case "data":
            s = CA(s, u);
            break;
          case "step-start":
            s = SA(s, u);
            break;
          case "step-finish":
            s = IA(s, u);
            break;
          case "error":
            s = wA(s, u), r?.(u.error);
            break;
          case "update-state":
            s = vA(s, u);
            break;
          default: {
            const l = c;
            throw new Error(`Unsupported chunk type: ${l}`);
          }
        }
        s.status.type !== "running" && (s = {
          ...s,
          metadata: {
            ...s.metadata,
            timing: Gd(i, s)
          }
        }), o();
      },
      flush(u) {
        if (s.status?.type === "running") {
          const c = s.parts?.some((l) => l.type === "tool-call" && (l.state === "call" || l.state === "partial-call") && l.result === void 0) ?? !1;
          s = Yd(s, {
            finishReason: c ? "tool-calls" : "unknown"
          }), s = {
            ...s,
            metadata: {
              ...s.metadata,
              timing: Gd(i, s)
            }
          }, u.enqueue(s);
        }
      }
    });
  }
}
class RA extends cA {
  constructor() {
    super((t) => {
      const n = new uA({
        transform(r, s) {
          s.appendText(r);
        }
      });
      return t.pipeThrough(new TextDecoderStream()).pipeThrough(n);
    });
  }
}
class Ks {
  constructor(t) {
    k(this, "readable");
    this.readable = t, this.readable = t;
  }
  static fromAssistantStream(t) {
    return new Ks(t.pipeThrough(new kA()));
  }
  async unstable_result() {
    let t;
    for await (const n of this)
      t = n;
    return t || {
      role: "assistant",
      status: { type: "complete", reason: "unknown" },
      parts: [],
      content: [],
      metadata: {
        unstable_state: null,
        unstable_data: [],
        unstable_annotations: [],
        steps: [],
        custom: {}
      }
    };
  }
  [Symbol.asyncIterator]() {
    const t = this.readable.getReader();
    return {
      async next() {
        const { done: n, value: r } = await t.read();
        return n ? { done: !0, value: void 0 } : { done: !1, value: r };
      }
    };
  }
  tee() {
    const [t, n] = this.readable.tee();
    return [
      new Ks(t),
      new Ks(n)
    ];
  }
}
const Wd = /* @__PURE__ */ Symbol.for("aui.tool-response");
class Ia {
  constructor(t) {
    k(this, "artifact");
    k(this, "result");
    k(this, "isError");
    k(this, "messages");
    t.artifact !== void 0 && (this.artifact = t.artifact), this.result = t.result, this.isError = t.isError ?? !1, t.messages !== void 0 && (this.messages = t.messages);
  }
  get [Wd]() {
    return !0;
  }
  static [Symbol.hasInstance](t) {
    return typeof t == "object" && t !== null && Wd in t;
  }
  static toResponse(t) {
    return t instanceof Ia ? t : new Ia({
      result: t === void 0 ? "<no result>" : t
    });
  }
}
const Or = (e) => {
  const [, t] = mn(e.getState);
  return ht(() => (t(e.getState()), e.subscribe(() => {
    t(e.getState());
  })), [e]), e.getState();
}, _m = Ue(({ runtime: e }) => {
  const t = Or(e);
  return {
    getState: () => t,
    remove: e.remove,
    __internal_getRuntime: () => e
  };
}), PA = Ue(({ runtime: e }) => {
  const t = Or(e);
  return {
    getState: () => t,
    addToolResult: (n) => e.addToolResult(n),
    resumeToolCall: (n) => e.resumeToolCall(n),
    __internal_getRuntime: () => e
  };
}), OA = Ue(({ runtime: e, index: t }) => {
  const n = Me(() => e.getAttachmentByIndex(t), [e, t]);
  return Ft(_m({
    runtime: n
  }));
}), Tm = Ue(({ threadIdRef: e, messageIdRef: t, runtime: n }) => {
  const r = Or(n), s = jc();
  ht(() => {
    const o = [];
    for (const u of ["send", "attachmentAdd"]) {
      const c = n.unstable_on(u, () => {
        s(`composer.${u}`, {
          threadId: e.current,
          ...t && { messageId: t.current }
        });
      });
      o.push(c);
    }
    return o.push(n.unstable_on("attachmentAddError", () => {
      const u = n.getState().attachments.findLast((c) => c.status.type === "incomplete" && c.status.reason === "error");
      s("composer.attachmentAddError", {
        threadId: e.current,
        ...t && { messageId: t.current },
        ...u && { attachmentId: u.id }
      });
    })), () => {
      for (const u of o)
        u();
    };
  }, [n, s, e, t]);
  const i = is(() => r.attachments.map((o, u) => kn(o.id, OA({
    runtime: n,
    index: u
  }))), [r.attachments, n]), a = Me(() => ({
    text: r.text,
    role: r.role,
    attachments: i.state,
    runConfig: r.runConfig,
    isEditing: r.isEditing,
    canCancel: r.canCancel,
    attachmentAccept: r.attachmentAccept,
    isEmpty: r.isEmpty,
    type: r.type ?? "thread",
    dictation: r.dictation,
    quote: r.quote,
    queue: []
  }), [r, i.state]);
  return {
    getState: () => a,
    setText: n.setText,
    setRole: n.setRole,
    setRunConfig: n.setRunConfig,
    addAttachment: n.addAttachment,
    reset: n.reset,
    clearAttachments: n.clearAttachments,
    send: n.send,
    cancel: n.cancel,
    beginEdit: n.beginEdit ?? (() => {
      throw new Error("beginEdit is not supported in this runtime");
    }),
    startDictation: n.startDictation,
    stopDictation: n.stopDictation,
    setQuote: n.setQuote,
    attachment: (o) => "id" in o ? i.get({ key: o.id }) : i.get(o),
    queueItem: () => {
      throw new Error("Queue is not supported in this runtime");
    },
    __internal_getRuntime: () => n
  };
}), DA = Ue(({ runtime: e, index: t }) => {
  const n = Me(() => e.getAttachmentByIndex(t), [e, t]);
  return Ft(_m({ runtime: n }));
}), LA = Ue(({ runtime: e, index: t }) => {
  const n = Me(() => e.getMessagePartByIndex(t), [e, t]);
  return Ft(PA({ runtime: n }));
}), MA = Ue(({ runtime: e, threadIdRef: t }) => {
  const n = Or(e), [r, s] = mn(!1), [i, a] = mn(!1), o = Me(() => ({
    get current() {
      return e.getState().id;
    }
  }), [e]), u = Ja(Tm({
    runtime: e.composer,
    threadIdRef: t,
    messageIdRef: o
  })), c = is(() => n.content.map((m, p) => kn("toolCallId" in m && m.toolCallId != null ? `toolCallId-${m.toolCallId}` : `index-${p}`, LA({ runtime: e, index: p }))), [n.content, e]), l = is(() => (n.attachments ?? []).map((m, p) => kn(m.id, DA({ runtime: e, index: p }))), [n.attachments, e]), h = Me(() => ({
    ...n,
    parts: c.state,
    composer: u.state,
    isCopied: r,
    isHovering: i
  }), [
    n,
    c.state,
    u.state,
    r,
    i
  ]);
  return {
    getState: () => h,
    composer: () => u.methods,
    reload: (m) => e.reload(m),
    speak: () => e.speak(),
    stopSpeaking: () => e.stopSpeaking(),
    submitFeedback: (m) => e.submitFeedback(m),
    switchToBranch: (m) => e.switchToBranch(m),
    getCopyText: () => e.unstable_getCopyText(),
    part: (m) => "index" in m ? c.get({ index: m.index }) : c.get({ key: `toolCallId-${m.toolCallId}` }),
    attachment: (m) => "id" in m ? l.get({ key: m.id }) : l.get(m),
    setIsCopied: s,
    setIsHovering: a,
    __internal_getRuntime: () => e
  };
}), HA = Ue(({ runtime: e, id: t, threadIdRef: n }) => {
  const r = Me(() => e.getMessageById(t), [e, t]);
  return Ft(MA({ runtime: r, threadIdRef: n }));
}), BA = Ue(({ runtime: e }) => {
  const t = Or(e), n = jc();
  ht(() => {
    const o = [], u = [
      "runStart",
      "runEnd",
      "initialize",
      "modelContextUpdate"
    ];
    for (const c of u) {
      const l = e.unstable_on(c, () => {
        const h = e.getState()?.threadId || "unknown";
        n(`thread.${c}`, {
          threadId: h
        });
      });
      o.push(l);
    }
    return () => {
      for (const c of o)
        c();
    };
  }, [e, n]);
  const r = Me(() => ({
    get current() {
      return e.getState().threadId;
    }
  }), [e]), s = Ja(Tm({
    runtime: e.composer,
    threadIdRef: r
  })), i = is(() => t.messages.map((o) => kn(o.id, HA({ runtime: e, id: o.id, threadIdRef: r }))), [t.messages, e, r]), a = Me(() => ({
    isEmpty: i.state.length === 0 && !t.isLoading,
    isDisabled: t.isDisabled,
    isLoading: t.isLoading,
    isRunning: t.isRunning,
    capabilities: t.capabilities,
    state: t.state,
    suggestions: t.suggestions,
    extras: t.extras,
    speech: t.speech,
    composer: s.state,
    messages: i.state
  }), [t, i, s.state]);
  return {
    getState: () => a,
    composer: () => s.methods,
    append: e.append,
    startRun: e.startRun,
    resumeRun: e.resumeRun,
    unstable_resumeRun: e.resumeRun,
    cancelRun: e.cancelRun,
    getModelContext: e.getModelContext,
    export: e.export,
    import: e.import,
    reset: e.reset,
    stopSpeaking: e.stopSpeaking,
    startVoice: async () => {
      throw new Error("startVoice is not supported in this runtime");
    },
    stopVoice: async () => {
      throw new Error("stopVoice is not supported in this runtime");
    },
    message: (o) => "id" in o ? i.get({ key: o.id }) : i.get(o),
    __internal_getRuntime: () => e
  };
}), Am = Ue(({ runtime: e }) => {
  const t = Or(e), n = jc();
  return ht(() => {
    const r = [], s = [
      "switchedTo",
      "switchedAway"
    ];
    for (const i of s) {
      const a = e.unstable_on(i, () => {
        n(`threadListItem.${i}`, {
          threadId: e.getState().id
        });
      });
      r.push(a);
    }
    return () => {
      for (const i of r)
        i();
    };
  }, [e, n]), {
    getState: () => t,
    switchTo: e.switchTo,
    rename: e.rename,
    archive: e.archive,
    unarchive: e.unarchive,
    delete: e.delete,
    generateTitle: e.generateTitle,
    initialize: e.initialize,
    detach: e.detach,
    __internal_getRuntime: () => e
  };
}), UA = Ue(({ runtime: e, id: t }) => {
  const n = Me(() => e.getItemById(t), [e, t]);
  return Ft(Am({
    runtime: n
  }));
}), FA = Ue(({ runtime: e, __internal_assistantRuntime: t }) => {
  const n = Or(e), r = Ja(BA({
    runtime: e.main
  })), s = is(() => Object.keys(n.threadItems).map((a) => kn(a, UA({ runtime: e, id: a }))), [n.threadItems, e]), i = Me(() => ({
    mainThreadId: n.mainThreadId,
    newThreadId: n.newThreadId ?? null,
    isLoading: n.isLoading,
    threadIds: n.threadIds,
    archivedThreadIds: n.archivedThreadIds,
    threadItems: s.state,
    main: r.state
  }), [n, s.state, r.state]);
  return {
    getState: () => i,
    thread: () => r.methods,
    item: (a) => {
      if (a === "main")
        return s.get({ key: i.mainThreadId });
      if ("id" in a)
        return s.get({ key: a.id });
      const { index: o, archived: u = !1 } = a, c = u ? i.archivedThreadIds[o] : i.threadIds[o];
      return s.get({ key: c });
    },
    switchToThread: async (a) => {
      await e.switchToThread(a);
    },
    switchToNewThread: async () => {
      await e.switchToNewThread();
    },
    __internal_getAssistantRuntime: () => t
  };
}), jA = Ue((e) => {
  const t = lm();
  return ht(() => e.registerModelContextProvider(t.current.modelContext()), [e, t]), Ft(FA({
    runtime: e.threads,
    __internal_assistantRuntime: e
  }));
}), $A = (e, t) => {
  e.thread ?? (e.thread = vn({
    source: "threads",
    query: { type: "main" },
    get: (n) => n.threads().thread("main")
  })), e.threadListItem ?? (e.threadListItem = vn({
    source: "threads",
    query: { type: "main" },
    get: (n) => n.threads().item("main")
  })), e.composer ?? (e.composer = vn({
    source: "thread",
    query: {},
    get: (n) => n.threads().thread("main").composer()
  })), !e.modelContext && t.modelContext.source === null && (e.modelContext = hm()), !e.suggestions && t.suggestions.source === null && (e.suggestions = X1());
}, zA = ({ runtime: e, children: t }) => {
  const n = Re({
    threadListItem: Am({ runtime: e })
  });
  return d.jsx(Pr, { value: n, children: t });
}, ym = ({ index: e, children: t }) => {
  const n = Re({
    message: vn({
      source: "thread",
      query: { type: "index", index: e },
      get: (r) => r.thread().message({ index: e })
    }),
    composer: vn({
      source: "message",
      query: {},
      get: (r) => r.thread().message({ index: e }).composer()
    })
  });
  return d.jsx(Pr, { value: n, children: t });
}, xm = ({ index: e, children: t }) => {
  const n = Re({
    part: vn({
      source: "message",
      query: { type: "index", index: e },
      get: (r) => r.message().part({ index: e })
    })
  });
  return d.jsx(Pr, { value: n, children: t });
}, VA = Ue(({ text: e, isRunning: t }) => {
  const n = Me(() => ({
    type: "text",
    text: e,
    status: t ? { type: "running" } : { type: "complete" }
  }), [e, t]);
  return {
    getState: () => n,
    addToolResult: () => {
      throw new Error("Not supported");
    },
    resumeToolCall: () => {
      throw new Error("Not supported");
    }
  };
}), YA = ({ text: e, isRunning: t = !1, children: n }) => {
  const r = Re({
    part: VA({ text: e, isRunning: t })
  });
  return d.jsx(Pr, { value: r, children: n });
}, GA = ({ startIndex: e, endIndex: t, children: n }) => {
  const r = J((a) => a.message.parts).slice(e, t + 1), s = Re(), i = Re({
    chainOfThought: Z1({
      parts: r,
      getMessagePart: ({ index: a }) => {
        if (a < 0 || a >= r.length)
          throw new Error(`ChainOfThought part index ${a} is out of bounds (0..${r.length - 1})`);
        return s.message().part({ index: e + a });
      }
    })
  });
  return d.jsx(Pr, { value: i, children: n });
}, Cm = ({ index: e, archived: t, children: n }) => {
  const r = Re({
    threadListItem: vn({
      source: "threads",
      query: { type: "index", index: e, archived: t },
      get: (s) => s.threads().item({ index: e, archived: t })
    })
  });
  return d.jsx(Pr, { value: r, children: n });
}, tn = /* @__PURE__ */ Symbol("skip-update");
function WA(e, t) {
  if (e === void 0 && t === void 0)
    return !0;
  if (e === void 0 || t === void 0)
    return !1;
  for (const n of Object.keys(e)) {
    const r = e[n], s = t[n];
    if (!Object.is(r, s))
      return !1;
  }
  return !0;
}
class Ti {
  constructor() {
    k(this, "_subscribers", /* @__PURE__ */ new Set());
  }
  subscribe(t) {
    return this._subscribers.add(t), () => this._subscribers.delete(t);
  }
  waitForUpdate() {
    return new Promise((t) => {
      const n = this.subscribe(() => {
        n(), t();
      });
    });
  }
  _notifySubscribers() {
    const t = [];
    for (const n of this._subscribers)
      try {
        n();
      } catch (r) {
        t.push(r);
      }
    if (t.length > 0) {
      if (t.length === 1)
        throw t[0];
      for (const n of t)
        console.error(n);
      throw new AggregateError(t);
    }
  }
}
class no {
  constructor() {
    k(this, "_subscriptions", /* @__PURE__ */ new Set());
    k(this, "_connection");
  }
  get isConnected() {
    return !!this._connection;
  }
  notifySubscribers() {
    for (const t of this._subscriptions)
      t();
  }
  _updateConnection() {
    if (this._subscriptions.size > 0) {
      if (this._connection)
        return;
      this._connection = this._connect();
    } else
      this._connection?.(), this._connection = void 0;
  }
  subscribe(t) {
    return this._subscriptions.add(t), this._updateConnection(), () => {
      this._subscriptions.delete(t), this._updateConnection();
    };
  }
}
class Zt extends no {
  constructor(n) {
    super();
    k(this, "binding");
    k(this, "_previousState");
    k(this, "getState", () => (this.isConnected || this._syncState(), this._previousState));
    this.binding = n;
    const r = n.getState();
    if (r === tn)
      throw new Error("Entry not available in the store");
    this._previousState = r;
  }
  get path() {
    return this.binding.path;
  }
  _syncState() {
    const n = this.binding.getState();
    return n === tn || WA(n, this._previousState) ? !1 : (this._previousState = n, !0);
  }
  _connect() {
    const n = () => {
      this._syncState() && this.notifySubscribers();
    };
    return this.binding.subscribe(n);
  }
}
class Yc extends no {
  constructor(n) {
    super();
    k(this, "binding");
    k(this, "_previousStateDirty", !0);
    k(this, "_previousState");
    k(this, "getState", () => {
      if (!this.isConnected || this._previousStateDirty) {
        const n = this.binding.getState();
        n !== tn && (this._previousState = n), this._previousStateDirty = !1;
      }
      if (this._previousState === void 0)
        throw new Error("Entry not available in the store");
      return this._previousState;
    });
    this.binding = n;
  }
  get path() {
    return this.binding.path;
  }
  _connect() {
    const n = () => {
      this._previousStateDirty = !0, this.notifySubscribers();
    };
    return this.binding.subscribe(n);
  }
}
class wa extends no {
  constructor(n) {
    super();
    k(this, "binding");
    this.binding = n;
  }
  get path() {
    return this.binding.path;
  }
  getState() {
    return this.binding.getState();
  }
  outerSubscribe(n) {
    return this.binding.subscribe(n);
  }
  _connect() {
    const n = () => {
      this.notifySubscribers();
    };
    let r = this.binding.getState(), s = r?.subscribe(n);
    const i = () => {
      const o = this.binding.getState();
      o !== r && (r = o, s?.(), s = o?.subscribe(n), n());
    }, a = this.outerSubscribe(i);
    return () => {
      a?.(), s?.();
    };
  }
}
class Sm extends no {
  constructor(n) {
    super();
    k(this, "config");
    this.config = n;
  }
  getState() {
    return this.config.binding.getState();
  }
  outerSubscribe(n) {
    return this.config.binding.subscribe(n);
  }
  _connect() {
    const n = () => {
      this.notifySubscribers();
    };
    let r = this.config.binding.getState(), s = r?.unstable_on(this.config.event, n);
    const i = () => {
      const o = this.config.binding.getState();
      o !== r && (r = o, s?.(), s = o?.unstable_on(this.config.event, n));
    }, a = this.outerSubscribe(i);
    return () => {
      a?.(), s?.();
    };
  }
}
class Gc {
  constructor() {
    k(this, "_contextProvider", new zc());
  }
  registerModelContextProvider(t) {
    return this._contextProvider.registerModelContextProvider(t);
  }
  getModelContextProvider() {
    return this._contextProvider;
  }
}
const va = (e) => e.content.filter((n) => n.type === "text").map((n) => n.text).join(`

`), Kn = Em("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7), qA = "__optimistic__", KA = () => `${qA}${Kn()}`, ro = /* @__PURE__ */ Symbol("autoStatus"), QA = Object.freeze(Object.assign({ type: "running" }, { [ro]: !0 })), XA = Object.freeze(Object.assign({
  type: "complete",
  reason: "unknown"
}, { [ro]: !0 })), JA = Object.freeze(Object.assign({
  type: "requires-action",
  reason: "tool-calls"
}, { [ro]: !0 })), ZA = Object.freeze(Object.assign({
  type: "requires-action",
  reason: "interrupt"
}, { [ro]: !0 })), Im = (e, t, n, r, s) => e && t ? QA : n ? ZA : r ? JA : XA, Qo = (e, t) => {
  if (e.startsWith("data-"))
    return { type: "data", name: e.substring(5), data: t };
}, Ai = (e, t, n) => {
  const { role: r, id: s, createdAt: i, attachments: a, status: o, metadata: u } = e, c = {
    id: s ?? t,
    createdAt: i ?? /* @__PURE__ */ new Date()
  }, l = typeof e.content == "string" ? [{ type: "text", text: e.content }] : e.content, h = ({ image: m, ...p }) => m.match(/^data:image\/(png|jpeg|jpg|gif|webp);base64,(.*)$/) ? { ...p, image: m } : (console.warn("Invalid image data format detected"), null);
  if (r !== "user" && a?.length)
    throw new Error("attachments are only supported for user messages");
  if (r !== "assistant" && o)
    throw new Error("status is only supported for assistant messages");
  if (r !== "assistant" && u?.steps)
    throw new Error("metadata.steps is only supported for assistant messages");
  switch (r) {
    case "assistant":
      return {
        ...c,
        role: r,
        content: l.map((m) => {
          const p = m.type;
          switch (p) {
            case "text":
            case "reasoning":
              return m.text.trim().length === 0 ? null : m;
            case "file":
            case "source":
              return m;
            case "image":
              return h(m);
            case "data":
              return m;
            case "tool-call": {
              const { parentId: E, messages: g, ..._ } = m, b = {
                ..._,
                toolCallId: m.toolCallId ?? `tool-${Kn()}`,
                ...E !== void 0 && { parentId: E },
                ...g !== void 0 && { messages: g }
              };
              return m.args ? {
                ...b,
                args: m.args,
                argsText: m.argsText ?? JSON.stringify(m.args)
              } : {
                ...b,
                args: eo(m.argsText ?? "") ?? {},
                argsText: m.argsText ?? ""
              };
            }
            default: {
              const E = Qo(p, m.data);
              if (E)
                return E;
              throw new Error(`Unsupported assistant message part type: ${p}`);
            }
          }
        }).filter((m) => !!m),
        status: o ?? n,
        metadata: {
          unstable_state: u?.unstable_state ?? null,
          unstable_annotations: u?.unstable_annotations ?? [],
          unstable_data: u?.unstable_data ?? [],
          custom: u?.custom ?? {},
          steps: u?.steps ?? [],
          ...u?.timing && { timing: u.timing },
          ...u?.submittedFeedback && {
            submittedFeedback: u.submittedFeedback
          }
        }
      };
    case "user":
      return {
        ...c,
        role: r,
        content: l.map((m) => {
          const p = m.type;
          switch (p) {
            case "text":
            case "image":
            case "audio":
            case "file":
            case "data":
              return m;
            default: {
              const E = Qo(p, m.data);
              if (E)
                return E;
              throw new Error(`Unsupported user message part type: ${p}`);
            }
          }
        }),
        attachments: (a ?? []).map((m) => ({
          ...m,
          content: m.content.map((p) => Qo(p.type, p.data) ?? p)
        })),
        metadata: {
          custom: u?.custom ?? {}
        }
      };
    case "system":
      if (l.length !== 1 || l[0].type !== "text")
        throw new Error("System messages must have exactly one text message part.");
      return {
        ...c,
        role: r,
        content: l,
        metadata: {
          custom: u?.custom ?? {}
        }
      };
    default: {
      const m = r;
      throw new Error(`Unknown message role: ${m}`);
    }
  }
}, Wc = {
  fromArray: (e) => {
    const t = e.map((n) => Ai(n, Kn(), Im(!1, !1, !1, !1)));
    return {
      messages: t.map((n, r) => ({
        parentId: r > 0 ? t[r - 1].id : null,
        message: n
      }))
    };
  }
}, la = (e) => e.next ? la(e.next) : "current" in e ? e : null;
class ey {
  constructor(t) {
    k(this, "func");
    k(this, "_value", null);
    this.func = t;
  }
  get value() {
    return this._value === null && (this._value = this.func()), this._value;
  }
  dirty() {
    this._value = null;
  }
}
class wm {
  constructor() {
    k(this, "messages", /* @__PURE__ */ new Map());
    k(this, "head", null);
    k(this, "root", {
      children: [],
      next: null
    });
    k(this, "_messages", new ey(() => {
      const t = new Array((this.head?.level ?? -1) + 1);
      for (let n = this.head; n; n = n.prev)
        t[n.level] = n.current;
      return t;
    }));
  }
  updateLevels(t, n) {
    t.level = n;
    for (const r of t.children) {
      const s = this.messages.get(r);
      s && this.updateLevels(s, n + 1);
    }
  }
  performOp(t, n, r) {
    const s = n.prev ?? this.root, i = t ?? this.root;
    if (!(r === "relink" && s === i)) {
      if (r !== "link" && (s.children = s.children.filter((a) => a !== n.current.id), s.next === n)) {
        const a = s.children.at(-1), o = a ? this.messages.get(a) : null;
        if (o === void 0)
          throw new Error("MessageRepository(performOp/cut): Fallback sibling message not found. This is likely an internal bug in assistant-ui.");
        s.next = o;
      }
      if (r !== "cut") {
        for (let o = t; o; o = o.prev)
          if (o.current.id === n.current.id)
            throw new Error("MessageRepository(performOp/link): A message with the same id already exists in the parent tree. This error occurs if the same message id is found multiple times. This is likely an internal bug in assistant-ui.");
        i.children = [
          ...i.children,
          n.current.id
        ], (la(n) === this.head || i.next === null) && (i.next = n), n.prev = t;
        const a = t ? t.level + 1 : 0;
        this.updateLevels(n, a);
      }
    }
  }
  get headId() {
    return this.head?.current.id ?? null;
  }
  getMessages(t) {
    if (t === void 0 || t === this.head?.current.id)
      return this._messages.value;
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(getMessages): Head message not found. This is likely an internal bug in assistant-ui.");
    const r = new Array(n.level + 1);
    for (let s = n; s; s = s.prev)
      r[s.level] = s.current;
    return r;
  }
  addOrUpdateMessage(t, n) {
    const r = this.messages.get(n.id), s = t ? this.messages.get(t) : null;
    if (s === void 0)
      throw new Error("MessageRepository(addOrUpdateMessage): Parent message not found. This is likely an internal bug in assistant-ui.");
    if (r) {
      r.current = n, this.performOp(s, r, "relink"), this._messages.dirty();
      return;
    }
    const i = {
      prev: s,
      current: n,
      next: null,
      children: [],
      level: s ? s.level + 1 : 0
    };
    this.messages.set(n.id, i), this.performOp(s, i, "link"), this.head === s && (this.head = i), this._messages.dirty();
  }
  getMessage(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(updateMessage): Message not found. This is likely an internal bug in assistant-ui.");
    return {
      parentId: n.prev?.current.id ?? null,
      message: n.current,
      index: n.level
    };
  }
  appendOptimisticMessage(t, n) {
    let r;
    do
      r = KA();
    while (this.messages.has(r));
    return this.addOrUpdateMessage(t, Ai(n, r, { type: "running" })), r;
  }
  deleteMessage(t, n) {
    const r = this.messages.get(t);
    if (!r)
      throw new Error("MessageRepository(deleteMessage): Message not found. This is likely an internal bug in assistant-ui.");
    const s = n === void 0 ? r.prev : n === null ? null : this.messages.get(n);
    if (s === void 0)
      throw new Error("MessageRepository(deleteMessage): Replacement not found. This is likely an internal bug in assistant-ui.");
    for (const i of r.children) {
      const a = this.messages.get(i);
      if (!a)
        throw new Error("MessageRepository(deleteMessage): Child message not found. This is likely an internal bug in assistant-ui.");
      this.performOp(s, a, "relink");
    }
    this.performOp(null, r, "cut"), this.messages.delete(t), this.head === r && (this.head = la(s ?? this.root)), this._messages.dirty();
  }
  getBranches(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(getBranches): Message not found. This is likely an internal bug in assistant-ui.");
    const { children: r } = n.prev ?? this.root;
    return r;
  }
  switchToBranch(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(switchToBranch): Branch not found. This is likely an internal bug in assistant-ui.");
    const r = n.prev ?? this.root;
    r.next = n, this.head = la(n), this._messages.dirty();
  }
  resetHead(t) {
    if (t === null) {
      this.clear();
      return;
    }
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(resetHead): Branch not found. This is likely an internal bug in assistant-ui.");
    if (n.children.length > 0) {
      const r = (s) => {
        for (const i of s.children) {
          const a = this.messages.get(i);
          a && (r(a), this.messages.delete(i));
        }
      };
      r(n), n.children = [], n.next = null;
    }
    this.head = n;
    for (let r = n; r; r = r.prev)
      r.prev ? r.prev.next = r : this.root.next = r;
    this._messages.dirty();
  }
  clear() {
    this.messages.clear(), this.head = null, this.root = {
      children: [],
      next: null
    }, this._messages.dirty();
  }
  export() {
    const t = [];
    for (const [, n] of this.messages)
      t.push({
        message: n.current,
        parentId: n.prev?.current.id ?? null
      });
    return {
      headId: this.head?.current.id ?? null,
      messages: t
    };
  }
  import({ headId: t, messages: n }) {
    for (const { message: r, parentId: s } of n)
      this.addOrUpdateMessage(s, r);
    this.resetHead(t ?? n.at(-1)?.message.id ?? null);
  }
}
function ty(e, t) {
  if (t === "*")
    return !0;
  const n = t.split(",").map((i) => i.trim().toLowerCase()), r = `.${e.name.split(".").pop().toLowerCase()}`, s = e.type.toLowerCase();
  for (const i of n) {
    if (i.startsWith(".") && i === r || i.includes("/") && i === s)
      return !0;
    if (i.endsWith("/*")) {
      const a = i.split("/")[0];
      if (s.startsWith(`${a}/`))
        return !0;
    }
  }
  return !1;
}
const Xo = (e) => e.status.type === "complete";
class vm extends Ti {
  constructor() {
    super(...arguments);
    k(this, "isEditing", !0);
    k(this, "_attachments", []);
    k(this, "_text", "");
    k(this, "_role", "user");
    k(this, "_runConfig", {});
    k(this, "_quote");
    k(this, "_dictation");
    k(this, "_dictationSession");
    k(this, "_dictationUnsubscribes", []);
    k(this, "_dictationBaseText", "");
    k(this, "_currentInterimText", "");
    k(this, "_dictationSessionIdCounter", 0);
    k(this, "_activeDictationSessionId");
    k(this, "_isCleaningDictation", !1);
    k(this, "_eventSubscribers", /* @__PURE__ */ new Map());
  }
  get attachmentAccept() {
    return this.getAttachmentAdapter()?.accept ?? "*";
  }
  get attachments() {
    return this._attachments;
  }
  setAttachments(n) {
    this._attachments = n, this._notifySubscribers();
  }
  get isEmpty() {
    return !this.text.trim() && !this.attachments.length;
  }
  get text() {
    return this._text;
  }
  get role() {
    return this._role;
  }
  get runConfig() {
    return this._runConfig;
  }
  get quote() {
    return this._quote;
  }
  setQuote(n) {
    this._quote !== n && (this._quote = n, this._notifySubscribers());
  }
  setText(n) {
    if (this._text !== n) {
      if (this._text = n, this._dictation) {
        this._dictationBaseText = n, this._currentInterimText = "";
        const { status: r, inputDisabled: s } = this._dictation;
        this._dictation = s ? { status: r, inputDisabled: s } : { status: r };
      }
      this._notifySubscribers();
    }
  }
  setRole(n) {
    this._role !== n && (this._role = n, this._notifySubscribers());
  }
  setRunConfig(n) {
    this._runConfig !== n && (this._runConfig = n, this._notifySubscribers());
  }
  _emptyTextAndAttachments() {
    this._attachments = [], this._text = "", this._notifySubscribers();
  }
  async _onClearAttachments() {
    const n = this.getAttachmentAdapter();
    if (n) {
      const r = this._attachments.filter((s) => !Xo(s));
      await Promise.all(r.map((s) => n.remove(s)));
    }
  }
  async reset() {
    if (this._attachments.length === 0 && this._text === "" && this._role === "user" && Object.keys(this._runConfig).length === 0 && this._quote === void 0)
      return;
    this._role = "user", this._runConfig = {}, this._quote = void 0;
    const n = this._onClearAttachments();
    this._emptyTextAndAttachments(), await n;
  }
  async clearAttachments() {
    const n = this._onClearAttachments();
    this.setAttachments([]), await n;
  }
  async send() {
    if (this.isEmpty)
      return;
    this._dictationSession && (this._dictationSession.cancel(), this._cleanupDictation());
    const n = this.getAttachmentAdapter(), r = this.attachments.length > 0 ? Promise.all(this.attachments.map(async (o) => {
      if (Xo(o))
        return o;
      if (!n)
        throw new Error("Attachments are not supported");
      return await n.send(o);
    })) : [], s = this.text, i = this._quote;
    this._quote = void 0, this._emptyTextAndAttachments();
    const a = {
      createdAt: /* @__PURE__ */ new Date(),
      role: this.role,
      content: s ? [{ type: "text", text: s }] : [],
      attachments: await r,
      runConfig: this.runConfig,
      metadata: { custom: { ...i ? { quote: i } : {} } }
    };
    this.handleSend(a), this._notifyEventSubscribers("send");
  }
  cancel() {
    this.handleCancel();
  }
  async addAttachment(n) {
    if (!(n instanceof File)) {
      const o = {
        id: n.id ?? Kn(),
        type: n.type ?? "document",
        name: n.name,
        contentType: n.contentType,
        content: n.content,
        status: { type: "complete" }
      };
      this._attachments = [...this._attachments, o], this._notifyEventSubscribers("attachmentAdd"), this._notifySubscribers();
      return;
    }
    const r = this.getAttachmentAdapter();
    if (!r)
      throw new Error("Attachments are not supported");
    if (!ty({ name: n.name, type: n.type }, r.accept))
      throw new Error(`File type ${n.type || "unknown"} is not accepted. Accepted types: ${r.accept}`);
    const s = (o) => {
      const u = this._attachments.findIndex((c) => c.id === o.id);
      u !== -1 ? this._attachments = [
        ...this._attachments.slice(0, u),
        o,
        ...this._attachments.slice(u + 1)
      ] : this._attachments = [...this._attachments, o], this._notifySubscribers();
    };
    let i;
    try {
      const o = r.add({ file: n });
      if (Symbol.asyncIterator in o)
        for await (const u of o)
          i = u, s(u);
      else
        i = await o, s(i);
    } catch (o) {
      i && s({
        ...i,
        status: { type: "incomplete", reason: "error" }
      });
      try {
        this._notifyEventSubscribers("attachmentAddError");
      } catch {
      }
      throw o;
    }
    const a = i?.status.type === "incomplete" && i.status.reason === "error";
    this._notifyEventSubscribers(a ? "attachmentAddError" : "attachmentAdd");
  }
  async removeAttachment(n) {
    const r = this._attachments.findIndex((i) => i.id === n);
    if (r === -1)
      throw new Error("Attachment not found");
    const s = this._attachments[r];
    if (!Xo(s)) {
      const i = this.getAttachmentAdapter();
      if (!i)
        throw new Error("Attachments are not supported");
      await i.remove(s);
    }
    this._attachments = this._attachments.filter((i) => i.id !== n), this._notifySubscribers();
  }
  get dictation() {
    return this._dictation;
  }
  _isActiveSession(n, r) {
    return this._activeDictationSessionId === n && this._dictationSession === r;
  }
  startDictation() {
    const n = this.getDictationAdapter();
    if (!n)
      throw new Error("Dictation adapter not configured");
    if (this._dictationSession) {
      for (const h of this._dictationUnsubscribes)
        h();
      this._dictationUnsubscribes = [], this._dictationSession.stop().catch(() => {
      }), this._dictationSession = void 0;
    }
    const r = n.disableInputDuringDictation ?? !1;
    this._dictationBaseText = this._text, this._currentInterimText = "";
    const s = n.listen();
    this._dictationSession = s;
    const i = ++this._dictationSessionIdCounter;
    this._activeDictationSessionId = i, this._dictation = { status: s.status, inputDisabled: r }, this._notifySubscribers();
    const a = s.onSpeech((l) => {
      if (!this._isActiveSession(i, s))
        return;
      const h = l.isFinal !== !1, p = this._dictationBaseText && !this._dictationBaseText.endsWith(" ") && l.transcript ? " " : "";
      if (h) {
        if (this._dictationBaseText = this._dictationBaseText + p + l.transcript, this._currentInterimText = "", this._text = this._dictationBaseText, this._dictation) {
          const { transcript: E, ...g } = this._dictation;
          this._dictation = g;
        }
        this._notifySubscribers();
      } else
        this._currentInterimText = p + l.transcript, this._text = this._dictationBaseText + this._currentInterimText, this._dictation && (this._dictation = {
          ...this._dictation,
          transcript: l.transcript
        }), this._notifySubscribers();
    });
    this._dictationUnsubscribes.push(a);
    const o = s.onSpeechStart(() => {
      this._isActiveSession(i, s) && (this._dictation = {
        status: { type: "running" },
        inputDisabled: r,
        ...this._dictation?.transcript && {
          transcript: this._dictation.transcript
        }
      }, this._notifySubscribers());
    });
    this._dictationUnsubscribes.push(o);
    const u = s.onSpeechEnd(() => {
      this._cleanupDictation({ sessionId: i });
    });
    this._dictationUnsubscribes.push(u);
    const c = setInterval(() => {
      this._isActiveSession(i, s) && s.status.type === "ended" && this._cleanupDictation({ sessionId: i });
    }, 100);
    this._dictationUnsubscribes.push(() => clearInterval(c));
  }
  stopDictation() {
    if (!this._dictationSession)
      return;
    const n = this._dictationSession, r = this._activeDictationSessionId;
    n.stop().finally(() => {
      this._cleanupDictation({ sessionId: r });
    });
  }
  _cleanupDictation(n) {
    if (!(n?.sessionId !== void 0 && n.sessionId !== this._activeDictationSessionId || this._isCleaningDictation)) {
      this._isCleaningDictation = !0;
      try {
        for (const s of this._dictationUnsubscribes)
          s();
        this._dictationUnsubscribes = [], this._dictationSession = void 0, this._activeDictationSessionId = void 0, this._dictation = void 0, this._dictationBaseText = "", this._currentInterimText = "", this._notifySubscribers();
      } finally {
        this._isCleaningDictation = !1;
      }
    }
  }
  _notifyEventSubscribers(n) {
    const r = this._eventSubscribers.get(n);
    if (r)
      for (const s of r)
        s();
  }
  unstable_on(n, r) {
    const s = this._eventSubscribers.get(n);
    return s ? s.add(r) : this._eventSubscribers.set(n, /* @__PURE__ */ new Set([r])), () => {
      const i = this._eventSubscribers.get(n);
      i && i.delete(r);
    };
  }
}
class Nm extends vm {
  constructor(n) {
    super();
    k(this, "runtime");
    k(this, "_canCancel", !1);
    this.runtime = n, this.connect();
  }
  get canCancel() {
    return this._canCancel;
  }
  getAttachmentAdapter() {
    return this.runtime.adapters?.attachments;
  }
  getDictationAdapter() {
    return this.runtime.adapters?.dictation;
  }
  connect() {
    return this.runtime.subscribe(() => {
      this.canCancel !== this.runtime.capabilities.cancel && (this._canCancel = this.runtime.capabilities.cancel, this._notifySubscribers());
    });
  }
  async handleSend(n) {
    this.runtime.append({
      ...n,
      parentId: this.runtime.messages.at(-1)?.id ?? null,
      sourceId: null
    });
  }
  async handleCancel() {
    this.runtime.cancelRun();
  }
}
class ny extends vm {
  constructor(n, r, { parentId: s, message: i }) {
    super();
    k(this, "runtime");
    k(this, "endEditCallback");
    k(this, "_nonTextParts");
    k(this, "_previousText");
    k(this, "_parentId");
    k(this, "_sourceId");
    this.runtime = n, this.endEditCallback = r, this._parentId = s, this._sourceId = i.id, this._previousText = va(i), this.setText(this._previousText), this.setRole(i.role), this.setAttachments(i.attachments ?? []), this._nonTextParts = i.content.filter((a) => a.type !== "text"), this.setRunConfig({ ...n.composer.runConfig });
  }
  get canCancel() {
    return !0;
  }
  getAttachmentAdapter() {
    return this.runtime.adapters?.attachments;
  }
  getDictationAdapter() {
    return this.runtime.adapters?.dictation;
  }
  async handleSend(n) {
    va(n) !== this._previousText && this.runtime.append({
      ...n,
      content: [...n.content, ...this._nonTextParts],
      parentId: this._parentId,
      sourceId: this._sourceId
    }), this.handleCancel();
  }
  handleCancel() {
    this.endEditCallback(), this._notifySubscribers();
  }
}
class ry {
  constructor(t) {
    k(this, "_contextProvider");
    k(this, "_subscriptions", /* @__PURE__ */ new Set());
    k(this, "_isInitialized", !1);
    k(this, "repository", new wm());
    k(this, "composer", new Nm(this));
    k(this, "_editComposers", /* @__PURE__ */ new Map());
    k(this, "_stopSpeaking");
    k(this, "speech");
    k(this, "_eventSubscribers", /* @__PURE__ */ new Map());
    this._contextProvider = t;
  }
  get messages() {
    return this.repository.getMessages();
  }
  get state() {
    let t;
    for (const n of this.messages)
      n.role === "assistant" && (t = n);
    return t?.metadata.unstable_state ?? null;
  }
  getModelContext() {
    return this._contextProvider.getModelContext();
  }
  getEditComposer(t) {
    return this._editComposers.get(t);
  }
  beginEdit(t) {
    if (this._editComposers.has(t))
      throw new Error("Edit already in progress");
    this._editComposers.set(t, new ny(this, () => this._editComposers.delete(t), this.repository.getMessage(t))), this._notifySubscribers();
  }
  getMessageById(t) {
    try {
      return this.repository.getMessage(t);
    } catch {
      return;
    }
  }
  getBranches(t) {
    return this.repository.getBranches(t);
  }
  switchToBranch(t) {
    this.repository.switchToBranch(t), this._notifySubscribers();
  }
  _notifySubscribers() {
    for (const t of this._subscriptions)
      t();
  }
  _notifyEventSubscribers(t) {
    const n = this._eventSubscribers.get(t);
    if (n)
      for (const r of n)
        r();
  }
  subscribe(t) {
    return this._subscriptions.add(t), () => this._subscriptions.delete(t);
  }
  submitFeedback({ messageId: t, type: n }) {
    const r = this.adapters?.feedback;
    if (!r)
      throw new Error("Feedback adapter not configured");
    const { message: s, parentId: i } = this.repository.getMessage(t);
    if (r.submit({ message: s, type: n }), s.role === "assistant") {
      const a = {
        ...s,
        metadata: {
          ...s.metadata,
          submittedFeedback: { type: n }
        }
      };
      this.repository.addOrUpdateMessage(i, a);
    }
    this._notifySubscribers();
  }
  speak(t) {
    const n = this.adapters?.speech;
    if (!n)
      throw new Error("Speech adapter not configured");
    const { message: r } = this.repository.getMessage(t);
    this._stopSpeaking?.();
    const s = n.speak(va(r)), i = s.subscribe(() => {
      s.status.type === "ended" ? (this._stopSpeaking = void 0, this.speech = void 0) : this.speech = { messageId: t, status: s.status }, this._notifySubscribers();
    });
    this.speech = { messageId: t, status: s.status }, this._notifySubscribers(), this._stopSpeaking = () => {
      s.cancel(), i(), this.speech = void 0, this._stopSpeaking = void 0;
    };
  }
  stopSpeaking() {
    if (!this._stopSpeaking)
      throw new Error("No message is being spoken");
    this._stopSpeaking(), this._notifySubscribers();
  }
  ensureInitialized() {
    this._isInitialized || (this._isInitialized = !0, this._notifyEventSubscribers("initialize"));
  }
  export() {
    return this.repository.export();
  }
  import(t) {
    this.ensureInitialized(), this.repository.clear(), this.repository.import(t), this._notifySubscribers();
  }
  reset(t) {
    this.import(Wc.fromArray(t ?? []));
  }
  unstable_on(t, n) {
    if (t === "modelContextUpdate")
      return this._contextProvider.subscribe?.(n) ?? (() => {
      });
    const r = this._eventSubscribers.get(t);
    return r ? r.add(n) : this._eventSubscribers.set(t, /* @__PURE__ */ new Set([n])), () => {
      this._eventSubscribers.get(t).delete(n);
    };
  }
}
class Ui {
  constructor(t, n) {
    k(this, "_core");
    k(this, "_threadListBinding");
    this._core = t, this._threadListBinding = n, this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.switchTo = this.switchTo.bind(this), this.rename = this.rename.bind(this), this.archive = this.archive.bind(this), this.unarchive = this.unarchive.bind(this), this.delete = this.delete.bind(this), this.initialize = this.initialize.bind(this), this.generateTitle = this.generateTitle.bind(this), this.subscribe = this.subscribe.bind(this), this.unstable_on = this.unstable_on.bind(this), this.getState = this.getState.bind(this), this.detach = this.detach.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  switchTo() {
    const t = this._core.getState();
    return this._threadListBinding.switchToThread(t.id);
  }
  rename(t) {
    const n = this._core.getState();
    return this._threadListBinding.rename(n.id, t);
  }
  archive() {
    const t = this._core.getState();
    return this._threadListBinding.archive(t.id);
  }
  unarchive() {
    const t = this._core.getState();
    return this._threadListBinding.unarchive(t.id);
  }
  delete() {
    const t = this._core.getState();
    return this._threadListBinding.delete(t.id);
  }
  initialize() {
    const t = this._core.getState();
    return this._threadListBinding.initialize(t.id);
  }
  generateTitle() {
    const t = this._core.getState();
    return this._threadListBinding.generateTitle(t.id);
  }
  unstable_on(t, n) {
    let r = this._core.getState().isMain, s = this._core.getState().id;
    return this.subscribe(() => {
      const i = this._core.getState(), a = i.isMain, o = i.id;
      r === a && s === o || (r = a, s = o, !(t === "switchedTo" && !a) && (t === "switchedAway" && a || n()));
    });
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  detach() {
    const t = this._core.getState();
    this._threadListBinding.detach(t.id);
  }
  __internal_getRuntime() {
    return this;
  }
}
const Na = /* @__PURE__ */ Symbol("innerMessage");
class km {
  constructor(t) {
    k(this, "_core");
    this._core = t, this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.getState = this.getState.bind(this), this.remove = this.remove.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
}
class Rm extends km {
  constructor(n, r) {
    super(n);
    k(this, "_composerApi");
    this._composerApi = r;
  }
  remove() {
    const n = this._composerApi.getState();
    if (!n)
      throw new Error("Composer is not available");
    return n.removeAttachment(this.getState().id);
  }
}
class sy extends Rm {
  get source() {
    return "thread-composer";
  }
}
class iy extends Rm {
  get source() {
    return "edit-composer";
  }
}
class ay extends km {
  get source() {
    return "message";
  }
  constructor(t) {
    super(t);
  }
  remove() {
    throw new Error("Message attachments cannot be removed");
  }
}
const Pm = Object.freeze([]), Om = Object.freeze({}), oy = (e) => Object.freeze({
  type: "thread",
  isEditing: e?.isEditing ?? !1,
  canCancel: e?.canCancel ?? !1,
  isEmpty: e?.isEmpty ?? !0,
  attachments: e?.attachments ?? Pm,
  text: e?.text ?? "",
  role: e?.role ?? "user",
  runConfig: e?.runConfig ?? Om,
  attachmentAccept: e?.attachmentAccept ?? "",
  dictation: e?.dictation,
  quote: e?.quote,
  value: e?.text ?? ""
}), uy = (e) => Object.freeze({
  type: "edit",
  isEditing: e?.isEditing ?? !1,
  canCancel: e?.canCancel ?? !1,
  isEmpty: e?.isEmpty ?? !0,
  text: e?.text ?? "",
  role: e?.role ?? "user",
  attachments: e?.attachments ?? Pm,
  runConfig: e?.runConfig ?? Om,
  attachmentAccept: e?.attachmentAccept ?? "",
  dictation: e?.dictation,
  quote: e?.quote,
  value: e?.text ?? ""
});
class Dm {
  constructor(t) {
    k(this, "_core");
    k(this, "_eventSubscriptionSubjects", /* @__PURE__ */ new Map());
    this._core = t;
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.setText = this.setText.bind(this), this.setRunConfig = this.setRunConfig.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.addAttachment = this.addAttachment.bind(this), this.reset = this.reset.bind(this), this.clearAttachments = this.clearAttachments.bind(this), this.send = this.send.bind(this), this.cancel = this.cancel.bind(this), this.setRole = this.setRole.bind(this), this.getAttachmentByIndex = this.getAttachmentByIndex.bind(this), this.startDictation = this.startDictation.bind(this), this.stopDictation = this.stopDictation.bind(this), this.setQuote = this.setQuote.bind(this), this.unstable_on = this.unstable_on.bind(this);
  }
  setText(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setText(t);
  }
  setRunConfig(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setRunConfig(t);
  }
  addAttachment(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    return n.addAttachment(t);
  }
  reset() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    return t.reset();
  }
  clearAttachments() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    return t.clearAttachments();
  }
  send() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.send();
  }
  cancel() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.cancel();
  }
  setRole(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setRole(t);
  }
  startDictation() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.startDictation();
  }
  stopDictation() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.stopDictation();
  }
  setQuote(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setQuote(t);
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  unstable_on(t, n) {
    let r = this._eventSubscriptionSubjects.get(t);
    return r || (r = new Sm({
      event: t,
      binding: this._core
    }), this._eventSubscriptionSubjects.set(t, r)), r.subscribe(n);
  }
}
class cy extends Dm {
  constructor(n) {
    const r = new Yc({
      path: n.path,
      getState: () => oy(n.getState()),
      subscribe: (s) => n.subscribe(s)
    });
    super({
      path: n.path,
      getState: () => n.getState(),
      subscribe: (s) => r.subscribe(s)
    });
    k(this, "_getState");
    this._getState = r.getState.bind(r), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  get type() {
    return "thread";
  }
  getState() {
    return this._getState();
  }
  getAttachmentByIndex(n) {
    return new sy(new Zt({
      path: {
        ...this.path,
        attachmentSource: "thread-composer",
        attachmentSelector: { type: "index", index: n },
        ref: `${this.path.ref}.attachments[${n}]`
      },
      getState: () => {
        const s = this.getState().attachments[n];
        return s ? {
          ...s,
          source: "thread-composer"
        } : tn;
      },
      subscribe: (r) => this._core.subscribe(r)
    }), this._core);
  }
}
class ly extends Dm {
  constructor(n, r) {
    const s = new Yc({
      path: n.path,
      getState: () => uy(n.getState()),
      subscribe: (i) => n.subscribe(i)
    });
    super({
      path: n.path,
      getState: () => n.getState(),
      subscribe: (i) => s.subscribe(i)
    });
    k(this, "_beginEdit");
    k(this, "_getState");
    this._beginEdit = r, this._getState = s.getState.bind(s), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  get type() {
    return "edit";
  }
  __internal_bindMethods() {
    super.__internal_bindMethods(), this.beginEdit = this.beginEdit.bind(this);
  }
  getState() {
    return this._getState();
  }
  beginEdit() {
    this._beginEdit();
  }
  getAttachmentByIndex(n) {
    return new iy(new Zt({
      path: {
        ...this.path,
        attachmentSource: "edit-composer",
        attachmentSelector: { type: "index", index: n },
        ref: `${this.path.ref}.attachments[${n}]`
      },
      getState: () => {
        const s = this.getState().attachments[n];
        return s ? {
          ...s,
          source: "edit-composer"
        } : tn;
      },
      subscribe: (r) => this._core.subscribe(r)
    }), this._core);
  }
}
class qd {
  constructor(t, n, r) {
    k(this, "contentBinding");
    k(this, "messageApi");
    k(this, "threadApi");
    this.contentBinding = t, this.messageApi = n, this.threadApi = r, this.__internal_bindMethods();
  }
  get path() {
    return this.contentBinding.path;
  }
  __internal_bindMethods() {
    this.addToolResult = this.addToolResult.bind(this), this.resumeToolCall = this.resumeToolCall.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  getState() {
    return this.contentBinding.getState();
  }
  addToolResult(t) {
    const n = this.contentBinding.getState();
    if (!n)
      throw new Error("Message part is not available");
    if (n.type !== "tool-call")
      throw new Error("Tried to add tool result to non-tool message part");
    if (!this.messageApi)
      throw new Error("Message API is not available. This is likely a bug in assistant-ui.");
    if (!this.threadApi)
      throw new Error("Thread API is not available");
    const r = this.messageApi.getState();
    if (!r)
      throw new Error("Message is not available");
    const s = n.toolName, i = n.toolCallId, a = Ia.toResponse(t);
    this.threadApi.getState().addToolResult({
      messageId: r.id,
      toolName: s,
      toolCallId: i,
      result: a.result,
      artifact: a.artifact,
      isError: a.isError
    });
  }
  resumeToolCall(t) {
    const n = this.contentBinding.getState();
    if (!n)
      throw new Error("Message part is not available");
    if (n.type !== "tool-call")
      throw new Error("Tried to resume tool call on non-tool message part");
    if (!this.threadApi)
      throw new Error("Thread API is not available");
    const r = n.toolCallId;
    this.threadApi.getState().resumeToolCall({
      toolCallId: r,
      payload: t
    });
  }
  subscribe(t) {
    return this.contentBinding.subscribe(t);
  }
}
const Fi = Object.freeze({
  type: "complete"
}), dy = (e, t, n) => {
  if (e.role !== "assistant")
    return Fi;
  if (n.type === "tool-call")
    return n.result ? Fi : e.status;
  const r = t === Math.max(0, e.content.length - 1);
  return e.status.type === "requires-action" ? Fi : r ? e.status : Fi;
}, Kd = (e, t) => {
  const n = e.content[t];
  if (!n)
    return tn;
  const r = dy(e, t, n);
  return Object.freeze({
    ...n,
    [Na]: n[Na],
    status: r
  });
};
class hy {
  constructor(t, n) {
    k(this, "_core");
    k(this, "_threadBinding");
    k(this, "composer");
    k(this, "_getEditComposerRuntimeCore", () => this._threadBinding.getState().getEditComposer(this._core.getState().id));
    this._core = t, this._threadBinding = n, this.composer = new ly(new wa({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.composer`,
        composerSource: "edit"
      },
      getState: this._getEditComposerRuntimeCore,
      subscribe: (r) => this._threadBinding.subscribe(r)
    }), () => this._threadBinding.getState().beginEdit(this._core.getState().id)), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.reload = this.reload.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.getMessagePartByIndex = this.getMessagePartByIndex.bind(this), this.getMessagePartByToolCallId = this.getMessagePartByToolCallId.bind(this), this.getAttachmentByIndex = this.getAttachmentByIndex.bind(this), this.unstable_getCopyText = this.unstable_getCopyText.bind(this), this.speak = this.speak.bind(this), this.stopSpeaking = this.stopSpeaking.bind(this), this.submitFeedback = this.submitFeedback.bind(this), this.switchToBranch = this.switchToBranch.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  reload(t = {}) {
    const n = this._getEditComposerRuntimeCore(), r = n ?? this._threadBinding.getState().composer, s = n ?? r, { runConfig: i = s.runConfig } = t, a = this._core.getState();
    if (a.role !== "assistant")
      throw new Error("Can only reload assistant messages");
    this._threadBinding.getState().startRun({
      parentId: a.parentId,
      sourceId: a.id,
      runConfig: i
    });
  }
  speak() {
    const t = this._core.getState();
    return this._threadBinding.getState().speak(t.id);
  }
  stopSpeaking() {
    const t = this._core.getState();
    if (this._threadBinding.getState().speech?.messageId === t.id)
      this._threadBinding.getState().stopSpeaking();
    else
      throw new Error("Message is not being spoken");
  }
  submitFeedback({ type: t }) {
    const n = this._core.getState();
    this._threadBinding.getState().submitFeedback({
      messageId: n.id,
      type: t
    });
  }
  switchToBranch({ position: t, branchId: n }) {
    const r = this._core.getState();
    if (n && t)
      throw new Error("May not specify both branchId and position");
    if (!n && !t)
      throw new Error("Must specify either branchId or position");
    const i = this._threadBinding.getState().getBranches(r.id);
    let a = n;
    if (t === "previous" ? a = i[r.branchNumber - 2] : t === "next" && (a = i[r.branchNumber]), !a)
      throw new Error("Branch not found");
    this._threadBinding.getState().switchToBranch(a);
  }
  unstable_getCopyText() {
    return va(this.getState());
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  getMessagePartByIndex(t) {
    if (t < 0)
      throw new Error("Message part index must be >= 0");
    return new qd(new Zt({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.content[${t}]`,
        messagePartSelector: { type: "index", index: t }
      },
      getState: () => Kd(this.getState(), t),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core, this._threadBinding);
  }
  getMessagePartByToolCallId(t) {
    return new qd(new Zt({
      path: {
        ...this.path,
        ref: this.path.ref + `${this.path.ref}.content[toolCallId=${JSON.stringify(t)}]`,
        messagePartSelector: { type: "toolCallId", toolCallId: t }
      },
      getState: () => {
        const n = this._core.getState(), r = n.content.findIndex((s) => s.type === "tool-call" && s.toolCallId === t);
        return r === -1 ? tn : Kd(n, r);
      },
      subscribe: (n) => this._core.subscribe(n)
    }), this._core, this._threadBinding);
  }
  getAttachmentByIndex(t) {
    return new ay(new Zt({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.attachments[${t}]`,
        attachmentSource: "message",
        attachmentSelector: { type: "index", index: t }
      },
      getState: () => {
        const r = this.getState().attachments?.[t];
        return r ? {
          ...r,
          source: "message"
        } : tn;
      },
      subscribe: (n) => this._core.subscribe(n)
    }));
  }
}
const fy = (e) => ({
  parentId: e.parentId ?? null,
  sourceId: e.sourceId ?? null,
  runConfig: e.runConfig ?? {},
  ...e.stream ? { stream: e.stream } : {}
}), py = (e) => ({
  parentId: e.parentId ?? null,
  sourceId: e.sourceId ?? null,
  runConfig: e.runConfig ?? {}
}), my = (e, t) => typeof t == "string" ? {
  createdAt: /* @__PURE__ */ new Date(),
  parentId: e.at(-1)?.id ?? null,
  sourceId: null,
  runConfig: {},
  role: "user",
  content: [{ type: "text", text: t }],
  attachments: [],
  metadata: { custom: {} }
} : {
  createdAt: t.createdAt ?? /* @__PURE__ */ new Date(),
  parentId: t.parentId ?? e.at(-1)?.id ?? null,
  sourceId: t.sourceId ?? null,
  role: t.role ?? "user",
  content: t.content,
  attachments: t.attachments ?? [],
  metadata: t.metadata ?? { custom: {} },
  runConfig: t.runConfig ?? {},
  startRun: t.startRun
}, gy = (e, t) => {
  const n = e.messages.at(-1);
  return Object.freeze({
    threadId: t.id,
    metadata: t,
    capabilities: e.capabilities,
    isDisabled: e.isDisabled,
    isLoading: e.isLoading,
    isRunning: n?.role !== "assistant" ? !1 : n.status.type === "running",
    messages: e.messages,
    state: e.state,
    suggestions: e.suggestions,
    extras: e.extras,
    speech: e.speech
  });
};
class Lm {
  constructor(t, n) {
    k(this, "_threadBinding");
    k(this, "composer");
    k(this, "_eventSubscriptionSubjects", /* @__PURE__ */ new Map());
    const r = new Zt({
      path: t.path,
      getState: () => gy(t.getState(), n.getState()),
      subscribe: (s) => {
        const i = t.subscribe(s), a = n.subscribe(s);
        return () => {
          i(), a();
        };
      }
    });
    this._threadBinding = {
      path: t.path,
      getState: () => t.getState(),
      getStateState: () => r.getState(),
      outerSubscribe: (s) => t.outerSubscribe(s),
      subscribe: (s) => t.subscribe(s)
    }, this.composer = new cy(new wa({
      path: {
        ...this.path,
        ref: `${this.path.ref}.composer`,
        composerSource: "thread"
      },
      getState: () => this._threadBinding.getState().composer,
      subscribe: (s) => this._threadBinding.subscribe(s)
    })), this.__internal_bindMethods();
  }
  get path() {
    return this._threadBinding.path;
  }
  get __internal_threadBinding() {
    return this._threadBinding;
  }
  __internal_bindMethods() {
    this.append = this.append.bind(this), this.resumeRun = this.resumeRun.bind(this), this.unstable_resumeRun = this.unstable_resumeRun.bind(this), this.unstable_loadExternalState = this.unstable_loadExternalState.bind(this), this.importExternalState = this.importExternalState.bind(this), this.exportExternalState = this.exportExternalState.bind(this), this.startRun = this.startRun.bind(this), this.cancelRun = this.cancelRun.bind(this), this.stopSpeaking = this.stopSpeaking.bind(this), this.export = this.export.bind(this), this.import = this.import.bind(this), this.reset = this.reset.bind(this), this.getMessageByIndex = this.getMessageByIndex.bind(this), this.getMessageById = this.getMessageById.bind(this), this.subscribe = this.subscribe.bind(this), this.unstable_on = this.unstable_on.bind(this), this.getModelContext = this.getModelContext.bind(this), this.getModelConfig = this.getModelConfig.bind(this), this.getState = this.getState.bind(this);
  }
  getState() {
    return this._threadBinding.getStateState();
  }
  append(t) {
    this._threadBinding.getState().append(my(this._threadBinding.getState().messages, t));
  }
  subscribe(t) {
    return this._threadBinding.subscribe(t);
  }
  getModelContext() {
    return this._threadBinding.getState().getModelContext();
  }
  getModelConfig() {
    return this.getModelContext();
  }
  startRun(t) {
    const n = t === null || typeof t == "string" ? { parentId: t } : t;
    return this._threadBinding.getState().startRun(py(n));
  }
  resumeRun(t) {
    return this._threadBinding.getState().resumeRun(fy(t));
  }
  /** @deprecated Use `resumeRun` instead. */
  unstable_resumeRun(t) {
    return this.resumeRun(t);
  }
  exportExternalState() {
    return this._threadBinding.getState().exportExternalState();
  }
  importExternalState(t) {
    this._threadBinding.getState().importExternalState(t);
  }
  unstable_loadExternalState(t) {
    this._threadBinding.getState().unstable_loadExternalState(t);
  }
  cancelRun() {
    this._threadBinding.getState().cancelRun();
  }
  stopSpeaking() {
    return this._threadBinding.getState().stopSpeaking();
  }
  export() {
    return this._threadBinding.getState().export();
  }
  import(t) {
    this._threadBinding.getState().import(t);
  }
  reset(t) {
    this._threadBinding.getState().reset(t);
  }
  getMessageByIndex(t) {
    if (t < 0)
      throw new Error("Message index must be >= 0");
    return this._getMessageRuntime({
      ...this.path,
      ref: `${this.path.ref}.messages[${t}]`,
      messageSelector: { type: "index", index: t }
    }, () => {
      const n = this._threadBinding.getState().messages, r = n[t];
      if (r)
        return {
          message: r,
          parentId: n[t - 1]?.id ?? null,
          index: t
        };
    });
  }
  getMessageById(t) {
    return this._getMessageRuntime({
      ...this.path,
      ref: `${this.path.ref}.messages[messageId=${JSON.stringify(t)}]`,
      messageSelector: { type: "messageId", messageId: t }
    }, () => this._threadBinding.getState().getMessageById(t));
  }
  _getMessageRuntime(t, n) {
    return new hy(new Zt({
      path: t,
      getState: () => {
        const { message: r, parentId: s, index: i } = n() ?? {}, { messages: a, speech: o } = this._threadBinding.getState();
        if (!r || s === void 0 || i === void 0)
          return tn;
        const c = this._threadBinding.getState().getBranches(r.id), l = r.metadata.submittedFeedback;
        return {
          ...r,
          [Na]: r[Na],
          index: i,
          isLast: a.at(-1)?.id === r.id,
          parentId: s,
          branchNumber: c.indexOf(r.id) + 1,
          branchCount: c.length,
          speech: o?.messageId === r.id ? o : void 0,
          submittedFeedback: l
        };
      },
      subscribe: (r) => this._threadBinding.subscribe(r)
    }), this._threadBinding);
  }
  unstable_on(t, n) {
    let r = this._eventSubscriptionSubjects.get(t);
    return r || (r = new Sm({
      event: t,
      binding: this._threadBinding
    }), this._eventSubscriptionSubjects.set(t, r)), r.subscribe(n);
  }
}
const Ey = (e) => ({
  mainThreadId: e.mainThreadId,
  newThreadId: e.newThreadId,
  threadIds: e.threadIds,
  archivedThreadIds: e.archivedThreadIds,
  isLoading: e.isLoading,
  threadItems: e.threadItems
}), ji = (e, t) => {
  if (t === void 0)
    return tn;
  const n = e.getItemById(t);
  return n ? {
    id: n.id,
    remoteId: n.remoteId,
    externalId: n.externalId,
    title: n.title,
    status: n.status,
    isMain: n.id === e.mainThreadId
  } : tn;
};
class Mm {
  constructor(t, n = Lm) {
    k(this, "_core");
    k(this, "_runtimeFactory");
    k(this, "_getState");
    k(this, "_mainThreadListItemRuntime");
    k(this, "main");
    this._core = t, this._runtimeFactory = n;
    const r = new Yc({
      path: {},
      getState: () => Ey(t),
      subscribe: (s) => t.subscribe(s)
    });
    this._getState = r.getState.bind(r), this._mainThreadListItemRuntime = new Ui(new Zt({
      path: {
        ref: "threadItems[main]",
        threadSelector: { type: "main" }
      },
      getState: () => ji(this._core, this._core.mainThreadId),
      subscribe: (s) => this._core.subscribe(s)
    }), this._core), this.main = new n(new wa({
      path: {
        ref: "threads.main",
        threadSelector: { type: "main" }
      },
      getState: () => t.getMainThreadRuntimeCore(),
      subscribe: (s) => t.subscribe(s)
    }), this._mainThreadListItemRuntime), this.__internal_bindMethods();
  }
  __internal_bindMethods() {
    this.switchToThread = this.switchToThread.bind(this), this.switchToNewThread = this.switchToNewThread.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.getById = this.getById.bind(this), this.getItemById = this.getItemById.bind(this), this.getItemByIndex = this.getItemByIndex.bind(this), this.getArchivedItemByIndex = this.getArchivedItemByIndex.bind(this);
  }
  switchToThread(t) {
    return this._core.switchToThread(t);
  }
  switchToNewThread() {
    return this._core.switchToNewThread();
  }
  getState() {
    return this._getState();
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  get mainItem() {
    return this._mainThreadListItemRuntime;
  }
  getById(t) {
    return new this._runtimeFactory(new wa({
      path: {
        ref: `threads[threadId=${JSON.stringify(t)}]`,
        threadSelector: { type: "threadId", threadId: t }
      },
      getState: () => this._core.getThreadRuntimeCore(t),
      subscribe: (n) => this._core.subscribe(n)
    }), this.mainItem);
  }
  getItemByIndex(t) {
    return new Ui(new Zt({
      path: {
        ref: `threadItems[${t}]`,
        threadSelector: { type: "index", index: t }
      },
      getState: () => ji(this._core, this._core.threadIds[t]),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
  getArchivedItemByIndex(t) {
    return new Ui(new Zt({
      path: {
        ref: `archivedThreadItems[${t}]`,
        threadSelector: { type: "archiveIndex", index: t }
      },
      getState: () => ji(this._core, this._core.archivedThreadIds[t]),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
  getItemById(t) {
    return new Ui(new Zt({
      path: {
        ref: `threadItems[threadId=${t}]`,
        threadSelector: { type: "threadId", threadId: t }
      },
      getState: () => ji(this._core, t),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
}
class qc {
  constructor(t) {
    k(this, "_core");
    k(this, "threads");
    k(this, "_thread");
    this._core = t, this.threads = new Mm(t.threads), this._thread = this.threads.main, this.__internal_bindMethods();
  }
  get threadList() {
    return this.threads;
  }
  __internal_bindMethods() {
    this.switchToNewThread = this.switchToNewThread.bind(this), this.switchToThread = this.switchToThread.bind(this), this.registerModelContextProvider = this.registerModelContextProvider.bind(this), this.registerModelConfigProvider = this.registerModelConfigProvider.bind(this), this.reset = this.reset.bind(this);
  }
  get thread() {
    return this._thread;
  }
  switchToNewThread() {
    return this._core.threads.switchToNewThread();
  }
  switchToThread(t) {
    return this._core.threads.switchToThread(t);
  }
  registerModelContextProvider(t) {
    return this._core.registerModelContextProvider(t);
  }
  registerModelConfigProvider(t) {
    return this.registerModelContextProvider(t);
  }
  reset({ initialMessages: t } = {}) {
    return this._core.threads.getMainThreadRuntimeCore().import(Wc.fromArray(t ?? []));
  }
}
const Hm = Ue((e) => Ft(jA(e)));
am(Hm, (e, t) => {
  $A(e, t), !e.tools && t.tools.source === null && (e.tools = fm({})), !e.dataRenderers && t.dataRenderers.source === null && (e.dataRenderers = nA());
});
const Xu = _t(null), Kc = ({ adapters: e, children: t }) => {
  const n = ft(Xu);
  return d.jsx(Xu.Provider, { value: {
    ...n,
    ...e
  }, children: t });
}, by = () => ft(Xu);
function _y(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
function Ju(e, t = 0) {
  return t > 100 ? !1 : e === null || typeof e == "string" || typeof e == "boolean" ? !0 : typeof e == "number" ? !Number.isNaN(e) && Number.isFinite(e) : Array.isArray(e) ? e.every((n) => Ju(n, t + 1)) : _y(e) ? Object.entries(e).every(([n, r]) => typeof n == "string" && Ju(r, t + 1)) : !1;
}
const Qd = (e, t) => t === void 0 ? e.status?.type === "requires-action" && e.status.reason === "tool-calls" && e.content.every((n) => n.type !== "tool-call" || !!n.result) : e.status?.type === "requires-action" && e.status.reason === "tool-calls" && e.content.every((n) => n.type !== "tool-call" || !!n.result || !t.includes(n.toolName));
class Jo extends Error {
  constructor(n, r) {
    super(r);
    k(this, "name", "AbortError");
    k(this, "detach");
    this.detach = n;
  }
}
class Ty extends ry {
  constructor(n, r) {
    super(n);
    k(this, "capabilities", {
      switchToBranch: !0,
      switchBranchDuringRun: !0,
      edit: !0,
      reload: !0,
      cancel: !0,
      unstable_copy: !0,
      speech: !1,
      dictation: !1,
      attachments: !1,
      feedback: !1,
      queue: !1
    });
    k(this, "abortController", null);
    k(this, "isDisabled", !1);
    k(this, "_isLoading", !1);
    k(this, "_suggestions", []);
    k(this, "_suggestionsController", null);
    k(this, "_options");
    k(this, "_lastRunConfig", {});
    k(this, "_getThreadId");
    k(this, "_getInitializePromise");
    k(this, "_loadPromise");
    this.__internal_setOptions(r);
  }
  get isLoading() {
    return this._isLoading;
  }
  get suggestions() {
    return this._suggestions;
  }
  get adapters() {
    return this._options.adapters;
  }
  __internal_setGetThreadId(n) {
    this._getThreadId = n;
  }
  __internal_setGetInitializePromise(n) {
    this._getInitializePromise = n;
  }
  get extras() {
  }
  __internal_setOptions(n) {
    if (this._options === n)
      return;
    this._options = n;
    let r = !1;
    const s = n.adapters?.speech !== void 0;
    this.capabilities.speech !== s && (this.capabilities.speech = s, r = !0);
    const i = n.adapters?.dictation !== void 0;
    this.capabilities.dictation !== i && (this.capabilities.dictation = i, r = !0);
    const a = n.adapters?.attachments !== void 0;
    this.capabilities.attachments !== a && (this.capabilities.attachments = a, r = !0);
    const o = n.adapters?.feedback !== void 0;
    this.capabilities.feedback !== o && (this.capabilities.feedback = o, r = !0), r && this._notifySubscribers();
  }
  __internal_load() {
    if (this._loadPromise)
      return this._loadPromise;
    const n = this.adapters.history?.load() ?? Promise.resolve(null);
    return this._isLoading = !0, this._notifySubscribers(), this._loadPromise = n.then((r) => {
      if (!r)
        return;
      this.repository.import(r), r.messages.length > 0 && this.ensureInitialized(), this._notifySubscribers();
      const s = this.adapters.history?.resume?.bind(this.adapters.history);
      r.unstable_resume && s && this.startRun({
        parentId: this.repository.headId,
        sourceId: this.repository.headId,
        runConfig: this._lastRunConfig
      }, s).catch(() => {
      });
    }).finally(() => {
      this._isLoading = !1, this._notifySubscribers();
    }), this._loadPromise;
  }
  async append(n) {
    this.ensureInitialized();
    const r = this._getInitializePromise?.();
    r && await r;
    const s = Ai(n, Kn(), {
      type: "complete",
      reason: "unknown"
    });
    this.repository.addOrUpdateMessage(n.parentId, s), this._options.adapters.history?.append({
      parentId: n.parentId,
      message: s,
      ...n.runConfig !== void 0 && { runConfig: n.runConfig }
    }), n.startRun ?? n.role === "user" ? await this.startRun({
      parentId: s.id,
      sourceId: n.sourceId,
      runConfig: n.runConfig ?? {}
    }) : (this.repository.resetHead(s.id), this._notifySubscribers());
  }
  resumeRun({ stream: n, ...r }) {
    if (!n)
      throw new Error("You must pass a stream parameter to resume runs.");
    return this.startRun(r, n);
  }
  exportExternalState() {
    throw new Error("Runtime does not support exporting external states.");
  }
  importExternalState() {
    throw new Error("Runtime does not support importing external states.");
  }
  unstable_loadExternalState() {
    throw new Error("Runtime does not support importing external states.");
  }
  async startRun({ parentId: n, runConfig: r }, s) {
    this.ensureInitialized();
    let a = {
      id: Kn(),
      role: "assistant",
      status: { type: "running" },
      content: [],
      metadata: {
        unstable_state: this.state,
        unstable_annotations: [],
        unstable_data: [],
        steps: [],
        custom: {}
      },
      createdAt: /* @__PURE__ */ new Date()
    };
    this._notifyEventSubscribers("runStart");
    try {
      this._suggestions = [], this._suggestionsController?.abort(), this._suggestionsController = null, this._notifySubscribers();
      do
        a = await this.performRoundtrip(n, a, r, s), s = void 0;
      while (Qd(a, this._options.unstable_humanToolNames));
    } finally {
      this._notifyEventSubscribers("runEnd");
    }
    this._suggestionsController = new AbortController();
    const o = this._suggestionsController.signal;
    if (this.adapters.suggestion && a.status?.type !== "requires-action") {
      const u = this.adapters.suggestion?.generate({
        messages: this.messages
      });
      if (Symbol.asyncIterator in u)
        for await (const c of u) {
          if (o.aborted)
            break;
          this._suggestions = c, this._notifySubscribers();
        }
      else {
        const c = await u;
        if (o.aborted)
          return;
        this._suggestions = c, this._notifySubscribers();
      }
    }
  }
  async performRoundtrip(n, r, s, i) {
    const a = n ? this.repository.getMessages(n) : [];
    this.abortController?.abort(), this.abortController = new AbortController();
    const o = r.content, u = r.metadata?.unstable_annotations, c = r.metadata?.unstable_data, l = r.metadata?.steps, h = r.metadata?.custom, m = (g) => {
      const _ = g.metadata?.steps, b = _ ? [...l ?? [], ..._] : void 0, T = g.metadata?.unstable_annotations, C = g.metadata?.unstable_data, R = T ? [...u ?? [], ...T] : void 0, D = C ? [...c ?? [], ...C] : void 0;
      r = {
        ...r,
        ...g.content ? { content: [...o, ...g.content ?? []] } : void 0,
        status: g.status ?? r.status,
        ...g.metadata ? {
          metadata: {
            ...r.metadata,
            ...g.metadata.unstable_state ? { unstable_state: g.metadata.unstable_state } : void 0,
            ...R ? { unstable_annotations: R } : void 0,
            ...D ? { unstable_data: D } : void 0,
            ...b ? { steps: b } : void 0,
            ...g.metadata?.timing ? { timing: g.metadata.timing } : void 0,
            ...g.metadata?.custom ? {
              custom: {
                ...h ?? {},
                ...g.metadata.custom
              }
            } : void 0
          }
        } : void 0
      }, this.repository.addOrUpdateMessage(n, r), this._notifySubscribers();
    }, p = this._options.maxSteps ?? 2;
    if ((r.metadata?.steps?.length ?? 0) >= p)
      return m({
        status: {
          type: "incomplete",
          reason: "tool-calls"
        }
      }), r;
    m({
      status: {
        type: "running"
      }
    }), this.repository.resetHead(r.id), this._notifySubscribers();
    try {
      this._lastRunConfig = s ?? {};
      const g = this.getModelContext();
      i = i ?? this.adapters.chatModel.run.bind(this.adapters.chatModel);
      const _ = this.abortController.signal, b = this._getThreadId?.(), T = i({
        messages: a,
        runConfig: this._lastRunConfig,
        abortSignal: _,
        context: g,
        config: g,
        unstable_assistantMessageId: r.id,
        unstable_threadId: b,
        unstable_parentId: n,
        unstable_getMessage() {
          return r;
        }
      });
      if (Symbol.asyncIterator in T)
        for await (const C of T) {
          if (_.aborted) {
            m({
              status: { type: "incomplete", reason: "cancelled" }
            });
            break;
          }
          m(C);
        }
      else
        m(await T);
      r.status.type === "running" && m({
        status: { type: "complete", reason: "unknown" }
      });
    } catch (g) {
      if (g instanceof Jo)
        m({
          status: { type: "incomplete", reason: "cancelled" }
        });
      else if (g instanceof Error && g.name === "AbortError")
        m({
          status: { type: "incomplete", reason: "cancelled" }
        });
      else
        throw m({
          status: {
            type: "incomplete",
            reason: "error",
            error: g instanceof Error ? g.message : `[${typeof g}] ${new String(g).toString()}`
          }
        }), g;
    } finally {
      this.abortController = null, (r.status.type === "complete" || r.status.type === "incomplete") && await this._options.adapters.history?.append({
        parentId: n,
        message: r,
        runConfig: this._lastRunConfig
      });
    }
    return r;
  }
  detach() {
    const n = new Jo(!0);
    this.abortController?.abort(n), this.abortController = null;
  }
  cancelRun() {
    const n = new Jo(!1);
    this.abortController?.abort(n), this.abortController = null;
  }
  addToolResult({ messageId: n, toolCallId: r, result: s, isError: i, artifact: a }) {
    const o = this.repository.getMessage(n), { parentId: u } = o;
    let { message: c } = o;
    if (c.role !== "assistant")
      throw new Error("Tried to add tool result to non-assistant message");
    let l = !1, h = !1;
    const m = c.content.map((p) => p.type !== "tool-call" || p.toolCallId !== r ? p : (h = !0, p.result || (l = !0), {
      ...p,
      result: s,
      artifact: a,
      isError: i
    }));
    if (!h)
      throw new Error("Tried to add tool result to non-existing tool call");
    c = {
      ...c,
      content: m
    }, this.repository.addOrUpdateMessage(u, c), l && Qd(c, this._options.unstable_humanToolNames) && this.performRoundtrip(u, c, this._lastRunConfig).catch(() => {
    });
  }
  resumeToolCall(n) {
    throw new Error("Local runtime does not support resuming tool calls.");
  }
}
const Xd = Object.freeze([]), Zu = "__DEFAULT_ID__", Ay = Object.freeze({
  [Zu]: {
    id: Zu,
    remoteId: void 0,
    externalId: void 0,
    status: "regular",
    title: void 0
  }
});
class yy extends Ti {
  constructor(n) {
    super();
    k(this, "_mainThread");
    this._mainThread = n();
  }
  get isLoading() {
    return !1;
  }
  getMainThreadRuntimeCore() {
    return this._mainThread;
  }
  get newThreadId() {
  }
  get threadIds() {
    return Xd;
  }
  get archivedThreadIds() {
    return Xd;
  }
  get mainThreadId() {
    return Zu;
  }
  get threadItems() {
    return Ay;
  }
  getThreadRuntimeCore() {
    throw new Error("Method not implemented.");
  }
  getLoadThreadsPromise() {
    return Promise.resolve();
  }
  getItemById(n) {
    if (n === this.mainThreadId)
      return {
        status: "regular",
        id: this.mainThreadId,
        remoteId: this.mainThreadId,
        externalId: void 0,
        title: void 0,
        isMain: !0
      };
    throw new Error("Method not implemented");
  }
  async switchToThread() {
    throw new Error("Method not implemented.");
  }
  switchToNewThread() {
    throw new Error("Method not implemented.");
  }
  rename() {
    throw new Error("Method not implemented.");
  }
  archive() {
    throw new Error("Method not implemented.");
  }
  detach() {
    throw new Error("Method not implemented.");
  }
  unarchive() {
    throw new Error("Method not implemented.");
  }
  delete() {
    throw new Error("Method not implemented.");
  }
  initialize(n) {
    return Promise.resolve({ remoteId: n, externalId: void 0 });
  }
  generateTitle() {
    throw new Error("Method not implemented.");
  }
}
class xy extends Gc {
  constructor(n, r) {
    super();
    k(this, "threads");
    k(this, "Provider");
    k(this, "_options");
    this._options = n, this.threads = new yy(() => new Ty(this._contextProvider, this._options)), r && this.threads.getMainThreadRuntimeCore().import(Wc.fromArray(r));
  }
}
const Jd = (e, t, n) => n.reduce((r, s) => s?.(r, t) ?? r, e);
class Cy extends Ti {
  constructor(n) {
    super();
    k(this, "_pendingTransforms", []);
    /**
     * `optimistic` callbacks from transforms that have already resolved.
     * Re-applied after every `then` callback so that a wholesale state
     * replacement (e.g. list()) cannot erase earlier completed effects
     * (e.g. delete). Cleared when no pending transforms remain.
     *
     * Correctness requirement: `optimistic` callbacks must be idempotent.
     */
    k(this, "_completedOptimistics", []);
    k(this, "_baseValue");
    k(this, "_cachedValue");
    this._baseValue = n, this._cachedValue = n;
  }
  _updateState() {
    this._cachedValue = this._pendingTransforms.reduce((n, r) => Jd(n, r.task, [
      r.loading,
      r.optimistic
    ]), this._baseValue), this._notifySubscribers();
  }
  get baseValue() {
    return this._baseValue;
  }
  get value() {
    return this._cachedValue;
  }
  update(n) {
    this._baseValue = n, this._updateState();
  }
  async optimisticUpdate(n) {
    const r = n.execute(), s = { ...n, task: r };
    try {
      this._pendingTransforms.push(s), this._updateState();
      const i = await r;
      this._baseValue = Jd(this._baseValue, i, [
        n.optimistic,
        n.then
      ]);
      for (const a of this._completedOptimistics)
        this._baseValue = a(this._baseValue);
      return n.optimistic && this._completedOptimistics.push(n.optimistic), i;
    } finally {
      const i = this._pendingTransforms.indexOf(s);
      i > -1 && this._pendingTransforms.splice(i, 1), this._pendingTransforms.length === 0 && (this._completedOptimistics.length = 0), this._updateState();
    }
  }
}
const Qe = new Error("This is the empty thread, a placeholder for the main thread. You cannot perform any actions on this thread instance. This error is probably because you tried to call a thread method in your render function. Call the method inside a `useEffect` hook instead."), Sy = {
  getMessageById() {
  },
  getBranches() {
    return [];
  },
  switchToBranch() {
    throw Qe;
  },
  append() {
    throw Qe;
  },
  startRun() {
    throw Qe;
  },
  resumeRun() {
    throw Qe;
  },
  cancelRun() {
    throw Qe;
  },
  addToolResult() {
    throw Qe;
  },
  resumeToolCall() {
    throw Qe;
  },
  speak() {
    throw Qe;
  },
  stopSpeaking() {
    throw Qe;
  },
  submitFeedback() {
    throw Qe;
  },
  getModelContext() {
    return {};
  },
  exportExternalState() {
    throw Qe;
  },
  importExternalState() {
    throw Qe;
  },
  unstable_loadExternalState() {
    throw Qe;
  },
  composer: {
    attachments: [],
    attachmentAccept: "*",
    async addAttachment(e) {
      throw Qe;
    },
    async removeAttachment() {
      throw Qe;
    },
    isEditing: !0,
    canCancel: !1,
    isEmpty: !0,
    text: "",
    setText() {
      throw Qe;
    },
    role: "user",
    setRole() {
      throw Qe;
    },
    runConfig: {},
    setRunConfig() {
      throw Qe;
    },
    async reset() {
    },
    async clearAttachments() {
    },
    send() {
      throw Qe;
    },
    cancel() {
    },
    dictation: void 0,
    startDictation() {
      throw Qe;
    },
    stopDictation() {
    },
    quote: void 0,
    setQuote() {
      throw Qe;
    },
    subscribe() {
      return () => {
      };
    },
    unstable_on() {
      return () => {
      };
    }
  },
  getEditComposer() {
  },
  beginEdit() {
    throw Qe;
  },
  speech: void 0,
  capabilities: {
    switchToBranch: !1,
    switchBranchDuringRun: !1,
    edit: !1,
    reload: !1,
    cancel: !1,
    unstable_copy: !1,
    speech: !1,
    dictation: !1,
    attachments: !1,
    feedback: !1,
    queue: !1
  },
  isDisabled: !1,
  isLoading: !1,
  messages: [],
  state: null,
  suggestions: [],
  extras: void 0,
  subscribe() {
    return () => {
    };
  },
  import() {
    throw Qe;
  },
  export() {
    return { messages: [] };
  },
  reset() {
    throw Qe;
  },
  unstable_on() {
    return () => {
    };
  }
};
const $s = (e, t) => {
  const n = e.threadIdMap[t];
  if (n !== void 0)
    return e.threadData[n];
}, $i = (e, t, n) => {
  const r = $s(e, t);
  if (!r)
    return e;
  const { id: s, remoteId: i, status: a } = r;
  if (a === n)
    return e;
  const o = { ...e };
  switch (a) {
    case "new":
      o.newThreadId = void 0;
      break;
    case "regular":
      o.threadIds = o.threadIds.filter((u) => u !== s);
      break;
    case "archived":
      o.archivedThreadIds = o.archivedThreadIds.filter((u) => u !== s);
      break;
    default: {
      const u = a;
      throw new Error(`Unsupported state: ${u}`);
    }
  }
  switch (n) {
    case "regular":
      o.threadIds = [s, ...o.threadIds];
      break;
    case "archived":
      o.archivedThreadIds = [s, ...o.archivedThreadIds];
      break;
    case "deleted":
      o.threadData = Object.fromEntries(Object.entries(o.threadData).filter(([u]) => u !== s)), o.threadIdMap = Object.fromEntries(Object.entries(o.threadIdMap).filter(([u]) => u !== s && u !== i));
      break;
    default: {
      const u = n;
      throw new Error(`Unsupported state: ${u}`);
    }
  }
  return n !== "deleted" && (o.threadData = {
    ...o.threadData,
    [s]: {
      ...r,
      status: n
    }
  }), o;
};
class Iy extends Ti {
  constructor(n, r) {
    super();
    k(this, "useRuntimeHook");
    k(this, "instances", /* @__PURE__ */ new Map());
    k(this, "useAliveThreadsKeysChanged", as(() => ({})));
    k(this, "parent");
    k(this, "_InnerActiveThreadProvider", ({ threadId: n }) => {
      const { useRuntime: r } = this.useRuntimeHook(), s = r(), i = s.thread.__internal_threadBinding, a = ne(() => {
        const l = this.instances.get(n);
        if (!l)
          throw new Error("Thread not found. This is a bug in assistant-ui.");
        l.runtime = i.getState(), this._notifySubscribers();
      }, [n, i]), o = Ke(!1);
      o.current || a(), xe(() => (o.current = !0, a(), i.outerSubscribe(a)), [i, a]);
      const u = Re(), c = Ke(void 0);
      return xe(() => {
        const l = i.getState(), h = l.__internal_setGetInitializePromise;
        typeof h == "function" && h.call(l, () => c.current);
      }, [i]), xe(() => s.threads.main.unstable_on("initialize", () => {
        if (u.threadListItem().getState().status === "new") {
          c.current = u.threadListItem().initialize();
          const h = s.thread.unstable_on("runEnd", () => {
            h(), u.threadListItem().generateTitle();
          });
        }
      }), [s, u]), null;
    });
    k(this, "_OuterActiveThreadProvider", he(({ threadId: n, provider: r }) => {
      const s = ie(() => new Mm(this.parent).getItemById(n), [n]);
      return d.jsx(zA, { runtime: s, children: d.jsx(r, { children: d.jsx(this._InnerActiveThreadProvider, { threadId: n }) }) });
    }));
    k(this, "__internal_RenderThreadRuntimes", ({ provider: n }) => (this.useAliveThreadsKeysChanged(), Array.from(this.instances.keys()).map((r) => d.jsx(this._OuterActiveThreadProvider, { threadId: r, provider: n }, r))));
    this.parent = r, this.useRuntimeHook = as(() => ({ useRuntime: n }));
  }
  startThreadRuntime(n) {
    return this.instances.has(n) || (this.instances.set(n, {}), this.useAliveThreadsKeysChanged.setState({}, !0)), new Promise((r, s) => {
      const i = () => {
        const o = this.instances.get(n);
        if (!o)
          a(), s(new Error("Thread was deleted before runtime was started"));
        else if (o.runtime)
          a(), r(o.runtime);
        else
          return;
      }, a = this.subscribe(i);
      i();
    });
  }
  getThreadRuntimeCore(n) {
    const r = this.instances.get(n);
    if (r)
      return r.runtime;
  }
  stopThreadRuntime(n) {
    this.instances.delete(n), this.useAliveThreadsKeysChanged.setState({}, !0);
  }
  setRuntimeHook(n) {
    this.useRuntimeHook.getState().useRuntime !== n && this.useRuntimeHook.setState({ useRuntime: n }, !0);
  }
}
class wy extends Ti {
  constructor(n, r) {
    super();
    k(this, "_options");
    k(this, "_hookManager");
    k(this, "_loadThreadsPromise");
    k(this, "_mainThreadId");
    k(this, "_state", new Cy({
      isLoading: !1,
      newThreadId: void 0,
      threadIds: [],
      archivedThreadIds: [],
      threadIdMap: {},
      threadData: {}
    }));
    k(this, "contextProvider");
    k(this, "useProvider");
    k(this, "initialize", async (n) => {
      if (this._state.value.newThreadId !== n) {
        const r = this.getItemById(n);
        if (!r)
          throw new Error("Thread not found");
        if (r.status === "new")
          throw new Error("Unexpected new state");
        return r.initializeTask;
      }
      return this._state.optimisticUpdate({
        execute: () => this._options.adapter.initialize(n),
        optimistic: (r) => $i(r, n, "regular"),
        loading: (r, s) => {
          const i = n;
          return {
            ...r,
            threadData: {
              ...r.threadData,
              [i]: {
                ...r.threadData[i],
                initializeTask: s
              }
            }
          };
        },
        then: (r, { remoteId: s, externalId: i }) => {
          const a = $s(r, n);
          if (!a)
            return r;
          const o = n;
          return {
            ...r,
            threadIdMap: {
              ...r.threadIdMap,
              [s]: o
            },
            threadData: {
              ...r.threadData,
              [o]: {
                ...a,
                initializeTask: Promise.resolve({ remoteId: s, externalId: i }),
                remoteId: s,
                externalId: i
              }
            }
          };
        }
      });
    });
    k(this, "generateTitle", async (n) => {
      const r = this.getItemById(n);
      if (!r)
        throw new Error("Thread not found");
      if (r.status === "new")
        throw new Error("Thread is not yet initialized");
      const { remoteId: s } = await r.initializeTask, i = this._hookManager.getThreadRuntimeCore(r.id);
      if (!i)
        return;
      const a = i.messages, o = await this._options.adapter.generateTitle(s, a), u = Ks.fromAssistantStream(o);
      for await (const c of u) {
        const l = c.parts.filter((p) => p.type === "text")[0]?.text, h = this._state.baseValue, m = $s(h, r.id);
        m && this._state.update({
          ...h,
          threadData: {
            ...h.threadData,
            [m.id]: {
              ...m,
              title: l
            }
          }
        });
      }
    });
    k(this, "useBoundIds", as(() => []));
    k(this, "__internal_RenderComponent", () => {
      const n = HT();
      xe(() => (this.useBoundIds.setState((a) => [...a, n], !0), () => {
        this.useBoundIds.setState((a) => a.filter((o) => o !== n), !0);
      }), [n]);
      const r = this.useBoundIds(), { Provider: s } = this.useProvider(), i = {
        modelContext: this.contextProvider
      };
      return (r.length === 0 || r[0] === n) && // only render if the component is the first one mounted
      d.jsx(Kc, { adapters: i, children: d.jsx(this._hookManager.__internal_RenderThreadRuntimes, { provider: s }) });
    });
    this.contextProvider = r, this._state.subscribe(() => this._notifySubscribers()), this._hookManager = new Iy(n.runtimeHook, this), this.useProvider = as(() => ({
      Provider: n.adapter.unstable_Provider ?? Sd
    })), this.__internal_setOptions(n), this.switchToNewThread();
  }
  get threadItems() {
    return this._state.value.threadData;
  }
  getLoadThreadsPromise() {
    return this._loadThreadsPromise || (this._loadThreadsPromise = this._state.optimisticUpdate({
      execute: () => this._options.adapter.list(),
      loading: (n) => ({
        ...n,
        isLoading: !0
      }),
      then: (n, r) => {
        const s = [], i = [], a = {}, o = {};
        for (const u of r.threads) {
          switch (u.status) {
            case "regular":
              s.push(u.remoteId);
              break;
            case "archived":
              i.push(u.remoteId);
              break;
            default: {
              const l = u.status;
              throw new Error(`Unsupported state: ${l}`);
            }
          }
          const c = u.remoteId;
          a[u.remoteId] = c, o[c] = {
            id: u.remoteId,
            remoteId: u.remoteId,
            externalId: u.externalId,
            status: u.status,
            title: u.title,
            initializeTask: Promise.resolve({
              remoteId: u.remoteId,
              externalId: u.externalId
            })
          };
        }
        return {
          ...n,
          threadIds: s,
          archivedThreadIds: i,
          threadIdMap: {
            ...n.threadIdMap,
            ...a
          },
          threadData: {
            ...n.threadData,
            ...o
          }
        };
      }
    }).then(() => {
    })), this._loadThreadsPromise;
  }
  __internal_setOptions(n) {
    if (this._options === n)
      return;
    this._options = n;
    const r = n.adapter.unstable_Provider ?? Sd;
    r !== this.useProvider.getState().Provider && this.useProvider.setState({ Provider: r }, !0), this._hookManager.setRuntimeHook(n.runtimeHook);
  }
  __internal_load() {
    this.getLoadThreadsPromise();
  }
  get isLoading() {
    return this._state.value.isLoading;
  }
  get threadIds() {
    return this._state.value.threadIds;
  }
  get archivedThreadIds() {
    return this._state.value.archivedThreadIds;
  }
  get newThreadId() {
    return this._state.value.newThreadId;
  }
  get mainThreadId() {
    return this._mainThreadId;
  }
  getMainThreadRuntimeCore() {
    const n = this._hookManager.getThreadRuntimeCore(this._mainThreadId);
    return n || Sy;
  }
  getThreadRuntimeCore(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    const s = this._hookManager.getThreadRuntimeCore(r.id);
    if (!s)
      throw new Error("Thread not found");
    return s;
  }
  getItemById(n) {
    return $s(this._state.value, n);
  }
  async switchToThread(n) {
    let r = this.getItemById(n);
    if (!r) {
      const i = await this._options.adapter.fetch(n), a = this._state.value, o = i.remoteId, u = {
        ...a.threadData,
        [o]: {
          id: o,
          initializeTask: Promise.resolve({
            remoteId: i.remoteId,
            externalId: i.externalId
          }),
          remoteId: i.remoteId,
          externalId: i.externalId,
          status: i.status,
          title: i.title
        }
      }, c = {
        ...a.threadIdMap,
        [i.remoteId]: o
      }, l = i.status === "regular" ? [...a.threadIds, i.remoteId] : a.threadIds, h = i.status === "archived" ? [...a.archivedThreadIds, i.remoteId] : a.archivedThreadIds;
      this._state.update({
        ...a,
        threadIds: l,
        archivedThreadIds: h,
        threadIdMap: c,
        threadData: u
      }), r = this.getItemById(n);
    }
    if (!r)
      throw new Error("Thread not found");
    if (this._mainThreadId === r.id)
      return;
    const s = this._hookManager.startThreadRuntime(r.id);
    this.mainThreadId !== void 0 ? await s : s.then(() => this._notifySubscribers()), r.status === "archived" && await this.unarchive(r.id), this._mainThreadId = r.id, this._notifySubscribers();
  }
  async switchToNewThread() {
    for (; this._state.baseValue.newThreadId !== void 0 && this._state.value.newThreadId === void 0; )
      await this._state.waitForUpdate();
    const n = this._state.value;
    let r = this._state.value.newThreadId;
    if (r === void 0) {
      do
        r = `__LOCALID_${Kn()}`;
      while (n.threadIdMap[r]);
      const s = r;
      this._state.update({
        ...n,
        newThreadId: r,
        threadIdMap: {
          ...n.threadIdMap,
          [r]: s
        },
        threadData: {
          ...n.threadData,
          [s]: {
            status: "new",
            id: r,
            remoteId: void 0,
            externalId: void 0,
            title: void 0
          }
        }
      });
    }
    return this.switchToThread(r);
  }
  rename(n, r) {
    const s = this.getItemById(n);
    if (!s)
      throw new Error("Thread not found");
    if (s.status === "new")
      throw new Error("Thread is not yet initialized");
    return this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: i } = await s.initializeTask;
        return this._options.adapter.rename(i, r);
      },
      optimistic: (i) => {
        const a = $s(i, n);
        return a ? {
          ...i,
          threadData: {
            ...i.threadData,
            [a.id]: {
              ...a,
              title: r
            }
          }
        } : i;
      }
    });
  }
  async _ensureThreadIsNotMain(n) {
    if (n === this.newThreadId)
      throw new Error("Cannot ensure new thread is not main");
    n === this._mainThreadId && await this.switchToNewThread();
  }
  async archive(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular")
      throw new Error("Thread is not yet initialized or already archived");
    return await this._ensureThreadIsNotMain(r.id), this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: s } = await r.initializeTask;
        return this._options.adapter.archive(s);
      },
      optimistic: (s) => $i(s, r.id, "archived")
    });
  }
  unarchive(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "archived")
      throw new Error("Thread is not archived");
    return this._state.optimisticUpdate({
      execute: async () => {
        try {
          const { remoteId: s } = await r.initializeTask;
          return await this._options.adapter.unarchive(s);
        } catch (s) {
          throw await this._ensureThreadIsNotMain(r.id), s;
        }
      },
      optimistic: (s) => $i(s, r.id, "regular")
    });
  }
  async delete(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular" && r.status !== "archived")
      throw new Error("Thread is not yet initialized");
    return await this._ensureThreadIsNotMain(r.id), this._hookManager.stopThreadRuntime(r.id), this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: s } = await r.initializeTask;
        return await this._options.adapter.delete(s);
      },
      optimistic: (s) => $i(s, r.id, "deleted")
    });
  }
  async detach(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular" && r.status !== "archived")
      throw new Error("Thread is not yet initialized");
    await this._ensureThreadIsNotMain(r.id), this._hookManager.stopThreadRuntime(r.id);
  }
}
class vy extends Gc {
  constructor(n) {
    super();
    k(this, "threads");
    this.threads = new wy(n, this._contextProvider);
  }
  get RenderComponent() {
    return this.threads.__internal_RenderComponent;
  }
}
const Ny = (e) => {
  const [t] = de(() => new vy(e));
  return xe(() => {
    t.threads.__internal_setOptions(e), t.threads.__internal_load();
  }, [t, e]), ie(() => new qc(t), [t]);
}, Bm = (e) => {
  const t = Ke(e.runtimeHook);
  t.current = e.runtimeHook;
  const n = ne(() => t.current(), []), r = ie(() => ({
    adapter: e.adapter,
    allowNesting: e.allowNesting,
    runtimeHook: n
  }), [e.adapter, e.allowNesting, n]);
  if (Re().threadListItem.source !== null) {
    if (!r.allowNesting)
      throw new Error("useRemoteThreadListRuntime cannot be nested inside another RemoteThreadListRuntime. Set allowNesting: true to allow nesting (the inner runtime will become a no-op).");
    return n();
  }
  return Ny(r);
}, Zd = (e) => {
  try {
    const n = e.split(".")[1];
    if (!n)
      throw new Error("Invalid JWT format");
    let r = n.replace(/-/g, "+").replace(/_/g, "/");
    for (; r.length % 4 !== 0; )
      r += "=";
    const s = atob(r), a = JSON.parse(s).exp;
    if (!a || typeof a != "number")
      throw new Error('JWT does not contain a valid "exp" field');
    return a * 1e3;
  } catch (t) {
    throw new Error(`Unable to determine the token expiry: ${t}`);
  }
};
var gi;
class Um {
  constructor(t) {
    k(this, "strategy", "jwt");
    k(this, "cachedToken", null);
    k(this, "tokenExpiry", null);
    vs(this, gi);
    Ns(this, gi, t);
  }
  async getAuthHeaders() {
    const t = Date.now();
    if (this.cachedToken && this.tokenExpiry && this.tokenExpiry - t > 30 * 1e3)
      return { Authorization: `Bearer ${this.cachedToken}` };
    const n = await ws(this, gi).call(this);
    return n ? (this.cachedToken = n, this.tokenExpiry = Zd(n), { Authorization: `Bearer ${n}` }) : !1;
  }
  readAuthHeaders(t) {
    const n = t.get("Authorization");
    if (!n)
      return;
    const [r, s] = n.split(" ");
    if (r !== "Bearer" || !s)
      throw new Error("Invalid auth header received");
    this.cachedToken = s, this.tokenExpiry = Zd(s);
  }
}
gi = new WeakMap();
var Ei, bi, _i;
class ky {
  constructor(t, n, r) {
    k(this, "strategy", "api-key");
    vs(this, Ei);
    vs(this, bi);
    vs(this, _i);
    Ns(this, Ei, t), Ns(this, bi, n), Ns(this, _i, r);
  }
  async getAuthHeaders() {
    return {
      Authorization: `Bearer ${ws(this, Ei)}`,
      "Aui-User-Id": ws(this, bi),
      "Aui-Workspace-Id": ws(this, _i)
    };
  }
  readAuthHeaders() {
  }
}
Ei = new WeakMap(), bi = new WeakMap(), _i = new WeakMap();
const zi = "aui:refresh_token";
class Ry {
  constructor(t) {
    k(this, "strategy", "anon");
    k(this, "baseUrl");
    k(this, "jwtStrategy");
    this.baseUrl = t, this.jwtStrategy = new Um(async () => {
      const n = Date.now(), r = localStorage.getItem(zi), s = r ? JSON.parse(r) : void 0;
      if (s)
        if (new Date(s.expires_at).getTime() - n > 30 * 1e3) {
          const l = await fetch(`${this.baseUrl}/v1/auth/tokens/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refresh_token: s.token })
          });
          if (l.ok) {
            const h = await l.json(), { access_token: m, refresh_token: p } = h;
            return p && localStorage.setItem(zi, JSON.stringify(p)), m;
          }
        } else
          localStorage.removeItem(zi);
      const i = await fetch(`${this.baseUrl}/v1/auth/tokens/anonymous`, {
        method: "POST"
      });
      if (!i.ok)
        return null;
      const a = await i.json(), { access_token: o, refresh_token: u } = a;
      return !o || !u ? null : (localStorage.setItem(zi, JSON.stringify(u)), o);
    });
  }
  async getAuthHeaders() {
    return this.jwtStrategy.getAuthHeaders();
  }
  readAuthHeaders(t) {
    this.jwtStrategy.readAuthHeaders(t);
  }
}
class eh extends Error {
  constructor(t) {
    super(t), this.name = "APIError";
  }
}
class Py {
  constructor(t) {
    k(this, "_auth");
    k(this, "_baseUrl");
    if ("authToken" in t)
      this._baseUrl = t.baseUrl, this._auth = new Um(t.authToken);
    else if ("apiKey" in t)
      this._baseUrl = "https://backend.assistant-api.com", this._auth = new ky(t.apiKey, t.userId, t.workspaceId);
    else if ("anonymous" in t)
      this._baseUrl = t.baseUrl, this._auth = new Ry(t.baseUrl);
    else
      throw new Error("Invalid configuration: Must provide authToken, apiKey, or anonymous configuration");
  }
  async initializeAuth() {
    return !!this._auth.getAuthHeaders();
  }
  async makeRawRequest(t, n = {}) {
    const r = await this._auth.getAuthHeaders();
    if (!r)
      throw new Error("Authorization failed");
    const s = {
      ...r,
      ...n.headers,
      "Content-Type": "application/json"
    }, i = new URLSearchParams();
    if (n.query)
      for (const [u, c] of Object.entries(n.query))
        c !== !1 && (c === !0 ? i.set(u, "true") : i.set(u, c.toString()));
    const a = new URL(`${this._baseUrl}/v1${t}`);
    a.search = i.toString();
    const o = await fetch(a, {
      method: n.method ?? "GET",
      headers: s,
      body: n.body ? JSON.stringify(n.body) : null
    });
    if (this._auth.readAuthHeaders(o.headers), !o.ok) {
      const u = await o.text();
      try {
        const c = JSON.parse(u);
        throw new eh(c.message);
      } catch (c) {
        throw c instanceof eh ? c : new Error(`Request failed with status ${o.status}, ${u}`);
      }
    }
    return o;
  }
  async makeRequest(t, n = {}) {
    return (await this.makeRawRequest(t, n)).json();
  }
}
class Oy {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  async create() {
    return this.cloud.makeRequest("/auth/tokens", { method: "POST" });
  }
}
class Dy {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  __internal_getAssistantOptions(t) {
    return {
      api: `${this.cloud._baseUrl}/v1/runs/stream`,
      headers: async () => {
        const n = await this.cloud._auth.getAuthHeaders();
        if (!n)
          throw new Error("Authorization failed");
        return {
          ...n,
          Accept: "text/plain"
        };
      },
      body: {
        assistant_id: t,
        response_format: "vercel-ai-data-stream/v1",
        thread_id: "unstable_todo"
      }
    };
  }
  async stream(t) {
    const n = await this.cloud.makeRawRequest("/runs/stream", {
      method: "POST",
      headers: {
        Accept: "text/plain"
      },
      body: t
    });
    return Qu.fromResponse(n, new RA());
  }
  async report(t) {
    return this.cloud.makeRequest("/runs", { method: "POST", body: t });
  }
}
class Ly {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  async list(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages`, { query: n });
  }
  async create(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages`, { method: "POST", body: n });
  }
  async update(t, n, r) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages/${encodeURIComponent(n)}`, { method: "PUT", body: r });
  }
}
class My {
  constructor(t) {
    k(this, "cloud");
    k(this, "messages");
    this.cloud = t, this.messages = new Ly(t);
  }
  async list(t) {
    return this.cloud.makeRequest("/threads", { query: t });
  }
  async get(t) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`);
  }
  async create(t) {
    return this.cloud.makeRequest("/threads", { method: "POST", body: t });
  }
  async update(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`, {
      method: "PUT",
      body: n
    });
  }
  async delete(t) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`, {
      method: "DELETE"
    });
  }
}
class Hy {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  async pdfToImages(t) {
    return this.cloud.makeRequest("/files/pdf-to-images", {
      method: "POST",
      body: t
    });
  }
  async generatePresignedUploadUrl(t) {
    return this.cloud.makeRequest("/files/attachments/generate-presigned-upload-url", {
      method: "POST",
      body: t
    });
  }
}
class By {
  constructor(t) {
    k(this, "threads");
    k(this, "auth");
    k(this, "runs");
    k(this, "files");
    k(this, "telemetry");
    const n = new Py(t);
    this.threads = new My(n), this.auth = {
      tokens: new Oy(n)
    }, this.runs = new Dy(n), this.files = new Hy(n);
    const r = t.telemetry;
    this.telemetry = r === !1 ? { enabled: !1 } : r === !0 || r === void 0 ? { enabled: !0 } : { enabled: r.enabled !== !1, ...r };
  }
}
class Uy {
  constructor(t) {
    k(this, "cloud");
    k(this, "idMapping", {});
    this.cloud = t;
  }
  /**
   * Persist a message to the cloud.
   *
   * @param threadId - Remote thread ID
   * @param messageId - Local message ID (used for tracking)
   * @param parentId - Local parent message ID (or null for first message)
   * @param format - Message format (e.g., "aui/v0", "ai-sdk/v6")
   * @param content - Message content (format-specific)
   */
  async append(t, n, r, s, i) {
    const a = r ? await this.idMapping[r] ?? r : null, o = this.cloud.threads.messages.create(t, {
      parent_id: a,
      format: s,
      content: i
    }).then(({ message_id: u }) => (this.idMapping[n] = u, u)).catch((u) => {
      throw this.idMapping[n] === o && delete this.idMapping[n], u;
    });
    return this.idMapping[n] = o, o.then(() => {
    });
  }
  /**
   * Update an already-persisted message in the cloud.
   */
  async update(t, n, r, s) {
    const i = await this.getRemoteId(n);
    i && await this.cloud.threads.messages.update(t, i, { content: s });
  }
  /**
   * Check if a message has been persisted (or is currently being persisted).
   */
  isPersisted(t) {
    return t in this.idMapping;
  }
  /**
   * Get the remote ID for a local message ID (resolved).
   * Returns undefined if not persisted.
   */
  async getRemoteId(t) {
    const n = this.idMapping[t];
    if (n)
      return n;
  }
  /**
   * Load messages from the cloud and populate the ID mapping.
   *
   * The ID mapping is populated so that `isPersisted()` returns true for
   * loaded messages, preventing re-persistence of already-stored messages.
   *
   * @param threadId - Remote thread ID
   * @param format - Optional format filter
   * @returns Array of cloud messages
   */
  async load(t, n) {
    const { messages: r } = await this.cloud.threads.messages.list(t, n ? { format: n } : void 0);
    for (const s of r)
      this.idMapping[s.id] = s.id;
    return r;
  }
  /**
   * Reset the ID mapping (call when switching threads).
   */
  reset() {
    this.idMapping = {};
  }
}
const Fy = (e, t) => ({
  append: async (n, r) => {
    const s = t.getId(r.message), i = t.encode(r);
    return e.append(n, s, r.parentId, t.format, i);
  },
  update: e.update ? async (n, r, s) => {
    const i = t.encode(r);
    return e.update(n, s, t.format, i);
  } : void 0,
  load: async (n) => ({
    messages: (await e.load(n, t.format)).filter((s) => s.format === t.format).map((s) => t.decode({
      id: s.id,
      parent_id: s.parent_id,
      format: s.format,
      content: s.content
    })).reverse()
  }),
  isPersisted: (n) => e.isPersisted(n)
});
class jy {
  list() {
    return Promise.resolve({
      threads: []
    });
  }
  rename() {
    return Promise.resolve();
  }
  archive() {
    return Promise.resolve();
  }
  unarchive() {
    return Promise.resolve();
  }
  delete() {
    return Promise.resolve();
  }
  initialize(t) {
    return Promise.resolve({ remoteId: t, externalId: void 0 });
  }
  generateTitle() {
    return Promise.resolve(new ReadableStream());
  }
  fetch(t) {
    return Promise.reject(new Error("Thread not found"));
  }
}
function $y(e) {
  const t = e.status?.type === "running" ? { type: "incomplete", reason: "cancelled" } : e.status;
  return {
    role: e.role,
    content: e.content.map((n) => {
      const r = n.type;
      switch (r) {
        case "text":
          return { type: "text", text: n.text };
        case "reasoning":
          return { type: "reasoning", text: n.text };
        case "source":
          return {
            type: "source",
            sourceType: n.sourceType,
            id: n.id,
            url: n.url,
            ...n.title ? { title: n.title } : void 0
          };
        case "tool-call":
          return Ju(n.result) || console.warn(`tool-call result is not JSON! ${JSON.stringify(n)}`), {
            type: "tool-call",
            toolCallId: n.toolCallId,
            toolName: n.toolName,
            ...JSON.stringify(n.args) === n.argsText ? { args: n.args } : { argsText: n.argsText },
            ...n.result ? { result: n.result } : void 0,
            ...n.isError ? { isError: !0 } : void 0
          };
        case "image":
          return { type: "image", image: n.image };
        case "file":
          return {
            type: "file",
            data: n.data,
            mimeType: n.mimeType,
            ...n.filename ? { filename: n.filename } : void 0
          };
        default: {
          const s = r;
          throw new Error(`Message part type not supported by aui/v0: ${s}`);
        }
      }
    }),
    metadata: e.metadata,
    ...t ? { status: t } : void 0
  };
}
function zy(e) {
  const t = e.content, n = Ai({
    id: e.id,
    createdAt: e.created_at,
    ...t
  }, e.id, { type: "complete", reason: "unknown" });
  return {
    parentId: e.parent_id,
    message: n
  };
}
const Zo = /* @__PURE__ */ new WeakMap();
class Vy {
  constructor(t, n) {
    k(this, "cloudRef");
    k(this, "aui");
    this.cloudRef = t, this.aui = n;
  }
  get _persistence() {
    const t = this.aui.threadListItem();
    return Zo.has(t) || Zo.set(t, new Uy(this.cloudRef.current)), Zo.get(t);
  }
  withFormat(t) {
    const n = this, r = Fy(this._persistence, t);
    return {
      // Note: callers must also call reportTelemetry() for run tracking
      async append(s) {
        const { remoteId: i } = await n.aui.threadListItem().initialize();
        await r.append(i, s);
      },
      async update(s, i) {
        const a = n.aui.threadListItem().getState().remoteId;
        a && await r.update?.(a, s, i);
      },
      reportTelemetry(s, i) {
        const a = s.map((o) => t.encode(o));
        n._reportRunTelemetry(t.format, a, i);
      },
      async load() {
        const s = n.aui.threadListItem().getState().remoteId;
        return s ? r.load(s) : { messages: [] };
      }
    };
  }
  async append({ parentId: t, message: n }) {
    const { remoteId: r } = await this.aui.threadListItem().initialize(), s = $y(n);
    await this._persistence.append(r, n.id, t, "aui/v0", s), this.cloudRef.current.telemetry.enabled && this._maybeReportRun(r, "aui/v0", s);
  }
  async load() {
    const t = this.aui.threadListItem().getState().remoteId;
    return t ? {
      messages: (await this._persistence.load(t, "aui/v0")).filter((r) => r.format === "aui/v0").map(zy).reverse()
    } : { messages: [] };
  }
  _reportRunTelemetry(t, n, r) {
    if (!this.cloudRef.current.telemetry.enabled)
      return;
    const s = this.aui.threadListItem().getState().remoteId;
    if (!s)
      return;
    const i = qy(t, n);
    i && this._sendReport(s, i, r?.durationMs, r?.stepTimestamps);
  }
  _maybeReportRun(t, n, r) {
    const s = jm(n, r);
    s && this._sendReport(t, s);
  }
  _sendReport(t, n, r, s) {
    const i = Wy(n.steps, s), a = {
      thread_id: t,
      status: n.status,
      ...n.totalSteps != null ? { total_steps: n.totalSteps } : void 0,
      ...n.toolCalls ? { tool_calls: n.toolCalls } : void 0,
      ...i ? { steps: i } : void 0,
      ...n.inputTokens != null ? { input_tokens: n.inputTokens } : void 0,
      ...n.outputTokens != null ? { output_tokens: n.outputTokens } : void 0,
      ...n.reasoningTokens != null ? { reasoning_tokens: n.reasoningTokens } : void 0,
      ...n.cachedInputTokens != null ? { cached_input_tokens: n.cachedInputTokens } : void 0,
      ...r != null ? { duration_ms: r } : void 0,
      ...n.outputText != null ? { output_text: n.outputText } : void 0,
      ...n.metadata ? { metadata: n.metadata } : void 0,
      ...n.modelId ? { model_id: n.modelId } : void 0
    }, { beforeReport: o } = this.cloudRef.current.telemetry, u = o ? o(a) : a;
    u && this.cloudRef.current.runs.report(u).catch(() => {
    });
  }
}
const th = 5e4;
function so(e) {
  return e.length <= th ? e : e.slice(0, th);
}
function ec(e) {
  if (e != null)
    try {
      return so(JSON.stringify(e));
    } catch {
      return;
    }
}
const Yy = /^[A-Za-z0-9+/]{100,}={0,2}$/;
function Gy(e) {
  if (e != null) {
    try {
      const t = typeof e == "string" ? JSON.parse(e) : e;
      if (Array.isArray(t)) {
        const n = t.map((r) => {
          if (r && typeof r == "object" && r.type && (r.type === "image" || r.type === "audio") && typeof r.data == "string" && Yy.test(r.data.slice(0, 200))) {
            const s = (r.data.length * 3 / 4 / 1024).toFixed(1);
            return { ...r, data: `[${r.type}: ${s}KB]` };
          }
          return r;
        });
        return so(JSON.stringify(n));
      }
    } catch {
    }
    return ec(e);
  }
}
function Fm(e, t, n, r, s, i) {
  const a = {
    tool_name: e,
    tool_call_id: t
  }, o = s ?? ec(n);
  o !== void 0 && (a.tool_args = o);
  const u = i === "mcp" ? Gy(r) : ec(r);
  return u !== void 0 && (a.tool_result = u), i && (a.tool_source = i), a;
}
function Wy(e, t) {
  if (!t)
    return e;
  if (!e)
    return t.map((r) => ({ ...r }));
  const n = Math.min(e.length, t.length);
  return e.map((r, s) => ({
    ...r,
    ...s < n ? t[s] : void 0
  }));
}
function jm(e, t) {
  switch (e) {
    case "aui/v0":
      return Qy(t);
    case "ai-sdk/v6":
      return tx(t);
    default:
      return null;
  }
}
function qy(e, t) {
  if (e === "ai-sdk/v6")
    return nx(t);
  for (let n = t.length - 1; n >= 0; n--) {
    const r = jm(e, t[n]);
    if (r)
      return r;
  }
  return null;
}
const Ky = {
  error: "error",
  incomplete: "incomplete"
};
function Qy(e) {
  const t = e;
  if (t.role !== "assistant")
    return null;
  const n = t.content?.filter((g) => g.type === "tool-call" && g.toolName && g.toolCallId).map((g) => Fm(g.toolName, g.toolCallId, g.args, g.result, g.argsText)), r = t.content?.filter((g) => g.type === "text" && g.text), s = r && r.length > 0 ? so(r.map((g) => g.text).join("")) : void 0, i = t.metadata?.steps;
  let a, o, u, c;
  if (i && i.length > 0) {
    let g = 0, _ = 0, b = 0, T = 0, C = !1, R = !1, D = !1, I = !1;
    for (const O of i)
      O.usage?.inputTokens != null && (g += O.usage.inputTokens, C = !0), O.usage?.outputTokens != null && (_ += O.usage.outputTokens, R = !0), O.usage?.reasoningTokens != null && (b += O.usage.reasoningTokens, D = !0), O.usage?.cachedInputTokens != null && (T += O.usage.cachedInputTokens, I = !0);
    a = C ? g : void 0, o = R ? _ : void 0, u = D ? b : void 0, c = I ? T : void 0;
  }
  const l = t.status?.type, h = l && Ky[l] || "completed", m = t.metadata?.custom, p = t.metadata?.modelId ?? (typeof t.metadata?.custom?.modelId == "string" ? t.metadata.custom.modelId : void 0), E = i && i.length > 1 ? i.map((g) => ({
    ...g.usage?.inputTokens != null ? { input_tokens: g.usage.inputTokens } : void 0,
    ...g.usage?.outputTokens != null ? { output_tokens: g.usage.outputTokens } : void 0,
    ...g.usage?.reasoningTokens != null ? { reasoning_tokens: g.usage.reasoningTokens } : void 0,
    ...g.usage?.cachedInputTokens != null ? { cached_input_tokens: g.usage.cachedInputTokens } : void 0
  })) : void 0;
  return {
    status: h,
    ...n && n.length > 0 ? { toolCalls: n } : void 0,
    ...i?.length ? { totalSteps: i.length } : void 0,
    ...a != null ? { inputTokens: a } : void 0,
    ...o != null ? { outputTokens: o } : void 0,
    ...u != null ? { reasoningTokens: u } : void 0,
    ...c != null ? { cachedInputTokens: c } : void 0,
    ...s != null ? { outputText: s } : void 0,
    ...m ? { metadata: m } : void 0,
    ...E ? { steps: E } : void 0,
    ...p ? { modelId: p } : void 0
  };
}
function Xy(e) {
  return e.toolCallId ? e.type === "tool-call" || e.type === "dynamic-tool" ? !!e.toolName : e.type.startsWith("tool-") || e.type.startsWith("dynamic-tool-") : !1;
}
function Jy(e) {
  return e.type === "dynamic-tool" || e.type.startsWith("dynamic-tool-");
}
function Zy(e) {
  const t = Jy(e) ? "mcp" : void 0;
  return Fm(e.toolName ?? e.type.slice(5), e.toolCallId, e.args ?? e.input, e.result ?? e.output, void 0, t);
}
function $m(e) {
  const t = [], n = [], r = [];
  let s = null;
  for (const i of e)
    if (i.type === "step-start")
      s !== null && r.push({ tool_calls: s }), s = [];
    else if (i.type === "text" && i.text)
      t.push(i.text);
    else if (Xy(i)) {
      const a = Zy(i);
      n.push(a), s !== null && s.push(a);
    }
  return s !== null && r.push({ tool_calls: s }), { textParts: t, toolCalls: n, stepsData: r };
}
function ex(e) {
  if (!e)
    return;
  if (typeof e.modelId == "string")
    return e.modelId;
  const t = e.custom;
  if (typeof t?.modelId == "string")
    return t.modelId;
}
function zm(e, t, n, r, s, i) {
  const a = e.length > 0, o = a ? so(e.join("")) : void 0, u = ex(r), c = s && s.length > 1 ? s.map((l) => ({
    ...l.tool_calls.length > 0 ? { tool_calls: l.tool_calls } : void 0
  })) : void 0;
  return {
    status: a ? "completed" : "incomplete",
    ...t.length > 0 ? { toolCalls: t } : void 0,
    ...n > 0 ? { totalSteps: n } : void 0,
    ...i?.inputTokens != null ? { inputTokens: i.inputTokens } : void 0,
    ...i?.outputTokens != null ? { outputTokens: i.outputTokens } : void 0,
    ...i?.reasoningTokens != null ? { reasoningTokens: i.reasoningTokens } : void 0,
    ...i?.cachedInputTokens != null ? { cachedInputTokens: i.cachedInputTokens } : void 0,
    ...o != null ? { outputText: o } : void 0,
    ...r ? { metadata: r } : void 0,
    ...c ? { steps: c } : void 0,
    ...u ? { modelId: u } : void 0
  };
}
function nh(e) {
  const t = e.inputTokens ?? e.promptTokens, n = e.outputTokens ?? e.completionTokens;
  if (!(t == null && n == null && e.reasoningTokens == null && e.cachedInputTokens == null))
    return {
      ...t != null ? { inputTokens: t } : void 0,
      ...n != null ? { outputTokens: n } : void 0,
      ...e.reasoningTokens != null ? { reasoningTokens: e.reasoningTokens } : void 0,
      ...e.cachedInputTokens != null ? { cachedInputTokens: e.cachedInputTokens } : void 0
    };
}
function Vm(e) {
  const t = e?.usage;
  if (t) {
    const r = nh(t);
    if (r)
      return r;
  }
  const n = e?.steps;
  if (n && n.length > 0) {
    let r = 0, s = 0, i = 0, a = 0, o = !1, u = !1, c = !1, l = !1, h = !1;
    for (const m of n) {
      if (!m.usage)
        continue;
      const p = nh(m.usage);
      p && (p.inputTokens != null && (r += p.inputTokens, o = !0), p.outputTokens != null && (s += p.outputTokens, u = !0), p.reasoningTokens != null && (i += p.reasoningTokens, c = !0), p.cachedInputTokens != null && (a += p.cachedInputTokens, l = !0), h = !0);
    }
    if (h)
      return {
        ...o ? { inputTokens: r } : void 0,
        ...u ? { outputTokens: s } : void 0,
        ...c ? { reasoningTokens: i } : void 0,
        ...l ? { cachedInputTokens: a } : void 0
      };
  }
}
function tx(e) {
  const t = e;
  if (t.role !== "assistant")
    return null;
  const { textParts: n, toolCalls: r, stepsData: s } = $m(t.parts ?? []);
  return zm(n, r, s.length, t.metadata, s, Vm(t.metadata));
}
function nx(e) {
  const t = [], n = [], r = [];
  let s = !1, i, a = 0, o = 0, u = 0, c = 0, l = !1, h = !1, m = !1, p = !1;
  for (const E of e) {
    const g = E;
    if (g.role !== "assistant")
      continue;
    s = !0;
    const { textParts: _, toolCalls: b, stepsData: T } = $m(g.parts ?? []);
    t.push(..._), n.push(...b), r.push(...T), g.metadata && (i = g.metadata);
    const C = Vm(g.metadata);
    C && (C.inputTokens != null && (a += C.inputTokens, l = !0), C.outputTokens != null && (o += C.outputTokens, h = !0), C.reasoningTokens != null && (u += C.reasoningTokens, m = !0), C.cachedInputTokens != null && (c += C.cachedInputTokens, p = !0));
  }
  return s ? zm(t, n, r.length, i, r, {
    ...l ? { inputTokens: a } : void 0,
    ...h ? { outputTokens: o } : void 0,
    ...m ? { reasoningTokens: u } : void 0,
    ...p ? { cachedInputTokens: c } : void 0
  }) : null;
}
function rx(e) {
  const t = Re(), [n] = de(() => new Vy(e, t));
  return n;
}
const sx = (e) => e.startsWith("image/") ? "image" : e.startsWith("text/") ? "document" : "file";
class ix {
  constructor(t) {
    k(this, "cloud");
    k(this, "accept", "*");
    k(this, "uploadedUrls", /* @__PURE__ */ new Map());
    this.cloud = t;
  }
  async *add({ file: t }) {
    const n = crypto.randomUUID(), r = sx(t.type);
    let s = {
      id: n,
      type: r,
      name: t.name,
      contentType: t.type,
      file: t,
      status: { type: "running", reason: "uploading", progress: 0 }
    };
    yield s;
    try {
      const { signedUrl: i, publicUrl: a } = await this.cloud.files.generatePresignedUploadUrl({
        filename: t.name
      });
      await fetch(i, {
        method: "PUT",
        body: t,
        headers: {
          "Content-Type": t.type
        },
        mode: "cors"
      }), this.uploadedUrls.set(n, a), s = {
        ...s,
        status: { type: "requires-action", reason: "composer-send" }
      }, yield s;
    } catch {
      s = {
        ...s,
        status: { type: "incomplete", reason: "error" }
      }, yield s;
    }
  }
  async remove(t) {
    this.uploadedUrls.delete(t.id);
  }
  async send(t) {
    const n = this.uploadedUrls.get(t.id);
    if (!n)
      throw new Error("Attachment not uploaded");
    this.uploadedUrls.delete(t.id);
    let r;
    return t.type === "image" ? r = [{ type: "image", image: n, filename: t.name }] : r = [
      {
        type: "file",
        data: n,
        mimeType: t.contentType ?? "",
        filename: t.name
      }
    ], {
      ...t,
      status: { type: "complete" },
      content: r
    };
  }
}
const rh = typeof process < "u" && process?.env?.NEXT_PUBLIC_ASSISTANT_BASE_URL, eu = rh ? new By({ baseUrl: rh, anonymous: !0 }) : void 0, ax = (e) => {
  const t = Ke(e);
  xe(() => {
    t.current = e;
  }, [e]);
  const n = ne(function({ children: i }) {
    const a = rx({
      get current() {
        return t.current.cloud ?? eu;
      }
    }), o = t.current.cloud ?? eu, u = ie(() => new ix(o), [o]), c = ie(() => ({
      history: a,
      attachments: u
    }), [a, u]);
    return d.jsx(Kc, { adapters: c, children: i });
  }, []), r = e.cloud ?? eu;
  if (!r) {
    const s = t, i = new jy();
    return i.initialize = async (a) => {
      const o = await s.current.create?.();
      return { remoteId: a, externalId: o?.externalId };
    }, i;
  }
  return {
    list: async () => {
      const { threads: s } = await r.threads.list();
      return {
        threads: s.map((i) => ({
          status: i.is_archived ? "archived" : "regular",
          remoteId: i.id,
          title: i.title,
          externalId: i.external_id ?? void 0
        }))
      };
    },
    initialize: async () => {
      const i = await (e.create?.() ?? Promise.resolve()), a = i ? i.externalId : void 0, { thread_id: o } = await r.threads.create({
        last_message_at: /* @__PURE__ */ new Date(),
        external_id: a
      });
      return { externalId: a, remoteId: o };
    },
    rename: async (s, i) => r.threads.update(s, { title: i }),
    archive: async (s) => r.threads.update(s, { is_archived: !0 }),
    unarchive: async (s) => r.threads.update(s, { is_archived: !1 }),
    delete: async (s) => (await e.delete?.(s), r.threads.delete(s)),
    generateTitle: async (s, i) => {
      const a = i.map((o) => ({
        ...o,
        content: o.content.filter((u) => u.type === "text" || u.type === "tool-call")
      }));
      return r.runs.stream({
        thread_id: s,
        assistant_id: "system/thread_title",
        messages: a
      });
    },
    fetch: async (s) => {
      const i = await r.threads.get(s);
      return {
        status: i.is_archived ? "archived" : "regular",
        remoteId: i.id,
        title: i.title,
        externalId: i.external_id ?? void 0
      };
    },
    unstable_Provider: n
  };
}, ox = (e) => e._core?.RenderComponent, ux = he(({ runtime: e, aui: t = null, children: n }) => {
  const r = Re({ threads: Hm(e) }, { parent: t }), s = ox(e);
  return d.jsxs(Pr, { value: r, children: [s && d.jsx(s, {}), n] });
}), Ym = (e, t) => e.Message === t.Message && e.EditComposer === t.EditComposer && e.UserEditComposer === t.UserEditComposer && e.AssistantEditComposer === t.AssistantEditComposer && e.SystemEditComposer === t.SystemEditComposer && e.UserMessage === t.UserMessage && e.AssistantMessage === t.AssistantMessage && e.SystemMessage === t.SystemMessage, cx = () => null, lx = (e, t, n) => {
  switch (t) {
    case "user":
      return n ? e.UserEditComposer ?? e.EditComposer ?? e.UserMessage ?? e.Message : e.UserMessage ?? e.Message;
    case "assistant":
      return n ? e.AssistantEditComposer ?? e.EditComposer ?? e.AssistantMessage ?? e.Message : e.AssistantMessage ?? e.Message;
    case "system":
      return n ? e.SystemEditComposer ?? e.EditComposer ?? e.SystemMessage ?? e.Message : e.SystemMessage ?? e.Message ?? cx;
    default:
      const r = t;
      throw new Error(`Unknown message role: ${r}`);
  }
}, Gm = ({ components: e }) => {
  const t = J((s) => s.message.role), n = J((s) => s.message.composer.isEditing), r = lx(e, t, n);
  return d.jsx(r, {});
}, Qc = he(({ index: e, components: t }) => d.jsx(ym, { index: e, children: d.jsx(Gm, { components: t }) }), (e, t) => e.index === t.index && Ym(e.components, t.components));
Qc.displayName = "ThreadPrimitive.MessageByIndex";
const sh = ({ children: e }) => {
  const t = J((n) => n.thread.messages.length);
  return ie(() => t === 0 ? null : Array.from({ length: t }, (n, r) => d.jsx(ym, { index: r, children: d.jsx($c, { getItemState: (s) => s.thread().message({ index: r }).getState(), children: (s) => e({
    get message() {
      return s();
    }
  }) }) }, r)), [t, e]);
}, Wm = ({ components: e, children: t }) => e ? d.jsx(sh, { children: () => d.jsx(Gm, { components: e }) }) : d.jsx(sh, { children: t });
Wm.displayName = "ThreadPrimitive.Messages";
he(Wm, (e, t) => e.children || t.children ? e.children === t.children : Ym(e.components, t.components));
const dx = (e) => {
  const t = e.message.metadata;
  if (!(!t || typeof t != "object"))
    return t.custom?.quote;
}, ih = (e) => Symbol.iterator in e, ah = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), oh = (e, t) => {
  const n = e instanceof Map ? e : new Map(e.entries()), r = t instanceof Map ? t : new Map(t.entries());
  if (n.size !== r.size)
    return !1;
  for (const [s, i] of n)
    if (!r.has(s) || !Object.is(i, r.get(s)))
      return !1;
  return !0;
}, hx = (e, t) => {
  const n = e[Symbol.iterator](), r = t[Symbol.iterator]();
  let s = n.next(), i = r.next();
  for (; !s.done && !i.done; ) {
    if (!Object.is(s.value, i.value))
      return !1;
    s = n.next(), i = r.next();
  }
  return !!s.done && !!i.done;
};
function fx(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : ih(e) && ih(t) ? ah(e) && ah(t) ? oh(e, t) : hx(e, t) : oh(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function px(e) {
  const t = Ze.useRef(void 0);
  return (n) => {
    const r = e(n);
    return fx(t.current, r) ? t.current : t.current = r;
  };
}
const tu = (e) => {
  let t = -1;
  return {
    startGroup: (n) => {
      t === -1 && (t = n);
    },
    endGroup: (n, r) => {
      t !== -1 && (r.push({
        type: e,
        startIndex: t,
        endIndex: n
      }), t = -1);
    },
    finalize: (n, r) => {
      t !== -1 && r.push({
        type: e,
        startIndex: t,
        endIndex: n
      });
    }
  };
}, mx = (e, t) => {
  const n = [];
  if (t) {
    const r = tu("chainOfThoughtGroup");
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      i === "tool-call" || i === "reasoning" ? r.startGroup(s) : (r.endGroup(s - 1, n), n.push({ type: "single", index: s }));
    }
    r.finalize(e.length - 1, n);
  } else {
    const r = tu("toolGroup"), s = tu("reasoningGroup");
    for (let i = 0; i < e.length; i++) {
      const a = e[i];
      a === "tool-call" ? (s.endGroup(i - 1, n), r.startGroup(i)) : a === "reasoning" ? (r.endGroup(i - 1, n), s.startGroup(i)) : (r.endGroup(i - 1, n), s.endGroup(i - 1, n), n.push({ type: "single", index: i }));
    }
    r.finalize(e.length - 1, n), s.finalize(e.length - 1, n);
  }
  return n;
}, gx = (e) => {
  const t = J(px((n) => n.message.parts.map((r) => r.type)));
  return ie(() => t.length === 0 ? [] : mx(t, e), [t, e]);
}, Ex = ({ Fallback: e, ...t }) => {
  const n = J((r) => {
    const s = r.tools.tools[t.toolName] ?? e;
    return Array.isArray(s) ? s[0] ?? e : s;
  });
  return n ? d.jsx(n, { ...t }) : null;
}, bx = ({ Fallback: e, ...t }) => {
  const n = J((r) => {
    const s = r.dataRenderers.renderers[t.name] ?? e;
    return Array.isArray(s) ? s[0] ?? e : s;
  });
  return n ? d.jsx(n, { ...t }) : null;
}, gt = {
  Text: () => null,
  Reasoning: () => null,
  Source: () => null,
  Image: () => null,
  File: () => null,
  Unstable_Audio: () => null,
  ToolGroup: ({ children: e }) => e,
  ReasoningGroup: ({ children: e }) => e
}, _x = ({ components: { Text: e = gt.Text, Reasoning: t = gt.Reasoning, Image: n = gt.Image, Source: r = gt.Source, File: s = gt.File, Unstable_Audio: i = gt.Unstable_Audio, tools: a = {}, data: o } = {} }) => {
  const u = Re(), c = J((h) => h.part), l = c.type;
  if (l === "tool-call") {
    const h = u.part().addToolResult, m = u.part().resumeToolCall;
    if ("Override" in a)
      return d.jsx(a.Override, { ...c, addResult: h, resume: m });
    const p = a.by_name?.[c.toolName] ?? a.Fallback;
    return d.jsx(Ex, { ...c, Fallback: p, addResult: h, resume: m });
  }
  if (c.status?.type === "requires-action")
    throw new Error("Encountered unexpected requires-action status");
  switch (l) {
    case "text":
      return d.jsx(e, { ...c });
    case "reasoning":
      return d.jsx(t, { ...c });
    case "source":
      return d.jsx(r, { ...c });
    case "image":
      return d.jsx(n, { ...c });
    case "file":
      return d.jsx(s, { ...c });
    case "audio":
      return d.jsx(i, { ...c });
    case "data": {
      const h = o?.by_name?.[c.name] ?? o?.Fallback;
      return d.jsx(bx, { ...c, Fallback: h });
    }
    default:
      return console.warn(`Unknown message part type: ${l}`), null;
  }
}, da = he(({ index: e, components: t }) => d.jsx(xm, { index: e, children: d.jsx(_x, { components: t }) }), (e, t) => e.index === t.index && e.components?.Text === t.components?.Text && e.components?.Reasoning === t.components?.Reasoning && e.components?.Source === t.components?.Source && e.components?.Image === t.components?.Image && e.components?.File === t.components?.File && e.components?.Unstable_Audio === t.components?.Unstable_Audio && e.components?.tools === t.components?.tools && e.components?.data === t.components?.data && e.components?.ToolGroup === t.components?.ToolGroup && e.components?.ReasoningGroup === t.components?.ReasoningGroup);
da.displayName = "MessagePrimitive.PartByIndex";
const Tx = ({ status: e, component: t }) => d.jsx(YA, { text: "", isRunning: e.type === "running", children: d.jsx(t, { type: "text", text: "", status: e }) }), Ax = Object.freeze({
  type: "complete"
}), yx = ({ components: e }) => {
  const t = J((n) => n.message.status ?? Ax);
  return e?.Empty ? d.jsx(e.Empty, { status: t }) : t.type !== "running" ? null : d.jsx(Tx, { status: t, component: e?.Text ?? gt.Text });
}, qm = he(yx, (e, t) => e.components?.Empty === t.components?.Empty && e.components?.Text === t.components?.Text), xx = ({ components: e, enabled: t }) => J((r) => {
  if (!t || r.message.parts.length === 0)
    return !1;
  const s = r.message.parts[r.message.parts.length - 1];
  return s?.type !== "text" && s?.type !== "reasoning";
}) ? d.jsx(qm, { components: e }) : null, Cx = he(xx, (e, t) => e.enabled === t.enabled && e.components?.Empty === t.components?.Empty && e.components?.Text === t.components?.Text), Sx = ({ Quote: e }) => {
  const t = J(dx);
  return t ? d.jsx(e, { text: t.text, messageId: t.messageId }) : null;
}, Ix = he(Sx), Km = () => {
  const e = Re(), t = J((r) => r.part), n = J((r) => {
    if (r.part.type !== "tool-call")
      return null;
    const s = r.tools.tools[r.part.toolName];
    return Array.isArray(s) ? s[0] ?? null : s ?? null;
  });
  return !n || t.type !== "tool-call" ? null : d.jsx(n, { ...t, addResult: e.part().addToolResult, resume: e.part().resumeToolCall });
}, Qm = () => {
  const e = J((n) => n.part), t = J((n) => {
    if (n.part.type !== "data")
      return null;
    const r = n.dataRenderers.renderers[n.part.name];
    return Array.isArray(r) ? r[0] ?? null : r ?? null;
  });
  return !t || e.type !== "data" ? null : d.jsx(t, { ...e });
}, wx = () => {
  const e = J((t) => t.part.type);
  return e === "tool-call" ? d.jsx(Km, {}) : e === "data" ? d.jsx(Qm, {}) : null;
}, vx = ({ children: e }) => {
  const t = Re(), n = J((r) => r.message.parts.length);
  return ie(() => Array.from({ length: n }, (r, s) => d.jsx(xm, { index: s, children: d.jsx($c, { getItemState: (i) => i.message().part({ index: s }).getState(), children: (i) => {
    const a = e({
      get part() {
        const o = i();
        if (o.type === "tool-call") {
          const u = t.tools().getState().tools[o.toolName], c = Array.isArray(u) ? !!u[0] : !!u, l = t.message().part({ index: s });
          return {
            ...o,
            toolUI: c ? d.jsx(Km, {}) : null,
            addResult: l.addToolResult,
            resume: l.resumeToolCall
          };
        }
        if (o.type === "data") {
          const u = t.dataRenderers().getState().renderers[o.name], c = Array.isArray(u) ? !!u[0] : !!u;
          return {
            ...o,
            dataRendererUI: c ? d.jsx(Qm, {}) : null
          };
        }
        return o;
      }
    });
    return a !== null ? a : d.jsx(wx, {});
  } }) }, s)), [n, e]);
}, tc = ({ components: e, unstable_showEmptyOnNonTextEnd: t = !0, children: n }) => n ? d.jsx(vx, { children: n }) : d.jsx(Nx, { components: e, unstable_showEmptyOnNonTextEnd: t });
tc.displayName = "MessagePrimitive.Parts";
const Nx = ({ components: e, unstable_showEmptyOnNonTextEnd: t }) => {
  const n = J((a) => a.message.parts.length), r = !!e?.ChainOfThought, s = gx(r), i = ie(() => n === 0 ? d.jsx(qm, { components: e }) : s.map((a) => {
    if (a.type === "single")
      return d.jsx(da, { index: a.index, components: e }, a.index);
    if (a.type === "chainOfThoughtGroup") {
      const o = e?.ChainOfThought;
      return o ? d.jsx(GA, { startIndex: a.startIndex, endIndex: a.endIndex, children: d.jsx(o, {}) }, `chainOfThought-${a.startIndex}`) : null;
    } else if (a.type === "toolGroup") {
      const o = e?.ToolGroup ?? gt.ToolGroup;
      return d.jsx(o, { startIndex: a.startIndex, endIndex: a.endIndex, children: Array.from({ length: a.endIndex - a.startIndex + 1 }, (u, c) => d.jsx(da, { index: a.startIndex + c, components: e }, c)) }, `tool-${a.startIndex}`);
    } else {
      const o = e?.ReasoningGroup ?? gt.ReasoningGroup;
      return d.jsx(o, { startIndex: a.startIndex, endIndex: a.endIndex, children: Array.from({ length: a.endIndex - a.startIndex + 1 }, (u, c) => d.jsx(da, { index: a.startIndex + c, components: e }, c)) }, `reasoning-${a.startIndex}`);
    }
  }), [s, e, n]);
  return d.jsxs(d.Fragment, { children: [e?.Quote && d.jsx(Ix, { Quote: e.Quote }), i, d.jsx(Cx, { components: e, enabled: t })] });
}, kx = he(({ index: e, archived: t = !1, components: n }) => {
  const r = n.ThreadListItem;
  return d.jsx(Cm, { index: e, archived: t, children: d.jsx(r, {}) });
}, (e, t) => e.index === t.index && e.archived === t.archived && e.components.ThreadListItem === t.components.ThreadListItem);
kx.displayName = "ThreadListPrimitive.ItemByIndex";
const uh = ({ archived: e, children: t }) => {
  const n = J((r) => e ? r.threads.archivedThreadIds.length : r.threads.threadIds.length);
  return ie(() => Array.from({ length: n }, (r, s) => d.jsx(Cm, { index: s, archived: e, children: d.jsx($c, { getItemState: (i) => i.threads().item({ index: s, archived: e }).getState(), children: (i) => t({
    get threadListItem() {
      return i();
    }
  }) }) }, s)), [n, e, t]);
}, Xm = ({ archived: e = !1, components: t, children: n }) => {
  if (t) {
    const r = t.ThreadListItem;
    return d.jsx(uh, { archived: e, children: () => d.jsx(r, {}) });
  }
  return d.jsx(uh, { archived: e, children: n });
};
Xm.displayName = "ThreadListPrimitive.Items";
const Jm = ({ fallback: e }) => {
  const t = J((n) => n.threadListItem.title);
  return d.jsx(d.Fragment, { children: t || e });
};
Jm.displayName = "ThreadListItemPrimitive.Title";
const Rx = () => {
  const e = Re(), t = J((r) => r.thread.isRunning && !r.thread.capabilities.queue || !r.composer.isEditing || r.composer.isEmpty);
  return { send: ne((r) => {
    e.composer().send(r);
  }, [e]), disabled: t };
}, Px = () => {
  const e = Re(), t = J((r) => !r.composer.canCancel);
  return { cancel: ne(() => {
    e.composer().cancel();
  }, [e]), disabled: t };
}, Ox = () => {
  const e = Re(), t = J((r) => r.composer.isEditing);
  return { edit: ne(() => {
    e.composer().beginEdit();
  }, [e]), disabled: t };
}, Dx = () => {
  const e = Re(), t = J((r) => r.thread.isRunning || r.thread.isDisabled || r.message.role !== "assistant");
  return { reload: ne(() => {
    e.message().reload();
  }, [e]), disabled: t };
}, Lx = () => {
  const e = Re(), t = J((r) => r.message.metadata.submittedFeedback?.type === "positive");
  return { submit: ne(() => {
    e.message().submitFeedback({ type: "positive" });
  }, [e]), isSubmitted: t };
}, Mx = () => {
  const e = Re(), t = J((r) => r.message.metadata.submittedFeedback?.type === "negative");
  return { submit: ne(() => {
    e.message().submitFeedback({ type: "negative" });
  }, [e]), isSubmitted: t };
}, Hx = () => {
  const e = Re(), t = J((r) => !!(r.message.branchNumber >= r.message.branchCount || r.thread.isRunning && !r.thread.capabilities.switchBranchDuringRun));
  return { next: ne(() => {
    e.message().switchToBranch({ position: "next" });
  }, [e]), disabled: t };
}, Bx = () => {
  const e = Re(), t = J((r) => !!(r.message.branchNumber <= 1 || r.thread.isRunning && !r.thread.capabilities.switchBranchDuringRun));
  return { previous: ne(() => {
    e.message().switchToBranch({ position: "previous" });
  }, [e]), disabled: t };
}, Ux = ({ prompt: e, send: t, clearComposer: n = !0 }) => {
  const r = Re(), s = J((o) => o.thread.isDisabled), i = t ?? !1;
  return { trigger: ne(() => {
    const o = r.thread().getState().isRunning;
    if (i && !o)
      r.thread().append({
        content: [{ type: "text", text: e }],
        runConfig: r.composer().getState().runConfig
      }), n && r.composer().setText("");
    else if (n)
      r.composer().setText(e);
    else {
      const u = r.composer().getState().text;
      r.composer().setText(u.trim() ? `${u} ${e}` : e);
    }
  }, [r, i, n, e]), disabled: s };
}, Fx = () => {
  const e = Re();
  return { switchTo: ne(() => {
    e.threadListItem().switchTo();
  }, [e]) };
}, jx = () => {
  const e = Re();
  return { switchToNewThread: ne(() => {
    e.threads().switchToNewThread();
  }, [e]) };
}, $x = () => J((e) => e.message.status?.type === "incomplete" && e.message.status.reason === "error" ? e.message.status.error ?? "An error occurred" : void 0), zx = (e, { initialMessages: t, ...n }) => {
  const { modelContext: r, ...s } = by() ?? {}, i = {
    ...n,
    adapters: {
      ...s,
      ...n.adapters,
      chatModel: e
    }
  }, [a] = de(() => new xy(i, t)), o = Ke(void 0);
  return o.current = J((u) => u.threadListItem.remoteId), xe(() => {
    a.threads.getMainThreadRuntimeCore().__internal_setGetThreadId(() => o.current);
  }, [a]), xe(() => () => {
    a.threads.getMainThreadRuntimeCore().detach();
  }, [a]), xe(() => {
    a.threads.getMainThreadRuntimeCore().__internal_setOptions(i), a.threads.getMainThreadRuntimeCore().__internal_load();
  }), xe(() => {
    if (r)
      return a.registerModelContextProvider(r);
  }, [r, a]), ie(() => new qc(a), [a]);
}, Vx = (e, { cloud: t, ...n } = {}) => {
  const r = ax({ cloud: t });
  return Bm({
    runtimeHook: function() {
      return zx(e, n);
    },
    adapter: r,
    allowNesting: !0
  });
}, nu = (e) => {
  const t = /* @__PURE__ */ new Map(), n = () => {
    let r = 0;
    for (const s of t.values())
      r += s;
    e(r);
  };
  return {
    register: () => {
      const r = /* @__PURE__ */ Symbol();
      return t.set(r, 0), {
        setHeight: (s) => {
          t.get(r) !== s && (t.set(r, s), n());
        },
        unregister: () => {
          t.delete(r), n();
        }
      };
    }
  };
}, Yx = (e = {}) => {
  const t = /* @__PURE__ */ new Set(), n = nu((a) => {
    i.setState({
      height: {
        ...i.getState().height,
        viewport: a
      }
    });
  }), r = nu((a) => {
    i.setState({
      height: {
        ...i.getState().height,
        inset: a
      }
    });
  }), s = nu((a) => {
    i.setState({
      height: {
        ...i.getState().height,
        userMessage: a
      }
    });
  }), i = as(() => ({
    isAtBottom: !0,
    scrollToBottom: ({ behavior: a = "auto" } = {}) => {
      for (const o of t)
        o({ behavior: a });
    },
    onScrollToBottom: (a) => (t.add(a), () => {
      t.delete(a);
    }),
    turnAnchor: e.turnAnchor ?? "bottom",
    height: {
      viewport: 0,
      inset: 0,
      userMessage: 0
    },
    registerViewport: n.register,
    registerContentInset: r.register,
    registerUserMessageHeight: s.register
  }));
  return i;
};
function Gx(e, t) {
  function n(r) {
    const s = ft(e);
    if (!r?.optional && !s)
      throw new Error(`This component must be used within ${t}.`);
    return s;
  }
  return n;
}
function Zm(e, t) {
  function n(s) {
    const i = e(s);
    return i ? i[t] : null;
  }
  function r(s) {
    let i = !1, a;
    typeof s == "function" ? a = s : s && typeof s == "object" && (i = !!s.optional, a = s.selector);
    const o = n({
      optional: i
    });
    return o ? a ? o(a) : o() : null;
  }
  return {
    [t]: r,
    [`${t}Store`]: n
  };
}
const eg = _t(null), Wx = Gx(eg, "ThreadPrimitive.Viewport"), { useThreadViewport: ai, useThreadViewportStore: io } = Zm(Wx, "useThreadViewport"), oi = (e) => e, qx = (e) => {
  const t = io({ optional: !0 }), [n] = de(() => Yx(e));
  return xe(() => t?.getState().onScrollToBottom(() => {
    n.getState().scrollToBottom();
  }), [t, n]), xe(() => {
    if (t)
      return n.subscribe((r) => {
        t.getState().isAtBottom !== r.isAtBottom && oi(t).setState({ isAtBottom: r.isAtBottom });
      });
  }, [n, t]), xe(() => {
    const r = {
      turnAnchor: e.turnAnchor ?? "bottom"
    };
    n.getState().turnAnchor !== r.turnAnchor && oi(n).setState(r);
  }, [n, e.turnAnchor]), n;
}, tg = ({ children: e, options: t = {} }) => {
  const n = qx(t), [r] = de(() => ({
    useThreadViewport: n
  }));
  return d.jsx(eg.Provider, { value: r, children: e });
};
let zr;
const ru = () => {
  if (zr)
    return zr;
  const e = () => ({
    apis: /* @__PURE__ */ new Map(),
    nextId: 0,
    listeners: /* @__PURE__ */ new Set()
  });
  if (typeof window > "u")
    return zr = e(), zr;
  const t = window.__ASSISTANT_UI_DEVTOOLS_HOOK__;
  if (t)
    return zr = t, t;
  const n = e();
  return window.__ASSISTANT_UI_DEVTOOLS_HOOK__ = n, zr = n, n;
}, $n = class $n {
  static register(t) {
    const n = ru();
    for (const o of n.apis.values())
      if (o.api === t)
        return () => {
        };
    const r = n.nextId++, s = {
      api: t,
      logs: []
    }, i = t.on?.("*", (o) => {
      const u = n.apis.get(r);
      u && (u.logs.push({
        time: /* @__PURE__ */ new Date(),
        event: o.event,
        data: o.payload
      }), u.logs.length > $n.MAX_EVENT_LOGS_PER_API && (u.logs = u.logs.slice(-200)), $n.notifyListeners(r));
    }), a = t.subscribe?.(() => {
      $n.notifyListeners(r);
    });
    return n.apis.set(r, s), $n.notifyListeners(r), () => {
      const o = ru();
      o.apis.get(r) && (i?.(), a?.(), o.apis.delete(r), $n.notifyListeners(r));
    };
  }
  static notifyListeners(t) {
    ru().listeners.forEach((r) => r(t));
  }
};
k($n, "MAX_EVENT_LOGS_PER_API", 200);
let nc = $n;
const Kx = () => {
  const e = Re();
  return xe(() => {
    if (!(typeof process > "u" || process.env.NODE_ENV === "production"))
      return nc.register(e);
  }, [e]), null;
}, Qx = ({ children: e, aui: t, runtime: n }) => d.jsxs(ux, { runtime: n, aui: t ?? null, children: [d.jsx(Kx, {}), d.jsx(tg, { children: e })] }), Xx = he(Qx);
function ch(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Xc(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((s) => {
      const i = ch(s, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let s = 0; s < r.length; s++) {
          const i = r[s];
          typeof i == "function" ? i() : ch(e[s], null);
        }
      };
  };
}
function ze(...e) {
  return A.useCallback(Xc(...e), e);
}
var Jx = /* @__PURE__ */ Symbol.for("react.lazy"), ka = A[" use ".trim().toString()];
function Zx(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function ng(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Jx && "_payload" in e && Zx(e._payload);
}
// @__NO_SIDE_EFFECTS__
function rg(e) {
  const t = /* @__PURE__ */ tC(e), n = A.forwardRef((r, s) => {
    let { children: i, ...a } = r;
    ng(i) && typeof ka == "function" && (i = ka(i._payload));
    const o = A.Children.toArray(i), u = o.find(rC);
    if (u) {
      const c = u.props.children, l = o.map((h) => h === u ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : h);
      return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: A.isValidElement(c) ? A.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var eC = /* @__PURE__ */ rg("Slot");
// @__NO_SIDE_EFFECTS__
function tC(e) {
  const t = A.forwardRef((n, r) => {
    let { children: s, ...i } = n;
    if (ng(s) && typeof ka == "function" && (s = ka(s._payload)), A.isValidElement(s)) {
      const a = iC(s), o = sC(i, s.props);
      return s.type !== A.Fragment && (o.ref = r ? Xc(r, a) : a), A.cloneElement(s, o);
    }
    return A.Children.count(s) > 1 ? A.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var nC = /* @__PURE__ */ Symbol("radix.slottable");
function rC(e) {
  return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === nC;
}
function sC(e, t) {
  const n = { ...t };
  for (const r in t) {
    const s = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? s && i ? n[r] = (...o) => {
      const u = i(...o);
      return s(...o), u;
    } : s && (n[r] = s) : r === "style" ? n[r] = { ...s, ...i } : r === "className" && (n[r] = [s, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function iC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var aC = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Rt = aC.reduce((e, t) => {
  const n = /* @__PURE__ */ rg(`Primitive.${t}`), r = A.forwardRef((s, i) => {
    const { asChild: a, ...o } = s, u = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d.jsx(u, { ...o, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Sn;
(function(e) {
  e.Hidden = "hidden", e.Floating = "floating", e.Normal = "normal";
})(Sn || (Sn = {}));
const oC = ({ hideWhenRunning: e, autohide: t, autohideFloat: n, forceVisible: r }) => J((s) => {
  if (e && s.thread.isRunning)
    return Sn.Hidden;
  const i = t === "always" || t === "not-last" && !s.message.isLast, a = r || s.message.isHovering;
  return i ? a ? n === "always" || n === "single-branch" && s.message.branchCount <= 1 ? Sn.Floating : Sn.Normal : Sn.Hidden : Sn.Normal;
}), uC = _t(null), ao = Je(({ hideWhenRunning: e, autohide: t, autohideFloat: n, ...r }, s) => {
  const [i, a] = de(0), o = ne(() => {
    let l = !1;
    return a((h) => h + 1), () => {
      l || (l = !0, a((h) => Math.max(0, h - 1)));
    };
  }, []), u = ie(() => ({ acquireInteractionLock: o }), [o]), c = oC({
    hideWhenRunning: e,
    autohide: t,
    autohideFloat: n,
    forceVisible: i > 0
  });
  return c === Sn.Hidden ? null : d.jsx(uC.Provider, { value: u, children: d.jsx(Rt.div, { ...c === Sn.Floating ? { "data-floating": "true" } : null, ...r, ref: s }) });
});
ao.displayName = "ActionBarPrimitive.Root";
function be(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(s) {
    if (e?.(s), n === !1 || !s.defaultPrevented)
      return t?.(s);
  };
}
const On = (e, t, n = []) => {
  const r = Je((s, i) => {
    const a = {}, o = {};
    Object.keys(s).forEach((c) => {
      n.includes(c) ? a[c] = s[c] : o[c] = s[c];
    });
    const u = t(a) ?? void 0;
    return d.jsx(Rt.button, { ...o, type: "button", ref: i, disabled: o.disabled || !u, onClick: be(o.onClick, u) });
  });
  return r.displayName = e, r;
}, cC = () => {
  const { disabled: e, reload: t } = Dx();
  return e ? null : t;
}, sg = On("ActionBarPrimitive.Reload", cC), lC = () => {
  const { disabled: e, edit: t } = Ox();
  return e ? null : t;
}, dC = On("ActionBarPrimitive.Edit", lC);
function jt(e) {
  const t = A.useRef(e);
  return A.useEffect(() => {
    t.current = e;
  }), A.useMemo(() => (...n) => t.current?.(...n), []);
}
function ig(e, t = globalThis?.document) {
  const n = jt(e);
  A.useEffect(() => {
    const r = (s) => {
      s.key === "Escape" && n(s);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
const hC = () => {
  const { submit: e } = Lx();
  return e;
}, ag = Je(({ onClick: e, disabled: t, ...n }, r) => {
  const s = J((a) => a.message.metadata.submittedFeedback?.type === "positive"), i = hC();
  return d.jsx(Rt.button, { type: "button", ...s ? { "data-submitted": "true" } : {}, ...n, ref: r, disabled: t || !i, onClick: be(e, () => {
    i?.();
  }) });
});
ag.displayName = "ActionBarPrimitive.FeedbackPositive";
const fC = () => {
  const { submit: e } = Mx();
  return e;
}, og = Je(({ onClick: e, disabled: t, ...n }, r) => {
  const s = J((a) => a.message.metadata.submittedFeedback?.type === "negative"), i = fC();
  return d.jsx(Rt.button, { type: "button", ...s ? { "data-submitted": "true" } : {}, ...n, ref: r, disabled: t || !i, onClick: be(e, () => {
    i?.();
  }) });
});
og.displayName = "ActionBarPrimitive.FeedbackNegative";
// @__NO_SIDE_EFFECTS__
function Sr(e) {
  const t = /* @__PURE__ */ pC(e), n = A.forwardRef((r, s) => {
    const { children: i, ...a } = r, o = A.Children.toArray(i), u = o.find(gC);
    if (u) {
      const c = u.props.children, l = o.map((h) => h === u ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : h);
      return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: A.isValidElement(c) ? A.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var ug = /* @__PURE__ */ Sr("Slot");
// @__NO_SIDE_EFFECTS__
function pC(e) {
  const t = A.forwardRef((n, r) => {
    const { children: s, ...i } = n;
    if (A.isValidElement(s)) {
      const a = bC(s), o = EC(i, s.props);
      return s.type !== A.Fragment && (o.ref = r ? Xc(r, a) : a), A.cloneElement(s, o);
    }
    return A.Children.count(s) > 1 ? A.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var cg = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function mC(e) {
  const t = ({ children: n }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = cg, t;
}
function gC(e) {
  return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === cg;
}
function EC(e, t) {
  const n = { ...t };
  for (const r in t) {
    const s = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? s && i ? n[r] = (...o) => {
      const u = i(...o);
      return s(...o), u;
    } : s && (n[r] = s) : r === "style" ? n[r] = { ...s, ...i } : r === "className" && (n[r] = [s, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function bC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _C = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ve = _C.reduce((e, t) => {
  const n = /* @__PURE__ */ Sr(`Primitive.${t}`), r = A.forwardRef((s, i) => {
    const { asChild: a, ...o } = s, u = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d.jsx(u, { ...o, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function TC(e, t) {
  e && Ka.flushSync(() => e.dispatchEvent(t));
}
var lg = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), AC = "VisuallyHidden", dg = A.forwardRef(
  (e, t) => /* @__PURE__ */ d.jsx(
    Ve.span,
    {
      ...e,
      ref: t,
      style: { ...lg, ...e.style }
    }
  )
);
dg.displayName = AC;
var yC = dg;
function xC(e, t) {
  const n = A.createContext(t), r = (i) => {
    const { children: a, ...o } = i, u = A.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ d.jsx(n.Provider, { value: u, children: a });
  };
  r.displayName = e + "Provider";
  function s(i) {
    const a = A.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, s];
}
function ps(e, t = []) {
  let n = [];
  function r(i, a) {
    const o = A.createContext(a), u = n.length;
    n = [...n, a];
    const c = (h) => {
      const { scope: m, children: p, ...E } = h, g = m?.[e]?.[u] || o, _ = A.useMemo(() => E, Object.values(E));
      return /* @__PURE__ */ d.jsx(g.Provider, { value: _, children: p });
    };
    c.displayName = i + "Provider";
    function l(h, m) {
      const p = m?.[e]?.[u] || o, E = A.useContext(p);
      if (E) return E;
      if (a !== void 0) return a;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return [c, l];
  }
  const s = () => {
    const i = n.map((a) => A.createContext(a));
    return function(o) {
      const u = o?.[e] || i;
      return A.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: u } }),
        [o, u]
      );
    };
  };
  return s.scopeName = e, [r, CC(s, ...t)];
}
function CC(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(i) {
      const a = r.reduce((o, { useScope: u, scopeName: c }) => {
        const h = u(i)[`__scope${c}`];
        return { ...o, ...h };
      }, {});
      return A.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function SC(e) {
  const t = e + "CollectionProvider", [n, r] = ps(t), [s, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (g) => {
    const { scope: _, children: b } = g, T = Ze.useRef(null), C = Ze.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d.jsx(s, { scope: _, itemMap: C, collectionRef: T, children: b });
  };
  a.displayName = t;
  const o = e + "CollectionSlot", u = /* @__PURE__ */ Sr(o), c = Ze.forwardRef(
    (g, _) => {
      const { scope: b, children: T } = g, C = i(o, b), R = ze(_, C.collectionRef);
      return /* @__PURE__ */ d.jsx(u, { ref: R, children: T });
    }
  );
  c.displayName = o;
  const l = e + "CollectionItemSlot", h = "data-radix-collection-item", m = /* @__PURE__ */ Sr(l), p = Ze.forwardRef(
    (g, _) => {
      const { scope: b, children: T, ...C } = g, R = Ze.useRef(null), D = ze(_, R), I = i(l, b);
      return Ze.useEffect(() => (I.itemMap.set(R, { ref: R, ...C }), () => {
        I.itemMap.delete(R);
      })), /* @__PURE__ */ d.jsx(m, { [h]: "", ref: D, children: T });
    }
  );
  p.displayName = l;
  function E(g) {
    const _ = i(e + "CollectionConsumer", g);
    return Ze.useCallback(() => {
      const T = _.collectionRef.current;
      if (!T) return [];
      const C = Array.from(T.querySelectorAll(`[${h}]`));
      return Array.from(_.itemMap.values()).sort(
        (I, O) => C.indexOf(I.ref.current) - C.indexOf(O.ref.current)
      );
    }, [_.collectionRef, _.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: p },
    E,
    r
  ];
}
var bt = globalThis?.document ? A.useLayoutEffect : () => {
}, IC = A[" useInsertionEffect ".trim().toString()] || bt;
function ui({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [s, i, a] = wC({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, u = o ? e : s;
  {
    const l = A.useRef(e !== void 0);
    A.useEffect(() => {
      const h = l.current;
      h !== o && console.warn(
        `${r} is changing from ${h ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), l.current = o;
    }, [o, r]);
  }
  const c = A.useCallback(
    (l) => {
      if (o) {
        const h = vC(l) ? l(e) : l;
        h !== e && a.current?.(h);
      } else
        i(l);
    },
    [o, e, i, a]
  );
  return [u, c];
}
function wC({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = A.useState(e), s = A.useRef(n), i = A.useRef(t);
  return IC(() => {
    i.current = t;
  }, [t]), A.useEffect(() => {
    s.current !== n && (i.current?.(n), s.current = n);
  }, [n, s]), [n, r, i];
}
function vC(e) {
  return typeof e == "function";
}
function NC(e, t) {
  return A.useReducer((n, r) => t[n][r] ?? n, e);
}
var Zn = (e) => {
  const { present: t, children: n } = e, r = kC(t), s = typeof n == "function" ? n({ present: r.isPresent }) : A.Children.only(n), i = ze(r.ref, RC(s));
  return typeof n == "function" || r.isPresent ? A.cloneElement(s, { ref: i }) : null;
};
Zn.displayName = "Presence";
function kC(e) {
  const [t, n] = A.useState(), r = A.useRef(null), s = A.useRef(e), i = A.useRef("none"), a = e ? "mounted" : "unmounted", [o, u] = NC(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return A.useEffect(() => {
    const c = Vi(r.current);
    i.current = o === "mounted" ? c : "none";
  }, [o]), bt(() => {
    const c = r.current, l = s.current;
    if (l !== e) {
      const m = i.current, p = Vi(c);
      e ? u("MOUNT") : p === "none" || c?.display === "none" ? u("UNMOUNT") : u(l && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), s.current = e;
    }
  }, [e, u]), bt(() => {
    if (t) {
      let c;
      const l = t.ownerDocument.defaultView ?? window, h = (p) => {
        const g = Vi(r.current).includes(CSS.escape(p.animationName));
        if (p.target === t && g && (u("ANIMATION_END"), !s.current)) {
          const _ = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = l.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = _);
          });
        }
      }, m = (p) => {
        p.target === t && (i.current = Vi(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", h), t.addEventListener("animationend", h), () => {
        l.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", h), t.removeEventListener("animationend", h);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: A.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Vi(e) {
  return e?.animationName || "none";
}
function RC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var PC = A[" useId ".trim().toString()] || (() => {
}), OC = 0;
function Gn(e) {
  const [t, n] = A.useState(PC());
  return bt(() => {
    n((r) => r ?? String(OC++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var DC = A.createContext(void 0);
function LC(e) {
  const t = A.useContext(DC);
  return e || t || "ltr";
}
var MC = "DismissableLayer", rc = "dismissableLayer.update", HC = "dismissableLayer.pointerDownOutside", BC = "dismissableLayer.focusOutside", lh, hg = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), yi = A.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: s,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: o,
      ...u
    } = e, c = A.useContext(hg), [l, h] = A.useState(null), m = l?.ownerDocument ?? globalThis?.document, [, p] = A.useState({}), E = ze(t, (O) => h(O)), g = Array.from(c.layers), [_] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(_), T = l ? g.indexOf(l) : -1, C = c.layersWithOutsidePointerEventsDisabled.size > 0, R = T >= b, D = jC((O) => {
      const U = O.target, q = [...c.branches].some((P) => P.contains(U));
      !R || q || (s?.(O), a?.(O), O.defaultPrevented || o?.());
    }, m), I = $C((O) => {
      const U = O.target;
      [...c.branches].some((P) => P.contains(U)) || (i?.(O), a?.(O), O.defaultPrevented || o?.());
    }, m);
    return ig((O) => {
      T === c.layers.size - 1 && (r?.(O), !O.defaultPrevented && o && (O.preventDefault(), o()));
    }, m), A.useEffect(() => {
      if (l)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (lh = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(l)), c.layers.add(l), dh(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = lh);
        };
    }, [l, m, n, c]), A.useEffect(() => () => {
      l && (c.layers.delete(l), c.layersWithOutsidePointerEventsDisabled.delete(l), dh());
    }, [l, c]), A.useEffect(() => {
      const O = () => p({});
      return document.addEventListener(rc, O), () => document.removeEventListener(rc, O);
    }, []), /* @__PURE__ */ d.jsx(
      Ve.div,
      {
        ...u,
        ref: E,
        style: {
          pointerEvents: C ? R ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: be(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: be(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: be(
          e.onPointerDownCapture,
          D.onPointerDownCapture
        )
      }
    );
  }
);
yi.displayName = MC;
var UC = "DismissableLayerBranch", FC = A.forwardRef((e, t) => {
  const n = A.useContext(hg), r = A.useRef(null), s = ze(t, r);
  return A.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ d.jsx(Ve.div, { ...e, ref: s });
});
FC.displayName = UC;
function jC(e, t = globalThis?.document) {
  const n = jt(e), r = A.useRef(!1), s = A.useRef(() => {
  });
  return A.useEffect(() => {
    const i = (o) => {
      if (o.target && !r.current) {
        let u = function() {
          fg(
            HC,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: o };
        o.pointerType === "touch" ? (t.removeEventListener("click", s.current), s.current = u, t.addEventListener("click", s.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", s.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", s.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function $C(e, t = globalThis?.document) {
  const n = jt(e), r = A.useRef(!1);
  return A.useEffect(() => {
    const s = (i) => {
      i.target && !r.current && fg(BC, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", s), () => t.removeEventListener("focusin", s);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function dh() {
  const e = new CustomEvent(rc);
  document.dispatchEvent(e);
}
function fg(e, t, n, { discrete: r }) {
  const s = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && s.addEventListener(e, t, { once: !0 }), r ? TC(s, i) : s.dispatchEvent(i);
}
var su = "focusScope.autoFocusOnMount", iu = "focusScope.autoFocusOnUnmount", hh = { bubbles: !1, cancelable: !0 }, zC = "FocusScope", oo = A.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: s,
    onUnmountAutoFocus: i,
    ...a
  } = e, [o, u] = A.useState(null), c = jt(s), l = jt(i), h = A.useRef(null), m = ze(t, (g) => u(g)), p = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (r) {
      let g = function(C) {
        if (p.paused || !o) return;
        const R = C.target;
        o.contains(R) ? h.current = R : Un(h.current, { select: !0 });
      }, _ = function(C) {
        if (p.paused || !o) return;
        const R = C.relatedTarget;
        R !== null && (o.contains(R) || Un(h.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const D of C)
            D.removedNodes.length > 0 && Un(o);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", _);
      const T = new MutationObserver(b);
      return o && T.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", _), T.disconnect();
      };
    }
  }, [r, o, p.paused]), A.useEffect(() => {
    if (o) {
      ph.add(p);
      const g = document.activeElement;
      if (!o.contains(g)) {
        const b = new CustomEvent(su, hh);
        o.addEventListener(su, c), o.dispatchEvent(b), b.defaultPrevented || (VC(KC(pg(o)), { select: !0 }), document.activeElement === g && Un(o));
      }
      return () => {
        o.removeEventListener(su, c), setTimeout(() => {
          const b = new CustomEvent(iu, hh);
          o.addEventListener(iu, l), o.dispatchEvent(b), b.defaultPrevented || Un(g ?? document.body, { select: !0 }), o.removeEventListener(iu, l), ph.remove(p);
        }, 0);
      };
    }
  }, [o, c, l, p]);
  const E = A.useCallback(
    (g) => {
      if (!n && !r || p.paused) return;
      const _ = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (_ && b) {
        const T = g.currentTarget, [C, R] = YC(T);
        C && R ? !g.shiftKey && b === R ? (g.preventDefault(), n && Un(C, { select: !0 })) : g.shiftKey && b === C && (g.preventDefault(), n && Un(R, { select: !0 })) : b === T && g.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ d.jsx(Ve.div, { tabIndex: -1, ...a, ref: m, onKeyDown: E });
});
oo.displayName = zC;
function VC(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Un(r, { select: t }), document.activeElement !== n) return;
}
function YC(e) {
  const t = pg(e), n = fh(t, e), r = fh(t.reverse(), e);
  return [n, r];
}
function pg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const s = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || s ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function fh(e, t) {
  for (const n of e)
    if (!GC(n, { upTo: t })) return n;
}
function GC(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function WC(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Un(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && WC(e) && t && e.select();
  }
}
var ph = qC();
function qC() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = mh(e, t), e.unshift(t);
    },
    remove(t) {
      e = mh(e, t), e[0]?.resume();
    }
  };
}
function mh(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function KC(e) {
  return e.filter((t) => t.tagName !== "A");
}
var QC = "Portal", xi = A.forwardRef((e, t) => {
  const { container: n, ...r } = e, [s, i] = A.useState(!1);
  bt(() => i(!0), []);
  const a = n || s && globalThis?.document?.body;
  return a ? $T.createPortal(/* @__PURE__ */ d.jsx(Ve.div, { ...r, ref: t }), a) : null;
});
xi.displayName = QC;
var au = 0;
function Jc() {
  A.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? gh()), document.body.insertAdjacentElement("beforeend", e[1] ?? gh()), au++, () => {
      au === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), au--;
    };
  }, []);
}
function gh() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var dn = function() {
  return dn = Object.assign || function(t) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, dn.apply(this, arguments);
};
function mg(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(e); s < r.length; s++)
      t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (n[r[s]] = e[r[s]]);
  return n;
}
function XC(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, s = t.length, i; r < s; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var ha = "right-scroll-bar-position", fa = "width-before-scroll-bar", JC = "with-scroll-bars-hidden", ZC = "--removed-body-scroll-bar-size";
function ou(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function eS(e, t) {
  var n = de(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var s = n.value;
          s !== r && (n.value = r, n.callback(r, s));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var tS = typeof window < "u" ? A.useLayoutEffect : A.useEffect, Eh = /* @__PURE__ */ new WeakMap();
function nS(e, t) {
  var n = eS(null, function(r) {
    return e.forEach(function(s) {
      return ou(s, r);
    });
  });
  return tS(function() {
    var r = Eh.get(n);
    if (r) {
      var s = new Set(r), i = new Set(e), a = n.current;
      s.forEach(function(o) {
        i.has(o) || ou(o, null);
      }), i.forEach(function(o) {
        s.has(o) || ou(o, a);
      });
    }
    Eh.set(n, e);
  }, [e]), n;
}
function rS(e) {
  return e;
}
function sS(e, t) {
  t === void 0 && (t = rS);
  var n = [], r = !1, s = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(o) {
          return o !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(o) {
          return i(o);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var o = n;
        n = [], o.forEach(i), a = n;
      }
      var u = function() {
        var l = a;
        a = [], l.forEach(i);
      }, c = function() {
        return Promise.resolve().then(u);
      };
      c(), n = {
        push: function(l) {
          a.push(l), c();
        },
        filter: function(l) {
          return a = a.filter(l), n;
        }
      };
    }
  };
  return s;
}
function iS(e) {
  e === void 0 && (e = {});
  var t = sS(null);
  return t.options = dn({ async: !0, ssr: !1 }, e), t;
}
var gg = function(e) {
  var t = e.sideCar, n = mg(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return A.createElement(r, dn({}, n));
};
gg.isSideCarExport = !0;
function aS(e, t) {
  return e.useMedium(t), gg;
}
var Eg = iS(), uu = function() {
}, uo = A.forwardRef(function(e, t) {
  var n = A.useRef(null), r = A.useState({
    onScrollCapture: uu,
    onWheelCapture: uu,
    onTouchMoveCapture: uu
  }), s = r[0], i = r[1], a = e.forwardProps, o = e.children, u = e.className, c = e.removeScrollBar, l = e.enabled, h = e.shards, m = e.sideCar, p = e.noRelative, E = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, b = e.as, T = b === void 0 ? "div" : b, C = e.gapMode, R = mg(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), D = m, I = nS([n, t]), O = dn(dn({}, R), s);
  return A.createElement(
    A.Fragment,
    null,
    l && A.createElement(D, { sideCar: Eg, removeScrollBar: c, shards: h, noRelative: p, noIsolation: E, inert: g, setCallbacks: i, allowPinchZoom: !!_, lockRef: n, gapMode: C }),
    a ? A.cloneElement(A.Children.only(o), dn(dn({}, O), { ref: I })) : A.createElement(T, dn({}, O, { className: u, ref: I }), o)
  );
});
uo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
uo.classNames = {
  fullWidth: fa,
  zeroRight: ha
};
var oS = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function uS() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = oS();
  return t && e.setAttribute("nonce", t), e;
}
function cS(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function lS(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var dS = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = uS()) && (cS(t, n), lS(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, hS = function() {
  var e = dS();
  return function(t, n) {
    A.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, bg = function() {
  var e = hS(), t = function(n) {
    var r = n.styles, s = n.dynamic;
    return e(r, s), null;
  };
  return t;
}, fS = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, cu = function(e) {
  return parseInt(e || "", 10) || 0;
}, pS = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], s = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [cu(n), cu(r), cu(s)];
}, mS = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return fS;
  var t = pS(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, gS = bg(), es = "data-scroll-locked", ES = function(e, t, n, r) {
  var s = e.left, i = e.top, a = e.right, o = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(JC, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(o, "px ").concat(r, `;
  }
  body[`).concat(es, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(s, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(o, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ha, ` {
    right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(fa, ` {
    margin-right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(ha, " .").concat(ha, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(fa, " .").concat(fa, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(es, `] {
    `).concat(ZC, ": ").concat(o, `px;
  }
`);
}, bh = function() {
  var e = parseInt(document.body.getAttribute(es) || "0", 10);
  return isFinite(e) ? e : 0;
}, bS = function() {
  A.useEffect(function() {
    return document.body.setAttribute(es, (bh() + 1).toString()), function() {
      var e = bh() - 1;
      e <= 0 ? document.body.removeAttribute(es) : document.body.setAttribute(es, e.toString());
    };
  }, []);
}, _S = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, s = r === void 0 ? "margin" : r;
  bS();
  var i = A.useMemo(function() {
    return mS(s);
  }, [s]);
  return A.createElement(gS, { styles: ES(i, !t, s, n ? "" : "!important") });
}, sc = !1;
if (typeof window < "u")
  try {
    var Yi = Object.defineProperty({}, "passive", {
      get: function() {
        return sc = !0, !0;
      }
    });
    window.addEventListener("test", Yi, Yi), window.removeEventListener("test", Yi, Yi);
  } catch {
    sc = !1;
  }
var Vr = sc ? { passive: !1 } : !1, TS = function(e) {
  return e.tagName === "TEXTAREA";
}, _g = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !TS(e) && n[t] === "visible")
  );
}, AS = function(e) {
  return _g(e, "overflowY");
}, yS = function(e) {
  return _g(e, "overflowX");
}, _h = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var s = Tg(e, r);
    if (s) {
      var i = Ag(e, r), a = i[1], o = i[2];
      if (a > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, xS = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, CS = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Tg = function(e, t) {
  return e === "v" ? AS(t) : yS(t);
}, Ag = function(e, t) {
  return e === "v" ? xS(t) : CS(t);
}, SS = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, IS = function(e, t, n, r, s) {
  var i = SS(e, window.getComputedStyle(t).direction), a = i * r, o = n.target, u = t.contains(o), c = !1, l = a > 0, h = 0, m = 0;
  do {
    if (!o)
      break;
    var p = Ag(e, o), E = p[0], g = p[1], _ = p[2], b = g - _ - i * E;
    (E || b) && Tg(e, o) && (h += b, m += E);
    var T = o.parentNode;
    o = T && T.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? T.host : T;
  } while (
    // portaled content
    !u && o !== document.body || // self content
    u && (t.contains(o) || t === o)
  );
  return (l && Math.abs(h) < 1 || !l && Math.abs(m) < 1) && (c = !0), c;
}, Gi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Th = function(e) {
  return [e.deltaX, e.deltaY];
}, Ah = function(e) {
  return e && "current" in e ? e.current : e;
}, wS = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, vS = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, NS = 0, Yr = [];
function kS(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), r = A.useRef(), s = A.useState(NS++)[0], i = A.useState(bg)[0], a = A.useRef(e);
  A.useEffect(function() {
    a.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(s));
      var g = XC([e.lockRef.current], (e.shards || []).map(Ah), !0).filter(Boolean);
      return g.forEach(function(_) {
        return _.classList.add("allow-interactivity-".concat(s));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(s)), g.forEach(function(_) {
          return _.classList.remove("allow-interactivity-".concat(s));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = A.useCallback(function(g, _) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = Gi(g), T = n.current, C = "deltaX" in g ? g.deltaX : T[0] - b[0], R = "deltaY" in g ? g.deltaY : T[1] - b[1], D, I = g.target, O = Math.abs(C) > Math.abs(R) ? "h" : "v";
    if ("touches" in g && O === "h" && I.type === "range")
      return !1;
    var U = window.getSelection(), q = U && U.anchorNode, P = q ? q === I || q.contains(I) : !1;
    if (P)
      return !1;
    var z = _h(O, I);
    if (!z)
      return !0;
    if (z ? D = O : (D = O === "v" ? "h" : "v", z = _h(O, I)), !z)
      return !1;
    if (!r.current && "changedTouches" in g && (C || R) && (r.current = D), !D)
      return !0;
    var G = r.current || D;
    return IS(G, _, g, G === "h" ? C : R);
  }, []), u = A.useCallback(function(g) {
    var _ = g;
    if (!(!Yr.length || Yr[Yr.length - 1] !== i)) {
      var b = "deltaY" in _ ? Th(_) : Gi(_), T = t.current.filter(function(D) {
        return D.name === _.type && (D.target === _.target || _.target === D.shadowParent) && wS(D.delta, b);
      })[0];
      if (T && T.should) {
        _.cancelable && _.preventDefault();
        return;
      }
      if (!T) {
        var C = (a.current.shards || []).map(Ah).filter(Boolean).filter(function(D) {
          return D.contains(_.target);
        }), R = C.length > 0 ? o(_, C[0]) : !a.current.noIsolation;
        R && _.cancelable && _.preventDefault();
      }
    }
  }, []), c = A.useCallback(function(g, _, b, T) {
    var C = { name: g, delta: _, target: b, should: T, shadowParent: RS(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== C;
      });
    }, 1);
  }, []), l = A.useCallback(function(g) {
    n.current = Gi(g), r.current = void 0;
  }, []), h = A.useCallback(function(g) {
    c(g.type, Th(g), g.target, o(g, e.lockRef.current));
  }, []), m = A.useCallback(function(g) {
    c(g.type, Gi(g), g.target, o(g, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return Yr.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", u, Vr), document.addEventListener("touchmove", u, Vr), document.addEventListener("touchstart", l, Vr), function() {
      Yr = Yr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", u, Vr), document.removeEventListener("touchmove", u, Vr), document.removeEventListener("touchstart", l, Vr);
    };
  }, []);
  var p = e.removeScrollBar, E = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    E ? A.createElement(i, { styles: vS(s) }) : null,
    p ? A.createElement(_S, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function RS(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const PS = aS(Eg, kS);
var co = A.forwardRef(function(e, t) {
  return A.createElement(uo, dn({}, e, { ref: t, sideCar: PS }));
});
co.classNames = uo.classNames;
var OS = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Gr = /* @__PURE__ */ new WeakMap(), Wi = /* @__PURE__ */ new WeakMap(), qi = {}, lu = 0, yg = function(e) {
  return e && (e.host || yg(e.parentNode));
}, DS = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = yg(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, LS = function(e, t, n, r) {
  var s = DS(t, Array.isArray(e) ? e : [e]);
  qi[n] || (qi[n] = /* @__PURE__ */ new WeakMap());
  var i = qi[n], a = [], o = /* @__PURE__ */ new Set(), u = new Set(s), c = function(h) {
    !h || o.has(h) || (o.add(h), c(h.parentNode));
  };
  s.forEach(c);
  var l = function(h) {
    !h || u.has(h) || Array.prototype.forEach.call(h.children, function(m) {
      if (o.has(m))
        l(m);
      else
        try {
          var p = m.getAttribute(r), E = p !== null && p !== "false", g = (Gr.get(m) || 0) + 1, _ = (i.get(m) || 0) + 1;
          Gr.set(m, g), i.set(m, _), a.push(m), g === 1 && E && Wi.set(m, !0), _ === 1 && m.setAttribute(n, "true"), E || m.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", m, b);
        }
    });
  };
  return l(t), o.clear(), lu++, function() {
    a.forEach(function(h) {
      var m = Gr.get(h) - 1, p = i.get(h) - 1;
      Gr.set(h, m), i.set(h, p), m || (Wi.has(h) || h.removeAttribute(r), Wi.delete(h)), p || h.removeAttribute(n);
    }), lu--, lu || (Gr = /* @__PURE__ */ new WeakMap(), Gr = /* @__PURE__ */ new WeakMap(), Wi = /* @__PURE__ */ new WeakMap(), qi = {});
  };
}, Zc = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), s = OS(e);
  return s ? (r.push.apply(r, Array.from(s.querySelectorAll("[aria-live], script"))), LS(r, s, n, "aria-hidden")) : function() {
    return null;
  };
}, lo = "Dialog", [xg] = ps(lo), [MS, an] = xg(lo), Cg = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    modal: a = !0
  } = e, o = A.useRef(null), u = A.useRef(null), [c, l] = ui({
    prop: r,
    defaultProp: s ?? !1,
    onChange: i,
    caller: lo
  });
  return /* @__PURE__ */ d.jsx(
    MS,
    {
      scope: t,
      triggerRef: o,
      contentRef: u,
      contentId: Gn(),
      titleId: Gn(),
      descriptionId: Gn(),
      open: c,
      onOpenChange: l,
      onOpenToggle: A.useCallback(() => l((h) => !h), [l]),
      modal: a,
      children: n
    }
  );
};
Cg.displayName = lo;
var Sg = "DialogTrigger", HS = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = an(Sg, n), i = ze(t, s.triggerRef);
    return /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.contentId,
        "data-state": nl(s.open),
        ...r,
        ref: i,
        onClick: be(e.onClick, s.onOpenToggle)
      }
    );
  }
);
HS.displayName = Sg;
var el = "DialogPortal", [BS, Ig] = xg(el, {
  forceMount: void 0
}), wg = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: s } = e, i = an(el, t);
  return /* @__PURE__ */ d.jsx(BS, { scope: t, forceMount: n, children: A.Children.map(r, (a) => /* @__PURE__ */ d.jsx(Zn, { present: n || i.open, children: /* @__PURE__ */ d.jsx(xi, { asChild: !0, container: s, children: a }) })) });
};
wg.displayName = el;
var Ra = "DialogOverlay", vg = A.forwardRef(
  (e, t) => {
    const n = Ig(Ra, e.__scopeDialog), { forceMount: r = n.forceMount, ...s } = e, i = an(Ra, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ d.jsx(Zn, { present: r || i.open, children: /* @__PURE__ */ d.jsx(FS, { ...s, ref: t }) }) : null;
  }
);
vg.displayName = Ra;
var US = /* @__PURE__ */ Sr("DialogOverlay.RemoveScroll"), FS = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = an(Ra, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ d.jsx(co, { as: US, allowPinchZoom: !0, shards: [s.contentRef], children: /* @__PURE__ */ d.jsx(
        Ve.div,
        {
          "data-state": nl(s.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Ir = "DialogContent", Ng = A.forwardRef(
  (e, t) => {
    const n = Ig(Ir, e.__scopeDialog), { forceMount: r = n.forceMount, ...s } = e, i = an(Ir, e.__scopeDialog);
    return /* @__PURE__ */ d.jsx(Zn, { present: r || i.open, children: i.modal ? /* @__PURE__ */ d.jsx(jS, { ...s, ref: t }) : /* @__PURE__ */ d.jsx($S, { ...s, ref: t }) });
  }
);
Ng.displayName = Ir;
var jS = A.forwardRef(
  (e, t) => {
    const n = an(Ir, e.__scopeDialog), r = A.useRef(null), s = ze(t, n.contentRef, r);
    return A.useEffect(() => {
      const i = r.current;
      if (i) return Zc(i);
    }, []), /* @__PURE__ */ d.jsx(
      kg,
      {
        ...e,
        ref: s,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: be(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, o = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || o) && i.preventDefault();
        }),
        onFocusOutside: be(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), $S = A.forwardRef(
  (e, t) => {
    const n = an(Ir, e.__scopeDialog), r = A.useRef(!1), s = A.useRef(!1);
    return /* @__PURE__ */ d.jsx(
      kg,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, s.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (s.current = !0));
          const a = i.target;
          n.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && s.current && i.preventDefault();
        }
      }
    );
  }
), kg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: s, onCloseAutoFocus: i, ...a } = e, o = an(Ir, n), u = A.useRef(null), c = ze(t, u);
    return Jc(), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(
        oo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: s,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ d.jsx(
            yi,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": nl(o.open),
              ...a,
              ref: c,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        /* @__PURE__ */ d.jsx(zS, { titleId: o.titleId }),
        /* @__PURE__ */ d.jsx(YS, { contentRef: u, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), tl = "DialogTitle", Rg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = an(tl, n);
    return /* @__PURE__ */ d.jsx(Ve.h2, { id: s.titleId, ...r, ref: t });
  }
);
Rg.displayName = tl;
var Pg = "DialogDescription", Og = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = an(Pg, n);
    return /* @__PURE__ */ d.jsx(Ve.p, { id: s.descriptionId, ...r, ref: t });
  }
);
Og.displayName = Pg;
var Dg = "DialogClose", Lg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = an(Dg, n);
    return /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, () => s.onOpenChange(!1))
      }
    );
  }
);
Lg.displayName = Dg;
function nl(e) {
  return e ? "open" : "closed";
}
var Mg = "DialogTitleWarning", [HF, Hg] = xC(Mg, {
  contentName: Ir,
  titleName: tl,
  docsSlug: "dialog"
}), zS = ({ titleId: e }) => {
  const t = Hg(Mg), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return A.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, VS = "DialogDescriptionWarning", YS = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Hg(VS).contentName}}.`;
  return A.useEffect(() => {
    const s = e.current?.getAttribute("aria-describedby");
    t && s && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, GS = Cg, WS = wg, qS = vg, KS = Ng, QS = Rg, XS = Og, JS = Lg;
function ZS(e) {
  const t = A.useRef({ value: e, previous: e });
  return A.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function eI(e) {
  const [t, n] = A.useState(void 0);
  return bt(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((s) => {
        if (!Array.isArray(s) || !s.length)
          return;
        const i = s[0];
        let a, o;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          a = c.inlineSize, o = c.blockSize;
        } else
          a = e.offsetWidth, o = e.offsetHeight;
        n({ width: a, height: o });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
const tI = ["top", "right", "bottom", "left"], Qn = Math.min, Ht = Math.max, Pa = Math.round, Ki = Math.floor, pn = (e) => ({
  x: e,
  y: e
}), nI = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, rI = {
  start: "end",
  end: "start"
};
function ic(e, t, n) {
  return Ht(e, Qn(t, n));
}
function Rn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Pn(e) {
  return e.split("-")[0];
}
function ms(e) {
  return e.split("-")[1];
}
function rl(e) {
  return e === "x" ? "y" : "x";
}
function sl(e) {
  return e === "y" ? "height" : "width";
}
const sI = /* @__PURE__ */ new Set(["top", "bottom"]);
function fn(e) {
  return sI.has(Pn(e)) ? "y" : "x";
}
function il(e) {
  return rl(fn(e));
}
function iI(e, t, n) {
  n === void 0 && (n = !1);
  const r = ms(e), s = il(e), i = sl(s);
  let a = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Oa(a)), [a, Oa(a)];
}
function aI(e) {
  const t = Oa(e);
  return [ac(e), t, ac(t)];
}
function ac(e) {
  return e.replace(/start|end/g, (t) => rI[t]);
}
const yh = ["left", "right"], xh = ["right", "left"], oI = ["top", "bottom"], uI = ["bottom", "top"];
function cI(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? xh : yh : t ? yh : xh;
    case "left":
    case "right":
      return t ? oI : uI;
    default:
      return [];
  }
}
function lI(e, t, n, r) {
  const s = ms(e);
  let i = cI(Pn(e), n === "start", r);
  return s && (i = i.map((a) => a + "-" + s), t && (i = i.concat(i.map(ac)))), i;
}
function Oa(e) {
  return e.replace(/left|right|bottom|top/g, (t) => nI[t]);
}
function dI(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Bg(e) {
  return typeof e != "number" ? dI(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Da(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function Ch(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = fn(t), a = il(t), o = sl(a), u = Pn(t), c = i === "y", l = r.x + r.width / 2 - s.width / 2, h = r.y + r.height / 2 - s.height / 2, m = r[o] / 2 - s[o] / 2;
  let p;
  switch (u) {
    case "top":
      p = {
        x: l,
        y: r.y - s.height
      };
      break;
    case "bottom":
      p = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      p = {
        x: r.x - s.width,
        y: h
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (ms(t)) {
    case "start":
      p[a] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += m * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function hI(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: a,
    elements: o,
    strategy: u
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: h = "floating",
    altBoundary: m = !1,
    padding: p = 0
  } = Rn(t, e), E = Bg(p), _ = o[m ? h === "floating" ? "reference" : "floating" : h], b = Da(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(_))) == null || n ? _ : _.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: l,
    strategy: u
  })), T = h === "floating" ? {
    x: r,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), R = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = Da(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: T,
    offsetParent: C,
    strategy: u
  }) : T);
  return {
    top: (b.top - D.top + E.top) / R.y,
    bottom: (D.bottom - b.bottom + E.bottom) / R.y,
    left: (b.left - D.left + E.left) / R.x,
    right: (D.right - b.right + E.right) / R.x
  };
}
const fI = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: a
  } = n, o = i.filter(Boolean), u = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: l,
    y: h
  } = Ch(c, r, u), m = r, p = {}, E = 0;
  for (let _ = 0; _ < o.length; _++) {
    var g;
    const {
      name: b,
      fn: T
    } = o[_], {
      x: C,
      y: R,
      data: D,
      reset: I
    } = await T({
      x: l,
      y: h,
      initialPlacement: r,
      placement: m,
      strategy: s,
      middlewareData: p,
      rects: c,
      platform: {
        ...a,
        detectOverflow: (g = a.detectOverflow) != null ? g : hI
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    l = C ?? l, h = R ?? h, p = {
      ...p,
      [b]: {
        ...p[b],
        ...D
      }
    }, I && E <= 50 && (E++, typeof I == "object" && (I.placement && (m = I.placement), I.rects && (c = I.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : I.rects), {
      x: l,
      y: h
    } = Ch(c, m, u)), _ = -1);
  }
  return {
    x: l,
    y: h,
    placement: m,
    strategy: s,
    middlewareData: p
  };
}, pI = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: s,
      rects: i,
      platform: a,
      elements: o,
      middlewareData: u
    } = t, {
      element: c,
      padding: l = 0
    } = Rn(e, t) || {};
    if (c == null)
      return {};
    const h = Bg(l), m = {
      x: n,
      y: r
    }, p = il(s), E = sl(p), g = await a.getDimensions(c), _ = p === "y", b = _ ? "top" : "left", T = _ ? "bottom" : "right", C = _ ? "clientHeight" : "clientWidth", R = i.reference[E] + i.reference[p] - m[p] - i.floating[E], D = m[p] - i.reference[p], I = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let O = I ? I[C] : 0;
    (!O || !await (a.isElement == null ? void 0 : a.isElement(I))) && (O = o.floating[C] || i.floating[E]);
    const U = R / 2 - D / 2, q = O / 2 - g[E] / 2 - 1, P = Qn(h[b], q), z = Qn(h[T], q), G = P, F = O - g[E] - z, M = O / 2 - g[E] / 2 + U, H = ic(G, M, F), B = !u.arrow && ms(s) != null && M !== H && i.reference[E] / 2 - (M < G ? P : z) - g[E] / 2 < 0, Y = B ? M < G ? M - G : M - F : 0;
    return {
      [p]: m[p] + Y,
      data: {
        [p]: H,
        centerOffset: M - H - Y,
        ...B && {
          alignmentOffset: Y
        }
      },
      reset: B
    };
  }
}), mI = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: u,
        elements: c
      } = t, {
        mainAxis: l = !0,
        crossAxis: h = !0,
        fallbackPlacements: m,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: E = "none",
        flipAlignment: g = !0,
        ..._
      } = Rn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = Pn(s), T = fn(o), C = Pn(o) === o, R = await (u.isRTL == null ? void 0 : u.isRTL(c.floating)), D = m || (C || !g ? [Oa(o)] : aI(o)), I = E !== "none";
      !m && I && D.push(...lI(o, g, E, R));
      const O = [o, ...D], U = await u.detectOverflow(t, _), q = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (l && q.push(U[b]), h) {
        const M = iI(s, a, R);
        q.push(U[M[0]], U[M[1]]);
      }
      if (P = [...P, {
        placement: s,
        overflows: q
      }], !q.every((M) => M <= 0)) {
        var z, G;
        const M = (((z = i.flip) == null ? void 0 : z.index) || 0) + 1, H = O[M];
        if (H && (!(h === "alignment" ? T !== fn(H) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every(($) => fn($.placement) === T ? $.overflows[0] > 0 : !0)))
          return {
            data: {
              index: M,
              overflows: P
            },
            reset: {
              placement: H
            }
          };
        let B = (G = P.filter((Y) => Y.overflows[0] <= 0).sort((Y, $) => Y.overflows[1] - $.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!B)
          switch (p) {
            case "bestFit": {
              var F;
              const Y = (F = P.filter(($) => {
                if (I) {
                  const Z = fn($.placement);
                  return Z === T || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map(($) => [$.placement, $.overflows.filter((Z) => Z > 0).reduce((Z, y) => Z + y, 0)]).sort(($, Z) => $[1] - Z[1])[0]) == null ? void 0 : F[0];
              Y && (B = Y);
              break;
            }
            case "initialPlacement":
              B = o;
              break;
          }
        if (s !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function Sh(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ih(e) {
  return tI.some((t) => e[t] >= 0);
}
const gI = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: s = "referenceHidden",
        ...i
      } = Rn(e, t);
      switch (s) {
        case "referenceHidden": {
          const a = await r.detectOverflow(t, {
            ...i,
            elementContext: "reference"
          }), o = Sh(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Ih(o)
            }
          };
        }
        case "escaped": {
          const a = await r.detectOverflow(t, {
            ...i,
            altBoundary: !0
          }), o = Sh(a, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Ih(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Ug = /* @__PURE__ */ new Set(["left", "top"]);
async function EI(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), a = Pn(n), o = ms(n), u = fn(n) === "y", c = Ug.has(a) ? -1 : 1, l = i && u ? -1 : 1, h = Rn(t, e);
  let {
    mainAxis: m,
    crossAxis: p,
    alignmentAxis: E
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return o && typeof E == "number" && (p = o === "end" ? E * -1 : E), u ? {
    x: p * l,
    y: m * c
  } : {
    x: m * c,
    y: p * l
  };
}
const bI = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: i,
        placement: a,
        middlewareData: o
      } = t, u = await EI(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: s + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, _I = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: s,
        platform: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: u = {
          fn: (b) => {
            let {
              x: T,
              y: C
            } = b;
            return {
              x: T,
              y: C
            };
          }
        },
        ...c
      } = Rn(e, t), l = {
        x: n,
        y: r
      }, h = await i.detectOverflow(t, c), m = fn(Pn(s)), p = rl(m);
      let E = l[p], g = l[m];
      if (a) {
        const b = p === "y" ? "top" : "left", T = p === "y" ? "bottom" : "right", C = E + h[b], R = E - h[T];
        E = ic(C, E, R);
      }
      if (o) {
        const b = m === "y" ? "top" : "left", T = m === "y" ? "bottom" : "right", C = g + h[b], R = g - h[T];
        g = ic(C, g, R);
      }
      const _ = u.fn({
        ...t,
        [p]: E,
        [m]: g
      });
      return {
        ..._,
        data: {
          x: _.x - n,
          y: _.y - r,
          enabled: {
            [p]: a,
            [m]: o
          }
        }
      };
    }
  };
}, TI = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: s,
        rects: i,
        middlewareData: a
      } = t, {
        offset: o = 0,
        mainAxis: u = !0,
        crossAxis: c = !0
      } = Rn(e, t), l = {
        x: n,
        y: r
      }, h = fn(s), m = rl(h);
      let p = l[m], E = l[h];
      const g = Rn(o, t), _ = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (u) {
        const C = m === "y" ? "height" : "width", R = i.reference[m] - i.floating[C] + _.mainAxis, D = i.reference[m] + i.reference[C] - _.mainAxis;
        p < R ? p = R : p > D && (p = D);
      }
      if (c) {
        var b, T;
        const C = m === "y" ? "width" : "height", R = Ug.has(Pn(s)), D = i.reference[h] - i.floating[C] + (R && ((b = a.offset) == null ? void 0 : b[h]) || 0) + (R ? 0 : _.crossAxis), I = i.reference[h] + i.reference[C] + (R ? 0 : ((T = a.offset) == null ? void 0 : T[h]) || 0) - (R ? _.crossAxis : 0);
        E < D ? E = D : E > I && (E = I);
      }
      return {
        [m]: p,
        [h]: E
      };
    }
  };
}, AI = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        rects: i,
        platform: a,
        elements: o
      } = t, {
        apply: u = () => {
        },
        ...c
      } = Rn(e, t), l = await a.detectOverflow(t, c), h = Pn(s), m = ms(s), p = fn(s) === "y", {
        width: E,
        height: g
      } = i.floating;
      let _, b;
      h === "top" || h === "bottom" ? (_ = h, b = m === (await (a.isRTL == null ? void 0 : a.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (b = h, _ = m === "end" ? "top" : "bottom");
      const T = g - l.top - l.bottom, C = E - l.left - l.right, R = Qn(g - l[_], T), D = Qn(E - l[b], C), I = !t.middlewareData.shift;
      let O = R, U = D;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (U = C), (r = t.middlewareData.shift) != null && r.enabled.y && (O = T), I && !m) {
        const P = Ht(l.left, 0), z = Ht(l.right, 0), G = Ht(l.top, 0), F = Ht(l.bottom, 0);
        p ? U = E - 2 * (P !== 0 || z !== 0 ? P + z : Ht(l.left, l.right)) : O = g - 2 * (G !== 0 || F !== 0 ? G + F : Ht(l.top, l.bottom));
      }
      await u({
        ...t,
        availableWidth: U,
        availableHeight: O
      });
      const q = await a.getDimensions(o.floating);
      return E !== q.width || g !== q.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ho() {
  return typeof window < "u";
}
function gs(e) {
  return Fg(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Bt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function bn(e) {
  var t;
  return (t = (Fg(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Fg(e) {
  return ho() ? e instanceof Node || e instanceof Bt(e).Node : !1;
}
function nn(e) {
  return ho() ? e instanceof Element || e instanceof Bt(e).Element : !1;
}
function gn(e) {
  return ho() ? e instanceof HTMLElement || e instanceof Bt(e).HTMLElement : !1;
}
function wh(e) {
  return !ho() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Bt(e).ShadowRoot;
}
const yI = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ci(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = rn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !yI.has(s);
}
const xI = /* @__PURE__ */ new Set(["table", "td", "th"]);
function CI(e) {
  return xI.has(gs(e));
}
const SI = [":popover-open", ":modal"];
function fo(e) {
  return SI.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const II = ["transform", "translate", "scale", "rotate", "perspective"], wI = ["transform", "translate", "scale", "rotate", "perspective", "filter"], vI = ["paint", "layout", "strict", "content"];
function al(e) {
  const t = ol(), n = nn(e) ? rn(e) : e;
  return II.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || wI.some((r) => (n.willChange || "").includes(r)) || vI.some((r) => (n.contain || "").includes(r));
}
function NI(e) {
  let t = Xn(e);
  for (; gn(t) && !os(t); ) {
    if (al(t))
      return t;
    if (fo(t))
      return null;
    t = Xn(t);
  }
  return null;
}
function ol() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const kI = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function os(e) {
  return kI.has(gs(e));
}
function rn(e) {
  return Bt(e).getComputedStyle(e);
}
function po(e) {
  return nn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Xn(e) {
  if (gs(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    wh(e) && e.host || // Fallback.
    bn(e)
  );
  return wh(t) ? t.host : t;
}
function jg(e) {
  const t = Xn(e);
  return os(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : gn(t) && Ci(t) ? t : jg(t);
}
function ci(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = jg(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Bt(s);
  if (i) {
    const o = oc(a);
    return t.concat(a, a.visualViewport || [], Ci(s) ? s : [], o && n ? ci(o) : []);
  }
  return t.concat(s, ci(s, [], n));
}
function oc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function $g(e) {
  const t = rn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = gn(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : r, o = Pa(n) !== i || Pa(r) !== a;
  return o && (n = i, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function ul(e) {
  return nn(e) ? e : e.contextElement;
}
function ts(e) {
  const t = ul(e);
  if (!gn(t))
    return pn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = $g(t);
  let a = (i ? Pa(n.width) : n.width) / r, o = (i ? Pa(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const RI = /* @__PURE__ */ pn(0);
function zg(e) {
  const t = Bt(e);
  return !ol() || !t.visualViewport ? RI : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function PI(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Bt(e) ? !1 : t;
}
function wr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = ul(e);
  let a = pn(1);
  t && (r ? nn(r) && (a = ts(r)) : a = ts(e));
  const o = PI(i, n, r) ? zg(i) : pn(0);
  let u = (s.left + o.x) / a.x, c = (s.top + o.y) / a.y, l = s.width / a.x, h = s.height / a.y;
  if (i) {
    const m = Bt(i), p = r && nn(r) ? Bt(r) : r;
    let E = m, g = oc(E);
    for (; g && r && p !== E; ) {
      const _ = ts(g), b = g.getBoundingClientRect(), T = rn(g), C = b.left + (g.clientLeft + parseFloat(T.paddingLeft)) * _.x, R = b.top + (g.clientTop + parseFloat(T.paddingTop)) * _.y;
      u *= _.x, c *= _.y, l *= _.x, h *= _.y, u += C, c += R, E = Bt(g), g = oc(E);
    }
  }
  return Da({
    width: l,
    height: h,
    x: u,
    y: c
  });
}
function mo(e, t) {
  const n = po(e).scrollLeft;
  return t ? t.left + n : wr(bn(e)).left + n;
}
function Vg(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - mo(e, n), s = n.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function OI(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", a = bn(r), o = t ? fo(t.floating) : !1;
  if (r === a || o && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = pn(1);
  const l = pn(0), h = gn(r);
  if ((h || !h && !i) && ((gs(r) !== "body" || Ci(a)) && (u = po(r)), gn(r))) {
    const p = wr(r);
    c = ts(r), l.x = p.x + r.clientLeft, l.y = p.y + r.clientTop;
  }
  const m = a && !h && !i ? Vg(a, u) : pn(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - u.scrollLeft * c.x + l.x + m.x,
    y: n.y * c.y - u.scrollTop * c.y + l.y + m.y
  };
}
function DI(e) {
  return Array.from(e.getClientRects());
}
function LI(e) {
  const t = bn(e), n = po(e), r = e.ownerDocument.body, s = Ht(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Ht(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + mo(e);
  const o = -n.scrollTop;
  return rn(r).direction === "rtl" && (a += Ht(t.clientWidth, r.clientWidth) - s), {
    width: s,
    height: i,
    x: a,
    y: o
  };
}
const vh = 25;
function MI(e, t) {
  const n = Bt(e), r = bn(e), s = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, o = 0, u = 0;
  if (s) {
    i = s.width, a = s.height;
    const l = ol();
    (!l || l && t === "fixed") && (o = s.offsetLeft, u = s.offsetTop);
  }
  const c = mo(r);
  if (c <= 0) {
    const l = r.ownerDocument, h = l.body, m = getComputedStyle(h), p = l.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, E = Math.abs(r.clientWidth - h.clientWidth - p);
    E <= vh && (i -= E);
  } else c <= vh && (i += c);
  return {
    width: i,
    height: a,
    x: o,
    y: u
  };
}
const HI = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function BI(e, t) {
  const n = wr(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, i = gn(e) ? ts(e) : pn(1), a = e.clientWidth * i.x, o = e.clientHeight * i.y, u = s * i.x, c = r * i.y;
  return {
    width: a,
    height: o,
    x: u,
    y: c
  };
}
function Nh(e, t, n) {
  let r;
  if (t === "viewport")
    r = MI(e, n);
  else if (t === "document")
    r = LI(bn(e));
  else if (nn(t))
    r = BI(t, n);
  else {
    const s = zg(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return Da(r);
}
function Yg(e, t) {
  const n = Xn(e);
  return n === t || !nn(n) || os(n) ? !1 : rn(n).position === "fixed" || Yg(n, t);
}
function UI(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ci(e, [], !1).filter((o) => nn(o) && gs(o) !== "body"), s = null;
  const i = rn(e).position === "fixed";
  let a = i ? Xn(e) : e;
  for (; nn(a) && !os(a); ) {
    const o = rn(a), u = al(a);
    !u && o.position === "fixed" && (s = null), (i ? !u && !s : !u && o.position === "static" && !!s && HI.has(s.position) || Ci(a) && !u && Yg(e, a)) ? r = r.filter((l) => l !== a) : s = o, a = Xn(a);
  }
  return t.set(e, r), r;
}
function FI(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const a = [...n === "clippingAncestors" ? fo(t) ? [] : UI(t, this._c) : [].concat(n), r], o = a[0], u = a.reduce((c, l) => {
    const h = Nh(t, l, s);
    return c.top = Ht(h.top, c.top), c.right = Qn(h.right, c.right), c.bottom = Qn(h.bottom, c.bottom), c.left = Ht(h.left, c.left), c;
  }, Nh(t, o, s));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function jI(e) {
  const {
    width: t,
    height: n
  } = $g(e);
  return {
    width: t,
    height: n
  };
}
function $I(e, t, n) {
  const r = gn(t), s = bn(t), i = n === "fixed", a = wr(e, !0, i, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = pn(0);
  function c() {
    u.x = mo(s);
  }
  if (r || !r && !i)
    if ((gs(t) !== "body" || Ci(s)) && (o = po(t)), r) {
      const p = wr(t, !0, i, t);
      u.x = p.x + t.clientLeft, u.y = p.y + t.clientTop;
    } else s && c();
  i && !r && s && c();
  const l = s && !r && !i ? Vg(s, o) : pn(0), h = a.left + o.scrollLeft - u.x - l.x, m = a.top + o.scrollTop - u.y - l.y;
  return {
    x: h,
    y: m,
    width: a.width,
    height: a.height
  };
}
function du(e) {
  return rn(e).position === "static";
}
function kh(e, t) {
  if (!gn(e) || rn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return bn(e) === n && (n = n.ownerDocument.body), n;
}
function Gg(e, t) {
  const n = Bt(e);
  if (fo(e))
    return n;
  if (!gn(e)) {
    let s = Xn(e);
    for (; s && !os(s); ) {
      if (nn(s) && !du(s))
        return s;
      s = Xn(s);
    }
    return n;
  }
  let r = kh(e, t);
  for (; r && CI(r) && du(r); )
    r = kh(r, t);
  return r && os(r) && du(r) && !al(r) ? n : r || NI(e) || n;
}
const zI = async function(e) {
  const t = this.getOffsetParent || Gg, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: $I(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function VI(e) {
  return rn(e).direction === "rtl";
}
const YI = {
  convertOffsetParentRelativeRectToViewportRelativeRect: OI,
  getDocumentElement: bn,
  getClippingRect: FI,
  getOffsetParent: Gg,
  getElementRects: zI,
  getClientRects: DI,
  getDimensions: jI,
  getScale: ts,
  isElement: nn,
  isRTL: VI
};
function Wg(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function GI(e, t) {
  let n = null, r;
  const s = bn(e);
  function i() {
    var o;
    clearTimeout(r), (o = n) == null || o.disconnect(), n = null;
  }
  function a(o, u) {
    o === void 0 && (o = !1), u === void 0 && (u = 1), i();
    const c = e.getBoundingClientRect(), {
      left: l,
      top: h,
      width: m,
      height: p
    } = c;
    if (o || t(), !m || !p)
      return;
    const E = Ki(h), g = Ki(s.clientWidth - (l + m)), _ = Ki(s.clientHeight - (h + p)), b = Ki(l), C = {
      rootMargin: -E + "px " + -g + "px " + -_ + "px " + -b + "px",
      threshold: Ht(0, Qn(1, u)) || 1
    };
    let R = !0;
    function D(I) {
      const O = I[0].intersectionRatio;
      if (O !== u) {
        if (!R)
          return a();
        O ? a(!1, O) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !Wg(c, e.getBoundingClientRect()) && a(), R = !1;
    }
    try {
      n = new IntersectionObserver(D, {
        ...C,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(D, C);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function WI(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, c = ul(e), l = s || i ? [...c ? ci(c) : [], ...ci(t)] : [];
  l.forEach((b) => {
    s && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const h = c && o ? GI(c, n) : null;
  let m = -1, p = null;
  a && (p = new ResizeObserver((b) => {
    let [T] = b;
    T && T.target === c && p && (p.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(t);
    })), n();
  }), c && !u && p.observe(c), p.observe(t));
  let E, g = u ? wr(e) : null;
  u && _();
  function _() {
    const b = wr(e);
    g && !Wg(g, b) && n(), g = b, E = requestAnimationFrame(_);
  }
  return n(), () => {
    var b;
    l.forEach((T) => {
      s && T.removeEventListener("scroll", n), i && T.removeEventListener("resize", n);
    }), h?.(), (b = p) == null || b.disconnect(), p = null, u && cancelAnimationFrame(E);
  };
}
const qI = bI, KI = _I, QI = mI, XI = AI, JI = gI, Rh = pI, ZI = TI, e2 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = {
    platform: YI,
    ...n
  }, i = {
    ...s.platform,
    _c: r
  };
  return fI(e, t, {
    ...s,
    platform: i
  });
};
var t2 = typeof document < "u", n2 = function() {
}, pa = t2 ? rs : n2;
function La(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, s;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!La(e[r], t[r]))
          return !1;
      return !0;
    }
    if (s = Object.keys(e), n = s.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, s[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = s[r];
      if (!(i === "_owner" && e.$$typeof) && !La(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function qg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ph(e, t) {
  const n = qg(e);
  return Math.round(t * n) / n;
}
function hu(e) {
  const t = A.useRef(e);
  return pa(() => {
    t.current = e;
  }), t;
}
function r2(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: s,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: o = !0,
    whileElementsMounted: u,
    open: c
  } = e, [l, h] = A.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, p] = A.useState(r);
  La(m, r) || p(r);
  const [E, g] = A.useState(null), [_, b] = A.useState(null), T = A.useCallback(($) => {
    $ !== I.current && (I.current = $, g($));
  }, []), C = A.useCallback(($) => {
    $ !== O.current && (O.current = $, b($));
  }, []), R = i || E, D = a || _, I = A.useRef(null), O = A.useRef(null), U = A.useRef(l), q = u != null, P = hu(u), z = hu(s), G = hu(c), F = A.useCallback(() => {
    if (!I.current || !O.current)
      return;
    const $ = {
      placement: t,
      strategy: n,
      middleware: m
    };
    z.current && ($.platform = z.current), e2(I.current, O.current, $).then((Z) => {
      const y = {
        ...Z,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: G.current !== !1
      };
      M.current && !La(U.current, y) && (U.current = y, Ka.flushSync(() => {
        h(y);
      }));
    });
  }, [m, t, n, z, G]);
  pa(() => {
    c === !1 && U.current.isPositioned && (U.current.isPositioned = !1, h(($) => ({
      ...$,
      isPositioned: !1
    })));
  }, [c]);
  const M = A.useRef(!1);
  pa(() => (M.current = !0, () => {
    M.current = !1;
  }), []), pa(() => {
    if (R && (I.current = R), D && (O.current = D), R && D) {
      if (P.current)
        return P.current(R, D, F);
      F();
    }
  }, [R, D, F, P, q]);
  const H = A.useMemo(() => ({
    reference: I,
    floating: O,
    setReference: T,
    setFloating: C
  }), [T, C]), B = A.useMemo(() => ({
    reference: R,
    floating: D
  }), [R, D]), Y = A.useMemo(() => {
    const $ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!B.floating)
      return $;
    const Z = Ph(B.floating, l.x), y = Ph(B.floating, l.y);
    return o ? {
      ...$,
      transform: "translate(" + Z + "px, " + y + "px)",
      ...qg(B.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Z,
      top: y
    };
  }, [n, o, B.floating, l.x, l.y]);
  return A.useMemo(() => ({
    ...l,
    update: F,
    refs: H,
    elements: B,
    floatingStyles: Y
  }), [l, F, H, B, Y]);
}
const s2 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: s
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Rh({
        element: r.current,
        padding: s
      }).fn(n) : {} : r ? Rh({
        element: r,
        padding: s
      }).fn(n) : {};
    }
  };
}, i2 = (e, t) => ({
  ...qI(e),
  options: [e, t]
}), a2 = (e, t) => ({
  ...KI(e),
  options: [e, t]
}), o2 = (e, t) => ({
  ...ZI(e),
  options: [e, t]
}), u2 = (e, t) => ({
  ...QI(e),
  options: [e, t]
}), c2 = (e, t) => ({
  ...XI(e),
  options: [e, t]
}), l2 = (e, t) => ({
  ...JI(e),
  options: [e, t]
}), d2 = (e, t) => ({
  ...s2(e),
  options: [e, t]
});
var h2 = "Arrow", Kg = A.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: s = 5, ...i } = e;
  return /* @__PURE__ */ d.jsx(
    Ve.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: s,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Kg.displayName = h2;
var f2 = Kg, cl = "Popper", [Qg, Es] = ps(cl), [p2, Xg] = Qg(cl), Jg = (e) => {
  const { __scopePopper: t, children: n } = e, [r, s] = A.useState(null);
  return /* @__PURE__ */ d.jsx(p2, { scope: t, anchor: r, onAnchorChange: s, children: n });
};
Jg.displayName = cl;
var Zg = "PopperAnchor", e0 = A.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...s } = e, i = Xg(Zg, n), a = A.useRef(null), o = ze(t, a), u = A.useRef(null);
    return A.useEffect(() => {
      const c = u.current;
      u.current = r?.current || a.current, c !== u.current && i.onAnchorChange(u.current);
    }), r ? null : /* @__PURE__ */ d.jsx(Ve.div, { ...s, ref: o });
  }
);
e0.displayName = Zg;
var ll = "PopperContent", [m2, g2] = Qg(ll), t0 = A.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: s = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: o = 0,
      avoidCollisions: u = !0,
      collisionBoundary: c = [],
      collisionPadding: l = 0,
      sticky: h = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: E,
      ...g
    } = e, _ = Xg(ll, n), [b, T] = A.useState(null), C = ze(t, (re) => T(re)), [R, D] = A.useState(null), I = eI(R), O = I?.width ?? 0, U = I?.height ?? 0, q = r + (i !== "center" ? "-" + i : ""), P = typeof l == "number" ? l : { top: 0, right: 0, bottom: 0, left: 0, ...l }, z = Array.isArray(c) ? c : [c], G = z.length > 0, F = {
      padding: P,
      boundary: z.filter(b2),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: G
    }, { refs: M, floatingStyles: H, placement: B, isPositioned: Y, middlewareData: $ } = r2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: q,
      whileElementsMounted: (...re) => WI(...re, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: _.anchor
      },
      middleware: [
        i2({ mainAxis: s + U, alignmentAxis: a }),
        u && a2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? o2() : void 0,
          ...F
        }),
        u && u2({ ...F }),
        c2({
          ...F,
          apply: ({ elements: re, rects: Te, availableWidth: ce, availableHeight: ue }) => {
            const { width: Ae, height: Pe } = Te.reference, qe = re.floating.style;
            qe.setProperty("--radix-popper-available-width", `${ce}px`), qe.setProperty("--radix-popper-available-height", `${ue}px`), qe.setProperty("--radix-popper-anchor-width", `${Ae}px`), qe.setProperty("--radix-popper-anchor-height", `${Pe}px`);
          }
        }),
        R && d2({ element: R, padding: o }),
        _2({ arrowWidth: O, arrowHeight: U }),
        m && l2({ strategy: "referenceHidden", ...F })
      ]
    }), [Z, y] = s0(B), fe = jt(E);
    bt(() => {
      Y && fe?.();
    }, [Y, fe]);
    const Ce = $.arrow?.x, v = $.arrow?.y, Se = $.arrow?.centerOffset !== 0, [_e, pe] = A.useState();
    return bt(() => {
      b && pe(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ d.jsx(
      "div",
      {
        ref: M.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...H,
          transform: Y ? H.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: _e,
          "--radix-popper-transform-origin": [
            $.transformOrigin?.x,
            $.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...$.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d.jsx(
          m2,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: D,
            arrowX: Ce,
            arrowY: v,
            shouldHideArrow: Se,
            children: /* @__PURE__ */ d.jsx(
              Ve.div,
              {
                "data-side": Z,
                "data-align": y,
                ...g,
                ref: C,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Y ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
t0.displayName = ll;
var n0 = "PopperArrow", E2 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, r0 = A.forwardRef(function(t, n) {
  const { __scopePopper: r, ...s } = t, i = g2(n0, r), a = E2[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d.jsx(
          f2,
          {
            ...s,
            ref: n,
            style: {
              ...s.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
r0.displayName = n0;
function b2(e) {
  return e !== null;
}
var _2 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: s } = t, a = s.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, u = a ? 0 : e.arrowHeight, [c, l] = s0(n), h = { start: "0%", center: "50%", end: "100%" }[l], m = (s.arrow?.x ?? 0) + o / 2, p = (s.arrow?.y ?? 0) + u / 2;
    let E = "", g = "";
    return c === "bottom" ? (E = a ? h : `${m}px`, g = `${-u}px`) : c === "top" ? (E = a ? h : `${m}px`, g = `${r.floating.height + u}px`) : c === "right" ? (E = `${-u}px`, g = a ? h : `${p}px`) : c === "left" && (E = `${r.floating.width + u}px`, g = a ? h : `${p}px`), { data: { x: E, y: g } };
  }
});
function s0(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var dl = Jg, go = e0, hl = t0, fl = r0;
function Oh(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Eo = "Popover", [i0] = ps(Eo, [
  Es
]), Si = Es(), [T2, er] = i0(Eo), a0 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    modal: a = !1
  } = e, o = Si(t), u = A.useRef(null), [c, l] = A.useState(!1), [h, m] = ui({
    prop: r,
    defaultProp: s ?? !1,
    onChange: i,
    caller: Eo
  });
  return /* @__PURE__ */ d.jsx(dl, { ...o, children: /* @__PURE__ */ d.jsx(
    T2,
    {
      scope: t,
      contentId: Gn(),
      triggerRef: u,
      open: h,
      onOpenChange: m,
      onOpenToggle: A.useCallback(() => m((p) => !p), [m]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: A.useCallback(() => l(!0), []),
      onCustomAnchorRemove: A.useCallback(() => l(!1), []),
      modal: a,
      children: n
    }
  ) });
};
a0.displayName = Eo;
var o0 = "PopoverAnchor", A2 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = er(o0, n), i = Si(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: o } = s;
    return A.useEffect(() => (a(), () => o()), [a, o]), /* @__PURE__ */ d.jsx(go, { ...i, ...r, ref: t });
  }
);
A2.displayName = o0;
var u0 = "PopoverTrigger", c0 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = er(u0, n), i = Si(n), a = ze(t, s.triggerRef), o = /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.contentId,
        "data-state": p0(s.open),
        ...r,
        ref: a,
        onClick: be(e.onClick, s.onOpenToggle)
      }
    );
    return s.hasCustomAnchor ? o : /* @__PURE__ */ d.jsx(go, { asChild: !0, ...i, children: o });
  }
);
c0.displayName = u0;
var pl = "PopoverPortal", [y2, x2] = i0(pl, {
  forceMount: void 0
}), l0 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: s } = e, i = er(pl, t);
  return /* @__PURE__ */ d.jsx(y2, { scope: t, forceMount: n, children: /* @__PURE__ */ d.jsx(Zn, { present: n || i.open, children: /* @__PURE__ */ d.jsx(xi, { asChild: !0, container: s, children: r }) }) });
};
l0.displayName = pl;
var us = "PopoverContent", d0 = A.forwardRef(
  (e, t) => {
    const n = x2(us, e.__scopePopover), { forceMount: r = n.forceMount, ...s } = e, i = er(us, e.__scopePopover);
    return /* @__PURE__ */ d.jsx(Zn, { present: r || i.open, children: i.modal ? /* @__PURE__ */ d.jsx(S2, { ...s, ref: t }) : /* @__PURE__ */ d.jsx(I2, { ...s, ref: t }) });
  }
);
d0.displayName = us;
var C2 = /* @__PURE__ */ Sr("PopoverContent.RemoveScroll"), S2 = A.forwardRef(
  (e, t) => {
    const n = er(us, e.__scopePopover), r = A.useRef(null), s = ze(t, r), i = A.useRef(!1);
    return A.useEffect(() => {
      const a = r.current;
      if (a) return Zc(a);
    }, []), /* @__PURE__ */ d.jsx(co, { as: C2, allowPinchZoom: !0, children: /* @__PURE__ */ d.jsx(
      h0,
      {
        ...e,
        ref: s,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), i.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: be(
          e.onPointerDownOutside,
          (a) => {
            const o = a.detail.originalEvent, u = o.button === 0 && o.ctrlKey === !0, c = o.button === 2 || u;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: be(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), I2 = A.forwardRef(
  (e, t) => {
    const n = er(us, e.__scopePopover), r = A.useRef(!1), s = A.useRef(!1);
    return /* @__PURE__ */ d.jsx(
      h0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, s.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (s.current = !0));
          const a = i.target;
          n.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && s.current && i.preventDefault();
        }
      }
    );
  }
), h0 = A.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: s,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: o,
      onPointerDownOutside: u,
      onFocusOutside: c,
      onInteractOutside: l,
      ...h
    } = e, m = er(us, n), p = Si(n);
    return Jc(), /* @__PURE__ */ d.jsx(
      oo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: s,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ d.jsx(
          yi,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: l,
            onEscapeKeyDown: o,
            onPointerDownOutside: u,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ d.jsx(
              hl,
              {
                "data-state": p0(m.open),
                role: "dialog",
                id: m.contentId,
                ...p,
                ...h,
                ref: t,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), f0 = "PopoverClose", w2 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = er(f0, n);
    return /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, () => s.onOpenChange(!1))
      }
    );
  }
);
w2.displayName = f0;
var v2 = "PopoverArrow", N2 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = Si(n);
    return /* @__PURE__ */ d.jsx(fl, { ...s, ...r, ref: t });
  }
);
N2.displayName = v2;
function p0(e) {
  return e ? "open" : "closed";
}
var k2 = a0, R2 = c0, P2 = l0, O2 = d0, D2 = [" ", "Enter", "ArrowUp", "ArrowDown"], L2 = [" ", "Enter"], vr = "Select", [bo, _o, M2] = SC(vr), [bs] = ps(vr, [
  M2,
  Es
]), To = Es(), [H2, tr] = bs(vr), [B2, U2] = bs(vr), m0 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    value: a,
    defaultValue: o,
    onValueChange: u,
    dir: c,
    name: l,
    autoComplete: h,
    disabled: m,
    required: p,
    form: E
  } = e, g = To(t), [_, b] = A.useState(null), [T, C] = A.useState(null), [R, D] = A.useState(!1), I = LC(c), [O, U] = ui({
    prop: r,
    defaultProp: s ?? !1,
    onChange: i,
    caller: vr
  }), [q, P] = ui({
    prop: a,
    defaultProp: o,
    onChange: u,
    caller: vr
  }), z = A.useRef(null), G = _ ? E || !!_.closest("form") : !0, [F, M] = A.useState(/* @__PURE__ */ new Set()), H = Array.from(F).map((B) => B.props.value).join(";");
  return /* @__PURE__ */ d.jsx(dl, { ...g, children: /* @__PURE__ */ d.jsxs(
    H2,
    {
      required: p,
      scope: t,
      trigger: _,
      onTriggerChange: b,
      valueNode: T,
      onValueNodeChange: C,
      valueNodeHasChildren: R,
      onValueNodeHasChildrenChange: D,
      contentId: Gn(),
      value: q,
      onValueChange: P,
      open: O,
      onOpenChange: U,
      dir: I,
      triggerPointerDownPosRef: z,
      disabled: m,
      children: [
        /* @__PURE__ */ d.jsx(bo.Provider, { scope: t, children: /* @__PURE__ */ d.jsx(
          B2,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: A.useCallback((B) => {
              M((Y) => new Set(Y).add(B));
            }, []),
            onNativeOptionRemove: A.useCallback((B) => {
              M((Y) => {
                const $ = new Set(Y);
                return $.delete(B), $;
              });
            }, []),
            children: n
          }
        ) }),
        G ? /* @__PURE__ */ d.jsxs(
          H0,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: l,
            autoComplete: h,
            value: q,
            onChange: (B) => P(B.target.value),
            disabled: m,
            form: E,
            children: [
              q === void 0 ? /* @__PURE__ */ d.jsx("option", { value: "" }) : null,
              Array.from(F)
            ]
          },
          H
        ) : null
      ]
    }
  ) });
};
m0.displayName = vr;
var g0 = "SelectTrigger", E0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...s } = e, i = To(n), a = tr(g0, n), o = a.disabled || r, u = ze(t, a.onTriggerChange), c = _o(n), l = A.useRef("touch"), [h, m, p] = U0((g) => {
      const _ = c().filter((C) => !C.disabled), b = _.find((C) => C.value === a.value), T = F0(_, g, b);
      T !== void 0 && a.onValueChange(T.value);
    }), E = (g) => {
      o || (a.onOpenChange(!0), p()), g && (a.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ d.jsx(go, { asChild: !0, ...i, children: /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-placeholder": B0(a.value) ? "" : void 0,
        ...s,
        ref: u,
        onClick: be(s.onClick, (g) => {
          g.currentTarget.focus(), l.current !== "mouse" && E(g);
        }),
        onPointerDown: be(s.onPointerDown, (g) => {
          l.current = g.pointerType;
          const _ = g.target;
          _.hasPointerCapture(g.pointerId) && _.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (E(g), g.preventDefault());
        }),
        onKeyDown: be(s.onKeyDown, (g) => {
          const _ = h.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && m(g.key), !(_ && g.key === " ") && D2.includes(g.key) && (E(), g.preventDefault());
        })
      }
    ) });
  }
);
E0.displayName = g0;
var b0 = "SelectValue", _0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: s, children: i, placeholder: a = "", ...o } = e, u = tr(b0, n), { onValueNodeHasChildrenChange: c } = u, l = i !== void 0, h = ze(t, u.onValueNodeChange);
    return bt(() => {
      c(l);
    }, [c, l]), /* @__PURE__ */ d.jsx(
      Ve.span,
      {
        ...o,
        ref: h,
        style: { pointerEvents: "none" },
        children: B0(u.value) ? /* @__PURE__ */ d.jsx(d.Fragment, { children: a }) : i
      }
    );
  }
);
_0.displayName = b0;
var F2 = "SelectIcon", T0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...s } = e;
    return /* @__PURE__ */ d.jsx(Ve.span, { "aria-hidden": !0, ...s, ref: t, children: r || "▼" });
  }
);
T0.displayName = F2;
var j2 = "SelectPortal", A0 = (e) => /* @__PURE__ */ d.jsx(xi, { asChild: !0, ...e });
A0.displayName = j2;
var Nr = "SelectContent", y0 = A.forwardRef(
  (e, t) => {
    const n = tr(Nr, e.__scopeSelect), [r, s] = A.useState();
    if (bt(() => {
      s(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Ka.createPortal(
        /* @__PURE__ */ d.jsx(x0, { scope: e.__scopeSelect, children: /* @__PURE__ */ d.jsx(bo.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ d.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ d.jsx(C0, { ...e, ref: t });
  }
);
y0.displayName = Nr;
var Xt = 10, [x0, nr] = bs(Nr), $2 = "SelectContentImpl", z2 = /* @__PURE__ */ Sr("SelectContent.RemoveScroll"), C0 = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: o,
      sideOffset: u,
      align: c,
      alignOffset: l,
      arrowPadding: h,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: E,
      hideWhenDetached: g,
      avoidCollisions: _,
      //
      ...b
    } = e, T = tr(Nr, n), [C, R] = A.useState(null), [D, I] = A.useState(null), O = ze(t, (re) => R(re)), [U, q] = A.useState(null), [P, z] = A.useState(
      null
    ), G = _o(n), [F, M] = A.useState(!1), H = A.useRef(!1);
    A.useEffect(() => {
      if (C) return Zc(C);
    }, [C]), Jc();
    const B = A.useCallback(
      (re) => {
        const [Te, ...ce] = G().map((Pe) => Pe.ref.current), [ue] = ce.slice(-1), Ae = document.activeElement;
        for (const Pe of re)
          if (Pe === Ae || (Pe?.scrollIntoView({ block: "nearest" }), Pe === Te && D && (D.scrollTop = 0), Pe === ue && D && (D.scrollTop = D.scrollHeight), Pe?.focus(), document.activeElement !== Ae)) return;
      },
      [G, D]
    ), Y = A.useCallback(
      () => B([U, C]),
      [B, U, C]
    );
    A.useEffect(() => {
      F && Y();
    }, [F, Y]);
    const { onOpenChange: $, triggerPointerDownPosRef: Z } = T;
    A.useEffect(() => {
      if (C) {
        let re = { x: 0, y: 0 };
        const Te = (ue) => {
          re = {
            x: Math.abs(Math.round(ue.pageX) - (Z.current?.x ?? 0)),
            y: Math.abs(Math.round(ue.pageY) - (Z.current?.y ?? 0))
          };
        }, ce = (ue) => {
          re.x <= 10 && re.y <= 10 ? ue.preventDefault() : C.contains(ue.target) || $(!1), document.removeEventListener("pointermove", Te), Z.current = null;
        };
        return Z.current !== null && (document.addEventListener("pointermove", Te), document.addEventListener("pointerup", ce, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Te), document.removeEventListener("pointerup", ce, { capture: !0 });
        };
      }
    }, [C, $, Z]), A.useEffect(() => {
      const re = () => $(!1);
      return window.addEventListener("blur", re), window.addEventListener("resize", re), () => {
        window.removeEventListener("blur", re), window.removeEventListener("resize", re);
      };
    }, [$]);
    const [y, fe] = U0((re) => {
      const Te = G().filter((Ae) => !Ae.disabled), ce = Te.find((Ae) => Ae.ref.current === document.activeElement), ue = F0(Te, re, ce);
      ue && setTimeout(() => ue.ref.current.focus());
    }), Ce = A.useCallback(
      (re, Te, ce) => {
        const ue = !H.current && !ce;
        (T.value !== void 0 && T.value === Te || ue) && (q(re), ue && (H.current = !0));
      },
      [T.value]
    ), v = A.useCallback(() => C?.focus(), [C]), Se = A.useCallback(
      (re, Te, ce) => {
        const ue = !H.current && !ce;
        (T.value !== void 0 && T.value === Te || ue) && z(re);
      },
      [T.value]
    ), _e = r === "popper" ? uc : S0, pe = _e === uc ? {
      side: o,
      sideOffset: u,
      align: c,
      alignOffset: l,
      arrowPadding: h,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: E,
      hideWhenDetached: g,
      avoidCollisions: _
    } : {};
    return /* @__PURE__ */ d.jsx(
      x0,
      {
        scope: n,
        content: C,
        viewport: D,
        onViewportChange: I,
        itemRefCallback: Ce,
        selectedItem: U,
        onItemLeave: v,
        itemTextRefCallback: Se,
        focusSelectedItem: Y,
        selectedItemText: P,
        position: r,
        isPositioned: F,
        searchRef: y,
        children: /* @__PURE__ */ d.jsx(co, { as: z2, allowPinchZoom: !0, children: /* @__PURE__ */ d.jsx(
          oo,
          {
            asChild: !0,
            trapped: T.open,
            onMountAutoFocus: (re) => {
              re.preventDefault();
            },
            onUnmountAutoFocus: be(s, (re) => {
              T.trigger?.focus({ preventScroll: !0 }), re.preventDefault();
            }),
            children: /* @__PURE__ */ d.jsx(
              yi,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (re) => re.preventDefault(),
                onDismiss: () => T.onOpenChange(!1),
                children: /* @__PURE__ */ d.jsx(
                  _e,
                  {
                    role: "listbox",
                    id: T.contentId,
                    "data-state": T.open ? "open" : "closed",
                    dir: T.dir,
                    onContextMenu: (re) => re.preventDefault(),
                    ...b,
                    ...pe,
                    onPlaced: () => M(!0),
                    ref: O,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: be(b.onKeyDown, (re) => {
                      const Te = re.ctrlKey || re.altKey || re.metaKey;
                      if (re.key === "Tab" && re.preventDefault(), !Te && re.key.length === 1 && fe(re.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(re.key)) {
                        let ue = G().filter((Ae) => !Ae.disabled).map((Ae) => Ae.ref.current);
                        if (["ArrowUp", "End"].includes(re.key) && (ue = ue.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(re.key)) {
                          const Ae = re.target, Pe = ue.indexOf(Ae);
                          ue = ue.slice(Pe + 1);
                        }
                        setTimeout(() => B(ue)), re.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
C0.displayName = $2;
var V2 = "SelectItemAlignedPosition", S0 = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...s } = e, i = tr(Nr, n), a = nr(Nr, n), [o, u] = A.useState(null), [c, l] = A.useState(null), h = ze(t, (O) => l(O)), m = _o(n), p = A.useRef(!1), E = A.useRef(!0), { viewport: g, selectedItem: _, selectedItemText: b, focusSelectedItem: T } = a, C = A.useCallback(() => {
    if (i.trigger && i.valueNode && o && c && g && _ && b) {
      const O = i.trigger.getBoundingClientRect(), U = c.getBoundingClientRect(), q = i.valueNode.getBoundingClientRect(), P = b.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const Ae = P.left - U.left, Pe = q.left - Ae, qe = O.left - Pe, mt = O.width + qe, Kt = Math.max(mt, U.width), zt = window.innerWidth - Xt, An = Oh(Pe, [
          Xt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Xt, zt - Kt)
        ]);
        o.style.minWidth = mt + "px", o.style.left = An + "px";
      } else {
        const Ae = U.right - P.right, Pe = window.innerWidth - q.right - Ae, qe = window.innerWidth - O.right - Pe, mt = O.width + qe, Kt = Math.max(mt, U.width), zt = window.innerWidth - Xt, An = Oh(Pe, [
          Xt,
          Math.max(Xt, zt - Kt)
        ]);
        o.style.minWidth = mt + "px", o.style.right = An + "px";
      }
      const z = m(), G = window.innerHeight - Xt * 2, F = g.scrollHeight, M = window.getComputedStyle(c), H = parseInt(M.borderTopWidth, 10), B = parseInt(M.paddingTop, 10), Y = parseInt(M.borderBottomWidth, 10), $ = parseInt(M.paddingBottom, 10), Z = H + B + F + $ + Y, y = Math.min(_.offsetHeight * 5, Z), fe = window.getComputedStyle(g), Ce = parseInt(fe.paddingTop, 10), v = parseInt(fe.paddingBottom, 10), Se = O.top + O.height / 2 - Xt, _e = G - Se, pe = _.offsetHeight / 2, re = _.offsetTop + pe, Te = H + B + re, ce = Z - Te;
      if (Te <= Se) {
        const Ae = z.length > 0 && _ === z[z.length - 1].ref.current;
        o.style.bottom = "0px";
        const Pe = c.clientHeight - g.offsetTop - g.offsetHeight, qe = Math.max(
          _e,
          pe + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Ae ? v : 0) + Pe + Y
        ), mt = Te + qe;
        o.style.height = mt + "px";
      } else {
        const Ae = z.length > 0 && _ === z[0].ref.current;
        o.style.top = "0px";
        const qe = Math.max(
          Se,
          H + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Ae ? Ce : 0) + pe
        ) + ce;
        o.style.height = qe + "px", g.scrollTop = Te - Se + g.offsetTop;
      }
      o.style.margin = `${Xt}px 0`, o.style.minHeight = y + "px", o.style.maxHeight = G + "px", r?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    o,
    c,
    g,
    _,
    b,
    i.dir,
    r
  ]);
  bt(() => C(), [C]);
  const [R, D] = A.useState();
  bt(() => {
    c && D(window.getComputedStyle(c).zIndex);
  }, [c]);
  const I = A.useCallback(
    (O) => {
      O && E.current === !0 && (C(), T?.(), E.current = !1);
    },
    [C, T]
  );
  return /* @__PURE__ */ d.jsx(
    G2,
    {
      scope: n,
      contentWrapper: o,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: I,
      children: /* @__PURE__ */ d.jsx(
        "div",
        {
          ref: u,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: R
          },
          children: /* @__PURE__ */ d.jsx(
            Ve.div,
            {
              ...s,
              ref: h,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...s.style
              }
            }
          )
        }
      )
    }
  );
});
S0.displayName = V2;
var Y2 = "SelectPopperPosition", uc = A.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: s = Xt,
    ...i
  } = e, a = To(n);
  return /* @__PURE__ */ d.jsx(
    hl,
    {
      ...a,
      ...i,
      ref: t,
      align: r,
      collisionPadding: s,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
uc.displayName = Y2;
var [G2, ml] = bs(Nr, {}), cc = "SelectViewport", I0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...s } = e, i = nr(cc, n), a = ml(cc, n), o = ze(t, i.onViewportChange), u = A.useRef(0);
    return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ d.jsx(bo.Slot, { scope: n, children: /* @__PURE__ */ d.jsx(
        Ve.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...s,
          ref: o,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...s.style
          },
          onScroll: be(s.onScroll, (c) => {
            const l = c.currentTarget, { contentWrapper: h, shouldExpandOnScrollRef: m } = a;
            if (m?.current && h) {
              const p = Math.abs(u.current - l.scrollTop);
              if (p > 0) {
                const E = window.innerHeight - Xt * 2, g = parseFloat(h.style.minHeight), _ = parseFloat(h.style.height), b = Math.max(g, _);
                if (b < E) {
                  const T = b + p, C = Math.min(E, T), R = T - C;
                  h.style.height = C + "px", h.style.bottom === "0px" && (l.scrollTop = R > 0 ? R : 0, h.style.justifyContent = "flex-end");
                }
              }
            }
            u.current = l.scrollTop;
          })
        }
      ) })
    ] });
  }
);
I0.displayName = cc;
var w0 = "SelectGroup", [W2, q2] = bs(w0), K2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, s = Gn();
    return /* @__PURE__ */ d.jsx(W2, { scope: n, id: s, children: /* @__PURE__ */ d.jsx(Ve.div, { role: "group", "aria-labelledby": s, ...r, ref: t }) });
  }
);
K2.displayName = w0;
var v0 = "SelectLabel", Q2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, s = q2(v0, n);
    return /* @__PURE__ */ d.jsx(Ve.div, { id: s.id, ...r, ref: t });
  }
);
Q2.displayName = v0;
var Ma = "SelectItem", [X2, N0] = bs(Ma), k0 = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: s = !1,
      textValue: i,
      ...a
    } = e, o = tr(Ma, n), u = nr(Ma, n), c = o.value === r, [l, h] = A.useState(i ?? ""), [m, p] = A.useState(!1), E = ze(
      t,
      (T) => u.itemRefCallback?.(T, r, s)
    ), g = Gn(), _ = A.useRef("touch"), b = () => {
      s || (o.onValueChange(r), o.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d.jsx(
      X2,
      {
        scope: n,
        value: r,
        disabled: s,
        textId: g,
        isSelected: c,
        onItemTextChange: A.useCallback((T) => {
          h((C) => C || (T?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d.jsx(
          bo.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: s,
            textValue: l,
            children: /* @__PURE__ */ d.jsx(
              Ve.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": s || void 0,
                "data-disabled": s ? "" : void 0,
                tabIndex: s ? void 0 : -1,
                ...a,
                ref: E,
                onFocus: be(a.onFocus, () => p(!0)),
                onBlur: be(a.onBlur, () => p(!1)),
                onClick: be(a.onClick, () => {
                  _.current !== "mouse" && b();
                }),
                onPointerUp: be(a.onPointerUp, () => {
                  _.current === "mouse" && b();
                }),
                onPointerDown: be(a.onPointerDown, (T) => {
                  _.current = T.pointerType;
                }),
                onPointerMove: be(a.onPointerMove, (T) => {
                  _.current = T.pointerType, s ? u.onItemLeave?.() : _.current === "mouse" && T.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: be(a.onPointerLeave, (T) => {
                  T.currentTarget === document.activeElement && u.onItemLeave?.();
                }),
                onKeyDown: be(a.onKeyDown, (T) => {
                  u.searchRef?.current !== "" && T.key === " " || (L2.includes(T.key) && b(), T.key === " " && T.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
k0.displayName = Ma;
var zs = "SelectItemText", R0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: s, ...i } = e, a = tr(zs, n), o = nr(zs, n), u = N0(zs, n), c = U2(zs, n), [l, h] = A.useState(null), m = ze(
      t,
      (b) => h(b),
      u.onItemTextChange,
      (b) => o.itemTextRefCallback?.(b, u.value, u.disabled)
    ), p = l?.textContent, E = A.useMemo(
      () => /* @__PURE__ */ d.jsx("option", { value: u.value, disabled: u.disabled, children: p }, u.value),
      [u.disabled, u.value, p]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: _ } = c;
    return bt(() => (g(E), () => _(E)), [g, _, E]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(Ve.span, { id: u.textId, ...i, ref: m }),
      u.isSelected && a.valueNode && !a.valueNodeHasChildren ? Ka.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
R0.displayName = zs;
var P0 = "SelectItemIndicator", O0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return N0(P0, n).isSelected ? /* @__PURE__ */ d.jsx(Ve.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
O0.displayName = P0;
var lc = "SelectScrollUpButton", D0 = A.forwardRef((e, t) => {
  const n = nr(lc, e.__scopeSelect), r = ml(lc, e.__scopeSelect), [s, i] = A.useState(!1), a = ze(t, r.onScrollButtonChange);
  return bt(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const c = u.scrollTop > 0;
        i(c);
      };
      const u = n.viewport;
      return o(), u.addEventListener("scroll", o), () => u.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), s ? /* @__PURE__ */ d.jsx(
    M0,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: u } = n;
        o && u && (o.scrollTop = o.scrollTop - u.offsetHeight);
      }
    }
  ) : null;
});
D0.displayName = lc;
var dc = "SelectScrollDownButton", L0 = A.forwardRef((e, t) => {
  const n = nr(dc, e.__scopeSelect), r = ml(dc, e.__scopeSelect), [s, i] = A.useState(!1), a = ze(t, r.onScrollButtonChange);
  return bt(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const c = u.scrollHeight - u.clientHeight, l = Math.ceil(u.scrollTop) < c;
        i(l);
      };
      const u = n.viewport;
      return o(), u.addEventListener("scroll", o), () => u.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), s ? /* @__PURE__ */ d.jsx(
    M0,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: u } = n;
        o && u && (o.scrollTop = o.scrollTop + u.offsetHeight);
      }
    }
  ) : null;
});
L0.displayName = dc;
var M0 = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...s } = e, i = nr("SelectScrollButton", n), a = A.useRef(null), o = _o(n), u = A.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return A.useEffect(() => () => u(), [u]), bt(() => {
    o().find((l) => l.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [o]), /* @__PURE__ */ d.jsx(
    Ve.div,
    {
      "aria-hidden": !0,
      ...s,
      ref: t,
      style: { flexShrink: 0, ...s.style },
      onPointerDown: be(s.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: be(s.onPointerMove, () => {
        i.onItemLeave?.(), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: be(s.onPointerLeave, () => {
        u();
      })
    }
  );
}), J2 = "SelectSeparator", Z2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ d.jsx(Ve.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Z2.displayName = J2;
var hc = "SelectArrow", ew = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, s = To(n), i = tr(hc, n), a = nr(hc, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ d.jsx(fl, { ...s, ...r, ref: t }) : null;
  }
);
ew.displayName = hc;
var tw = "SelectBubbleInput", H0 = A.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const s = A.useRef(null), i = ze(r, s), a = ZS(t);
    return A.useEffect(() => {
      const o = s.current;
      if (!o) return;
      const u = window.HTMLSelectElement.prototype, l = Object.getOwnPropertyDescriptor(
        u,
        "value"
      ).set;
      if (a !== t && l) {
        const h = new Event("change", { bubbles: !0 });
        l.call(o, t), o.dispatchEvent(h);
      }
    }, [a, t]), /* @__PURE__ */ d.jsx(
      Ve.select,
      {
        ...n,
        style: { ...lg, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
H0.displayName = tw;
function B0(e) {
  return e === "" || e === void 0;
}
function U0(e) {
  const t = jt(e), n = A.useRef(""), r = A.useRef(0), s = A.useCallback(
    (a) => {
      const o = n.current + a;
      t(o), (function u(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => u(""), 1e3));
      })(o);
    },
    [t]
  ), i = A.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return A.useEffect(() => () => window.clearTimeout(r.current), []), [n, s, i];
}
function F0(e, t, n) {
  const s = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = nw(e, Math.max(i, 0));
  s.length === 1 && (a = a.filter((c) => c !== n));
  const u = a.find(
    (c) => c.textValue.toLowerCase().startsWith(s.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function nw(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var rw = m0, sw = E0, iw = _0, aw = T0, ow = A0, uw = y0, cw = I0, lw = k0, dw = R0, hw = O0, fw = D0, pw = L0, [Ao] = ps("Tooltip", [
  Es
]), yo = Es(), j0 = "TooltipProvider", mw = 700, fc = "tooltip.open", [gw, gl] = Ao(j0), $0 = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = mw,
    skipDelayDuration: r = 300,
    disableHoverableContent: s = !1,
    children: i
  } = e, a = A.useRef(!0), o = A.useRef(!1), u = A.useRef(0);
  return A.useEffect(() => {
    const c = u.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ d.jsx(
    gw,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: A.useCallback(() => {
        window.clearTimeout(u.current), a.current = !1;
      }, []),
      onClose: A.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: o,
      onPointerInTransitChange: A.useCallback((c) => {
        o.current = c;
      }, []),
      disableHoverableContent: s,
      children: i
    }
  );
};
$0.displayName = j0;
var li = "Tooltip", [Ew, Ii] = Ao(li), z0 = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: o
  } = e, u = gl(li, e.__scopeTooltip), c = yo(t), [l, h] = A.useState(null), m = Gn(), p = A.useRef(0), E = a ?? u.disableHoverableContent, g = o ?? u.delayDuration, _ = A.useRef(!1), [b, T] = ui({
    prop: r,
    defaultProp: s ?? !1,
    onChange: (O) => {
      O ? (u.onOpen(), document.dispatchEvent(new CustomEvent(fc))) : u.onClose(), i?.(O);
    },
    caller: li
  }), C = A.useMemo(() => b ? _.current ? "delayed-open" : "instant-open" : "closed", [b]), R = A.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, _.current = !1, T(!0);
  }, [T]), D = A.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, T(!1);
  }, [T]), I = A.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      _.current = !0, T(!0), p.current = 0;
    }, g);
  }, [g, T]);
  return A.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ d.jsx(dl, { ...c, children: /* @__PURE__ */ d.jsx(
    Ew,
    {
      scope: t,
      contentId: m,
      open: b,
      stateAttribute: C,
      trigger: l,
      onTriggerChange: h,
      onTriggerEnter: A.useCallback(() => {
        u.isOpenDelayedRef.current ? I() : R();
      }, [u.isOpenDelayedRef, I, R]),
      onTriggerLeave: A.useCallback(() => {
        E ? D() : (window.clearTimeout(p.current), p.current = 0);
      }, [D, E]),
      onOpen: R,
      onClose: D,
      disableHoverableContent: E,
      children: n
    }
  ) });
};
z0.displayName = li;
var pc = "TooltipTrigger", V0 = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, s = Ii(pc, n), i = gl(pc, n), a = yo(n), o = A.useRef(null), u = ze(t, o, s.onTriggerChange), c = A.useRef(!1), l = A.useRef(!1), h = A.useCallback(() => c.current = !1, []);
    return A.useEffect(() => () => document.removeEventListener("pointerup", h), [h]), /* @__PURE__ */ d.jsx(go, { asChild: !0, ...a, children: /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        "aria-describedby": s.open ? s.contentId : void 0,
        "data-state": s.stateAttribute,
        ...r,
        ref: u,
        onPointerMove: be(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !l.current && !i.isPointerInTransitRef.current && (s.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: be(e.onPointerLeave, () => {
          s.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: be(e.onPointerDown, () => {
          s.open && s.onClose(), c.current = !0, document.addEventListener("pointerup", h, { once: !0 });
        }),
        onFocus: be(e.onFocus, () => {
          c.current || s.onOpen();
        }),
        onBlur: be(e.onBlur, s.onClose),
        onClick: be(e.onClick, s.onClose)
      }
    ) });
  }
);
V0.displayName = pc;
var El = "TooltipPortal", [bw, _w] = Ao(El, {
  forceMount: void 0
}), Y0 = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: s } = e, i = Ii(El, t);
  return /* @__PURE__ */ d.jsx(bw, { scope: t, forceMount: n, children: /* @__PURE__ */ d.jsx(Zn, { present: n || i.open, children: /* @__PURE__ */ d.jsx(xi, { asChild: !0, container: s, children: r }) }) });
};
Y0.displayName = El;
var cs = "TooltipContent", G0 = A.forwardRef(
  (e, t) => {
    const n = _w(cs, e.__scopeTooltip), { forceMount: r = n.forceMount, side: s = "top", ...i } = e, a = Ii(cs, e.__scopeTooltip);
    return /* @__PURE__ */ d.jsx(Zn, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ d.jsx(W0, { side: s, ...i, ref: t }) : /* @__PURE__ */ d.jsx(Tw, { side: s, ...i, ref: t }) });
  }
), Tw = A.forwardRef((e, t) => {
  const n = Ii(cs, e.__scopeTooltip), r = gl(cs, e.__scopeTooltip), s = A.useRef(null), i = ze(t, s), [a, o] = A.useState(null), { trigger: u, onClose: c } = n, l = s.current, { onPointerInTransitChange: h } = r, m = A.useCallback(() => {
    o(null), h(!1);
  }, [h]), p = A.useCallback(
    (E, g) => {
      const _ = E.currentTarget, b = { x: E.clientX, y: E.clientY }, T = Cw(b, _.getBoundingClientRect()), C = Sw(b, T), R = Iw(g.getBoundingClientRect()), D = vw([...C, ...R]);
      o(D), h(!0);
    },
    [h]
  );
  return A.useEffect(() => () => m(), [m]), A.useEffect(() => {
    if (u && l) {
      const E = (_) => p(_, l), g = (_) => p(_, u);
      return u.addEventListener("pointerleave", E), l.addEventListener("pointerleave", g), () => {
        u.removeEventListener("pointerleave", E), l.removeEventListener("pointerleave", g);
      };
    }
  }, [u, l, p, m]), A.useEffect(() => {
    if (a) {
      const E = (g) => {
        const _ = g.target, b = { x: g.clientX, y: g.clientY }, T = u?.contains(_) || l?.contains(_), C = !ww(b, a);
        T ? m() : C && (m(), c());
      };
      return document.addEventListener("pointermove", E), () => document.removeEventListener("pointermove", E);
    }
  }, [u, l, a, c, m]), /* @__PURE__ */ d.jsx(W0, { ...e, ref: i });
}), [Aw, yw] = Ao(li, { isInside: !1 }), xw = /* @__PURE__ */ mC("TooltipContent"), W0 = A.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": s,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...o
    } = e, u = Ii(cs, n), c = yo(n), { onClose: l } = u;
    return A.useEffect(() => (document.addEventListener(fc, l), () => document.removeEventListener(fc, l)), [l]), A.useEffect(() => {
      if (u.trigger) {
        const h = (m) => {
          m.target?.contains(u.trigger) && l();
        };
        return window.addEventListener("scroll", h, { capture: !0 }), () => window.removeEventListener("scroll", h, { capture: !0 });
      }
    }, [u.trigger, l]), /* @__PURE__ */ d.jsx(
      yi,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (h) => h.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ d.jsxs(
          hl,
          {
            "data-state": u.stateAttribute,
            ...c,
            ...o,
            ref: t,
            style: {
              ...o.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ d.jsx(xw, { children: r }),
              /* @__PURE__ */ d.jsx(Aw, { scope: n, isInside: !0, children: /* @__PURE__ */ d.jsx(yC, { id: u.contentId, role: "tooltip", children: s || r }) })
            ]
          }
        )
      }
    );
  }
);
G0.displayName = cs;
var q0 = "TooltipArrow", K0 = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, s = yo(n);
    return yw(
      q0,
      n
    ).isInside ? null : /* @__PURE__ */ d.jsx(fl, { ...s, ...r, ref: t });
  }
);
K0.displayName = q0;
function Cw(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), s = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, s, i)) {
    case i:
      return "left";
    case s:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Sw(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function Iw(e) {
  const { top: t, right: n, bottom: r, left: s } = e;
  return [
    { x: s, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: s, y: r }
  ];
}
function ww(e, t) {
  const { x: n, y: r } = e;
  let s = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const o = t[i], u = t[a], c = o.x, l = o.y, h = u.x, m = u.y;
    l > r != m > r && n < (h - c) * (r - l) / (m - l) + c && (s = !s);
  }
  return s;
}
function vw(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Nw(t);
}
function Nw(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (s.y - a.y) >= (i.y - a.y) * (s.x - a.x)) t.pop();
      else break;
    }
    t.push(s);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const s = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (s.y - a.y) >= (i.y - a.y) * (s.x - a.x)) n.pop();
      else break;
    }
    n.push(s);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var kw = $0, Rw = z0, Pw = V0, Ow = Y0, Dw = G0, Lw = K0;
const Mw = () => {
  const { disabled: e, next: t } = Hx();
  return e ? null : t;
}, Hw = On("BranchPickerPrimitive.Next", Mw), Bw = () => {
  const { disabled: e, previous: t } = Bx();
  return e ? null : t;
}, Uw = On("BranchPickerPrimitive.Previous", Bw), Fw = () => J((t) => t.message.branchCount), Q0 = () => {
  const e = Fw();
  return d.jsx(d.Fragment, { children: e });
};
Q0.displayName = "BranchPickerPrimitive.Count";
const jw = () => J((t) => t.message.branchNumber), X0 = () => {
  const e = jw();
  return d.jsx(d.Fragment, { children: e });
};
X0.displayName = "BranchPickerPrimitive.Number";
const $w = (e) => J((t) => {
  const { role: n, attachments: r, parts: s, branchCount: i, isLast: a, speech: o, isCopied: u, isHovering: c } = t.message;
  return !(e.hasBranches === !0 && i < 2 || e.user && n !== "user" || e.assistant && n !== "assistant" || e.system && n !== "system" || e.lastOrHover === !0 && !c && !a || e.last !== void 0 && e.last !== a || e.copied === !0 && !u || e.copied === !1 && u || e.speaking === !0 && o == null || e.speaking === !1 && o != null || e.hasAttachments === !0 && (n !== "user" || !r?.length) || e.hasAttachments === !1 && n === "user" && r?.length || e.hasContent === !0 && s.length === 0 || e.hasContent === !1 && s.length > 0 || e.submittedFeedback !== void 0 && (t.message.metadata.submittedFeedback?.type ?? null) !== e.submittedFeedback);
}), Jt = ({ children: e, ...t }) => $w(t) ? e : null;
Jt.displayName = "MessagePrimitive.If";
const J0 = Je(({ hideWhenSingleBranch: e, ...t }, n) => d.jsx(Jt, { hasBranches: e ? !0 : void 0, children: d.jsx(Rt.div, { ...t, ref: n }) }));
J0.displayName = "BranchPickerPrimitive.Root";
const Z0 = () => {
  const { disabled: e, send: t } = Rx(), n = ne(() => t(), [t]);
  return e ? null : n;
}, eE = On("ComposerPrimitive.Send", Z0), bl = Je(({ onSubmit: e, ...t }, n) => {
  const r = Z0(), s = (i) => {
    i.preventDefault(), r && r();
  };
  return d.jsx(Rt.form, { ...t, ref: n, onSubmit: be(e, s) });
});
bl.displayName = "ComposerPrimitive.Root";
function mc() {
  return mc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mc.apply(null, arguments);
}
function zw(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var Vw = rs, Yw = function(t) {
  var n = Ze.useRef(t);
  return Vw(function() {
    n.current = t;
  }), n;
}, Dh = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, Gw = function(t, n) {
  var r = Ze.useRef();
  return Ze.useCallback(function(s) {
    t.current = s, r.current && Dh(r.current, null), r.current = n, n && Dh(n, s);
  }, [n]);
}, Lh = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, Ww = function(t) {
  Object.keys(Lh).forEach(function(n) {
    t.style.setProperty(n, Lh[n], "important");
  });
}, Mh = Ww, Ct = null, Hh = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function qw(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), Ct || (Ct = document.createElement("textarea"), Ct.setAttribute("tabindex", "-1"), Ct.setAttribute("aria-hidden", "true"), Mh(Ct)), Ct.parentNode === null && document.body.appendChild(Ct);
  var s = e.paddingSize, i = e.borderSize, a = e.sizingStyle, o = a.boxSizing;
  Object.keys(a).forEach(function(m) {
    var p = m;
    Ct.style[p] = a[p];
  }), Mh(Ct), Ct.value = t;
  var u = Hh(Ct, e);
  Ct.value = t, u = Hh(Ct, e), Ct.value = "x";
  var c = Ct.scrollHeight - s, l = c * n;
  o === "border-box" && (l = l + s + i), u = Math.max(l, u);
  var h = c * r;
  return o === "border-box" && (h = h + s + i), u = Math.min(h, u), [u, c];
}
var Bh = function() {
}, Kw = function(t, n) {
  return t.reduce(function(r, s) {
    return r[s] = n[s], r;
  }, {});
}, Qw = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], Xw = !!document.documentElement.currentStyle, Jw = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = Kw(Qw, n), s = r.boxSizing;
  if (s === "")
    return null;
  Xw && s === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var i = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), a = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: i,
    borderSize: a
  };
}, Zw = Jw;
function _l(e, t, n) {
  var r = Yw(n);
  A.useLayoutEffect(function() {
    var s = function(a) {
      return r.current(a);
    };
    if (e)
      return e.addEventListener(t, s), function() {
        return e.removeEventListener(t, s);
      };
  }, []);
}
var ev = function(t, n) {
  _l(document.body, "reset", function(r) {
    t.current.form === r.target && n(r);
  });
}, tv = function(t) {
  _l(window, "resize", t);
}, nv = function(t) {
  _l(document.fonts, "loadingdone", t);
}, rv = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], sv = function(t, n) {
  var r = t.cacheMeasurements, s = t.maxRows, i = t.minRows, a = t.onChange, o = a === void 0 ? Bh : a, u = t.onHeightChange, c = u === void 0 ? Bh : u, l = zw(t, rv), h = l.value !== void 0, m = A.useRef(null), p = Gw(m, n), E = A.useRef(0), g = A.useRef(), _ = function() {
    var C = m.current, R = r && g.current ? g.current : Zw(C);
    if (R) {
      g.current = R;
      var D = qw(R, C.value || C.placeholder || "x", i, s), I = D[0], O = D[1];
      E.current !== I && (E.current = I, C.style.setProperty("height", I + "px", "important"), c(I, {
        rowHeight: O
      }));
    }
  }, b = function(C) {
    h || _(), o(C);
  };
  return A.useLayoutEffect(_), ev(m, function() {
    if (!h) {
      var T = m.current.value;
      requestAnimationFrame(function() {
        var C = m.current;
        C && T !== C.value && _();
      });
    }
  }), tv(_), nv(_), /* @__PURE__ */ A.createElement("textarea", mc({}, l, {
    onChange: b,
    ref: p
  }));
}, iv = /* @__PURE__ */ A.forwardRef(sv);
const tE = (e) => {
  const t = jt(e), n = ai((r) => r.onScrollToBottom);
  xe(() => n(t), [n, t]);
}, av = _t(null), ov = () => ft(av), uv = _t(null), cv = () => ft(uv), Tl = Je(({ autoFocus: e = !1, asChild: t, disabled: n, onChange: r, onKeyDown: s, onPaste: i, onSelect: a, submitOnEnter: o, submitMode: u, cancelOnEscape: c = !0, unstable_focusOnRunStart: l = !0, unstable_focusOnScrollToBottom: h = !0, unstable_focusOnThreadSwitched: m = !0, addAttachmentOnPaste: p = !0, ...E }, g) => {
  const _ = Re(), b = ov(), T = cv(), C = u ?? (o === !1 ? "none" : "enter"), R = J((F) => F.composer.isEditing ? F.composer.text : ""), D = t ? ug : iv, I = J((F) => F.thread.isDisabled || F.composer.dictation?.inputDisabled) || n, O = Ke(null), U = ze(g, O);
  ig((F) => {
    if (!O.current?.contains(F.target))
      return;
    if (b?.open) {
      b.handleKeyDown(F);
      return;
    }
    if (!c)
      return;
    const M = _.composer();
    M.getState().canCancel && (M.cancel(), F.preventDefault());
  });
  const q = (F) => {
    if (!I && !F.nativeEvent.isComposing && !b?.handleKeyDown(F) && F.key === "Enter") {
      const M = _.thread().getState(), H = M.capabilities.queue;
      if (F.shiftKey && (F.ctrlKey || F.metaKey) && H && C !== "none" && !_.composer().getState().isEmpty) {
        F.preventDefault(), _.composer().send({ steer: !0 });
        return;
      }
      if (F.shiftKey || M.isRunning && !H)
        return;
      let B = !1;
      C === "ctrlEnter" ? B = F.ctrlKey || F.metaKey : C === "enter" && (B = !0), B && (F.preventDefault(), O.current?.closest("form")?.requestSubmit());
    }
  }, P = async (F) => {
    if (!p)
      return;
    const M = _.thread().getState().capabilities, H = Array.from(F.clipboardData?.files || []);
    if (M.attachments && H.length > 0)
      try {
        F.preventDefault(), await Promise.all(H.map((B) => _.composer().addAttachment(B)));
      } catch (B) {
        console.error("Error adding attachment:", B);
      }
  }, z = e && !I, G = ne(() => {
    const F = O.current;
    !F || !z || (F.focus({ preventScroll: !0 }), F.setSelectionRange(F.value.length, F.value.length));
  }, [z]);
  return xe(() => G(), [G]), tE(() => {
    _.composer().getState().type === "thread" && h && G();
  }), xe(() => {
    if (!(_.composer().getState().type !== "thread" || !l))
      return _.on("thread.runStart", G);
  }, [l, G, _]), xe(() => {
    if (!(_.composer().getState().type !== "thread" || !m))
      return _.on("threadListItem.switchedTo", G);
  }, [m, G, _]), d.jsx(D, { name: "input", value: R, ...E, ref: U, disabled: I, onChange: be(r, (F) => {
    _.composer().getState().isEditing && (p1(() => {
      _.composer().setText(F.target.value);
    }), T?.setCursorPosition(F.target.selectionStart ?? F.target.value.length));
  }), onKeyDown: be(s, q), onSelect: be(a, (F) => {
    const M = F.target;
    T?.setCursorPosition(M.selectionStart ?? M.value.length);
  }), onPaste: be(i, P) });
});
Tl.displayName = "ComposerPrimitive.Input";
const lv = () => {
  const { disabled: e, cancel: t } = Px();
  return e ? null : t;
}, nE = On("ComposerPrimitive.Cancel", lv), rE = () => J((t) => {
  if (t.part.type !== "text" && t.part.type !== "reasoning")
    throw new Error("MessagePartText can only be used inside text or reasoning message parts.");
  return t.part;
}), sE = _t(null), dv = (e) => ({ useSmoothStatus: as(() => e) }), hv = ({ children: e }) => {
  const t = iE({ optional: !0 }), n = Re(), [r] = de(() => dv(n.part().getState().status));
  return t ? e : d.jsx(sE.Provider, { value: r, children: e });
}, fv = (e) => {
  const t = Je((n, r) => d.jsx(hv, { children: d.jsx(e, { ...n, ref: r }) }));
  return t.displayName = e.displayName, t;
};
function iE(e) {
  const t = ft(sE);
  if (!e?.optional && !t)
    throw new Error("This component must be used within a SmoothContextProvider.");
  return t;
}
const { useSmoothStatus: pv, useSmoothStatusStore: mv } = Zm(iE, "useSmoothStatus");
class gv {
  constructor(t, n) {
    k(this, "currentText");
    k(this, "setText");
    k(this, "animationFrameId", null);
    k(this, "lastUpdateTime", Date.now());
    k(this, "targetText", "");
    k(this, "animate", () => {
      const t = Date.now();
      let r = t - this.lastUpdateTime;
      const s = this.targetText.length - this.currentText.length, i = Math.min(5, 250 / s);
      let a = 0;
      for (; r >= i && a < s; )
        a++, r -= i;
      a !== s ? this.animationFrameId = requestAnimationFrame(this.animate) : this.animationFrameId = null, a !== 0 && (this.currentText = this.targetText.slice(0, this.currentText.length + a), this.lastUpdateTime = t - r, this.setText(this.currentText));
    });
    this.currentText = t, this.setText = n;
  }
  start() {
    this.animationFrameId === null && (this.lastUpdateTime = Date.now(), this.animate());
  }
  stop() {
    this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null);
  }
}
const fu = Object.freeze({
  type: "running"
}), aE = (e, t = !1) => {
  const { text: n } = e, r = J((l) => l.message.id), s = Ke(r), [i, a] = de(e.status.type === "running" ? "" : n), o = mv({ optional: !0 }), u = jt((l) => {
    if (a(l), o) {
      const h = i !== l || e.status.type === "running" ? fu : e.status;
      oi(o).setState(h, !0);
    }
  });
  xe(() => {
    if (o) {
      const l = t && (i !== n || e.status.type === "running") ? fu : e.status;
      oi(o).setState(l, !0);
    }
  }, [o, t, n, i, e.status]);
  const [c] = de(new gv(i, u));
  return xe(() => {
    if (!t) {
      c.stop();
      return;
    }
    if (s.current !== r || !n.startsWith(c.targetText)) {
      s.current = r, e.status.type === "running" ? (u(""), c.currentText = "", c.targetText = n, c.start()) : (u(n), c.currentText = n, c.targetText = n, c.stop());
      return;
    }
    c.targetText = n, c.start();
  }, [u, c, r, t, n, e.status.type]), xe(() => () => {
    c.stop();
  }, [c]), ie(() => t ? {
    type: "text",
    text: i,
    status: n === i ? e.status : fu
  } : e, [t, i, e, n]);
}, oE = Je(({ smooth: e = !0, component: t = "span", ...n }, r) => {
  const { text: s, status: i } = aE(rE(), e);
  return d.jsx(t, { "data-status": i.type, ...n, ref: r, children: s });
});
oE.displayName = "MessagePartPrimitive.Text";
const Ev = () => J((t) => {
  if (t.part.type !== "image")
    throw new Error("MessagePartImage can only be used inside image message parts.");
  return t.part;
}), uE = Je((e, t) => {
  const { image: n } = Ev();
  return d.jsx(Rt.img, { src: n, ...e, ref: t });
});
uE.displayName = "MessagePartPrimitive.Image";
const cE = ({ children: e }) => J((n) => n.part.status.type === "running") ? e : null;
cE.displayName = "MessagePartPrimitive.InProgress";
const wi = (e) => {
  const t = Ke(void 0);
  return ne((r) => {
    t.current && t.current(), r && (t.current = e(r));
  }, [e]);
}, lE = (e, t) => {
  const n = ne((r) => {
    if (!e)
      return;
    const s = e(), i = () => {
      const o = t ? t(r) : r.offsetHeight;
      s.setHeight(o);
    }, a = new ResizeObserver(i);
    return a.observe(r), i(), () => {
      a.disconnect(), s.unregister();
    };
  }, [e, t]);
  return wi(n);
}, Uh = _t(!1), Fh = (e, t) => {
  const n = e.match(/^([\d.]+)(em|px|rem)$/);
  if (!n)
    return 0;
  const r = parseFloat(n[1]), s = n[2];
  if (s === "px")
    return r;
  if (s === "em") {
    const i = parseFloat(getComputedStyle(t).fontSize) || 16;
    return r * i;
  }
  if (s === "rem") {
    const i = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return r * i;
  }
  return 0;
}, dE = ({ children: e, fillClampThreshold: t = "10em", fillClampOffset: n = "6em" }) => {
  const r = J(
    // only add slack to the last assistant message following a user message (valid turn)
    (u) => u.message.isLast && u.message.role === "assistant" && u.message.index >= 1 && u.thread.messages.at(u.message.index - 1)?.role === "user"
  ), s = io({ optional: !0 }), i = ft(Uh), a = ne((u) => {
    if (!s || i)
      return;
    const c = () => {
      const l = s.getState();
      if (l.turnAnchor === "top" && r) {
        const { viewport: h, inset: m, userMessage: p } = l.height, E = Fh(t, u), g = Fh(n, u), _ = p <= E ? p : g, b = Math.max(0, h - m - _);
        u.style.minHeight = `${b}px`, u.style.flexShrink = "0", u.style.transition = "min-height 0s";
      } else
        u.style.minHeight = "", u.style.flexShrink = "", u.style.transition = "";
    };
    return c(), s.subscribe(c);
  }, [
    s,
    r,
    i,
    t,
    n
  ]), o = wi(a);
  return d.jsx(Uh.Provider, { value: !0, children: d.jsx(ug, { ref: o, children: e }) });
};
dE.displayName = "ThreadPrimitive.ViewportSlack";
const bv = () => {
  const e = Re(), t = J(() => e.message()), n = ne((r) => {
    const s = () => {
      t.setIsHovering(!0);
    }, i = () => {
      t.setIsHovering(!1);
    };
    return r.addEventListener("mouseenter", s), r.addEventListener("mouseleave", i), r.matches(":hover") && queueMicrotask(() => t.setIsHovering(!0)), () => {
      r.removeEventListener("mouseenter", s), r.removeEventListener("mouseleave", i), t.setIsHovering(!1);
    };
  }, [t]);
  return wi(n);
}, _v = () => {
  const e = ai((s) => s.turnAnchor), t = ai((s) => s.registerUserMessageHeight), n = J((s) => e === "top" && s.message.role === "user" && s.message.index === s.thread.messages.length - 2 && s.thread.messages.at(-1)?.role === "assistant"), r = ne((s) => s.offsetHeight, []);
  return lE(n ? t : null, r);
}, xo = Je((e, t) => {
  const n = bv(), r = _v(), s = ze(t, n, r), i = J((a) => a.message.id);
  return d.jsx(dE, { children: d.jsx(Rt.div, { ...e, ref: s, "data-message-id": i }) });
});
xo.displayName = "MessagePrimitive.Root";
const pu = {
  ...gt,
  Text: () => d.jsxs("p", { style: { whiteSpace: "pre-line" }, children: [d.jsx(oE, {}), d.jsx(cE, { children: d.jsx("span", { style: { fontFamily: "revert" }, children: " ●" }) })] }),
  Image: () => d.jsx(uE, {})
}, Co = (e) => {
  if ("children" in e)
    return d.jsx(tc, { children: e.children });
  const { components: t, ...n } = e, r = t ? {
    Text: t.Text ?? pu.Text,
    Image: t.Image ?? pu.Image,
    Reasoning: t.Reasoning ?? gt.Reasoning,
    Source: t.Source ?? gt.Source,
    File: t.File ?? gt.File,
    Unstable_Audio: t.Unstable_Audio ?? gt.Unstable_Audio,
    ..."ChainOfThought" in t ? { ChainOfThought: t.ChainOfThought } : {
      tools: t.tools,
      data: t.data,
      ToolGroup: t.ToolGroup ?? gt.ToolGroup,
      ReasoningGroup: t.ReasoningGroup ?? gt.ReasoningGroup
    },
    Empty: t.Empty,
    Quote: t.Quote
  } : pu;
  return d.jsx(tc, { components: r, ...n });
};
Co.displayName = "MessagePrimitive.Parts";
const Al = ({ children: e }) => $x() !== void 0 ? e : null;
Al.displayName = "MessagePrimitive.Error";
const yl = Je((e, t) => d.jsx(Rt.div, { ...e, ref: t }));
yl.displayName = "ThreadPrimitive.Root";
const hE = ({ children: e }) => J((n) => n.thread.isEmpty) ? e : null;
hE.displayName = "ThreadPrimitive.Empty";
const Tv = (e) => J((t) => !(e.empty === !0 && !t.thread.isEmpty || e.empty === !1 && t.thread.isEmpty || e.running === !0 && !t.thread.isRunning || e.running === !1 && t.thread.isRunning || e.disabled === !0 && !t.thread.isDisabled || e.disabled === !1 && t.thread.isDisabled)), di = ({ children: e, ...t }) => Tv(t) ? e : null;
di.displayName = "ThreadPrimitive.If";
const Av = (e) => {
  const t = jt(e), n = ne((r) => {
    const s = new ResizeObserver(() => {
      t();
    }), i = new MutationObserver((a) => {
      a.some((u) => u.type !== "attributes" || u.attributeName !== "style") && t();
    });
    return s.observe(r), i.observe(r, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      characterData: !0
    }), () => {
      s.disconnect(), i.disconnect();
    };
  }, [t]);
  return wi(n);
}, yv = ({ autoScroll: e, scrollToBottomOnRunStart: t = !0, scrollToBottomOnInitialize: n = !0, scrollToBottomOnThreadSwitch: r = !0 }) => {
  const s = Ke(null), i = io();
  e === void 0 && (e = i.getState().turnAnchor !== "top");
  const a = Ke(0), o = Ke(null), u = ne((p) => {
    const E = s.current;
    E && (o.current = p, E.scrollTo({ top: E.scrollHeight, behavior: p }));
  }, []), c = () => {
    const p = s.current;
    if (!p)
      return;
    const E = i.getState().isAtBottom, g = Math.abs(p.scrollHeight - p.scrollTop - p.clientHeight) < 1 || p.scrollHeight <= p.clientHeight;
    !g && a.current < p.scrollTop || (g && (o.current = null), (g || o.current === null) && g !== E && oi(i).setState({
      isAtBottom: g
    })), a.current = p.scrollTop;
  }, l = Av(() => {
    const p = o.current;
    p ? u(p) : e && i.getState().isAtBottom && u("instant"), c();
  }), h = wi((p) => (p.addEventListener("scroll", c), () => {
    p.removeEventListener("scroll", c);
  }));
  return tE(({ behavior: p }) => {
    u(p);
  }), qo("thread.runStart", () => {
    t && (o.current = "auto", requestAnimationFrame(() => {
      u("auto");
    }));
  }), qo("thread.initialize", () => {
    n && (o.current = "instant", requestAnimationFrame(() => {
      u("instant");
    }));
  }), qo("threadListItem.switchedTo", () => {
    r && (o.current = "instant", requestAnimationFrame(() => {
      u("instant");
    }));
  }), ze(l, h, s);
}, xv = () => {
  const e = ai((n) => n.registerViewport), t = ne((n) => n.clientHeight, []);
  return lE(e, t);
}, fE = Je(({ autoScroll: e, scrollToBottomOnRunStart: t, scrollToBottomOnInitialize: n, scrollToBottomOnThreadSwitch: r, children: s, ...i }, a) => {
  const o = yv({
    autoScroll: e,
    scrollToBottomOnRunStart: t,
    scrollToBottomOnInitialize: n,
    scrollToBottomOnThreadSwitch: r
  }), u = xv(), c = ze(a, o, u);
  return d.jsx(Rt.div, { ...i, ref: c, children: s });
});
fE.displayName = "ThreadPrimitive.ViewportScrollable";
const xl = Je(({ turnAnchor: e, ...t }, n) => d.jsx(tg, { options: { turnAnchor: e }, children: d.jsx(fE, { ...t, ref: n }) }));
xl.displayName = "ThreadPrimitive.Viewport";
const Cv = ({ behavior: e } = {}) => {
  const t = ai((s) => s.isAtBottom), n = io(), r = ne(() => {
    n.getState().scrollToBottom({ behavior: e });
  }, [n, e]);
  return t ? null : r;
}, pE = On("ThreadPrimitive.ScrollToBottom", Cv, ["behavior"]), Sv = ({ prompt: e, send: t, clearComposer: n, autoSend: r, method: s }) => {
  const i = t ?? r ?? !1, { disabled: a, trigger: o } = Ux({
    prompt: e,
    send: i,
    clearComposer: n
  });
  return a ? null : o;
}, Iv = On("ThreadPrimitive.Suggestion", Sv, ["prompt", "send", "clearComposer", "autoSend", "method"]), mE = Je(({ onClick: e, disabled: t, ...n }, r) => {
  const s = J((a) => a.threads.newThreadId === a.threads.mainThreadId), { switchToNewThread: i } = jx();
  return d.jsx(Rt.button, { type: "button", ...s ? { "data-active": "true", "aria-current": "true" } : null, ...n, ref: r, disabled: t, onClick: be(e, i) });
});
mE.displayName = "ThreadListPrimitive.New";
const gE = Je((e, t) => d.jsx(Rt.div, { ...e, ref: t }));
gE.displayName = "ThreadListPrimitive.Root";
const EE = Je((e, t) => {
  const n = J((r) => r.threads.mainThreadId === r.threadListItem.id);
  return d.jsx(Rt.div, { ...n ? { "data-active": "true", "aria-current": "true" } : null, ...e, ref: t });
});
EE.displayName = "ThreadListItemPrimitive.Root";
const wv = () => {
  const { switchTo: e } = Fx();
  return e;
}, vv = On("ThreadListItemPrimitive.Trigger", wv), Nv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AssistantRuntimeImpl: qc,
  BaseAssistantRuntimeCore: Gc,
  CompositeContextProvider: zc,
  DefaultThreadComposerRuntimeCore: Nm,
  MessageRepository: wm,
  ThreadRuntimeImpl: Lm,
  fromThreadMessageLike: Ai,
  generateId: Kn,
  getAutoStatus: Im,
  useSmooth: aE,
  useSmoothStatus: pv,
  withSmoothContextProvider: fv
}, Symbol.toStringTag, { value: "Module" }));
const kv = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Rv = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), jh = (e) => {
  const t = Rv(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, bE = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), Pv = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
var Ov = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const Dv = Je(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: s = "",
    children: i,
    iconNode: a,
    ...o
  }, u) => Gu(
    "svg",
    {
      ref: u,
      ...Ov,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: bE("lucide", s),
      ...!i && !Pv(o) && { "aria-hidden": "true" },
      ...o
    },
    [
      ...a.map(([c, l]) => Gu(c, l)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
const st = (e, t) => {
  const n = Je(
    ({ className: r, ...s }, i) => Gu(Dv, {
      ref: i,
      iconNode: t,
      className: bE(
        `lucide-${kv(jh(e))}`,
        `lucide-${e}`,
        r
      ),
      ...s
    })
  );
  return n.displayName = jh(e), n;
};
const Lv = [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
], Mv = st("align-justify", Lv);
const Hv = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], _E = st("arrow-down", Hv);
const Bv = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], So = st("check", Bv);
const Uv = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], TE = st("chevron-down", Uv);
const Fv = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], AE = st("chevron-left", Fv);
const jv = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], $v = st("chevron-right", jv);
const zv = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Vv = st("chevron-up", zv);
const Yv = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], $h = st("circle-check", Yv);
const Gv = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Cl = st("copy", Gv);
const Wv = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], qv = st("ellipsis-vertical", Wv);
const Kv = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], Qv = st("external-link", Kv);
const Xv = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], Jv = st("globe", Xv);
const Zv = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], eN = st("link-2", Zv);
const tN = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], nN = st("maximize-2", tN);
const rN = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], sN = st("plus", rN);
const iN = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], yE = st("refresh-cw", iN);
const aN = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], oN = st("send", aN);
const uN = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], cN = st("thumbs-down", uN);
const lN = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], dN = st("thumbs-up", lN);
const hN = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], xE = st("x", hN), fN = ({
  isOpen: e,
  isDeleting: t,
  onCancel: n,
  onConfirm: r
}) => {
  const s = ne(
    (o) => {
      o.stopPropagation(), n();
    },
    [n]
  ), i = ne(
    (o) => {
      o.stopPropagation(), r();
    },
    [r]
  ), a = ne((o) => {
    o.stopPropagation();
  }, []);
  return {
    isOpen: e,
    isDeleting: t,
    onOverlayClick: t ? void 0 : s,
    onContentClick: a,
    onCancelClick: s,
    onConfirmClick: i
  };
};
function CE(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (n = CE(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function SE() {
  for (var e, t, n = 0, r = "", s = arguments.length; n < s; n++) (e = arguments[n]) && (t = CE(e)) && (r && (r += " "), r += t);
  return r;
}
const zh = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Vh = SE, pN = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return Vh(e, n?.class, n?.className);
  const { variants: s, defaultVariants: i } = t, a = Object.keys(s).map((c) => {
    const l = n?.[c], h = i?.[c];
    if (l === null) return null;
    const m = zh(l) || zh(h);
    return s[c][m];
  }), o = n && Object.entries(n).reduce((c, l) => {
    let [h, m] = l;
    return m === void 0 || (c[h] = m), c;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, l) => {
    let { class: h, className: m, ...p } = l;
    return Object.entries(p).every((E) => {
      let [g, _] = E;
      return Array.isArray(_) ? _.includes({
        ...i,
        ...o
      }[g]) : {
        ...i,
        ...o
      }[g] === _;
    }) ? [
      ...c,
      h,
      m
    ] : c;
  }, []);
  return Vh(e, a, u, n?.class, n?.className);
}, mN = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, gN = (e, t) => ({
  classGroupId: e,
  validator: t
}), IE = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), Ha = "-", Yh = [], EN = "arbitrary..", bN = (e) => {
  const t = TN(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return _N(a);
      const o = a.split(Ha), u = o[0] === "" && o.length > 1 ? 1 : 0;
      return wE(o, u, t);
    },
    getConflictingClassGroupIds: (a, o) => {
      if (o) {
        const u = r[a], c = n[a];
        return u ? c ? mN(c, u) : u : c || Yh;
      }
      return n[a] || Yh;
    }
  };
}, wE = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const s = e[t], i = n.nextPart.get(s);
  if (i) {
    const c = wE(e, t + 1, i);
    if (c) return c;
  }
  const a = n.validators;
  if (a === null)
    return;
  const o = t === 0 ? e.join(Ha) : e.slice(t).join(Ha), u = a.length;
  for (let c = 0; c < u; c++) {
    const l = a[c];
    if (l.validator(o))
      return l.classGroupId;
  }
}, _N = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? EN + r : void 0;
})(), TN = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return AN(n, t);
}, AN = (e, t) => {
  const n = IE();
  for (const r in e) {
    const s = e[r];
    Sl(s, n, r, t);
  }
  return n;
}, Sl = (e, t, n, r) => {
  const s = e.length;
  for (let i = 0; i < s; i++) {
    const a = e[i];
    yN(a, t, n, r);
  }
}, yN = (e, t, n, r) => {
  if (typeof e == "string") {
    xN(e, t, n);
    return;
  }
  if (typeof e == "function") {
    CN(e, t, n, r);
    return;
  }
  SN(e, t, n, r);
}, xN = (e, t, n) => {
  const r = e === "" ? t : vE(t, e);
  r.classGroupId = n;
}, CN = (e, t, n, r) => {
  if (IN(e)) {
    Sl(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(gN(n, e));
}, SN = (e, t, n, r) => {
  const s = Object.entries(e), i = s.length;
  for (let a = 0; a < i; a++) {
    const [o, u] = s[a];
    Sl(u, vE(t, o), n, r);
  }
}, vE = (e, t) => {
  let n = e;
  const r = t.split(Ha), s = r.length;
  for (let i = 0; i < s; i++) {
    const a = r[i];
    let o = n.nextPart.get(a);
    o || (o = IE(), n.nextPart.set(a, o)), n = o;
  }
  return n;
}, IN = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, wN = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const s = (i, a) => {
    n[i] = a, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(i) {
      let a = n[i];
      if (a !== void 0)
        return a;
      if ((a = r[i]) !== void 0)
        return s(i, a), a;
    },
    set(i, a) {
      i in n ? n[i] = a : s(i, a);
    }
  };
}, gc = "!", Gh = ":", vN = [], Wh = (e, t, n, r, s) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: s
}), NN = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (s) => {
    const i = [];
    let a = 0, o = 0, u = 0, c;
    const l = s.length;
    for (let g = 0; g < l; g++) {
      const _ = s[g];
      if (a === 0 && o === 0) {
        if (_ === Gh) {
          i.push(s.slice(u, g)), u = g + 1;
          continue;
        }
        if (_ === "/") {
          c = g;
          continue;
        }
      }
      _ === "[" ? a++ : _ === "]" ? a-- : _ === "(" ? o++ : _ === ")" && o--;
    }
    const h = i.length === 0 ? s : s.slice(u);
    let m = h, p = !1;
    h.endsWith(gc) ? (m = h.slice(0, -1), p = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      h.startsWith(gc) && (m = h.slice(1), p = !0)
    );
    const E = c && c > u ? c - u : void 0;
    return Wh(i, p, m, E);
  };
  if (t) {
    const s = t + Gh, i = r;
    r = (a) => a.startsWith(s) ? i(a.slice(s.length)) : Wh(vN, !1, a, void 0, !0);
  }
  if (n) {
    const s = r;
    r = (i) => n({
      className: i,
      parseClassName: s
    });
  }
  return r;
}, kN = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let s = [];
    for (let i = 0; i < n.length; i++) {
      const a = n[i], o = a[0] === "[", u = t.has(a);
      o || u ? (s.length > 0 && (s.sort(), r.push(...s), s = []), r.push(a)) : s.push(a);
    }
    return s.length > 0 && (s.sort(), r.push(...s)), r;
  };
}, RN = (e) => ({
  cache: wN(e.cacheSize),
  parseClassName: NN(e),
  sortModifiers: kN(e),
  ...bN(e)
}), PN = /\s+/, ON = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: s,
    sortModifiers: i
  } = t, a = [], o = e.trim().split(PN);
  let u = "";
  for (let c = o.length - 1; c >= 0; c -= 1) {
    const l = o[c], {
      isExternal: h,
      modifiers: m,
      hasImportantModifier: p,
      baseClassName: E,
      maybePostfixModifierPosition: g
    } = n(l);
    if (h) {
      u = l + (u.length > 0 ? " " + u : u);
      continue;
    }
    let _ = !!g, b = r(_ ? E.substring(0, g) : E);
    if (!b) {
      if (!_) {
        u = l + (u.length > 0 ? " " + u : u);
        continue;
      }
      if (b = r(E), !b) {
        u = l + (u.length > 0 ? " " + u : u);
        continue;
      }
      _ = !1;
    }
    const T = m.length === 0 ? "" : m.length === 1 ? m[0] : i(m).join(":"), C = p ? T + gc : T, R = C + b;
    if (a.indexOf(R) > -1)
      continue;
    a.push(R);
    const D = s(b, _);
    for (let I = 0; I < D.length; ++I) {
      const O = D[I];
      a.push(C + O);
    }
    u = l + (u.length > 0 ? " " + u : u);
  }
  return u;
}, DN = (...e) => {
  let t = 0, n, r, s = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = NE(n)) && (s && (s += " "), s += r);
  return s;
}, NE = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = NE(e[r])) && (n && (n += " "), n += t);
  return n;
}, LN = (e, ...t) => {
  let n, r, s, i;
  const a = (u) => {
    const c = t.reduce((l, h) => h(l), e());
    return n = RN(c), r = n.cache.get, s = n.cache.set, i = o, o(u);
  }, o = (u) => {
    const c = r(u);
    if (c)
      return c;
    const l = ON(u, n);
    return s(u, l), l;
  };
  return i = a, (...u) => i(DN(...u));
}, MN = [], it = (e) => {
  const t = (n) => n[e] || MN;
  return t.isThemeGetter = !0, t;
}, kE = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, RE = /^\((?:(\w[\w-]*):)?(.+)\)$/i, HN = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, BN = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, UN = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, FN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, jN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $N = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Mn = (e) => HN.test(e), we = (e) => !!e && !Number.isNaN(Number(e)), Hn = (e) => !!e && Number.isInteger(Number(e)), mu = (e) => e.endsWith("%") && we(e.slice(0, -1)), xn = (e) => BN.test(e), PE = () => !0, zN = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  UN.test(e) && !FN.test(e)
), Il = () => !1, VN = (e) => jN.test(e), YN = (e) => $N.test(e), GN = (e) => !ae(e) && !oe(e), WN = (e) => rr(e, LE, Il), ae = (e) => kE.test(e), hr = (e) => rr(e, ME, zN), qh = (e) => rr(e, tk, we), qN = (e) => rr(e, BE, PE), KN = (e) => rr(e, HE, Il), Kh = (e) => rr(e, OE, Il), QN = (e) => rr(e, DE, YN), Qi = (e) => rr(e, UE, VN), oe = (e) => RE.test(e), Os = (e) => Dr(e, ME), XN = (e) => Dr(e, HE), Qh = (e) => Dr(e, OE), JN = (e) => Dr(e, LE), ZN = (e) => Dr(e, DE), Xi = (e) => Dr(e, UE, !0), ek = (e) => Dr(e, BE, !0), rr = (e, t, n) => {
  const r = kE.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Dr = (e, t, n = !1) => {
  const r = RE.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, OE = (e) => e === "position" || e === "percentage", DE = (e) => e === "image" || e === "url", LE = (e) => e === "length" || e === "size" || e === "bg-size", ME = (e) => e === "length", tk = (e) => e === "number", HE = (e) => e === "family-name", BE = (e) => e === "number" || e === "weight", UE = (e) => e === "shadow", nk = () => {
  const e = it("color"), t = it("font"), n = it("text"), r = it("font-weight"), s = it("tracking"), i = it("leading"), a = it("breakpoint"), o = it("container"), u = it("spacing"), c = it("radius"), l = it("shadow"), h = it("inset-shadow"), m = it("text-shadow"), p = it("drop-shadow"), E = it("blur"), g = it("perspective"), _ = it("aspect"), b = it("ease"), T = it("animate"), C = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], D = () => [...R(), oe, ae], I = () => ["auto", "hidden", "clip", "visible", "scroll"], O = () => ["auto", "contain", "none"], U = () => [oe, ae, u], q = () => [Mn, "full", "auto", ...U()], P = () => [Hn, "none", "subgrid", oe, ae], z = () => ["auto", {
    span: ["full", Hn, oe, ae]
  }, Hn, oe, ae], G = () => [Hn, "auto", oe, ae], F = () => ["auto", "min", "max", "fr", oe, ae], M = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], H = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], B = () => ["auto", ...U()], Y = () => [Mn, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...U()], $ = () => [Mn, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...U()], Z = () => [Mn, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...U()], y = () => [e, oe, ae], fe = () => [...R(), Qh, Kh, {
    position: [oe, ae]
  }], Ce = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], v = () => ["auto", "cover", "contain", JN, WN, {
    size: [oe, ae]
  }], Se = () => [mu, Os, hr], _e = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    oe,
    ae
  ], pe = () => ["", we, Os, hr], re = () => ["solid", "dashed", "dotted", "double"], Te = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ce = () => [we, mu, Qh, Kh], ue = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    E,
    oe,
    ae
  ], Ae = () => ["none", we, oe, ae], Pe = () => ["none", we, oe, ae], qe = () => [we, oe, ae], mt = () => [Mn, "full", ...U()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [xn],
      breakpoint: [xn],
      color: [PE],
      container: [xn],
      "drop-shadow": [xn],
      ease: ["in", "out", "in-out"],
      font: [GN],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [xn],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [xn],
      shadow: [xn],
      spacing: ["px", we],
      text: [xn],
      "text-shadow": [xn],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Mn, ae, oe, _]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [we, ae, oe, o]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": C()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": C()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: D()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: q()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": q()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": q()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": q(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: q()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": q(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: q()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": q()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": q()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: q()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: q()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: q()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: q()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Hn, "auto", oe, ae]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Mn, "full", "auto", o, ...U()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [we, Mn, "auto", "initial", "none", ae]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", we, oe, ae]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", we, oe, ae]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Hn, "first", "last", "none", oe, ae]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": P()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: z()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": G()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": G()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": P()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: z()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": G()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": G()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": F()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": F()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: U()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": U()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": U()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...M(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...H(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...H()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...M()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...H(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...H(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": M()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...H(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...H()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: U()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: U()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: U()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: U()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: U()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: U()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: U()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: U()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: U()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: U()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: U()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: B()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: B()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: B()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: B()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: B()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: B()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: B()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: B()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: B()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: B()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: B()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": U()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": U()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: Y()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...$()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...$()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...$()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...Z()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...Z()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...Z()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [o, "screen", ...Y()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          o,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...Y()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          o,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...Y()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...Y()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...Y()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...Y()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Os, hr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, ek, qN]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", mu, ae]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [XN, KN, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [ae]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [s, oe, ae]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [we, "none", oe, qh]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          i,
          ...U()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", oe, ae]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", oe, ae]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: y()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: y()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...re(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [we, "from-font", "auto", oe, hr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: y()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [we, "auto", oe, ae]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: U()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", oe, ae]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", oe, ae]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: fe()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Ce()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: v()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Hn, oe, ae],
          radial: ["", oe, ae],
          conic: [Hn, oe, ae]
        }, ZN, QN]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: y()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Se()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Se()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Se()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: y()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: y()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: y()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: _e()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": _e()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": _e()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": _e()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": _e()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": _e()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": _e()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": _e()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": _e()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": _e()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": _e()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": _e()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": _e()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": _e()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": _e()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: pe()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": pe()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": pe()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": pe()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": pe()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": pe()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": pe()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": pe()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": pe()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": pe()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": pe()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": pe()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": pe()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...re(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...re(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: y()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": y()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": y()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": y()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": y()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": y()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": y()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": y()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": y()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": y()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": y()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: y()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...re(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [we, oe, ae]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", we, Os, hr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: y()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          l,
          Xi,
          Qi
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: y()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", h, Xi, Qi]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": y()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: pe()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: y()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [we, hr]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": y()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": pe()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": y()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, Xi, Qi]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": y()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [we, oe, ae]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Te(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Te()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [we]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": ce()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": ce()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": y()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": y()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": ce()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": ce()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": y()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": y()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": ce()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": ce()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": y()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": y()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": ce()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": ce()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": y()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": y()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": ce()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": ce()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": y()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": y()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": ce()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": ce()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": y()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": y()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": ce()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": ce()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": y()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": y()
      }],
      "mask-image-radial": [{
        "mask-radial": [oe, ae]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": ce()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": ce()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": y()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": y()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": R()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [we]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": ce()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": ce()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": y()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": y()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: fe()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Ce()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: v()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", oe, ae]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          ae
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: ue()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [we, oe, ae]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [we, oe, ae]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          Xi,
          Qi
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": y()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", we, oe, ae]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [we, oe, ae]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", we, oe, ae]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [we, oe, ae]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", we, oe, ae]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          ae
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": ue()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [we, oe, ae]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [we, oe, ae]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", we, oe, ae]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [we, oe, ae]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", we, oe, ae]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [we, oe, ae]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [we, oe, ae]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", we, oe, ae]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": U()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": U()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": U()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", oe, ae]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [we, "initial", oe, ae]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", b, oe, ae]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [we, oe, ae]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", T, oe, ae]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, oe, ae]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": D()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Ae()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Ae()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Ae()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Ae()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Pe()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Pe()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Pe()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Pe()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: qe()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": qe()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": qe()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [oe, ae, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: D()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: mt()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": mt()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": mt()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": mt()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: y()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: y()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", oe, ae]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": U()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": U()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": U()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": U()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": U()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": U()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": U()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": U()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": U()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": U()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": U()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": U()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": U()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": U()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": U()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": U()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": U()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": U()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": U()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": U()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": U()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": U()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", oe, ae]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...y()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [we, Os, hr, qh]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...y()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, rk = /* @__PURE__ */ LN(nk);
function le(...e) {
  return rk(SE(e));
}
const sk = pN(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer",
  {
    variants: {
      variant: {
        "purple-gradient": `
          text-white
          overflow-hidden
          border
          border-white/20
          bg-gradient-to-r
          from-[rgba(98,36,198,0.8)]
          from-10.17%
          to-[rgba(66,24,133,0.8)]
          to-86.14%
          backdrop-blur-xl
          shadow-[inset_-2px_-2px_20px_0px_#f6f0ff33]
          before:content-['']
          before:absolute
          before:inset-0
          before:-z-10
          before:bg-gradient-to-r
          before:from-[#6224c6]
          before:from-10.17%
          before:to-[#421885]
          before:to-86.14%
          before:opacity-0
          before:transition-opacity
          before:duration-300
          before:ease-in-out
          disabled:bg-neutral-200
          disabled:text-neutral-500
          disabled:shadow-none
          disabled:cursor-not-allowed
          disabled:[&_svg]:fill-neutral-500
          hover:enabled:border-[#6b27d8]
          hover:enabled:shadow-[0px_2px_4px_0px_#6224c680]
          hover:enabled:before:opacity-100
        `,
        "highlight-border": `
          bg-secondary
          text-secondary-foreground
          shadow-sm
          border
          border-violet-300
          w-fit
          hover:bg-secondary/80
        `,
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        purple: `
          shadow-xs
          border
          border-[#5F3D85]
          bg-[#4A276F]
          data-[active]:bg-[#5F3D85]
          hover:bg-[#5F3D85]
        `
      },
      size: {
        default: "h-9 px-4 py-3 has-[>svg]:pl-2 has-[>svg]:pr-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), It = A.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    asChild: r = !1,
    ...s
  }, i) => {
    const a = r ? eC : "button";
    return /* @__PURE__ */ d.jsx(a, { "data-slot": "button", className: le(sk({ variant: t, size: n, className: e })), ...s, ref: i });
  }
), Fe = FT, vi = jT, ik = ["pt-BR", "en", "es"];
function Xh(e) {
  return ik.includes(e);
}
const Ji = {
  title: {
    key: "zai.delete-thread-modal.title",
    defaultValue: "Excluir chat"
  },
  description: {
    key: "zai.delete-thread-modal.description",
    defaultValue: "Tem certeza de que deseja excluir este chat?"
  },
  cancel: {
    key: "zai.delete-thread-modal.cancel",
    defaultValue: "Cancelar"
  },
  confirm: {
    key: "zai.delete-thread-modal.confirm",
    defaultValue: "Excluir"
  }
}, ak = ({
  isOpen: e,
  isDeleting: t,
  onOverlayClick: n,
  onContentClick: r,
  onCancelClick: s,
  onConfirmClick: i
}) => {
  const { t: a } = Fe();
  return /* @__PURE__ */ d.jsx("div", { onClick: r, children: /* @__PURE__ */ d.jsxs(ks, { show: e, animate: !1, classes: ["w-[90%]!", "max-w-[500px]!"], children: [
    /* @__PURE__ */ d.jsx(ks.Overlay, { onClick: n }),
    /* @__PURE__ */ d.jsx(ks.Header, { children: /* @__PURE__ */ d.jsx("h2", { className: "text-2xl font-semibold text-[#2b2b2b]", children: a(Ji.title) }) }),
    /* @__PURE__ */ d.jsx(ks.Body, { classes: ["py-4"], children: /* @__PURE__ */ d.jsx("p", { className: "text-sm font-normal text-[#4c5567]", children: a(Ji.description) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "h-px bg-black/10" }),
    /* @__PURE__ */ d.jsxs(ks.Footer, { classes: ["gap-4", "pt-4"], children: [
      /* @__PURE__ */ d.jsx(
        It,
        {
          variant: "ghost",
          onClick: s,
          disabled: t,
          className: "h-9 rounded-[4px] px-4 font-normal text-[#4c5567] hover:bg-transparent hover:text-[#4c5567] dark:hover:bg-transparent",
          children: a(Ji.cancel)
        }
      ),
      /* @__PURE__ */ d.jsxs(
        It,
        {
          variant: "default",
          onClick: i,
          disabled: t,
          className: "relative h-9 rounded-[4px] bg-[#6224c6] px-4 font-normal text-white hover:bg-[#6224c6]",
          children: [
            /* @__PURE__ */ d.jsx("span", { className: t ? "invisible" : void 0, children: a(Ji.confirm) }),
            t && /* @__PURE__ */ d.jsx("span", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ d.jsx("span", { className: "size-4 animate-spin rounded-full border-2 border-white border-t-transparent" }) })
          ]
        }
      )
    ] })
  ] }) });
}, ok = he(ak), uk = (e) => {
  const t = fN(e);
  return /* @__PURE__ */ d.jsx(ok, { ...t });
}, ck = ({ onDeleteClick: e }) => {
  const [t, n] = de(!1), r = ne((i) => {
    i.stopPropagation();
  }, []), s = ne(
    (i) => {
      i.stopPropagation(), n(!1), e();
    },
    [e]
  );
  return {
    isOpen: t,
    onOpenChange: n,
    onTriggerClick: r,
    onDeleteClick: s
  };
}, FE = _t({
  container: null
});
function Io() {
  return ft(FE).container;
}
const Wr = {
  dark: null,
  light: null
}, gu = {
  dark: 0,
  light: 0
};
function wl({
  children: e,
  theme: t = "dark"
}) {
  const [n, r] = de(null);
  return xe(() => {
    if (gu[t]++, !Wr[t]) {
      const s = document.createElement("div");
      s.id = `zai-chat-portal-container-${t}`, s.className = `zai-chat-package ${t}`, s.style.cssText = "position:fixed;z-index:99999999991;", document.body.appendChild(s), Wr[t] = s;
    }
    return r(Wr[t]), () => {
      gu[t]--, gu[t] === 0 && Wr[t] && (document.body.removeChild(Wr[t]), Wr[t] = null);
    };
  }, [t]), /* @__PURE__ */ d.jsx(FE.Provider, { value: { container: n }, children: e });
}
function vl({ ...e }) {
  return /* @__PURE__ */ d.jsx(k2, { "data-slot": "popover", ...e });
}
function Nl({ ...e }) {
  return /* @__PURE__ */ d.jsx(R2, { "data-slot": "popover-trigger", ...e });
}
function kl({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...r
}) {
  const s = Io();
  return /* @__PURE__ */ d.jsx(P2, { container: s ?? void 0, children: /* @__PURE__ */ d.jsx(
    O2,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: le(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...r
    }
  ) });
}
const Jh = {
  delete: {
    key: "zai.thread-list-item-menu.delete",
    defaultValue: "Excluir"
  },
  actionsLabel: {
    key: "zai.thread-list-item-menu.actions-label",
    defaultValue: "Ações da conversa"
  }
}, lk = ({ isOpen: e, onOpenChange: t, onTriggerClick: n, onDeleteClick: r }) => {
  const { t: s } = Fe();
  return /* @__PURE__ */ d.jsxs(vl, { open: e, onOpenChange: t, children: [
    /* @__PURE__ */ d.jsx(
      Nl,
      {
        onClick: n,
        "aria-label": s(Jh.actionsLabel),
        className: `
          flex
          items-center
          justify-center
          size-5
          rounded-full
          bg-[#6f6f6f]
          shrink-0
          opacity-0
          group-hover:opacity-100
          focus-visible:opacity-100
          data-[state=open]:opacity-100
          outline-none
        `,
        children: /* @__PURE__ */ d.jsx(qv, { className: "size-3 text-[#f7f9fc]" })
      }
    ),
    /* @__PURE__ */ d.jsx(
      kl,
      {
        align: "end",
        onClick: n,
        className: "w-[180px] p-0 rounded shadow-[0px_2px_10px_1px_rgba(0,0,0,0.08)] bg-white border-none",
        children: /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "button",
            onClick: r,
            className: "w-full h-9 pl-6 pr-2 py-2 rounded text-start text-sm text-[#4c5567] hover:bg-neutral-100",
            children: s(Jh.delete)
          }
        )
      }
    )
  ] });
}, dk = he(lk), hk = (e) => {
  const t = ck(e);
  return /* @__PURE__ */ d.jsx(dk, { ...t });
};
class wo extends BT {
  constructor() {
    super(...arguments), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t) {
    (t?.message?.includes("tapClientLookup") || t?.message?.includes("out of bounds")) && setTimeout(() => this.setState({ hasError: !1 }), 0);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
const jE = _t(void 0), $E = () => {
  const e = ft(jE);
  if (!e)
    throw new Error("useThreadRunningState must be used within a ThreadRunningStateProvider");
  return e;
}, zE = _t(void 0), VE = () => {
  const e = ft(zE);
  if (!e)
    throw new Error("useZaiChatSectionStates must be used within a ZaiChatSectionStatesProvider");
  return e;
}, fk = ({ children: e }) => {
  const [t, n] = de({}), r = ne(
    (c) => t[c]?.threadId,
    [t]
  ), s = ne(({ contextKey: c, id: l }) => {
    n((h) => ({
      ...h,
      [c]: {
        ...h[c] || {},
        threadId: l
      }
    }));
  }, []), i = ne(
    (c) => t[c]?.lastPrompt,
    [t]
  ), a = ne(({ contextKey: c, prompt: l }) => {
    n((h) => ({
      ...h,
      [c]: {
        ...h[c] || {},
        lastPrompt: l
      }
    }));
  }, []), o = ne(
    (c) => Object.values(t).some((l) => l.threadId === c),
    [t]
  ), u = ie(
    () => ({
      getCurrentThreadId: r,
      setCurrentThreadId: s,
      getLastPrompt: i,
      setLastPrompt: a,
      isSectionThreadId: o
    }),
    [r, s, i, a, o]
  );
  return /* @__PURE__ */ d.jsx(zE.Provider, { value: u, children: e });
}, pk = ({
  children: e,
  onBackgroundThreadComplete: t,
  isChatVisible: n
}) => {
  const [r, s] = de({}), { isSectionThreadId: i } = VE(), a = ne(({ threadId: l, isRunning: h }) => {
    s((m) => {
      if (!!m[l] === h) return m;
      if (!h) {
        const { [l]: p, ...E } = m;
        return E;
      }
      return { ...m, [l]: !0 };
    });
  }, []), o = ne(
    ({ threadId: l, isActiveThread: h, title: m }) => {
      if (!t || i(l)) return;
      (!h || !n?.()) && t(l, m);
    },
    [t, n, i]
  ), u = ne(
    (l) => !!(l && r[l]),
    [r]
  ), c = ie(
    () => ({ isThreadRunning: u, setThreadRunning: a, notifyIfBackground: o }),
    [u, a, o]
  );
  return /* @__PURE__ */ d.jsx(jE.Provider, { value: c, children: e });
}, vo = {
  isEnabled: (e) => Id.isEnabled(e),
  getValue: (e) => Id.getValue(e)
}, $t = {
  loading: {
    key: "zai.loading",
    defaultValue: "Carregando..."
  },
  loadingThreads: {
    key: "zai.loading-threads",
    defaultValue: "Carregando conversas"
  },
  copy: {
    key: "zai.copy",
    defaultValue: "Copiar"
  },
  newThread: {
    key: "zai.new-thread",
    defaultValue: "Nova conversa"
  },
  scrollToBottom: {
    key: "zai.thread.scroll-to-bottom",
    defaultValue: "Role para baixo"
  },
  welcomeMessage: {
    key: "zai.thread.welcome-message",
    defaultValue: "Como posso ajudar você hoje?"
  },
  placeholder: {
    key: "zai.thread.placeholder",
    defaultValue: "Escreva sua mensagem para ZAI"
  },
  somethingWentWrong: {
    key: "zai.thread.something-went-wrong",
    defaultValue: "Parece que algo deu errado. Tente novamente."
  }
}, YE = ({ handleItemClick: e }) => {
  const t = J((r) => r?.threads?.isLoading), { t: n } = Fe();
  return /* @__PURE__ */ d.jsxs(gE, { className: "flex flex-col items-stretch gap-1.5", children: [
    /* @__PURE__ */ d.jsx(mk, { handleItemClick: e }),
    t ? /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-center p-4 gap-2.5", children: [
      /* @__PURE__ */ d.jsx("span", { className: "animate-spin size-5 border-2 border-purple-300 rounded-full border-t-transparent" }),
      /* @__PURE__ */ d.jsx("p", { className: "text-white font-medium", children: n($t.loadingThreads) })
    ] }) : /* @__PURE__ */ d.jsx(gk, { handleItemClick: e })
  ] });
}, mk = ({ handleItemClick: e }) => {
  const { t } = Fe();
  return /* @__PURE__ */ d.jsx(mE, { asChild: !0, children: /* @__PURE__ */ d.jsxs(
    It,
    {
      onClick: e,
      variant: "purple",
      size: "default",
      className: `
          justify-start
          rounded-lg
          h-11
        `,
      children: [
        /* @__PURE__ */ d.jsx(sN, {}),
        t($t.newThread)
      ]
    }
  ) });
}, gk = ({ handleItemClick: e }) => /* @__PURE__ */ d.jsx(wo, { children: /* @__PURE__ */ d.jsx(
  Xm,
  {
    components: { ThreadListItem: () => /* @__PURE__ */ d.jsx(Ek, { handleItemClick: e }) }
  }
) }), Ek = ({ handleItemClick: e }) => {
  const [t, n] = de(!1), [r, s] = de(!1), a = Re().threadListItem(), o = vo.isEnabled("isZaiA2AOrchestratorEnabled"), u = async () => {
    s(!0);
    try {
      await a.delete(), n(!1);
    } finally {
      s(!1);
    }
  };
  return /* @__PURE__ */ d.jsxs(
    EE,
    {
      onClick: e,
      className: "group data-[active]:bg-neutral-700 hover:bg-neutral-700 focus-visible:bg-neutral-700 focus-visible:ring-ring flex items-center gap-2 rounded-lg transition-all focus-visible:outline-none focus-visible:ring-2",
      children: [
        /* @__PURE__ */ d.jsx(vv, { className: "flex-grow px-3 py-2 text-start w-full min-w-0", children: /* @__PURE__ */ d.jsx(bk, {}) }),
        o && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsx(hk, { onDeleteClick: () => n(!0) }),
          /* @__PURE__ */ d.jsx(
            uk,
            {
              isOpen: t,
              isDeleting: r,
              onCancel: () => n(!1),
              onConfirm: u
            }
          )
        ] })
      ]
    }
  );
}, bk = () => {
  const e = J((r) => r?.threadListItem?.id), { isThreadRunning: t } = $E(), { t: n } = Fe();
  return /* @__PURE__ */ d.jsxs("p", { className: "text-sm font-medium flex items-center gap-1.5 min-w-0", children: [
    t(e) && /* @__PURE__ */ d.jsx("span", { "data-status": "running", role: "status", "aria-label": n($t.loading), className: "aui-md shrink-0" }),
    /* @__PURE__ */ d.jsx("span", { className: "truncate", children: /* @__PURE__ */ d.jsx(Jm, { fallback: "New Chat" }) })
  ] });
};
function _k({ ...e }) {
  return /* @__PURE__ */ d.jsx(GS, { "data-slot": "sheet", ...e });
}
function Tk({ ...e }) {
  const t = Io();
  return /* @__PURE__ */ d.jsx(WS, { "data-slot": "sheet-portal", container: t ?? void 0, ...e });
}
function Ak({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    qS,
    {
      "data-slot": "sheet-overlay",
      className: le(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function yk({
  className: e,
  children: t,
  side: n = "right",
  ...r
}) {
  return /* @__PURE__ */ d.jsxs(Tk, { children: [
    /* @__PURE__ */ d.jsx(Ak, {}),
    /* @__PURE__ */ d.jsxs(
      KS,
      {
        "data-slot": "sheet-content",
        className: le(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
          n === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm",
          n === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm",
          n === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b",
          n === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t",
          e
        ),
        ...r,
        children: [
          t,
          /* @__PURE__ */ d.jsxs(JS, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none", children: [
            /* @__PURE__ */ d.jsx(xE, { className: "size-4" }),
            /* @__PURE__ */ d.jsx("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function xk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx("div", { "data-slot": "sheet-header", className: le("flex flex-col gap-1.5 p-4", e), ...t });
}
function Ck({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    QS,
    {
      "data-slot": "sheet-title",
      className: le("text-foreground font-semibold", e),
      ...t
    }
  );
}
function Sk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    XS,
    {
      "data-slot": "sheet-description",
      className: le("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function kt({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx("div", { "data-slot": "skeleton", className: le("bg-accent animate-pulse rounded-md", e), ...t });
}
function GE({ delayDuration: e = 0, ...t }) {
  return /* @__PURE__ */ d.jsx(kw, { "data-slot": "tooltip-provider", delayDuration: e, ...t });
}
function Ik({ ...e }) {
  return /* @__PURE__ */ d.jsx(GE, { children: /* @__PURE__ */ d.jsx(Rw, { "data-slot": "tooltip", ...e }) });
}
function wk({ ...e }) {
  return /* @__PURE__ */ d.jsx(Pw, { "data-slot": "tooltip-trigger", ...e });
}
function vk({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...r
}) {
  const s = Io();
  return /* @__PURE__ */ d.jsx(Ow, { container: s ?? void 0, children: /* @__PURE__ */ d.jsxs(
    Dw,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: le(
        "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ d.jsx(Lw, { className: "bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
const Eu = 768;
function Nk() {
  const [e, t] = A.useState(void 0);
  return A.useEffect(() => {
    const n = window.matchMedia(`(max-width: ${Eu - 1}px)`), r = () => {
      t(window.innerWidth < Eu);
    };
    return n.addEventListener("change", r), t(window.innerWidth < Eu), () => n.removeEventListener("change", r);
  }, []), !!e;
}
const kk = "sidebar_state", Rk = 3600 * 24 * 7, Pk = "16rem", Ok = "18rem", Dk = "3rem", Lk = "b", WE = A.createContext(null);
function Mk() {
  const e = A.useContext(WE);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function Hk({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: n,
  className: r,
  style: s,
  children: i,
  ...a
}) {
  const o = Nk(), [u, c] = A.useState(!1), [l, h] = A.useState(e), m = t ?? l, p = A.useCallback(
    (b) => {
      const T = typeof b == "function" ? b(m) : b;
      n ? n(T) : h(T), document.cookie = `${kk}=${T}; path=/; max-age=${Rk}`;
    },
    [n, m]
  ), E = A.useCallback(() => o ? c((b) => !b) : p((b) => !b), [o, p, c]);
  A.useEffect(() => {
    const b = (T) => {
      T.key === Lk && (T.metaKey || T.ctrlKey) && (T.preventDefault(), E());
    };
    return window.addEventListener("keydown", b), () => window.removeEventListener("keydown", b);
  }, [E]);
  const g = m ? "expanded" : "collapsed", _ = A.useMemo(
    () => ({
      state: g,
      open: m,
      setOpen: p,
      isMobile: o,
      openMobile: u,
      setOpenMobile: c,
      toggleSidebar: E
    }),
    [g, m, p, o, u, c, E]
  );
  return /* @__PURE__ */ d.jsx(WE.Provider, { value: _, children: /* @__PURE__ */ d.jsx(GE, { delayDuration: 0, children: /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-wrapper",
      style: {
        "--sidebar-width": Pk,
        "--sidebar-width-icon": Dk,
        ...s
      },
      className: le("group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full", r),
      ...a,
      children: i
    }
  ) }) });
}
function Bk({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: n = "offcanvas",
  className: r,
  children: s,
  ...i
}) {
  const { isMobile: a, state: o, openMobile: u, setOpenMobile: c } = Mk();
  return n === "none" ? /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar",
      className: le("bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col", r),
      ...i,
      children: s
    }
  ) : a ? /* @__PURE__ */ d.jsx(_k, { open: u, onOpenChange: c, ...i, children: /* @__PURE__ */ d.jsxs(
    yk,
    {
      "data-sidebar": "sidebar",
      "data-slot": "sidebar",
      "data-mobile": "true",
      className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
      style: {
        "--sidebar-width": Ok
      },
      side: e,
      children: [
        /* @__PURE__ */ d.jsxs(xk, { className: "sr-only", children: [
          /* @__PURE__ */ d.jsx(Ck, { children: "Sidebar" }),
          /* @__PURE__ */ d.jsx(Sk, { children: "Displays the mobile sidebar." })
        ] }),
        /* @__PURE__ */ d.jsx("div", { className: "flex h-full w-full flex-col", children: s })
      ]
    }
  ) }) : /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: "group peer text-sidebar-foreground hidden md:block",
      "data-state": o,
      "data-collapsible": o === "collapsed" ? n : "",
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ d.jsx(
          "div",
          {
            "data-slot": "sidebar-gap",
            className: le(
              "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
            )
          }
        ),
        /* @__PURE__ */ d.jsx(
          "div",
          {
            "data-slot": "sidebar-container",
            className: le(
              "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              r
            ),
            ...i,
            children: /* @__PURE__ */ d.jsx(
              "div",
              {
                "data-sidebar": "sidebar",
                "data-slot": "sidebar-inner",
                className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-xl group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm",
                children: s
              }
            )
          }
        )
      ]
    }
  );
}
function Uk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: le(
        "bg-background relative flex w-full flex-1 flex-col",
        "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2",
        e
      ),
      ...t
    }
  );
}
function Fk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: le("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function jk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: le(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    }
  );
}
function $k({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: le("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    }
  );
}
function zk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: le("flex w-full min-w-0 flex-col gap-1", e),
      ...t
    }
  );
}
function Vk({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: le("group/menu-item relative", e),
      ...t
    }
  );
}
const Yk = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M7.433.91a3.25 3.25 0 0 1 3.317 3.257v10.834a4.086 4.086 0 0 1-4.348 4.07 4.084 4.084 0 0 1-3.817-4.113A4.08 4.08 0 0 1 .93 12.01 4.08 4.08 0 0 1 1.998 8.9a4.08 4.08 0 0 1 1.189-4.511 4.1 4.1 0 0 1 1.093-.665A3.25 3.25 0 0 1 7.432.91m.03 1.5a1.75 1.75 0 0 0-1.711 1.827.75.75 0 0 1-.563.76A2.586 2.586 0 0 0 3.25 7.604c.016.391.12.775.307 1.12a.75.75 0 0 1-.188.937 2.585 2.585 0 0 0 .36 4.255.75.75 0 0 1 .374.75 2.59 2.59 0 0 0 1.385 2.63A2.583 2.583 0 0 0 9.25 15V4.164A1.75 1.75 0 0 0 7.464 2.41",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M12.567.91a3.25 3.25 0 0 1 3.152 2.814 4.085 4.085 0 0 1 2.528 3.941 4.1 4.1 0 0 1-.246 1.234 4.082 4.082 0 0 1-.586 6.06 4.08 4.08 0 0 1-.929 2.633 4.085 4.085 0 0 1-7.236-2.59V4.166A3.25 3.25 0 0 1 12.567.91m-.03 1.5a1.75 1.75 0 0 0-1.787 1.754V15a2.585 2.585 0 0 0 2.751 2.575 2.583 2.583 0 0 0 2.395-2.909.75.75 0 0 1 .374-.749 2.583 2.583 0 0 0 .36-4.255.75.75 0 0 1-.188-.937 2.59 2.59 0 0 0-.6-3.193 2.6 2.6 0 0 0-1.032-.534.75.75 0 0 1-.562-.76 1.75 1.75 0 0 0-1.712-1.828",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M10 6.75a.75.75 0 0 1 .749.709 3 3 0 0 0 2 2.667.75.75 0 0 1-.498 1.415 4.5 4.5 0 0 1-2.106-1.545q-.076-.103-.145-.209-.07.106-.145.21A4.5 4.5 0 0 1 7.75 11.54a.75.75 0 0 1-.498-1.415 3 3 0 0 0 2-2.667l.022-.145A.75.75 0 0 1 10 6.75m5.03-3.228a.75.75 0 0 1 .718.78 3.25 3.25 0 0 1-.433 1.49.75.75 0 1 1-1.299-.75c.141-.245.221-.52.233-.802a.75.75 0 0 1 .78-.718m-10.057 0a.75.75 0 0 1 .78.719c.011.282.091.557.232.801a.75.75 0 0 1-1.3.75 3.25 3.25 0 0 1-.43-1.49.75.75 0 0 1 .718-.78M2.98 8.021a.833.833 0 1 1 .81 1.458q-.195.107-.366.248A.834.834 0 0 1 2.37 8.434q.286-.233.61-.413m12.907.325a.833.833 0 0 1 1.132-.325q.324.18.61.413a.834.834 0 0 1-1.053 1.293 2.5 2.5 0 0 0-.365-.248.833.833 0 0 1-.324-1.133M2.708 14.202a.75.75 0 0 1 1.021-.285c.388.218.825.333 1.27.333A.75.75 0 0 1 5 15.75a4.1 4.1 0 0 1-2.007-.527.75.75 0 0 1-.285-1.021m13.562-.285a.75.75 0 0 1 .738 1.306A4.1 4.1 0 0 1 15 15.75a.75.75 0 0 1 0-1.5 2.6 2.6 0 0 0 1.27-.333",
      fill: "currentColor"
    }
  )
] }), Gk = ({ index: e, ...t }) => /* @__PURE__ */ d.jsxs("svg", { width: "192", height: "192", viewBox: "0 0 192 192", className: "w-48 h-48", ...t, children: [
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: `donut-clip-${e}`, children: /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M 96 96 m -96 0 a 96 96 0 1 0 192 0 a 96 96 0 1 0 -192 0 Z M 96 96 m -72 0 a 72 72 0 0 1 144 0 a 72 72 0 0 1 -144 0 Z",
      fillRule: "evenodd"
    }
  ) }) }),
  /* @__PURE__ */ d.jsx(
    "rect",
    {
      width: "192",
      height: "192",
      fill: "rgb(75, 85, 99)",
      clipPath: `url(#donut-clip-${e})`,
      className: "animate-pulse"
    }
  )
] }), Wk = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#a)", fill: "currentColor", children: [
    /* @__PURE__ */ d.jsx("path", { d: "M10.637 2.387a.888.888 0 0 0-1.774 0v.141A2.1 2.1 0 0 1 7.637 4.43a1 1 0 0 1-.238.069 2.1 2.1 0 0 1-2.182-.472l-.056-.055a.89.89 0 0 0-1.254 0 .886.886 0 0 0 0 1.255l.055.055a2.1 2.1 0 0 1 .436 2.272 2.1 2.1 0 0 1-1.92 1.375h-.091a.888.888 0 0 0 0 1.773h.141a2.1 2.1 0 0 1 1.918 1.265 2.1 2.1 0 0 1-.419 2.316l-.055.056a.89.89 0 0 0 0 1.254.886.886 0 0 0 1.255 0l.055-.055a2.1 2.1 0 0 1 2.272-.437l.045.017h-.001a2.1 2.1 0 0 1 1.33 1.905v.09a.887.887 0 0 0 1.774 0v-.141a2.1 2.1 0 0 1 1.265-1.92 2.1 2.1 0 0 1 2.316.42l.056.056.064.059a.89.89 0 0 0 1.383-.347.89.89 0 0 0-.192-.967l-.056-.055a2.1 2.1 0 0 1-.42-2.317 2.1 2.1 0 0 1 1.92-1.264h.075a.887.887 0 0 0 0-1.774h-.141a2.1 2.1 0 0 1-1.902-1.226 1 1 0 0 1-.07-.238 2.1 2.1 0 0 1 .473-2.182l.055-.056.059-.064a.89.89 0 0 0-.059-1.19.886.886 0 0 0-1.255 0l-.055.055a2.1 2.1 0 0 1-2.317.42V4.38a2.1 2.1 0 0 1-1.264-1.918zm1.5.07.006.087a.6.6 0 0 0 .28.422l.077.04.008.003a.6.6 0 0 0 .66-.12l.044-.043a2.388 2.388 0 0 1 3.377 3.376l-.044.044-.058.068a.6.6 0 0 0-.067.58q.03.076.049.163a.6.6 0 0 0 .508.286h.136a2.387 2.387 0 0 1 0 4.774h-.07l-.087.006a.6.6 0 0 0-.462.357l-.003.008a.6.6 0 0 0 .116.658l.047.046a2.39 2.39 0 0 1 .518 2.603 2.388 2.388 0 0 1-3.894.774l-.044-.044a.6.6 0 0 0-.66-.12l-.009.004a.6.6 0 0 0-.363.549v.135a2.387 2.387 0 0 1-4.773 0v-.066a.6.6 0 0 0-.393-.538l-.044-.019a.6.6 0 0 0-.66.12l-.044.044a2.39 2.39 0 0 1-2.602.518 2.385 2.385 0 0 1-.773-3.895l.042-.043a.6.6 0 0 0 .12-.66l-.004-.009a.6.6 0 0 0-.462-.356l-.087-.007h-.135a2.387 2.387 0 0 1 0-4.773h.065a.6.6 0 0 0 .54-.393q.008-.023.018-.044a.6.6 0 0 0-.12-.66h-.001l-.043-.044A2.387 2.387 0 1 1 6.222 2.91l.044.044.068.058a.6.6 0 0 0 .58.067l.08-.028.083-.022a.6.6 0 0 0 .286-.505v-.138a2.387 2.387 0 0 1 4.774 0z" }),
    /* @__PURE__ */ d.jsx("path", { d: "M11 9.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0" })
  ] }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "a", children: /* @__PURE__ */ d.jsx("path", { d: "M0 0h20v20H0z" }) }) })
] }), qk = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M6.75 15.833a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M16.75 12.917a2.167 2.167 0 0 0-2.167-2.167H5.417a3.667 3.667 0 1 1 0-7.333H12.5a.75.75 0 0 1 0 1.5H5.417a2.167 2.167 0 0 0 0 4.333h9.166a3.668 3.668 0 0 1 0 7.334H7.5a.75.75 0 0 1 0-1.5h7.083a2.17 2.17 0 0 0 2.167-2.167",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M16.75 4.167a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
      fill: "currentColor"
    }
  )
] }), Kk = (e) => /* @__PURE__ */ d.jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_318_263)", children: [
    /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M11.1694 6.01412C11.2759 5.6973 11.7241 5.6973 11.8306 6.01412L11.8596 6.1003C12.4887 7.97035 13.9013 9.4735 15.7288 10.2173C16.0103 10.3319 16.0103 10.7306 15.7288 10.8452C13.9013 11.589 12.4887 13.0921 11.8596 14.9622L11.8306 15.0484C11.7241 15.3652 11.2759 15.3652 11.1694 15.0484L11.1404 14.9622C10.5113 13.0921 9.09865 11.589 7.27121 10.8452C6.98968 10.7306 6.98968 10.3319 7.27121 10.2173C9.09865 9.4735 10.5113 7.97035 11.1404 6.1003L11.1694 6.01412Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ d.jsx(
      "path",
      {
        opacity: "0.4",
        d: "M4.25463 2.66311C4.33892 2.43533 4.66109 2.43533 4.74537 2.66311C5.27536 4.09538 6.40462 5.22464 7.83689 5.75463C8.06467 5.83892 8.06467 6.16109 7.83689 6.24537C6.40462 6.77536 5.27536 7.90462 4.74537 9.33689C4.66109 9.56467 4.33892 9.56467 4.25463 9.33689C3.72464 7.90462 2.59538 6.77536 1.16311 6.24537C0.935326 6.16109 0.935326 5.83892 1.16311 5.75463C2.59538 5.22464 3.72464 4.09538 4.25463 2.66311Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ d.jsx(
      "path",
      {
        opacity: "0.4",
        d: "M9.37731 0.300304C9.41946 0.186413 9.58054 0.186413 9.62269 0.300304C9.88768 1.01644 10.4523 1.58107 11.1684 1.84606C11.2823 1.88821 11.2823 2.04929 11.1684 2.09144C10.4523 2.35643 9.88768 2.92106 9.62269 3.6372C9.58054 3.75109 9.41946 3.75109 9.37731 3.6372C9.11232 2.92106 8.54769 2.35643 7.83155 2.09144C7.71766 2.04929 7.71766 1.88821 7.83155 1.84606C8.54769 1.58107 9.11232 1.01644 9.37731 0.300304Z",
        fill: "currentColor"
      }
    )
  ] }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_318_263", children: /* @__PURE__ */ d.jsx("rect", { width: "16", height: "16", fill: "currentColor", transform: "translate(0.5)" }) }) })
] }), Zh = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M10 .916a1.17 1.17 0 0 1 1.095.762l.029.091.004.015 1.317 5.112a.92.92 0 0 0 .66.658h-.002l5.114 1.319.012.002c.215.06.409.18.557.344l.06.074.055.079a1.167 1.167 0 0 1-.672 1.752l-.012.004-5.113 1.317a.92.92 0 0 0-.62.543l-.039.116-1.318 5.112-.004.015a1.168 1.168 0 0 1-2.251-.015l-1.317-5.112a.92.92 0 0 0-.659-.658l-5.113-1.319-.017-.005a1.17 1.17 0 0 1-.844-1.027L.918 10l.004-.095a1.17 1.17 0 0 1 .844-1.028l.017-.004 5.112-1.319h.001a.92.92 0 0 0 .659-.658l1.318-5.112.004-.015A1.17 1.17 0 0 1 10 .916m-.993 6.355A2.42 2.42 0 0 1 7.27 9.006L3.42 10l3.85.994a2.42 2.42 0 0 1 1.737 1.736l.992 3.854.994-3.854a2.42 2.42 0 0 1 1.736-1.736L16.581 10l-3.851-.992a2.42 2.42 0 0 1-1.737-1.736L10 3.417zm6.91-1.438V2.5a.75.75 0 1 1 1.5 0v3.333a.75.75 0 0 1-1.5 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M18.333 3.417a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1 0-1.5zM2.583 15.834v-1.667a.75.75 0 1 1 1.5 0v1.667a.75.75 0 0 1-1.5 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx("path", { d: "M4.167 14.25a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1 0-1.5z", fill: "currentColor" })
] }), Qk = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M17.584 10a7.584 7.584 0 1 0-15.168 0 7.584 7.584 0 0 0 15.168 0m1.5 0A9.084 9.084 0 1 1 .915 9.999a9.084 9.084 0 0 1 18.169 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M11.97 7.803a.75.75 0 1 1 1.06 1.06l-3.333 3.334a.75.75 0 0 1-1.06 0L6.97 10.53a.75.75 0 0 1 1.06-1.06l1.136 1.135z",
      fill: "currentColor"
    }
  )
] }), qE = (e) => /* @__PURE__ */ d.jsxs("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M19.5606 13.3584C19.7026 12.9378 20.2975 12.9378 20.4395 13.3584L20.4767 13.4685C21.3173 15.9574 23.2009 17.9566 25.6355 18.9438C26.011 19.096 26.011 19.6277 25.6355 19.78C23.2009 20.7672 21.3173 22.7662 20.4767 25.2553L20.4395 25.3654C20.2975 25.786 19.7026 25.786 19.5606 25.3654L19.5234 25.2553C18.6829 22.7662 16.7993 20.7672 14.3646 19.78C13.9891 19.6277 13.9891 19.096 14.3646 18.9438C16.7993 17.9566 18.6829 15.9574 19.5234 13.4685L19.5606 13.3584Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      opacity: "0.4",
      d: "M10.3406 8.90916C10.4529 8.60678 10.8806 8.60678 10.9929 8.90916C11.7002 10.8131 13.2067 12.3141 15.1125 13.0165C15.4164 13.1285 15.4164 13.5588 15.1125 13.6708C13.2067 14.3734 11.7002 15.8743 10.9929 17.7782C10.8806 18.0806 10.4529 18.0806 10.3406 17.7782C9.63331 15.8743 8.12679 14.3734 6.22105 13.6708C5.9172 13.5588 5.9172 13.1285 6.22105 13.0165C8.12679 12.3141 9.63331 10.8131 10.3406 8.90916Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      opacity: "0.4",
      d: "M17.1703 5.77233C17.2264 5.62114 17.4403 5.62114 17.4964 5.77233C17.85 6.7243 18.6034 7.47478 19.5562 7.82601C19.7082 7.88201 19.7082 8.09718 19.5562 8.15318C18.6034 8.50439 17.85 9.25487 17.4964 10.2069C17.4403 10.358 17.2264 10.358 17.1703 10.2069C16.8167 9.25487 16.0634 8.50439 15.1106 8.15318C14.9586 8.09718 14.9586 7.88201 15.1106 7.82601C16.0634 7.47478 16.8167 6.7243 17.1703 5.77233Z",
      fill: "currentColor"
    }
  )
] }), KE = () => /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ d.jsx(qE, { width: 32, height: 32, color: "#FFFFFF" }),
  /* @__PURE__ */ d.jsx("span", { className: "text-2xl font-medium", children: "ZAI" })
] });
function Xk({
  isZaiRagEnabled: e,
  ...t
}) {
  const n = e ? "h-[calc(100%_-_98px)]" : "";
  return /* @__PURE__ */ d.jsx(Bk, { ...t, variant: "floating", collapsible: "none", className: `p-4 bg-transparent ${n}`, children: /* @__PURE__ */ d.jsxs($k, { className: "p-0 bg-sidebar h-full rounded-xl", children: [
    /* @__PURE__ */ d.jsx(Fk, { className: "p-6", children: /* @__PURE__ */ d.jsx(zk, { children: /* @__PURE__ */ d.jsx(Vk, { children: /* @__PURE__ */ d.jsx(KE, {}) }) }) }),
    /* @__PURE__ */ d.jsx(jk, { className: "p-6 pt-0", children: /* @__PURE__ */ d.jsx(YE, {}) })
  ] }) });
}
const QE = _t(null), pt = () => {
  const e = ft(QE);
  if (!e)
    throw new Error("useAccessContext must be used within an AccessContextProvider");
  return e;
}, Jk = {
  "center-stage": "Center Stage",
  "side-chat": "Side Chat",
  "soa-chat": "SOA Chat",
  "demand-intelligence": "Demand Intelligence"
}, XE = _t(null), _s = () => {
  const e = ft(XE);
  if (!e)
    throw new Error("useMixpanelSendMessageSettings must be used within a MixpanelSendMessageSettingsProvider");
  return e;
}, Zk = ({ children: e }) => {
  const t = Ke(null), n = Ke(null), r = Ke(null), s = Ke(null), i = ne(({ origin: g }) => {
    t.current = Jk[g] || null;
  }, []), a = ne(({ page: g }) => {
    n.current = g;
  }, []), o = ne((g) => {
    r.current = g;
  }, []), u = ne(() => t.current, []), c = ne(() => n.current, []), l = ne(() => !!r.current, []), h = ne(() => {
    r.current = null, n.current = null, s.current = null;
  }, []), m = ne((g) => {
    s.current = g;
  }, []), p = ne(() => !!s.current, []), E = {
    setOrigin: i,
    getOrigin: u,
    setPage: a,
    getPage: c,
    setIsPrePrompt: o,
    checkIsPrePrompt: l,
    resetIsPrePrompt: h,
    setIsProactiveMessage: m,
    checkIsProactiveMessage: p
  };
  return /* @__PURE__ */ d.jsx(XE.Provider, { value: E, children: e });
}, JE = _t(void 0), Rl = () => {
  const e = ft(JE);
  if (!e)
    throw new Error("usePrePromptParams must be used within a PrePromptParamsProvider");
  return e;
}, eR = ({ children: e }) => {
  const t = Ke(null), n = ne((a) => {
    t.current = a;
  }, []), r = ne(() => t.current, []), s = ne(() => {
    t.current = null;
  }, []), i = ie(
    () => ({
      setQuickPromptId: n,
      getQuickPromptId: r,
      resetPrePromptParams: s
    }),
    [r, s, n]
  );
  return /* @__PURE__ */ d.jsx(JE.Provider, { value: i, children: e });
}, lt = [];
for (let e = 0; e < 256; ++e)
  lt.push((e + 256).toString(16).slice(1));
function tR(e, t = 0) {
  return (lt[e[t + 0]] + lt[e[t + 1]] + lt[e[t + 2]] + lt[e[t + 3]] + "-" + lt[e[t + 4]] + lt[e[t + 5]] + "-" + lt[e[t + 6]] + lt[e[t + 7]] + "-" + lt[e[t + 8]] + lt[e[t + 9]] + "-" + lt[e[t + 10]] + lt[e[t + 11]] + lt[e[t + 12]] + lt[e[t + 13]] + lt[e[t + 14]] + lt[e[t + 15]]).toLowerCase();
}
let bu;
const nR = new Uint8Array(16);
function rR() {
  if (!bu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    bu = crypto.getRandomValues.bind(crypto);
  }
  return bu(nR);
}
const sR = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ef = { randomUUID: sR };
function iR(e, t, n) {
  if (ef.randomUUID && !e)
    return ef.randomUUID();
  e = e || {};
  const r = e.random ?? e.rng?.() ?? rR();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, tR(r);
}
const ZE = {
  // Brand Resources
  get_my_brand: "winnin://brands/me",
  get_my_competitors: "winnin://brands/competitors",
  share_of_engagement_content_and_views: "winnin://brands/share_of_engagement_content_and_views/:provider/:territoryType/:timeRangeInDays",
  get_key_findings: "winnin://brands/me/key_findings/:language",
  get_brand_engagement_histogram: "winnin://brands/engagement/histogram/:provider/:territoryType/:timeRangeInDays",
  get_brand_views_histogram: "winnin://brands/views/histogram/:provider/:territoryType/:timeRangeInDays",
  get_brand_posts_histogram: "winnin://brands/posts/histogram/:provider/:territoryType/:timeRangeInDays",
  // Brand V2 Resources
  get_my_brand_v2: "winnin://brands-v2/me",
  get_my_competitors_v2: "winnin://brands-v2/competitors",
  share_of_engagement_content_and_views_v2: "winnin://brands-v2/share_of_engagement_content_and_views/:provider/:timeRangeInDays",
  get_brand_engagement_histogram_v2: "winnin://brands-v2/engagement/histogram/:provider/:timeRangeInDays",
  get_brand_posts_histogram_v2: "winnin://brands-v2/posts/histogram/:provider/:timeRangeInDays",
  get_brand_views_histogram_v2: "winnin://brands-v2/views/histogram/:provider/:timeRangeInDays",
  // Category Resources
  share_of_attention: "winnin://category/share_of_attention/:year/:period",
  share_of_attention_v2: "winnin://category/share_of_attention/v2/:year/:period",
  get_trending_territories: "winnin://category/trending_territories",
  get_category: "winnin://category",
  // Category V2 Resources
  share_of_attention_v3: "winnin://category-v2/share_of_attention/v3/:industryId/:year/:period",
  get_share_of_attention_industries: "winnin://category-v2/share_of_attention/v3/industries",
  get_share_of_attention_reasoning: "winnin://category-v2/share_of_attention/v3/reasoning/:industryId/:year/:period",
  // Territory Resources
  get_territory_resource: "winnin://territory/:territoryId",
  get_territory_tags_resource: "winnin://territory/:territoryId/:timeRange/tags",
  get_territory_niches_resource: "winnin://territory/:territoryId/:timeRange/niches/:context",
  get_territory_formats_resource: "winnin://territory/:territoryId/:timeRange/formats",
  get_territory_creators_resource: "winnin://territory/:territoryId/:timeRange/creators",
  get_territory_videos_resource: "winnin://territory/:territoryId/:timeRange/videos/:sortBy",
  get_territory_performance_resource: "winnin://territory/:territoryId/:timeRange/metrics",
  get_territory_affinities_resource: "winnin://territory/:territoryId/:timeRange/affinity",
  get_territory_audience_resource: "winnin://territory/:territoryId/:timeRange/audience",
  deep_territory_analysis: "winnin://territory/:territoryId/:timeRange/deep_analysis",
  get_territory_relevance_resource: "winnin://territory/:territoryId/:timeRange/relevance",
  // Winnin Documentation Resources
  about_winnin: "winnin://winnin/about",
  about_relevance_index: "winnin://metrics/relevance_index",
  about_avg_engagement: "winnin://metrics/avg_engagement",
  about_avg_views: "winnin://metrics/avg_views",
  about_total_videos: "winnin://metrics/total_videos",
  metrics_vs_retention: "winnin://metrics/retention",
  about_affinity: "winnin://metrics/affinity_calculation",
  about_relationship_metric: "winnin://metrics/relationship_calculation",
  about_audience: "winnin://audience/data_collection",
  what_are_trending_topics_in_territories: "winnin://trending/topics_in_territories",
  what_are_trending_tags_in_sidebar: "winnin://trending/tags_sidebar",
  what_does_trending_creator_or_subtopic_mean: "winnin://trending/creator_subtopic_meaning",
  why_do_some_creators_appear_without_subscriber_count: "winnin://creators/missing_subscriber_count"
}, Wt = (e, t = 1) => {
  const n = Math.abs(e), r = e < 0 ? "-" : "";
  let s;
  if (n >= 1e12)
    s = (n / 1e12).toFixed(t) + "T";
  else if (n >= 1e9)
    s = (n / 1e9).toFixed(t) + "B";
  else if (n >= 1e6)
    s = (n / 1e6).toFixed(t) + "M";
  else if (n >= 1e3)
    s = (n / 1e3).toFixed(t) + "K";
  else
    return Number.isInteger(n) ? n : n.toFixed(t);
  return r + s;
};
function aR(e) {
  return e.match(/:(\w+)/g)?.map((t) => t.substring(1)) || [];
}
function En(e, t) {
  return Object.entries(t).reduce((n, [r, s]) => n?.replace(new RegExp(`:${r}\\b`, "g"), String(s)), e);
}
const ls = {
  earned: "earned",
  paid: "paid",
  selfContent: "proprietary-channels",
  owned: "proprietary-channels",
  // 'owned' is the same as 'selfContent'
  grouped: "overview",
  overview: "overview"
  // 'overview' is the same as 'grouped'
}, tf = {
  earned: {
    skipEarned: !1,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !0
  },
  paid: {
    skipEarned: !0,
    skipPaid: !1,
    skipGrouped: !0,
    skipSelfContent: !0
  },
  grouped: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !1,
    skipSelfContent: !0
  },
  selfContent: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !1
  },
  // 'overview' is the same as 'grouped'
  overview: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !1,
    skipSelfContent: !0
  },
  // 'owned' is the same as 'selfContent'
  owned: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !1
  }
}, oR = "#755CFF", Be = {
  // Charts
  graph_item_1: "#F7CA00",
  graph_item_2: "#F76D3E",
  graph_item_3: "#3BBA18",
  graph_item_4: "#005DFF",
  graph_item_5: "#EF377A",
  graph_item_6: "#C519F0",
  graph_item_7: "#0EC9F2",
  graph_item_8: "#FD3636",
  graph_item_9: "#A9DC1A",
  graph_item_10: "#FF9B21",
  graph_item_11: "#FA6FA2",
  graph_item_12: "#238508",
  graph_item_13: "#DC5BFC",
  graph_item_14: "#0443B1",
  graph_item_15: "#B5350A",
  graph_item_16: "#00A3FF",
  graph_item_17: "#1ECF8F",
  graph_item_18: "#C4A000",
  graph_item_19: "#D94411",
  graph_item_20: "#780404",
  graph_item_21: "#A2BBCD",
  graph_item_22: "#795E00",
  graph_item_23: "#9570FF",
  graph_item_24: "#0086A4",
  graph_item_25: "#510090",
  graph_item_26: "#9F007C",
  graph_item_27: "#1B654A",
  graph_item_28: "#474747",
  graph_item_29: "#909C00",
  graph_item_30: "#24FF00",
  winnin: oR
}, nf = [
  Be.graph_item_1,
  Be.graph_item_2,
  Be.graph_item_3,
  Be.graph_item_4,
  Be.graph_item_5,
  Be.graph_item_6,
  Be.graph_item_7,
  Be.graph_item_8,
  Be.graph_item_9,
  Be.graph_item_10,
  Be.graph_item_11,
  Be.graph_item_12,
  Be.graph_item_13,
  Be.graph_item_14,
  Be.graph_item_15,
  Be.graph_item_16,
  Be.graph_item_17,
  Be.graph_item_18,
  Be.graph_item_19,
  Be.graph_item_20,
  Be.graph_item_21,
  Be.graph_item_22,
  Be.graph_item_23,
  Be.graph_item_24,
  Be.graph_item_25,
  Be.graph_item_26,
  Be.graph_item_27,
  Be.graph_item_28,
  Be.graph_item_29,
  Be.graph_item_30
];
class uR {
  constructor() {
    this.baseUrl = "";
  }
}
const Pl = new uR(), un = (e) => e.replace(/\//g, "\\/").replace(/:\w+/g, `[^\\/\\s)"'\\],.;:><!?|#]+(?:\\.[^\\/\\s)"'\\],.;:><!?|#]+)*`) + `(?=[\\s)"'\\],;:><!?|#]|\\.(?:[^\\w]|$)|$)`, Ee = "winnin://", te = {
  // Brand Resources
  GET_KEY_FINDINGS: `${Ee}brands/me/key_findings/:language`,
  GET_MY_BRAND: `${Ee}brands/me`,
  GET_MY_COMPETITORS: `${Ee}brands/competitors`,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS: `${Ee}brands/share_of_engagement_content_and_views/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE: `${Ee}brands/engagement/histogram/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_VIEWS_HISTOGRAM: `${Ee}brands/views/histogram/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_POSTS_HISTOGRAM: `${Ee}brands/posts/histogram/:provider/:territoryType/:timeRangeInDays`,
  // Brand V2 Resources
  GET_MY_BRAND_V2: `${Ee}brands-v2/me`,
  GET_MY_COMPETITORS_V2: `${Ee}brands-v2/competitors`,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2: `${Ee}brands-v2/share_of_engagement_content_and_views/:provider/:timeRangeInDays`,
  GET_BRAND_ENGAGEMENT_HISTOGRAM_V2: `${Ee}brands-v2/engagement/histogram/:provider/:timeRangeInDays`,
  GET_BRAND_POSTS_HISTOGRAM_V2: `${Ee}brands-v2/posts/histogram/:provider/:timeRangeInDays`,
  GET_BRAND_VIEWS_HISTOGRAM_V2: `${Ee}brands-v2/views/histogram/:provider/:timeRangeInDays`,
  // Category Resources
  SHARE_OF_ATTENTION_V2: `${Ee}category/share_of_attention/v2/:year/:period`,
  SHARE_OF_ATTENTION: `${Ee}category/share_of_attention/:year/:period`,
  GET_TRENDING_TERRITORIES: `${Ee}category/trending_territories`,
  GET_CATEGORY: `${Ee}category`,
  // Category V2 Resources
  GET_SHARE_OF_ATTENTION_REASONING: `${Ee}category-v2/share_of_attention/v3/reasoning/:industryId/:year/:period`,
  SHARE_OF_ATTENTION_V3: `${Ee}category-v2/share_of_attention/v3/:industryId/:year/:period`,
  GET_SHARE_OF_ATTENTION_INDUSTRIES: `${Ee}category-v2/share_of_attention/v3/industries`,
  // Territory Resources
  GET_TERRITORY_NICHES_RESOURCE: `${Ee}territory/:territoryId/:timeRange/niches/:context`,
  GET_TERRITORY_VIDEOS_RESOURCE: `${Ee}territory/:territoryId/:timeRange/videos/:sortBy`,
  GET_TERRITORY_TAGS_RESOURCE: `${Ee}territory/:territoryId/:timeRange/tags`,
  GET_TERRITORY_FORMATS_RESOURCE: `${Ee}territory/:territoryId/:timeRange/formats`,
  GET_TERRITORY_CREATORS_RESOURCE: `${Ee}territory/:territoryId/:timeRange/creators`,
  GET_TERRITORY_PERFORMANCE_RESOURCE: `${Ee}territory/:territoryId/:timeRange/metrics`,
  GET_TERRITORY_AFFINITIES_RESOURCE: `${Ee}territory/:territoryId/:timeRange/affinity`,
  GET_TERRITORY_AUDIENCE_RESOURCE: `${Ee}territory/:territoryId/:timeRange/audience`,
  DEEP_ANALYSIS_RESOURCE: `${Ee}territory/:territoryId/:timeRange/deep_analysis`,
  GET_TERRITORY_RELEVANCE_RESOURCE: `${Ee}territory/:territoryId/:timeRange/relevance`,
  GET_TERRITORY_RESOURCE: `${Ee}territory/:territoryId`,
  // Other
  POST: `${Ee}post/:provider/:id`,
  CREATOR: `${Ee}creator/:provider/:id`,
  // Winnin Documentation Resources
  ABOUT_WINNIN: `${Ee}winnin/about`,
  ABOUT_RELEVANCE_INDEX: `${Ee}metrics/relevance_index`,
  ABOUT_AVG_ENGAGEMENT: `${Ee}metrics/avg_engagement`,
  ABOUT_AVG_VIEWS: `${Ee}metrics/avg_views`,
  ABOUT_TOTAL_VIDEOS: `${Ee}metrics/total_videos`,
  METRICS_VS_RETENTION: `${Ee}metrics/retention`,
  ABOUT_AFFINITY: `${Ee}metrics/affinity_calculation`,
  ABOUT_RELATIONSHIP_METRIC: `${Ee}metrics/relationship_calculation`,
  ABOUT_AUDIENCE: `${Ee}audience/data_collection`,
  WHAT_ARE_TRENDING_TOPICS_IN_TERRITORIES: `${Ee}trending/topics_in_territories`,
  WHAT_ARE_TRENDING_TAGS_IN_SIDEBAR: `${Ee}trending/tags_sidebar`,
  WHAT_DOES_TRENDING_CREATOR_OR_SUBTOPIC_MEAN: `${Ee}trending/creator_subtopic_meaning`,
  WHY_DO_SOME_CREATORS_APPEAR_WITHOUT_SUBSCRIBER_COUNT: `${Ee}creators/missing_subscriber_count`
}, Zi = {
  SHARE_OF_ATTENTION: [te.SHARE_OF_ATTENTION, te.GET_TRENDING_TERRITORIES],
  BRAND: [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]
}, He = Pl.baseUrl, Jn = {
  [te.GET_MY_BRAND]: `${He}/workspace/:panelId/brands/overview`,
  [te.GET_MY_COMPETITORS]: `${He}/workspace/:panelId/brands/overview`,
  [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]: `${He}/workspace/:panelId/brands/:tab`,
  [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2]: `${He}/workspace/:panelId/brands/overview`,
  [te.GET_KEY_FINDINGS]: `${He}/workspace/:panelId/brands/overview`,
  [te.SHARE_OF_ATTENTION]: `${He}/workspace/:panelId/share-of-attention`,
  [te.SHARE_OF_ATTENTION_V2]: `${He}/workspace/:panelId/share-of-attention`,
  [te.SHARE_OF_ATTENTION_V3]: `${He}/workspace/:panelId/share-of-attention`,
  [te.GET_TRENDING_TERRITORIES]: `${He}/workspace/:panelId`,
  [te.GET_TERRITORY_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/overview`,
  [te.GET_TERRITORY_TAGS_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/hashtags`,
  [te.GET_TERRITORY_NICHES_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/niches`,
  [te.GET_TERRITORY_FORMATS_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/formats`,
  [te.GET_TERRITORY_CREATORS_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/creators`,
  [te.GET_TERRITORY_VIDEOS_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/videos`,
  [te.GET_TERRITORY_PERFORMANCE_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/performance`,
  [te.GET_TERRITORY_AFFINITIES_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/people-also-watch`,
  [te.GET_TERRITORY_AUDIENCE_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/audience`,
  [te.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE]: `${He}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_VIEWS_HISTOGRAM]: `${He}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_POSTS_HISTOGRAM]: `${He}/workspace/:panelId/brands/:tab`,
  [te.GET_MY_BRAND_V2]: `${He}/workspace/:panelId/brands/overview`,
  [te.GET_MY_COMPETITORS_V2]: `${He}/workspace/:panelId/brands/overview`,
  [te.GET_BRAND_ENGAGEMENT_HISTOGRAM_V2]: `${He}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_POSTS_HISTOGRAM_V2]: `${He}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_VIEWS_HISTOGRAM_V2]: `${He}/workspace/:panelId/brands/:tab`,
  [te.GET_CATEGORY]: `${He}/workspace/:panelId/share-of-attention`,
  [te.GET_SHARE_OF_ATTENTION_INDUSTRIES]: `${He}/workspace/:panelId/share-of-attention`,
  [te.GET_SHARE_OF_ATTENTION_REASONING]: `${He}/workspace/:panelId/share-of-attention`,
  [te.GET_TERRITORY_RELEVANCE_RESOURCE]: `${He}/workspace/:panelId/:territoryType/:entityId/performance`,
  [te.POST]: `${He}/workspace/:panelId/post/:provider/:id`,
  [te.CREATOR]: `${He}/creator/:id/:provider`
}, at = {
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS: te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2: te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2,
  SHARE_OF_ATTENTION: te.SHARE_OF_ATTENTION,
  SHARE_OF_ATTENTION_V2: te.SHARE_OF_ATTENTION_V2,
  SHARE_OF_ATTENTION_V3: te.SHARE_OF_ATTENTION_V3,
  GET_TERRITORY_PERFORMANCE_RESOURCE: te.GET_TERRITORY_PERFORMANCE_RESOURCE,
  GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE: te.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE,
  POST: te.POST,
  CREATOR: te.CREATOR
}, cR = [
  {
    pattern: new RegExp(
      un(at.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS),
      "g"
    ),
    replacement: (e) => `<embed data-type="shares" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(
      un(at.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2),
      "g"
    ),
    replacement: (e) => `<embed data-type="shares" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(un(at.SHARE_OF_ATTENTION_V3), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(un(at.SHARE_OF_ATTENTION_V2), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(un(at.SHARE_OF_ATTENTION), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(un(at.GET_TERRITORY_PERFORMANCE_RESOURCE), "g"),
    replacement: (e) => `<embed data-type="territory-performance" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(
      un(at.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE),
      "g"
    ),
    replacement: (e) => `<embed data-type="brand-engagement-over-time" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(un(at.POST), "g"),
    replacement: (e) => `<embed data-type="post" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(un(at.CREATOR), "g"),
    replacement: (e) => `<embed data-type="creator" data-uri="${e}"></embed>`
  }
], Ol = {
  yt: "YouTube",
  fb: "Facebook",
  in: "Instagram",
  tt: "TikTok",
  tw: "Twitter",
  all: "All Providers"
}, ea = { fb: !0, tt: !0, yt: !0, in: !0, tw: !0 }, Dl = {
  topic: "topic",
  subtopic: "subtopic",
  global_topic: "global-topic",
  niche: "niche",
  saved_search: "saved-search",
  brand_territory: "brand",
  trending_subject: "trending-tag",
  trending: "trending",
  brand_group: "brand-group",
  tag: "tag",
  industry_topic: "industry-category"
};
class lR {
  /**
   * @param customSettings string in the format: `{ color: string }` or just the color string
   */
  parseColorFromSettings(t, n) {
    const r = t?.trim();
    try {
      const i = JSON.parse(r ?? "");
      if (i?.color)
        return i.color;
    } catch {
      if (r?.startsWith("#") || r?.startsWith("rgba") || r?.startsWith("rgb"))
        return r;
    }
    return nf[n % nf.length];
  }
  /**
   * Get color from brand, checking brand.color, brand.brandColor, then customSettings, then default
   */
  getBrandColor(t, n) {
    return t.color ? t.color : t.brandColor ? t.brandColor : this.parseColorFromSettings(t.customSettings, n);
  }
  getMetricKeyByTerritoryType(t) {
    const n = {
      earned: "earnedTerritory",
      paid: "paidTerritory",
      selfContent: "selfContentTerritory",
      owned: "selfContentTerritory",
      // 'owned' is the same as 'selfContent'
      grouped: "groupedTerritory",
      overview: "groupedTerritory"
      // 'overview' is the same as 'grouped'
    };
    return n[t] || n.grouped;
  }
}
const qr = new lR(), rf = (e) => {
  const n = [3, 6, 12, 24, 36, 61], r = Math.floor(e / 30);
  return n.includes(r) ? {
    timeUnit: "month",
    timeValue: r
  } : {
    timeUnit: "day",
    timeValue: e
  };
}, dR = (e) => {
  const t = e.split(":");
  if (t.length === 2) {
    const n = new Date(t[0]), r = new Date(t[1]);
    if (!isNaN(n.getTime()) && !isNaN(r.getTime()))
      return {
        gte: Math.floor(n.getTime()),
        lte: Math.floor(r.getTime())
      };
  }
}, _u = (e) => typeof e == "string" && e.includes(":") ? { publishedAt: dR(e), timeRange: null } : typeof e == "number" ? { timeRange: rf(e), publishedAt: null } : typeof e == "string" && !isNaN(Number(e)) ? { timeRange: rf(Number(e)), publishedAt: null } : {}, hR = function() {
  if (window.location.hostname === "localhost")
    return "local";
  const t = window.location.href, n = /^([^.]+\/)(\b((?!insights\b)[\s\S])+)/;
  if (n.test(t)) {
    const s = n.exec(t);
    if (!s)
      return "production";
    switch (s[2]) {
      // temporary production environment for testing
      case "production.":
        return "production";
      case "staging.":
        return "staging";
      case "local.":
        return "local";
      case "dev.":
        return "development";
      default:
        return s[2].includes("testprod") ? "staging" : "development";
    }
  }
  return "production";
}, fR = Object.values(at), pR = Object.values(te).filter((e) => !fR.includes(e)).map(un), mR = (e) => pR.reduce((t, n) => {
  const r = new RegExp(
    // Negative lookbehind to avoid matching URIs preceded by quotes
    `(?<!")(?<!')(${n})(?!")(?!')`,
    "g"
  );
  return t.replace(r, "");
}, e), sf = (e, t) => {
  const n = "yt|fb|in|tt|tw", r = new RegExp(
    `(?<!\\]\\([^\\)]*?)(?:winnin://)?(${t}):(${n}):([a-zA-Z0-9_-]+)(?=\\s|$|\\.|,|\\))`,
    "g"
  ), s = new RegExp(
    `\\[([^\\]]+)\\]\\((?:winnin://)?(${t}):(${n}):([a-zA-Z0-9_-]+)\\)`,
    "g"
  );
  let i = e;
  return i = i.replace(
    s,
    (a, o, u, c, l) => `winnin://${u}/${c}/${l}`
  ), i = i.replace(
    r,
    (a, o, u, c) => `winnin://${o}/${u}/${c}`
  ), i;
}, eb = (e, t, n = "overview") => {
  const [r, s] = t.split("."), i = Dl[r];
  return i ? `${Pl.baseUrl}/workspace/${e}/${i}/${s}/${n}` : "";
}, gR = (e, t) => {
  const n = "global_topic|industry_topic|topic|subtopic|niche|saved_search|brand_territory|trending_subject|trending|brand_group", r = new RegExp(
    // 1) In markdown link format with and without "winnin://" [text](winnin://brand_territory.abc-123) or [text](brand_territory.abc-123)
    `\\[(?<text>[^\\]]+)\\]\\((?:winnin://)?(?<fullMatch>(${n})\\.([a-zA-Z0-9_-]+))\\)|\\[(?<onlyBrackets>(${n})\\.([a-zA-Z0-9_-]+))\\]|(?<!\\]\\([^\\)]*?)(?<!/)(?<!winnin://)(?<loose>(${n})\\.([a-zA-Z0-9_-]+))(?!/|\\?)(?=\\s|$|\\.|,|\\)|\\])`,
    "g"
  );
  return t.replace(r, (i, ...a) => {
    const o = a.at(-1), u = o.fullMatch || o.onlyBrackets || o.loose;
    if (!u) return i;
    const c = eb(e, u);
    return `[${o.text || u}](${c})`;
  });
}, ER = (e) => cR.reduce((t, { pattern: n, replacement: r }) => t.replace(n, r), e);
function ut(e, t = {}) {
  const n = typeof t == "string" ? { path: t, exact: !1, strict: !1, sensitive: !1 } : {
    path: t.path,
    exact: t.exact ?? !1,
    strict: t.strict ?? !1,
    sensitive: t.sensitive ?? !1
  }, { path: r, exact: s, strict: i, sensitive: a } = n;
  if (!r) return null;
  const o = [], u = r.replace(/\/$/, i ? "/" : "/?").replace(/:(\w+)/g, (g, _) => (o.push({ name: _ }), "([^\\/]+)")).replace(/\*/g, "(.*)"), c = a ? "" : "i", h = new RegExp("^" + u + (s ? "$" : ""), c).exec(e);
  if (!h) return null;
  const m = h[0], p = e === m;
  if (s && !p) return null;
  const E = o.reduce(
    (g, _, b) => (g[_.name] = h[b + 1] || "", g),
    {}
  );
  return { path: r, url: m, isExact: p, params: E };
}
const bR = (e, t) => t.replace(
  /<embed data-type="(shares|share-of-attention)" data-uri="([^"]+)"><\/embed>/g,
  (n, r, s) => {
    if (!Object.values(te).find(
      (o) => ut(s, { path: o, exact: !0 })
    )) return n;
    const a = En(Jn[te.SHARE_OF_ATTENTION_V2], {
      panelId: e
    });
    return `[${a}](${a})`;
  }
);
class Ll {
  constructor(t, n) {
    this.workspaceId = t, this.text = n;
  }
  replaceText(t) {
    return this.text = t, this;
  }
  /**
   * Replaces territory IDs in the text with markdown links.
   */
  replaceTerritoryIds() {
    const t = gR(this.workspaceId, this.text);
    return this.replaceText(t);
  }
  /**
   * Replaces post IDs in the text with markdown links.
   */
  replacePostIds() {
    const t = sf(this.text, "post");
    return this.replaceText(t);
  }
  /**
   * Replaces creator IDs in the text with markdown links.
   */
  replaceCreatorIds() {
    const t = sf(this.text, "creator");
    return this.replaceText(t);
  }
  /**
   * Replaces specific URI patterns in the text with corresponding widget embed tags.
   */
  replaceWidgets() {
    const t = ER(this.text);
    return this.replaceText(t);
  }
  cleanUnusedURIs() {
    const t = mR(this.text);
    return this.replaceText(t);
  }
  /**
   * Replaces widget embed tags with macroarea links.
   */
  replaceWidgetTagWithLink() {
    const t = bR(this.workspaceId, this.text);
    return this.replaceText(t);
  }
  /**
   * @returns The final text with all replacements made.
   */
  build() {
    return this.text;
  }
}
const _R = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, TR = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, AR = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function yR(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    xR(e);
    return;
  }
  return t;
}
function xR(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function tb(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const n = e.trim();
  if (n.length <= 9)
    switch (n.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!AR.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (_R.test(e) || TR.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, yR);
    }
    return JSON.parse(e);
  } catch (r) {
    if (t.strict)
      throw r;
    return e;
  }
}
function af(e) {
  if (!e)
    return {
      id: null,
      metadata: null,
      data: null,
      mimetype: null,
      encoding: null,
      path: null
    };
  if (typeof e.data == "string")
    try {
      e.data = tb(e.data);
    } catch (t) {
      console.error("Failed to parse tool result data:", t), e.data = null;
    }
  return e;
}
function nb(e) {
  if (!e) return [];
  if (typeof e == "string")
    try {
      return e = tb(e), Array.isArray(e) ? e.map(af) : [af(e)];
    } catch (t) {
      return console.error("Failed to parse tool result:", t), [];
    }
  return e;
}
const of = {
  local: "http://localhost:3000",
  development: "https://zai-chat.dev.insights.winnin.com",
  staging: "https://zai-chat-staging.insights.winnin.com",
  production: "https://chat.insights.winnin.com"
};
class CR {
  constructor(t) {
    this.workspaceId = t.workspaceId, this.getValidToken = t.getValidToken, this.userId = t.userId, this.userEmail = t.userEmail, this.abortSignal = t.abortSignal, this.baseUrl = this.getBaseURLByEnvironment();
  }
  getBaseURLByEnvironment() {
    const t = hR();
    return of[t] || of.development;
  }
  async getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await this.getValidToken()}`
    };
  }
  async getPrePrompts(t) {
    const n = new URLSearchParams({ language: t }), r = `${this.baseUrl}/api/workspace/${this.workspaceId}/prompt?${n.toString()}`;
    try {
      const s = await this.getHeaders(), i = await fetch(r, {
        method: "GET",
        headers: s
      });
      if (!i.ok)
        throw new Error(`Failed to fetch prompts: ${i.statusText}`);
      return await i.json() ?? [];
    } catch (s) {
      throw console.error({
        log: "Zai Chat - Error to fetch pre prompts from backend",
        query: { name: r },
        error: s
      }), s;
    }
  }
  async getThreads() {
    const t = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads`;
    try {
      const n = await this.getHeaders(), r = await fetch(t, {
        method: "GET",
        headers: n
      });
      if (!r.ok)
        throw new Error(`Failed to fetch threads: ${r.statusText}`);
      return await r.json();
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch threads from backend",
        query: { name: t },
        error: n
      }), n;
    }
  }
  async getMessagesByThreadId(t) {
    const n = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads/${t}`;
    try {
      const r = await this.getHeaders(), s = await fetch(n, {
        method: "GET",
        headers: r
      });
      if (!s.ok)
        throw new Error(`Failed to fetch thread: ${s.statusText}`);
      return await s.json();
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch messages by thread ID from backend",
        query: { name: n },
        error: r
      }), r;
    }
  }
  async deleteThread(t) {
    const n = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads/${t}`;
    try {
      const r = await this.getHeaders(), s = await fetch(n, {
        method: "DELETE",
        headers: r
      });
      if (!s.ok)
        throw new Error(`Failed to delete thread: ${s.statusText}`);
      return await s.json();
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error deleting thread in backend",
        query: { name: n, variables: { threadId: t, workspaceId: this.workspaceId } },
        error: r
      }), r;
    }
  }
  async postMessageToThread(t, n, r = {}) {
    const s = `${this.baseUrl}/api/workspace/${this.workspaceId}/chat`, i = JSON.stringify({
      thread: t,
      ...n
    });
    try {
      const a = await this.getHeaders(), o = await fetch(s, {
        method: "POST",
        headers: a,
        body: i,
        signal: r?.abortSignal || this.abortSignal
      });
      if (!o.ok)
        throw new Error(`Failed to post message: ${o.statusText}`);
      return o.body?.getReader();
    } catch (a) {
      throw console.error({
        log: "Zai Chat - Error to post message to thread in backend",
        query: { name: s, variables: { body: i } },
        error: a
      }), a;
    }
  }
  // This method is not currently being used, but it will be useful in the future when we migrate message processing to the frontend.
  static processThreadMessages(t, n) {
    const r = t.filter((a) => a.role === "tool").reduce((a, o) => {
      const u = o;
      return a[u.content.kwargs.tool_call_id] = {
        content: u.content.kwargs.content,
        status: u.content.kwargs.status
      }, a;
    }, {});
    return t.filter((a) => a.role !== "tool").map((a) => {
      switch (a.role) {
        case "user":
          return {
            id: crypto.randomUUID(),
            metadata: {},
            role: "user",
            attachments: [],
            content: [{ type: "text", text: a.content }],
            createdAt: new Date(a.created_at),
            status: { type: "complete", reason: "stop" }
          };
        case "assistant": {
          if (typeof a.content == "string") {
            const m = new Ll(n, a.content).replaceTerritoryIds().replacePostIds().replaceCreatorIds().replaceWidgets().cleanUnusedURIs().build();
            return {
              id: crypto.randomUUID(),
              metadata: {},
              role: "assistant",
              content: [{ type: "text", text: m }],
              createdAt: new Date(a.created_at),
              status: { type: "complete", reason: "stop" }
            };
          }
          const o = a.content;
          let u;
          try {
            u = JSON.parse(o.arguments);
          } catch {
            console.log("Failed to parse arguments:", o.arguments);
          }
          const c = u?.resource_uri;
          let l = ZE[o.name];
          l && (l = En(l, u));
          const h = r[o.id];
          return {
            id: crypto.randomUUID(),
            metadata: {},
            createdAt: new Date(a.created_at),
            role: "assistant",
            content: [
              {
                type: "tool-call",
                toolCallId: o.id,
                toolName: o.name,
                args: u,
                argsText: c || l,
                result: nb(h?.content) || null
              }
            ],
            status: h ? { type: "complete", reason: "stop" } : { type: "requires-action", reason: "tool-calls" }
          };
        }
        default:
          return {};
      }
    }).reduce(
      (a, o) => {
        const u = a.messages[a.messages.length - 1] || null;
        if (u?.message.role === o.role && u.message.id === a.lastId) {
          const c = a.messages[a.messages.length - 1].message.content;
          a.messages[a.messages.length - 1].message.content = [...c, ...o.content], a.messages[a.messages.length - 1].message.status = o.status;
        } else {
          const c = o.id;
          a.messages.push({ message: o, parentId: a.lastId }), a.lastId = c;
        }
        return a;
      },
      { messages: [], lastId: null }
    ).messages;
  }
}
const Ml = (e) => {
  const { workspaceId: t, userId: n, userEmail: r, getValidToken: s } = pt();
  return ie(
    () => new CR({
      workspaceId: t,
      getValidToken: s,
      userId: n,
      userEmail: r,
      abortSignal: e?.abortSignal
    }),
    [t, n, r, s, e?.abortSignal]
  );
}, rb = he(
  ({ children: e, currentThread: t }) => {
    const n = Ml(), r = J((u) => u?.threadListItem?.remoteId), s = J((u) => u?.threadListItem?.id), i = J((u) => u?.threads?.mainThreadId);
    s === i && (t.current = r ?? null);
    const a = ie(
      () => ({
        async load() {
          return r ? { messages: await n.getMessagesByThreadId(r) } : { messages: [] };
        },
        async append() {
        }
      }),
      [r, n]
    ), o = ie(() => ({ history: a }), [a]);
    return /* @__PURE__ */ d.jsx(Kc, { adapters: o, children: e });
  }
);
rb.displayName = "ThreadAdapterProvider";
const SR = ({ currentThread: e }) => (t) => /* @__PURE__ */ d.jsx(rb, { currentThread: e, ...t });
new TextEncoder();
const IR = 4096;
function sb(e, t, n) {
  let r = t;
  const s = r + n, i = [];
  let a = "";
  for (; r < s; ) {
    const o = e[r++];
    if ((o & 128) === 0)
      i.push(o);
    else if ((o & 224) === 192) {
      const u = e[r++] & 63;
      i.push((o & 31) << 6 | u);
    } else if ((o & 240) === 224) {
      const u = e[r++] & 63, c = e[r++] & 63;
      i.push((o & 31) << 12 | u << 6 | c);
    } else if ((o & 248) === 240) {
      const u = e[r++] & 63, c = e[r++] & 63, l = e[r++] & 63;
      let h = (o & 7) << 18 | u << 12 | c << 6 | l;
      h > 65535 && (h -= 65536, i.push(h >>> 10 & 1023 | 55296), h = 56320 | h & 1023), i.push(h);
    } else
      i.push(o);
    i.length >= IR && (a += String.fromCharCode(...i), i.length = 0);
  }
  return i.length > 0 && (a += String.fromCharCode(...i)), a;
}
const wR = new TextDecoder(), vR = 200;
function NR(e, t, n) {
  const r = e.subarray(t, t + n);
  return wR.decode(r);
}
function kR(e, t, n) {
  return n > vR ? NR(e, t, n) : sb(e, t, n);
}
class ta {
  constructor(t, n) {
    k(this, "type");
    k(this, "data");
    this.type = t, this.data = n;
  }
}
class Mt extends Error {
  constructor(t) {
    super(t);
    const n = Object.create(Mt.prototype);
    Object.setPrototypeOf(this, n), Object.defineProperty(this, "name", {
      configurable: !0,
      enumerable: !1,
      value: Mt.name
    });
  }
}
const Ds = 4294967295;
function RR(e, t, n) {
  const r = Math.floor(n / 4294967296), s = n;
  e.setUint32(t, r), e.setUint32(t + 4, s);
}
function ib(e, t) {
  const n = e.getInt32(t), r = e.getUint32(t + 4);
  return n * 4294967296 + r;
}
function PR(e, t) {
  const n = e.getUint32(t), r = e.getUint32(t + 4);
  return n * 4294967296 + r;
}
const OR = -1, DR = 4294967296 - 1, LR = 17179869184 - 1;
function MR({ sec: e, nsec: t }) {
  if (e >= 0 && t >= 0 && e <= LR)
    if (t === 0 && e <= DR) {
      const n = new Uint8Array(4);
      return new DataView(n.buffer).setUint32(0, e), n;
    } else {
      const n = e / 4294967296, r = e & 4294967295, s = new Uint8Array(8), i = new DataView(s.buffer);
      return i.setUint32(0, t << 2 | n & 3), i.setUint32(4, r), s;
    }
  else {
    const n = new Uint8Array(12), r = new DataView(n.buffer);
    return r.setUint32(0, t), RR(r, 4, e), n;
  }
}
function HR(e) {
  const t = e.getTime(), n = Math.floor(t / 1e3), r = (t - n * 1e3) * 1e6, s = Math.floor(r / 1e9);
  return {
    sec: n + s,
    nsec: r - s * 1e9
  };
}
function BR(e) {
  if (e instanceof Date) {
    const t = HR(e);
    return MR(t);
  } else
    return null;
}
function UR(e) {
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength);
  switch (e.byteLength) {
    case 4:
      return { sec: t.getUint32(0), nsec: 0 };
    case 8: {
      const n = t.getUint32(0), r = t.getUint32(4), s = (n & 3) * 4294967296 + r, i = n >>> 2;
      return { sec: s, nsec: i };
    }
    case 12: {
      const n = ib(t, 4), r = t.getUint32(0);
      return { sec: n, nsec: r };
    }
    default:
      throw new Mt(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${e.length}`);
  }
}
function FR(e) {
  const t = UR(e);
  return new Date(t.sec * 1e3 + t.nsec / 1e6);
}
const jR = {
  type: OR,
  encode: BR,
  decode: FR
}, Wa = class Wa {
  constructor() {
    // ensures ExtensionCodecType<X> matches ExtensionCodec<X>
    // this will make type errors a lot more clear
    // eslint-disable-next-line @typescript-eslint/naming-convention
    k(this, "__brand");
    // built-in extensions
    k(this, "builtInEncoders", []);
    k(this, "builtInDecoders", []);
    // custom extensions
    k(this, "encoders", []);
    k(this, "decoders", []);
    this.register(jR);
  }
  register({ type: t, encode: n, decode: r }) {
    if (t >= 0)
      this.encoders[t] = n, this.decoders[t] = r;
    else {
      const s = -1 - t;
      this.builtInEncoders[s] = n, this.builtInDecoders[s] = r;
    }
  }
  tryToEncode(t, n) {
    for (let r = 0; r < this.builtInEncoders.length; r++) {
      const s = this.builtInEncoders[r];
      if (s != null) {
        const i = s(t, n);
        if (i != null) {
          const a = -1 - r;
          return new ta(a, i);
        }
      }
    }
    for (let r = 0; r < this.encoders.length; r++) {
      const s = this.encoders[r];
      if (s != null) {
        const i = s(t, n);
        if (i != null) {
          const a = r;
          return new ta(a, i);
        }
      }
    }
    return t instanceof ta ? t : null;
  }
  decode(t, n, r) {
    const s = n < 0 ? this.builtInDecoders[-1 - n] : this.decoders[n];
    return s ? s(t, n, r) : new ta(n, t);
  }
};
k(Wa, "defaultCodec", new Wa());
let Ec = Wa;
function $R(e) {
  return e instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer;
}
function uf(e) {
  return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : $R(e) ? new Uint8Array(e) : Uint8Array.from(e);
}
function Tu(e) {
  return `${e < 0 ? "-" : ""}0x${Math.abs(e).toString(16).padStart(2, "0")}`;
}
const zR = 16, VR = 16;
class YR {
  constructor(t = zR, n = VR) {
    k(this, "hit", 0);
    k(this, "miss", 0);
    k(this, "caches");
    k(this, "maxKeyLength");
    k(this, "maxLengthPerKey");
    this.maxKeyLength = t, this.maxLengthPerKey = n, this.caches = [];
    for (let r = 0; r < this.maxKeyLength; r++)
      this.caches.push([]);
  }
  canBeCached(t) {
    return t > 0 && t <= this.maxKeyLength;
  }
  find(t, n, r) {
    const s = this.caches[r - 1];
    e: for (const i of s) {
      const a = i.bytes;
      for (let o = 0; o < r; o++)
        if (a[o] !== t[n + o])
          continue e;
      return i.str;
    }
    return null;
  }
  store(t, n) {
    const r = this.caches[t.length - 1], s = { bytes: t, str: n };
    r.length >= this.maxLengthPerKey ? r[Math.random() * r.length | 0] = s : r.push(s);
  }
  decode(t, n, r) {
    const s = this.find(t, n, r);
    if (s != null)
      return this.hit++, s;
    this.miss++;
    const i = sb(t, n, r), a = Uint8Array.prototype.slice.call(t, n, n + r);
    return this.store(a, i), i;
  }
}
const bc = "array", Qs = "map_key", ab = "map_value", GR = (e) => {
  if (typeof e == "string" || typeof e == "number")
    return e;
  throw new Mt("The type of key must be string or number but " + typeof e);
};
class WR {
  constructor() {
    k(this, "stack", []);
    k(this, "stackHeadPosition", -1);
  }
  get length() {
    return this.stackHeadPosition + 1;
  }
  top() {
    return this.stack[this.stackHeadPosition];
  }
  pushArrayState(t) {
    const n = this.getUninitializedStateFromPool();
    n.type = bc, n.position = 0, n.size = t, n.array = new Array(t);
  }
  pushMapState(t) {
    const n = this.getUninitializedStateFromPool();
    n.type = Qs, n.readCount = 0, n.size = t, n.map = {};
  }
  getUninitializedStateFromPool() {
    if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
      const t = {
        type: void 0,
        size: 0,
        array: void 0,
        position: 0,
        readCount: 0,
        map: void 0,
        key: null
      };
      this.stack.push(t);
    }
    return this.stack[this.stackHeadPosition];
  }
  release(t) {
    if (this.stack[this.stackHeadPosition] !== t)
      throw new Error("Invalid stack state. Released state is not on top of the stack.");
    if (t.type === bc) {
      const r = t;
      r.size = 0, r.array = void 0, r.position = 0, r.type = void 0;
    }
    if (t.type === Qs || t.type === ab) {
      const r = t;
      r.size = 0, r.map = void 0, r.readCount = 0, r.type = void 0;
    }
    this.stackHeadPosition--;
  }
  reset() {
    this.stack.length = 0, this.stackHeadPosition = -1;
  }
}
const Ls = -1, Hl = new DataView(new ArrayBuffer(0)), qR = new Uint8Array(Hl.buffer);
try {
  Hl.getInt8(0);
} catch (e) {
  if (!(e instanceof RangeError))
    throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
const cf = new RangeError("Insufficient data"), KR = new YR();
class Bl {
  constructor(t) {
    k(this, "extensionCodec");
    k(this, "context");
    k(this, "useBigInt64");
    k(this, "rawStrings");
    k(this, "maxStrLength");
    k(this, "maxBinLength");
    k(this, "maxArrayLength");
    k(this, "maxMapLength");
    k(this, "maxExtLength");
    k(this, "keyDecoder");
    k(this, "mapKeyConverter");
    k(this, "totalPos", 0);
    k(this, "pos", 0);
    k(this, "view", Hl);
    k(this, "bytes", qR);
    k(this, "headByte", Ls);
    k(this, "stack", new WR());
    k(this, "entered", !1);
    this.extensionCodec = t?.extensionCodec ?? Ec.defaultCodec, this.context = t?.context, this.useBigInt64 = t?.useBigInt64 ?? !1, this.rawStrings = t?.rawStrings ?? !1, this.maxStrLength = t?.maxStrLength ?? Ds, this.maxBinLength = t?.maxBinLength ?? Ds, this.maxArrayLength = t?.maxArrayLength ?? Ds, this.maxMapLength = t?.maxMapLength ?? Ds, this.maxExtLength = t?.maxExtLength ?? Ds, this.keyDecoder = t?.keyDecoder !== void 0 ? t.keyDecoder : KR, this.mapKeyConverter = t?.mapKeyConverter ?? GR;
  }
  clone() {
    return new Bl({
      extensionCodec: this.extensionCodec,
      context: this.context,
      useBigInt64: this.useBigInt64,
      rawStrings: this.rawStrings,
      maxStrLength: this.maxStrLength,
      maxBinLength: this.maxBinLength,
      maxArrayLength: this.maxArrayLength,
      maxMapLength: this.maxMapLength,
      maxExtLength: this.maxExtLength,
      keyDecoder: this.keyDecoder
    });
  }
  reinitializeState() {
    this.totalPos = 0, this.headByte = Ls, this.stack.reset();
  }
  setBuffer(t) {
    const n = uf(t);
    this.bytes = n, this.view = new DataView(n.buffer, n.byteOffset, n.byteLength), this.pos = 0;
  }
  appendBuffer(t) {
    if (this.headByte === Ls && !this.hasRemaining(1))
      this.setBuffer(t);
    else {
      const n = this.bytes.subarray(this.pos), r = uf(t), s = new Uint8Array(n.length + r.length);
      s.set(n), s.set(r, n.length), this.setBuffer(s);
    }
  }
  hasRemaining(t) {
    return this.view.byteLength - this.pos >= t;
  }
  createExtraByteError(t) {
    const { view: n, pos: r } = this;
    return new RangeError(`Extra ${n.byteLength - r} of ${n.byteLength} byte(s) found at buffer[${t}]`);
  }
  /**
   * @throws {@link DecodeError}
   * @throws {@link RangeError}
   */
  decode(t) {
    if (this.entered)
      return this.clone().decode(t);
    try {
      this.entered = !0, this.reinitializeState(), this.setBuffer(t);
      const n = this.doDecodeSync();
      if (this.hasRemaining(1))
        throw this.createExtraByteError(this.pos);
      return n;
    } finally {
      this.entered = !1;
    }
  }
  *decodeMulti(t) {
    if (this.entered) {
      yield* this.clone().decodeMulti(t);
      return;
    }
    try {
      for (this.entered = !0, this.reinitializeState(), this.setBuffer(t); this.hasRemaining(1); )
        yield this.doDecodeSync();
    } finally {
      this.entered = !1;
    }
  }
  async decodeAsync(t) {
    if (this.entered)
      return this.clone().decodeAsync(t);
    try {
      this.entered = !0;
      let n = !1, r;
      for await (const o of t) {
        if (n)
          throw this.entered = !1, this.createExtraByteError(this.totalPos);
        this.appendBuffer(o);
        try {
          r = this.doDecodeSync(), n = !0;
        } catch (u) {
          if (!(u instanceof RangeError))
            throw u;
        }
        this.totalPos += this.pos;
      }
      if (n) {
        if (this.hasRemaining(1))
          throw this.createExtraByteError(this.totalPos);
        return r;
      }
      const { headByte: s, pos: i, totalPos: a } = this;
      throw new RangeError(`Insufficient data in parsing ${Tu(s)} at ${a} (${i} in the current buffer)`);
    } finally {
      this.entered = !1;
    }
  }
  decodeArrayStream(t) {
    return this.decodeMultiAsync(t, !0);
  }
  decodeStream(t) {
    return this.decodeMultiAsync(t, !1);
  }
  async *decodeMultiAsync(t, n) {
    if (this.entered) {
      yield* this.clone().decodeMultiAsync(t, n);
      return;
    }
    try {
      this.entered = !0;
      let r = n, s = -1;
      for await (const i of t) {
        if (n && s === 0)
          throw this.createExtraByteError(this.totalPos);
        this.appendBuffer(i), r && (s = this.readArraySize(), r = !1, this.complete());
        try {
          for (; yield this.doDecodeSync(), --s !== 0; )
            ;
        } catch (a) {
          if (!(a instanceof RangeError))
            throw a;
        }
        this.totalPos += this.pos;
      }
    } finally {
      this.entered = !1;
    }
  }
  doDecodeSync() {
    e: for (; ; ) {
      const t = this.readHeadByte();
      let n;
      if (t >= 224)
        n = t - 256;
      else if (t < 192)
        if (t < 128)
          n = t;
        else if (t < 144) {
          const s = t - 128;
          if (s !== 0) {
            this.pushMapState(s), this.complete();
            continue e;
          } else
            n = {};
        } else if (t < 160) {
          const s = t - 144;
          if (s !== 0) {
            this.pushArrayState(s), this.complete();
            continue e;
          } else
            n = [];
        } else {
          const s = t - 160;
          n = this.decodeString(s, 0);
        }
      else if (t === 192)
        n = null;
      else if (t === 194)
        n = !1;
      else if (t === 195)
        n = !0;
      else if (t === 202)
        n = this.readF32();
      else if (t === 203)
        n = this.readF64();
      else if (t === 204)
        n = this.readU8();
      else if (t === 205)
        n = this.readU16();
      else if (t === 206)
        n = this.readU32();
      else if (t === 207)
        this.useBigInt64 ? n = this.readU64AsBigInt() : n = this.readU64();
      else if (t === 208)
        n = this.readI8();
      else if (t === 209)
        n = this.readI16();
      else if (t === 210)
        n = this.readI32();
      else if (t === 211)
        this.useBigInt64 ? n = this.readI64AsBigInt() : n = this.readI64();
      else if (t === 217) {
        const s = this.lookU8();
        n = this.decodeString(s, 1);
      } else if (t === 218) {
        const s = this.lookU16();
        n = this.decodeString(s, 2);
      } else if (t === 219) {
        const s = this.lookU32();
        n = this.decodeString(s, 4);
      } else if (t === 220) {
        const s = this.readU16();
        if (s !== 0) {
          this.pushArrayState(s), this.complete();
          continue e;
        } else
          n = [];
      } else if (t === 221) {
        const s = this.readU32();
        if (s !== 0) {
          this.pushArrayState(s), this.complete();
          continue e;
        } else
          n = [];
      } else if (t === 222) {
        const s = this.readU16();
        if (s !== 0) {
          this.pushMapState(s), this.complete();
          continue e;
        } else
          n = {};
      } else if (t === 223) {
        const s = this.readU32();
        if (s !== 0) {
          this.pushMapState(s), this.complete();
          continue e;
        } else
          n = {};
      } else if (t === 196) {
        const s = this.lookU8();
        n = this.decodeBinary(s, 1);
      } else if (t === 197) {
        const s = this.lookU16();
        n = this.decodeBinary(s, 2);
      } else if (t === 198) {
        const s = this.lookU32();
        n = this.decodeBinary(s, 4);
      } else if (t === 212)
        n = this.decodeExtension(1, 0);
      else if (t === 213)
        n = this.decodeExtension(2, 0);
      else if (t === 214)
        n = this.decodeExtension(4, 0);
      else if (t === 215)
        n = this.decodeExtension(8, 0);
      else if (t === 216)
        n = this.decodeExtension(16, 0);
      else if (t === 199) {
        const s = this.lookU8();
        n = this.decodeExtension(s, 1);
      } else if (t === 200) {
        const s = this.lookU16();
        n = this.decodeExtension(s, 2);
      } else if (t === 201) {
        const s = this.lookU32();
        n = this.decodeExtension(s, 4);
      } else
        throw new Mt(`Unrecognized type byte: ${Tu(t)}`);
      this.complete();
      const r = this.stack;
      for (; r.length > 0; ) {
        const s = r.top();
        if (s.type === bc)
          if (s.array[s.position] = n, s.position++, s.position === s.size)
            n = s.array, r.release(s);
          else
            continue e;
        else if (s.type === Qs) {
          if (n === "__proto__")
            throw new Mt("The key __proto__ is not allowed");
          s.key = this.mapKeyConverter(n), s.type = ab;
          continue e;
        } else if (s.map[s.key] = n, s.readCount++, s.readCount === s.size)
          n = s.map, r.release(s);
        else {
          s.key = null, s.type = Qs;
          continue e;
        }
      }
      return n;
    }
  }
  readHeadByte() {
    return this.headByte === Ls && (this.headByte = this.readU8()), this.headByte;
  }
  complete() {
    this.headByte = Ls;
  }
  readArraySize() {
    const t = this.readHeadByte();
    switch (t) {
      case 220:
        return this.readU16();
      case 221:
        return this.readU32();
      default: {
        if (t < 160)
          return t - 144;
        throw new Mt(`Unrecognized array type byte: ${Tu(t)}`);
      }
    }
  }
  pushMapState(t) {
    if (t > this.maxMapLength)
      throw new Mt(`Max length exceeded: map length (${t}) > maxMapLengthLength (${this.maxMapLength})`);
    this.stack.pushMapState(t);
  }
  pushArrayState(t) {
    if (t > this.maxArrayLength)
      throw new Mt(`Max length exceeded: array length (${t}) > maxArrayLength (${this.maxArrayLength})`);
    this.stack.pushArrayState(t);
  }
  decodeString(t, n) {
    return !this.rawStrings || this.stateIsMapKey() ? this.decodeUtf8String(t, n) : this.decodeBinary(t, n);
  }
  /**
   * @throws {@link RangeError}
   */
  decodeUtf8String(t, n) {
    if (t > this.maxStrLength)
      throw new Mt(`Max length exceeded: UTF-8 byte length (${t}) > maxStrLength (${this.maxStrLength})`);
    if (this.bytes.byteLength < this.pos + n + t)
      throw cf;
    const r = this.pos + n;
    let s;
    return this.stateIsMapKey() && this.keyDecoder?.canBeCached(t) ? s = this.keyDecoder.decode(this.bytes, r, t) : s = kR(this.bytes, r, t), this.pos += n + t, s;
  }
  stateIsMapKey() {
    return this.stack.length > 0 ? this.stack.top().type === Qs : !1;
  }
  /**
   * @throws {@link RangeError}
   */
  decodeBinary(t, n) {
    if (t > this.maxBinLength)
      throw new Mt(`Max length exceeded: bin length (${t}) > maxBinLength (${this.maxBinLength})`);
    if (!this.hasRemaining(t + n))
      throw cf;
    const r = this.pos + n, s = this.bytes.subarray(r, r + t);
    return this.pos += n + t, s;
  }
  decodeExtension(t, n) {
    if (t > this.maxExtLength)
      throw new Mt(`Max length exceeded: ext length (${t}) > maxExtLength (${this.maxExtLength})`);
    const r = this.view.getInt8(this.pos + n), s = this.decodeBinary(
      t,
      n + 1
      /* extType */
    );
    return this.extensionCodec.decode(s, r, this.context);
  }
  lookU8() {
    return this.view.getUint8(this.pos);
  }
  lookU16() {
    return this.view.getUint16(this.pos);
  }
  lookU32() {
    return this.view.getUint32(this.pos);
  }
  readU8() {
    const t = this.view.getUint8(this.pos);
    return this.pos++, t;
  }
  readI8() {
    const t = this.view.getInt8(this.pos);
    return this.pos++, t;
  }
  readU16() {
    const t = this.view.getUint16(this.pos);
    return this.pos += 2, t;
  }
  readI16() {
    const t = this.view.getInt16(this.pos);
    return this.pos += 2, t;
  }
  readU32() {
    const t = this.view.getUint32(this.pos);
    return this.pos += 4, t;
  }
  readI32() {
    const t = this.view.getInt32(this.pos);
    return this.pos += 4, t;
  }
  readU64() {
    const t = PR(this.view, this.pos);
    return this.pos += 8, t;
  }
  readI64() {
    const t = ib(this.view, this.pos);
    return this.pos += 8, t;
  }
  readU64AsBigInt() {
    const t = this.view.getBigUint64(this.pos);
    return this.pos += 8, t;
  }
  readI64AsBigInt() {
    const t = this.view.getBigInt64(this.pos);
    return this.pos += 8, t;
  }
  readF32() {
    const t = this.view.getFloat32(this.pos);
    return this.pos += 4, t;
  }
  readF64() {
    const t = this.view.getFloat64(this.pos);
    return this.pos += 8, t;
  }
}
function QR(e, t) {
  return new Bl(t).decode(e);
}
const fr = "ZAI", pr = {
  click: "Click",
  select: "Select",
  view: "View",
  start: "Start"
}, Er = {
  prePrompts: `${fr}_${pr.click} Quick prompts`,
  sendMessage: `${fr}_${pr.click} Send message`,
  sendMessageError: `${fr}_${pr.view} Error`,
  feedback: `${fr}_${pr.select} Feedback`,
  sideChatOpen: `${fr}_${pr.click} Side chat`,
  sideChatClose: `${fr}_${pr.click} Side chat close`,
  demandIntelligenceSendMessage: "CAT_Click DI ZAI Send Message",
  startProactiveMessage: `${fr}_${pr.start} Proactive message`
};
class XR {
  constructor() {
  }
  track(t, n) {
    const s = {
      "Macro Area": "ZAI",
      ...n
    };
    wd.track(t, s);
  }
  identify(t) {
    t && wd.identify(t);
  }
}
const br = new XR(), JR = (e, t) => Object.prototype.hasOwnProperty.call(e, t), Ba = (e, t, n) => {
  if (Array.isArray(e))
    return e.map((r, s) => Ba(r, `${t}[${s}]`, n));
  if (e && typeof e == "object") {
    const r = e, s = Object.keys(r), i = n.get(t) ?? [], a = new Set(i), o = [
      ...i.filter((u) => JR(r, u)),
      ...s.filter((u) => !a.has(u))
    ];
    return n.set(t, o), Object.fromEntries(o.map((u) => [
      u,
      Ba(r[u], `${t}.${u}`, n)
    ]));
  }
  return e;
}, ob = (e, t) => {
  const n = e?.get(t) ?? /* @__PURE__ */ new Map();
  return e?.set(t, n), n;
}, ZR = (e, t, n) => {
  const r = ob(e, t);
  Ba(n, "$", r);
}, ub = (e, t, n) => {
  const r = ob(e, t), s = Ba(n, "$", r);
  return JSON.stringify(s);
}, cb = (e, t, n) => `${e ?? "unknown"}:${t}:${n}`, eP = ({ chunk: e, matchingToolCallChunk: t, messageId: n, toolArgsKeyOrderCache: r }) => {
  const s = cb(n, "tool", e.id), i = e.partial_json ?? t?.args ?? t?.args_json, a = i ?? ub(r, s, e.args), o = a ? eo(a) : null, u = a ? o ?? {} : e.args;
  return ZR(r, s, o ?? e.args), i == null && r?.delete(s), { args: u, argsText: a };
}, Au = (e) => e?.metadata ?? {}, lf = /* @__PURE__ */ new Set(), tP = (e) => {
  typeof process > "u" || process?.env?.NODE_ENV !== "development" || lf.has(e) || (lf.add(e), console.warn(`Unknown message part type: ${e}`));
}, df = /* @__PURE__ */ new Set(), nP = (e) => {
  if (typeof process > "u" || process?.env?.NODE_ENV !== "development")
    return;
  const t = Object.keys(e).sort().join(",");
  df.has(t) || (df.add(t), console.warn(`Unsupported file content block shape: ${t}`));
}, rP = (e) => "file" in e ? {
  type: "file",
  filename: e.file.filename,
  data: e.file.file_data,
  mimeType: e.file.mime_type
} : "data" in e && typeof e.data == "string" ? {
  type: "file",
  filename: e.metadata?.filename ?? "file",
  data: e.data,
  mimeType: e.mime_type
} : "base64" in e && typeof e.base64 == "string" ? {
  type: "file",
  filename: e.filename ?? "file",
  data: e.base64,
  mimeType: e.mime_type
} : (nP(e), null), hf = (e, t, n) => typeof e == "string" ? [{ type: "text", text: e }] : e.map((r) => {
  const s = r.type;
  switch (s) {
    case "text":
      return { type: "text", text: r.text };
    case "text_delta":
      return { type: "text", text: r.text };
    case "image_url":
      return typeof r.image_url == "string" ? { type: "image", image: r.image_url } : {
        type: "image",
        image: r.image_url.url
      };
    case "file":
      return rP(r);
    case "thinking":
      return { type: "reasoning", text: r.thinking };
    case "reasoning":
      return {
        type: "reasoning",
        text: r.summary.map((o) => o.text).join(`


`)
      };
    case "tool_use":
      return null;
    case "input_json_delta":
      return null;
    case "computer_call":
      const i = r.action;
      return {
        type: "tool-call",
        toolCallId: r.call_id,
        toolName: "computer_call",
        args: i,
        argsText: ub(t.toolArgsKeyOrderCache, cb(n, "computer", r.call_id), i)
      };
    default:
      return tP(s), null;
  }
}).filter((r) => r !== null), sP = (e, t = {}) => {
  switch (e.type) {
    case "system":
      return {
        role: "system",
        id: e.id,
        content: [{ type: "text", text: e.content }],
        metadata: { custom: Au(e.additional_kwargs) }
      };
    case "human":
      return {
        role: "user",
        id: e.id,
        content: hf(e.content, t, e.id),
        metadata: { custom: Au(e.additional_kwargs) }
      };
    case "ai":
      const n = e.tool_calls?.map((i) => {
        const a = e.tool_call_chunks?.find((c) => c.id === i.id), { args: o, argsText: u } = eP({
          chunk: i,
          matchingToolCallChunk: a,
          messageId: e.id,
          toolArgsKeyOrderCache: t.toolArgsKeyOrderCache
        });
        return {
          type: "tool-call",
          toolCallId: i.id,
          toolName: i.name,
          args: o,
          argsText: u
        };
      }) ?? [], r = typeof e.content == "string" ? [{ type: "text", text: e.content }] : e.content, s = [
        e.additional_kwargs?.reasoning,
        ...r,
        ...e.additional_kwargs?.tool_outputs ?? []
      ].filter((i) => i !== void 0);
      return {
        role: "assistant",
        id: e.id,
        content: [
          ...hf(s, t, e.id),
          ...n
        ],
        metadata: { custom: Au(e.additional_kwargs) },
        ...e.status && { status: e.status }
      };
    case "tool":
      return {
        role: "tool",
        toolName: e.name,
        toolCallId: e.tool_call_id,
        result: e.content,
        artifact: e.artifact,
        isError: e.status === "error"
      };
  }
}, dt = [];
for (let e = 0; e < 256; ++e)
  dt.push((e + 256).toString(16).slice(1));
function iP(e, t = 0) {
  return (dt[e[t + 0]] + dt[e[t + 1]] + dt[e[t + 2]] + dt[e[t + 3]] + "-" + dt[e[t + 4]] + dt[e[t + 5]] + "-" + dt[e[t + 6]] + dt[e[t + 7]] + "-" + dt[e[t + 8]] + dt[e[t + 9]] + "-" + dt[e[t + 10]] + dt[e[t + 11]] + dt[e[t + 12]] + dt[e[t + 13]] + dt[e[t + 14]] + dt[e[t + 15]]).toLowerCase();
}
let yu;
const aP = new Uint8Array(16);
function oP() {
  if (!yu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    yu = crypto.getRandomValues.bind(crypto);
  }
  return yu(aP);
}
const uP = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ff = { randomUUID: uP };
function cP(e, t, n) {
  e = e || {};
  const r = e.random ?? e.rng?.() ?? oP();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, iP(r);
}
function lP(e, t, n) {
  return ff.randomUUID && !e ? ff.randomUUID() : cP(e);
}
class dP {
  constructor({ initialMessages: t = [], appendMessage: n = ((r, s) => s) } = {}) {
    k(this, "messagesMap", /* @__PURE__ */ new Map());
    k(this, "metadataMap", /* @__PURE__ */ new Map());
    k(this, "appendMessage");
    this.appendMessage = n, this.addMessages(t);
  }
  ensureMessageId(t) {
    return t.id ? t : { ...t, id: lP() };
  }
  addMessages(t) {
    if (t.length === 0)
      return this.getMessages();
    for (const n of t.map(this.ensureMessageId)) {
      const r = n.id, s = this.messagesMap.get(r);
      this.messagesMap.set(r, this.appendMessage(s, n));
    }
    return this.getMessages();
  }
  addMessageWithMetadata(t, n) {
    const r = this.ensureMessageId(t), s = r.id, i = this.messagesMap.get(s);
    this.messagesMap.set(s, this.appendMessage(i, r));
    const a = this.metadataMap.get(s);
    return this.metadataMap.set(s, { ...a, ...n }), this.getMessages();
  }
  getMessages() {
    return [...this.messagesMap.values()];
  }
  getMetadataMap() {
    return this.metadataMap;
  }
  replaceMessages(t) {
    this.messagesMap.clear(), this.metadataMap.clear();
    for (const n of t.map(this.ensureMessageId))
      this.messagesMap.set(n.id, n);
    return this.getMessages();
  }
  clear() {
    this.messagesMap.clear(), this.metadataMap.clear();
  }
}
const hP = (e, t) => {
  if (t.type !== "AIMessageChunk")
    return t;
  if (e?.type !== "ai")
    return {
      ...t,
      type: t.type.replace("MessageChunk", "").toLowerCase()
    };
  const n = typeof e.content == "string" ? [{ type: "text", text: e.content }] : [...e.content];
  if (typeof t?.content == "string") {
    const s = n.length - 1;
    n[s]?.type === "text" ? n[s].text = n[s].text + t.content : n.push({ type: "text", text: t.content });
  } else if (Array.isArray(t.content)) {
    const s = n.length - 1;
    for (const i of t.content)
      "type" in i && (i.type === "text" ? n[s]?.type === "text" ? n[s].text = n[s].text + i.text : n.push({ type: "text", text: i.text }) : i.type === "image_url" && n.push(i));
  }
  const r = [...e.tool_calls ?? []];
  for (const s of t.tool_call_chunks ?? []) {
    const i = r[s.index] ?? { argsText: "" }, a = (i.argsText || "") + s.args;
    r[s.index] = {
      ...s,
      ...i,
      argsText: a,
      args: eo(a) ?? ("args" in i ? i.args : {})
    };
  }
  return {
    ...e,
    content: n,
    tool_calls: r
  };
}, fP = /* @__PURE__ */ new Set([
  "analyze",
  "plan",
  "execute_step",
  "validate_step",
  "synthesize",
  "clarify"
]), pP = /* @__PURE__ */ new Set(["execute_step", "validate_step"]);
class mP {
  constructor() {
    this.accumulator = new dP({
      initialMessages: [],
      appendMessage: hP
    });
  }
  addChunk(t) {
    this.accumulator.addMessages([t]);
  }
  addProgress(t) {
    if (!fP.has(t.node) || t.node === "clarify")
      return;
    const n = this.progress?.entries ?? [], r = this.getEntryKey(t, n), s = t.message ?? t.step_description ?? "", a = n.some((o) => o.key === r) ? n.map((o) => o.key === r ? { ...o, node: t.node, text: s } : o) : [...n, { key: r, node: t.node, text: s }];
    this.progress = { entries: a, activeKey: r, activeNode: t.node };
  }
  getEntryKey(t, n) {
    if (!pP.has(t.node))
      return t.node;
    if (t.step_id) return `${t.node}#id:${t.step_id}`;
    if (typeof t.current_step == "number") return `${t.node}#step:${t.current_step}`;
    const r = n.filter((s) => s.node === t.node).length;
    return `${t.node}#idx:${r}`;
  }
  getCompletedResponse(t) {
    const n = this.accumulator.getMessages().flatMap((i) => sP(i, {})), r = n.filter((i) => i?.role === "tool").reduce((i, a) => (i[a.toolCallId] = {
      result: a.result,
      toolName: a.toolName,
      isError: a.isError
    }, i), {});
    return {
      content: n.filter((i) => i && i.role === "assistant").map((i) => i.content.map((a) => {
        if (a.toolCallId) {
          const o = a.args?.resource_uri;
          let u = ZE[a.toolName];
          u && (u = En(u, a.args));
          const c = r[a.toolCallId];
          if (a.argsText = o || u, c)
            return {
              ...a,
              type: "tool-call",
              toolName: c.toolName,
              result: nb(c.result),
              isError: c.isError
            };
        } else if (a.type === "text")
          return {
            type: "text",
            text: new Ll(t, a.text).replaceTerritoryIds().replacePostIds().replaceCreatorIds().replaceWidgets().cleanUnusedURIs().build()
          };
        return a;
      })).flat(),
      ...this.progress ? { metadata: { custom: { zaiProgress: this.progress } } } : {}
    };
  }
}
const gP = {
  "pt-BR": "por",
  en: "eng",
  es: "spa"
}, EP = (e) => gP[e];
function bP(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), n;
}
const _P = ({
  workspaceId: e,
  thread: t,
  langRef: n,
  getOrigin: r,
  getPromptPage: s,
  checkIsPrePrompt: i,
  resetIsPrePrompt: a,
  checkIsProactiveMessage: o,
  getQuickPromptId: u,
  service: c
}) => ({
  async *run({ messages: h, abortSignal: m, context: p, runConfig: E }) {
    const g = h?.length ? h[h.length - 1]?.content[0]?.text : null, _ = i(), b = o(), T = r(), C = s(), R = _ ? u() : null, D = _ || !!E?.custom?.skipResponseInteraction, I = {
      workspaceId: e,
      thread: t.current
    };
    if (g && (I.message = g), T && (I.origin = T), _ && C && (I.page = C), b)
      br.track(Er.startProactiveMessage, I);
    else {
      const P = Er[_ ? "prePrompts" : "sendMessage"];
      br.track(P, I), !_ && T === "Demand Intelligence" && I.message && br.track(Er.demandIntelligenceSendMessage, { "Message Text": I.message });
    }
    a();
    const O = await c.postMessageToThread(
      t.current || "",
      {
        messages: h,
        context: p,
        language: EP(n.current || "en"),
        ...R ? { quick_prompt_id: R } : {},
        skip_response_interaction: D
      },
      {
        abortSignal: m
      }
    );
    if (!O)
      return;
    const U = new mP();
    let q = new Uint8Array(0);
    for (; ; ) {
      const { done: P, value: z } = await O.read();
      if (P)
        break;
      for (q = bP(q, z); !(q.length < 4); ) {
        const F = new DataView(q.buffer, q.byteOffset, 4).getUint32(0, !1);
        if (q.length < 4 + F) break;
        const M = q.subarray(4, 4 + F);
        q = q.subarray(4 + F);
        try {
          const H = QR(M);
          if (H.type === "ping")
            continue;
          if (H.type === "progress") {
            U.addProgress(H), yield U.getCompletedResponse(e);
            continue;
          }
          U.addChunk(H), yield U.getCompletedResponse(e);
        } catch (H) {
          br.track(Er.sendMessageError, I), console.error("Failed to decode msgpack chunk:", H);
        }
      }
    }
  }
}), TP = (e) => () => {
  const t = _P(e), n = Vx(t, {}), r = J((l) => l?.threadListItem?.remoteId), s = J((l) => l?.threadListItem?.id), i = J((l) => l?.threads?.mainThreadId), a = J((l) => l?.threadListItem?.title), { setThreadRunning: o, notifyIfBackground: u } = $E(), c = Ke({
    remoteId: r,
    threadListItemId: s,
    mainThreadId: i,
    title: a,
    setThreadRunning: o,
    notifyIfBackground: u
  });
  return c.current = { remoteId: r, threadListItemId: s, mainThreadId: i, title: a, setThreadRunning: o, notifyIfBackground: u }, xe(() => {
    const l = n.thread.unstable_on("runStart", () => {
      const { threadListItemId: m, setThreadRunning: p } = c.current;
      m && p({ threadId: m, isRunning: !0 });
    }), h = n.thread.unstable_on("runEnd", () => {
      const { threadListItemId: m, setThreadRunning: p } = c.current;
      m && p({ threadId: m, isRunning: !1 }), setTimeout(() => {
        const { remoteId: E, threadListItemId: g, mainThreadId: _, title: b, notifyIfBackground: T } = c.current;
        !E || !b || T({ threadId: E, isActiveThread: g === _, title: b });
      }, 100);
    });
    return () => {
      l(), h();
    };
  }, [n]), n;
}, AP = ({ workspaceId: e }) => {
  const t = Ml(), { getOrigin: n, getPage: r, checkIsPrePrompt: s, resetIsPrePrompt: i, checkIsProactiveMessage: a } = _s(), { getQuickPromptId: o, resetPrePromptParams: u } = Rl(), c = ne(() => {
    i(), u();
  }, [i, u]), { language: l } = vi(), h = Xh(l) ? l : "pt-BR", m = Ke(h), p = Ke(null), E = ie(
    () => TP({
      workspaceId: e,
      thread: p,
      langRef: m,
      getOrigin: n,
      getPromptPage: r,
      checkIsPrePrompt: s,
      resetIsPrePrompt: c,
      checkIsProactiveMessage: a,
      getQuickPromptId: o,
      service: t
    }),
    [
      e,
      n,
      r,
      s,
      c,
      a,
      o,
      t
    ]
  ), g = ie(() => SR({ currentThread: p }), []), _ = Bm({
    runtimeHook: E,
    adapter: {
      unstable_Provider: g,
      async list() {
        return {
          threads: await t.getThreads()
        };
      },
      async fetch(b) {
        return (await t.getThreads()).find((C) => C.remoteId === b) ?? { status: "regular", remoteId: b };
      },
      async initialize() {
        const b = iR();
        return p.current = b, { remoteId: b, externalId: b };
      },
      async rename() {
      },
      async delete(b) {
        await t.deleteThread(b);
      },
      async archive() {
      },
      async generateTitle(b, T) {
        let C = "New Thread";
        return T?.[0]?.content[0]?.type === "text" && (C = T[0].content[0]?.text), new ReadableStream({
          start(D) {
            D.enqueue({
              type: "part-start",
              part: { type: "text" },
              path: [0]
            }), D.enqueue({
              type: "text-delta",
              textDelta: C,
              path: [0]
            }), D.enqueue({
              type: "part-finish",
              path: [0]
            }), D.close();
          }
        });
      },
      async unarchive() {
      }
    }
  });
  return xe(() => {
    Xh(l) && (m.current = l);
  }, [l]), {
    threadRuntime: _
  };
}, yP = ({
  children: e,
  workspaceId: t,
  setAssistantUiIsReady: n,
  setAssistantUiControl: r
}) => {
  const { threadRuntime: s } = AP({ workspaceId: t });
  return xe(() => n(!!s), [n, s]), xe(() => {
    s && r?.((i) => s.threads.switchToThread(i));
  }, [s, r]), /* @__PURE__ */ d.jsx(Xx, { runtime: s, children: e });
}, xP = he(yP), BF = ({
  workspaceId: e,
  userId: t,
  userEmail: n,
  getValidToken: r,
  children: s,
  onBackgroundThreadComplete: i,
  setAssistantUiControl: a,
  isChatVisible: o
}) => {
  const [u, c] = de(!1);
  return /* @__PURE__ */ d.jsx(QE.Provider, { value: { workspaceId: e, userId: t, userEmail: n, getValidToken: r, assistantUiIsReady: u }, children: /* @__PURE__ */ d.jsx(Zk, { children: /* @__PURE__ */ d.jsx(eR, { children: /* @__PURE__ */ d.jsx(fk, { children: e ? /* @__PURE__ */ d.jsx(
    pk,
    {
      onBackgroundThreadComplete: i,
      isChatVisible: o,
      children: /* @__PURE__ */ d.jsx(
        xP,
        {
          workspaceId: e,
          setAssistantUiIsReady: c,
          setAssistantUiControl: a,
          children: s
        }
      )
    }
  ) : s }) }) }) });
}, CP = {
  7: "0",
  30: "1",
  90: "3",
  180: "6",
  365: "12",
  730: "24",
  1095: "36"
}, pf = {
  0: "day",
  1: "week",
  3: "week",
  6: "month",
  12: "month",
  24: "quarter",
  36: "quarter",
  61: "quarter"
}, Ul = (e) => CP[String(e)], _c = (e) => {
  const t = Ul(e);
  return t && pf[t] || pf[1];
}, lb = (e) => {
  const t = new URLSearchParams();
  if (e.timeRangeInDays !== void 0) {
    const n = Ul(e.timeRangeInDays);
    n && t.set("uploadDate", n);
  }
  return e.provider && e.provider !== "all" && t.set("providers", e.provider), t;
};
function SP(e, t, n) {
  const r = e.getUTCDate().toString().padStart(2, "0"), s = (e.getUTCMonth() + 1).toString().padStart(2, "0"), i = e.getUTCFullYear().toString();
  if (n) {
    if (t === "DD/MM/YYYY")
      return `${r}/${s}/${i}`;
    const o = new Intl.DateTimeFormat(n, {
      timeZone: "UTC",
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).formatToParts(e), u = o.find((h) => h.type === "day")?.value || r, c = o.find((h) => h.type === "month")?.value || s, l = o.find((h) => h.type === "year")?.value || i;
    return `${u}/${c}/${l}`;
  }
  return t.replace("DD", r).replace("MM", s).replace("YYYY", i);
}
function mf(e, t, n) {
  const r = new Date(e);
  switch (n) {
    case "day":
      r.setUTCDate(r.getUTCDate() + t);
      break;
    case "week":
      r.setUTCDate(r.getUTCDate() + t * 7);
      break;
    case "month":
      r.setUTCMonth(r.getUTCMonth() + t);
      break;
    case "quarter":
      r.setUTCMonth(r.getUTCMonth() + t * 3);
      break;
    case "year":
      r.setUTCFullYear(r.getUTCFullYear() + t);
      break;
    default:
      throw new Error(`Unsupported unit: ${n}`);
  }
  return r;
}
function IP(e, t, n) {
  switch (n) {
    case "day":
      return Math.floor((t.getTime() - e.getTime()) / (1e3 * 60 * 60 * 24));
    case "week":
      return Math.floor((t.getTime() - e.getTime()) / (1e3 * 60 * 60 * 24 * 7));
    case "month":
      return (t.getUTCFullYear() - e.getUTCFullYear()) * 12 + (t.getUTCMonth() - e.getUTCMonth());
    case "quarter": {
      const r = (t.getUTCFullYear() - e.getUTCFullYear()) * 12 + (t.getUTCMonth() - e.getUTCMonth());
      return Math.floor(r / 3);
    }
    case "year":
      return t.getUTCFullYear() - e.getUTCFullYear();
    default:
      throw new Error(`Unsupported unit: ${n}`);
  }
}
function wP(e, t, n = "DD/MM/YYYY", r = "day", s = null) {
  const i = (E) => {
    if (E instanceof Date)
      return new Date(Date.UTC(E.getUTCFullYear(), E.getUTCMonth(), E.getUTCDate()));
    const g = /* @__PURE__ */ new Date(E + "T00:00:00.000");
    if (isNaN(g.getTime())) {
      const _ = new Date(E);
      return isNaN(_.getTime()) ? /* @__PURE__ */ new Date(NaN) : new Date(Date.UTC(_.getUTCFullYear(), _.getUTCMonth(), _.getUTCDate()));
    }
    return new Date(Date.UTC(g.getFullYear(), g.getMonth(), g.getDate()));
  }, a = i(e), o = i(t);
  if (isNaN(a.getTime()) || isNaN(o.getTime()))
    return [];
  const u = IP(a, o, r), c = Math.abs(u) + 1, h = c > 0 ? c : 0, m = u < 0;
  return Array.from(Array(h)).map((E, g) => {
    const _ = m ? mf(a, -g, r) : mf(a, g, r);
    return SP(_, n, s || void 0);
  });
}
const vP = `
  query Creator($creatorId: ID!, $filter: AnalyticsFilterInput!) {
    creator(_id: $creatorId) {
      ... on Creator {
        id: creatorId
        subscribers
        title
        provider
        country
        thumbnail
        isTrending
        performance {
          analytics(filter: $filter) {
            avgEngagement
            avgEngagementVariation
          }
        }
      }
      ... on CreatorIncompleteIN {
        title
      }
      ... on CreatorIncompleteTT {
        title
      }
      ... on CreatorIncompleteYT {
        title
      }
      ... on CreatorIncompleteFB {
        title
      }
      ... on CreatorIncompleteTW {
        title
      }
      ... on CreatorPublic {
        id: creatorId
        subscribers
        title
        provider
        country
        thumbnail
        isTrending
      }
    }
  }
`, NP = `
  query Post($postId: ID!) {
    post(_id: $postId) {
      id: postId
      thumbnail
      publishedAt
      provider
      views
      likes
      title
      creator {
        ... on Creator {
          id: creatorId
          title
          thumbnail
          provider
        }
        ... on CreatorIncompleteTW {
          title
        }
        ... on CreatorIncompleteFB {
          title
        }
        ... on CreatorIncompleteYT {
          title
        }
        ... on CreatorIncompleteTT {
          title
        }
        ... on CreatorIncompleteIN {
          title
        }
        ... on CreatorPublic {
          title
          thumbnail
        }
      }
    }
  }
`, kP = `
  query getDocumentsList($take: Int!, $cursor: String, $status: [FileStorageStatus!]) {
    getWorkspace {
      fileStorage {
        filesPaginated(take: $take, cursor: $cursor, status: $status) {
          cursor
          totalCount
          data {
            fileName
            id
            size
          }
        }
      }
    }
  }
`, RP = `
  fragment TerritoryEngagementOverTime on TerritoryInterface {
    territoryId
    territoryPerformance {
      metricsPerMonth(
        timeRange: $timeRange
        publishedAt: $publishedAt
        providers: $providers
        interval: $interval
      ) {
        date
        totalEngagement
      }
    }
  }

  fragment EngagementOverTimeBrandItem on WorkspaceBrand {
    id
    name
    customSettings
    workspaceBrandTerritories {
      selfContentTerritory @skip(if: $skipSelfContent) {
        ...TerritoryEngagementOverTime
      }
      earnedTerritory @skip(if: $skipEarned) {
        ...TerritoryEngagementOverTime
      }
      paidTerritory @skip(if: $skipPaid) {
        ...TerritoryEngagementOverTime
      }
      groupedTerritory @skip(if: $skipGrouped) {
        ...TerritoryEngagementOverTime
      }
    }
  }

  query getBrandEngagementOverTime(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $interval: SparklineIntervalInput
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand {
        ...EngagementOverTimeBrandItem
      }
      workspaceBrandCompetitorsPaginated {
        data {
          ...EngagementOverTimeBrandItem
        }
      }
    }
  }
`, PP = `
  fragment TerritoryEngagementOverTime on TerritoryInterface {
    territoryId
    territoryPerformance {
      metricsPerMonth(
        timeRange: $timeRange
        publishedAt: $publishedAt
        providers: $providers
        interval: $interval
      ) {
        date
        totalEngagement
      }
    }
  }

  fragment EngagementOverTimeBrandItem on WorkspaceBrandV2 {
    id
    name
    customSettings # <- "{ color: string }"
    workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
      selfContentTerritory @skip(if: $skipSelfContent) {
        ...TerritoryEngagementOverTime
      }
      earnedTerritory @skip(if: $skipEarned) {
        ...TerritoryEngagementOverTime
      }
      paidTerritory @skip(if: $skipPaid) {
        ...TerritoryEngagementOverTime
      }
      groupedTerritory @skip(if: $skipGrouped) {
        ...TerritoryEngagementOverTime
      }
    }
  }

  query getBrandEngagementOverTime(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $interval: SparklineIntervalInput
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        ...EngagementOverTimeBrandItem
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          ...EngagementOverTimeBrandItem
        }
      }
    }
  }
`, OP = `
  fragment TerritoryPerformanceFields on TerritoryPerformance {
    metrics(
      timeRange: $timeRange
      publishedAt: $publishedAt
      providers: $providers
    ) {
      totalEngagement
      totalViews
    }
    totalPosts(
      timeRange: $timeRange
      providers: $providers
      publishedAt: $publishedAt
    )
  }

  query BrandCharts_AttentionMetrics(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand {
        id
        name
        customSettings
        workspaceBrandTerritories {
          selfContentTerritory @skip(if: $skipSelfContent) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          earnedTerritory @skip(if: $skipEarned) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          paidTerritory @skip(if: $skipPaid) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          groupedTerritory @skip(if: $skipGrouped) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated {
        data {
          id
          name
          customSettings
          workspaceBrandTerritories {
            selfContentTerritory @skip(if: $skipSelfContent) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            earnedTerritory @skip(if: $skipEarned) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            paidTerritory @skip(if: $skipPaid) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            groupedTerritory @skip(if: $skipGrouped) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
          }
        }
      }
    }
  }
`, DP = `
  fragment TerritoryPerformanceFields on TerritoryPerformance {
    metrics(
      timeRange: $timeRange
      publishedAt: $publishedAt
      providers: $providers
    ) {
      totalEngagement
      totalViews
    }
    totalPosts(
      timeRange: $timeRange
      providers: $providers
      publishedAt: $publishedAt
    )
  }

  query BrandCharts_AttentionMetrics(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        customSettings # <- "{ color: string }"
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          selfContentTerritory @skip(if: $skipSelfContent) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          earnedTerritory @skip(if: $skipEarned) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          paidTerritory @skip(if: $skipPaid) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          groupedTerritory @skip(if: $skipGrouped) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
          customSettings # <- "{ color: string }"
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            selfContentTerritory @skip(if: $skipSelfContent) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            earnedTerritory @skip(if: $skipEarned) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            paidTerritory @skip(if: $skipPaid) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            groupedTerritory @skip(if: $skipGrouped) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
          }
        }
      }
    }
  }
`, LP = `
  query getShareOfAttentionV2($input: ShareOfAttentionV2Input!) {
    getWorkspace {
      listShareOfAttentionV2(input: $input) {
        data {
          current {
            donut {
              brand {
                id
                name
                brandColor
              }
              rankPosition
              rankVariation
              value
              valueVariation
            }
            histogram {
              brand {
                id
                name
                brandColor
              }
              date
              rankPosition
              rankVariation
              value
              valueVariation
            }
          }
        }
      }
      selfBrandSOA {
        brand {
          id
          name
        }
        category {
          id
          name
          country
        }
      }
    }
  }
`, MP = `
  query SHARE_OF_ATTENTION_V3($input: ShareOfAttentionV3MetricsInput!) {
    shareOfAttentionV3 {
      metrics(input: $input) {

        histogram {
          brand {
            id
            color
            name
            thumbnailUrl
          }

          date
          value
          valueVariation
          rankPosition
          rankVariation
          isPartial
        }

      }

      myBrand {
        id
        name
        color
        thumbnailUrl
        isVerified
        country
      }

      listMySoas {
        id
        name
      }
    }
  }
`, HP = `
  query getTerritoryRelevance(
    $territoryId: ID!
    $interval: SparklineIntervalInput
    $publishedAt: RangeQuery
    $timeRange: TimeRange
  ) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryPerformance {
        totalPosts(timeRange: $timeRange, publishedAt: $publishedAt)
        relevancev2(
          filters: { timeRange: $timeRange, interval: $interval, publishedAt: $publishedAt }
        ) {
          sparkline
          endDate
          startDate
        }
      }
    }
  }
`;
class Xr {
  constructor({ workspaceId: t, getValidToken: n, userId: r, userEmail: s = "" }) {
    this.workspaceId = t, this.getValidToken = n, this.userId = r, this.userEmail = s;
  }
  async getInsightsHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: await this.getValidToken(),
      "x-insights-workspace": this.workspaceId
    };
  }
  async fetchInsightsGraphQL(t, n) {
    const r = await this.getInsightsHeaders(), s = await fetch(`${Pl.baseUrl}/graphql`, {
      method: "POST",
      headers: r,
      body: JSON.stringify({ query: t, variables: n })
    });
    if (!s.ok) {
      const i = await s.text();
      throw new Error(`Insights GraphQL error: ${s.status} ${i}`);
    }
    return s.json();
  }
  static formatBrandEngagementData(t, n) {
    const r = qr.getMetricKeyByTerritoryType(n), s = t?.workspaceBrand, i = t?.workspaceBrandCompetitorsPaginated?.data || [];
    return [s, ...i].map((o, u) => {
      const c = o.workspaceBrandTerritories?.[r]?.territoryPerformance?.metricsPerMonth || [];
      return {
        id: o.id,
        name: o.name,
        color: qr.parseColorFromSettings(o.customSettings, u),
        metrics: c.map((l) => ({ date: l.date, totalEngagement: l.totalEngagement }))
      };
    });
  }
  static formatSharesData(t, n) {
    const r = qr.getMetricKeyByTerritoryType(n), s = t?.workspaceBrand, i = t?.workspaceBrandCompetitorsPaginated?.data || [];
    return [s, ...i].map((o, u) => {
      const c = o.workspaceBrandTerritories?.[r]?.territoryPerformance;
      return {
        id: o.id,
        name: o.name,
        color: qr.parseColorFromSettings(o.customSettings, u),
        totalEngagement: c?.metrics?.totalEngagement || 0,
        totalViews: c?.metrics?.totalViews || 0,
        totalPosts: c?.totalPosts || 0
      };
    });
  }
  static formatSoAData(t) {
    const n = {
      category: t.selfBrandSOA?.brand?.category || null,
      brands: []
    }, r = {}, s = t.selfBrandSOA?.brand?.id;
    return t.listShareOfAttentionV2.data.current.histogram.forEach((i, a) => {
      const o = i.brand.id;
      r[o] || (r[o] = {
        id: o,
        name: i.brand.name,
        color: qr.getBrandColor(i.brand, a),
        isSelf: o === s,
        dateMap: /* @__PURE__ */ new Map()
      }), r[o].dateMap.set(i.date, parseFloat(Number(i.value * 100).toFixed(2)));
    }), n.brands = Object.values(r).map((i) => ({
      id: i.id,
      name: i.name,
      color: i.color,
      isSelf: i.isSelf,
      scores: Array.from(i.dateMap.entries()).sort(([a], [o]) => a.localeCompare(o)).map(([a, o]) => ({ date: a, value: o }))
    })), n;
  }
  static formatSoAV3Data({ histogram: t, industry: n, myBrand: r }) {
    const i = {
      category: n ? { id: n.id, name: n.name, country: r.country ?? "" } : null,
      brands: []
    }, a = {};
    return t.forEach((o, u) => {
      const c = o.brand.id;
      a[c] || (a[c] = {
        id: c,
        name: o.brand.name,
        color: qr.getBrandColor(o.brand, u),
        isSelf: c === r.id,
        dateMap: /* @__PURE__ */ new Map()
      }), a[c].dateMap.set(o.date, parseFloat(Number(o.value * 100).toFixed(2)));
    }), i.brands = Object.values(a).map((o) => ({
      id: o.id,
      name: o.name,
      color: o.color,
      isSelf: o.isSelf,
      scores: Array.from(o.dateMap.entries()).sort(([u], [c]) => u.localeCompare(c)).map(([u, c]) => ({ date: u, value: c }))
    })), i;
  }
  async getBrandEngagementOverTimeData(t, n = {}) {
    try {
      const r = t.territoryType || "grouped", s = t.provider || "all", i = s in ea ? [s] : Object.keys(ea), a = Number.parseInt(t.timeRangeInDays || "30", 10), { publishedAt: o, timeRange: u } = _u(a), c = tf[r], l = { type: "calendar", timeUnit: _c(a) }, h = n?.isNewPageBrandOverviewEnabled ? PP : RP, m = await this.fetchInsightsGraphQL(h, {
        ...c,
        providers: i,
        publishedAt: o,
        timeRange: u,
        interval: l
      });
      return Xr.formatBrandEngagementData(m.data.getWorkspace, r);
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch brand engagement over time from backend",
        error: r
      }), r;
    }
  }
  async getShareOfAttentionData(t, n = {}) {
    try {
      const r = t.period || "monthly", s = Number.parseInt(t.year || String((/* @__PURE__ */ new Date()).getFullYear()), 10);
      if (n?.isSOAV3WithZaiEnabled) {
        const a = await this.fetchInsightsGraphQL(MP, { input: { aggregate: r, year: s } }), o = a.data.shareOfAttentionV3?.metrics?.histogram, u = a.data.shareOfAttentionV3?.listMySoas, c = a.data.shareOfAttentionV3?.myBrand;
        return Xr.formatSoAV3Data({
          histogram: o,
          industry: u,
          myBrand: c
        });
      }
      const i = await this.fetchInsightsGraphQL(LP, { input: { aggregate: r, year: s } });
      return Xr.formatSoAData(i.data.getWorkspace);
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch share of attention data from backend",
        error: r
      }), r;
    }
  }
  async getSharesData(t, n = {}) {
    const r = t.territoryType || "grouped", s = t.provider || "all", i = s in ea ? [s] : Object.keys(ea), a = Number.parseInt(t.timeRangeInDays || "30", 10), { publishedAt: o, timeRange: u } = _u(a), c = n?.isNewPageBrandOverviewEnabled ? DP : OP;
    try {
      const l = await this.fetchInsightsGraphQL(c, {
        ...tf[r],
        providers: i,
        publishedAt: o,
        timeRange: u
      });
      return Xr.formatSharesData(l.data.getWorkspace, r);
    } catch (l) {
      throw console.error({
        log: "Zai Chat - Error to fetch shares data from backend",
        error: l
      }), l;
    }
  }
  async getTerritoryRelevanceData(t) {
    const n = t.territoryId, r = t.timeRange || "30", s = _u(r), i = { type: "calendar", timeUnit: _c(r) };
    try {
      const a = await this.fetchInsightsGraphQL(HP, {
        territoryId: n,
        interval: i,
        publishedAt: s.publishedAt,
        timeRange: s.timeRange
      }), o = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.sparkline || [], u = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.startDate, c = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.endDate, l = wP(u, c, "YYYY-MM-DD", i.timeUnit);
      return { sparkline: Array.from({ length: Math.min(o.length, l.length) }, (m, p) => ({
        date: l[p],
        value: o[p]
      })), startDate: u, endDate: c };
    } catch (a) {
      throw console.error({
        log: "Zai Chat - Error to fetch territory relevance data from backend",
        error: a
      }), a;
    }
  }
  async getFiles(t) {
    try {
      return (await this.fetchInsightsGraphQL(kP, {
        take: t.limit,
        cursor: t.cursor,
        status: ["REQUESTED", "PROCESSING", "PROCESSED"]
      })).data.getWorkspace.fileStorage.filesPaginated;
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch files from backend",
        error: n
      }), n;
    }
  }
  async getCreatorData(t, n) {
    try {
      return (await this.fetchInsightsGraphQL(vP, {
        creatorId: t,
        filter: { periodInMonths: n.performanceInMonths }
      })).data.creator;
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch creator data from backend",
        query: { variables: { creatorId: t } },
        error: r
      }), r;
    }
  }
  async getPostData(t) {
    try {
      return (await this.fetchInsightsGraphQL(NP, { postId: t })).data.post;
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch post data from backend",
        query: { variables: { postId: t } },
        error: n
      }), n;
    }
  }
}
const Lr = () => {
  const { workspaceId: e, userId: t, userEmail: n, getValidToken: r } = pt();
  return ie(
    () => new Xr({ workspaceId: e, getValidToken: r, userId: t, userEmail: n }),
    [e, t, n, r]
  );
}, BP = ({ limit: e = 100 }) => {
  const { workspaceId: t } = pt(), n = Lr(), [r, s] = de(!1), [i, a] = de(!1), [o, u] = de(!1), [c, l] = de(null), h = ne(async () => {
    if (t)
      try {
        s(!0), u(!1);
        const p = await n.getFiles({ limit: e });
        l(p);
      } catch {
        u(!0);
      } finally {
        s(!1);
      }
  }, [t, e, n]), m = ne(async () => {
    if (!(!t || !c?.cursor))
      try {
        a(!0), u(!1);
        const p = await n.getFiles({ limit: e, cursor: c.cursor });
        l((E) => ({
          cursor: p.cursor,
          data: [...E?.data || [], ...p.data],
          totalCount: p.totalCount
        }));
      } catch {
        u(!0);
      } finally {
        a(!1);
      }
  }, [t, c?.cursor, e, n]);
  return xe(() => {
    h();
  }, []), {
    isLoading: r,
    isLoadingMore: i,
    isError: o,
    data: c,
    refetch: h,
    fetchMore: m
  };
}, UP = 1, db = "h-[82px]", FP = ({
  data: e,
  isLoading: t,
  isError: n,
  refetch: r,
  onButtonClick: s = () => {
  },
  onInfoClick: i = () => {
  }
}) => {
  const a = ie(() => e?.totalCount || 0, [e?.totalCount]), o = ie(() => a === 0, [a]), u = ne(() => {
    s();
  }, [s]), c = ne(
    (l) => {
      l.stopPropagation(), i();
    },
    [i]
  );
  return {
    isEmpty: o,
    totalCount: a,
    showLoading: t,
    showError: n,
    handleButtonClick: u,
    handleInfoClick: c,
    refetch: r
  };
}, gf = {
  0: "gap-0",
  26: "gap-[26px]"
}, jP = (e) => {
  const t = !e.description && !e.hasTrendTag ? gf[26] : gf[0];
  return /* @__PURE__ */ d.jsx("a", { href: e.creatorUrl, target: "_blank", rel: "noopener noreferrer", className: "flex w-full h-full no-underline", children: /* @__PURE__ */ d.jsx(jr, { theme: e.theme || "dark", children: /* @__PURE__ */ d.jsxs("div", { className: "flex gap-3", children: [
    e.thumbnail && /* @__PURE__ */ d.jsx("div", { className: "w-[100px] shrink-0", children: /* @__PURE__ */ d.jsx(jr.Thumbnail, { ...e.thumbnail }) }),
    /* @__PURE__ */ d.jsxs("div", { className: `flex flex-col ${t}`, children: [
      e.title && /* @__PURE__ */ d.jsx(jr.Title, { children: e.title }),
      (e.description || e.hasTrendTag) && /* @__PURE__ */ d.jsxs("div", { className: "flex gap-[10px] pb-[10px]", children: [
        e.description && /* @__PURE__ */ d.jsx(jr.Description, { children: e.description }),
        e.hasTrendTag && /* @__PURE__ */ d.jsx(jr.TrendTag, {})
      ] }),
      e.metrics && /* @__PURE__ */ d.jsx(jr.Metrics, { ...e.metrics })
    ] })
  ] }) }) });
}, $P = he(jP), Tc = {
  fb: "facebook",
  in: "instagram",
  tt: "tiktok",
  tw: "twitch",
  yt: "youtube"
}, zP = (e) => /* @__PURE__ */ d.jsxs($r, { theme: e.theme || "dark", classes: ["ds-video-card-default"], children: [
  /* @__PURE__ */ d.jsx("a", { href: e.videoUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ d.jsx($r.Thumbnail, { ...e.thumbnail }) }),
  /* @__PURE__ */ d.jsx($r.Description, { classes: ["px-2"], children: e.description }),
  /* @__PURE__ */ d.jsxs("div", { className: "flex px-2 justify-between items-center", children: [
    e.creatorUrl ? /* @__PURE__ */ d.jsx("a", { href: e.creatorUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ d.jsx($r.Creator, { ...e.creator }) }) : /* @__PURE__ */ d.jsx($r.Creator, { ...e.creator }),
    /* @__PURE__ */ d.jsx($r.Metrics, { ...e.metrics })
  ] })
] }), VP = he(zP), sn = {
  VideoCardDefault: VP,
  // IIconProps is not exported from @winnin/ds-icon, so we widen the name type via cast
  Icon: zT,
  CreatorCardDefault: $P,
  LineChart: YT,
  SyncMultipleDonut: GT,
  ColumnsChart: VT
}, YP = he(({ children: e, ...t }) => /* @__PURE__ */ d.jsxs(
  "button",
  {
    ...t,
    type: "button",
    className: "flex justify-between items-center w-full gap-5 p-5 bg-black rounded-xl cursor-pointer h-[82px]",
    children: [
      /* @__PURE__ */ d.jsx("div", { className: "text-sm text-white text-left leading-[21px]", children: e }),
      /* @__PURE__ */ d.jsx(sn.Icon, { name: "upload", width: 24, height: 24, className: "shrink-0 text-purple-300" })
    ]
  }
)), Mr = ({
  isLoading: e,
  isError: t,
  isEmpty: n,
  emptyComponent: r,
  errorComponent: s,
  loadingComponent: i,
  children: a
}) => e ? /* @__PURE__ */ d.jsx(d.Fragment, { children: i }) : t ? /* @__PURE__ */ d.jsx(d.Fragment, { children: s }) : n && r ? /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: a }), Ua = {
  error: {
    key: "file-upload.error.title",
    defaultValue: "Falha ao carregar arquivos"
  },
  tryAgain: {
    key: "file-upload.try-again",
    defaultValue: "Tentar novamente"
  },
  emptyMessage: {
    key: "file-upload.empty-message",
    defaultValue: "Expanda o conhecimento da Zai com documentos da sua marca"
  },
  filesCount: (e) => ({
    key: "file-upload.files-count",
    defaultValue: "{count, plural, one {# arquivo adicionado} other {# arquivos adicionados}}",
    parameters: { count: e }
  })
}, GP = ({ refetch: e, t }) => /* @__PURE__ */ d.jsxs(
  "div",
  {
    className: `w-full p-4 bg-black rounded-xl flex flex-col items-center justify-center gap-1 ${db}`,
    children: [
      /* @__PURE__ */ d.jsx("strong", { className: "text-white text-sm", children: t(Ua.error) }),
      /* @__PURE__ */ d.jsx(It, { variant: "highlight-border", onClick: e, children: t(Ua.tryAgain) })
    ]
  }
), WP = he(GP), qP = () => /* @__PURE__ */ d.jsx("div", { className: "w-full", children: /* @__PURE__ */ d.jsx(kt, { className: `bg-gray-600 rounded-xl w-full ${db}` }) }), KP = he(qP), QP = ({
  isEmpty: e,
  totalCount: t,
  showLoading: n,
  showError: r,
  handleButtonClick: s,
  handleInfoClick: i,
  refetch: a,
  t: o
}) => /* @__PURE__ */ d.jsx("div", { className: "w-full", children: /* @__PURE__ */ d.jsx(
  Mr,
  {
    isLoading: n,
    isError: r,
    loadingComponent: /* @__PURE__ */ d.jsx(KP, {}),
    errorComponent: /* @__PURE__ */ d.jsx(WP, { refetch: a, t: o }),
    children: /* @__PURE__ */ d.jsxs(YP, { onClick: s, children: [
      o(e ? Ua.emptyMessage : Ua.filesCount(t)),
      e && /* @__PURE__ */ d.jsx(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "inline-block align-middle pl-2 cursor-pointer",
          onClick: i,
          children: /* @__PURE__ */ d.jsx(sn.Icon, { name: "info", width: 16, height: 16, className: "text-white" })
        }
      )
    ] })
  }
) }), XP = he(QP), hb = Je(({ onButtonClick: e, onInfoClick: t }, n) => {
  const { t: r } = Fe(), { data: s, isLoading: i, isError: a, refetch: o } = BP({
    limit: UP
  });
  UT(
    n,
    () => ({
      refetch: o
    }),
    [o]
  );
  const u = FP({
    data: s,
    isLoading: i,
    isError: a,
    refetch: o,
    onButtonClick: e,
    onInfoClick: t
  });
  return /* @__PURE__ */ d.jsx(XP, { ...u, t: r });
});
hb.displayName = "FileUpload";
const JP = ({ copiedDuration: e = 3e3 } = {}) => {
  const { workspaceId: t } = pt(), n = Re(), r = n.message(), s = n.composer(), i = Re(), a = J((u) => {
    const c = u?.message;
    return c ? (c.role !== "assistant" || c.status.type !== "running") && c.content.some((l) => l.type === "text" && l.text?.length > 0) : !1;
  }), o = ne(() => {
    const { isEditing: u, text: c } = s.getState(), l = u ? c : r.getCopyText(), h = new Ll(t, l).replaceWidgetTagWithLink().build();
    navigator.clipboard.writeText(h).then(() => {
      i.message().setIsCopied(!0), setTimeout(() => i.message().setIsCopied(!1), e);
    });
  }, [s, r, t, i, e]);
  return a ? o : null;
}, Fl = Je(({ copiedDuration: e, onClick: t, disabled: n, ...r }, s) => {
  const i = J((o) => o.message.isCopied), a = JP({ copiedDuration: e });
  return /* @__PURE__ */ d.jsx(
    Rt.button,
    {
      type: "button",
      ...i ? { "data-copied": "true" } : {},
      ...r,
      ref: s,
      disabled: n || !a,
      onClick: be(t, () => {
        a?.();
      })
    }
  );
});
Fl.displayName = "ActionBarPrimitive.Copy";
function Ef(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), s = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const a = n.slice(s, r).trim();
    (a || !i) && t.push(a), s = r + 1, r = n.indexOf(",", s);
  }
  return t;
}
function fb(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const ZP = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, e3 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, t3 = {};
function bf(e, t) {
  return (t3.jsx ? e3 : ZP).test(e);
}
const n3 = /[ \t\n\f\r]/g;
function r3(e) {
  return typeof e == "object" ? e.type === "text" ? _f(e.value) : !1 : _f(e);
}
function _f(e) {
  return e.replace(n3, "") === "";
}
class Ni {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Ni.prototype.normal = {};
Ni.prototype.property = {};
Ni.prototype.space = void 0;
function pb(e, t) {
  const n = {}, r = {};
  for (const s of e)
    Object.assign(n, s.property), Object.assign(r, s.normal);
  return new Ni(n, r, t);
}
function hi(e) {
  return e.toLowerCase();
}
class Pt {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Pt.prototype.attribute = "";
Pt.prototype.booleanish = !1;
Pt.prototype.boolean = !1;
Pt.prototype.commaOrSpaceSeparated = !1;
Pt.prototype.commaSeparated = !1;
Pt.prototype.defined = !1;
Pt.prototype.mustUseProperty = !1;
Pt.prototype.number = !1;
Pt.prototype.overloadedBoolean = !1;
Pt.prototype.property = "";
Pt.prototype.spaceSeparated = !1;
Pt.prototype.space = void 0;
let s3 = 0;
const Ie = Hr(), rt = Hr(), Ac = Hr(), X = Hr(), We = Hr(), ns = Hr(), Lt = Hr();
function Hr() {
  return 2 ** ++s3;
}
const yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Ie,
  booleanish: rt,
  commaOrSpaceSeparated: Lt,
  commaSeparated: ns,
  number: X,
  overloadedBoolean: Ac,
  spaceSeparated: We
}, Symbol.toStringTag, { value: "Module" })), xu = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(yc)
);
class jl extends Pt {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, s) {
    let i = -1;
    if (super(t, n), Tf(this, "space", s), typeof r == "number")
      for (; ++i < xu.length; ) {
        const a = xu[i];
        Tf(this, xu[i], (r & yc[a]) === yc[a]);
      }
  }
}
jl.prototype.defined = !0;
function Tf(e, t, n) {
  n && (e[t] = n);
}
function Ts(e) {
  const t = {}, n = {};
  for (const [r, s] of Object.entries(e.properties)) {
    const i = new jl(
      r,
      e.transform(e.attributes || {}, r),
      s,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[hi(r)] = r, n[hi(i.attribute)] = r;
  }
  return new Ni(t, n, e.space);
}
const mb = Ts({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: rt,
    ariaAutoComplete: null,
    ariaBusy: rt,
    ariaChecked: rt,
    ariaColCount: X,
    ariaColIndex: X,
    ariaColSpan: X,
    ariaControls: We,
    ariaCurrent: null,
    ariaDescribedBy: We,
    ariaDetails: null,
    ariaDisabled: rt,
    ariaDropEffect: We,
    ariaErrorMessage: null,
    ariaExpanded: rt,
    ariaFlowTo: We,
    ariaGrabbed: rt,
    ariaHasPopup: null,
    ariaHidden: rt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: We,
    ariaLevel: X,
    ariaLive: null,
    ariaModal: rt,
    ariaMultiLine: rt,
    ariaMultiSelectable: rt,
    ariaOrientation: null,
    ariaOwns: We,
    ariaPlaceholder: null,
    ariaPosInSet: X,
    ariaPressed: rt,
    ariaReadOnly: rt,
    ariaRelevant: null,
    ariaRequired: rt,
    ariaRoleDescription: We,
    ariaRowCount: X,
    ariaRowIndex: X,
    ariaRowSpan: X,
    ariaSelected: rt,
    ariaSetSize: X,
    ariaSort: null,
    ariaValueMax: X,
    ariaValueMin: X,
    ariaValueNow: X,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function gb(e, t) {
  return t in e ? e[t] : t;
}
function Eb(e, t) {
  return gb(e, t.toLowerCase());
}
const i3 = Ts({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ns,
    acceptCharset: We,
    accessKey: We,
    action: null,
    allow: null,
    allowFullScreen: Ie,
    allowPaymentRequest: Ie,
    allowUserMedia: Ie,
    alt: null,
    as: null,
    async: Ie,
    autoCapitalize: null,
    autoComplete: We,
    autoFocus: Ie,
    autoPlay: Ie,
    blocking: We,
    capture: null,
    charSet: null,
    checked: Ie,
    cite: null,
    className: We,
    cols: X,
    colSpan: null,
    content: null,
    contentEditable: rt,
    controls: Ie,
    controlsList: We,
    coords: X | ns,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Ie,
    defer: Ie,
    dir: null,
    dirName: null,
    disabled: Ie,
    download: Ac,
    draggable: rt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Ie,
    formTarget: null,
    headers: We,
    height: X,
    hidden: Ac,
    high: X,
    href: null,
    hrefLang: null,
    htmlFor: We,
    httpEquiv: We,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Ie,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Ie,
    itemId: null,
    itemProp: We,
    itemRef: We,
    itemScope: Ie,
    itemType: We,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Ie,
    low: X,
    manifest: null,
    max: null,
    maxLength: X,
    media: null,
    method: null,
    min: null,
    minLength: X,
    multiple: Ie,
    muted: Ie,
    name: null,
    nonce: null,
    noModule: Ie,
    noValidate: Ie,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Ie,
    optimum: X,
    pattern: null,
    ping: We,
    placeholder: null,
    playsInline: Ie,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Ie,
    referrerPolicy: null,
    rel: We,
    required: Ie,
    reversed: Ie,
    rows: X,
    rowSpan: X,
    sandbox: We,
    scope: null,
    scoped: Ie,
    seamless: Ie,
    selected: Ie,
    shadowRootClonable: Ie,
    shadowRootDelegatesFocus: Ie,
    shadowRootMode: null,
    shape: null,
    size: X,
    sizes: null,
    slot: null,
    span: X,
    spellCheck: rt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: X,
    step: null,
    style: null,
    tabIndex: X,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Ie,
    useMap: null,
    value: rt,
    width: X,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: We,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: X,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: X,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Ie,
    // Lists. Use CSS to reduce space between items instead
    declare: Ie,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: X,
    // `<img>` and `<object>`
    leftMargin: X,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: X,
    // `<body>`
    marginWidth: X,
    // `<body>`
    noResize: Ie,
    // `<frame>`
    noHref: Ie,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Ie,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Ie,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: X,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: rt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: X,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: X,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Ie,
    disableRemotePlayback: Ie,
    prefix: null,
    property: null,
    results: X,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Eb
}), a3 = Ts({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Lt,
    accentHeight: X,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: X,
    amplitude: X,
    arabicForm: null,
    ascent: X,
    attributeName: null,
    attributeType: null,
    azimuth: X,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: X,
    by: null,
    calcMode: null,
    capHeight: X,
    className: We,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: X,
    diffuseConstant: X,
    direction: null,
    display: null,
    dur: null,
    divisor: X,
    dominantBaseline: null,
    download: Ie,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: X,
    enableBackground: null,
    end: null,
    event: null,
    exponent: X,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: X,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ns,
    g2: ns,
    glyphName: ns,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: X,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: X,
    horizOriginX: X,
    horizOriginY: X,
    id: null,
    ideographic: X,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: X,
    k: X,
    k1: X,
    k2: X,
    k3: X,
    k4: X,
    kernelMatrix: Lt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: X,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: X,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: X,
    overlineThickness: X,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: X,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: We,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: X,
    pointsAtY: X,
    pointsAtZ: X,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Lt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Lt,
    rev: Lt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Lt,
    requiredFeatures: Lt,
    requiredFonts: Lt,
    requiredFormats: Lt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: X,
    specularExponent: X,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: X,
    strikethroughThickness: X,
    string: null,
    stroke: null,
    strokeDashArray: Lt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: X,
    strokeOpacity: X,
    strokeWidth: null,
    style: null,
    surfaceScale: X,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Lt,
    tabIndex: X,
    tableValues: null,
    target: null,
    targetX: X,
    targetY: X,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Lt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: X,
    underlineThickness: X,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: X,
    values: null,
    vAlphabetic: X,
    vMathematical: X,
    vectorEffect: null,
    vHanging: X,
    vIdeographic: X,
    version: null,
    vertAdvY: X,
    vertOriginX: X,
    vertOriginY: X,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: X,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: gb
}), bb = Ts({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), _b = Ts({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Eb
}), Tb = Ts({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), o3 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, u3 = /[A-Z]/g, Af = /-[a-z]/g, c3 = /^data[-\w.:]+$/i;
function No(e, t) {
  const n = hi(t);
  let r = t, s = Pt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && c3.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(Af, d3);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!Af.test(i)) {
        let a = i.replace(u3, l3);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    s = jl;
  }
  return new s(r, t);
}
function l3(e) {
  return "-" + e.toLowerCase();
}
function d3(e) {
  return e.charAt(1).toUpperCase();
}
const ki = pb([mb, i3, bb, _b, Tb], "html"), sr = pb([mb, a3, bb, _b, Tb], "svg");
function yf(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function Ab(e) {
  return e.join(" ").trim();
}
var Ms = {}, na = { exports: {} }, Cu, xf;
function h3() {
  if (xf) return Cu;
  xf = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, s = /^:\s*/, i = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, a = /^[;\s]*/, o = /^\s+|\s+$/g, u = `
`, c = "/", l = "*", h = "", m = "comment", p = "declaration";
  Cu = function(g, _) {
    if (typeof g != "string")
      throw new TypeError("First argument must be a string");
    if (!g) return [];
    _ = _ || {};
    var b = 1, T = 1;
    function C(F) {
      var M = F.match(t);
      M && (b += M.length);
      var H = F.lastIndexOf(u);
      T = ~H ? F.length - H : T + F.length;
    }
    function R() {
      var F = { line: b, column: T };
      return function(M) {
        return M.position = new D(F), U(), M;
      };
    }
    function D(F) {
      this.start = F, this.end = { line: b, column: T }, this.source = _.source;
    }
    D.prototype.content = g;
    function I(F) {
      var M = new Error(
        _.source + ":" + b + ":" + T + ": " + F
      );
      if (M.reason = F, M.filename = _.source, M.line = b, M.column = T, M.source = g, !_.silent) throw M;
    }
    function O(F) {
      var M = F.exec(g);
      if (M) {
        var H = M[0];
        return C(H), g = g.slice(H.length), M;
      }
    }
    function U() {
      O(n);
    }
    function q(F) {
      var M;
      for (F = F || []; M = P(); )
        M !== !1 && F.push(M);
      return F;
    }
    function P() {
      var F = R();
      if (!(c != g.charAt(0) || l != g.charAt(1))) {
        for (var M = 2; h != g.charAt(M) && (l != g.charAt(M) || c != g.charAt(M + 1)); )
          ++M;
        if (M += 2, h === g.charAt(M - 1))
          return I("End of comment missing");
        var H = g.slice(2, M - 2);
        return T += 2, C(H), g = g.slice(M), T += 2, F({
          type: m,
          comment: H
        });
      }
    }
    function z() {
      var F = R(), M = O(r);
      if (M) {
        if (P(), !O(s)) return I("property missing ':'");
        var H = O(i), B = F({
          type: p,
          property: E(M[0].replace(e, h)),
          value: H ? E(H[0].replace(e, h)) : h
        });
        return O(a), B;
      }
    }
    function G() {
      var F = [];
      q(F);
      for (var M; M = z(); )
        M !== !1 && (F.push(M), q(F));
      return F;
    }
    return U(), G();
  };
  function E(g) {
    return g ? g.replace(o, h) : h;
  }
  return Cu;
}
var Cf;
function f3() {
  if (Cf) return na.exports;
  Cf = 1;
  var e = h3();
  function t(n, r) {
    var s = null;
    if (!n || typeof n != "string")
      return s;
    for (var i, a = e(n), o = typeof r == "function", u, c, l = 0, h = a.length; l < h; l++)
      i = a[l], u = i.property, c = i.value, o ? r(u, c, i) : c && (s || (s = {}), s[u] = c);
    return s;
  }
  return na.exports = t, na.exports.default = t, na.exports;
}
var Hs = {}, Sf;
function p3() {
  if (Sf) return Hs;
  Sf = 1, Hs.__esModule = !0, Hs.camelCase = void 0;
  var e = /^--[a-zA-Z0-9-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, s = /^-(ms)-/, i = function(c) {
    return !c || n.test(c) || e.test(c);
  }, a = function(c, l) {
    return l.toUpperCase();
  }, o = function(c, l) {
    return "".concat(l, "-");
  }, u = function(c, l) {
    return l === void 0 && (l = {}), i(c) ? c : (c = c.toLowerCase(), l.reactCompat ? c = c.replace(s, o) : c = c.replace(r, o), c.replace(t, a));
  };
  return Hs.camelCase = u, Hs;
}
var If;
function m3() {
  return If || (If = 1, (function(e) {
    var t = Ms && Ms.__importDefault || function(i) {
      return i && i.__esModule ? i : { default: i };
    };
    e.__esModule = !0;
    var n = t(f3()), r = p3();
    function s(i, a) {
      var o = {};
      return !i || typeof i != "string" || (0, n.default)(i, function(u, c) {
        u && c && (o[(0, r.camelCase)(u, a)] = c);
      }), o;
    }
    e.default = s;
  })(Ms)), Ms;
}
var g3 = m3();
const E3 = /* @__PURE__ */ Rr(g3), ko = yb("end"), _n = yb("start");
function yb(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function b3(e) {
  const t = _n(e), n = ko(e);
  if (t && n)
    return { start: t, end: n };
}
function Xs(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? wf(e.position) : "start" in e || "end" in e ? wf(e) : "line" in e || "column" in e ? xc(e) : "";
}
function xc(e) {
  return vf(e && e.line) + ":" + vf(e && e.column);
}
function wf(e) {
  return xc(e && e.start) + "-" + xc(e && e.end);
}
function vf(e) {
  return e && typeof e == "number" ? e : 1;
}
class Tt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let s = "", i = {}, a = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? s = t : !i.cause && t && (a = !0, s = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? i.ruleId = r : (i.source = r.slice(0, u), i.ruleId = r.slice(u + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const u = i.ancestors[i.ancestors.length - 1];
      u && (i.place = u.position);
    }
    const o = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file = "", this.message = s, this.line = o ? o.line : void 0, this.name = Xs(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = a && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
Tt.prototype.file = "";
Tt.prototype.name = "";
Tt.prototype.reason = "";
Tt.prototype.message = "";
Tt.prototype.stack = "";
Tt.prototype.column = void 0;
Tt.prototype.line = void 0;
Tt.prototype.ancestors = void 0;
Tt.prototype.cause = void 0;
Tt.prototype.fatal = void 0;
Tt.prototype.place = void 0;
Tt.prototype.ruleId = void 0;
Tt.prototype.source = void 0;
const $l = {}.hasOwnProperty, _3 = /* @__PURE__ */ new Map(), T3 = /[A-Z]/g, A3 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), y3 = /* @__PURE__ */ new Set(["td", "th"]), xb = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function x3(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = R3(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = k3(n, t.jsx, t.jsxs);
  }
  const s = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? sr : ki,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, i = Cb(s, e, void 0);
  return i && typeof i != "string" ? i : s.create(
    e,
    s.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function Cb(e, t, n) {
  if (t.type === "element")
    return C3(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return S3(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return w3(e, t, n);
  if (t.type === "mdxjsEsm")
    return I3(e, t);
  if (t.type === "root")
    return v3(e, t, n);
  if (t.type === "text")
    return N3(e, t);
}
function C3(e, t, n) {
  const r = e.schema;
  let s = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (s = sr, e.schema = s), e.ancestors.push(t);
  const i = Ib(e, t.tagName, !1), a = P3(e, t);
  let o = Vl(e, t);
  return A3.has(t.tagName) && (o = o.filter(function(u) {
    return typeof u == "string" ? !r3(u) : !0;
  })), Sb(e, a, i, t), zl(a, o), e.ancestors.pop(), e.schema = r, e.create(t, i, a, n);
}
function S3(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  fi(e, t.position);
}
function I3(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  fi(e, t.position);
}
function w3(e, t, n) {
  const r = e.schema;
  let s = r;
  t.name === "svg" && r.space === "html" && (s = sr, e.schema = s), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : Ib(e, t.name, !0), a = O3(e, t), o = Vl(e, t);
  return Sb(e, a, i, t), zl(a, o), e.ancestors.pop(), e.schema = r, e.create(t, i, a, n);
}
function v3(e, t, n) {
  const r = {};
  return zl(r, Vl(e, t)), e.create(t, e.Fragment, r, n);
}
function N3(e, t) {
  return t.value;
}
function Sb(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function zl(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function k3(e, t, n) {
  return r;
  function r(s, i, a, o) {
    const c = Array.isArray(a.children) ? n : t;
    return o ? c(i, a, o) : c(i, a);
  }
}
function R3(e, t) {
  return n;
  function n(r, s, i, a) {
    const o = Array.isArray(i.children), u = _n(r);
    return t(
      s,
      i,
      a,
      o,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function P3(e, t) {
  const n = {};
  let r, s;
  for (s in t.properties)
    if (s !== "children" && $l.call(t.properties, s)) {
      const i = D3(e, s, t.properties[s]);
      if (i) {
        const [a, o] = i;
        e.tableCellAlignToStyle && a === "align" && typeof o == "string" && y3.has(t.tagName) ? r = o : n[a] = o;
      }
    }
  if (r) {
    const i = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function O3(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const i = r.data.estree.body[0];
        i.type;
        const a = i.expression;
        a.type;
        const o = a.properties[0];
        o.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(o.argument)
        );
      } else
        fi(e, t.position);
    else {
      const s = r.name;
      let i;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const o = r.value.data.estree.body[0];
          o.type, i = e.evaluater.evaluateExpression(o.expression);
        } else
          fi(e, t.position);
      else
        i = r.value === null ? !0 : r.value;
      n[s] = /** @type {Props[keyof Props]} */
      i;
    }
  return n;
}
function Vl(e, t) {
  const n = [];
  let r = -1;
  const s = e.passKeys ? /* @__PURE__ */ new Map() : _3;
  for (; ++r < t.children.length; ) {
    const i = t.children[r];
    let a;
    if (e.passKeys) {
      const u = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (u) {
        const c = s.get(u) || 0;
        a = u + "-" + c, s.set(u, c + 1);
      }
    }
    const o = Cb(e, i, a);
    o !== void 0 && n.push(o);
  }
  return n;
}
function D3(e, t, n) {
  const r = No(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? fb(n) : Ab(n)), r.property === "style") {
      let s = typeof n == "object" ? n : L3(e, String(n));
      return e.stylePropertyNameCase === "css" && (s = M3(s)), ["style", s];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? o3[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function L3(e, t) {
  try {
    return E3(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), s = new Tt("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw s.file = e.filePath || void 0, s.url = xb + "#cannot-parse-style-attribute", s;
  }
}
function Ib(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const s = t.split(".");
    let i = -1, a;
    for (; ++i < s.length; ) {
      const o = bf(s[i]) ? { type: "Identifier", name: s[i] } : { type: "Literal", value: s[i] };
      a = a ? {
        type: "MemberExpression",
        object: a,
        property: o,
        computed: !!(i && o.type === "Literal"),
        optional: !1
      } : o;
    }
    r = a;
  } else
    r = bf(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const s = (
      /** @type {string | number} */
      r.value
    );
    return $l.call(e.components, s) ? e.components[s] : s;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  fi(e);
}
function fi(e, t) {
  const n = new Tt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = xb + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function M3(e) {
  const t = {};
  let n;
  for (n in e)
    $l.call(e, n) && (t[H3(n)] = e[n]);
  return t;
}
function H3(e) {
  let t = e.replace(T3, B3);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function B3(e) {
  return "-" + e.toLowerCase();
}
const Su = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, U3 = {};
function Yl(e, t) {
  const n = U3, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, s = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return wb(e, r, s);
}
function wb(e, t, n) {
  if (F3(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Nf(e.children, t, n);
  }
  return Array.isArray(e) ? Nf(e, t, n) : "";
}
function Nf(e, t, n) {
  const r = [];
  let s = -1;
  for (; ++s < e.length; )
    r[s] = wb(e[s], t, n);
  return r.join("");
}
function F3(e) {
  return !!(e && typeof e == "object");
}
const kf = document.createElement("i");
function Gl(e) {
  const t = "&" + e + ";";
  kf.innerHTML = t;
  const n = kf.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Ut(e, t, n, r) {
  const s = e.length;
  let i = 0, a;
  if (t < 0 ? t = -t > s ? 0 : s + t : t = t > s ? s : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); i < r.length; )
      a = r.slice(i, i + 1e4), a.unshift(t, 0), e.splice(...a), i += 1e4, t += 1e4;
}
function Yt(e, t) {
  return e.length > 0 ? (Ut(e, e.length, 0, t), e) : t;
}
const Rf = {}.hasOwnProperty;
function vb(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    j3(t, e[n]);
  return t;
}
function j3(e, t) {
  let n;
  for (n in t) {
    const s = (Rf.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let a;
    if (i)
      for (a in i) {
        Rf.call(s, a) || (s[a] = []);
        const o = i[a];
        $3(
          // @ts-expect-error Looks like a list.
          s[a],
          Array.isArray(o) ? o : o ? [o] : []
        );
      }
  }
}
function $3(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Ut(e, 0, 0, r);
}
function Nb(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function en(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const St = ir(/[A-Za-z]/), Et = ir(/[\dA-Za-z]/), z3 = ir(/[#-'*+\--9=?A-Z^-~]/);
function Fa(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Cc = ir(/\d/), V3 = ir(/[\dA-Fa-f]/), Y3 = ir(/[!-/:-@[-`{-~]/);
function me(e) {
  return e !== null && e < -2;
}
function Ge(e) {
  return e !== null && (e < 0 || e === 32);
}
function ke(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ro = ir(/\p{P}|\p{S}/u), kr = ir(/\s/);
function ir(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function As(e) {
  const t = [];
  let n = -1, r = 0, s = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let a = "";
    if (i === 37 && Et(e.charCodeAt(n + 1)) && Et(e.charCodeAt(n + 2)))
      s = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (a = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const o = e.charCodeAt(n + 1);
      i < 56320 && o > 56319 && o < 57344 ? (a = String.fromCharCode(i, o), s = 1) : a = "�";
    } else
      a = String.fromCharCode(i);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + s + 1, a = ""), s && (n += s, s = 0);
  }
  return t.join("") + e.slice(r);
}
function Le(e, t, n, r) {
  const s = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return a;
  function a(u) {
    return ke(u) ? (e.enter(n), o(u)) : t(u);
  }
  function o(u) {
    return ke(u) && i++ < s ? (e.consume(u), o) : (e.exit(n), t(u));
  }
}
const G3 = {
  tokenize: W3
};
function W3(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, s);
  let n;
  return t;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Le(e, t, "linePrefix");
  }
  function s(o) {
    return e.enter("paragraph"), i(o);
  }
  function i(o) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, a(o);
  }
  function a(o) {
    if (o === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(o);
      return;
    }
    return me(o) ? (e.consume(o), e.exit("chunkText"), i) : (e.consume(o), a);
  }
}
const q3 = {
  tokenize: K3
}, Pf = {
  tokenize: Q3
};
function K3(e) {
  const t = this, n = [];
  let r = 0, s, i, a;
  return o;
  function o(C) {
    if (r < n.length) {
      const R = n[r];
      return t.containerState = R[1], e.attempt(R[0].continuation, u, c)(C);
    }
    return c(C);
  }
  function u(C) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, s && T();
      const R = t.events.length;
      let D = R, I;
      for (; D--; )
        if (t.events[D][0] === "exit" && t.events[D][1].type === "chunkFlow") {
          I = t.events[D][1].end;
          break;
        }
      b(r);
      let O = R;
      for (; O < t.events.length; )
        t.events[O][1].end = {
          ...I
        }, O++;
      return Ut(t.events, D + 1, 0, t.events.slice(R)), t.events.length = O, c(C);
    }
    return o(C);
  }
  function c(C) {
    if (r === n.length) {
      if (!s)
        return m(C);
      if (s.currentConstruct && s.currentConstruct.concrete)
        return E(C);
      t.interrupt = !!(s.currentConstruct && !s._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Pf, l, h)(C);
  }
  function l(C) {
    return s && T(), b(r), m(C);
  }
  function h(C) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, E(C);
  }
  function m(C) {
    return t.containerState = {}, e.attempt(Pf, p, E)(C);
  }
  function p(C) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(C);
  }
  function E(C) {
    if (C === null) {
      s && T(), b(0), e.consume(C);
      return;
    }
    return s = s || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: s,
      contentType: "flow",
      previous: i
    }), g(C);
  }
  function g(C) {
    if (C === null) {
      _(e.exit("chunkFlow"), !0), b(0), e.consume(C);
      return;
    }
    return me(C) ? (e.consume(C), _(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, o) : (e.consume(C), g);
  }
  function _(C, R) {
    const D = t.sliceStream(C);
    if (R && D.push(null), C.previous = i, i && (i.next = C), i = C, s.defineSkip(C.start), s.write(D), t.parser.lazy[C.start.line]) {
      let I = s.events.length;
      for (; I--; )
        if (
          // The token starts before the line ending…
          s.events[I][1].start.offset < a && // …and either is not ended yet…
          (!s.events[I][1].end || // …or ends after it.
          s.events[I][1].end.offset > a)
        )
          return;
      const O = t.events.length;
      let U = O, q, P;
      for (; U--; )
        if (t.events[U][0] === "exit" && t.events[U][1].type === "chunkFlow") {
          if (q) {
            P = t.events[U][1].end;
            break;
          }
          q = !0;
        }
      for (b(r), I = O; I < t.events.length; )
        t.events[I][1].end = {
          ...P
        }, I++;
      Ut(t.events, U + 1, 0, t.events.slice(O)), t.events.length = I;
    }
  }
  function b(C) {
    let R = n.length;
    for (; R-- > C; ) {
      const D = n[R];
      t.containerState = D[1], D[0].exit.call(t, e);
    }
    n.length = C;
  }
  function T() {
    s.write([null]), i = void 0, s = void 0, t.containerState._closeFlow = void 0;
  }
}
function Q3(e, t, n) {
  return Le(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function ds(e) {
  if (e === null || Ge(e) || kr(e))
    return 1;
  if (Ro(e))
    return 2;
}
function Po(e, t, n) {
  const r = [];
  let s = -1;
  for (; ++s < e.length; ) {
    const i = e[s].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const Sc = {
  name: "attention",
  resolveAll: X3,
  tokenize: J3
};
function X3(e, t) {
  let n = -1, r, s, i, a, o, u, c, l;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const h = {
            ...e[r][1].end
          }, m = {
            ...e[n][1].start
          };
          Of(h, -u), Of(m, u), a = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: {
              ...e[r][1].end
            }
          }, o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, i = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, s = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...a.start
            },
            end: {
              ...o.end
            }
          }, e[r][1].end = {
            ...a.start
          }, e[n][1].start = {
            ...o.end
          }, c = [], e[r][1].end.offset - e[r][1].start.offset && (c = Yt(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = Yt(c, [["enter", s, t], ["enter", a, t], ["exit", a, t], ["enter", i, t]]), c = Yt(c, Po(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = Yt(c, [["exit", i, t], ["enter", o, t], ["exit", o, t], ["exit", s, t]]), e[n][1].end.offset - e[n][1].start.offset ? (l = 2, c = Yt(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : l = 0, Ut(e, r - 1, n - r + 3, c), n = r + c.length - l - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function J3(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, s = ds(r);
  let i;
  return a;
  function a(u) {
    return i = u, e.enter("attentionSequence"), o(u);
  }
  function o(u) {
    if (u === i)
      return e.consume(u), o;
    const c = e.exit("attentionSequence"), l = ds(u), h = !l || l === 2 && s || n.includes(u), m = !s || s === 2 && l || n.includes(r);
    return c._open = !!(i === 42 ? h : h && (s || !m)), c._close = !!(i === 42 ? m : m && (l || !h)), t(u);
  }
}
function Of(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Z3 = {
  name: "autolink",
  tokenize: eO
};
function eO(e, t, n) {
  let r = 0;
  return s;
  function s(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(p) {
    return St(p) ? (e.consume(p), a) : p === 64 ? n(p) : c(p);
  }
  function a(p) {
    return p === 43 || p === 45 || p === 46 || Et(p) ? (r = 1, o(p)) : c(p);
  }
  function o(p) {
    return p === 58 ? (e.consume(p), r = 0, u) : (p === 43 || p === 45 || p === 46 || Et(p)) && r++ < 32 ? (e.consume(p), o) : (r = 0, c(p));
  }
  function u(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || Fa(p) ? n(p) : (e.consume(p), u);
  }
  function c(p) {
    return p === 64 ? (e.consume(p), l) : z3(p) ? (e.consume(p), c) : n(p);
  }
  function l(p) {
    return Et(p) ? h(p) : n(p);
  }
  function h(p) {
    return p === 46 ? (e.consume(p), r = 0, l) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(p);
  }
  function m(p) {
    if ((p === 45 || Et(p)) && r++ < 63) {
      const E = p === 45 ? m : h;
      return e.consume(p), E;
    }
    return n(p);
  }
}
const Ri = {
  partial: !0,
  tokenize: tO
};
function tO(e, t, n) {
  return r;
  function r(i) {
    return ke(i) ? Le(e, s, "linePrefix")(i) : s(i);
  }
  function s(i) {
    return i === null || me(i) ? t(i) : n(i);
  }
}
const kb = {
  continuation: {
    tokenize: rO
  },
  exit: sO,
  name: "blockQuote",
  tokenize: nO
};
function nO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    if (a === 62) {
      const o = r.containerState;
      return o.open || (e.enter("blockQuote", {
        _container: !0
      }), o.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), i;
    }
    return n(a);
  }
  function i(a) {
    return ke(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function rO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return ke(a) ? Le(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a) : i(a);
  }
  function i(a) {
    return e.attempt(kb, t, n)(a);
  }
}
function sO(e) {
  e.exit("blockQuote");
}
const Rb = {
  name: "characterEscape",
  tokenize: iO
};
function iO(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), s;
  }
  function s(i) {
    return Y3(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const Pb = {
  name: "characterReference",
  tokenize: aO
};
function aO(e, t, n) {
  const r = this;
  let s = 0, i, a;
  return o;
  function o(h) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), u;
  }
  function u(h) {
    return h === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(h), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), i = 31, a = Et, l(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(h), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, a = V3, l) : (e.enter("characterReferenceValue"), i = 7, a = Cc, l(h));
  }
  function l(h) {
    if (h === 59 && s) {
      const m = e.exit("characterReferenceValue");
      return a === Et && !Gl(r.sliceSerialize(m)) ? n(h) : (e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(h) && s++ < i ? (e.consume(h), l) : n(h);
  }
}
const Df = {
  partial: !0,
  tokenize: uO
}, Lf = {
  concrete: !0,
  name: "codeFenced",
  tokenize: oO
};
function oO(e, t, n) {
  const r = this, s = {
    partial: !0,
    tokenize: D
  };
  let i = 0, a = 0, o;
  return u;
  function u(I) {
    return c(I);
  }
  function c(I) {
    const O = r.events[r.events.length - 1];
    return i = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, o = I, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), l(I);
  }
  function l(I) {
    return I === o ? (a++, e.consume(I), l) : a < 3 ? n(I) : (e.exit("codeFencedFenceSequence"), ke(I) ? Le(e, h, "whitespace")(I) : h(I));
  }
  function h(I) {
    return I === null || me(I) ? (e.exit("codeFencedFence"), r.interrupt ? t(I) : e.check(Df, g, R)(I)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(I));
  }
  function m(I) {
    return I === null || me(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), h(I)) : ke(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Le(e, p, "whitespace")(I)) : I === 96 && I === o ? n(I) : (e.consume(I), m);
  }
  function p(I) {
    return I === null || me(I) ? h(I) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), E(I));
  }
  function E(I) {
    return I === null || me(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), h(I)) : I === 96 && I === o ? n(I) : (e.consume(I), E);
  }
  function g(I) {
    return e.attempt(s, R, _)(I);
  }
  function _(I) {
    return e.enter("lineEnding"), e.consume(I), e.exit("lineEnding"), b;
  }
  function b(I) {
    return i > 0 && ke(I) ? Le(e, T, "linePrefix", i + 1)(I) : T(I);
  }
  function T(I) {
    return I === null || me(I) ? e.check(Df, g, R)(I) : (e.enter("codeFlowValue"), C(I));
  }
  function C(I) {
    return I === null || me(I) ? (e.exit("codeFlowValue"), T(I)) : (e.consume(I), C);
  }
  function R(I) {
    return e.exit("codeFenced"), t(I);
  }
  function D(I, O, U) {
    let q = 0;
    return P;
    function P(H) {
      return I.enter("lineEnding"), I.consume(H), I.exit("lineEnding"), z;
    }
    function z(H) {
      return I.enter("codeFencedFence"), ke(H) ? Le(I, G, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : G(H);
    }
    function G(H) {
      return H === o ? (I.enter("codeFencedFenceSequence"), F(H)) : U(H);
    }
    function F(H) {
      return H === o ? (q++, I.consume(H), F) : q >= a ? (I.exit("codeFencedFenceSequence"), ke(H) ? Le(I, M, "whitespace")(H) : M(H)) : U(H);
    }
    function M(H) {
      return H === null || me(H) ? (I.exit("codeFencedFence"), O(H)) : U(H);
    }
  }
}
function uO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const Iu = {
  name: "codeIndented",
  tokenize: lO
}, cO = {
  partial: !0,
  tokenize: dO
};
function lO(e, t, n) {
  const r = this;
  return s;
  function s(c) {
    return e.enter("codeIndented"), Le(e, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? a(c) : n(c);
  }
  function a(c) {
    return c === null ? u(c) : me(c) ? e.attempt(cO, a, u)(c) : (e.enter("codeFlowValue"), o(c));
  }
  function o(c) {
    return c === null || me(c) ? (e.exit("codeFlowValue"), a(c)) : (e.consume(c), o);
  }
  function u(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function dO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return r.parser.lazy[r.now().line] ? n(a) : me(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), s) : Le(e, i, "linePrefix", 5)(a);
  }
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(a) : me(a) ? s(a) : n(a);
  }
}
const hO = {
  name: "codeText",
  previous: pO,
  resolve: fO,
  tokenize: mO
};
function fO(e) {
  let t = e.length - 4, n = 3, r, s;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    s === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (s = r) : (r === t || e[r][1].type === "lineEnding") && (e[s][1].type = "codeTextData", r !== s + 2 && (e[s][1].end = e[r - 1][1].end, e.splice(s + 2, r - s - 2), t -= r - s - 2, r = s + 2), s = void 0);
  return e;
}
function pO(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function mO(e, t, n) {
  let r = 0, s, i;
  return a;
  function a(h) {
    return e.enter("codeText"), e.enter("codeTextSequence"), o(h);
  }
  function o(h) {
    return h === 96 ? (e.consume(h), r++, o) : (e.exit("codeTextSequence"), u(h));
  }
  function u(h) {
    return h === null ? n(h) : h === 32 ? (e.enter("space"), e.consume(h), e.exit("space"), u) : h === 96 ? (i = e.enter("codeTextSequence"), s = 0, l(h)) : me(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), u) : (e.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || me(h) ? (e.exit("codeTextData"), u(h)) : (e.consume(h), c);
  }
  function l(h) {
    return h === 96 ? (e.consume(h), s++, l) : s === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(h)) : (i.type = "codeTextData", c(h));
  }
}
class gO {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const s = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - s, Number.POSITIVE_INFINITY);
    return r && Bs(this.left, r), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Bs(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Bs(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Bs(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Bs(this.left, n.reverse());
      }
  }
}
function Bs(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Ob(e) {
  const t = {};
  let n = -1, r, s, i, a, o, u, c;
  const l = new gO(e);
  for (; ++n < l.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = l.get(n), n && r[1].type === "chunkFlow" && l.get(n - 1)[1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, i = 0, i < u.length && u[i][1].type === "lineEndingBlank" && (i += 2), i < u.length && u[i][1].type === "content"))
      for (; ++i < u.length && u[i][1].type !== "content"; )
        u[i][1].type === "chunkText" && (u[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, EO(l, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (i = n, s = void 0; i--; )
        if (a = l.get(i), a[1].type === "lineEnding" || a[1].type === "lineEndingBlank")
          a[0] === "enter" && (s && (l.get(s)[1].type = "lineEndingBlank"), a[1].type = "lineEnding", s = i);
        else if (!(a[1].type === "linePrefix" || a[1].type === "listItemIndent")) break;
      s && (r[1].end = {
        ...l.get(s)[1].start
      }, o = l.slice(s, n), o.unshift(r), l.splice(s, n - s + 1, o));
    }
  }
  return Ut(e, 0, Number.POSITIVE_INFINITY, l.slice(0)), !c;
}
function EO(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let s = t - 1;
  const i = [];
  let a = n._tokenizer;
  a || (a = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (a._contentTypeTextTrailing = !0));
  const o = a.events, u = [], c = {};
  let l, h, m = -1, p = n, E = 0, g = 0;
  const _ = [g];
  for (; p; ) {
    for (; e.get(++s)[1] !== p; )
      ;
    i.push(s), p._tokenizer || (l = r.sliceStream(p), p.next || l.push(null), h && a.defineSkip(p.start), p._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(l), p._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), h = p, p = p.next;
  }
  for (p = n; ++m < o.length; )
    // Find a void token that includes a break.
    o[m][0] === "exit" && o[m - 1][0] === "enter" && o[m][1].type === o[m - 1][1].type && o[m][1].start.line !== o[m][1].end.line && (g = m + 1, _.push(g), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (a.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : _.pop(), m = _.length; m--; ) {
    const b = o.slice(_[m], _[m + 1]), T = i.pop();
    u.push([T, T + b.length - 1]), e.splice(T, 2, b);
  }
  for (u.reverse(), m = -1; ++m < u.length; )
    c[E + u[m][0]] = E + u[m][1], E += u[m][1] - u[m][0] - 1;
  return c;
}
const bO = {
  resolve: TO,
  tokenize: AO
}, _O = {
  partial: !0,
  tokenize: yO
};
function TO(e) {
  return Ob(e), e;
}
function AO(e, t) {
  let n;
  return r;
  function r(o) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), s(o);
  }
  function s(o) {
    return o === null ? i(o) : me(o) ? e.check(_O, a, i)(o) : (e.consume(o), s);
  }
  function i(o) {
    return e.exit("chunkContent"), e.exit("content"), t(o);
  }
  function a(o) {
    return e.consume(o), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, s;
  }
}
function yO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Le(e, i, "linePrefix");
  }
  function i(a) {
    if (a === null || me(a))
      return n(a);
    const o = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function Db(e, t, n, r, s, i, a, o, u) {
  const c = u || Number.POSITIVE_INFINITY;
  let l = 0;
  return h;
  function h(b) {
    return b === 60 ? (e.enter(r), e.enter(s), e.enter(i), e.consume(b), e.exit(i), m) : b === null || b === 32 || b === 41 || Fa(b) ? n(b) : (e.enter(r), e.enter(a), e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), g(b));
  }
  function m(b) {
    return b === 62 ? (e.enter(i), e.consume(b), e.exit(i), e.exit(s), e.exit(r), t) : (e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), p(b));
  }
  function p(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(o), m(b)) : b === null || b === 60 || me(b) ? n(b) : (e.consume(b), b === 92 ? E : p);
  }
  function E(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), p) : p(b);
  }
  function g(b) {
    return !l && (b === null || b === 41 || Ge(b)) ? (e.exit("chunkString"), e.exit(o), e.exit(a), e.exit(r), t(b)) : l < c && b === 40 ? (e.consume(b), l++, g) : b === 41 ? (e.consume(b), l--, g) : b === null || b === 32 || b === 40 || Fa(b) ? n(b) : (e.consume(b), b === 92 ? _ : g);
  }
  function _(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), g) : g(b);
  }
}
function Lb(e, t, n, r, s, i) {
  const a = this;
  let o = 0, u;
  return c;
  function c(p) {
    return e.enter(r), e.enter(s), e.consume(p), e.exit(s), e.enter(i), l;
  }
  function l(p) {
    return o > 999 || p === null || p === 91 || p === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !o && "_hiddenFootnoteSupport" in a.parser.constructs ? n(p) : p === 93 ? (e.exit(i), e.enter(s), e.consume(p), e.exit(s), e.exit(r), t) : me(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), l) : (e.enter("chunkString", {
      contentType: "string"
    }), h(p));
  }
  function h(p) {
    return p === null || p === 91 || p === 93 || me(p) || o++ > 999 ? (e.exit("chunkString"), l(p)) : (e.consume(p), u || (u = !ke(p)), p === 92 ? m : h);
  }
  function m(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, h) : h(p);
  }
}
function Mb(e, t, n, r, s, i) {
  let a;
  return o;
  function o(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(s), e.consume(m), e.exit(s), a = m === 40 ? 41 : m, u) : n(m);
  }
  function u(m) {
    return m === a ? (e.enter(s), e.consume(m), e.exit(s), e.exit(r), t) : (e.enter(i), c(m));
  }
  function c(m) {
    return m === a ? (e.exit(i), u(a)) : m === null ? n(m) : me(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), Le(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), l(m));
  }
  function l(m) {
    return m === a || m === null || me(m) ? (e.exit("chunkString"), c(m)) : (e.consume(m), m === 92 ? h : l);
  }
  function h(m) {
    return m === a || m === 92 ? (e.consume(m), l) : l(m);
  }
}
function Js(e, t) {
  let n;
  return r;
  function r(s) {
    return me(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), n = !0, r) : ke(s) ? Le(e, r, n ? "linePrefix" : "lineSuffix")(s) : t(s);
  }
}
const xO = {
  name: "definition",
  tokenize: SO
}, CO = {
  partial: !0,
  tokenize: IO
};
function SO(e, t, n) {
  const r = this;
  let s;
  return i;
  function i(p) {
    return e.enter("definition"), a(p);
  }
  function a(p) {
    return Lb.call(
      r,
      e,
      o,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function o(p) {
    return s = en(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), u) : n(p);
  }
  function u(p) {
    return Ge(p) ? Js(e, c)(p) : c(p);
  }
  function c(p) {
    return Db(
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function l(p) {
    return e.attempt(CO, h, h)(p);
  }
  function h(p) {
    return ke(p) ? Le(e, m, "whitespace")(p) : m(p);
  }
  function m(p) {
    return p === null || me(p) ? (e.exit("definition"), r.parser.defined.push(s), t(p)) : n(p);
  }
}
function IO(e, t, n) {
  return r;
  function r(o) {
    return Ge(o) ? Js(e, s)(o) : n(o);
  }
  function s(o) {
    return Mb(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(o);
  }
  function i(o) {
    return ke(o) ? Le(e, a, "whitespace")(o) : a(o);
  }
  function a(o) {
    return o === null || me(o) ? t(o) : n(o);
  }
}
const wO = {
  name: "hardBreakEscape",
  tokenize: vO
};
function vO(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), s;
  }
  function s(i) {
    return me(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const NO = {
  name: "headingAtx",
  resolve: kO,
  tokenize: RO
};
function kO(e, t) {
  let n = e.length - 2, r = 3, s, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (s = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Ut(e, r, n - r + 1, [["enter", s, t], ["enter", i, t], ["exit", i, t], ["exit", s, t]])), e;
}
function RO(e, t, n) {
  let r = 0;
  return s;
  function s(l) {
    return e.enter("atxHeading"), i(l);
  }
  function i(l) {
    return e.enter("atxHeadingSequence"), a(l);
  }
  function a(l) {
    return l === 35 && r++ < 6 ? (e.consume(l), a) : l === null || Ge(l) ? (e.exit("atxHeadingSequence"), o(l)) : n(l);
  }
  function o(l) {
    return l === 35 ? (e.enter("atxHeadingSequence"), u(l)) : l === null || me(l) ? (e.exit("atxHeading"), t(l)) : ke(l) ? Le(e, o, "whitespace")(l) : (e.enter("atxHeadingText"), c(l));
  }
  function u(l) {
    return l === 35 ? (e.consume(l), u) : (e.exit("atxHeadingSequence"), o(l));
  }
  function c(l) {
    return l === null || l === 35 || Ge(l) ? (e.exit("atxHeadingText"), o(l)) : (e.consume(l), c);
  }
}
const PO = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Mf = ["pre", "script", "style", "textarea"], OO = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: MO,
  tokenize: HO
}, DO = {
  partial: !0,
  tokenize: UO
}, LO = {
  partial: !0,
  tokenize: BO
};
function MO(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function HO(e, t, n) {
  const r = this;
  let s, i, a, o, u;
  return c;
  function c(v) {
    return l(v);
  }
  function l(v) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(v), h;
  }
  function h(v) {
    return v === 33 ? (e.consume(v), m) : v === 47 ? (e.consume(v), i = !0, g) : v === 63 ? (e.consume(v), s = 3, r.interrupt ? t : y) : St(v) ? (e.consume(v), a = String.fromCharCode(v), _) : n(v);
  }
  function m(v) {
    return v === 45 ? (e.consume(v), s = 2, p) : v === 91 ? (e.consume(v), s = 5, o = 0, E) : St(v) ? (e.consume(v), s = 4, r.interrupt ? t : y) : n(v);
  }
  function p(v) {
    return v === 45 ? (e.consume(v), r.interrupt ? t : y) : n(v);
  }
  function E(v) {
    const Se = "CDATA[";
    return v === Se.charCodeAt(o++) ? (e.consume(v), o === Se.length ? r.interrupt ? t : G : E) : n(v);
  }
  function g(v) {
    return St(v) ? (e.consume(v), a = String.fromCharCode(v), _) : n(v);
  }
  function _(v) {
    if (v === null || v === 47 || v === 62 || Ge(v)) {
      const Se = v === 47, _e = a.toLowerCase();
      return !Se && !i && Mf.includes(_e) ? (s = 1, r.interrupt ? t(v) : G(v)) : PO.includes(a.toLowerCase()) ? (s = 6, Se ? (e.consume(v), b) : r.interrupt ? t(v) : G(v)) : (s = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(v) : i ? T(v) : C(v));
    }
    return v === 45 || Et(v) ? (e.consume(v), a += String.fromCharCode(v), _) : n(v);
  }
  function b(v) {
    return v === 62 ? (e.consume(v), r.interrupt ? t : G) : n(v);
  }
  function T(v) {
    return ke(v) ? (e.consume(v), T) : P(v);
  }
  function C(v) {
    return v === 47 ? (e.consume(v), P) : v === 58 || v === 95 || St(v) ? (e.consume(v), R) : ke(v) ? (e.consume(v), C) : P(v);
  }
  function R(v) {
    return v === 45 || v === 46 || v === 58 || v === 95 || Et(v) ? (e.consume(v), R) : D(v);
  }
  function D(v) {
    return v === 61 ? (e.consume(v), I) : ke(v) ? (e.consume(v), D) : C(v);
  }
  function I(v) {
    return v === null || v === 60 || v === 61 || v === 62 || v === 96 ? n(v) : v === 34 || v === 39 ? (e.consume(v), u = v, O) : ke(v) ? (e.consume(v), I) : U(v);
  }
  function O(v) {
    return v === u ? (e.consume(v), u = null, q) : v === null || me(v) ? n(v) : (e.consume(v), O);
  }
  function U(v) {
    return v === null || v === 34 || v === 39 || v === 47 || v === 60 || v === 61 || v === 62 || v === 96 || Ge(v) ? D(v) : (e.consume(v), U);
  }
  function q(v) {
    return v === 47 || v === 62 || ke(v) ? C(v) : n(v);
  }
  function P(v) {
    return v === 62 ? (e.consume(v), z) : n(v);
  }
  function z(v) {
    return v === null || me(v) ? G(v) : ke(v) ? (e.consume(v), z) : n(v);
  }
  function G(v) {
    return v === 45 && s === 2 ? (e.consume(v), B) : v === 60 && s === 1 ? (e.consume(v), Y) : v === 62 && s === 4 ? (e.consume(v), fe) : v === 63 && s === 3 ? (e.consume(v), y) : v === 93 && s === 5 ? (e.consume(v), Z) : me(v) && (s === 6 || s === 7) ? (e.exit("htmlFlowData"), e.check(DO, Ce, F)(v)) : v === null || me(v) ? (e.exit("htmlFlowData"), F(v)) : (e.consume(v), G);
  }
  function F(v) {
    return e.check(LO, M, Ce)(v);
  }
  function M(v) {
    return e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), H;
  }
  function H(v) {
    return v === null || me(v) ? F(v) : (e.enter("htmlFlowData"), G(v));
  }
  function B(v) {
    return v === 45 ? (e.consume(v), y) : G(v);
  }
  function Y(v) {
    return v === 47 ? (e.consume(v), a = "", $) : G(v);
  }
  function $(v) {
    if (v === 62) {
      const Se = a.toLowerCase();
      return Mf.includes(Se) ? (e.consume(v), fe) : G(v);
    }
    return St(v) && a.length < 8 ? (e.consume(v), a += String.fromCharCode(v), $) : G(v);
  }
  function Z(v) {
    return v === 93 ? (e.consume(v), y) : G(v);
  }
  function y(v) {
    return v === 62 ? (e.consume(v), fe) : v === 45 && s === 2 ? (e.consume(v), y) : G(v);
  }
  function fe(v) {
    return v === null || me(v) ? (e.exit("htmlFlowData"), Ce(v)) : (e.consume(v), fe);
  }
  function Ce(v) {
    return e.exit("htmlFlow"), t(v);
  }
}
function BO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return me(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : n(a);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function UO(e, t, n) {
  return r;
  function r(s) {
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), e.attempt(Ri, t, n);
  }
}
const FO = {
  name: "htmlText",
  tokenize: jO
};
function jO(e, t, n) {
  const r = this;
  let s, i, a;
  return o;
  function o(y) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(y), u;
  }
  function u(y) {
    return y === 33 ? (e.consume(y), c) : y === 47 ? (e.consume(y), D) : y === 63 ? (e.consume(y), C) : St(y) ? (e.consume(y), U) : n(y);
  }
  function c(y) {
    return y === 45 ? (e.consume(y), l) : y === 91 ? (e.consume(y), i = 0, E) : St(y) ? (e.consume(y), T) : n(y);
  }
  function l(y) {
    return y === 45 ? (e.consume(y), p) : n(y);
  }
  function h(y) {
    return y === null ? n(y) : y === 45 ? (e.consume(y), m) : me(y) ? (a = h, Y(y)) : (e.consume(y), h);
  }
  function m(y) {
    return y === 45 ? (e.consume(y), p) : h(y);
  }
  function p(y) {
    return y === 62 ? B(y) : y === 45 ? m(y) : h(y);
  }
  function E(y) {
    const fe = "CDATA[";
    return y === fe.charCodeAt(i++) ? (e.consume(y), i === fe.length ? g : E) : n(y);
  }
  function g(y) {
    return y === null ? n(y) : y === 93 ? (e.consume(y), _) : me(y) ? (a = g, Y(y)) : (e.consume(y), g);
  }
  function _(y) {
    return y === 93 ? (e.consume(y), b) : g(y);
  }
  function b(y) {
    return y === 62 ? B(y) : y === 93 ? (e.consume(y), b) : g(y);
  }
  function T(y) {
    return y === null || y === 62 ? B(y) : me(y) ? (a = T, Y(y)) : (e.consume(y), T);
  }
  function C(y) {
    return y === null ? n(y) : y === 63 ? (e.consume(y), R) : me(y) ? (a = C, Y(y)) : (e.consume(y), C);
  }
  function R(y) {
    return y === 62 ? B(y) : C(y);
  }
  function D(y) {
    return St(y) ? (e.consume(y), I) : n(y);
  }
  function I(y) {
    return y === 45 || Et(y) ? (e.consume(y), I) : O(y);
  }
  function O(y) {
    return me(y) ? (a = O, Y(y)) : ke(y) ? (e.consume(y), O) : B(y);
  }
  function U(y) {
    return y === 45 || Et(y) ? (e.consume(y), U) : y === 47 || y === 62 || Ge(y) ? q(y) : n(y);
  }
  function q(y) {
    return y === 47 ? (e.consume(y), B) : y === 58 || y === 95 || St(y) ? (e.consume(y), P) : me(y) ? (a = q, Y(y)) : ke(y) ? (e.consume(y), q) : B(y);
  }
  function P(y) {
    return y === 45 || y === 46 || y === 58 || y === 95 || Et(y) ? (e.consume(y), P) : z(y);
  }
  function z(y) {
    return y === 61 ? (e.consume(y), G) : me(y) ? (a = z, Y(y)) : ke(y) ? (e.consume(y), z) : q(y);
  }
  function G(y) {
    return y === null || y === 60 || y === 61 || y === 62 || y === 96 ? n(y) : y === 34 || y === 39 ? (e.consume(y), s = y, F) : me(y) ? (a = G, Y(y)) : ke(y) ? (e.consume(y), G) : (e.consume(y), M);
  }
  function F(y) {
    return y === s ? (e.consume(y), s = void 0, H) : y === null ? n(y) : me(y) ? (a = F, Y(y)) : (e.consume(y), F);
  }
  function M(y) {
    return y === null || y === 34 || y === 39 || y === 60 || y === 61 || y === 96 ? n(y) : y === 47 || y === 62 || Ge(y) ? q(y) : (e.consume(y), M);
  }
  function H(y) {
    return y === 47 || y === 62 || Ge(y) ? q(y) : n(y);
  }
  function B(y) {
    return y === 62 ? (e.consume(y), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(y);
  }
  function Y(y) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), $;
  }
  function $(y) {
    return ke(y) ? Le(e, Z, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(y) : Z(y);
  }
  function Z(y) {
    return e.enter("htmlTextData"), a(y);
  }
}
const Wl = {
  name: "labelEnd",
  resolveAll: YO,
  resolveTo: GO,
  tokenize: WO
}, $O = {
  tokenize: qO
}, zO = {
  tokenize: KO
}, VO = {
  tokenize: QO
};
function YO(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const s = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += s;
    }
  }
  return e.length !== n.length && Ut(e, 0, e.length, n), e;
}
function GO(e, t) {
  let n = e.length, r = 0, s, i, a, o;
  for (; n--; )
    if (s = e[n][1], i) {
      if (s.type === "link" || s.type === "labelLink" && s._inactive)
        break;
      e[n][0] === "enter" && s.type === "labelLink" && (s._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (s.type === "labelImage" || s.type === "labelLink") && !s._balanced && (i = n, s.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else s.type === "labelEnd" && (a = n);
  const u = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[a][1].end
    }
  }, l = {
    type: "labelText",
    start: {
      ...e[i + r + 2][1].end
    },
    end: {
      ...e[a - 2][1].start
    }
  };
  return o = [["enter", u, t], ["enter", c, t]], o = Yt(o, e.slice(i + 1, i + r + 3)), o = Yt(o, [["enter", l, t]]), o = Yt(o, Po(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, a - 3), t)), o = Yt(o, [["exit", l, t], e[a - 2], e[a - 1], ["exit", c, t]]), o = Yt(o, e.slice(a + 1)), o = Yt(o, [["exit", u, t]]), Ut(e, i, e.length, o), e;
}
function WO(e, t, n) {
  const r = this;
  let s = r.events.length, i, a;
  for (; s--; )
    if ((r.events[s][1].type === "labelImage" || r.events[s][1].type === "labelLink") && !r.events[s][1]._balanced) {
      i = r.events[s][1];
      break;
    }
  return o;
  function o(m) {
    return i ? i._inactive ? h(m) : (a = r.parser.defined.includes(en(r.sliceSerialize({
      start: i.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(m);
  }
  function u(m) {
    return m === 40 ? e.attempt($O, l, a ? l : h)(m) : m === 91 ? e.attempt(zO, l, a ? c : h)(m) : a ? l(m) : h(m);
  }
  function c(m) {
    return e.attempt(VO, l, h)(m);
  }
  function l(m) {
    return t(m);
  }
  function h(m) {
    return i._balanced = !0, n(m);
  }
}
function qO(e, t, n) {
  return r;
  function r(h) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), s;
  }
  function s(h) {
    return Ge(h) ? Js(e, i)(h) : i(h);
  }
  function i(h) {
    return h === 41 ? l(h) : Db(e, a, o, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function a(h) {
    return Ge(h) ? Js(e, u)(h) : l(h);
  }
  function o(h) {
    return n(h);
  }
  function u(h) {
    return h === 34 || h === 39 || h === 40 ? Mb(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : l(h);
  }
  function c(h) {
    return Ge(h) ? Js(e, l)(h) : l(h);
  }
  function l(h) {
    return h === 41 ? (e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), e.exit("resource"), t) : n(h);
  }
}
function KO(e, t, n) {
  const r = this;
  return s;
  function s(o) {
    return Lb.call(r, e, i, a, "reference", "referenceMarker", "referenceString")(o);
  }
  function i(o) {
    return r.parser.defined.includes(en(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(o) : n(o);
  }
  function a(o) {
    return n(o);
  }
}
function QO(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), s;
  }
  function s(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const XO = {
  name: "labelStartImage",
  resolveAll: Wl.resolveAll,
  tokenize: JO
};
function JO(e, t, n) {
  const r = this;
  return s;
  function s(o) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(o), e.exit("labelImageMarker"), i;
  }
  function i(o) {
    return o === 91 ? (e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelImage"), a) : n(o);
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const ZO = {
  name: "labelStartLink",
  resolveAll: Wl.resolveAll,
  tokenize: eD
};
function eD(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const wu = {
  name: "lineEnding",
  tokenize: tD
};
function tD(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Le(e, t, "linePrefix");
  }
}
const ma = {
  name: "thematicBreak",
  tokenize: nD
};
function nD(e, t, n) {
  let r = 0, s;
  return i;
  function i(c) {
    return e.enter("thematicBreak"), a(c);
  }
  function a(c) {
    return s = c, o(c);
  }
  function o(c) {
    return c === s ? (e.enter("thematicBreakSequence"), u(c)) : r >= 3 && (c === null || me(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function u(c) {
    return c === s ? (e.consume(c), r++, u) : (e.exit("thematicBreakSequence"), ke(c) ? Le(e, o, "whitespace")(c) : o(c));
  }
}
const Nt = {
  continuation: {
    tokenize: aD
  },
  exit: uD,
  name: "list",
  tokenize: iD
}, rD = {
  partial: !0,
  tokenize: cD
}, sD = {
  partial: !0,
  tokenize: oD
};
function iD(e, t, n) {
  const r = this, s = r.events[r.events.length - 1];
  let i = s && s[1].type === "linePrefix" ? s[2].sliceSerialize(s[1], !0).length : 0, a = 0;
  return o;
  function o(p) {
    const E = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (E === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : Cc(p)) {
      if (r.containerState.type || (r.containerState.type = E, e.enter(E, {
        _container: !0
      })), E === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(ma, n, c)(p) : c(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(p);
    }
    return n(p);
  }
  function u(p) {
    return Cc(p) && ++a < 10 ? (e.consume(p), u) : (!r.interrupt || a < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), c(p)) : n(p);
  }
  function c(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      Ri,
      // Can’t be empty when interrupting.
      r.interrupt ? n : l,
      e.attempt(rD, m, h)
    );
  }
  function l(p) {
    return r.containerState.initialBlankLine = !0, i++, m(p);
  }
  function h(p) {
    return ke(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), m) : n(p);
  }
  function m(p) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function aD(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ri, s, i);
  function s(o) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Le(e, t, "listItemIndent", r.containerState.size + 1)(o);
  }
  function i(o) {
    return r.containerState.furtherBlankLines || !ke(o) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(o)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(sD, t, a)(o));
  }
  function a(o) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Le(e, e.attempt(Nt, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o);
  }
}
function oD(e, t, n) {
  const r = this;
  return Le(e, s, "listItemIndent", r.containerState.size + 1);
  function s(i) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function uD(e) {
  e.exit(this.containerState.type);
}
function cD(e, t, n) {
  const r = this;
  return Le(e, s, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function s(i) {
    const a = r.events[r.events.length - 1];
    return !ke(i) && a && a[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const Hf = {
  name: "setextUnderline",
  resolveTo: lD,
  tokenize: dD
};
function lD(e, t) {
  let n = e.length, r, s, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (s = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const a = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[s][1].type = "setextHeadingText", i ? (e.splice(s, 0, ["enter", a, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[i][1].end
  }) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function dD(e, t, n) {
  const r = this;
  let s;
  return i;
  function i(c) {
    let l = r.events.length, h;
    for (; l--; )
      if (r.events[l][1].type !== "lineEnding" && r.events[l][1].type !== "linePrefix" && r.events[l][1].type !== "content") {
        h = r.events[l][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || h) ? (e.enter("setextHeadingLine"), s = c, a(c)) : n(c);
  }
  function a(c) {
    return e.enter("setextHeadingLineSequence"), o(c);
  }
  function o(c) {
    return c === s ? (e.consume(c), o) : (e.exit("setextHeadingLineSequence"), ke(c) ? Le(e, u, "lineSuffix")(c) : u(c));
  }
  function u(c) {
    return c === null || me(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const hD = {
  tokenize: fD
};
function fD(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Ri,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, s, Le(e, e.attempt(this.parser.constructs.flow, s, e.attempt(bO, s)), "linePrefix"))
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function s(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const pD = {
  resolveAll: Bb()
}, mD = Hb("string"), gD = Hb("text");
function Hb(e) {
  return {
    resolveAll: Bb(e === "text" ? ED : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, s = this.parser.constructs[e], i = n.attempt(s, a, o);
    return a;
    function a(l) {
      return c(l) ? i(l) : o(l);
    }
    function o(l) {
      if (l === null) {
        n.consume(l);
        return;
      }
      return n.enter("data"), n.consume(l), u;
    }
    function u(l) {
      return c(l) ? (n.exit("data"), i(l)) : (n.consume(l), u);
    }
    function c(l) {
      if (l === null)
        return !0;
      const h = s[l];
      let m = -1;
      if (h)
        for (; ++m < h.length; ) {
          const p = h[m];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Bb(e) {
  return t;
  function t(n, r) {
    let s = -1, i;
    for (; ++s <= n.length; )
      i === void 0 ? n[s] && n[s][1].type === "data" && (i = s, s++) : (!n[s] || n[s][1].type !== "data") && (s !== i + 2 && (n[i][1].end = n[s - 1][1].end, n.splice(i + 2, s - i - 2), s = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function ED(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], s = t.sliceStream(r);
      let i = s.length, a = -1, o = 0, u;
      for (; i--; ) {
        const c = s[i];
        if (typeof c == "string") {
          for (a = c.length; c.charCodeAt(a - 1) === 32; )
            o++, a--;
          if (a) break;
          a = -1;
        } else if (c === -2)
          u = !0, o++;
        else if (c !== -1) {
          i++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (o = 0), o) {
        const c = {
          type: n === e.length || u || o < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: i ? a : r.start._bufferIndex + a,
            _index: r.start._index + i,
            line: r.end.line,
            column: r.end.column - o,
            offset: r.end.offset - o
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...c.start
        }, r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(n, 0, ["enter", c, t], ["exit", c, t]), n += 2);
      }
      n++;
    }
  return e;
}
const bD = {
  42: Nt,
  43: Nt,
  45: Nt,
  48: Nt,
  49: Nt,
  50: Nt,
  51: Nt,
  52: Nt,
  53: Nt,
  54: Nt,
  55: Nt,
  56: Nt,
  57: Nt,
  62: kb
}, _D = {
  91: xO
}, TD = {
  [-2]: Iu,
  [-1]: Iu,
  32: Iu
}, AD = {
  35: NO,
  42: ma,
  45: [Hf, ma],
  60: OO,
  61: Hf,
  95: ma,
  96: Lf,
  126: Lf
}, yD = {
  38: Pb,
  92: Rb
}, xD = {
  [-5]: wu,
  [-4]: wu,
  [-3]: wu,
  33: XO,
  38: Pb,
  42: Sc,
  60: [Z3, FO],
  91: ZO,
  92: [wO, Rb],
  93: Wl,
  95: Sc,
  96: hO
}, CD = {
  null: [Sc, pD]
}, SD = {
  null: [42, 95]
}, ID = {
  null: []
}, wD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: SD,
  contentInitial: _D,
  disable: ID,
  document: bD,
  flow: AD,
  flowInitial: TD,
  insideSpan: CD,
  string: yD,
  text: xD
}, Symbol.toStringTag, { value: "Module" }));
function vD(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const s = {}, i = [];
  let a = [], o = [];
  const u = {
    attempt: O(D),
    check: O(I),
    consume: T,
    enter: C,
    exit: R,
    interrupt: O(I, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: g,
    events: [],
    now: E,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: p,
    write: h
  };
  let l = t.tokenize.call(c, u);
  return t.resolveAll && i.push(t), c;
  function h(z) {
    return a = Yt(a, z), _(), a[a.length - 1] !== null ? [] : (U(t, 0), c.events = Po(i, c.events, c), c.events);
  }
  function m(z, G) {
    return kD(p(z), G);
  }
  function p(z) {
    return ND(a, z);
  }
  function E() {
    const {
      _bufferIndex: z,
      _index: G,
      line: F,
      column: M,
      offset: H
    } = r;
    return {
      _bufferIndex: z,
      _index: G,
      line: F,
      column: M,
      offset: H
    };
  }
  function g(z) {
    s[z.line] = z.column, P();
  }
  function _() {
    let z;
    for (; r._index < a.length; ) {
      const G = a[r._index];
      if (typeof G == "string")
        for (z = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === z && r._bufferIndex < G.length; )
          b(G.charCodeAt(r._bufferIndex));
      else
        b(G);
    }
  }
  function b(z) {
    l = l(z);
  }
  function T(z) {
    me(z) ? (r.line++, r.column = 1, r.offset += z === -3 ? 2 : 1, P()) : z !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    a[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = z;
  }
  function C(z, G) {
    const F = G || {};
    return F.type = z, F.start = E(), c.events.push(["enter", F, c]), o.push(F), F;
  }
  function R(z) {
    const G = o.pop();
    return G.end = E(), c.events.push(["exit", G, c]), G;
  }
  function D(z, G) {
    U(z, G.from);
  }
  function I(z, G) {
    G.restore();
  }
  function O(z, G) {
    return F;
    function F(M, H, B) {
      let Y, $, Z, y;
      return Array.isArray(M) ? (
        /* c8 ignore next 1 */
        Ce(M)
      ) : "tokenize" in M ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          M
        ])
      ) : fe(M);
      function fe(pe) {
        return re;
        function re(Te) {
          const ce = Te !== null && pe[Te], ue = Te !== null && pe.null, Ae = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ce) ? ce : ce ? [ce] : [],
            ...Array.isArray(ue) ? ue : ue ? [ue] : []
          ];
          return Ce(Ae)(Te);
        }
      }
      function Ce(pe) {
        return Y = pe, $ = 0, pe.length === 0 ? B : v(pe[$]);
      }
      function v(pe) {
        return re;
        function re(Te) {
          return y = q(), Z = pe, pe.partial || (c.currentConstruct = pe), pe.name && c.parser.constructs.disable.null.includes(pe.name) ? _e() : pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            G ? Object.assign(Object.create(c), G) : c,
            u,
            Se,
            _e
          )(Te);
        }
      }
      function Se(pe) {
        return z(Z, y), H;
      }
      function _e(pe) {
        return y.restore(), ++$ < Y.length ? v(Y[$]) : B;
      }
    }
  }
  function U(z, G) {
    z.resolveAll && !i.includes(z) && i.push(z), z.resolve && Ut(c.events, G, c.events.length - G, z.resolve(c.events.slice(G), c)), z.resolveTo && (c.events = z.resolveTo(c.events, c));
  }
  function q() {
    const z = E(), G = c.previous, F = c.currentConstruct, M = c.events.length, H = Array.from(o);
    return {
      from: M,
      restore: B
    };
    function B() {
      r = z, c.previous = G, c.currentConstruct = F, c.events.length = M, o = H, P();
    }
  }
  function P() {
    r.line in s && r.column < 2 && (r.column = s[r.line], r.offset += s[r.line] - 1);
  }
}
function ND(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, s = t.end._index, i = t.end._bufferIndex;
  let a;
  if (n === s)
    a = [e[n].slice(r, i)];
  else {
    if (a = e.slice(n, s), r > -1) {
      const o = a[0];
      typeof o == "string" ? a[0] = o.slice(r) : a.shift();
    }
    i > 0 && a.push(e[s].slice(0, i));
  }
  return a;
}
function kD(e, t) {
  let n = -1;
  const r = [];
  let s;
  for (; ++n < e.length; ) {
    const i = e[n];
    let a;
    if (typeof i == "string")
      a = i;
    else switch (i) {
      case -5: {
        a = "\r";
        break;
      }
      case -4: {
        a = `
`;
        break;
      }
      case -3: {
        a = `\r
`;
        break;
      }
      case -2: {
        a = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && s) continue;
        a = " ";
        break;
      }
      default:
        a = String.fromCharCode(i);
    }
    s = i === -2, r.push(a);
  }
  return r.join("");
}
function RD(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      vb([wD, ...(e || {}).extensions || []])
    ),
    content: s(G3),
    defined: [],
    document: s(q3),
    flow: s(hD),
    lazy: {},
    string: s(mD),
    text: s(gD)
  };
  return r;
  function s(i) {
    return a;
    function a(o) {
      return vD(r, i, o);
    }
  }
}
function PD(e) {
  for (; !Ob(e); )
    ;
  return e;
}
const Bf = /[\0\t\n\r]/g;
function OD() {
  let e = 1, t = "", n = !0, r;
  return s;
  function s(i, a, o) {
    const u = [];
    let c, l, h, m, p;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(a || void 0).decode(i)), h = 0, t = "", n && (i.charCodeAt(0) === 65279 && h++, n = void 0); h < i.length; ) {
      if (Bf.lastIndex = h, c = Bf.exec(i), m = c && c.index !== void 0 ? c.index : i.length, p = i.charCodeAt(m), !c) {
        t = i.slice(h);
        break;
      }
      if (p === 10 && h === m && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), h < m && (u.push(i.slice(h, m)), e += m - h), p) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (l = Math.ceil(e / 4) * 4, u.push(-2); e++ < l; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      h = m + 1;
    }
    return o && (r && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const DD = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function LD(e) {
  return e.replace(DD, MD);
}
function MD(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const s = n.charCodeAt(1), i = s === 120 || s === 88;
    return Nb(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Gl(n) || e;
}
const Ub = {}.hasOwnProperty;
function HD(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), BD(n)(PD(RD(n).document().write(OD()(e, t, !0))));
}
function BD(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(or),
      autolinkProtocol: q,
      autolinkEmail: q,
      atxHeading: i(Kt),
      blockQuote: i(ue),
      characterEscape: q,
      characterReference: q,
      codeFenced: i(Ae),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: i(Ae, a),
      codeText: i(Pe, a),
      codeTextData: q,
      data: q,
      codeFlowValue: q,
      definition: i(qe),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: i(mt),
      hardBreakEscape: i(zt),
      hardBreakTrailing: i(zt),
      htmlFlow: i(An, a),
      htmlFlowData: q,
      htmlText: i(An, a),
      htmlTextData: q,
      image: i(Li),
      label: a,
      link: i(or),
      listItem: i(jo),
      listItemValue: m,
      listOrdered: i(Mi, h),
      listUnordered: i(Mi),
      paragraph: i(Is),
      reference: v,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: i(Kt),
      strong: i($o),
      thematicBreak: i(Hi)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: D,
      autolink: u(),
      autolinkEmail: ce,
      autolinkProtocol: Te,
      blockQuote: u(),
      characterEscapeValue: P,
      characterReferenceMarkerHexadecimal: _e,
      characterReferenceMarkerNumeric: _e,
      characterReferenceValue: pe,
      characterReference: re,
      codeFenced: u(_),
      codeFencedFence: g,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: E,
      codeFlowValue: P,
      codeIndented: u(b),
      codeText: u(H),
      codeTextData: P,
      data: P,
      definition: u(),
      definitionDestinationString: R,
      definitionLabelString: T,
      definitionTitleString: C,
      emphasis: u(),
      hardBreakEscape: u(G),
      hardBreakTrailing: u(G),
      htmlFlow: u(F),
      htmlFlowData: P,
      htmlText: u(M),
      htmlTextData: P,
      image: u(Y),
      label: Z,
      labelText: $,
      lineEnding: z,
      link: u(B),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Se,
      resourceDestinationString: y,
      resourceTitleString: fe,
      resource: Ce,
      setextHeading: u(U),
      setextHeadingLineSequence: O,
      setextHeadingText: I,
      strong: u(),
      thematicBreak: u()
    }
  };
  Fb(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(V) {
    let ee = {
      type: "root",
      children: []
    };
    const ye = {
      stack: [ee],
      tokenStack: [],
      config: t,
      enter: o,
      exit: c,
      buffer: a,
      resume: l,
      data: n
    }, ve = [];
    let je = -1;
    for (; ++je < V.length; )
      if (V[je][1].type === "listOrdered" || V[je][1].type === "listUnordered")
        if (V[je][0] === "enter")
          ve.push(je);
        else {
          const Ot = ve.pop();
          je = s(V, Ot, je);
        }
    for (je = -1; ++je < V.length; ) {
      const Ot = t[V[je][0]];
      Ub.call(Ot, V[je][1].type) && Ot[V[je][1].type].call(Object.assign({
        sliceSerialize: V[je][2].sliceSerialize
      }, ye), V[je][1]);
    }
    if (ye.tokenStack.length > 0) {
      const Ot = ye.tokenStack[ye.tokenStack.length - 1];
      (Ot[1] || Uf).call(ye, void 0, Ot[0]);
    }
    for (ee.position = {
      start: Bn(V.length > 0 ? V[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Bn(V.length > 0 ? V[V.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, je = -1; ++je < t.transforms.length; )
      ee = t.transforms[je](ee) || ee;
    return ee;
  }
  function s(V, ee, ye) {
    let ve = ee - 1, je = -1, Ot = !1, yn, Qt, ur, cr;
    for (; ++ve <= ye; ) {
      const yt = V[ve];
      switch (yt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          yt[0] === "enter" ? je++ : je--, cr = void 0;
          break;
        }
        case "lineEndingBlank": {
          yt[0] === "enter" && (yn && !cr && !je && !ur && (ur = ve), cr = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          cr = void 0;
      }
      if (!je && yt[0] === "enter" && yt[1].type === "listItemPrefix" || je === -1 && yt[0] === "exit" && (yt[1].type === "listUnordered" || yt[1].type === "listOrdered")) {
        if (yn) {
          let Ln = ve;
          for (Qt = void 0; Ln--; ) {
            const Dt = V[Ln];
            if (Dt[1].type === "lineEnding" || Dt[1].type === "lineEndingBlank") {
              if (Dt[0] === "exit") continue;
              Qt && (V[Qt][1].type = "lineEndingBlank", Ot = !0), Dt[1].type = "lineEnding", Qt = Ln;
            } else if (!(Dt[1].type === "linePrefix" || Dt[1].type === "blockQuotePrefix" || Dt[1].type === "blockQuotePrefixWhitespace" || Dt[1].type === "blockQuoteMarker" || Dt[1].type === "listItemIndent")) break;
          }
          ur && (!Qt || ur < Qt) && (yn._spread = !0), yn.end = Object.assign({}, Qt ? V[Qt][1].start : yt[1].end), V.splice(Qt || ve, 0, ["exit", yn, yt[2]]), ve++, ye++;
        }
        if (yt[1].type === "listItemPrefix") {
          const Ln = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, yt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          yn = Ln, V.splice(ve, 0, ["enter", Ln, yt[2]]), ve++, ye++, ur = void 0, cr = !0;
        }
      }
    }
    return V[ee][1]._spread = Ot, ye;
  }
  function i(V, ee) {
    return ye;
    function ye(ve) {
      o.call(this, V(ve), ve), ee && ee.call(this, ve);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function o(V, ee, ye) {
    this.stack[this.stack.length - 1].children.push(V), this.stack.push(V), this.tokenStack.push([ee, ye || void 0]), V.position = {
      start: Bn(ee.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(V) {
    return ee;
    function ee(ye) {
      V && V.call(this, ye), c.call(this, ye);
    }
  }
  function c(V, ee) {
    const ye = this.stack.pop(), ve = this.tokenStack.pop();
    if (ve)
      ve[0].type !== V.type && (ee ? ee.call(this, V, ve[0]) : (ve[1] || Uf).call(this, V, ve[0]));
    else throw new Error("Cannot close `" + V.type + "` (" + Xs({
      start: V.start,
      end: V.end
    }) + "): it’s not open");
    ye.position.end = Bn(V.end);
  }
  function l() {
    return Yl(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(V) {
    if (this.data.expectingFirstListItemValue) {
      const ee = this.stack[this.stack.length - 2];
      ee.start = Number.parseInt(this.sliceSerialize(V), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.lang = V;
  }
  function E() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.meta = V;
  }
  function g() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function _() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V.replace(/(\r?\n|\r)$/g, "");
  }
  function T(V) {
    const ee = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = ee, ye.identifier = en(this.sliceSerialize(V)).toLowerCase();
  }
  function C() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.title = V;
  }
  function R() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.url = V;
  }
  function D(V) {
    const ee = this.stack[this.stack.length - 1];
    if (!ee.depth) {
      const ye = this.sliceSerialize(V).length;
      ee.depth = ye;
    }
  }
  function I() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(V) {
    const ee = this.stack[this.stack.length - 1];
    ee.depth = this.sliceSerialize(V).codePointAt(0) === 61 ? 1 : 2;
  }
  function U() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function q(V) {
    const ye = this.stack[this.stack.length - 1].children;
    let ve = ye[ye.length - 1];
    (!ve || ve.type !== "text") && (ve = zo(), ve.position = {
      start: Bn(V.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ye.push(ve)), this.stack.push(ve);
  }
  function P(V) {
    const ee = this.stack.pop();
    ee.value += this.sliceSerialize(V), ee.position.end = Bn(V.end);
  }
  function z(V) {
    const ee = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ye = ee.children[ee.children.length - 1];
      ye.position.end = Bn(V.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(ee.type) && (q.call(this, V), P.call(this, V));
  }
  function G() {
    this.data.atHardBreak = !0;
  }
  function F() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V;
  }
  function M() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V;
  }
  function H() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V;
  }
  function B() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ee = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = ee, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function Y() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ee = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = ee, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function $(V) {
    const ee = this.sliceSerialize(V), ye = this.stack[this.stack.length - 2];
    ye.label = LD(ee), ye.identifier = en(ee).toLowerCase();
  }
  function Z() {
    const V = this.stack[this.stack.length - 1], ee = this.resume(), ye = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ye.type === "link") {
      const ve = V.children;
      ye.children = ve;
    } else
      ye.alt = ee;
  }
  function y() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.url = V;
  }
  function fe() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.title = V;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function v() {
    this.data.referenceType = "collapsed";
  }
  function Se(V) {
    const ee = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = ee, ye.identifier = en(this.sliceSerialize(V)).toLowerCase(), this.data.referenceType = "full";
  }
  function _e(V) {
    this.data.characterReferenceType = V.type;
  }
  function pe(V) {
    const ee = this.sliceSerialize(V), ye = this.data.characterReferenceType;
    let ve;
    ye ? (ve = Nb(ee, ye === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ve = Gl(ee);
    const je = this.stack[this.stack.length - 1];
    je.value += ve;
  }
  function re(V) {
    const ee = this.stack.pop();
    ee.position.end = Bn(V.end);
  }
  function Te(V) {
    P.call(this, V);
    const ee = this.stack[this.stack.length - 1];
    ee.url = this.sliceSerialize(V);
  }
  function ce(V) {
    P.call(this, V);
    const ee = this.stack[this.stack.length - 1];
    ee.url = "mailto:" + this.sliceSerialize(V);
  }
  function ue() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ae() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Pe() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function qe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function mt() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Kt() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function zt() {
    return {
      type: "break"
    };
  }
  function An() {
    return {
      type: "html",
      value: ""
    };
  }
  function Li() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function or() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Mi(V) {
    return {
      type: "list",
      ordered: V.type === "listOrdered",
      start: null,
      spread: V._spread,
      children: []
    };
  }
  function jo(V) {
    return {
      type: "listItem",
      spread: V._spread,
      checked: null,
      children: []
    };
  }
  function Is() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function $o() {
    return {
      type: "strong",
      children: []
    };
  }
  function zo() {
    return {
      type: "text",
      value: ""
    };
  }
  function Hi() {
    return {
      type: "thematicBreak"
    };
  }
}
function Bn(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Fb(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Fb(e, r) : UD(e, r);
  }
}
function UD(e, t) {
  let n;
  for (n in t)
    if (Ub.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Uf(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Xs({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Xs({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Xs({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function FD(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return HD(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function jD(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function $D(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function zD(e, t) {
  const n = t.value ? t.value + `
` : "", r = {}, s = t.lang ? t.lang.split(/\s+/) : [];
  s.length > 0 && (r.className = ["language-" + s[0]]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function VD(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function YD(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function GD(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), s = As(r.toLowerCase()), i = e.footnoteOrder.indexOf(r);
  let a, o = e.footnoteCounts.get(r);
  o === void 0 ? (o = 0, e.footnoteOrder.push(r), a = e.footnoteOrder.length) : a = i + 1, o += 1, e.footnoteCounts.set(r, o);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + s,
      id: n + "fnref-" + s + (o > 1 ? "-" + o : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(a) }]
  };
  e.patch(t, u);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function WD(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function qD(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function jb(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const s = e.all(t), i = s[0];
  i && i.type === "text" ? i.value = "[" + i.value : s.unshift({ type: "text", value: "[" });
  const a = s[s.length - 1];
  return a && a.type === "text" ? a.value += r : s.push({ type: "text", value: r }), s;
}
function KD(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return jb(e, t);
  const s = { src: As(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (s.title = r.title);
  const i = { type: "element", tagName: "img", properties: s, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function QD(e, t) {
  const n = { src: As(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function XD(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function JD(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return jb(e, t);
  const s = { href: As(r.url || "") };
  r.title !== null && r.title !== void 0 && (s.title = r.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: s,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function ZD(e, t) {
  const n = { href: As(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function eL(e, t, n) {
  const r = e.all(t), s = n ? tL(n) : $b(t), i = {}, a = [];
  if (typeof t.checked == "boolean") {
    const l = r[0];
    let h;
    l && l.type === "element" && l.tagName === "p" ? h = l : (h = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let o = -1;
  for (; ++o < r.length; ) {
    const l = r[o];
    (s || o !== 0 || l.type !== "element" || l.tagName !== "p") && a.push({ type: "text", value: `
` }), l.type === "element" && l.tagName === "p" && !s ? a.push(...l.children) : a.push(l);
  }
  const u = r[r.length - 1];
  u && (s || u.type !== "element" || u.tagName !== "p") && a.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: i, children: a };
  return e.patch(t, c), e.applyData(t, c);
}
function tL(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = $b(n[r]);
  }
  return t;
}
function $b(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function nL(e, t) {
  const n = {}, r = e.all(t);
  let s = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++s < r.length; ) {
    const a = r[s];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function rL(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function sL(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function iL(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function aL(e, t) {
  const n = e.all(t), r = n.shift(), s = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), s.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, o = _n(t.children[1]), u = ko(t.children[t.children.length - 1]);
    o && u && (a.position = { start: o, end: u }), s.push(a);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(s, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function oL(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, o = a ? a.length : t.children.length;
  let u = -1;
  const c = [];
  for (; ++u < o; ) {
    const h = t.children[u], m = {}, p = a ? a[u] : void 0;
    p && (m.align = p);
    let E = { type: "element", tagName: i, properties: m, children: [] };
    h && (E.children = e.all(h), e.patch(h, E), E = e.applyData(h, E)), c.push(E);
  }
  const l = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function uL(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Ff = 9, jf = 32;
function cL(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), s = 0;
  const i = [];
  for (; r; )
    i.push(
      $f(t.slice(s, r.index), s > 0, !0),
      r[0]
    ), s = r.index + r[0].length, r = n.exec(t);
  return i.push($f(t.slice(s), s > 0, !1)), i.join("");
}
function $f(e, t, n) {
  let r = 0, s = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === Ff || i === jf; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(s - 1);
    for (; i === Ff || i === jf; )
      s--, i = e.codePointAt(s - 1);
  }
  return s > r ? e.slice(r, s) : "";
}
function lL(e, t) {
  const n = { type: "text", value: cL(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function dL(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const hL = {
  blockquote: jD,
  break: $D,
  code: zD,
  delete: VD,
  emphasis: YD,
  footnoteReference: GD,
  heading: WD,
  html: qD,
  imageReference: KD,
  image: QD,
  inlineCode: XD,
  linkReference: JD,
  link: ZD,
  listItem: eL,
  list: nL,
  paragraph: rL,
  // @ts-expect-error: root is different, but hard to type.
  root: sL,
  strong: iL,
  table: aL,
  tableCell: uL,
  tableRow: oL,
  text: lL,
  thematicBreak: dL,
  toml: ra,
  yaml: ra,
  definition: ra,
  footnoteDefinition: ra
};
function ra() {
}
const zb = -1, Oo = 0, Zs = 1, ja = 2, ql = 3, Kl = 4, Ql = 5, Xl = 6, Vb = 7, Yb = 8, zf = typeof self == "object" ? self : globalThis, fL = (e, t) => {
  const n = (s, i) => (e.set(i, s), s), r = (s) => {
    if (e.has(s))
      return e.get(s);
    const [i, a] = t[s];
    switch (i) {
      case Oo:
      case zb:
        return n(a, s);
      case Zs: {
        const o = n([], s);
        for (const u of a)
          o.push(r(u));
        return o;
      }
      case ja: {
        const o = n({}, s);
        for (const [u, c] of a)
          o[r(u)] = r(c);
        return o;
      }
      case ql:
        return n(new Date(a), s);
      case Kl: {
        const { source: o, flags: u } = a;
        return n(new RegExp(o, u), s);
      }
      case Ql: {
        const o = n(/* @__PURE__ */ new Map(), s);
        for (const [u, c] of a)
          o.set(r(u), r(c));
        return o;
      }
      case Xl: {
        const o = n(/* @__PURE__ */ new Set(), s);
        for (const u of a)
          o.add(r(u));
        return o;
      }
      case Vb: {
        const { name: o, message: u } = a;
        return n(new zf[o](u), s);
      }
      case Yb:
        return n(BigInt(a), s);
      case "BigInt":
        return n(Object(BigInt(a)), s);
      case "ArrayBuffer":
        return n(new Uint8Array(a).buffer, a);
      case "DataView": {
        const { buffer: o } = new Uint8Array(a);
        return n(new DataView(o), a);
      }
    }
    return n(new zf[i](a), s);
  };
  return r;
}, Vf = (e) => fL(/* @__PURE__ */ new Map(), e)(0), Kr = "", { toString: pL } = {}, { keys: mL } = Object, Us = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [Oo, t];
  const n = pL.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Zs, Kr];
    case "Object":
      return [ja, Kr];
    case "Date":
      return [ql, Kr];
    case "RegExp":
      return [Kl, Kr];
    case "Map":
      return [Ql, Kr];
    case "Set":
      return [Xl, Kr];
    case "DataView":
      return [Zs, n];
  }
  return n.includes("Array") ? [Zs, n] : n.includes("Error") ? [Vb, n] : [ja, n];
}, sa = ([e, t]) => e === Oo && (t === "function" || t === "symbol"), gL = (e, t, n, r) => {
  const s = (a, o) => {
    const u = r.push(a) - 1;
    return n.set(o, u), u;
  }, i = (a) => {
    if (n.has(a))
      return n.get(a);
    let [o, u] = Us(a);
    switch (o) {
      case Oo: {
        let l = a;
        switch (u) {
          case "bigint":
            o = Yb, l = a.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            l = null;
            break;
          case "undefined":
            return s([zb], a);
        }
        return s([o, l], a);
      }
      case Zs: {
        if (u) {
          let m = a;
          return u === "DataView" ? m = new Uint8Array(a.buffer) : u === "ArrayBuffer" && (m = new Uint8Array(a)), s([u, [...m]], a);
        }
        const l = [], h = s([o, l], a);
        for (const m of a)
          l.push(i(m));
        return h;
      }
      case ja: {
        if (u)
          switch (u) {
            case "BigInt":
              return s([u, a.toString()], a);
            case "Boolean":
            case "Number":
            case "String":
              return s([u, a.valueOf()], a);
          }
        if (t && "toJSON" in a)
          return i(a.toJSON());
        const l = [], h = s([o, l], a);
        for (const m of mL(a))
          (e || !sa(Us(a[m]))) && l.push([i(m), i(a[m])]);
        return h;
      }
      case ql:
        return s([o, a.toISOString()], a);
      case Kl: {
        const { source: l, flags: h } = a;
        return s([o, { source: l, flags: h }], a);
      }
      case Ql: {
        const l = [], h = s([o, l], a);
        for (const [m, p] of a)
          (e || !(sa(Us(m)) || sa(Us(p)))) && l.push([i(m), i(p)]);
        return h;
      }
      case Xl: {
        const l = [], h = s([o, l], a);
        for (const m of a)
          (e || !sa(Us(m))) && l.push(i(m));
        return h;
      }
    }
    const { message: c } = a;
    return s([o, { name: u, message: c }], a);
  };
  return i;
}, Yf = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return gL(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, hs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Vf(Yf(e, t)) : structuredClone(e)
) : (e, t) => Vf(Yf(e, t));
function EL(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function bL(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function _L(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || EL, r = e.options.footnoteBackLabel || bL, s = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", a = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, o = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!c)
      continue;
    const l = e.all(c), h = String(c.identifier).toUpperCase(), m = As(h.toLowerCase());
    let p = 0;
    const E = [], g = e.footnoteCounts.get(h);
    for (; g !== void 0 && ++p <= g; ) {
      E.length > 0 && E.push({ type: "text", value: " " });
      let T = typeof n == "string" ? n : n(u, p);
      typeof T == "string" && (T = { type: "text", value: T }), E.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + m + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(T) ? T : [T]
      });
    }
    const _ = l[l.length - 1];
    if (_ && _.type === "element" && _.tagName === "p") {
      const T = _.children[_.children.length - 1];
      T && T.type === "text" ? T.value += " " : _.children.push({ type: "text", value: " " }), _.children.push(...E);
    } else
      l.push(...E);
    const b = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + m },
      children: e.wrap(l, !0)
    };
    e.patch(c, b), o.push(b);
  }
  if (o.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...hs(a),
            id: "footnote-label"
          },
          children: [{ type: "text", value: s }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(o, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Do = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return xL;
    if (typeof e == "function")
      return Lo(e);
    if (typeof e == "object")
      return Array.isArray(e) ? TL(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        AL(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return yL(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function TL(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Do(e[n]);
  return Lo(r);
  function r(...s) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, s)) return !0;
    return !1;
  }
}
function AL(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Lo(n);
  function n(r) {
    const s = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in e)
      if (s[i] !== t[i]) return !1;
    return !0;
  }
}
function yL(e) {
  return Lo(t);
  function t(n) {
    return n && n.type === e;
  }
}
function Lo(e) {
  return t;
  function t(n, r, s) {
    return !!(CL(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      s || void 0
    ));
  }
}
function xL() {
  return !0;
}
function CL(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Gb = [], SL = !0, Ic = !1, IL = "skip";
function Wb(e, t, n, r) {
  let s;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : s = t;
  const i = Do(s), a = r ? -1 : 1;
  o(e, void 0, [])();
  function o(u, c, l) {
    const h = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof h.type == "string") {
      const p = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(m, "name", {
        value: "node (" + (u.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return m;
    function m() {
      let p = Gb, E, g, _;
      if ((!t || i(u, c, l[l.length - 1] || void 0)) && (p = wL(n(u, l)), p[0] === Ic))
        return p;
      if ("children" in u && u.children) {
        const b = (
          /** @type {UnistParent} */
          u
        );
        if (b.children && p[0] !== IL)
          for (g = (r ? b.children.length : -1) + a, _ = l.concat(b); g > -1 && g < b.children.length; ) {
            const T = b.children[g];
            if (E = o(T, g, _)(), E[0] === Ic)
              return E;
            g = typeof E[1] == "number" ? E[1] : g + a;
          }
      }
      return p;
    }
  }
}
function wL(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [SL, e] : e == null ? Gb : [e];
}
function Mo(e, t, n, r) {
  let s, i, a;
  typeof t == "function" && typeof n != "function" ? (i = void 0, a = t, s = n) : (i = t, a = n, s = r), Wb(e, i, o, s);
  function o(u, c) {
    const l = c[c.length - 1], h = l ? l.children.indexOf(u) : void 0;
    return a(u, h, l);
  }
}
const wc = {}.hasOwnProperty, vL = {};
function NL(e, t) {
  const n = t || vL, r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = { ...hL, ...n.handlers }, o = {
    all: c,
    applyData: RL,
    definitionById: r,
    footnoteById: s,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: a,
    one: u,
    options: n,
    patch: kL,
    wrap: OL
  };
  return Mo(e, function(l) {
    if (l.type === "definition" || l.type === "footnoteDefinition") {
      const h = l.type === "definition" ? r : s, m = String(l.identifier).toUpperCase();
      h.has(m) || h.set(m, l);
    }
  }), o;
  function u(l, h) {
    const m = l.type, p = o.handlers[m];
    if (wc.call(o.handlers, m) && p)
      return p(o, l, h);
    if (o.options.passThrough && o.options.passThrough.includes(m)) {
      if ("children" in l) {
        const { children: g, ..._ } = l, b = hs(_);
        return b.children = o.all(l), b;
      }
      return hs(l);
    }
    return (o.options.unknownHandler || PL)(o, l, h);
  }
  function c(l) {
    const h = [];
    if ("children" in l) {
      const m = l.children;
      let p = -1;
      for (; ++p < m.length; ) {
        const E = o.one(m[p], l);
        if (E) {
          if (p && m[p - 1].type === "break" && (!Array.isArray(E) && E.type === "text" && (E.value = Gf(E.value)), !Array.isArray(E) && E.type === "element")) {
            const g = E.children[0];
            g && g.type === "text" && (g.value = Gf(g.value));
          }
          Array.isArray(E) ? h.push(...E) : h.push(E);
        }
      }
    }
    return h;
  }
}
function kL(e, t) {
  e.position && (t.position = b3(e));
}
function RL(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, s = e.data.hChildren, i = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const a = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: a };
      }
    n.type === "element" && i && Object.assign(n.properties, hs(i)), "children" in n && n.children && s !== null && s !== void 0 && (n.children = s);
  }
  return n;
}
function PL(e, t) {
  const n = t.data || {}, r = "value" in t && !(wc.call(n, "hProperties") || wc.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function OL(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Gf(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Wf(e, t) {
  const n = NL(e, t), r = n.one(e, void 0), s = _L(n), i = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return s && i.children.push({ type: "text", value: `
` }, s), i;
}
function DL(e, t) {
  return e && "run" in e ? async function(n, r) {
    const s = (
      /** @type {HastRoot} */
      Wf(n, { file: r, ...t })
    );
    await e.run(s, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Wf(n, { file: r, ...e || t })
    );
  };
}
function qf(e) {
  if (e)
    throw e;
}
var vu, Kf;
function LL() {
  if (Kf) return vu;
  Kf = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, s = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : t.call(c) === "[object Array]";
  }, i = function(c) {
    if (!c || t.call(c) !== "[object Object]")
      return !1;
    var l = e.call(c, "constructor"), h = c.constructor && c.constructor.prototype && e.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !l && !h)
      return !1;
    var m;
    for (m in c)
      ;
    return typeof m > "u" || e.call(c, m);
  }, a = function(c, l) {
    n && l.name === "__proto__" ? n(c, l.name, {
      enumerable: !0,
      configurable: !0,
      value: l.newValue,
      writable: !0
    }) : c[l.name] = l.newValue;
  }, o = function(c, l) {
    if (l === "__proto__")
      if (e.call(c, l)) {
        if (r)
          return r(c, l).value;
      } else return;
    return c[l];
  };
  return vu = function u() {
    var c, l, h, m, p, E, g = arguments[0], _ = 1, b = arguments.length, T = !1;
    for (typeof g == "boolean" && (T = g, g = arguments[1] || {}, _ = 2), (g == null || typeof g != "object" && typeof g != "function") && (g = {}); _ < b; ++_)
      if (c = arguments[_], c != null)
        for (l in c)
          h = o(g, l), m = o(c, l), g !== m && (T && m && (i(m) || (p = s(m))) ? (p ? (p = !1, E = h && s(h) ? h : []) : E = h && i(h) ? h : {}, a(g, { name: l, newValue: u(T, E, m) })) : typeof m < "u" && a(g, { name: l, newValue: m }));
    return g;
  }, vu;
}
var ML = LL();
const Nu = /* @__PURE__ */ Rr(ML);
function vc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function HL() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...s) {
    let i = -1;
    const a = s.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    o(null, ...s);
    function o(u, ...c) {
      const l = e[++i];
      let h = -1;
      if (u) {
        a(u);
        return;
      }
      for (; ++h < s.length; )
        (c[h] === null || c[h] === void 0) && (c[h] = s[h]);
      s = c, l ? BL(l, o)(...c) : a(null, ...c);
    }
  }
  function r(s) {
    if (typeof s != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + s
      );
    return e.push(s), t;
  }
}
function BL(e, t) {
  let n;
  return r;
  function r(...a) {
    const o = e.length > a.length;
    let u;
    o && a.push(s);
    try {
      u = e.apply(this, a);
    } catch (c) {
      const l = (
        /** @type {Error} */
        c
      );
      if (o && n)
        throw l;
      return s(l);
    }
    o || (u && u.then && typeof u.then == "function" ? u.then(i, s) : u instanceof Error ? s(u) : i(u));
  }
  function s(a, ...o) {
    n || (n = !0, t(a, ...o));
  }
  function i(a) {
    s(null, a);
  }
}
const cn = { basename: UL, dirname: FL, extname: jL, join: $L, sep: "/" };
function UL(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Pi(e);
  let n = 0, r = -1, s = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; s--; )
      if (e.codePointAt(s) === 47) {
        if (i) {
          n = s + 1;
          break;
        }
      } else r < 0 && (i = !0, r = s + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, o = t.length - 1;
  for (; s--; )
    if (e.codePointAt(s) === 47) {
      if (i) {
        n = s + 1;
        break;
      }
    } else
      a < 0 && (i = !0, a = s + 1), o > -1 && (e.codePointAt(s) === t.codePointAt(o--) ? o < 0 && (r = s) : (o = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function FL(e) {
  if (Pi(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function jL(e) {
  Pi(e);
  let t = e.length, n = -1, r = 0, s = -1, i = 0, a;
  for (; t--; ) {
    const o = e.codePointAt(t);
    if (o === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), o === 46 ? s < 0 ? s = t : i !== 1 && (i = 1) : s > -1 && (i = -1);
  }
  return s < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && s === n - 1 && s === r + 1 ? "" : e.slice(s, n);
}
function $L(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Pi(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : zL(n);
}
function zL(e) {
  Pi(e);
  const t = e.codePointAt(0) === 47;
  let n = VL(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function VL(e, t) {
  let n = "", r = 0, s = -1, i = 0, a = -1, o, u;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      o = e.codePointAt(a);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(s === a - 1 || i === 1)) if (s !== a - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), s = a, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, s = a, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(s + 1, a) : n = e.slice(s + 1, a), r = a - s - 1;
      s = a, i = 0;
    } else o === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function Pi(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const YL = { cwd: GL };
function GL() {
  return "/";
}
function Nc(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function WL(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Nc(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return qL(e);
}
function qL(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const s = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw s.code = "ERR_INVALID_FILE_URL_PATH", s;
      }
    }
  return decodeURIComponent(t);
}
const ku = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class qb {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Nc(t) ? n = { path: t } : typeof t == "string" || KL(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : YL.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < ku.length; ) {
      const i = ku[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let s;
    for (s in n)
      ku.includes(s) || (this[s] = n[s]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? cn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Pu(t, "basename"), Ru(t, "basename"), this.path = cn.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? cn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Qf(this.basename, "dirname"), this.path = cn.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? cn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (Ru(t, "extname"), Qf(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = cn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Nc(t) && (t = WL(t)), Pu(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? cn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Pu(t, "stem"), Ru(t, "stem"), this.path = cn.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const s = this.message(t, n, r);
    throw s.fatal = !0, s;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const s = this.message(t, n, r);
    return s.fatal = void 0, s;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const s = new Tt(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (s.name = this.path + ":" + s.name, s.file = this.path), s.fatal = !1, this.messages.push(s), s;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Ru(e, t) {
  if (e && e.includes(cn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + cn.sep + "`"
    );
}
function Pu(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Qf(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function KL(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const QL = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), s = r[e], i = function() {
      return s.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, r), i;
  })
), XL = {}.hasOwnProperty;
class Jl extends QL {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = HL();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Jl()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Nu(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (Lu("data", this.frozen), this.namespace[t] = n, this) : XL.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (Lu("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const s = n.call(t, ...r);
      typeof s == "function" && this.transformers.use(s);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = ia(t), r = this.parser || this.Parser;
    return Ou("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), Ou("process", this.parser || this.Parser), Du("process", this.compiler || this.Compiler), n ? s(void 0, n) : new Promise(s);
    function s(i, a) {
      const o = ia(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(o)
      );
      r.run(u, o, function(l, h, m) {
        if (l || !h || !m)
          return c(l);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), E = r.stringify(p, m);
        eM(E) ? m.value = E : m.result = E, c(
          l,
          /** @type {VFileWithOutput<CompileResult>} */
          m
        );
      });
      function c(l, h) {
        l || !h ? a(l) : i ? i(h) : n(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), Ou("processSync", this.parser || this.Parser), Du("processSync", this.compiler || this.Compiler), this.process(t, s), Jf("processSync", "process", n), r;
    function s(i, a) {
      n = !0, qf(i), r = a;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    Xf(t), this.freeze();
    const s = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(a, o) {
      const u = ia(n);
      s.run(t, u, c);
      function c(l, h, m) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || t
        );
        l ? o(l) : a ? a(p) : r(void 0, p, m);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, s;
    return this.run(t, n, i), Jf("runSync", "run", r), s;
    function i(a, o) {
      qf(a), s = o, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = ia(n), s = this.compiler || this.Compiler;
    return Du("stringify", s), Xf(t), s(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, s = this.namespace;
    if (Lu("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? o(t) : a(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function i(c) {
      if (typeof c == "function")
        u(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [l, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          u(l, h);
        } else
          a(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function a(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      o(c.plugins), c.settings && (s.settings = Nu(!0, s.settings, c.settings));
    }
    function o(c) {
      let l = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++l < c.length; ) {
          const h = c[l];
          i(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function u(c, l) {
      let h = -1, m = -1;
      for (; ++h < r.length; )
        if (r[h][0] === c) {
          m = h;
          break;
        }
      if (m === -1)
        r.push([c, ...l]);
      else if (l.length > 0) {
        let [p, ...E] = l;
        const g = r[m][1];
        vc(g) && vc(p) && (p = Nu(!0, g, p)), r[m] = [c, p, ...E];
      }
    }
  }
}
const JL = new Jl().freeze();
function Ou(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Du(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Lu(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Xf(e) {
  if (!vc(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Jf(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function ia(e) {
  return ZL(e) ? e : new qb(e);
}
function ZL(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function eM(e) {
  return typeof e == "string" || tM(e);
}
function tM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const nM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Zf = [], ep = { allowDangerousHtml: !0 }, rM = /^(https?|ircs?|mailto|xmpp)$/i, sM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Kb(e) {
  const t = iM(e), n = aM(e);
  return oM(t.runSync(t.parse(n), n), e);
}
function iM(e) {
  const t = e.rehypePlugins || Zf, n = e.remarkPlugins || Zf, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...ep } : ep;
  return JL().use(FD).use(n).use(DL, r).use(t);
}
function aM(e) {
  const t = e.children || "", n = new qb();
  return typeof t == "string" && (n.value = t), n;
}
function oM(e, t) {
  const n = t.allowedElements, r = t.allowElement, s = t.components, i = t.disallowedElements, a = t.skipHtml, o = t.unwrapDisallowed, u = t.urlTransform || uM;
  for (const l of sM)
    Object.hasOwn(t, l.from) && ("" + l.from + (l.to ? "use `" + l.to + "` instead" : "remove it") + nM + l.id, void 0);
  return Mo(e, c), x3(e, {
    Fragment: d.Fragment,
    components: s,
    ignoreInvalidStyle: !0,
    jsx: d.jsx,
    jsxs: d.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function c(l, h, m) {
    if (l.type === "raw" && m && typeof h == "number")
      return a ? m.children.splice(h, 1) : m.children[h] = { type: "text", value: l.value }, h;
    if (l.type === "element") {
      let p;
      for (p in Su)
        if (Object.hasOwn(Su, p) && Object.hasOwn(l.properties, p)) {
          const E = l.properties[p], g = Su[p];
          (g === null || g.includes(l.tagName)) && (l.properties[p] = u(String(E || ""), p, l));
        }
    }
    if (l.type === "element") {
      let p = n ? !n.includes(l.tagName) : i ? i.includes(l.tagName) : !1;
      if (!p && r && typeof h == "number" && (p = !r(l, h, m)), p && m && typeof h == "number")
        return o && l.children ? m.children.splice(h, 1, ...l.children) : m.children.splice(h, 1), h;
    }
  }
}
function uM(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), s = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    s !== -1 && t > s || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    rM.test(e.slice(0, t)) ? e : ""
  );
}
const cM = (e, t) => typeof e == "string" ? e === t : JSON.stringify(e) === JSON.stringify(t), lM = (e, t) => {
  if (!e || !t)
    return !1;
  const n = (r) => {
    const { position: s, data: i, ...a } = r || {};
    return a;
  };
  return JSON.stringify(n(e.properties)) === JSON.stringify(n(t.properties)) && cM(e.children, t.children);
}, Zl = (e, t) => lM(e.node, t.node), dM = (e = {}) => Object.fromEntries(Object.entries(e ?? {}).map(([t, n]) => {
  if (!n)
    return [t, n];
  const r = n;
  return [t, he(({ node: i, ...a }) => d.jsx(r, { ...a }), Zl)];
})), ed = _t(null), Qb = () => ft(ed) !== null, hM = ({ children: e, ...t }) => d.jsx(ed.Provider, { value: t, children: e }), fM = he(hM, Zl), pM = ({ node: e, ...t }) => d.jsx("pre", { ...t }), mM = ({ node: e, ...t }) => d.jsx("code", { ...t }), td = ({ node: e, components: { Pre: t, Code: n }, code: r }) => d.jsx(t, { children: d.jsx(n, { node: e, children: r }) }), gM = () => null, EM = ({ node: e, components: { Pre: t, Code: n, SyntaxHighlighter: r, CodeHeader: s }, language: i, code: a }) => {
  const o = ie(() => ({ Pre: t, Code: n }), [t, n]), u = i ? r : td;
  return d.jsxs(d.Fragment, { children: [d.jsx(s, { node: e, language: i, code: a }), d.jsx(u, { node: e, components: o, language: i ?? "unknown", code: a })] });
};
var Mu = { exports: {} };
var tp;
function bM() {
  return tp || (tp = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", a = 0; a < arguments.length; a++) {
          var o = arguments[a];
          o && (i = s(i, r(o)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var a = "";
        for (var o in i)
          t.call(i, o) && i[o] && (a = s(a, o));
        return a;
      }
      function s(i, a) {
        return a ? i ? i + " " + a : i + a : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(Mu)), Mu.exports;
}
var _M = bM();
const Xb = /* @__PURE__ */ Rr(_M), np = ({ className: e, ...t }) => ({ className: n, ...r }) => ({
  className: Xb(e, n),
  ...t,
  ...r
}), TM = ({ node: e, components: { Pre: t, Code: n, SyntaxHighlighter: r, CodeHeader: s }, componentsByLanguage: i = {}, children: a, ...o }) => {
  const u = ft(ed), c = np(u), l = jt((_) => d.jsx(t, { ...c(_) })), h = np(o), m = jt((_) => d.jsx(n, { ...h(_) })), p = /language-(\w+)/.exec(o.className || "")?.[1] ?? "";
  if (typeof a != "string")
    return d.jsx(td, { node: e, components: { Pre: l, Code: m }, code: a });
  const E = i[p]?.SyntaxHighlighter ?? r, g = i[p]?.CodeHeader ?? s;
  return d.jsx(EM, { node: e, components: {
    Pre: l,
    Code: m,
    SyntaxHighlighter: E,
    CodeHeader: g
  }, language: p || "unknown", code: a });
}, AM = ({ node: e, components: t, componentsByLanguage: n, ...r }) => Qb() ? d.jsx(TM, { node: e, components: t, componentsByLanguage: n, ...r }) : d.jsx(t.Code, { ...r }), yM = he(AM, (e, t) => e.components === t.components && e.componentsByLanguage === t.componentsByLanguage && Zl(e, t)), { useSmooth: xM, useSmoothStatus: CM, withSmoothContextProvider: SM } = Nv, IM = ({ components: e, componentsByLanguage: t, smooth: n = !0, preprocess: r, ...s }) => {
  const i = rE(), a = ie(() => r ? {
    ...i,
    text: r(i.text)
  } : i, [i, r]), { text: o } = xM(a, n), { pre: u = pM, code: c = mM, SyntaxHighlighter: l = td, CodeHeader: h = gM } = e ?? {}, m = ie(() => ({
    Pre: u,
    Code: c,
    SyntaxHighlighter: l,
    CodeHeader: h
  }), [u, c, l, h]), p = jt((g) => d.jsx(yM, { components: m, componentsByLanguage: t, ...g })), E = ie(() => {
    const { pre: g, code: _, SyntaxHighlighter: b, CodeHeader: T, ...C } = e ?? {};
    return {
      ...C,
      pre: fM,
      code: p
    };
  }, [p, e]);
  return d.jsx(Kb, { components: E, ...s, children: o });
}, Jb = Je(({ className: e, containerProps: t, containerComponent: n = "div", ...r }, s) => {
  const i = CM();
  return d.jsx(n, { "data-status": i.type, ...t, className: Xb(e, t?.className), ref: s, children: d.jsx(IM, { ...r }) });
});
Jb.displayName = "MarkdownTextPrimitive";
const wM = SM(Jb), rp = /[#.]/g;
function vM(e, t) {
  const n = e || "", r = {};
  let s = 0, i, a;
  for (; s < n.length; ) {
    rp.lastIndex = s;
    const o = rp.exec(n), u = n.slice(s, o ? o.index : n.length);
    u && (i ? i === "#" ? r.id = u : Array.isArray(r.className) ? r.className.push(u) : r.className = [u] : a = u, s += u.length), o && (i = o[0], s++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: a || t || "div",
    properties: r,
    children: []
  };
}
function Zb(e, t, n) {
  const r = n ? PM(n) : void 0;
  function s(i, a, ...o) {
    let u;
    if (i == null) {
      u = { type: "root", children: [] };
      const c = (
        /** @type {Child} */
        a
      );
      o.unshift(c);
    } else {
      u = vM(i, t);
      const c = u.tagName.toLowerCase(), l = r ? r.get(c) : void 0;
      if (u.tagName = l || c, NM(a))
        o.unshift(a);
      else
        for (const [h, m] of Object.entries(a))
          kM(e, u.properties, h, m);
    }
    for (const c of o)
      kc(u.children, c);
    return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
  }
  return s;
}
function NM(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    e
  ), n = Object.keys(e);
  for (const r of n) {
    const s = t[r];
    if (s && typeof s == "object") {
      if (!Array.isArray(s)) return !0;
      const i = (
        /** @type {ReadonlyArray<unknown>} */
        s
      );
      for (const a of i)
        if (typeof a != "number" && typeof a != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function kM(e, t, n, r) {
  const s = No(e, n);
  let i;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) return;
      i = r;
    } else typeof r == "boolean" ? i = r : typeof r == "string" ? s.spaceSeparated ? i = yf(r) : s.commaSeparated ? i = Ef(r) : s.commaOrSpaceSeparated ? i = yf(Ef(r).join(" ")) : i = sp(s, s.property, r) : Array.isArray(r) ? i = [...r] : i = s.property === "style" ? RM(r) : String(r);
    if (Array.isArray(i)) {
      const a = [];
      for (const o of i)
        a.push(
          /** @type {number | string} */
          sp(s, s.property, o)
        );
      i = a;
    }
    s.property === "className" && Array.isArray(t.className) && (i = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      i
    )), t[s.property] = i;
  }
}
function kc(e, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const n of t)
      kc(e, n);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? kc(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function sp(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || hi(n) === hi(t)))
      return !0;
  }
  return n;
}
function RM(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    t.push([n, r].join(": "));
  return t.join("; ");
}
function PM(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.set(n.toLowerCase(), n);
  return t;
}
const OM = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], DM = Zb(ki, "div"), LM = Zb(sr, "g", OM);
function MM(e) {
  const t = String(e), n = [];
  return { toOffset: s, toPoint: r };
  function r(i) {
    if (typeof i == "number" && i > -1 && i <= t.length) {
      let a = 0;
      for (; ; ) {
        let o = n[a];
        if (o === void 0) {
          const u = ip(t, n[a - 1]);
          o = u === -1 ? t.length + 1 : u + 1, n[a] = o;
        }
        if (o > i)
          return {
            line: a + 1,
            column: i - (a > 0 ? n[a - 1] : 0) + 1,
            offset: i
          };
        a++;
      }
    }
  }
  function s(i) {
    if (i && typeof i.line == "number" && typeof i.column == "number" && !Number.isNaN(i.line) && !Number.isNaN(i.column)) {
      for (; n.length < i.line; ) {
        const o = n[n.length - 1], u = ip(t, o), c = u === -1 ? t.length + 1 : u + 1;
        if (o === c) break;
        n.push(c);
      }
      const a = (i.line > 1 ? n[i.line - 2] : 0) + i.column - 1;
      if (a < n[i.line - 1]) return a;
    }
  }
}
function ip(e, t) {
  const n = e.indexOf("\r", t), r = e.indexOf(`
`, t);
  return r === -1 ? n : n === -1 || n + 1 === r ? r : n < r ? n : r;
}
const _r = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, e_ = {}.hasOwnProperty, HM = Object.prototype;
function BM(e, t) {
  const n = t || {};
  return nd(
    {
      file: n.file || void 0,
      location: !1,
      schema: n.space === "svg" ? sr : ki,
      verbose: n.verbose || !1
    },
    e
  );
}
function nd(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return n = { type: "comment", value: r.data }, ga(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), s = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: t_(e, t.childNodes),
        data: { quirksMode: s }
      }, e.file && e.location) {
        const i = String(e.file), a = MM(i), o = a.toPoint(0), u = a.toPoint(i.length);
        n.position = { start: o, end: u };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return n = { type: "doctype" }, ga(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return n = { type: "text", value: r.value }, ga(e, r, n), n;
    }
    // Element.
    default:
      return n = UM(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), n;
  }
}
function t_(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; ) {
    const s = (
      /** @type {RootContent} */
      nd(e, t[n])
    );
    r.push(s);
  }
  return r;
}
function UM(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === _r.svg ? sr : ki;
  let r = -1;
  const s = {};
  for (; ++r < t.attrs.length; ) {
    const o = t.attrs[r], u = (o.prefix ? o.prefix + ":" : "") + o.name;
    e_.call(HM, u) || (s[u] = o.value);
  }
  const a = (e.schema.space === "svg" ? LM : DM)(t.tagName, s, t_(e, t.childNodes));
  if (ga(e, t, a), a.tagName === "template") {
    const o = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), u = o.sourceCodeLocation, c = u && u.startTag && Jr(u.startTag), l = u && u.endTag && Jr(u.endTag), h = (
      /** @type {Root} */
      nd(e, o.content)
    );
    c && l && e.file && (h.position = { start: c.end, end: l.start }), a.content = h;
  }
  return e.schema = n, a;
}
function ga(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = FM(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function FM(e, t, n) {
  const r = Jr(n);
  if (t.type === "element") {
    const s = t.children[t.children.length - 1];
    if (r && !n.endTag && s && s.position && s.position.end && (r.end = Object.assign({}, s.position.end)), e.verbose) {
      const i = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          e_.call(n.attrs, a) && (i[No(e.schema, a).property] = Jr(
            n.attrs[a]
          ));
      n.startTag;
      const o = Jr(n.startTag), u = n.endTag ? Jr(n.endTag) : void 0, c = { opening: o };
      u && (c.closing = u), c.properties = i, t.data = { position: c };
    }
  }
  return r;
}
function Jr(e) {
  const t = ap({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = ap({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function ap(e) {
  return e.line && e.column ? e : void 0;
}
const op = {}.hasOwnProperty;
function n_(e, t) {
  const n = t || {};
  function r(s, ...i) {
    let a = r.invalid;
    const o = r.handlers;
    if (s && op.call(s, e)) {
      const u = String(s[e]);
      a = op.call(o, u) ? o[u] : r.unknown;
    }
    if (a)
      return a.call(this, s, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const jM = {}, $M = {}.hasOwnProperty, r_ = n_("type", { handlers: { root: VM, element: KM, text: WM, comment: qM, doctype: GM } });
function zM(e, t) {
  const r = (t || jM).space;
  return r_(e, r === "svg" ? sr : ki);
}
function VM(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = rd(e.children, n, t), ys(e, n), n;
}
function YM(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = rd(e.children, n, t), ys(e, n), n;
}
function GM(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return ys(e, t), t;
}
function WM(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return ys(e, t), t;
}
function qM(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return ys(e, t), t;
}
function KM(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = sr);
  const s = [];
  let i;
  if (e.properties) {
    for (i in e.properties)
      if (i !== "children" && $M.call(e.properties, i)) {
        const u = QM(
          r,
          i,
          e.properties[i]
        );
        u && s.push(u);
      }
  }
  const a = r.space, o = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: s,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: _r[a],
    childNodes: [],
    parentNode: null
  };
  return o.childNodes = rd(e.children, o, r), ys(e, o), e.tagName === "template" && e.content && (o.content = YM(e.content, r)), o;
}
function QM(e, t, n) {
  const r = No(e, t);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? fb(n) : Ab(n));
  const s = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const i = s.name.indexOf(":");
    i < 0 ? s.prefix = "" : (s.name = s.name.slice(i + 1), s.prefix = r.attribute.slice(0, i)), s.namespace = _r[r.space];
  }
  return s;
}
function rd(e, t, n) {
  let r = -1;
  const s = [];
  if (e)
    for (; ++r < e.length; ) {
      const i = r_(e[r], n);
      i.parentNode = t, s.push(i);
    }
  return s;
}
function ys(e, t) {
  const n = e.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const XM = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], JM = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), Xe = "�";
var x;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(x || (x = {}));
const vt = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function s_(e) {
  return e >= 55296 && e <= 57343;
}
function ZM(e) {
  return e >= 56320 && e <= 57343;
}
function e6(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function i_(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function a_(e) {
  return e >= 64976 && e <= 65007 || JM.has(e);
}
var j;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(j || (j = {}));
const t6 = 65536;
class n6 {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = t6, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, n) {
    const { line: r, col: s, offset: i } = this, a = s + n, o = i + n;
    return {
      code: t,
      startLine: r,
      endLine: r,
      startCol: a,
      endCol: a,
      startOffset: o,
      endOffset: o
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (ZM(n))
        return this.pos++, this._addGap(), e6(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, x.EOF;
    return this._err(j.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, n) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, n) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(t, this.pos);
    for (let r = 0; r < t.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== t.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(t) {
    const n = this.pos + t;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, x.EOF;
    const r = this.html.charCodeAt(n);
    return r === x.CARRIAGE_RETURN ? x.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, x.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === x.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, x.LINE_FEED) : t === x.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, s_(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === x.LINE_FEED || t === x.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    i_(t) ? this._err(j.controlCharacterInInputStream) : a_(t) && this._err(j.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Ne;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(Ne || (Ne = {}));
function o_(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
}
const r6 = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), s6 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function i6(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = s6.get(e)) !== null && t !== void 0 ? t : e;
}
var ct;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(ct || (ct = {}));
const a6 = 32;
var zn;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(zn || (zn = {}));
function Rc(e) {
  return e >= ct.ZERO && e <= ct.NINE;
}
function o6(e) {
  return e >= ct.UPPER_A && e <= ct.UPPER_F || e >= ct.LOWER_A && e <= ct.LOWER_F;
}
function u6(e) {
  return e >= ct.UPPER_A && e <= ct.UPPER_Z || e >= ct.LOWER_A && e <= ct.LOWER_Z || Rc(e);
}
function c6(e) {
  return e === ct.EQUALS || u6(e);
}
var ot;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(ot || (ot = {}));
var In;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(In || (In = {}));
class l6 {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = ot.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = In.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = ot.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case ot.EntityStart:
        return t.charCodeAt(n) === ct.NUM ? (this.state = ot.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = ot.NamedEntity, this.stateNamedEntity(t, n));
      case ot.NumericStart:
        return this.stateNumericStart(t, n);
      case ot.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case ot.NumericHex:
        return this.stateNumericHex(t, n);
      case ot.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | a6) === ct.LOWER_X ? (this.state = ot.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = ot.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, s) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(s, i) + Number.parseInt(t.substr(n, i), s), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const s = t.charCodeAt(n);
      if (Rc(s) || o6(s))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(s, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const s = t.charCodeAt(n);
      if (Rc(s))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(s, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === ct.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === In.Strict)
      return 0;
    return this.emitCodePoint(i6(this.result), this.consumed), this.errors && (t !== ct.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let s = r[this.treeIndex], i = (s & zn.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const a = t.charCodeAt(n);
      if (this.treeIndex = d6(r, s, this.treeIndex + Math.max(1, i), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === In.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        c6(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (s = r[this.treeIndex], i = (s & zn.VALUE_LENGTH) >> 14, i !== 0) {
        if (a === ct.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== In.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, s = (r[n] & zn.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, s, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: s } = this;
    return this.emitCodePoint(n === 1 ? s[t] & ~zn.VALUE_LENGTH : s[t + 1], r), n === 3 && this.emitCodePoint(s[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case ot.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== In.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case ot.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case ot.NumericHex:
        return this.emitNumericEntity(0, 3);
      case ot.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case ot.EntityStart:
        return 0;
    }
  }
}
function d6(e, t, n, r) {
  const s = (t & zn.BRANCH_LENGTH) >> 7, i = t & zn.JUMP_TABLE;
  if (s === 0)
    return i !== 0 && r === i ? n : -1;
  if (i) {
    const u = r - i;
    return u < 0 || u >= s ? -1 : e[n + u] - 1;
  }
  let a = n, o = a + s - 1;
  for (; a <= o; ) {
    const u = a + o >>> 1, c = e[u];
    if (c < r)
      a = u + 1;
    else if (c > r)
      o = u - 1;
    else
      return e[u + s];
  }
  return -1;
}
var W;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(W || (W = {}));
var yr;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(yr || (yr = {}));
var Gt;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(Gt || (Gt = {}));
var L;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(L || (L = {}));
var f;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(f || (f = {}));
const h6 = /* @__PURE__ */ new Map([
  [L.A, f.A],
  [L.ADDRESS, f.ADDRESS],
  [L.ANNOTATION_XML, f.ANNOTATION_XML],
  [L.APPLET, f.APPLET],
  [L.AREA, f.AREA],
  [L.ARTICLE, f.ARTICLE],
  [L.ASIDE, f.ASIDE],
  [L.B, f.B],
  [L.BASE, f.BASE],
  [L.BASEFONT, f.BASEFONT],
  [L.BGSOUND, f.BGSOUND],
  [L.BIG, f.BIG],
  [L.BLOCKQUOTE, f.BLOCKQUOTE],
  [L.BODY, f.BODY],
  [L.BR, f.BR],
  [L.BUTTON, f.BUTTON],
  [L.CAPTION, f.CAPTION],
  [L.CENTER, f.CENTER],
  [L.CODE, f.CODE],
  [L.COL, f.COL],
  [L.COLGROUP, f.COLGROUP],
  [L.DD, f.DD],
  [L.DESC, f.DESC],
  [L.DETAILS, f.DETAILS],
  [L.DIALOG, f.DIALOG],
  [L.DIR, f.DIR],
  [L.DIV, f.DIV],
  [L.DL, f.DL],
  [L.DT, f.DT],
  [L.EM, f.EM],
  [L.EMBED, f.EMBED],
  [L.FIELDSET, f.FIELDSET],
  [L.FIGCAPTION, f.FIGCAPTION],
  [L.FIGURE, f.FIGURE],
  [L.FONT, f.FONT],
  [L.FOOTER, f.FOOTER],
  [L.FOREIGN_OBJECT, f.FOREIGN_OBJECT],
  [L.FORM, f.FORM],
  [L.FRAME, f.FRAME],
  [L.FRAMESET, f.FRAMESET],
  [L.H1, f.H1],
  [L.H2, f.H2],
  [L.H3, f.H3],
  [L.H4, f.H4],
  [L.H5, f.H5],
  [L.H6, f.H6],
  [L.HEAD, f.HEAD],
  [L.HEADER, f.HEADER],
  [L.HGROUP, f.HGROUP],
  [L.HR, f.HR],
  [L.HTML, f.HTML],
  [L.I, f.I],
  [L.IMG, f.IMG],
  [L.IMAGE, f.IMAGE],
  [L.INPUT, f.INPUT],
  [L.IFRAME, f.IFRAME],
  [L.KEYGEN, f.KEYGEN],
  [L.LABEL, f.LABEL],
  [L.LI, f.LI],
  [L.LINK, f.LINK],
  [L.LISTING, f.LISTING],
  [L.MAIN, f.MAIN],
  [L.MALIGNMARK, f.MALIGNMARK],
  [L.MARQUEE, f.MARQUEE],
  [L.MATH, f.MATH],
  [L.MENU, f.MENU],
  [L.META, f.META],
  [L.MGLYPH, f.MGLYPH],
  [L.MI, f.MI],
  [L.MO, f.MO],
  [L.MN, f.MN],
  [L.MS, f.MS],
  [L.MTEXT, f.MTEXT],
  [L.NAV, f.NAV],
  [L.NOBR, f.NOBR],
  [L.NOFRAMES, f.NOFRAMES],
  [L.NOEMBED, f.NOEMBED],
  [L.NOSCRIPT, f.NOSCRIPT],
  [L.OBJECT, f.OBJECT],
  [L.OL, f.OL],
  [L.OPTGROUP, f.OPTGROUP],
  [L.OPTION, f.OPTION],
  [L.P, f.P],
  [L.PARAM, f.PARAM],
  [L.PLAINTEXT, f.PLAINTEXT],
  [L.PRE, f.PRE],
  [L.RB, f.RB],
  [L.RP, f.RP],
  [L.RT, f.RT],
  [L.RTC, f.RTC],
  [L.RUBY, f.RUBY],
  [L.S, f.S],
  [L.SCRIPT, f.SCRIPT],
  [L.SEARCH, f.SEARCH],
  [L.SECTION, f.SECTION],
  [L.SELECT, f.SELECT],
  [L.SOURCE, f.SOURCE],
  [L.SMALL, f.SMALL],
  [L.SPAN, f.SPAN],
  [L.STRIKE, f.STRIKE],
  [L.STRONG, f.STRONG],
  [L.STYLE, f.STYLE],
  [L.SUB, f.SUB],
  [L.SUMMARY, f.SUMMARY],
  [L.SUP, f.SUP],
  [L.TABLE, f.TABLE],
  [L.TBODY, f.TBODY],
  [L.TEMPLATE, f.TEMPLATE],
  [L.TEXTAREA, f.TEXTAREA],
  [L.TFOOT, f.TFOOT],
  [L.TD, f.TD],
  [L.TH, f.TH],
  [L.THEAD, f.THEAD],
  [L.TITLE, f.TITLE],
  [L.TR, f.TR],
  [L.TRACK, f.TRACK],
  [L.TT, f.TT],
  [L.U, f.U],
  [L.UL, f.UL],
  [L.SVG, f.SVG],
  [L.VAR, f.VAR],
  [L.WBR, f.WBR],
  [L.XMP, f.XMP]
]);
function xs(e) {
  var t;
  return (t = h6.get(e)) !== null && t !== void 0 ? t : f.UNKNOWN;
}
const K = f, f6 = {
  [W.HTML]: /* @__PURE__ */ new Set([
    K.ADDRESS,
    K.APPLET,
    K.AREA,
    K.ARTICLE,
    K.ASIDE,
    K.BASE,
    K.BASEFONT,
    K.BGSOUND,
    K.BLOCKQUOTE,
    K.BODY,
    K.BR,
    K.BUTTON,
    K.CAPTION,
    K.CENTER,
    K.COL,
    K.COLGROUP,
    K.DD,
    K.DETAILS,
    K.DIR,
    K.DIV,
    K.DL,
    K.DT,
    K.EMBED,
    K.FIELDSET,
    K.FIGCAPTION,
    K.FIGURE,
    K.FOOTER,
    K.FORM,
    K.FRAME,
    K.FRAMESET,
    K.H1,
    K.H2,
    K.H3,
    K.H4,
    K.H5,
    K.H6,
    K.HEAD,
    K.HEADER,
    K.HGROUP,
    K.HR,
    K.HTML,
    K.IFRAME,
    K.IMG,
    K.INPUT,
    K.LI,
    K.LINK,
    K.LISTING,
    K.MAIN,
    K.MARQUEE,
    K.MENU,
    K.META,
    K.NAV,
    K.NOEMBED,
    K.NOFRAMES,
    K.NOSCRIPT,
    K.OBJECT,
    K.OL,
    K.P,
    K.PARAM,
    K.PLAINTEXT,
    K.PRE,
    K.SCRIPT,
    K.SECTION,
    K.SELECT,
    K.SOURCE,
    K.STYLE,
    K.SUMMARY,
    K.TABLE,
    K.TBODY,
    K.TD,
    K.TEMPLATE,
    K.TEXTAREA,
    K.TFOOT,
    K.TH,
    K.THEAD,
    K.TITLE,
    K.TR,
    K.TRACK,
    K.UL,
    K.WBR,
    K.XMP
  ]),
  [W.MATHML]: /* @__PURE__ */ new Set([K.MI, K.MO, K.MN, K.MS, K.MTEXT, K.ANNOTATION_XML]),
  [W.SVG]: /* @__PURE__ */ new Set([K.TITLE, K.FOREIGN_OBJECT, K.DESC]),
  [W.XLINK]: /* @__PURE__ */ new Set(),
  [W.XML]: /* @__PURE__ */ new Set(),
  [W.XMLNS]: /* @__PURE__ */ new Set()
}, Pc = /* @__PURE__ */ new Set([K.H1, K.H2, K.H3, K.H4, K.H5, K.H6]);
L.STYLE, L.SCRIPT, L.XMP, L.IFRAME, L.NOEMBED, L.NOFRAMES, L.PLAINTEXT;
var S;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(S || (S = {}));
const tt = {
  DATA: S.DATA,
  RCDATA: S.RCDATA,
  RAWTEXT: S.RAWTEXT,
  SCRIPT_DATA: S.SCRIPT_DATA,
  PLAINTEXT: S.PLAINTEXT,
  CDATA_SECTION: S.CDATA_SECTION
};
function p6(e) {
  return e >= x.DIGIT_0 && e <= x.DIGIT_9;
}
function Vs(e) {
  return e >= x.LATIN_CAPITAL_A && e <= x.LATIN_CAPITAL_Z;
}
function m6(e) {
  return e >= x.LATIN_SMALL_A && e <= x.LATIN_SMALL_Z;
}
function Fn(e) {
  return m6(e) || Vs(e);
}
function up(e) {
  return Fn(e) || p6(e);
}
function aa(e) {
  return e + 32;
}
function u_(e) {
  return e === x.SPACE || e === x.LINE_FEED || e === x.TABULATION || e === x.FORM_FEED;
}
function cp(e) {
  return u_(e) || e === x.SOLIDUS || e === x.GREATER_THAN_SIGN;
}
function g6(e) {
  return e === x.NULL ? j.nullCharacterReference : e > 1114111 ? j.characterReferenceOutsideUnicodeRange : s_(e) ? j.surrogateCharacterReference : a_(e) ? j.noncharacterCharacterReference : i_(e) || e === x.CARRIAGE_RETURN ? j.controlCharacterReference : null;
}
class E6 {
  constructor(t, n) {
    this.options = t, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = S.DATA, this.returnState = S.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new n6(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new l6(r6, (r, s) => {
      this.preprocessor.pos = this.entityStartPos + s - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(j.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (r) => {
        this._err(j.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
      },
      validateNumericCharacterReference: (r) => {
        const s = g6(r);
        s && this._err(s, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, n = 0) {
    var r, s;
    (s = (r = this.handler).onParseError) === null || s === void 0 || s.call(r, this.preprocessor.getError(t, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t?.());
  }
  write(t, n, r) {
    this.active = !0, this.preprocessor.write(t, n), this._runParsingLoop(), this.paused || r?.();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let n = 0; n < t; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, n) {
    return this.preprocessor.startsWith(t, n) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Ne.START_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Ne.END_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: Ne.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: Ne.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, n;
    const r = this.currentToken;
    if (o_(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const s = (t = (n = r.location).attrs) !== null && t !== void 0 ? t : n.attrs = /* @__PURE__ */ Object.create(null);
        s[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(j.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = xs(t.tagName), t.type === Ne.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(j.endTagWithAttributes), t.selfClosing && this._err(j.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case Ne.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Ne.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Ne.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: Ne.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    const n = u_(t) ? Ne.WHITESPACE_CHARACTER : t === x.NULL ? Ne.NULL_CHARACTER : Ne.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Ne.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = S.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? In.Attribute : In.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === S.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === S.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === S.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case S.DATA: {
        this._stateData(t);
        break;
      }
      case S.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case S.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case S.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case S.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case S.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case S.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case S.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case S.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case S.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case S.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case S.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case S.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case S.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case S.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case S.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case S.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case S.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case S.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case S.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case S.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case S.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case S.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case S.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case S.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case S.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case S.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case S.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case S.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case S.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case S.COMMENT: {
        this._stateComment(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case S.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case S.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case S.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case S.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case S.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case S.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case S.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case S.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case S.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case S.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case S.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case S.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case S.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case S.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case S.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case S.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case S.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case S.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case S.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case S.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case S.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case S.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case x.LESS_THAN_SIGN: {
        this.state = S.TAG_OPEN;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case x.LESS_THAN_SIGN: {
        this.state = S.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (Fn(t))
      this._createStartTagToken(), this.state = S.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case x.EXCLAMATION_MARK: {
          this.state = S.MARKUP_DECLARATION_OPEN;
          break;
        }
        case x.SOLIDUS: {
          this.state = S.END_TAG_OPEN;
          break;
        }
        case x.QUESTION_MARK: {
          this._err(j.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = S.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case x.EOF: {
          this._err(j.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(j.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = S.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (Fn(t))
      this._createEndTagToken(), this.state = S.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case x.GREATER_THAN_SIGN: {
          this._err(j.missingEndTagName), this.state = S.DATA;
          break;
        }
        case x.EOF: {
          this._err(j.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(j.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = S.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case x.SOLIDUS: {
        this.state = S.SELF_CLOSING_START_TAG;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.tagName += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(Vs(t) ? aa(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === x.SOLIDUS ? this.state = S.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = S.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    Fn(t) ? (this.state = S.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = S.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = S.BEFORE_ATTRIBUTE_NAME, !1;
      case x.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = S.SELF_CLOSING_START_TAG, !1;
      case x.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = S.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === x.SOLIDUS ? this.state = S.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = S.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    Fn(t) ? (this.state = S.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = S.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case x.SOLIDUS: {
        this.state = S.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case x.EXCLAMATION_MARK: {
        this.state = S.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = S.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    Fn(t) ? (this.state = S.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === x.HYPHEN_MINUS ? (this.state = S.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === x.HYPHEN_MINUS ? (this.state = S.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === x.SOLIDUS ? this.state = S.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Fn(t) ? (this._emitChars("<"), this.state = S.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    Fn(t) ? (this.state = S.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(vt.SCRIPT, !1) && cp(this.preprocessor.peek(vt.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < vt.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === x.SOLIDUS ? (this.state = S.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(vt.SCRIPT, !1) && cp(this.preprocessor.peek(vt.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < vt.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = S.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.SOLIDUS:
      case x.GREATER_THAN_SIGN:
      case x.EOF: {
        this.state = S.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case x.EQUALS_SIGN: {
        this._err(j.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = S.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = S.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
      case x.SOLIDUS:
      case x.GREATER_THAN_SIGN:
      case x.EOF: {
        this._leaveAttrName(), this.state = S.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case x.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = S.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case x.QUOTATION_MARK:
      case x.APOSTROPHE:
      case x.LESS_THAN_SIGN: {
        this._err(j.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.name += Xe;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Vs(t) ? aa(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.SOLIDUS: {
        this.state = S.SELF_CLOSING_START_TAG;
        break;
      }
      case x.EQUALS_SIGN: {
        this.state = S.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = S.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.QUOTATION_MARK: {
        this.state = S.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this.state = S.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingAttributeValue), this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = S.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case x.QUOTATION_MARK: {
        this.state = S.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.value += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case x.APOSTROPHE: {
        this.state = S.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.value += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this._leaveAttrValue(), this.state = S.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.value += Xe;
        break;
      }
      case x.QUOTATION_MARK:
      case x.APOSTROPHE:
      case x.LESS_THAN_SIGN:
      case x.EQUALS_SIGN:
      case x.GRAVE_ACCENT: {
        this._err(j.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this._leaveAttrValue(), this.state = S.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case x.SOLIDUS: {
        this._leaveAttrValue(), this.state = S.SELF_CLOSING_START_TAG;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingWhitespaceBetweenAttributes), this.state = S.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.unexpectedSolidusInTag), this.state = S.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const n = this.currentToken;
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.data += Xe;
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(vt.DASH_DASH, !0) ? (this._createCommentToken(vt.DASH_DASH.length + 1), this.state = S.COMMENT_START) : this._consumeSequenceIfMatch(vt.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(vt.DOCTYPE.length + 1), this.state = S.DOCTYPE) : this._consumeSequenceIfMatch(vt.CDATA_START, !0) ? this.inForeignNode ? this.state = S.CDATA_SECTION : (this._err(j.cdataInHtmlContent), this._createCommentToken(vt.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = S.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(j.incorrectlyOpenedComment), this._createCommentToken(2), this.state = S.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_START_DASH;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptClosingOfEmptyComment), this.state = S.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_END;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptClosingOfEmptyComment), this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_END_DASH;
        break;
      }
      case x.LESS_THAN_SIGN: {
        n.data += "<", this.state = S.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.data += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const n = this.currentToken;
    switch (t) {
      case x.EXCLAMATION_MARK: {
        n.data += "!", this.state = S.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case x.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === x.HYPHEN_MINUS ? this.state = S.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = S.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === x.HYPHEN_MINUS ? this.state = S.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = S.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== x.GREATER_THAN_SIGN && t !== x.EOF && this._err(j.nestedComment), this.state = S.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_END;
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const n = this.currentToken;
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EXCLAMATION_MARK: {
        this.state = S.COMMENT_END_BANG;
        break;
      }
      case x.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        n.data += "--!", this.state = S.COMMENT_END_DASH;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.incorrectlyClosedComment), this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_DOCTYPE_NAME;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingWhitespaceBeforeDoctypeName), this.state = S.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (Vs(t))
      this._createDoctypeToken(String.fromCharCode(aa(t))), this.state = S.DOCTYPE_NAME;
    else
      switch (t) {
        case x.SPACE:
        case x.LINE_FEED:
        case x.TABULATION:
        case x.FORM_FEED:
          break;
        case x.NULL: {
          this._err(j.unexpectedNullCharacter), this._createDoctypeToken(Xe), this.state = S.DOCTYPE_NAME;
          break;
        }
        case x.GREATER_THAN_SIGN: {
          this._err(j.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
          break;
        }
        case x.EOF: {
          this._err(j.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = S.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.AFTER_DOCTYPE_NAME;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.name += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(Vs(t) ? aa(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(vt.PUBLIC, !1) ? this.state = S.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(vt.SYSTEM, !1) ? this.state = S.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(j.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case x.QUOTATION_MARK: {
        this._err(j.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this._err(j.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.QUOTATION_MARK: {
        n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.QUOTATION_MARK: {
        this.state = S.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.publicId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.APOSTROPHE: {
        this.state = S.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.publicId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.QUOTATION_MARK: {
        this._err(j.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this._err(j.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.QUOTATION_MARK: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case x.QUOTATION_MARK: {
        this._err(j.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this._err(j.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.QUOTATION_MARK: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.QUOTATION_MARK: {
        this.state = S.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.systemId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.APOSTROPHE: {
        this.state = S.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.systemId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const n = this.currentToken;
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter);
        break;
      }
      case x.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case x.RIGHT_SQUARE_BRACKET: {
        this.state = S.CDATA_SECTION_BRACKET;
        break;
      }
      case x.EOF: {
        this._err(j.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === x.RIGHT_SQUARE_BRACKET ? this.state = S.CDATA_SECTION_END : (this._emitChars("]"), this.state = S.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA;
        break;
      }
      case x.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = S.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(x.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && up(this.preprocessor.peek(1)) ? S.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    up(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === x.SEMICOLON && this._err(j.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const c_ = /* @__PURE__ */ new Set([f.DD, f.DT, f.LI, f.OPTGROUP, f.OPTION, f.P, f.RB, f.RP, f.RT, f.RTC]), lp = /* @__PURE__ */ new Set([
  ...c_,
  f.CAPTION,
  f.COLGROUP,
  f.TBODY,
  f.TD,
  f.TFOOT,
  f.TH,
  f.THEAD,
  f.TR
]), $a = /* @__PURE__ */ new Set([
  f.APPLET,
  f.CAPTION,
  f.HTML,
  f.MARQUEE,
  f.OBJECT,
  f.TABLE,
  f.TD,
  f.TEMPLATE,
  f.TH
]), b6 = /* @__PURE__ */ new Set([...$a, f.OL, f.UL]), _6 = /* @__PURE__ */ new Set([...$a, f.BUTTON]), dp = /* @__PURE__ */ new Set([f.ANNOTATION_XML, f.MI, f.MN, f.MO, f.MS, f.MTEXT]), hp = /* @__PURE__ */ new Set([f.DESC, f.FOREIGN_OBJECT, f.TITLE]), T6 = /* @__PURE__ */ new Set([f.TR, f.TEMPLATE, f.HTML]), A6 = /* @__PURE__ */ new Set([f.TBODY, f.TFOOT, f.THEAD, f.TEMPLATE, f.HTML]), y6 = /* @__PURE__ */ new Set([f.TABLE, f.TEMPLATE, f.HTML]), x6 = /* @__PURE__ */ new Set([f.TD, f.TH]);
class C6 {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = f.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === f.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === W.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, n) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, n, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(t, n, r) {
    const s = this._indexOf(t) + 1;
    this.items.splice(s, 0, n), this.tagIDs.splice(s, 0, r), this.stackTop++, s === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, s === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(t, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== W.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const n = this._indexOf(t);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(Pc, W.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(x6, W.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, n) {
    for (let r = this.stackTop; r >= 0; r--)
      if (t.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n)
        return r;
    return -1;
  }
  clearBackTo(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(y6, W.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(A6, W.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(T6, W.HTML);
  }
  remove(t) {
    const n = this._indexOf(t);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === f.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const n = this._indexOf(t) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === f.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const s = this.tagIDs[r];
      switch (this.treeAdapter.getNamespaceURI(this.items[r])) {
        case W.HTML: {
          if (s === t)
            return !0;
          if (n.has(s))
            return !1;
          break;
        }
        case W.SVG: {
          if (hp.has(s))
            return !1;
          break;
        }
        case W.MATHML: {
          if (dp.has(s))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, $a);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, b6);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, _6);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case W.HTML: {
          if (Pc.has(n))
            return !0;
          if ($a.has(n))
            return !1;
          break;
        }
        case W.SVG: {
          if (hp.has(n))
            return !1;
          break;
        }
        case W.MATHML: {
          if (dp.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === W.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === W.HTML)
        switch (this.tagIDs[t]) {
          case f.TBODY:
          case f.THEAD:
          case f.TFOOT:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === W.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case f.OPTION:
          case f.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && c_.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && lp.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && lp.has(this.currentTagId); )
      this.pop();
  }
}
const Hu = 3;
var ln;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(ln || (ln = {}));
const fp = { type: ln.Marker };
class S6 {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, n) {
    const r = [], s = n.length, i = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t);
    for (let o = 0; o < this.entries.length; o++) {
      const u = this.entries[o];
      if (u.type === ln.Marker)
        break;
      const { element: c } = u;
      if (this.treeAdapter.getTagName(c) === i && this.treeAdapter.getNamespaceURI(c) === a) {
        const l = this.treeAdapter.getAttrList(c);
        l.length === s && r.push({ idx: o, attrs: l });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < Hu)
      return;
    const n = this.treeAdapter.getAttrList(t), r = this._getNoahArkConditionCandidates(t, n);
    if (r.length < Hu)
      return;
    const s = new Map(n.map((a) => [a.name, a.value]));
    let i = 0;
    for (let a = 0; a < r.length; a++) {
      const o = r[a];
      o.attrs.every((u) => s.get(u.name) === u.value) && (i += 1, i >= Hu && this.entries.splice(o.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(fp);
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: ln.Element,
      element: t,
      token: n
    });
  }
  insertElementAfterBookmark(t, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: ln.Element,
      element: t,
      token: n
    });
  }
  removeEntry(t) {
    const n = this.entries.indexOf(t);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(fp);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const n = this.entries.find((r) => r.type === ln.Marker || this.treeAdapter.getTagName(r.element) === t);
    return n && n.type === ln.Element ? n : null;
  }
  getElementEntry(t) {
    return this.entries.find((n) => n.type === ln.Element && n.element === t);
  }
}
const jn = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Gt.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, n) {
    return {
      nodeName: e,
      tagName: e,
      attrs: n,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, n) {
    const r = e.childNodes.indexOf(n);
    e.childNodes.splice(r, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, n, r) {
    const s = e.childNodes.find((i) => i.nodeName === "#documentType");
    if (s)
      s.name = t, s.publicId = n, s.systemId = r;
    else {
      const i = {
        nodeName: "#documentType",
        name: t,
        publicId: n,
        systemId: r,
        parentNode: null
      };
      jn.appendChild(e, i);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const n = e.childNodes[e.childNodes.length - 1];
      if (jn.isTextNode(n)) {
        n.value += t;
        return;
      }
    }
    jn.appendChild(e, jn.createTextNode(t));
  },
  insertTextBefore(e, t, n) {
    const r = e.childNodes[e.childNodes.indexOf(n) - 1];
    r && jn.isTextNode(r) ? r.value += t : jn.insertBefore(e, jn.createTextNode(t), n);
  },
  adoptAttributes(e, t) {
    const n = new Set(e.attrs.map((r) => r.name));
    for (let r = 0; r < t.length; r++)
      n.has(t[r].name) || e.attrs.push(t[r]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, l_ = "html", I6 = "about:legacy-compat", w6 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", d_ = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], v6 = [
  ...d_,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], N6 = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), h_ = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], k6 = [
  ...h_,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function pp(e, t) {
  return t.some((n) => e.startsWith(n));
}
function R6(e) {
  return e.name === l_ && e.publicId === null && (e.systemId === null || e.systemId === I6);
}
function P6(e) {
  if (e.name !== l_)
    return Gt.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === w6)
    return Gt.QUIRKS;
  let { publicId: n } = e;
  if (n !== null) {
    if (n = n.toLowerCase(), N6.has(n))
      return Gt.QUIRKS;
    let r = t === null ? v6 : d_;
    if (pp(n, r))
      return Gt.QUIRKS;
    if (r = t === null ? h_ : k6, pp(n, r))
      return Gt.LIMITED_QUIRKS;
  }
  return Gt.NO_QUIRKS;
}
const mp = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, O6 = "definitionurl", D6 = "definitionURL", L6 = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), M6 = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: W.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: W.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: W.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: W.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: W.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: W.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: W.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: W.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: W.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: W.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: W.XMLNS }]
]), H6 = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), B6 = /* @__PURE__ */ new Set([
  f.B,
  f.BIG,
  f.BLOCKQUOTE,
  f.BODY,
  f.BR,
  f.CENTER,
  f.CODE,
  f.DD,
  f.DIV,
  f.DL,
  f.DT,
  f.EM,
  f.EMBED,
  f.H1,
  f.H2,
  f.H3,
  f.H4,
  f.H5,
  f.H6,
  f.HEAD,
  f.HR,
  f.I,
  f.IMG,
  f.LI,
  f.LISTING,
  f.MENU,
  f.META,
  f.NOBR,
  f.OL,
  f.P,
  f.PRE,
  f.RUBY,
  f.S,
  f.SMALL,
  f.SPAN,
  f.STRONG,
  f.STRIKE,
  f.SUB,
  f.SUP,
  f.TABLE,
  f.TT,
  f.U,
  f.UL,
  f.VAR
]);
function U6(e) {
  const t = e.tagID;
  return t === f.FONT && e.attrs.some(({ name: r }) => r === yr.COLOR || r === yr.SIZE || r === yr.FACE) || B6.has(t);
}
function f_(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === O6) {
      e.attrs[t].name = D6;
      break;
    }
}
function p_(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = L6.get(e.attrs[t].name);
    n != null && (e.attrs[t].name = n);
  }
}
function sd(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = M6.get(e.attrs[t].name);
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
}
function F6(e) {
  const t = H6.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = xs(e.tagName));
}
function j6(e, t) {
  return t === W.MATHML && (e === f.MI || e === f.MO || e === f.MN || e === f.MS || e === f.MTEXT);
}
function $6(e, t, n) {
  if (t === W.MATHML && e === f.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === yr.ENCODING) {
        const s = n[r].value.toLowerCase();
        return s === mp.TEXT_HTML || s === mp.APPLICATION_XML;
      }
  }
  return t === W.SVG && (e === f.FOREIGN_OBJECT || e === f.DESC || e === f.TITLE);
}
function z6(e, t, n, r) {
  return (!r || r === W.HTML) && $6(e, t, n) || (!r || r === W.MATHML) && j6(e, t);
}
const V6 = "hidden", Y6 = 8, G6 = 3;
var w;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(w || (w = {}));
const W6 = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, m_ = /* @__PURE__ */ new Set([f.TABLE, f.TBODY, f.TFOOT, f.THEAD, f.TR]), gp = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: jn,
  onParseError: null
};
class Ep {
  constructor(t, n, r = null, s = null) {
    this.fragmentContext = r, this.scriptHandler = s, this.currentToken = null, this.stopped = !1, this.insertionMode = w.INITIAL, this.originalInsertionMode = w.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...gp,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new E6(this.options, this), this.activeFormattingElements = new S6(this.treeAdapter), this.fragmentContextID = r ? xs(this.treeAdapter.getTagName(r)) : f.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new C6(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, n) {
    const r = new this(n);
    return r.tokenizer.write(t, !0), r.document;
  }
  static getFragmentParser(t, n) {
    const r = {
      ...gp,
      ...n
    };
    t ?? (t = r.treeAdapter.createElement(L.TEMPLATE, W.HTML, []));
    const s = r.treeAdapter.createElement("documentmock", W.HTML, []), i = new this(r, s, t);
    return i.fragmentContextID === f.TEMPLATE && i.tmplInsertionModeStack.unshift(w.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, n), n;
  }
  //Errors
  /** @internal */
  _err(t, n, r) {
    var s;
    if (!this.onParseError)
      return;
    const i = (s = t.location) !== null && s !== void 0 ? s : W6, a = {
      code: n,
      startLine: i.startLine,
      startCol: i.startCol,
      startOffset: i.startOffset,
      endLine: r ? i.startLine : i.endLine,
      endCol: r ? i.startCol : i.endCol,
      endOffset: r ? i.startOffset : i.endOffset
    };
    this.onParseError(a);
  }
  //Stack events
  /** @internal */
  onItemPush(t, n, r) {
    var s, i;
    (i = (s = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(s, t), r && this.openElements.stackTop > 0 && this._setContextModes(t, n);
  }
  /** @internal */
  onItemPop(t, n) {
    var r, s;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (s = (r = this.treeAdapter).onItemPop) === null || s === void 0 || s.call(r, t, this.openElements.current), n) {
      let i, a;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, a = this.fragmentContextID) : { current: i, currentTagId: a } = this.openElements, this._setContextModes(i, a);
    }
  }
  _setContextModes(t, n) {
    const r = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === W.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && t !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, t);
  }
  /** @protected */
  _switchToTextParsing(t, n) {
    this._insertElement(t, W.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = w.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = w.TEXT, this.originalInsertionMode = w.IN_BODY, this.tokenizer.state = tt.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === L.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== W.HTML))
      switch (this.fragmentContextID) {
        case f.TITLE:
        case f.TEXTAREA: {
          this.tokenizer.state = tt.RCDATA;
          break;
        }
        case f.STYLE:
        case f.XMP:
        case f.IFRAME:
        case f.NOEMBED:
        case f.NOFRAMES:
        case f.NOSCRIPT: {
          this.tokenizer.state = tt.RAWTEXT;
          break;
        }
        case f.SCRIPT: {
          this.tokenizer.state = tt.SCRIPT_DATA;
          break;
        }
        case f.PLAINTEXT: {
          this.tokenizer.state = tt.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", s = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, s), t.location) {
      const a = this.treeAdapter.getChildNodes(this.document).find((o) => this.treeAdapter.isDocumentTypeNode(o));
      a && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location);
  }
  /** @protected */
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, n) {
    const r = this.treeAdapter.createElement(t, W.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  /** @protected */
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, W.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(L.HTML, W.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, f.HTML);
  }
  /** @protected */
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, t.chars, r) : this.treeAdapter.insertText(n, t.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, t.chars)), !t.location)
      return;
    const s = this.treeAdapter.getChildNodes(n), i = r ? s.lastIndexOf(r) : s.length, a = s[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(a)) {
      const { endLine: u, endCol: c, endOffset: l } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(a, { endLine: u, endCol: c, endOffset: l });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
  }
  /** @protected */
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  /** @protected */
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const r = n.location, s = this.treeAdapter.getTagName(t), i = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === Ne.END_TAG && s === n.tagName ? {
          endTag: { ...r },
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, i);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : { current: n, currentTagId: r } = this.openElements, t.tagID === f.SVG && this.treeAdapter.getTagName(n) === L.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === W.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === f.MGLYPH || t.tagID === f.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, W.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case Ne.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case Ne.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case Ne.COMMENT: {
        this.onComment(t);
        break;
      }
      case Ne.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case Ne.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case Ne.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case Ne.EOF: {
        this.onEof(t);
        break;
      }
      case Ne.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, n, r) {
    const s = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return z6(t, s, i, r);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const n = this.activeFormattingElements.entries.findIndex((s) => s.type === ln.Marker || this.openElements.contains(s.element)), r = n === -1 ? t - 1 : n - 1;
      for (let s = r; s >= 0; s--) {
        const i = this.activeFormattingElements.entries[s];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = w.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(f.P), this.openElements.popUntilTagNamePopped(f.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case f.TR: {
          this.insertionMode = w.IN_ROW;
          return;
        }
        case f.TBODY:
        case f.THEAD:
        case f.TFOOT: {
          this.insertionMode = w.IN_TABLE_BODY;
          return;
        }
        case f.CAPTION: {
          this.insertionMode = w.IN_CAPTION;
          return;
        }
        case f.COLGROUP: {
          this.insertionMode = w.IN_COLUMN_GROUP;
          return;
        }
        case f.TABLE: {
          this.insertionMode = w.IN_TABLE;
          return;
        }
        case f.BODY: {
          this.insertionMode = w.IN_BODY;
          return;
        }
        case f.FRAMESET: {
          this.insertionMode = w.IN_FRAMESET;
          return;
        }
        case f.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case f.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case f.HTML: {
          this.insertionMode = this.headElement ? w.AFTER_HEAD : w.BEFORE_HEAD;
          return;
        }
        case f.TD:
        case f.TH: {
          if (t > 0) {
            this.insertionMode = w.IN_CELL;
            return;
          }
          break;
        }
        case f.HEAD: {
          if (t > 0) {
            this.insertionMode = w.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = w.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === f.TEMPLATE)
          break;
        if (r === f.TABLE) {
          this.insertionMode = w.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = w.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return m_.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const n = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case f.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === W.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case f.TABLE: {
          const r = this.treeAdapter.getParentNode(n);
          return r ? { parent: r, beforeElement: n } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, n) {
    const r = this.treeAdapter.getNamespaceURI(t);
    return f6[r].has(n);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      x5(this, t);
      return;
    }
    switch (this.insertionMode) {
      case w.INITIAL: {
        Fs(this, t);
        break;
      }
      case w.BEFORE_HTML: {
        ei(this, t);
        break;
      }
      case w.BEFORE_HEAD: {
        ti(this, t);
        break;
      }
      case w.IN_HEAD: {
        ni(this, t);
        break;
      }
      case w.IN_HEAD_NO_SCRIPT: {
        ri(this, t);
        break;
      }
      case w.AFTER_HEAD: {
        si(this, t);
        break;
      }
      case w.IN_BODY:
      case w.IN_CAPTION:
      case w.IN_CELL:
      case w.IN_TEMPLATE: {
        E_(this, t);
        break;
      }
      case w.TEXT:
      case w.IN_SELECT:
      case w.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case w.IN_TABLE:
      case w.IN_TABLE_BODY:
      case w.IN_ROW: {
        Bu(this, t);
        break;
      }
      case w.IN_TABLE_TEXT: {
        x_(this, t);
        break;
      }
      case w.IN_COLUMN_GROUP: {
        za(this, t);
        break;
      }
      case w.AFTER_BODY: {
        Va(this, t);
        break;
      }
      case w.AFTER_AFTER_BODY: {
        Ea(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      y5(this, t);
      return;
    }
    switch (this.insertionMode) {
      case w.INITIAL: {
        Fs(this, t);
        break;
      }
      case w.BEFORE_HTML: {
        ei(this, t);
        break;
      }
      case w.BEFORE_HEAD: {
        ti(this, t);
        break;
      }
      case w.IN_HEAD: {
        ni(this, t);
        break;
      }
      case w.IN_HEAD_NO_SCRIPT: {
        ri(this, t);
        break;
      }
      case w.AFTER_HEAD: {
        si(this, t);
        break;
      }
      case w.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case w.IN_TABLE:
      case w.IN_TABLE_BODY:
      case w.IN_ROW: {
        Bu(this, t);
        break;
      }
      case w.IN_COLUMN_GROUP: {
        za(this, t);
        break;
      }
      case w.AFTER_BODY: {
        Va(this, t);
        break;
      }
      case w.AFTER_AFTER_BODY: {
        Ea(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Oc(this, t);
      return;
    }
    switch (this.insertionMode) {
      case w.INITIAL:
      case w.BEFORE_HTML:
      case w.BEFORE_HEAD:
      case w.IN_HEAD:
      case w.IN_HEAD_NO_SCRIPT:
      case w.AFTER_HEAD:
      case w.IN_BODY:
      case w.IN_TABLE:
      case w.IN_CAPTION:
      case w.IN_COLUMN_GROUP:
      case w.IN_TABLE_BODY:
      case w.IN_ROW:
      case w.IN_CELL:
      case w.IN_SELECT:
      case w.IN_SELECT_IN_TABLE:
      case w.IN_TEMPLATE:
      case w.IN_FRAMESET:
      case w.AFTER_FRAMESET: {
        Oc(this, t);
        break;
      }
      case w.IN_TABLE_TEXT: {
        js(this, t);
        break;
      }
      case w.AFTER_BODY: {
        e4(this, t);
        break;
      }
      case w.AFTER_AFTER_BODY:
      case w.AFTER_AFTER_FRAMESET: {
        t4(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case w.INITIAL: {
        n4(this, t);
        break;
      }
      case w.BEFORE_HEAD:
      case w.IN_HEAD:
      case w.IN_HEAD_NO_SCRIPT:
      case w.AFTER_HEAD: {
        this._err(t, j.misplacedDoctype);
        break;
      }
      case w.IN_TABLE_TEXT: {
        js(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, j.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? C5(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case w.INITIAL: {
        Fs(this, t);
        break;
      }
      case w.BEFORE_HTML: {
        r4(this, t);
        break;
      }
      case w.BEFORE_HEAD: {
        i4(this, t);
        break;
      }
      case w.IN_HEAD: {
        on(this, t);
        break;
      }
      case w.IN_HEAD_NO_SCRIPT: {
        u4(this, t);
        break;
      }
      case w.AFTER_HEAD: {
        l4(this, t);
        break;
      }
      case w.IN_BODY: {
        At(this, t);
        break;
      }
      case w.IN_TABLE: {
        fs(this, t);
        break;
      }
      case w.IN_TABLE_TEXT: {
        js(this, t);
        break;
      }
      case w.IN_CAPTION: {
        a5(this, t);
        break;
      }
      case w.IN_COLUMN_GROUP: {
        od(this, t);
        break;
      }
      case w.IN_TABLE_BODY: {
        Uo(this, t);
        break;
      }
      case w.IN_ROW: {
        Fo(this, t);
        break;
      }
      case w.IN_CELL: {
        c5(this, t);
        break;
      }
      case w.IN_SELECT: {
        I_(this, t);
        break;
      }
      case w.IN_SELECT_IN_TABLE: {
        d5(this, t);
        break;
      }
      case w.IN_TEMPLATE: {
        f5(this, t);
        break;
      }
      case w.AFTER_BODY: {
        m5(this, t);
        break;
      }
      case w.IN_FRAMESET: {
        g5(this, t);
        break;
      }
      case w.AFTER_FRAMESET: {
        b5(this, t);
        break;
      }
      case w.AFTER_AFTER_BODY: {
        T5(this, t);
        break;
      }
      case w.AFTER_AFTER_FRAMESET: {
        A5(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? S5(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case w.INITIAL: {
        Fs(this, t);
        break;
      }
      case w.BEFORE_HTML: {
        s4(this, t);
        break;
      }
      case w.BEFORE_HEAD: {
        a4(this, t);
        break;
      }
      case w.IN_HEAD: {
        o4(this, t);
        break;
      }
      case w.IN_HEAD_NO_SCRIPT: {
        c4(this, t);
        break;
      }
      case w.AFTER_HEAD: {
        d4(this, t);
        break;
      }
      case w.IN_BODY: {
        Bo(this, t);
        break;
      }
      case w.TEXT: {
        Q4(this, t);
        break;
      }
      case w.IN_TABLE: {
        pi(this, t);
        break;
      }
      case w.IN_TABLE_TEXT: {
        js(this, t);
        break;
      }
      case w.IN_CAPTION: {
        o5(this, t);
        break;
      }
      case w.IN_COLUMN_GROUP: {
        u5(this, t);
        break;
      }
      case w.IN_TABLE_BODY: {
        Dc(this, t);
        break;
      }
      case w.IN_ROW: {
        S_(this, t);
        break;
      }
      case w.IN_CELL: {
        l5(this, t);
        break;
      }
      case w.IN_SELECT: {
        w_(this, t);
        break;
      }
      case w.IN_SELECT_IN_TABLE: {
        h5(this, t);
        break;
      }
      case w.IN_TEMPLATE: {
        p5(this, t);
        break;
      }
      case w.AFTER_BODY: {
        N_(this, t);
        break;
      }
      case w.IN_FRAMESET: {
        E5(this, t);
        break;
      }
      case w.AFTER_FRAMESET: {
        _5(this, t);
        break;
      }
      case w.AFTER_AFTER_BODY: {
        Ea(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case w.INITIAL: {
        Fs(this, t);
        break;
      }
      case w.BEFORE_HTML: {
        ei(this, t);
        break;
      }
      case w.BEFORE_HEAD: {
        ti(this, t);
        break;
      }
      case w.IN_HEAD: {
        ni(this, t);
        break;
      }
      case w.IN_HEAD_NO_SCRIPT: {
        ri(this, t);
        break;
      }
      case w.AFTER_HEAD: {
        si(this, t);
        break;
      }
      case w.IN_BODY:
      case w.IN_TABLE:
      case w.IN_CAPTION:
      case w.IN_COLUMN_GROUP:
      case w.IN_TABLE_BODY:
      case w.IN_ROW:
      case w.IN_CELL:
      case w.IN_SELECT:
      case w.IN_SELECT_IN_TABLE: {
        A_(this, t);
        break;
      }
      case w.TEXT: {
        X4(this, t);
        break;
      }
      case w.IN_TABLE_TEXT: {
        js(this, t);
        break;
      }
      case w.IN_TEMPLATE: {
        v_(this, t);
        break;
      }
      case w.AFTER_BODY:
      case w.IN_FRAMESET:
      case w.AFTER_FRAMESET:
      case w.AFTER_AFTER_BODY:
      case w.AFTER_AFTER_FRAMESET: {
        ad(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === x.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case w.IN_HEAD:
      case w.IN_HEAD_NO_SCRIPT:
      case w.AFTER_HEAD:
      case w.TEXT:
      case w.IN_COLUMN_GROUP:
      case w.IN_SELECT:
      case w.IN_SELECT_IN_TABLE:
      case w.IN_FRAMESET:
      case w.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case w.IN_BODY:
      case w.IN_CAPTION:
      case w.IN_CELL:
      case w.IN_TEMPLATE:
      case w.AFTER_BODY:
      case w.AFTER_AFTER_BODY:
      case w.AFTER_AFTER_FRAMESET: {
        g_(this, t);
        break;
      }
      case w.IN_TABLE:
      case w.IN_TABLE_BODY:
      case w.IN_ROW: {
        Bu(this, t);
        break;
      }
      case w.IN_TABLE_TEXT: {
        y_(this, t);
        break;
      }
    }
  }
}
function q6(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagID) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : T_(e, t), n;
}
function K6(e, t) {
  let n = null, r = e.openElements.stackTop;
  for (; r >= 0; r--) {
    const s = e.openElements.items[r];
    if (s === t.element)
      break;
    e._isSpecialElement(s, e.openElements.tagIDs[r]) && (n = s);
  }
  return n || (e.openElements.shortenToLength(Math.max(r, 0)), e.activeFormattingElements.removeEntry(t)), n;
}
function Q6(e, t, n) {
  let r = t, s = e.openElements.getCommonAncestor(t);
  for (let i = 0, a = s; a !== n; i++, a = s) {
    s = e.openElements.getCommonAncestor(a);
    const o = e.activeFormattingElements.getElementEntry(a), u = o && i >= G6;
    !o || u ? (u && e.activeFormattingElements.removeEntry(o), e.openElements.remove(a)) : (a = X6(e, o), r === t && (e.activeFormattingElements.bookmark = o), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(a, r), r = a);
  }
  return r;
}
function X6(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function J6(e, t, n) {
  const r = e.treeAdapter.getTagName(t), s = xs(r);
  if (e._isElementCausesFosterParenting(s))
    e._fosterParentElement(n);
  else {
    const i = e.treeAdapter.getNamespaceURI(t);
    s === f.TEMPLATE && i === W.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function Z6(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), { token: s } = n, i = e.treeAdapter.createElement(s.tagName, r, s.attrs);
  e._adoptNodes(t, i), e.treeAdapter.appendChild(t, i), e.activeFormattingElements.insertElementAfterBookmark(i, s), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, i, s.tagID);
}
function id(e, t) {
  for (let n = 0; n < Y6; n++) {
    const r = q6(e, t);
    if (!r)
      break;
    const s = K6(e, r);
    if (!s)
      break;
    e.activeFormattingElements.bookmark = r;
    const i = Q6(e, s, r.element), a = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(i), a && J6(e, a, i), Z6(e, s, r);
  }
}
function Oc(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function e4(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function t4(e, t) {
  e._appendCommentNode(t, e.document);
}
function ad(e, t) {
  if (e.stopped = !0, t.location) {
    const n = e.fragmentContext ? 0 : 2;
    for (let r = e.openElements.stackTop; r >= n; r--)
      e._setEndLocation(e.openElements.items[r], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const r = e.openElements.items[0], s = e.treeAdapter.getNodeSourceCodeLocation(r);
      if (s && !s.endTag && (e._setEndLocation(r, t), e.openElements.stackTop >= 1)) {
        const i = e.openElements.items[1], a = e.treeAdapter.getNodeSourceCodeLocation(i);
        a && !a.endTag && e._setEndLocation(i, t);
      }
    }
  }
}
function n4(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? Gt.QUIRKS : P6(t);
  R6(t) || e._err(t, j.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = w.BEFORE_HTML;
}
function Fs(e, t) {
  e._err(t, j.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, Gt.QUIRKS), e.insertionMode = w.BEFORE_HTML, e._processToken(t);
}
function r4(e, t) {
  t.tagID === f.HTML ? (e._insertElement(t, W.HTML), e.insertionMode = w.BEFORE_HEAD) : ei(e, t);
}
function s4(e, t) {
  const n = t.tagID;
  (n === f.HTML || n === f.HEAD || n === f.BODY || n === f.BR) && ei(e, t);
}
function ei(e, t) {
  e._insertFakeRootElement(), e.insertionMode = w.BEFORE_HEAD, e._processToken(t);
}
function i4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.HEAD: {
      e._insertElement(t, W.HTML), e.headElement = e.openElements.current, e.insertionMode = w.IN_HEAD;
      break;
    }
    default:
      ti(e, t);
  }
}
function a4(e, t) {
  const n = t.tagID;
  n === f.HEAD || n === f.BODY || n === f.HTML || n === f.BR ? ti(e, t) : e._err(t, j.endTagWithoutMatchingOpenElement);
}
function ti(e, t) {
  e._insertFakeElement(L.HEAD, f.HEAD), e.headElement = e.openElements.current, e.insertionMode = w.IN_HEAD, e._processToken(t);
}
function on(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.TITLE: {
      e._switchToTextParsing(t, tt.RCDATA);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, tt.RAWTEXT) : (e._insertElement(t, W.HTML), e.insertionMode = w.IN_HEAD_NO_SCRIPT);
      break;
    }
    case f.NOFRAMES:
    case f.STYLE: {
      e._switchToTextParsing(t, tt.RAWTEXT);
      break;
    }
    case f.SCRIPT: {
      e._switchToTextParsing(t, tt.SCRIPT_DATA);
      break;
    }
    case f.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = w.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(w.IN_TEMPLATE);
      break;
    }
    case f.HEAD: {
      e._err(t, j.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ni(e, t);
  }
}
function o4(e, t) {
  switch (t.tagID) {
    case f.HEAD: {
      e.openElements.pop(), e.insertionMode = w.AFTER_HEAD;
      break;
    }
    case f.BODY:
    case f.BR:
    case f.HTML: {
      ni(e, t);
      break;
    }
    case f.TEMPLATE: {
      Br(e, t);
      break;
    }
    default:
      e._err(t, j.endTagWithoutMatchingOpenElement);
  }
}
function Br(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== f.TEMPLATE && e._err(t, j.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, j.endTagWithoutMatchingOpenElement);
}
function ni(e, t) {
  e.openElements.pop(), e.insertionMode = w.AFTER_HEAD, e._processToken(t);
}
function u4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.BASEFONT:
    case f.BGSOUND:
    case f.HEAD:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.STYLE: {
      on(e, t);
      break;
    }
    case f.NOSCRIPT: {
      e._err(t, j.nestedNoscriptInHead);
      break;
    }
    default:
      ri(e, t);
  }
}
function c4(e, t) {
  switch (t.tagID) {
    case f.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = w.IN_HEAD;
      break;
    }
    case f.BR: {
      ri(e, t);
      break;
    }
    default:
      e._err(t, j.endTagWithoutMatchingOpenElement);
  }
}
function ri(e, t) {
  const n = t.type === Ne.EOF ? j.openElementsLeftAfterEof : j.disallowedContentInNoscriptInHead;
  e._err(t, n), e.openElements.pop(), e.insertionMode = w.IN_HEAD, e._processToken(t);
}
function l4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.BODY: {
      e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = w.IN_BODY;
      break;
    }
    case f.FRAMESET: {
      e._insertElement(t, W.HTML), e.insertionMode = w.IN_FRAMESET;
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      e._err(t, j.abandonedHeadElementChild), e.openElements.push(e.headElement, f.HEAD), on(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case f.HEAD: {
      e._err(t, j.misplacedStartTagForHeadElement);
      break;
    }
    default:
      si(e, t);
  }
}
function d4(e, t) {
  switch (t.tagID) {
    case f.BODY:
    case f.HTML:
    case f.BR: {
      si(e, t);
      break;
    }
    case f.TEMPLATE: {
      Br(e, t);
      break;
    }
    default:
      e._err(t, j.endTagWithoutMatchingOpenElement);
  }
}
function si(e, t) {
  e._insertFakeElement(L.BODY, f.BODY), e.insertionMode = w.IN_BODY, Ho(e, t);
}
function Ho(e, t) {
  switch (t.type) {
    case Ne.CHARACTER: {
      E_(e, t);
      break;
    }
    case Ne.WHITESPACE_CHARACTER: {
      g_(e, t);
      break;
    }
    case Ne.COMMENT: {
      Oc(e, t);
      break;
    }
    case Ne.START_TAG: {
      At(e, t);
      break;
    }
    case Ne.END_TAG: {
      Bo(e, t);
      break;
    }
    case Ne.EOF: {
      A_(e, t);
      break;
    }
  }
}
function g_(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function E_(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function h4(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function f4(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function p4(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, W.HTML), e.insertionMode = w.IN_FRAMESET);
}
function m4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML);
}
function g4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && Pc.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, W.HTML);
}
function E4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function b4(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), n || (e.formElement = e.openElements.current));
}
function _4(e, t) {
  e.framesetOk = !1;
  const n = t.tagID;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const s = e.openElements.tagIDs[r];
    if (n === f.LI && s === f.LI || (n === f.DD || n === f.DT) && (s === f.DD || s === f.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.popUntilTagNamePopped(s);
      break;
    }
    if (s !== f.ADDRESS && s !== f.DIV && s !== f.P && e._isSpecialElement(e.openElements.items[r], s))
      break;
  }
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML);
}
function T4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), e.tokenizer.state = tt.PLAINTEXT;
}
function A4(e, t) {
  e.openElements.hasInScope(f.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.framesetOk = !1;
}
function y4(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(L.A);
  n && (id(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function x4(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function C4(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(f.NOBR) && (id(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function S4(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function I4(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== Gt.QUIRKS && e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = w.IN_TABLE;
}
function b_(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, W.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function __(e) {
  const t = o_(e, yr.TYPE);
  return t != null && t.toLowerCase() === V6;
}
function w4(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, W.HTML), __(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function v4(e, t) {
  e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
}
function N4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._appendElement(t, W.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function k4(e, t) {
  t.tagName = L.IMG, t.tagID = f.IMG, b_(e, t);
}
function R4(e, t) {
  e._insertElement(t, W.HTML), e.skipNextNewLine = !0, e.tokenizer.state = tt.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = w.TEXT;
}
function P4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, tt.RAWTEXT);
}
function O4(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, tt.RAWTEXT);
}
function bp(e, t) {
  e._switchToTextParsing(t, tt.RAWTEXT);
}
function D4(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === w.IN_TABLE || e.insertionMode === w.IN_CAPTION || e.insertionMode === w.IN_TABLE_BODY || e.insertionMode === w.IN_ROW || e.insertionMode === w.IN_CELL ? w.IN_SELECT_IN_TABLE : w.IN_SELECT;
}
function L4(e, t) {
  e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML);
}
function M4(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, W.HTML);
}
function H4(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(f.RTC), e._insertElement(t, W.HTML);
}
function B4(e, t) {
  e._reconstructActiveFormattingElements(), f_(t), sd(t), t.selfClosing ? e._appendElement(t, W.MATHML) : e._insertElement(t, W.MATHML), t.ackSelfClosing = !0;
}
function U4(e, t) {
  e._reconstructActiveFormattingElements(), p_(t), sd(t), t.selfClosing ? e._appendElement(t, W.SVG) : e._insertElement(t, W.SVG), t.ackSelfClosing = !0;
}
function _p(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML);
}
function At(e, t) {
  switch (t.tagID) {
    case f.I:
    case f.S:
    case f.B:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      x4(e, t);
      break;
    }
    case f.A: {
      y4(e, t);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      g4(e, t);
      break;
    }
    case f.P:
    case f.DL:
    case f.OL:
    case f.UL:
    case f.DIV:
    case f.DIR:
    case f.NAV:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.DETAILS:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      m4(e, t);
      break;
    }
    case f.LI:
    case f.DD:
    case f.DT: {
      _4(e, t);
      break;
    }
    case f.BR:
    case f.IMG:
    case f.WBR:
    case f.AREA:
    case f.EMBED:
    case f.KEYGEN: {
      b_(e, t);
      break;
    }
    case f.HR: {
      N4(e, t);
      break;
    }
    case f.RB:
    case f.RTC: {
      M4(e, t);
      break;
    }
    case f.RT:
    case f.RP: {
      H4(e, t);
      break;
    }
    case f.PRE:
    case f.LISTING: {
      E4(e, t);
      break;
    }
    case f.XMP: {
      P4(e, t);
      break;
    }
    case f.SVG: {
      U4(e, t);
      break;
    }
    case f.HTML: {
      h4(e, t);
      break;
    }
    case f.BASE:
    case f.LINK:
    case f.META:
    case f.STYLE:
    case f.TITLE:
    case f.SCRIPT:
    case f.BGSOUND:
    case f.BASEFONT:
    case f.TEMPLATE: {
      on(e, t);
      break;
    }
    case f.BODY: {
      f4(e, t);
      break;
    }
    case f.FORM: {
      b4(e, t);
      break;
    }
    case f.NOBR: {
      C4(e, t);
      break;
    }
    case f.MATH: {
      B4(e, t);
      break;
    }
    case f.TABLE: {
      I4(e, t);
      break;
    }
    case f.INPUT: {
      w4(e, t);
      break;
    }
    case f.PARAM:
    case f.TRACK:
    case f.SOURCE: {
      v4(e, t);
      break;
    }
    case f.IMAGE: {
      k4(e, t);
      break;
    }
    case f.BUTTON: {
      A4(e, t);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      S4(e, t);
      break;
    }
    case f.IFRAME: {
      O4(e, t);
      break;
    }
    case f.SELECT: {
      D4(e, t);
      break;
    }
    case f.OPTION:
    case f.OPTGROUP: {
      L4(e, t);
      break;
    }
    case f.NOEMBED:
    case f.NOFRAMES: {
      bp(e, t);
      break;
    }
    case f.FRAMESET: {
      p4(e, t);
      break;
    }
    case f.TEXTAREA: {
      R4(e, t);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? bp(e, t) : _p(e, t);
      break;
    }
    case f.PLAINTEXT: {
      T4(e, t);
      break;
    }
    case f.COL:
    case f.TH:
    case f.TD:
    case f.TR:
    case f.HEAD:
    case f.FRAME:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.CAPTION:
    case f.COLGROUP:
      break;
    default:
      _p(e, t);
  }
}
function F4(e, t) {
  if (e.openElements.hasInScope(f.BODY) && (e.insertionMode = w.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e._setEndLocation(n, t);
  }
}
function j4(e, t) {
  e.openElements.hasInScope(f.BODY) && (e.insertionMode = w.AFTER_BODY, N_(e, t));
}
function $4(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function z4(e) {
  const t = e.openElements.tmplCount > 0, { formElement: n } = e;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(f.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(f.FORM) : n && e.openElements.remove(n));
}
function V4(e) {
  e.openElements.hasInButtonScope(f.P) || e._insertFakeElement(L.P, f.P), e._closePElement();
}
function Y4(e) {
  e.openElements.hasInListItemScope(f.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(f.LI), e.openElements.popUntilTagNamePopped(f.LI));
}
function G4(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function W4(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function q4(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function K4(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(L.BR, f.BR), e.openElements.pop(), e.framesetOk = !1;
}
function T_(e, t) {
  const n = t.tagName, r = t.tagID;
  for (let s = e.openElements.stackTop; s > 0; s--) {
    const i = e.openElements.items[s], a = e.openElements.tagIDs[s];
    if (r === a && (r !== f.UNKNOWN || e.treeAdapter.getTagName(i) === n)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.stackTop >= s && e.openElements.shortenToLength(s);
      break;
    }
    if (e._isSpecialElement(i, a))
      break;
  }
}
function Bo(e, t) {
  switch (t.tagID) {
    case f.A:
    case f.B:
    case f.I:
    case f.S:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.NOBR:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      id(e, t);
      break;
    }
    case f.P: {
      V4(e);
      break;
    }
    case f.DL:
    case f.UL:
    case f.OL:
    case f.DIR:
    case f.DIV:
    case f.NAV:
    case f.PRE:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.BUTTON:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.DETAILS:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.LISTING:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      $4(e, t);
      break;
    }
    case f.LI: {
      Y4(e);
      break;
    }
    case f.DD:
    case f.DT: {
      G4(e, t);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      W4(e);
      break;
    }
    case f.BR: {
      K4(e);
      break;
    }
    case f.BODY: {
      F4(e, t);
      break;
    }
    case f.HTML: {
      j4(e, t);
      break;
    }
    case f.FORM: {
      z4(e);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      q4(e, t);
      break;
    }
    case f.TEMPLATE: {
      Br(e, t);
      break;
    }
    default:
      T_(e, t);
  }
}
function A_(e, t) {
  e.tmplInsertionModeStack.length > 0 ? v_(e, t) : ad(e, t);
}
function Q4(e, t) {
  var n;
  t.tagID === f.SCRIPT && ((n = e.scriptHandler) === null || n === void 0 || n.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function X4(e, t) {
  e._err(t, j.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function Bu(e, t) {
  if (e.openElements.currentTagId !== void 0 && m_.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = w.IN_TABLE_TEXT, t.type) {
      case Ne.CHARACTER: {
        x_(e, t);
        break;
      }
      case Ne.WHITESPACE_CHARACTER: {
        y_(e, t);
        break;
      }
    }
  else
    Oi(e, t);
}
function J4(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, W.HTML), e.insertionMode = w.IN_CAPTION;
}
function Z4(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, W.HTML), e.insertionMode = w.IN_COLUMN_GROUP;
}
function e5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(L.COLGROUP, f.COLGROUP), e.insertionMode = w.IN_COLUMN_GROUP, od(e, t);
}
function t5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, W.HTML), e.insertionMode = w.IN_TABLE_BODY;
}
function n5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(L.TBODY, f.TBODY), e.insertionMode = w.IN_TABLE_BODY, Uo(e, t);
}
function r5(e, t) {
  e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function s5(e, t) {
  __(t) ? e._appendElement(t, W.HTML) : Oi(e, t), t.ackSelfClosing = !0;
}
function i5(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, W.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function fs(e, t) {
  switch (t.tagID) {
    case f.TD:
    case f.TH:
    case f.TR: {
      n5(e, t);
      break;
    }
    case f.STYLE:
    case f.SCRIPT:
    case f.TEMPLATE: {
      on(e, t);
      break;
    }
    case f.COL: {
      e5(e, t);
      break;
    }
    case f.FORM: {
      i5(e, t);
      break;
    }
    case f.TABLE: {
      r5(e, t);
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      t5(e, t);
      break;
    }
    case f.INPUT: {
      s5(e, t);
      break;
    }
    case f.CAPTION: {
      J4(e, t);
      break;
    }
    case f.COLGROUP: {
      Z4(e, t);
      break;
    }
    default:
      Oi(e, t);
  }
}
function pi(e, t) {
  switch (t.tagID) {
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      Br(e, t);
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      Oi(e, t);
  }
}
function Oi(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Ho(e, t), e.fosterParentingEnabled = n;
}
function y_(e, t) {
  e.pendingCharacterTokens.push(t);
}
function x_(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function js(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      Oi(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const C_ = /* @__PURE__ */ new Set([f.CAPTION, f.COL, f.COLGROUP, f.TBODY, f.TD, f.TFOOT, f.TH, f.THEAD, f.TR]);
function a5(e, t) {
  const n = t.tagID;
  C_.has(n) ? e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = w.IN_TABLE, fs(e, t)) : At(e, t);
}
function o5(e, t) {
  const n = t.tagID;
  switch (n) {
    case f.CAPTION:
    case f.TABLE: {
      e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = w.IN_TABLE, n === f.TABLE && pi(e, t));
      break;
    }
    case f.BODY:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      Bo(e, t);
  }
}
function od(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.COL: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.TEMPLATE: {
      on(e, t);
      break;
    }
    default:
      za(e, t);
  }
}
function u5(e, t) {
  switch (t.tagID) {
    case f.COLGROUP: {
      e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = w.IN_TABLE);
      break;
    }
    case f.TEMPLATE: {
      Br(e, t);
      break;
    }
    case f.COL:
      break;
    default:
      za(e, t);
  }
}
function za(e, t) {
  e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = w.IN_TABLE, e._processToken(t));
}
function Uo(e, t) {
  switch (t.tagID) {
    case f.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, W.HTML), e.insertionMode = w.IN_ROW;
      break;
    }
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(L.TR, f.TR), e.insertionMode = w.IN_ROW, Fo(e, t);
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE, fs(e, t));
      break;
    }
    default:
      fs(e, t);
  }
}
function Dc(e, t) {
  const n = t.tagID;
  switch (t.tagID) {
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE);
      break;
    }
    case f.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE, pi(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
    case f.TR:
      break;
    default:
      pi(e, t);
  }
}
function Fo(e, t) {
  switch (t.tagID) {
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, W.HTML), e.insertionMode = w.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE_BODY, Uo(e, t));
      break;
    }
    default:
      fs(e, t);
  }
}
function S_(e, t) {
  switch (t.tagID) {
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE_BODY);
      break;
    }
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE_BODY, Dc(e, t));
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(f.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = w.IN_TABLE_BODY, Dc(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
      break;
    default:
      pi(e, t);
  }
}
function c5(e, t) {
  const n = t.tagID;
  C_.has(n) ? (e.openElements.hasInTableScope(f.TD) || e.openElements.hasInTableScope(f.TH)) && (e._closeTableCell(), Fo(e, t)) : At(e, t);
}
function l5(e, t) {
  const n = t.tagID;
  switch (n) {
    case f.TD:
    case f.TH: {
      e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = w.IN_ROW);
      break;
    }
    case f.TABLE:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(n) && (e._closeTableCell(), S_(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
      break;
    default:
      Bo(e, t);
  }
}
function I_(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._insertElement(t, W.HTML);
      break;
    }
    case f.OPTGROUP: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._insertElement(t, W.HTML);
      break;
    }
    case f.HR: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.INPUT:
    case f.KEYGEN:
    case f.TEXTAREA:
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), t.tagID !== f.SELECT && e._processStartTag(t));
      break;
    }
    case f.SCRIPT:
    case f.TEMPLATE: {
      on(e, t);
      break;
    }
  }
}
function w_(e, t) {
  switch (t.tagID) {
    case f.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === f.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === f.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop();
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop();
      break;
    }
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      Br(e, t);
      break;
    }
  }
}
function d5(e, t) {
  const n = t.tagID;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : I_(e, t);
}
function h5(e, t) {
  const n = t.tagID;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : w_(e, t);
}
function f5(e, t) {
  switch (t.tagID) {
    // First, handle tags that can start without a mode change
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      on(e, t);
      break;
    }
    // Re-process the token in the appropriate mode
    case f.CAPTION:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.tmplInsertionModeStack[0] = w.IN_TABLE, e.insertionMode = w.IN_TABLE, fs(e, t);
      break;
    }
    case f.COL: {
      e.tmplInsertionModeStack[0] = w.IN_COLUMN_GROUP, e.insertionMode = w.IN_COLUMN_GROUP, od(e, t);
      break;
    }
    case f.TR: {
      e.tmplInsertionModeStack[0] = w.IN_TABLE_BODY, e.insertionMode = w.IN_TABLE_BODY, Uo(e, t);
      break;
    }
    case f.TD:
    case f.TH: {
      e.tmplInsertionModeStack[0] = w.IN_ROW, e.insertionMode = w.IN_ROW, Fo(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = w.IN_BODY, e.insertionMode = w.IN_BODY, At(e, t);
  }
}
function p5(e, t) {
  t.tagID === f.TEMPLATE && Br(e, t);
}
function v_(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : ad(e, t);
}
function m5(e, t) {
  t.tagID === f.HTML ? At(e, t) : Va(e, t);
}
function N_(e, t) {
  var n;
  if (t.tagID === f.HTML) {
    if (e.fragmentContext || (e.insertionMode = w.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === f.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const r = e.openElements.items[1];
      r && !(!((n = e.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && e._setEndLocation(r, t);
    }
  } else
    Va(e, t);
}
function Va(e, t) {
  e.insertionMode = w.IN_BODY, Ho(e, t);
}
function g5(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.FRAMESET: {
      e._insertElement(t, W.HTML);
      break;
    }
    case f.FRAME: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.NOFRAMES: {
      on(e, t);
      break;
    }
  }
}
function E5(e, t) {
  t.tagID === f.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== f.FRAMESET && (e.insertionMode = w.AFTER_FRAMESET));
}
function b5(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.NOFRAMES: {
      on(e, t);
      break;
    }
  }
}
function _5(e, t) {
  t.tagID === f.HTML && (e.insertionMode = w.AFTER_AFTER_FRAMESET);
}
function T5(e, t) {
  t.tagID === f.HTML ? At(e, t) : Ea(e, t);
}
function Ea(e, t) {
  e.insertionMode = w.IN_BODY, Ho(e, t);
}
function A5(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      At(e, t);
      break;
    }
    case f.NOFRAMES: {
      on(e, t);
      break;
    }
  }
}
function y5(e, t) {
  t.chars = Xe, e._insertCharacters(t);
}
function x5(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function k_(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== W.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function C5(e, t) {
  if (U6(t))
    k_(e), e._startTagOutsideForeignContent(t);
  else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === W.MATHML ? f_(t) : r === W.SVG && (F6(t), p_(t)), sd(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function S5(e, t) {
  if (t.tagID === f.P || t.tagID === f.BR) {
    k_(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === W.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const s = e.treeAdapter.getTagName(r);
    if (s.toLowerCase() === t.tagName) {
      t.tagName = s, e.openElements.shortenToLength(n);
      break;
    }
  }
}
L.AREA, L.BASE, L.BASEFONT, L.BGSOUND, L.BR, L.COL, L.EMBED, L.FRAME, L.HR, L.IMG, L.INPUT, L.KEYGEN, L.LINK, L.META, L.PARAM, L.SOURCE, L.TRACK, L.WBR;
const I5 = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, w5 = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), Tp = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function R_(e, t) {
  const n = H5(e), r = n_("type", {
    handlers: { root: v5, element: N5, text: k5, comment: O_, doctype: R5, raw: O5 },
    unknown: D5
  }), s = {
    parser: n ? new Ep(Tp) : Ep.getFragmentParser(void 0, Tp),
    handle(o) {
      r(o, s);
    },
    stitches: !1,
    options: t || {}
  };
  r(e, s), Cs(s, _n());
  const i = n ? s.parser.document : s.parser.getFragment(), a = BM(i, {
    // To do: support `space`?
    file: s.options.file
  });
  return s.stitches && Mo(a, "comment", function(o, u, c) {
    const l = (
      /** @type {Stitch} */
      /** @type {unknown} */
      o
    );
    if (l.value.stitch && c && u !== void 0) {
      const h = c.children;
      return h[u] = l.value.stitch, u;
    }
  }), a.type === "root" && a.children.length === 1 && a.children[0].type === e.type ? a.children[0] : a;
}
function P_(e, t) {
  let n = -1;
  if (e)
    for (; ++n < e.length; )
      t.handle(e[n]);
}
function v5(e, t) {
  P_(e.children, t);
}
function N5(e, t) {
  L5(e, t), P_(e.children, t), M5(e, t);
}
function k5(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const n = {
    type: Ne.CHARACTER,
    chars: e.value,
    location: Di(e)
  };
  Cs(t, _n(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function R5(e, t) {
  const n = {
    type: Ne.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: Di(e)
  };
  Cs(t, _n(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function P5(e, t) {
  t.stitches = !0;
  const n = B5(e);
  if ("children" in e && "children" in n) {
    const r = (
      /** @type {Root} */
      R_({ type: "root", children: e.children }, t.options)
    );
    n.children = r.children;
  }
  O_({ type: "comment", value: { stitch: n } }, t);
}
function O_(e, t) {
  const n = e.value, r = {
    type: Ne.COMMENT,
    data: n,
    location: Di(e)
  };
  Cs(t, _n(e)), t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken);
}
function O5(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, D_(t, _n(e)), t.parser.tokenizer.write(
    t.options.tagfilter ? e.value.replace(I5, "&lt;$1$2") : e.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(n);
  }
}
function D5(e, t) {
  const n = (
    /** @type {Nodes} */
    e
  );
  if (t.options.passThrough && t.options.passThrough.includes(n.type))
    P5(n, t);
  else {
    let r = "";
    throw w5.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + n.type + "` node" + r);
  }
}
function Cs(e, t) {
  D_(e, t);
  const n = e.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = e.parser.tokenizer.preprocessor.line, n.location.endCol = e.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = tt.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function D_(e, t) {
  if (t && t.offset !== void 0) {
    const n = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = n;
  }
}
function L5(e, t) {
  const n = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === tt.PLAINTEXT) return;
  Cs(t, _n(e));
  const r = t.parser.openElements.current;
  let s = "namespaceURI" in r ? r.namespaceURI : _r.html;
  s === _r.html && n === "svg" && (s = _r.svg);
  const i = zM(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: s === _r.svg ? "svg" : "html" }
  ), a = {
    type: Ne.START_TAG,
    tagName: n,
    tagID: xs(n),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in i ? i.attrs : [],
    location: Di(e)
  };
  t.parser.currentToken = a, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = n;
}
function M5(e, t) {
  const n = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && XM.includes(n) || t.parser.tokenizer.state === tt.PLAINTEXT) return;
  Cs(t, ko(e));
  const r = {
    type: Ne.END_TAG,
    tagName: n,
    tagID: xs(n),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: Di(e)
  };
  t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  n === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === tt.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === tt.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === tt.SCRIPT_DATA) && (t.parser.tokenizer.state = tt.DATA);
}
function H5(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function Di(e) {
  const t = _n(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, n = ko(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function B5(e) {
  return "children" in e ? hs({ ...e, children: [] }) : hs(e);
}
function L_(e) {
  return function(t, n) {
    return (
      /** @type {Root} */
      R_(t, { ...e, file: n })
    );
  };
}
function Ap(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, s = n.indexOf(t);
  for (; s !== -1; )
    r++, s = n.indexOf(t, s + t.length);
  return r;
}
function U5(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function F5(e, t, n) {
  const s = Do((n || {}).ignore || []), i = j5(t);
  let a = -1;
  for (; ++a < i.length; )
    Wb(e, "text", o);
  function o(c, l) {
    let h = -1, m;
    for (; ++h < l.length; ) {
      const p = l[h], E = m ? m.children : void 0;
      if (s(
        p,
        E ? E.indexOf(p) : void 0,
        m
      ))
        return;
      m = p;
    }
    if (m)
      return u(c, l);
  }
  function u(c, l) {
    const h = l[l.length - 1], m = i[a][0], p = i[a][1];
    let E = 0;
    const _ = h.children.indexOf(c);
    let b = !1, T = [];
    m.lastIndex = 0;
    let C = m.exec(c.value);
    for (; C; ) {
      const R = C.index, D = {
        index: C.index,
        input: C.input,
        stack: [...l, c]
      };
      let I = p(...C, D);
      if (typeof I == "string" && (I = I.length > 0 ? { type: "text", value: I } : void 0), I === !1 ? m.lastIndex = R + 1 : (E !== R && T.push({
        type: "text",
        value: c.value.slice(E, R)
      }), Array.isArray(I) ? T.push(...I) : I && T.push(I), E = R + C[0].length, b = !0), !m.global)
        break;
      C = m.exec(c.value);
    }
    return b ? (E < c.value.length && T.push({ type: "text", value: c.value.slice(E) }), h.children.splice(_, 1, ...T)) : T = [c], _ + T.length;
  }
}
function j5(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const s = n[r];
    t.push([$5(s[0]), z5(s[1])]);
  }
  return t;
}
function $5(e) {
  return typeof e == "string" ? new RegExp(U5(e), "g") : e;
}
function z5(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const Uu = "phrasing", Fu = ["autolink", "link", "image", "label"];
function V5() {
  return {
    transforms: [X5],
    enter: {
      literalAutolink: G5,
      literalAutolinkEmail: ju,
      literalAutolinkHttp: ju,
      literalAutolinkWww: ju
    },
    exit: {
      literalAutolink: Q5,
      literalAutolinkEmail: K5,
      literalAutolinkHttp: W5,
      literalAutolinkWww: q5
    }
  };
}
function Y5() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: Uu,
        notInConstruct: Fu
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: Uu,
        notInConstruct: Fu
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: Uu,
        notInConstruct: Fu
      }
    ]
  };
}
function G5(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function ju(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function W5(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function q5(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function K5(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function Q5(e) {
  this.exit(e);
}
function X5(e) {
  F5(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, J5],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, Z5]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function J5(e, t, n, r, s) {
  let i = "";
  if (!M_(s) || (/^w/i.test(t) && (n = t + n, t = "", i = "http://"), !e8(n)))
    return !1;
  const a = t8(n + r);
  if (!a[0]) return !1;
  const o = {
    type: "link",
    title: null,
    url: i + t + a[0],
    children: [{ type: "text", value: t + a[0] }]
  };
  return a[1] ? [o, { type: "text", value: a[1] }] : o;
}
function Z5(e, t, n, r) {
  return (
    // Not an expected previous character.
    !M_(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function e8(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function t8(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const s = Ap(e, "(");
  let i = Ap(e, ")");
  for (; r !== -1 && s > i; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), i++;
  return [e, n];
}
function M_(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || kr(n) || Ro(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
H_.peek = l8;
function n8() {
  this.buffer();
}
function r8(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function s8() {
  this.buffer();
}
function i8(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function a8(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = en(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function o8(e) {
  this.exit(e);
}
function u8(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = en(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function c8(e) {
  this.exit(e);
}
function l8() {
  return "[";
}
function H_(e, t, n, r) {
  const s = n.createTracker(r);
  let i = s.move("[^");
  const a = n.enter("footnoteReference"), o = n.enter("reference");
  return i += s.move(
    n.safe(n.associationId(e), { after: "]", before: i })
  ), o(), a(), i += s.move("]"), i;
}
function d8() {
  return {
    enter: {
      gfmFootnoteCallString: n8,
      gfmFootnoteCall: r8,
      gfmFootnoteDefinitionLabelString: s8,
      gfmFootnoteDefinition: i8
    },
    exit: {
      gfmFootnoteCallString: a8,
      gfmFootnoteCall: o8,
      gfmFootnoteDefinitionLabelString: u8,
      gfmFootnoteDefinition: c8
    }
  };
}
function h8(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: H_ },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(r, s, i, a) {
    const o = i.createTracker(a);
    let u = o.move("[^");
    const c = i.enter("footnoteDefinition"), l = i.enter("label");
    return u += o.move(
      i.safe(i.associationId(r), { before: u, after: "]" })
    ), l(), u += o.move("]:"), r.children && r.children.length > 0 && (o.shift(4), u += o.move(
      (t ? `
` : " ") + i.indentLines(
        i.containerFlow(r, o.current()),
        t ? B_ : f8
      )
    )), c(), u;
  }
}
function f8(e, t, n) {
  return t === 0 ? e : B_(e, t, n);
}
function B_(e, t, n) {
  return (n ? "" : "    ") + e;
}
const p8 = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
U_.peek = _8;
function m8() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: E8 },
    exit: { strikethrough: b8 }
  };
}
function g8() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: p8
      }
    ],
    handlers: { delete: U_ }
  };
}
function E8(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function b8(e) {
  this.exit(e);
}
function U_(e, t, n, r) {
  const s = n.createTracker(r), i = n.enter("strikethrough");
  let a = s.move("~~");
  return a += n.containerPhrasing(e, {
    ...s.current(),
    before: a,
    after: "~"
  }), a += s.move("~~"), i(), a;
}
function _8() {
  return "~";
}
function T8(e) {
  return e.length;
}
function A8(e, t) {
  const n = t || {}, r = (n.align || []).concat(), s = n.stringLength || T8, i = [], a = [], o = [], u = [];
  let c = 0, l = -1;
  for (; ++l < e.length; ) {
    const g = [], _ = [];
    let b = -1;
    for (e[l].length > c && (c = e[l].length); ++b < e[l].length; ) {
      const T = y8(e[l][b]);
      if (n.alignDelimiters !== !1) {
        const C = s(T);
        _[b] = C, (u[b] === void 0 || C > u[b]) && (u[b] = C);
      }
      g.push(T);
    }
    a[l] = g, o[l] = _;
  }
  let h = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++h < c; )
      i[h] = yp(r[h]);
  else {
    const g = yp(r);
    for (; ++h < c; )
      i[h] = g;
  }
  h = -1;
  const m = [], p = [];
  for (; ++h < c; ) {
    const g = i[h];
    let _ = "", b = "";
    g === 99 ? (_ = ":", b = ":") : g === 108 ? _ = ":" : g === 114 && (b = ":");
    let T = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[h] - _.length - b.length
    );
    const C = _ + "-".repeat(T) + b;
    n.alignDelimiters !== !1 && (T = _.length + T + b.length, T > u[h] && (u[h] = T), p[h] = T), m[h] = C;
  }
  a.splice(1, 0, m), o.splice(1, 0, p), l = -1;
  const E = [];
  for (; ++l < a.length; ) {
    const g = a[l], _ = o[l];
    h = -1;
    const b = [];
    for (; ++h < c; ) {
      const T = g[h] || "";
      let C = "", R = "";
      if (n.alignDelimiters !== !1) {
        const D = u[h] - (_[h] || 0), I = i[h];
        I === 114 ? C = " ".repeat(D) : I === 99 ? D % 2 ? (C = " ".repeat(D / 2 + 0.5), R = " ".repeat(D / 2 - 0.5)) : (C = " ".repeat(D / 2), R = C) : R = " ".repeat(D);
      }
      n.delimiterStart !== !1 && !h && b.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && T === "") && (n.delimiterStart !== !1 || h) && b.push(" "), n.alignDelimiters !== !1 && b.push(C), b.push(T), n.alignDelimiters !== !1 && b.push(R), n.padding !== !1 && b.push(" "), (n.delimiterEnd !== !1 || h !== c - 1) && b.push("|");
    }
    E.push(
      n.delimiterEnd === !1 ? b.join("").replace(/ +$/, "") : b.join("")
    );
  }
  return E.join(`
`);
}
function y8(e) {
  return e == null ? "" : String(e);
}
function yp(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function x8(e, t, n, r) {
  const s = n.enter("blockquote"), i = n.createTracker(r);
  i.move("> "), i.shift(2);
  const a = n.indentLines(
    n.containerFlow(e, i.current()),
    C8
  );
  return s(), a;
}
function C8(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function S8(e, t) {
  return xp(e, t.inConstruct, !0) && !xp(e, t.notInConstruct, !1);
}
function xp(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Cp(e, t, n, r) {
  let s = -1;
  for (; ++s < n.unsafe.length; )
    if (n.unsafe[s].character === `
` && S8(n.stack, n.unsafe[s]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function I8(e, t) {
  const n = String(e);
  let r = n.indexOf(t), s = r, i = 0, a = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === s ? ++i > a && (a = i) : i = 1, s = r + t.length, r = n.indexOf(t, s);
  return a;
}
function w8(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function v8(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function N8(e, t, n, r) {
  const s = v8(n), i = e.value || "", a = s === "`" ? "GraveAccent" : "Tilde";
  if (w8(e, n)) {
    const h = n.enter("codeIndented"), m = n.indentLines(i, k8);
    return h(), m;
  }
  const o = n.createTracker(r), u = s.repeat(Math.max(I8(i, s) + 1, 3)), c = n.enter("codeFenced");
  let l = o.move(u);
  if (e.lang) {
    const h = n.enter(`codeFencedLang${a}`);
    l += o.move(
      n.safe(e.lang, {
        before: l,
        after: " ",
        encode: ["`"],
        ...o.current()
      })
    ), h();
  }
  if (e.lang && e.meta) {
    const h = n.enter(`codeFencedMeta${a}`);
    l += o.move(" "), l += o.move(
      n.safe(e.meta, {
        before: l,
        after: `
`,
        encode: ["`"],
        ...o.current()
      })
    ), h();
  }
  return l += o.move(`
`), i && (l += o.move(i + `
`)), l += o.move(u), c(), l;
}
function k8(e, t, n) {
  return (n ? "" : "    ") + e;
}
function ud(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function R8(e, t, n, r) {
  const s = ud(n), i = s === '"' ? "Quote" : "Apostrophe", a = n.enter("definition");
  let o = n.enter("label");
  const u = n.createTracker(r);
  let c = u.move("[");
  return c += u.move(
    n.safe(n.associationId(e), {
      before: c,
      after: "]",
      ...u.current()
    })
  ), c += u.move("]: "), o(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (o = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), o(), e.title && (o = n.enter(`title${i}`), c += u.move(" " + s), c += u.move(
    n.safe(e.title, {
      before: c,
      after: s,
      ...u.current()
    })
  ), c += u.move(s), o()), a(), c;
}
function P8(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function mi(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function Ya(e, t, n) {
  const r = ds(e), s = ds(t);
  return r === void 0 ? s === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
F_.peek = O8;
function F_(e, t, n, r) {
  const s = P8(n), i = n.enter("emphasis"), a = n.createTracker(r), o = a.move(s);
  let u = a.move(
    n.containerPhrasing(e, {
      after: s,
      before: o,
      ...a.current()
    })
  );
  const c = u.charCodeAt(0), l = Ya(
    r.before.charCodeAt(r.before.length - 1),
    c,
    s
  );
  l.inside && (u = mi(c) + u.slice(1));
  const h = u.charCodeAt(u.length - 1), m = Ya(r.after.charCodeAt(0), h, s);
  m.inside && (u = u.slice(0, -1) + mi(h));
  const p = a.move(s);
  return i(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: l.outside
  }, o + u + p;
}
function O8(e, t, n) {
  return n.options.emphasis || "*";
}
function D8(e, t) {
  let n = !1;
  return Mo(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, Ic;
  }), !!((!e.depth || e.depth < 3) && Yl(e) && (t.options.setext || n));
}
function L8(e, t, n, r) {
  const s = Math.max(Math.min(6, e.depth || 1), 1), i = n.createTracker(r);
  if (D8(e, n)) {
    const l = n.enter("headingSetext"), h = n.enter("phrasing"), m = n.containerPhrasing(e, {
      ...i.current(),
      before: `
`,
      after: `
`
    });
    return h(), l(), m + `
` + (s === 1 ? "=" : "-").repeat(
      // The whole size…
      m.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(m.lastIndexOf("\r"), m.lastIndexOf(`
`)) + 1)
    );
  }
  const a = "#".repeat(s), o = n.enter("headingAtx"), u = n.enter("phrasing");
  i.move(a + " ");
  let c = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...i.current()
  });
  return /^[\t ]/.test(c) && (c = mi(c.charCodeAt(0)) + c.slice(1)), c = c ? a + " " + c : a, n.options.closeAtx && (c += " " + a), u(), o(), c;
}
j_.peek = M8;
function j_(e) {
  return e.value || "";
}
function M8() {
  return "<";
}
$_.peek = H8;
function $_(e, t, n, r) {
  const s = ud(n), i = s === '"' ? "Quote" : "Apostrophe", a = n.enter("image");
  let o = n.enter("label");
  const u = n.createTracker(r);
  let c = u.move("![");
  return c += u.move(
    n.safe(e.alt, { before: c, after: "]", ...u.current() })
  ), c += u.move("]("), o(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (o = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), o(), e.title && (o = n.enter(`title${i}`), c += u.move(" " + s), c += u.move(
    n.safe(e.title, {
      before: c,
      after: s,
      ...u.current()
    })
  ), c += u.move(s), o()), c += u.move(")"), a(), c;
}
function H8() {
  return "!";
}
z_.peek = B8;
function z_(e, t, n, r) {
  const s = e.referenceType, i = n.enter("imageReference");
  let a = n.enter("label");
  const o = n.createTracker(r);
  let u = o.move("![");
  const c = n.safe(e.alt, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(c + "]["), a();
  const l = n.stack;
  n.stack = [], a = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return a(), n.stack = l, i(), s === "full" || !c || c !== h ? u += o.move(h + "]") : s === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function B8() {
  return "!";
}
V_.peek = U8;
function V_(e, t, n) {
  let r = e.value || "", s = "`", i = -1;
  for (; new RegExp("(^|[^`])" + s + "([^`]|$)").test(r); )
    s += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++i < n.unsafe.length; ) {
    const a = n.unsafe[i], o = n.compilePattern(a);
    let u;
    if (a.atBreak)
      for (; u = o.exec(r); ) {
        let c = u.index;
        r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(u.index + 1);
      }
  }
  return s + r + s;
}
function U8() {
  return "`";
}
function Y_(e, t) {
  const n = Yl(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
G_.peek = F8;
function G_(e, t, n, r) {
  const s = ud(n), i = s === '"' ? "Quote" : "Apostrophe", a = n.createTracker(r);
  let o, u;
  if (Y_(e, n)) {
    const l = n.stack;
    n.stack = [], o = n.enter("autolink");
    let h = a.move("<");
    return h += a.move(
      n.containerPhrasing(e, {
        before: h,
        after: ">",
        ...a.current()
      })
    ), h += a.move(">"), o(), n.stack = l, h;
  }
  o = n.enter("link"), u = n.enter("label");
  let c = a.move("[");
  return c += a.move(
    n.containerPhrasing(e, {
      before: c,
      after: "](",
      ...a.current()
    })
  ), c += a.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), c += a.move("<"), c += a.move(
    n.safe(e.url, { before: c, after: ">", ...a.current() })
  ), c += a.move(">")) : (u = n.enter("destinationRaw"), c += a.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...a.current()
    })
  )), u(), e.title && (u = n.enter(`title${i}`), c += a.move(" " + s), c += a.move(
    n.safe(e.title, {
      before: c,
      after: s,
      ...a.current()
    })
  ), c += a.move(s), u()), c += a.move(")"), o(), c;
}
function F8(e, t, n) {
  return Y_(e, n) ? "<" : "[";
}
W_.peek = j8;
function W_(e, t, n, r) {
  const s = e.referenceType, i = n.enter("linkReference");
  let a = n.enter("label");
  const o = n.createTracker(r);
  let u = o.move("[");
  const c = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(c + "]["), a();
  const l = n.stack;
  n.stack = [], a = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return a(), n.stack = l, i(), s === "full" || !c || c !== h ? u += o.move(h + "]") : s === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function j8() {
  return "[";
}
function cd(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function $8(e) {
  const t = cd(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function z8(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function q_(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function V8(e, t, n, r) {
  const s = n.enter("list"), i = n.bulletCurrent;
  let a = e.ordered ? z8(n) : cd(n);
  const o = e.ordered ? a === "." ? ")" : "." : $8(n);
  let u = t && n.bulletLastUsed ? a === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const l = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (a === "*" || a === "-") && // Empty first list item:
      l && (!l.children || !l.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), q_(n) === a && l
    ) {
      let h = -1;
      for (; ++h < e.children.length; ) {
        const m = e.children[h];
        if (m && m.type === "listItem" && m.children && m.children[0] && m.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (a = o), n.bulletCurrent = a;
  const c = n.containerFlow(e, r);
  return n.bulletLastUsed = a, n.bulletCurrent = i, s(), c;
}
function Y8(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function G8(e, t, n, r) {
  const s = Y8(n);
  let i = n.bulletCurrent || cd(n);
  t && t.type === "list" && t.ordered && (i = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + i);
  let a = i.length + 1;
  (s === "tab" || s === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4);
  const o = n.createTracker(r);
  o.move(i + " ".repeat(a - i.length)), o.shift(a);
  const u = n.enter("listItem"), c = n.indentLines(
    n.containerFlow(e, o.current()),
    l
  );
  return u(), c;
  function l(h, m, p) {
    return m ? (p ? "" : " ".repeat(a)) + h : (p ? i : i + " ".repeat(a - i.length)) + h;
  }
}
function W8(e, t, n, r) {
  const s = n.enter("paragraph"), i = n.enter("phrasing"), a = n.containerPhrasing(e, r);
  return i(), s(), a;
}
const q8 = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  Do([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function K8(e, t, n, r) {
  return (e.children.some(function(a) {
    return q8(a);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function Q8(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
K_.peek = X8;
function K_(e, t, n, r) {
  const s = Q8(n), i = n.enter("strong"), a = n.createTracker(r), o = a.move(s + s);
  let u = a.move(
    n.containerPhrasing(e, {
      after: s,
      before: o,
      ...a.current()
    })
  );
  const c = u.charCodeAt(0), l = Ya(
    r.before.charCodeAt(r.before.length - 1),
    c,
    s
  );
  l.inside && (u = mi(c) + u.slice(1));
  const h = u.charCodeAt(u.length - 1), m = Ya(r.after.charCodeAt(0), h, s);
  m.inside && (u = u.slice(0, -1) + mi(h));
  const p = a.move(s + s);
  return i(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: l.outside
  }, o + u + p;
}
function X8(e, t, n) {
  return n.options.strong || "*";
}
function J8(e, t, n, r) {
  return n.safe(e.value, r);
}
function Z8(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function eH(e, t, n) {
  const r = (q_(n) + (n.options.ruleSpaces ? " " : "")).repeat(Z8(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const Q_ = {
  blockquote: x8,
  break: Cp,
  code: N8,
  definition: R8,
  emphasis: F_,
  hardBreak: Cp,
  heading: L8,
  html: j_,
  image: $_,
  imageReference: z_,
  inlineCode: V_,
  link: G_,
  linkReference: W_,
  list: V8,
  listItem: G8,
  paragraph: W8,
  root: K8,
  strong: K_,
  text: J8,
  thematicBreak: eH
};
function tH() {
  return {
    enter: {
      table: nH,
      tableData: Sp,
      tableHeader: Sp,
      tableRow: sH
    },
    exit: {
      codeText: iH,
      table: rH,
      tableData: $u,
      tableHeader: $u,
      tableRow: $u
    }
  };
}
function nH(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function rH(e) {
  this.exit(e), this.data.inTable = void 0;
}
function sH(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function $u(e) {
  this.exit(e);
}
function Sp(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function iH(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, aH));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function aH(e, t) {
  return t === "|" ? t : e;
}
function oH(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, s = t.stringLength, i = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: m,
      table: a,
      tableCell: u,
      tableRow: o
    }
  };
  function a(p, E, g, _) {
    return c(l(p, g, _), p.align);
  }
  function o(p, E, g, _) {
    const b = h(p, g, _), T = c([b]);
    return T.slice(0, T.indexOf(`
`));
  }
  function u(p, E, g, _) {
    const b = g.enter("tableCell"), T = g.enter("phrasing"), C = g.containerPhrasing(p, {
      ..._,
      before: i,
      after: i
    });
    return T(), b(), C;
  }
  function c(p, E) {
    return A8(p, {
      align: E,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: s
    });
  }
  function l(p, E, g) {
    const _ = p.children;
    let b = -1;
    const T = [], C = E.enter("table");
    for (; ++b < _.length; )
      T[b] = h(_[b], E, g);
    return C(), T;
  }
  function h(p, E, g) {
    const _ = p.children;
    let b = -1;
    const T = [], C = E.enter("tableRow");
    for (; ++b < _.length; )
      T[b] = u(_[b], p, E, g);
    return C(), T;
  }
  function m(p, E, g) {
    let _ = Q_.inlineCode(p, E, g);
    return g.stack.includes("tableCell") && (_ = _.replace(/\|/g, "\\$&")), _;
  }
}
function uH() {
  return {
    exit: {
      taskListCheckValueChecked: Ip,
      taskListCheckValueUnchecked: Ip,
      paragraph: lH
    }
  };
}
function cH() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: dH }
  };
}
function Ip(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function lH(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const s = t.children;
      let i = -1, a;
      for (; ++i < s.length; ) {
        const o = s[i];
        if (o.type === "paragraph") {
          a = o;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function dH(e, t, n, r) {
  const s = e.children[0], i = typeof e.checked == "boolean" && s && s.type === "paragraph", a = "[" + (e.checked ? "x" : " ") + "] ", o = n.createTracker(r);
  i && o.move(a);
  let u = Q_.listItem(e, t, n, {
    ...r,
    ...o.current()
  });
  return i && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), u;
  function c(l) {
    return l + a;
  }
}
function hH() {
  return [
    V5(),
    d8(),
    m8(),
    tH(),
    uH()
  ];
}
function fH(e) {
  return {
    extensions: [
      Y5(),
      h8(e),
      g8(),
      oH(e),
      cH()
    ]
  };
}
const pH = {
  tokenize: TH,
  partial: !0
}, X_ = {
  tokenize: AH,
  partial: !0
}, J_ = {
  tokenize: yH,
  partial: !0
}, Z_ = {
  tokenize: xH,
  partial: !0
}, mH = {
  tokenize: CH,
  partial: !0
}, eT = {
  name: "wwwAutolink",
  tokenize: bH,
  previous: nT
}, tT = {
  name: "protocolAutolink",
  tokenize: _H,
  previous: rT
}, Dn = {
  name: "emailAutolink",
  tokenize: EH,
  previous: sT
}, Tn = {};
function gH() {
  return {
    text: Tn
  };
}
let mr = 48;
for (; mr < 123; )
  Tn[mr] = Dn, mr++, mr === 58 ? mr = 65 : mr === 91 && (mr = 97);
Tn[43] = Dn;
Tn[45] = Dn;
Tn[46] = Dn;
Tn[95] = Dn;
Tn[72] = [Dn, tT];
Tn[104] = [Dn, tT];
Tn[87] = [Dn, eT];
Tn[119] = [Dn, eT];
function EH(e, t, n) {
  const r = this;
  let s, i;
  return a;
  function a(h) {
    return !Lc(h) || !sT.call(r, r.previous) || ld(r.events) ? n(h) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), o(h));
  }
  function o(h) {
    return Lc(h) ? (e.consume(h), o) : h === 64 ? (e.consume(h), u) : n(h);
  }
  function u(h) {
    return h === 46 ? e.check(mH, l, c)(h) : h === 45 || h === 95 || Et(h) ? (i = !0, e.consume(h), u) : l(h);
  }
  function c(h) {
    return e.consume(h), s = !0, u;
  }
  function l(h) {
    return i && s && St(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(h)) : n(h);
  }
}
function bH(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return a !== 87 && a !== 119 || !nT.call(r, r.previous) || ld(r.events) ? n(a) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(pH, e.attempt(X_, e.attempt(J_, i), n), n)(a));
  }
  function i(a) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(a);
  }
}
function _H(e, t, n) {
  const r = this;
  let s = "", i = !1;
  return a;
  function a(h) {
    return (h === 72 || h === 104) && rT.call(r, r.previous) && !ld(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), s += String.fromCodePoint(h), e.consume(h), o) : n(h);
  }
  function o(h) {
    if (St(h) && s.length < 5)
      return s += String.fromCodePoint(h), e.consume(h), o;
    if (h === 58) {
      const m = s.toLowerCase();
      if (m === "http" || m === "https")
        return e.consume(h), u;
    }
    return n(h);
  }
  function u(h) {
    return h === 47 ? (e.consume(h), i ? c : (i = !0, u)) : n(h);
  }
  function c(h) {
    return h === null || Fa(h) || Ge(h) || kr(h) || Ro(h) ? n(h) : e.attempt(X_, e.attempt(J_, l), n)(h);
  }
  function l(h) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(h);
  }
}
function TH(e, t, n) {
  let r = 0;
  return s;
  function s(a) {
    return (a === 87 || a === 119) && r < 3 ? (r++, e.consume(a), s) : a === 46 && r === 3 ? (e.consume(a), i) : n(a);
  }
  function i(a) {
    return a === null ? n(a) : t(a);
  }
}
function AH(e, t, n) {
  let r, s, i;
  return a;
  function a(c) {
    return c === 46 || c === 95 ? e.check(Z_, u, o)(c) : c === null || Ge(c) || kr(c) || c !== 45 && Ro(c) ? u(c) : (i = !0, e.consume(c), a);
  }
  function o(c) {
    return c === 95 ? r = !0 : (s = r, r = void 0), e.consume(c), a;
  }
  function u(c) {
    return s || r || !i ? n(c) : t(c);
  }
}
function yH(e, t) {
  let n = 0, r = 0;
  return s;
  function s(a) {
    return a === 40 ? (n++, e.consume(a), s) : a === 41 && r < n ? i(a) : a === 33 || a === 34 || a === 38 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 60 || a === 63 || a === 93 || a === 95 || a === 126 ? e.check(Z_, t, i)(a) : a === null || Ge(a) || kr(a) ? t(a) : (e.consume(a), s);
  }
  function i(a) {
    return a === 41 && r++, e.consume(a), s;
  }
}
function xH(e, t, n) {
  return r;
  function r(o) {
    return o === 33 || o === 34 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 63 || o === 95 || o === 126 ? (e.consume(o), r) : o === 38 ? (e.consume(o), i) : o === 93 ? (e.consume(o), s) : (
      // `<` is an end.
      o === 60 || // So is whitespace.
      o === null || Ge(o) || kr(o) ? t(o) : n(o)
    );
  }
  function s(o) {
    return o === null || o === 40 || o === 91 || Ge(o) || kr(o) ? t(o) : r(o);
  }
  function i(o) {
    return St(o) ? a(o) : n(o);
  }
  function a(o) {
    return o === 59 ? (e.consume(o), r) : St(o) ? (e.consume(o), a) : n(o);
  }
}
function CH(e, t, n) {
  return r;
  function r(i) {
    return e.consume(i), s;
  }
  function s(i) {
    return Et(i) ? n(i) : t(i);
  }
}
function nT(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Ge(e);
}
function rT(e) {
  return !St(e);
}
function sT(e) {
  return !(e === 47 || Lc(e));
}
function Lc(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Et(e);
}
function ld(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const SH = {
  tokenize: OH,
  partial: !0
};
function IH() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: kH,
        continuation: {
          tokenize: RH
        },
        exit: PH
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: NH
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: wH,
        resolveTo: vH
      }
    }
  };
}
function wH(e, t, n) {
  const r = this;
  let s = r.events.length;
  const i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; s--; ) {
    const u = r.events[s][1];
    if (u.type === "labelImage") {
      a = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return o;
  function o(u) {
    if (!a || !a._balanced)
      return n(u);
    const c = en(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }));
    return c.codePointAt(0) !== 94 || !i.includes(c.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function vH(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, s = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  s.end.column++, s.end.offset++, s.end._bufferIndex++;
  const i = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, s.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, a = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, i.start),
    end: Object.assign({}, i.end)
  }, o = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", s, t],
    ["exit", s, t],
    // Everything in between.
    ["enter", i, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", i, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...o), e;
}
function NH(e, t, n) {
  const r = this, s = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i = 0, a;
  return o;
  function o(h) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(h) {
    return h !== 94 ? n(h) : (e.enter("gfmFootnoteCallMarker"), e.consume(h), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(h) {
    if (
      // Too long.
      i > 999 || // Closing brace with nothing.
      h === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      h === null || h === 91 || Ge(h)
    )
      return n(h);
    if (h === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteCallString");
      return s.includes(en(r.sliceSerialize(m))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(h);
    }
    return Ge(h) || (a = !0), i++, e.consume(h), h === 92 ? l : c;
  }
  function l(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), i++, c) : c(h);
  }
}
function kH(e, t, n) {
  const r = this, s = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i, a = 0, o;
  return u;
  function u(E) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(E) {
    return E === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", l) : n(E);
  }
  function l(E) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      E === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      E === null || E === 91 || Ge(E)
    )
      return n(E);
    if (E === 93) {
      e.exit("chunkString");
      const g = e.exit("gfmFootnoteDefinitionLabelString");
      return i = en(r.sliceSerialize(g)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), m;
    }
    return Ge(E) || (o = !0), a++, e.consume(E), E === 92 ? h : l;
  }
  function h(E) {
    return E === 91 || E === 92 || E === 93 ? (e.consume(E), a++, l) : l(E);
  }
  function m(E) {
    return E === 58 ? (e.enter("definitionMarker"), e.consume(E), e.exit("definitionMarker"), s.includes(i) || s.push(i), Le(e, p, "gfmFootnoteDefinitionWhitespace")) : n(E);
  }
  function p(E) {
    return t(E);
  }
}
function RH(e, t, n) {
  return e.check(Ri, t, e.attempt(SH, t, n));
}
function PH(e) {
  e.exit("gfmFootnoteDefinition");
}
function OH(e, t, n) {
  const r = this;
  return Le(e, s, "gfmFootnoteDefinitionIndent", 5);
  function s(i) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === 4 ? t(i) : n(i);
  }
}
function DH(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: i,
    resolveAll: s
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function s(a, o) {
    let u = -1;
    for (; ++u < a.length; )
      if (a[u][0] === "enter" && a[u][1].type === "strikethroughSequenceTemporary" && a[u][1]._close) {
        let c = u;
        for (; c--; )
          if (a[c][0] === "exit" && a[c][1].type === "strikethroughSequenceTemporary" && a[c][1]._open && // If the sizes are the same:
          a[u][1].end.offset - a[u][1].start.offset === a[c][1].end.offset - a[c][1].start.offset) {
            a[u][1].type = "strikethroughSequence", a[c][1].type = "strikethroughSequence";
            const l = {
              type: "strikethrough",
              start: Object.assign({}, a[c][1].start),
              end: Object.assign({}, a[u][1].end)
            }, h = {
              type: "strikethroughText",
              start: Object.assign({}, a[c][1].end),
              end: Object.assign({}, a[u][1].start)
            }, m = [["enter", l, o], ["enter", a[c][1], o], ["exit", a[c][1], o], ["enter", h, o]], p = o.parser.constructs.insideSpan.null;
            p && Ut(m, m.length, 0, Po(p, a.slice(c + 1, u), o)), Ut(m, m.length, 0, [["exit", h, o], ["enter", a[u][1], o], ["exit", a[u][1], o], ["exit", l, o]]), Ut(a, c - 1, u - c + 3, m), u = c + m.length - 2;
            break;
          }
      }
    for (u = -1; ++u < a.length; )
      a[u][1].type === "strikethroughSequenceTemporary" && (a[u][1].type = "data");
    return a;
  }
  function i(a, o, u) {
    const c = this.previous, l = this.events;
    let h = 0;
    return m;
    function m(E) {
      return c === 126 && l[l.length - 1][1].type !== "characterEscape" ? u(E) : (a.enter("strikethroughSequenceTemporary"), p(E));
    }
    function p(E) {
      const g = ds(c);
      if (E === 126)
        return h > 1 ? u(E) : (a.consume(E), h++, p);
      if (h < 2 && !n) return u(E);
      const _ = a.exit("strikethroughSequenceTemporary"), b = ds(E);
      return _._open = !b || b === 2 && !!g, _._close = !g || g === 2 && !!b, o(E);
    }
  }
}
class LH {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    MH(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(i, a) {
      return i[0] - a[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push(t.slice()), t.length = 0;
    let s = r.pop();
    for (; s; ) {
      for (const i of s)
        t.push(i);
      s = r.pop();
    }
    this.map.length = 0;
  }
}
function MH(e, t, n, r) {
  let s = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; s < e.map.length; ) {
      if (e.map[s][0] === t) {
        e.map[s][1] += n, e.map[s][2].push(...r);
        return;
      }
      s += 1;
    }
    e.map.push([t, n, r]);
  }
}
function HH(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const s = e[t];
    if (n) {
      if (s[0] === "enter")
        s[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (s[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const i = r.length - 1;
          r[i] = r[i] === "left" ? "center" : "right";
        }
      } else if (s[1].type === "tableDelimiterRow")
        break;
    } else s[0] === "enter" && s[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function BH() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: UH,
        resolveAll: FH
      }
    }
  };
}
function UH(e, t, n) {
  const r = this;
  let s = 0, i = 0, a;
  return o;
  function o(P) {
    let z = r.events.length - 1;
    for (; z > -1; ) {
      const M = r.events[z][1].type;
      if (M === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      M === "linePrefix") z--;
      else break;
    }
    const G = z > -1 ? r.events[z][1].type : null, F = G === "tableHead" || G === "tableRow" ? I : u;
    return F === I && r.parser.lazy[r.now().line] ? n(P) : F(P);
  }
  function u(P) {
    return e.enter("tableHead"), e.enter("tableRow"), c(P);
  }
  function c(P) {
    return P === 124 || (a = !0, i += 1), l(P);
  }
  function l(P) {
    return P === null ? n(P) : me(P) ? i > 1 ? (i = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(P), e.exit("lineEnding"), p) : n(P) : ke(P) ? Le(e, l, "whitespace")(P) : (i += 1, a && (a = !1, s += 1), P === 124 ? (e.enter("tableCellDivider"), e.consume(P), e.exit("tableCellDivider"), a = !0, l) : (e.enter("data"), h(P)));
  }
  function h(P) {
    return P === null || P === 124 || Ge(P) ? (e.exit("data"), l(P)) : (e.consume(P), P === 92 ? m : h);
  }
  function m(P) {
    return P === 92 || P === 124 ? (e.consume(P), h) : h(P);
  }
  function p(P) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(P) : (e.enter("tableDelimiterRow"), a = !1, ke(P) ? Le(e, E, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(P) : E(P));
  }
  function E(P) {
    return P === 45 || P === 58 ? _(P) : P === 124 ? (a = !0, e.enter("tableCellDivider"), e.consume(P), e.exit("tableCellDivider"), g) : D(P);
  }
  function g(P) {
    return ke(P) ? Le(e, _, "whitespace")(P) : _(P);
  }
  function _(P) {
    return P === 58 ? (i += 1, a = !0, e.enter("tableDelimiterMarker"), e.consume(P), e.exit("tableDelimiterMarker"), b) : P === 45 ? (i += 1, b(P)) : P === null || me(P) ? R(P) : D(P);
  }
  function b(P) {
    return P === 45 ? (e.enter("tableDelimiterFiller"), T(P)) : D(P);
  }
  function T(P) {
    return P === 45 ? (e.consume(P), T) : P === 58 ? (a = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(P), e.exit("tableDelimiterMarker"), C) : (e.exit("tableDelimiterFiller"), C(P));
  }
  function C(P) {
    return ke(P) ? Le(e, R, "whitespace")(P) : R(P);
  }
  function R(P) {
    return P === 124 ? E(P) : P === null || me(P) ? !a || s !== i ? D(P) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(P)) : D(P);
  }
  function D(P) {
    return n(P);
  }
  function I(P) {
    return e.enter("tableRow"), O(P);
  }
  function O(P) {
    return P === 124 ? (e.enter("tableCellDivider"), e.consume(P), e.exit("tableCellDivider"), O) : P === null || me(P) ? (e.exit("tableRow"), t(P)) : ke(P) ? Le(e, O, "whitespace")(P) : (e.enter("data"), U(P));
  }
  function U(P) {
    return P === null || P === 124 || Ge(P) ? (e.exit("data"), O(P)) : (e.consume(P), P === 92 ? q : U);
  }
  function q(P) {
    return P === 92 || P === 124 ? (e.consume(P), U) : U(P);
  }
}
function FH(e, t) {
  let n = -1, r = !0, s = 0, i = [0, 0, 0, 0], a = [0, 0, 0, 0], o = !1, u = 0, c, l, h;
  const m = new LH();
  for (; ++n < e.length; ) {
    const p = e[n], E = p[1];
    p[0] === "enter" ? E.type === "tableHead" ? (o = !1, u !== 0 && (wp(m, t, u, c, l), l = void 0, u = 0), c = {
      type: "table",
      start: Object.assign({}, E.start),
      // Note: correct end is set later.
      end: Object.assign({}, E.end)
    }, m.add(n, 0, [["enter", c, t]])) : E.type === "tableRow" || E.type === "tableDelimiterRow" ? (r = !0, h = void 0, i = [0, 0, 0, 0], a = [0, n + 1, 0, 0], o && (o = !1, l = {
      type: "tableBody",
      start: Object.assign({}, E.start),
      // Note: correct end is set later.
      end: Object.assign({}, E.end)
    }, m.add(n, 0, [["enter", l, t]])), s = E.type === "tableDelimiterRow" ? 2 : l ? 3 : 1) : s && (E.type === "data" || E.type === "tableDelimiterMarker" || E.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (i[1] !== 0 && (a[0] = a[1], h = oa(m, t, i, s, void 0, h), i = [0, 0, 0, 0]), a[2] = n)) : E.type === "tableCellDivider" && (r ? r = !1 : (i[1] !== 0 && (a[0] = a[1], h = oa(m, t, i, s, void 0, h)), i = a, a = [i[1], n, 0, 0])) : E.type === "tableHead" ? (o = !0, u = n) : E.type === "tableRow" || E.type === "tableDelimiterRow" ? (u = n, i[1] !== 0 ? (a[0] = a[1], h = oa(m, t, i, s, n, h)) : a[1] !== 0 && (h = oa(m, t, a, s, n, h)), s = 0) : s && (E.type === "data" || E.type === "tableDelimiterMarker" || E.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (u !== 0 && wp(m, t, u, c, l), m.consume(t.events), n = -1; ++n < t.events.length; ) {
    const p = t.events[n];
    p[0] === "enter" && p[1].type === "table" && (p[1]._align = HH(t.events, n));
  }
  return e;
}
function oa(e, t, n, r, s, i) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", o = "tableContent";
  n[0] !== 0 && (i.end = Object.assign({}, Qr(t.events, n[0])), e.add(n[0], 0, [["exit", i, t]]));
  const u = Qr(t.events, n[1]);
  if (i = {
    type: a,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", i, t]]), n[2] !== 0) {
    const c = Qr(t.events, n[2]), l = Qr(t.events, n[3]), h = {
      type: o,
      start: Object.assign({}, c),
      end: Object.assign({}, l)
    };
    if (e.add(n[2], 0, [["enter", h, t]]), r !== 2) {
      const m = t.events[n[2]], p = t.events[n[3]];
      if (m[1].end = Object.assign({}, p[1].end), m[1].type = "chunkText", m[1].contentType = "text", n[3] > n[2] + 1) {
        const E = n[2] + 1, g = n[3] - n[2] - 1;
        e.add(E, g, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", h, t]]);
  }
  return s !== void 0 && (i.end = Object.assign({}, Qr(t.events, s)), e.add(s, 0, [["exit", i, t]]), i = void 0), i;
}
function wp(e, t, n, r, s) {
  const i = [], a = Qr(t.events, n);
  s && (s.end = Object.assign({}, a), i.push(["exit", s, t])), r.end = Object.assign({}, a), i.push(["exit", r, t]), e.add(n + 1, 0, i);
}
function Qr(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const jH = {
  name: "tasklistCheck",
  tokenize: zH
};
function $H() {
  return {
    text: {
      91: jH
    }
  };
}
function zH(e, t, n) {
  const r = this;
  return s;
  function s(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), i)
    );
  }
  function i(u) {
    return Ge(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), a) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), a) : n(u);
  }
  function a(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), o) : n(u);
  }
  function o(u) {
    return me(u) ? t(u) : ke(u) ? e.check({
      tokenize: VH
    }, t, n)(u) : n(u);
  }
}
function VH(e, t, n) {
  return Le(e, r, "whitespace");
  function r(s) {
    return s === null ? n(s) : t(s);
  }
}
function YH(e) {
  return vb([
    gH(),
    IH(),
    DH(e),
    BH(),
    $H()
  ]);
}
const GH = {};
function iT(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || GH, r = t.data(), s = r.micromarkExtensions || (r.micromarkExtensions = []), i = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), a = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  s.push(YH(n)), i.push(hH()), a.push(fH(n));
}
const qt = Je(
  ({ children: e, tooltip: t, side: n = "bottom", className: r, ...s }, i) => /* @__PURE__ */ d.jsxs(Ik, { children: [
    /* @__PURE__ */ d.jsx(wk, { asChild: !0, children: /* @__PURE__ */ d.jsxs(It, { variant: "ghost", size: "icon", ...s, className: le("size-6 p-1", r), ref: i, children: [
      e,
      /* @__PURE__ */ d.jsx("span", { className: "sr-only", children: t })
    ] }) }),
    /* @__PURE__ */ d.jsx(vk, { side: n, children: t })
  ] })
);
qt.displayName = "TooltipIconButton";
const WH = {
  365: { unit: "months", value: 12 },
  730: { unit: "years", value: 2 },
  1095: { unit: "years", value: 3 }
}, Vn = {
  territoryGrouped: {
    key: "zai.widget.territory-type.grouped",
    defaultValue: "Visão geral"
  },
  territoryOwned: {
    key: "zai.widget.territory-type.owned",
    defaultValue: "Owned"
  },
  territoryEarned: {
    key: "zai.widget.territory-type.earned",
    defaultValue: "Earned (UGC)"
  },
  territoryPaid: {
    key: "zai.widget.territory-type.paid",
    defaultValue: "Paid"
  },
  lastNDays: (e) => ({
    key: "zai.widget.upload-date.last-n-days",
    parameters: e,
    defaultValue: "Últimos {days} dias"
  }),
  lastNMonths: (e) => ({
    key: "zai.widget.upload-date.last-n-months",
    parameters: e,
    defaultValue: "Últimos {months} meses"
  }),
  lastNYears: (e) => ({
    key: "zai.widget.upload-date.last-n-years",
    parameters: e,
    defaultValue: "Últimos {years} anos"
  })
}, aT = (e, t) => {
  switch (e) {
    case "earned":
      return t(Vn.territoryEarned);
    case "paid":
      return t(Vn.territoryPaid);
    case "selfContent":
    case "owned":
      return t(Vn.territoryOwned);
    default:
      return t(Vn.territoryGrouped);
  }
}, dd = (e, t) => {
  const n = WH[e];
  return n?.unit === "years" ? t(Vn.lastNYears({ years: n.value })) : n?.unit === "months" ? t(Vn.lastNMonths({ months: n.value })) : e >= 60 && e % 30 === 0 ? t(Vn.lastNMonths({ months: e / 30 })) : t(Vn.lastNDays({ days: e }));
};
var ba = { exports: {} }, qH = ba.exports, vp;
function hd() {
  return vp || (vp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(qH, (function() {
      var n = 1e3, r = 6e4, s = 36e5, i = "millisecond", a = "second", o = "minute", u = "hour", c = "day", l = "week", h = "month", m = "quarter", p = "year", E = "date", g = "Invalid Date", _ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
        var H = ["th", "st", "nd", "rd"], B = M % 100;
        return "[" + M + (H[(B - 20) % 10] || H[B] || H[0]) + "]";
      } }, C = function(M, H, B) {
        var Y = String(M);
        return !Y || Y.length >= H ? M : "" + Array(H + 1 - Y.length).join(B) + M;
      }, R = { s: C, z: function(M) {
        var H = -M.utcOffset(), B = Math.abs(H), Y = Math.floor(B / 60), $ = B % 60;
        return (H <= 0 ? "+" : "-") + C(Y, 2, "0") + ":" + C($, 2, "0");
      }, m: function M(H, B) {
        if (H.date() < B.date()) return -M(B, H);
        var Y = 12 * (B.year() - H.year()) + (B.month() - H.month()), $ = H.clone().add(Y, h), Z = B - $ < 0, y = H.clone().add(Y + (Z ? -1 : 1), h);
        return +(-(Y + (B - $) / (Z ? $ - y : y - $)) || 0);
      }, a: function(M) {
        return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
      }, p: function(M) {
        return { M: h, y: p, w: l, d: c, D: E, h: u, m: o, s: a, ms: i, Q: m }[M] || String(M || "").toLowerCase().replace(/s$/, "");
      }, u: function(M) {
        return M === void 0;
      } }, D = "en", I = {};
      I[D] = T;
      var O = "$isDayjsObject", U = function(M) {
        return M instanceof G || !(!M || !M[O]);
      }, q = function M(H, B, Y) {
        var $;
        if (!H) return D;
        if (typeof H == "string") {
          var Z = H.toLowerCase();
          I[Z] && ($ = Z), B && (I[Z] = B, $ = Z);
          var y = H.split("-");
          if (!$ && y.length > 1) return M(y[0]);
        } else {
          var fe = H.name;
          I[fe] = H, $ = fe;
        }
        return !Y && $ && (D = $), $ || !Y && D;
      }, P = function(M, H) {
        if (U(M)) return M.clone();
        var B = typeof H == "object" ? H : {};
        return B.date = M, B.args = arguments, new G(B);
      }, z = R;
      z.l = q, z.i = U, z.w = function(M, H) {
        return P(M, { locale: H.$L, utc: H.$u, x: H.$x, $offset: H.$offset });
      };
      var G = (function() {
        function M(B) {
          this.$L = q(B.locale, null, !0), this.parse(B), this.$x = this.$x || B.x || {}, this[O] = !0;
        }
        var H = M.prototype;
        return H.parse = function(B) {
          this.$d = (function(Y) {
            var $ = Y.date, Z = Y.utc;
            if ($ === null) return /* @__PURE__ */ new Date(NaN);
            if (z.u($)) return /* @__PURE__ */ new Date();
            if ($ instanceof Date) return new Date($);
            if (typeof $ == "string" && !/Z$/i.test($)) {
              var y = $.match(_);
              if (y) {
                var fe = y[2] - 1 || 0, Ce = (y[7] || "0").substring(0, 3);
                return Z ? new Date(Date.UTC(y[1], fe, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, Ce)) : new Date(y[1], fe, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, Ce);
              }
            }
            return new Date($);
          })(B), this.init();
        }, H.init = function() {
          var B = this.$d;
          this.$y = B.getFullYear(), this.$M = B.getMonth(), this.$D = B.getDate(), this.$W = B.getDay(), this.$H = B.getHours(), this.$m = B.getMinutes(), this.$s = B.getSeconds(), this.$ms = B.getMilliseconds();
        }, H.$utils = function() {
          return z;
        }, H.isValid = function() {
          return this.$d.toString() !== g;
        }, H.isSame = function(B, Y) {
          var $ = P(B);
          return this.startOf(Y) <= $ && $ <= this.endOf(Y);
        }, H.isAfter = function(B, Y) {
          return P(B) < this.startOf(Y);
        }, H.isBefore = function(B, Y) {
          return this.endOf(Y) < P(B);
        }, H.$g = function(B, Y, $) {
          return z.u(B) ? this[Y] : this.set($, B);
        }, H.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, H.valueOf = function() {
          return this.$d.getTime();
        }, H.startOf = function(B, Y) {
          var $ = this, Z = !!z.u(Y) || Y, y = z.p(B), fe = function(ce, ue) {
            var Ae = z.w($.$u ? Date.UTC($.$y, ue, ce) : new Date($.$y, ue, ce), $);
            return Z ? Ae : Ae.endOf(c);
          }, Ce = function(ce, ue) {
            return z.w($.toDate()[ce].apply($.toDate("s"), (Z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ue)), $);
          }, v = this.$W, Se = this.$M, _e = this.$D, pe = "set" + (this.$u ? "UTC" : "");
          switch (y) {
            case p:
              return Z ? fe(1, 0) : fe(31, 11);
            case h:
              return Z ? fe(1, Se) : fe(0, Se + 1);
            case l:
              var re = this.$locale().weekStart || 0, Te = (v < re ? v + 7 : v) - re;
              return fe(Z ? _e - Te : _e + (6 - Te), Se);
            case c:
            case E:
              return Ce(pe + "Hours", 0);
            case u:
              return Ce(pe + "Minutes", 1);
            case o:
              return Ce(pe + "Seconds", 2);
            case a:
              return Ce(pe + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, H.endOf = function(B) {
          return this.startOf(B, !1);
        }, H.$set = function(B, Y) {
          var $, Z = z.p(B), y = "set" + (this.$u ? "UTC" : ""), fe = ($ = {}, $[c] = y + "Date", $[E] = y + "Date", $[h] = y + "Month", $[p] = y + "FullYear", $[u] = y + "Hours", $[o] = y + "Minutes", $[a] = y + "Seconds", $[i] = y + "Milliseconds", $)[Z], Ce = Z === c ? this.$D + (Y - this.$W) : Y;
          if (Z === h || Z === p) {
            var v = this.clone().set(E, 1);
            v.$d[fe](Ce), v.init(), this.$d = v.set(E, Math.min(this.$D, v.daysInMonth())).$d;
          } else fe && this.$d[fe](Ce);
          return this.init(), this;
        }, H.set = function(B, Y) {
          return this.clone().$set(B, Y);
        }, H.get = function(B) {
          return this[z.p(B)]();
        }, H.add = function(B, Y) {
          var $, Z = this;
          B = Number(B);
          var y = z.p(Y), fe = function(Se) {
            var _e = P(Z);
            return z.w(_e.date(_e.date() + Math.round(Se * B)), Z);
          };
          if (y === h) return this.set(h, this.$M + B);
          if (y === p) return this.set(p, this.$y + B);
          if (y === c) return fe(1);
          if (y === l) return fe(7);
          var Ce = ($ = {}, $[o] = r, $[u] = s, $[a] = n, $)[y] || 1, v = this.$d.getTime() + B * Ce;
          return z.w(v, this);
        }, H.subtract = function(B, Y) {
          return this.add(-1 * B, Y);
        }, H.format = function(B) {
          var Y = this, $ = this.$locale();
          if (!this.isValid()) return $.invalidDate || g;
          var Z = B || "YYYY-MM-DDTHH:mm:ssZ", y = z.z(this), fe = this.$H, Ce = this.$m, v = this.$M, Se = $.weekdays, _e = $.months, pe = $.meridiem, re = function(ue, Ae, Pe, qe) {
            return ue && (ue[Ae] || ue(Y, Z)) || Pe[Ae].slice(0, qe);
          }, Te = function(ue) {
            return z.s(fe % 12 || 12, ue, "0");
          }, ce = pe || function(ue, Ae, Pe) {
            var qe = ue < 12 ? "AM" : "PM";
            return Pe ? qe.toLowerCase() : qe;
          };
          return Z.replace(b, (function(ue, Ae) {
            return Ae || (function(Pe) {
              switch (Pe) {
                case "YY":
                  return String(Y.$y).slice(-2);
                case "YYYY":
                  return z.s(Y.$y, 4, "0");
                case "M":
                  return v + 1;
                case "MM":
                  return z.s(v + 1, 2, "0");
                case "MMM":
                  return re($.monthsShort, v, _e, 3);
                case "MMMM":
                  return re(_e, v);
                case "D":
                  return Y.$D;
                case "DD":
                  return z.s(Y.$D, 2, "0");
                case "d":
                  return String(Y.$W);
                case "dd":
                  return re($.weekdaysMin, Y.$W, Se, 2);
                case "ddd":
                  return re($.weekdaysShort, Y.$W, Se, 3);
                case "dddd":
                  return Se[Y.$W];
                case "H":
                  return String(fe);
                case "HH":
                  return z.s(fe, 2, "0");
                case "h":
                  return Te(1);
                case "hh":
                  return Te(2);
                case "a":
                  return ce(fe, Ce, !0);
                case "A":
                  return ce(fe, Ce, !1);
                case "m":
                  return String(Ce);
                case "mm":
                  return z.s(Ce, 2, "0");
                case "s":
                  return String(Y.$s);
                case "ss":
                  return z.s(Y.$s, 2, "0");
                case "SSS":
                  return z.s(Y.$ms, 3, "0");
                case "Z":
                  return y;
              }
              return null;
            })(ue) || y.replace(":", "");
          }));
        }, H.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, H.diff = function(B, Y, $) {
          var Z, y = this, fe = z.p(Y), Ce = P(B), v = (Ce.utcOffset() - this.utcOffset()) * r, Se = this - Ce, _e = function() {
            return z.m(y, Ce);
          };
          switch (fe) {
            case p:
              Z = _e() / 12;
              break;
            case h:
              Z = _e();
              break;
            case m:
              Z = _e() / 3;
              break;
            case l:
              Z = (Se - v) / 6048e5;
              break;
            case c:
              Z = (Se - v) / 864e5;
              break;
            case u:
              Z = Se / s;
              break;
            case o:
              Z = Se / r;
              break;
            case a:
              Z = Se / n;
              break;
            default:
              Z = Se;
          }
          return $ ? Z : z.a(Z);
        }, H.daysInMonth = function() {
          return this.endOf(h).$D;
        }, H.$locale = function() {
          return I[this.$L];
        }, H.locale = function(B, Y) {
          if (!B) return this.$L;
          var $ = this.clone(), Z = q(B, Y, !0);
          return Z && ($.$L = Z), $;
        }, H.clone = function() {
          return z.w(this.$d, this);
        }, H.toDate = function() {
          return new Date(this.valueOf());
        }, H.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, H.toISOString = function() {
          return this.$d.toISOString();
        }, H.toString = function() {
          return this.$d.toUTCString();
        }, M;
      })(), F = G.prototype;
      return P.prototype = F, [["$ms", i], ["$s", a], ["$m", o], ["$H", u], ["$W", c], ["$M", h], ["$y", p], ["$D", E]].forEach((function(M) {
        F[M[1]] = function(H) {
          return this.$g(H, M[0], M[1]);
        };
      })), P.extend = function(M, H) {
        return M.$i || (M(H, G, P), M.$i = !0), P;
      }, P.locale = q, P.isDayjs = U, P.unix = function(M) {
        return P(1e3 * M);
      }, P.en = I[D], P.Ls = I, P.p = {}, P;
    }));
  })(ba)), ba.exports;
}
var KH = hd();
const xr = /* @__PURE__ */ Rr(KH), QH = (e) => ls[e] || ls.grouped, XH = (e, t) => {
  const n = {
    quarter: "MMM/YYYY",
    month: "MMM/YYYY",
    week: "MMM, DD YYYY",
    day: "MMM, DD YYYY"
  };
  return t === "quarter" ? `${xr(e).utc().format("MMM")}-${xr(e).add(2, "months").utc().format(n.quarter)}` : xr(e).utc().format(n[t]);
}, JH = ({
  provider: e = "all",
  territoryType: t = "grouped",
  timeRangeInDays: n = 30
}) => {
  const r = vo.isEnabled("isNewPageBrandOverviewEnabled"), { workspaceId: s } = pt(), i = Lr(), { t: a } = Fe(), o = ie(() => {
    const R = En(
      Jn[te.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE],
      {
        panelId: s,
        tab: QH(t)
      }
    ), D = lb({ provider: e, timeRangeInDays: n }).toString();
    return D ? `${R}?${D}` : R;
  }, [e, t, n, s]), [u, c] = de([]), [l, h] = de(!1), [m, p] = de(!1), E = ne(async () => {
    if (s) {
      h(!0), p(!1);
      try {
        const R = await i.getBrandEngagementOverTimeData(
          {
            provider: e,
            territoryType: t,
            timeRangeInDays: n?.toString()
          },
          { isNewPageBrandOverviewEnabled: r }
        );
        c(R);
      } catch {
        p(!0), c([]);
      } finally {
        h(!1);
      }
    }
  }, [s, i, e, t, n, r]);
  xe(() => {
    E();
  }, [E]);
  const g = ie(() => u?.map((R) => {
    const D = R.metrics.map((I) => I.totalEngagement);
    return {
      name: R.name,
      color: R.color,
      series: D
    };
  }) || [], [u]), _ = ie(() => !u || u.length === 0 ? [] : u[0]?.metrics?.map((R) => R.date) || [], [u]), b = ie(() => {
    const R = _c(n);
    return _.map((D) => XH(D, R));
  }, [_, n]), T = ie(
    () => g.length === 0 || g.flatMap((R) => R.series).every((R) => R === 0),
    [g]
  ), C = ie(() => {
    const R = Ol[e], D = aT(t, a), I = dd(n, a);
    return [R, D, I].join(" · ");
  }, [e, t, n, a]);
  return {
    data: u,
    isLoading: l,
    isError: m,
    isEmpty: T,
    refetch: E,
    macroareaURL: o,
    chartEntities: g,
    chartLabels: b,
    subtitle: C
  };
}, Np = {
  chart: {
    key: "widget-error.chart.title",
    defaultValue: "O gráfico falhou ao carregar"
  },
  video: {
    key: "widget-error.video.title",
    defaultValue: "O vídeo falhou ao carregar"
  },
  creator: {
    key: "widget-error.creator.title",
    defaultValue: "O criador falhou ao carregar"
  },
  tryAgain: {
    key: "widget-error.try-again",
    defaultValue: "Tentar novamente"
  }
}, Ss = ({ refetch: e, name: t }) => {
  const { t: n } = Fe(), r = Np;
  return /* @__PURE__ */ d.jsxs("div", { className: "my-5 w-full flex flex-col items-center justify-center gap-4", children: [
    /* @__PURE__ */ d.jsx("strong", { children: n(r[t]) }),
    e && /* @__PURE__ */ d.jsx(It, { variant: "highlight-border", onClick: e, children: n(Np.tryAgain) })
  ] });
}, oT = _t("dark"), fd = ({ theme: e, children: t }) => /* @__PURE__ */ d.jsx(oT.Provider, { value: e, children: t }), ar = () => ft(oT), kp = {
  accessMacroarea: {
    key: "brand-engagement-over-time.access-macroarea",
    defaultValue: "Acessar Engajamento"
  },
  noDataAvailable: {
    key: "brand-engagement-over-time.no-data-available",
    defaultValue: "Nenhum dado de engajamento disponível para o período selecionado"
  }
}, ZH = () => /* @__PURE__ */ d.jsx("div", { className: "w-full h-96 flex items-center justify-center", children: /* @__PURE__ */ d.jsx("div", { className: "animate-pulse w-full h-96 bg-muted rounded-md" }) }), eB = ({
  isError: e,
  isLoading: t,
  isEmpty: n,
  macroareaURL: r,
  refetch: s,
  chartEntities: i,
  chartLabels: a,
  subtitle: o
}) => {
  const { t: u } = Fe(), c = ar();
  return /* @__PURE__ */ d.jsxs("div", { className: "my-5 w-full flex flex-col gap-6", children: [
    o && /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: o }),
    /* @__PURE__ */ d.jsx(
      Mr,
      {
        isLoading: t,
        isError: e,
        loadingComponent: /* @__PURE__ */ d.jsx(ZH, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ss, { name: "chart", refetch: s }),
        isEmpty: n,
        emptyComponent: /* @__PURE__ */ d.jsx("div", { className: "flex justify-center items-center h-96", children: /* @__PURE__ */ d.jsx("p", { className: "text-center text-muted-foreground", children: u(kp.noDataAvailable) }) }),
        children: /* @__PURE__ */ d.jsx("div", { className: "w-full", children: /* @__PURE__ */ d.jsx(
          sn.LineChart,
          {
            legend: { type: "default" },
            entities: i,
            xAxisLabels: a,
            tooltip: { type: "default", shared: !0, formatter: (l) => Wt(l, 2) },
            customOptions: {
              yAxis: {
                labels: {
                  formatter: function() {
                    return Wt(Number(this.value), 0);
                  }
                }
              }
            },
            theme: c,
            height: 600
          }
        ) })
      }
    ),
    !e && /* @__PURE__ */ d.jsx(It, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: r, target: "_blank", rel: "noopener noreferrer", children: u(kp.accessMacroarea) }) })
  ] });
}, tB = (e = {}) => {
  const t = JH(e);
  return /* @__PURE__ */ d.jsx(eB, { ...e, ...t });
}, nB = ({ creatorId: e, performanceInMonths: t = 1 }) => {
  const { workspaceId: n } = pt(), r = Lr(), [s, i] = de(!1), [a, o] = de(!1), [u, c] = de(null), l = ne(async () => {
    if (!(!e || !n))
      try {
        i(!0), o(!1);
        const h = await r.getCreatorData(e, { performanceInMonths: t });
        c(h);
      } catch {
        o(!0);
      } finally {
        i(!1);
      }
  }, [n, e, t, r]);
  return xe(() => {
    l();
  }, [l]), {
    isLoading: s,
    isError: a,
    data: u,
    fetch: l
  };
}, rB = [
  {
    NAME: "Afghanistan",
    ALPHA_2: "AF",
    ALPHA_3: "AFG",
    CODE: 4,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Åland Islands",
    ALPHA_2: "AX",
    ALPHA_3: "ALA",
    CODE: 248,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Albania",
    ALPHA_2: "AL",
    ALPHA_3: "ALB",
    CODE: 8,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Algeria",
    ALPHA_2: "DZ",
    ALPHA_3: "DZA",
    CODE: 12,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "American Samoa",
    ALPHA_2: "AS",
    ALPHA_3: "ASM",
    CODE: 16,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Andorra",
    ALPHA_2: "AD",
    ALPHA_3: "AND",
    CODE: 20,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Angola",
    ALPHA_2: "AO",
    ALPHA_3: "AGO",
    CODE: 24,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Anguilla",
    ALPHA_2: "AI",
    ALPHA_3: "AIA",
    CODE: 660,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Antarctica",
    ALPHA_2: "AQ",
    ALPHA_3: "ATA",
    CODE: 10,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Antigua And Barbuda",
    ALPHA_2: "AG",
    ALPHA_3: "ATG",
    CODE: 28,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Argentina",
    ALPHA_2: "AR",
    ALPHA_3: "ARG",
    CODE: 32,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Armenia",
    ALPHA_2: "AM",
    ALPHA_3: "ARM",
    CODE: 51,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Aruba",
    ALPHA_2: "AW",
    ALPHA_3: "ABW",
    CODE: 533,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Australia",
    ALPHA_2: "AU",
    ALPHA_3: "AUS",
    CODE: 36,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Austria",
    ALPHA_2: "AT",
    ALPHA_3: "AUT",
    CODE: 40,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Azerbaijan",
    ALPHA_2: "AZ",
    ALPHA_3: "AZE",
    CODE: 31,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bahamas",
    ALPHA_2: "BS",
    ALPHA_3: "BHS",
    CODE: 44,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bahrain",
    ALPHA_2: "BH",
    ALPHA_3: "BHR",
    CODE: 48,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bangladesh",
    ALPHA_2: "BD",
    ALPHA_3: "BGD",
    CODE: 50,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Barbados",
    ALPHA_2: "BB",
    ALPHA_3: "BRB",
    CODE: 52,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belarus",
    ALPHA_2: "BY",
    ALPHA_3: "BLR",
    CODE: 112,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belgium",
    ALPHA_2: "BE",
    ALPHA_3: "BEL",
    CODE: 56,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belize",
    ALPHA_2: "BZ",
    ALPHA_3: "BLZ",
    CODE: 84,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Benin",
    ALPHA_2: "BJ",
    ALPHA_3: "BEN",
    CODE: 204,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bermuda",
    ALPHA_2: "BM",
    ALPHA_3: "BMU",
    CODE: 60,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bhutan",
    ALPHA_2: "BT",
    ALPHA_3: "BTN",
    CODE: 64,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bolivia",
    ALPHA_2: "BO",
    ALPHA_3: "BOL",
    CODE: 68,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bonaire, Sint Eustatius and Saba",
    ALPHA_2: "BQ",
    ALPHA_3: "BES",
    CODE: 535,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bosnia And Herzegovina",
    ALPHA_2: "BA",
    ALPHA_3: "BIH",
    CODE: 70,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Botswana",
    ALPHA_2: "BW",
    ALPHA_3: "BWA",
    CODE: 72,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bouvet Island",
    ALPHA_2: "BV",
    ALPHA_3: "BVT",
    CODE: 74,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Brazil",
    ALPHA_2: "BR",
    ALPHA_3: "BRA",
    CODE: 76,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "British Indian Ocean Territory",
    ALPHA_2: "IO",
    ALPHA_3: "IOT",
    CODE: 86,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Brunei Darussalam",
    ALPHA_2: "BN",
    ALPHA_3: "BRN",
    CODE: 96,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bulgaria",
    ALPHA_2: "BG",
    ALPHA_3: "BGR",
    CODE: 100,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burkina Faso",
    ALPHA_2: "BF",
    ALPHA_3: "BFA",
    CODE: 854,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burundi",
    ALPHA_2: "BI",
    ALPHA_3: "BDI",
    CODE: 108,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cape Verde",
    ALPHA_2: "CV",
    ALPHA_3: "CPV",
    CODE: 132,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cambodia",
    ALPHA_2: "KH",
    ALPHA_3: "KHM",
    CODE: 116,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cameroon",
    ALPHA_2: "CM",
    ALPHA_3: "CMR",
    CODE: 120,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Canada",
    ALPHA_2: "CA",
    ALPHA_3: "CAN",
    CODE: 124,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cayman Islands",
    ALPHA_2: "KY",
    ALPHA_3: "CYM",
    CODE: 136,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Central African Republic",
    ALPHA_2: "CF",
    ALPHA_3: "CAF",
    CODE: 140,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Chad",
    ALPHA_2: "TD",
    ALPHA_3: "TCD",
    CODE: 148,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Chile",
    ALPHA_2: "CL",
    ALPHA_3: "CHL",
    CODE: 152,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "China",
    ALPHA_2: "CN",
    ALPHA_3: "CHN",
    CODE: 156,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Christmas Island",
    ALPHA_2: "CX",
    ALPHA_3: "CXR",
    CODE: 162,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cocos (keeling) Islands",
    ALPHA_2: "CC",
    ALPHA_3: "CCK",
    CODE: 166,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Colombia",
    ALPHA_2: "CO",
    ALPHA_3: "COL",
    CODE: 170,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Comoros",
    ALPHA_2: "KM",
    ALPHA_3: "COM",
    CODE: 174,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Congo",
    ALPHA_2: "CG",
    ALPHA_3: "COG",
    CODE: 178,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Congo, The Democratic Republic Of The",
    ALPHA_2: "CD",
    ALPHA_3: "COD",
    CODE: 180,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cook Islands",
    ALPHA_2: "CK",
    ALPHA_3: "COK",
    CODE: 184,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Costa Rica",
    ALPHA_2: "CR",
    ALPHA_3: "CRI",
    CODE: 188,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "CÔte D'ivoire",
    ALPHA_2: "CI",
    ALPHA_3: "CIV",
    CODE: 384,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Croatia",
    ALPHA_2: "HR",
    ALPHA_3: "HRV",
    CODE: 191,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cuba",
    ALPHA_2: "CU",
    ALPHA_3: "CUB",
    CODE: 192,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Curaçao",
    ALPHA_2: "CW",
    ALPHA_3: "CUW",
    CODE: 531,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cyprus",
    ALPHA_2: "CY",
    ALPHA_3: "CYP",
    CODE: 196,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Czech Republic",
    ALPHA_2: "CZ",
    ALPHA_3: "CZE",
    CODE: 203,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Denmark",
    ALPHA_2: "DK",
    ALPHA_3: "DNK",
    CODE: 208,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Djibouti",
    ALPHA_2: "DJ",
    ALPHA_3: "DJI",
    CODE: 262,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Dominica",
    ALPHA_2: "DM",
    ALPHA_3: "DMA",
    CODE: 212,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Dominican Republic",
    ALPHA_2: "DO",
    ALPHA_3: "DOM",
    CODE: 214,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ecuador",
    ALPHA_2: "EC",
    ALPHA_3: "ECU",
    CODE: 218,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Egypt",
    ALPHA_2: "EG",
    ALPHA_3: "EGY",
    CODE: 818,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "El Salvador",
    ALPHA_2: "SV",
    ALPHA_3: "SLV",
    CODE: 222,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Equatorial Guinea",
    ALPHA_2: "GQ",
    ALPHA_3: "GNQ",
    CODE: 226,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Eritrea",
    ALPHA_2: "ER",
    ALPHA_3: "ERI",
    CODE: 232,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Estonia",
    ALPHA_2: "EE",
    ALPHA_3: "EST",
    CODE: 233,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Swaziland",
    ALPHA_2: "SZ",
    ALPHA_3: "SWZ",
    CODE: 748,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ethiopia",
    ALPHA_2: "ET",
    ALPHA_3: "ETH",
    CODE: 231,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Falkland Islands (malvinas)",
    ALPHA_2: "FK",
    ALPHA_3: "FLK",
    CODE: 238,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Faroe Islands",
    ALPHA_2: "FO",
    ALPHA_3: "FRO",
    CODE: 234,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Fiji",
    ALPHA_2: "FJ",
    ALPHA_3: "FJI",
    CODE: 242,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Finland",
    ALPHA_2: "FI",
    ALPHA_3: "FIN",
    CODE: 246,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "France",
    ALPHA_2: "FR",
    ALPHA_3: "FRA",
    CODE: 250,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Guiana",
    ALPHA_2: "GF",
    ALPHA_3: "GUF",
    CODE: 254,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Polynesia",
    ALPHA_2: "PF",
    ALPHA_3: "PYF",
    CODE: 258,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Southern Territories",
    ALPHA_2: "TF",
    ALPHA_3: "ATF",
    CODE: 260,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Gabon",
    ALPHA_2: "GA",
    ALPHA_3: "GAB",
    CODE: 266,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "The Gambia",
    ALPHA_2: "GM",
    ALPHA_3: "GMB",
    CODE: 270,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Georgia",
    ALPHA_2: "GE",
    ALPHA_3: "GEO",
    CODE: 268,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Germany",
    ALPHA_2: "DE",
    ALPHA_3: "DEU",
    CODE: 276,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ghana",
    ALPHA_2: "GH",
    ALPHA_3: "GHA",
    CODE: 288,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Gibraltar",
    ALPHA_2: "GI",
    ALPHA_3: "GIB",
    CODE: 292,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Greece",
    ALPHA_2: "GR",
    ALPHA_3: "GRC",
    CODE: 300,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Greenland",
    ALPHA_2: "GL",
    ALPHA_3: "GRL",
    CODE: 304,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Grenada",
    ALPHA_2: "GD",
    ALPHA_3: "GRD",
    CODE: 308,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guadeloupe",
    ALPHA_2: "GP",
    ALPHA_3: "GLP",
    CODE: 312,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guam",
    ALPHA_2: "GU",
    ALPHA_3: "GUM",
    CODE: 316,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guatemala",
    ALPHA_2: "GT",
    ALPHA_3: "GTM",
    CODE: 320,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guernsey",
    ALPHA_2: "GG",
    ALPHA_3: "GGY",
    CODE: 831,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guinea",
    ALPHA_2: "GN",
    ALPHA_3: "GIN",
    CODE: 324,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guinea-Bissau",
    ALPHA_2: "GW",
    ALPHA_3: "GNB",
    CODE: 624,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guyana",
    ALPHA_2: "GY",
    ALPHA_3: "GUY",
    CODE: 328,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Haiti",
    ALPHA_2: "HT",
    ALPHA_3: "HTI",
    CODE: 332,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Heard Island And Mcdonald Islands",
    ALPHA_2: "HM",
    ALPHA_3: "HMD",
    CODE: 334,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Vatican City",
    ALPHA_2: "VA",
    ALPHA_3: "VAT",
    CODE: 336,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Honduras",
    ALPHA_2: "HN",
    ALPHA_3: "HND",
    CODE: 340,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Hong Kong",
    ALPHA_2: "HK",
    ALPHA_3: "HKG",
    CODE: 344,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Hungary",
    ALPHA_2: "HU",
    ALPHA_3: "HUN",
    CODE: 348,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iceland",
    ALPHA_2: "IS",
    ALPHA_3: "ISL",
    CODE: 352,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "India",
    ALPHA_2: "IN",
    ALPHA_3: "IND",
    CODE: 356,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Indonesia",
    ALPHA_2: "ID",
    ALPHA_3: "IDN",
    CODE: 360,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iran",
    ALPHA_2: "IR",
    ALPHA_3: "IRN",
    CODE: 364,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iraq",
    ALPHA_2: "IQ",
    ALPHA_3: "IRQ",
    CODE: 368,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ireland",
    ALPHA_2: "IE",
    ALPHA_3: "IRL",
    CODE: 372,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Isle Of Man",
    ALPHA_2: "IM",
    ALPHA_3: "IMN",
    CODE: 833,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Israel",
    ALPHA_2: "IL",
    ALPHA_3: "ISR",
    CODE: 376,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Italy",
    ALPHA_2: "IT",
    ALPHA_3: "ITA",
    CODE: 380,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jamaica",
    ALPHA_2: "JM",
    ALPHA_3: "JAM",
    CODE: 388,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Japan",
    ALPHA_2: "JP",
    ALPHA_3: "JPN",
    CODE: 392,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jersey",
    ALPHA_2: "JE",
    ALPHA_3: "JEY",
    CODE: 832,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jordan",
    ALPHA_2: "JO",
    ALPHA_3: "JOR",
    CODE: 400,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kazakhstan",
    ALPHA_2: "KZ",
    ALPHA_3: "KAZ",
    CODE: 398,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kenya",
    ALPHA_2: "KE",
    ALPHA_3: "KEN",
    CODE: 404,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kiribati",
    ALPHA_2: "KI",
    ALPHA_3: "KIR",
    CODE: 296,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "North Korea",
    ALPHA_2: "KP",
    ALPHA_3: "PRK",
    CODE: 408,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Korea",
    ALPHA_2: "KR",
    ALPHA_3: "KOR",
    CODE: 410,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kuwait",
    ALPHA_2: "KW",
    ALPHA_3: "KWT",
    CODE: 414,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kyrgyzstan",
    ALPHA_2: "KG",
    ALPHA_3: "KGZ",
    CODE: 417,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lao People's Democratic Republic",
    ALPHA_2: "LA",
    ALPHA_3: "LAO",
    CODE: 418,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Latvia",
    ALPHA_2: "LV",
    ALPHA_3: "LVA",
    CODE: 428,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lebanon",
    ALPHA_2: "LB",
    ALPHA_3: "LBN",
    CODE: 422,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lesotho",
    ALPHA_2: "LS",
    ALPHA_3: "LSO",
    CODE: 426,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Liberia",
    ALPHA_2: "LR",
    ALPHA_3: "LBR",
    CODE: 430,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Libya",
    ALPHA_2: "LY",
    ALPHA_3: "LBY",
    CODE: 434,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Liechtenstein",
    ALPHA_2: "LI",
    ALPHA_3: "LIE",
    CODE: 438,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lithuania",
    ALPHA_2: "LT",
    ALPHA_3: "LTU",
    CODE: 440,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Luxembourg",
    ALPHA_2: "LU",
    ALPHA_3: "LUX",
    CODE: 442,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Macao",
    ALPHA_2: "MO",
    ALPHA_3: "MAC",
    CODE: 446,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Republic of Macedonia",
    ALPHA_2: "MK",
    ALPHA_3: "MKD",
    CODE: 807,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Madagascar",
    ALPHA_2: "MG",
    ALPHA_3: "MDG",
    CODE: 450,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malawi",
    ALPHA_2: "MW",
    ALPHA_3: "MWI",
    CODE: 454,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malaysia",
    ALPHA_2: "MY",
    ALPHA_3: "MYS",
    CODE: 458,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Maldives",
    ALPHA_2: "MV",
    ALPHA_3: "MDV",
    CODE: 462,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mali",
    ALPHA_2: "ML",
    ALPHA_3: "MLI",
    CODE: 466,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malta",
    ALPHA_2: "MT",
    ALPHA_3: "MLT",
    CODE: 470,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Marshall Islands",
    ALPHA_2: "MH",
    ALPHA_3: "MHL",
    CODE: 584,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Martinique",
    ALPHA_2: "MQ",
    ALPHA_3: "MTQ",
    CODE: 474,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mauritania",
    ALPHA_2: "MR",
    ALPHA_3: "MRT",
    CODE: 478,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mauritius",
    ALPHA_2: "MU",
    ALPHA_3: "MUS",
    CODE: 480,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mayotte",
    ALPHA_2: "YT",
    ALPHA_3: "MYT",
    CODE: 175,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mexico",
    ALPHA_2: "MX",
    ALPHA_3: "MEX",
    CODE: 484,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Micronesia, Federated States Of",
    ALPHA_2: "FM",
    ALPHA_3: "FSM",
    CODE: 583,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Moldova",
    ALPHA_2: "MD",
    ALPHA_3: "MDA",
    CODE: 498,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Monaco",
    ALPHA_2: "MC",
    ALPHA_3: "MCO",
    CODE: 492,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mongolia",
    ALPHA_2: "MN",
    ALPHA_3: "MNG",
    CODE: 496,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Montenegro",
    ALPHA_2: "ME",
    ALPHA_3: "MNE",
    CODE: 499,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Montserrat",
    ALPHA_2: "MS",
    ALPHA_3: "MSR",
    CODE: 500,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Morocco",
    ALPHA_2: "MA",
    ALPHA_3: "MAR",
    CODE: 504,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mozambique",
    ALPHA_2: "MZ",
    ALPHA_3: "MOZ",
    CODE: 508,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burma",
    ALPHA_2: "MM",
    ALPHA_3: "MMR",
    CODE: 104,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Namibia",
    ALPHA_2: "NA",
    ALPHA_3: "NAM",
    CODE: 516,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nauru",
    ALPHA_2: "NR",
    ALPHA_3: "NRU",
    CODE: 520,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nepal",
    ALPHA_2: "NP",
    ALPHA_3: "NPL",
    CODE: 524,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Netherlands",
    ALPHA_2: "NL",
    ALPHA_3: "NLD",
    CODE: 528,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "New Caledonia",
    ALPHA_2: "NC",
    ALPHA_3: "NCL",
    CODE: 540,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "New Zealand",
    ALPHA_2: "NZ",
    ALPHA_3: "NZL",
    CODE: 554,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nicaragua",
    ALPHA_2: "NI",
    ALPHA_3: "NIC",
    CODE: 558,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Niger",
    ALPHA_2: "NE",
    ALPHA_3: "NER",
    CODE: 562,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nigeria",
    ALPHA_2: "NG",
    ALPHA_3: "NGA",
    CODE: 566,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Niue",
    ALPHA_2: "NU",
    ALPHA_3: "NIU",
    CODE: 570,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Norfolk Island",
    ALPHA_2: "NF",
    ALPHA_3: "NFK",
    CODE: 574,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Northern Mariana Islands",
    ALPHA_2: "MP",
    ALPHA_3: "MNP",
    CODE: 580,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Norway",
    ALPHA_2: "NO",
    ALPHA_3: "NOR",
    CODE: 578,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Oman",
    ALPHA_2: "OM",
    ALPHA_3: "OMN",
    CODE: 512,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Pakistan",
    ALPHA_2: "PK",
    ALPHA_3: "PAK",
    CODE: 586,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Palau",
    ALPHA_2: "PW",
    ALPHA_3: "PLW",
    CODE: 585,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Palestinian Territory",
    ALPHA_2: "PS",
    ALPHA_3: "PSE",
    CODE: 275,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Panama",
    ALPHA_2: "PA",
    ALPHA_3: "PAN",
    CODE: 591,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Papua New Guinea",
    ALPHA_2: "PG",
    ALPHA_3: "PNG",
    CODE: 598,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Paraguay",
    ALPHA_2: "PY",
    ALPHA_3: "PRY",
    CODE: 600,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Peru",
    ALPHA_2: "PE",
    ALPHA_3: "PER",
    CODE: 604,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Philippines",
    ALPHA_2: "PH",
    ALPHA_3: "PHL",
    CODE: 608,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Pitcairn",
    ALPHA_2: "PN",
    ALPHA_3: "PCN",
    CODE: 612,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Poland",
    ALPHA_2: "PL",
    ALPHA_3: "POL",
    CODE: 616,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Portugal",
    ALPHA_2: "PT",
    ALPHA_3: "PRT",
    CODE: 620,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Puerto Rico",
    ALPHA_2: "PR",
    ALPHA_3: "PRI",
    CODE: 630,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Qatar",
    ALPHA_2: "QA",
    ALPHA_3: "QAT",
    CODE: 634,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "RÉunion",
    ALPHA_2: "RE",
    ALPHA_3: "REU",
    CODE: 638,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Romania",
    ALPHA_2: "RO",
    ALPHA_3: "ROU",
    CODE: 642,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Russian Federation",
    ALPHA_2: "RU",
    ALPHA_3: "RUS",
    CODE: 643,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Rwanda",
    ALPHA_2: "RW",
    ALPHA_3: "RWA",
    CODE: 646,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Barthélemy",
    ALPHA_2: "BL",
    ALPHA_3: "BLM",
    CODE: 652,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Helena",
    ALPHA_2: "SH",
    ALPHA_3: "SHN",
    CODE: 654,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Kitts And Nevis",
    ALPHA_2: "KN",
    ALPHA_3: "KNA",
    CODE: 659,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Lucia",
    ALPHA_2: "LC",
    ALPHA_3: "LCA",
    CODE: 662,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Martin (French part)",
    ALPHA_2: "MF",
    ALPHA_3: "MAF",
    CODE: 663,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Pierre And Miquelon",
    ALPHA_2: "PM",
    ALPHA_3: "SPM",
    CODE: 666,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Vincent and the Grenadines",
    ALPHA_2: "VC",
    ALPHA_3: "VCT",
    CODE: 670,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Samoa",
    ALPHA_2: "WS",
    ALPHA_3: "WSM",
    CODE: 882,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "San Marino",
    ALPHA_2: "SM",
    ALPHA_3: "SMR",
    CODE: 674,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sao Tome And Principe",
    ALPHA_2: "ST",
    ALPHA_3: "STP",
    CODE: 678,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saudi Arabia",
    ALPHA_2: "SA",
    ALPHA_3: "SAU",
    CODE: 682,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Senegal",
    ALPHA_2: "SN",
    ALPHA_3: "SEN",
    CODE: 686,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Serbia",
    ALPHA_2: "RS",
    ALPHA_3: "SRB",
    CODE: 688,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Seychelles",
    ALPHA_2: "SC",
    ALPHA_3: "SYC",
    CODE: 690,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sierra Leone",
    ALPHA_2: "SL",
    ALPHA_3: "SLE",
    CODE: 694,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Singapore",
    ALPHA_2: "SG",
    ALPHA_3: "SGP",
    CODE: 702,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sint Maarten (Dutch part)",
    ALPHA_2: "SX",
    ALPHA_3: "SXM",
    CODE: 534,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Slovakia",
    ALPHA_2: "SK",
    ALPHA_3: "SVK",
    CODE: 703,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Slovenia",
    ALPHA_2: "SI",
    ALPHA_3: "SVN",
    CODE: 705,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Solomon Islands",
    ALPHA_2: "SB",
    ALPHA_3: "SLB",
    CODE: 90,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Somalia",
    ALPHA_2: "SO",
    ALPHA_3: "SOM",
    CODE: 706,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Africa",
    ALPHA_2: "ZA",
    ALPHA_3: "ZAF",
    CODE: 710,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Georgia And The South Sandwich Islands",
    ALPHA_2: "GS",
    ALPHA_3: "SGS",
    CODE: 239,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Sudan",
    ALPHA_2: "SS",
    ALPHA_3: "SSD",
    CODE: 728,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Spain",
    ALPHA_2: "ES",
    ALPHA_3: "ESP",
    CODE: 724,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sri Lanka",
    ALPHA_2: "LK",
    ALPHA_3: "LKA",
    CODE: 144,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sudan",
    ALPHA_2: "SD",
    ALPHA_3: "SDN",
    CODE: 729,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Suriname",
    ALPHA_2: "SR",
    ALPHA_3: "SUR",
    CODE: 740,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Svalbard And Jan Mayen",
    ALPHA_2: "SJ",
    ALPHA_3: "SJM",
    CODE: 744,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sweden",
    ALPHA_2: "SE",
    ALPHA_3: "SWE",
    CODE: 752,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Switzerland",
    ALPHA_2: "CH",
    ALPHA_3: "CHE",
    CODE: 756,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Syrian Arab Republic",
    ALPHA_2: "SY",
    ALPHA_3: "SYR",
    CODE: 760,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Taiwan",
    ALPHA_2: "TW",
    ALPHA_3: "TWN",
    CODE: 158,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tajikistan",
    ALPHA_2: "TJ",
    ALPHA_3: "TJK",
    CODE: 762,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tanzania, United Republic Of",
    ALPHA_2: "TZ",
    ALPHA_3: "TZA",
    CODE: 834,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Thailand",
    ALPHA_2: "TH",
    ALPHA_3: "THA",
    CODE: 764,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "East Timor",
    ALPHA_2: "TL",
    ALPHA_3: "TLS",
    CODE: 626,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Togo",
    ALPHA_2: "TG",
    ALPHA_3: "TGO",
    CODE: 768,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tokelau",
    ALPHA_2: "TK",
    ALPHA_3: "TKL",
    CODE: 772,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tonga",
    ALPHA_2: "TO",
    ALPHA_3: "TON",
    CODE: 776,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Trinidad And Tobago",
    ALPHA_2: "TT",
    ALPHA_3: "TTO",
    CODE: 780,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tunisia",
    ALPHA_2: "TN",
    ALPHA_3: "TUN",
    CODE: 788,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turkey",
    ALPHA_2: "TR",
    ALPHA_3: "TUR",
    CODE: 792,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turkmenistan",
    ALPHA_2: "TM",
    ALPHA_3: "TKM",
    CODE: 795,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turks And Caicos Islands",
    ALPHA_2: "TC",
    ALPHA_3: "TCA",
    CODE: 796,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tuvalu",
    ALPHA_2: "TV",
    ALPHA_3: "TUV",
    CODE: 798,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uganda",
    ALPHA_2: "UG",
    ALPHA_3: "UGA",
    CODE: 800,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ukraine",
    ALPHA_2: "UA",
    ALPHA_3: "UKR",
    CODE: 804,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United Arab Emirates",
    ALPHA_2: "AE",
    ALPHA_3: "ARE",
    CODE: 784,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United Kingdom",
    ALPHA_2: "GB",
    ALPHA_3: "GBR",
    CODE: 826,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United States",
    ALPHA_2: "US",
    ALPHA_3: "USA",
    CODE: 840,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United States Minor Outlying Islands",
    ALPHA_2: "UM",
    ALPHA_3: "UMI",
    CODE: 581,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uruguay",
    ALPHA_2: "UY",
    ALPHA_3: "URY",
    CODE: 858,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uzbekistan",
    ALPHA_2: "UZ",
    ALPHA_3: "UZB",
    CODE: 860,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Vanuatu",
    ALPHA_2: "VU",
    ALPHA_3: "VUT",
    CODE: 548,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Venezuela",
    ALPHA_2: "VE",
    ALPHA_3: "VEN",
    CODE: 862,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Viet Nam",
    ALPHA_2: "VN",
    ALPHA_3: "VNM",
    CODE: 704,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "British Virgin Islands",
    ALPHA_2: "VG",
    ALPHA_3: "VGB",
    CODE: 92,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Virgin Islands, U.s.",
    ALPHA_2: "VI",
    ALPHA_3: "VIR",
    CODE: 850,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Wallis And Futuna",
    ALPHA_2: "WF",
    ALPHA_3: "WLF",
    CODE: 876,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Western Sahara",
    ALPHA_2: "EH",
    ALPHA_3: "ESH",
    CODE: 732,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Yemen",
    ALPHA_2: "YE",
    ALPHA_3: "YEM",
    CODE: 887,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Zambia",
    ALPHA_2: "ZM",
    ALPHA_3: "ZMB",
    CODE: 894,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Zimbabwe",
    ALPHA_2: "ZW",
    ALPHA_3: "ZWE",
    CODE: 716,
    HAS_AUDIENCE: !0
  }
], sB = ({ countryCode: e }) => {
  const t = e?.toUpperCase();
  return rB.find(
    (r) => r.ALPHA_2 === t || r.ALPHA_3 === t || r.NAME.toUpperCase() === t
  );
}, Rp = {
  subscribers: {
    key: "creator-widget.subscribers",
    defaultValue: "Inscritos"
  },
  engagement: {
    key: "creator-widget.engagement",
    defaultValue: "Engajamento/Vídeo"
  }
}, iB = ({ creator: e, workspaceId: t, t: n }) => ({
  data: ie(() => {
    if (!e || !t) return;
    const s = En(Jn[te.CREATOR], {
      id: e.id,
      provider: e.provider
    }), i = e.performance?.analytics;
    return {
      title: e.title,
      hasTrendTag: e.isTrending,
      creatorUrl: s,
      provider: e.provider,
      thumbnail: {
        imageUrl: e.thumbnail ?? ""
      },
      description: sB({ countryCode: e.country ?? "" })?.NAME,
      metrics: {
        data: [
          { title: n(Rp.subscribers), value: Wt(e.subscribers) },
          {
            title: n(Rp.engagement),
            value: Wt(i?.avgEngagement ?? 0),
            variation: i?.avgEngagementVariation && i.avgEngagementVariation !== 0 ? {
              value: `${Math.abs(i.avgEngagementVariation * 100).toFixed(1)}%`,
              sign: i.avgEngagementVariation > 0 ? "positive" : "negative"
            } : void 0
          }
        ]
      }
    };
  }, [t, e, n])
}), aB = () => /* @__PURE__ */ d.jsxs("div", { className: "flex w-full h-full gap-4", children: [
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-[100px] h-full min-h-[112px] shrink-0" }),
  /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col w-full h-[100%] gap-6", children: [
    /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }),
    /* @__PURE__ */ d.jsxs("div", { className: "flex w-full gap-6", children: [
      /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-2 w-[40%]", children: [
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }),
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-[80%] h-[10px]" })
      ] }),
      /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-2 w-[40%]", children: [
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }),
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-[80%] h-[10px]" })
      ] })
    ] })
  ] })
] }), oB = he(aB), uB = ({ data: e, refetch: t, showError: n, showLoading: r, theme: s }) => /* @__PURE__ */ d.jsx("div", { className: "w-[324px] min-h-[112px] mt-[20px] mb-[40px] px-4 flex float-left", children: /* @__PURE__ */ d.jsx(
  Mr,
  {
    isLoading: r,
    isError: n,
    loadingComponent: /* @__PURE__ */ d.jsx(oB, {}),
    errorComponent: /* @__PURE__ */ d.jsx(Ss, { name: "creator", refetch: t }),
    children: e && /* @__PURE__ */ d.jsx(
      sn.CreatorCardDefault,
      {
        ...e,
        theme: s,
        thumbnail: {
          ...e.thumbnail,
          IconProvider: /* @__PURE__ */ d.jsx(
            sn.Icon,
            {
              name: Tc[e.provider],
              width: 24,
              height: Tc[e.provider] === "youtube" ? 17 : 24
            }
          )
        }
      }
    )
  }
) }), cB = he(uB), lB = ({ creatorId: e, performanceInMonths: t }) => {
  const { workspaceId: n } = pt(), r = ar(), { t: s } = Fe(), {
    data: i,
    fetch: a,
    isError: o,
    isLoading: u
  } = nB({
    creatorId: e,
    performanceInMonths: t
  }), c = iB({
    workspaceId: n,
    creator: i,
    t: s
  });
  return /* @__PURE__ */ d.jsx(
    cB,
    {
      ...c,
      theme: r,
      showError: o,
      showLoading: u,
      refetch: a
    }
  );
}, dB = he(lB), hB = ({ postId: e }) => {
  const { workspaceId: t } = pt(), n = Lr(), [r, s] = de(!1), [i, a] = de(!1), [o, u] = de(null), c = ne(async () => {
    const l = `/api/workspace/${t}/posts/${e}`;
    if (!(!e || !t))
      try {
        s(!0), a(!1);
        const h = await n.getPostData(e);
        u(h);
      } catch (h) {
        console.error({
          log: "Zai Chat - Error to fetch post from backend",
          query: { name: l, variables: { postId: e } },
          error: h
        }), a(!0);
      } finally {
        s(!1);
      }
  }, [t, e, n]);
  return xe(() => {
    c();
  }, [c]), {
    isLoading: r,
    isError: i,
    data: o,
    fetch: c
  };
};
var _a = { exports: {} }, fB = _a.exports, Pp;
function pB() {
  return Pp || (Pp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(fB, (function() {
      return function(n, r, s) {
        n = n || {};
        var i = r.prototype, a = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function o(c, l, h, m) {
          return i.fromToBase(c, l, h, m);
        }
        s.en.relativeTime = a, i.fromToBase = function(c, l, h, m, p) {
          for (var E, g, _, b = h.$locale().relativeTime || a, T = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], C = T.length, R = 0; R < C; R += 1) {
            var D = T[R];
            D.d && (E = m ? s(c).diff(h, D.d, !0) : h.diff(c, D.d, !0));
            var I = (n.rounding || Math.round)(Math.abs(E));
            if (_ = E > 0, I <= D.r || !D.r) {
              I <= 1 && R > 0 && (D = T[R - 1]);
              var O = b[D.l];
              p && (I = p("" + I)), g = typeof O == "string" ? O.replace("%d", I) : O(I, l, D.l, _);
              break;
            }
          }
          if (l) return g;
          var U = _ ? b.future : b.past;
          return typeof U == "function" ? U(g) : U.replace("%s", g);
        }, i.to = function(c, l) {
          return o(c, l, this, !0);
        }, i.from = function(c, l) {
          return o(c, l, this);
        };
        var u = function(c) {
          return c.$u ? s.utc() : s();
        };
        i.toNow = function(c) {
          return this.to(u(this), c);
        }, i.fromNow = function(c) {
          return this.from(u(this), c);
        };
      };
    }));
  })(_a)), _a.exports;
}
var mB = pB();
const gB = /* @__PURE__ */ Rr(mB);
var Ta = { exports: {} }, EB = Ta.exports, Op;
function bB() {
  return Op || (Op = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(EB, (function() {
      var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
      return function(i, a, o) {
        var u = a.prototype;
        o.utc = function(g) {
          var _ = { date: g, utc: !0, args: arguments };
          return new a(_);
        }, u.utc = function(g) {
          var _ = o(this.toDate(), { locale: this.$L, utc: !0 });
          return g ? _.add(this.utcOffset(), n) : _;
        }, u.local = function() {
          return o(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = u.parse;
        u.parse = function(g) {
          g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
        };
        var l = u.init;
        u.init = function() {
          if (this.$u) {
            var g = this.$d;
            this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
          } else l.call(this);
        };
        var h = u.utcOffset;
        u.utcOffset = function(g, _) {
          var b = this.$utils().u;
          if (b(g)) return this.$u ? 0 : b(this.$offset) ? h.call(this) : this.$offset;
          if (typeof g == "string" && (g = (function(D) {
            D === void 0 && (D = "");
            var I = D.match(r);
            if (!I) return null;
            var O = ("" + I[0]).match(s) || ["-", 0, 0], U = O[0], q = 60 * +O[1] + +O[2];
            return q === 0 ? 0 : U === "+" ? q : -q;
          })(g), g === null)) return this;
          var T = Math.abs(g) <= 16 ? 60 * g : g;
          if (T === 0) return this.utc(_);
          var C = this.clone();
          if (_) return C.$offset = T, C.$u = !1, C;
          var R = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (C = this.local().add(T + R, n)).$offset = T, C.$x.$localOffset = R, C;
        };
        var m = u.format;
        u.format = function(g) {
          var _ = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return m.call(this, _);
        }, u.valueOf = function() {
          var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * g;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var p = u.toDate;
        u.toDate = function(g) {
          return g === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
        };
        var E = u.diff;
        u.diff = function(g, _, b) {
          if (g && this.$u === g.$u) return E.call(this, g, _, b);
          var T = this.local(), C = o(g).local();
          return E.call(T, C, _, b);
        };
      };
    }));
  })(Ta)), Ta.exports;
}
var _B = bB();
const TB = /* @__PURE__ */ Rr(_B);
var Aa = { exports: {} }, AB = Aa.exports, Dp;
function yB() {
  return Dp || (Dp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(AB, (function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
        var r = ["th", "st", "nd", "rd"], s = n % 100;
        return "[" + n + (r[(s - 20) % 10] || r[s] || r[0]) + "]";
      } };
    }));
  })(Aa)), Aa.exports;
}
yB();
var ya = { exports: {} }, xB = ya.exports, Lp;
function CB() {
  return Lp || (Lp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(hd());
    })(xB, (function(n) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var s = r(n), i = { name: "pt-br", weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"), weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"), weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"), months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"), monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"), ordinal: function(a) {
        return a + "º";
      }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY [às] HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm" }, relativeTime: { future: "em %s", past: "há %s", s: "poucos segundos", m: "um minuto", mm: "%d minutos", h: "uma hora", hh: "%d horas", d: "um dia", dd: "%d dias", M: "um mês", MM: "%d meses", y: "um ano", yy: "%d anos" } };
      return s.default.locale(i, null, !0), i;
    }));
  })(ya)), ya.exports;
}
CB();
var xa = { exports: {} }, SB = xa.exports, Mp;
function IB() {
  return Mp || (Mp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(hd());
    })(SB, (function(n) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var s = r(n), i = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(a) {
        return a + "º";
      } };
      return s.default.locale(i, null, !0), i;
    }));
  })(xa)), xa.exports;
}
IB();
xr.extend(gB);
xr.extend(TB);
const md = class md {
  static formatDate(t, n = "MMM YYYY") {
    return xr(t).format(n);
  }
};
md.getFormattedRelativeTime = (t, n) => xr(t).locale(n.toLowerCase()).fromNow();
let Wn = md;
const wB = ({ post: e, workspaceId: t, currentLanguage: n }) => ({
  data: ie(() => {
    if (!e || !t) return;
    const s = En(Jn[te.POST], {
      id: e.id,
      provider: e.provider,
      panelId: t
    });
    return {
      creatorUrl: e?.creator?.id && e?.creator?.provider ? En(Jn[te.CREATOR], {
        id: e?.creator?.id,
        provider: e?.creator?.provider
      }) : void 0,
      videoUrl: s,
      provider: e?.provider,
      thumbnail: {
        imageUrl: e?.thumbnail ?? ""
      },
      description: e?.title,
      metrics: {
        data: [
          { title: "Views", value: Wt(e?.views) },
          { title: "Likes", value: Wt(e?.likes) }
        ]
      },
      creator: {
        title: e?.creator?.title,
        description: Wn.getFormattedRelativeTime(e?.publishedAt, n),
        thumbnail: e?.creator?.thumbnail ?? ""
      }
    };
  }, [t, e, n])
}), vB = () => /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col w-full h-[312px] gap-4", children: [
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-[100%] h-[100%]" }),
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-[80%] h-4" }),
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-[50%] h-4" })
] }), NB = he(vB), kB = ({ data: e, refetch: t, showError: n, showLoading: r, theme: s }) => /* @__PURE__ */ d.jsx("div", { className: "w-[324px] min-h-[312px] mt-[20px] mb-[40px] px-4 flex float-left", children: /* @__PURE__ */ d.jsx(
  Mr,
  {
    isLoading: r,
    isError: n,
    loadingComponent: /* @__PURE__ */ d.jsx(NB, {}),
    errorComponent: /* @__PURE__ */ d.jsx(Ss, { name: "video", refetch: t }),
    children: e && /* @__PURE__ */ d.jsx(
      sn.VideoCardDefault,
      {
        ...e,
        theme: s,
        thumbnail: {
          ...e.thumbnail,
          IconProvider: /* @__PURE__ */ d.jsx(sn.Icon, { name: Tc[e.provider], width: 30, height: 30 })
        }
      }
    )
  }
) }), RB = he(kB), PB = ({ postId: e }) => {
  const { workspaceId: t } = pt(), n = ar(), { language: r } = vi(), {
    data: s,
    fetch: i,
    isError: a,
    isLoading: o
  } = hB({
    postId: e
  }), u = wB({
    workspaceId: t,
    post: s,
    currentLanguage: r
  });
  return /* @__PURE__ */ d.jsx(RB, { ...u, theme: n, showError: a, showLoading: o, refetch: i });
}, OB = he(PB), Cr = {
  categoryInfo: (e) => ({
    key: "share-of-attention-widget.category-info",
    parameters: e,
    defaultValue: "Categoria: {category} - País: {country} - Período: {period}"
  }),
  accessMacroarea: {
    key: "share-of-attention-widget.access-macroarea",
    defaultValue: "Acessar SoA"
  },
  emptyText: {
    key: "share-of-attention-widget.empty-text",
    defaultValue: "Dados insuficientes para exibir o gráfico no momento"
  },
  columnChart: {
    key: "share-of-attention-widget.column-chart",
    defaultValue: "Gráfico de Colunas"
  },
  lineChart: {
    key: "share-of-attention-widget.line-chart",
    defaultValue: "Gráfico de Linhas"
  },
  quarter: (e) => ({
    key: "share-of-attention-widget.quarter",
    parameters: e,
    defaultValue: "{quarter}º Trimestre"
  }),
  halfYear: (e) => ({
    key: "share-of-attention-widget.half-year",
    parameters: e,
    defaultValue: "{semester}º Semestre"
  })
}, DB = () => Intl.DateTimeFormat().resolvedOptions().timeZone, uT = (e, t) => {
  const n = Math.ceil((e.getUTCMonth() + 1) / 3);
  return t ? t(Cr.quarter({ quarter: n })) : `${n}º Trimestre`;
}, cT = (e, t) => {
  const n = e.getUTCMonth() + 1 <= 6 ? 1 : 2;
  return t ? t(Cr.halfYear({ semester: n })) : `${n}º Semestre`;
}, LB = (e, t, n = {}) => {
  const { timezone: r = DB(), locale: s = "en-US", translate: i } = n, a = new Date(e), o = {
    timeZone: r
  };
  switch (t) {
    case "monthly":
      return new Intl.DateTimeFormat(s, {
        ...o,
        month: "short"
      }).format(a);
    case "daily":
      return new Intl.DateTimeFormat("en-GB", {
        ...o,
        day: "2-digit",
        month: "2-digit"
      }).format(a);
    case "full":
      return new Intl.DateTimeFormat(s, {
        ...o,
        year: "numeric",
        month: "short",
        day: "numeric"
      }).format(a);
    case "quarterly":
      return uT(a, i);
    case "halfYearly":
      return cT(a, i);
    default:
      return e;
  }
}, MB = (e, t, n = "en-US", r) => LB(e, t, { timezone: "UTC", locale: n, translate: r }), Hp = (e, t, n) => {
  const r = new Date(e);
  switch (t) {
    case "monthly":
      return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        month: "short",
        year: "numeric"
      }).format(r);
    case "daily":
    case "weekly":
      return new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }).format(r);
    case "quarterly":
      return uT(r, n);
    case "halfYearly":
      return cT(r, n);
    default:
      return e;
  }
}, HB = ({
  period: e = "monthly",
  year: t = (/* @__PURE__ */ new Date()).getFullYear()
} = {}) => {
  const n = vo.isEnabled("isSOAV3WithZaiEnabled"), { t: r } = Fe(), { workspaceId: s } = pt(), i = Lr(), a = En(Jn[te.SHARE_OF_ATTENTION_V2], {
    panelId: s
  }), [o, u] = de(null), [c, l] = de(!1), [h, m] = de(!1), [p, E] = de("column"), g = ne(async () => {
    if (s) {
      l(!0), m(!1);
      try {
        const I = await i.getShareOfAttentionData(
          {
            period: e,
            year: t.toString()
          },
          { isSOAV3WithZaiEnabled: n }
        );
        u(I);
      } catch {
        m(!0), u(null);
      } finally {
        l(!1);
      }
    }
  }, [s, e, t, i, n]);
  xe(() => {
    g();
  }, [g]);
  const _ = ie(() => !o?.brands || o.brands.length === 0 ? [] : [...new Set(o.brands.flatMap((I) => I.scores.map((O) => O.date)))].sort(
    (I, O) => I.localeCompare(O)
  ), [o?.brands]), b = ie(() => o?.brands ? o.brands.map((I) => {
    const O = new Map(I.scores.map((U) => [U.date, U.value]));
    return {
      name: I.name,
      color: I.color,
      series: _.map((U) => O.get(U) ?? 0)
    };
  }) : [], [o, _]), T = ie(() => _.map((I) => MB(I, e, "en-US", r)), [_, e, r]), C = ie(() => {
    if (!o?.category || _.length === 0) return "";
    const I = _[0], O = _[_.length - 1], U = `${Hp(I, e, r)} - ${Hp(O, e, r)}`;
    return r(
      Cr.categoryInfo({
        category: o.category.name,
        country: o.category.country,
        period: U
      })
    );
  }, [_, o?.category, e, r]), R = ie(
    () => b.flatMap((I) => I.series).every((I) => I === 0),
    [b]
  ), D = ie(() => [
    { value: "column", label: r(Cr.columnChart) },
    { value: "line", label: r(Cr.lineChart) }
  ], [r]);
  return {
    data: o,
    isLoading: c,
    isError: h,
    isEmpty: R,
    refetch: g,
    chartEntities: b,
    chartLabels: T,
    categoryInfo: C,
    macroareaURL: a,
    chartType: p,
    onChartTypeChange: E,
    chartTypeOptions: D
  };
};
function BB({ ...e }) {
  return /* @__PURE__ */ d.jsx(rw, { "data-slot": "select", ...e });
}
function UB({ ...e }) {
  return /* @__PURE__ */ d.jsx(iw, { "data-slot": "select-value", ...e });
}
function FB({
  className: e,
  size: t = "default",
  children: n,
  ...r
}) {
  return /* @__PURE__ */ d.jsxs(
    sw,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: le(
        "border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ d.jsx(aw, { asChild: !0, children: /* @__PURE__ */ d.jsx(TE, { className: "size-4 opacity-50" }) })
      ]
    }
  );
}
function jB({
  className: e,
  children: t,
  position: n = "popper",
  align: r = "center",
  ...s
}) {
  const i = Io();
  return /* @__PURE__ */ d.jsx(ow, { container: i ?? void 0, children: /* @__PURE__ */ d.jsxs(
    uw,
    {
      "data-slot": "select-content",
      className: le(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: r,
      ...s,
      children: [
        /* @__PURE__ */ d.jsx(zB, {}),
        /* @__PURE__ */ d.jsx(
          cw,
          {
            className: le(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ d.jsx(VB, {})
      ]
    }
  ) });
}
function $B({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ d.jsxs(
    lw,
    {
      "data-slot": "select-item",
      className: le(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ d.jsx(hw, { children: /* @__PURE__ */ d.jsx(So, { className: "size-4" }) }) }),
        /* @__PURE__ */ d.jsx(dw, { children: t })
      ]
    }
  );
}
function zB({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    fw,
    {
      "data-slot": "select-scroll-up-button",
      className: le("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ d.jsx(Vv, { className: "size-4" })
    }
  );
}
function VB({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d.jsx(
    pw,
    {
      "data-slot": "select-scroll-down-button",
      className: le("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ d.jsx(TE, { className: "size-4" })
    }
  );
}
const YB = () => /* @__PURE__ */ d.jsx("div", { className: "flex justify-between items-end gap-2 px-4 h-112 w-full", children: Array.from({ length: 13 }).map((e, t) => /* @__PURE__ */ d.jsx(
  kt,
  {
    className: "bg-gray-600 rounded-lg flex-1 h-full"
  },
  `share-of-attention-widget-skeleton-item-${t}`
)) }), GB = ({
  categoryInfo: e,
  chartEntities: t,
  chartLabels: n,
  chartType: r,
  chartTypeOptions: s,
  isError: i,
  isEmpty: a,
  isLoading: o,
  macroareaURL: u,
  refetch: c,
  onChartTypeChange: l
}) => {
  const { t: h } = Fe(), m = ar();
  return /* @__PURE__ */ d.jsxs("div", { className: "w-full flex flex-col gap-5", children: [
    /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: e }),
    /* @__PURE__ */ d.jsxs("div", { className: "flex gap-2.5 justify-end items-center", children: [
      /* @__PURE__ */ d.jsxs(BB, { value: r, onValueChange: l, "aria-label": "Select Chart Type", children: [
        /* @__PURE__ */ d.jsx(FB, { className: "w-[180px] bg-secondary text-secondary-foreground hover:bg-secondary/80 border border-foreground/50", children: /* @__PURE__ */ d.jsx(UB, {}) }),
        /* @__PURE__ */ d.jsx(jB, { children: s.map((p) => /* @__PURE__ */ d.jsx($B, { value: p.value, children: p.label }, p.value)) })
      ] }),
      !i && /* @__PURE__ */ d.jsx(It, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: u, target: "_blank", rel: "noopener noreferrer", children: h(Cr.accessMacroarea) }) })
    ] }),
    /* @__PURE__ */ d.jsx(
      Mr,
      {
        isLoading: o,
        isError: i,
        isEmpty: a,
        loadingComponent: /* @__PURE__ */ d.jsx(YB, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ss, { name: "chart", refetch: c }),
        emptyComponent: /* @__PURE__ */ d.jsx("p", { className: "text-neutral-500 font-bold text-center", children: h(Cr.emptyText) }),
        children: r === "column" ? /* @__PURE__ */ d.jsx(
          sn.ColumnsChart,
          {
            isStacked: !0,
            theme: m,
            entities: t,
            xAxisLabels: n,
            yAxisOptions: { min: 0, max: 100, labelFormatType: "percent" },
            tooltip: { type: "default", valueFormatType: "percent", props: { followPointer: !0 } },
            legend: { type: "default", toggleHideDisabled: !0 },
            scrollablePlotArea: { minWidth: n.length > 10 ? 1300 : void 0 },
            height: 600
          }
        ) : /* @__PURE__ */ d.jsx(
          sn.LineChart,
          {
            legend: { type: "default" },
            entities: t,
            xAxisLabels: n,
            tooltip: { type: "default", valueFormatType: "percent" },
            yAxisOptions: { labelFormatType: "percent" },
            theme: m,
            height: 600
          }
        )
      }
    )
  ] });
}, zu = (e) => {
  const t = HB(e);
  return /* @__PURE__ */ d.jsx(GB, { ...t });
};
function Vu(e, t) {
  return {
    id: `${e.name}-${e.color}`,
    name: e.name,
    y: t,
    x: Wt(t, 2),
    color: e.color
  };
}
const WB = ({
  provider: e = "all",
  territoryType: t = "grouped",
  timeRangeInDays: n = 30
}) => {
  const { workspaceId: r } = pt(), s = Lr(), { t: i } = Fe(), a = ie(() => {
    const b = En(
      Jn[te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS],
      {
        panelId: r,
        tab: ls[t] || ls.grouped
      }
    ), T = lb({ provider: e, timeRangeInDays: n }).toString();
    return T ? `${b}?${T}` : b;
  }, [e, t, n, r]), [o, u] = de([]), [c, l] = de(!1), [h, m] = de(!1), p = ne(async () => {
    if (r) {
      l(!0), m(!1);
      try {
        const b = vo.isEnabled("isNewPageBrandOverviewEnabled"), T = await s.getSharesData(
          {
            provider: e?.toString(),
            territoryType: t,
            timeRangeInDays: n?.toString()
          },
          { isNewPageBrandOverviewEnabled: b }
        );
        u(T);
      } catch {
        m(!0), u([]);
      } finally {
        l(!1);
      }
    }
  }, [r, e, t, n, s]);
  xe(() => {
    p();
  }, [p]);
  const E = ie(() => o.reduce(
    (b, T) => ({
      engagement: b.engagement + T.totalEngagement,
      views: b.views + T.totalViews,
      content: b.content + T.totalPosts
    }),
    { engagement: 0, views: 0, content: 0 }
  ), [o]), g = ie(() => {
    const b = o.reduce(
      (T, C) => (T.engagement.push(Vu(C, C.totalEngagement)), T.views.push(Vu(C, C.totalViews)), T.content.push(Vu(C, C.totalPosts)), T),
      { engagement: [], views: [], content: [] }
    );
    return b.engagement.sort((T, C) => C.y - T.y), b.views.sort((T, C) => C.y - T.y), b.content.sort((T, C) => C.y - T.y), b;
  }, [o]), _ = ie(() => {
    const b = Ol[e], T = aT(t, i), C = dd(n, i);
    return [b, T, C].join(" · ");
  }, [e, t, n, i]);
  return {
    data: o,
    isLoading: c,
    isError: h,
    refetch: p,
    chartEntities: g,
    totals: E,
    macroareaURL: a,
    subtitle: _
  };
}, gr = {
  accessMacroarea: {
    key: "shares-widget.access-macroarea",
    defaultValue: "Acessar visão geral"
  },
  shareOfEngagement: {
    key: "shares-widget.share-of-engagement",
    defaultValue: "Share de engajamento"
  },
  shareOfViews: {
    key: "shares-widget.share-of-views",
    defaultValue: "Share de visualizações"
  },
  shareOfContent: {
    key: "shares-widget.share-of-content",
    defaultValue: "Share de conteúdo"
  },
  total: {
    key: "shares-widget.total",
    defaultValue: "Total"
  }
}, qB = () => /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col w-full py-5 ", children: [
  /* @__PURE__ */ d.jsx("div", { className: "flex flex-col md:flex-row justify-between items-center gap-8", children: Array.from({ length: 3 }).map((e, t) => /* @__PURE__ */ d.jsx("div", { className: "flex flex-col items-center flex-1", children: /* @__PURE__ */ d.jsx("div", { className: "mb-4", children: /* @__PURE__ */ d.jsx(Gk, { index: t }) }) }, `shares-widget-skeleton-${t}`)) }),
  /* @__PURE__ */ d.jsx("div", { className: "flex flex-wrap justify-center items-center gap-8 mt-4", children: Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-24 h-4" }, t)) })
] }), Yu = ({
  totalTitle: e,
  totalValue: t,
  theme: n
}) => {
  const r = n === "dark" ? "#FFFFFF" : "#000000";
  return `
    <div style="text-align: center; line-height: 18px;">
      <span style="font-size: 12px; color: ${r};">${e}</span><br/>
      <span style="font-size: 16px; font-weight: 700; color: ${r};">${t}</span>
    </div>
  `;
}, KB = ({
  isLoading: e,
  isError: t,
  chartEntities: n,
  totals: r,
  macroareaURL: s,
  refetch: i,
  subtitle: a
}) => {
  const { t: o } = Fe(), u = ar(), { engagement: c, content: l, views: h } = n;
  return /* @__PURE__ */ d.jsxs("div", { className: "my-5 w-full flex flex-col gap-6", children: [
    a && /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: a }),
    /* @__PURE__ */ d.jsx(
      Mr,
      {
        isLoading: e,
        isError: t,
        loadingComponent: /* @__PURE__ */ d.jsx(qB, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ss, { name: "chart", refetch: i }),
        children: /* @__PURE__ */ d.jsx(
          sn.SyncMultipleDonut,
          {
            theme: u,
            syncOptions: ["highlight", "tooltip"],
            chartsGroup: [
              {
                id: "share-of-engagement-widget",
                titleOptions: {
                  text: o(gr.shareOfEngagement)
                },
                entities: c,
                centerHtmlContent: Yu({
                  totalTitle: o(gr.total),
                  totalValue: Wt(r.engagement, 1),
                  theme: u
                })
              },
              {
                id: "share-of-views-widget",
                titleOptions: {
                  text: o(gr.shareOfViews)
                },
                entities: h,
                centerHtmlContent: Yu({
                  totalTitle: o(gr.total),
                  totalValue: Wt(r.views, 1),
                  theme: u
                })
              },
              {
                id: "share-of-content-widget",
                titleOptions: {
                  text: o(gr.shareOfContent)
                },
                entities: l,
                centerHtmlContent: Yu({
                  totalTitle: o(gr.total),
                  totalValue: Wt(r.content, 1),
                  theme: u
                })
              }
            ],
            yAxisOptions: { labelFormatType: "percent" },
            tooltip: { type: "inline", valueFormatType: "percent", props: { followPointer: !1 } },
            hasLegend: !0,
            dataLabels: { filter: { operator: ">", property: "percentage", value: 6 }, style: { fontSize: "12px" } },
            height: "120%"
          }
        )
      }
    ),
    !t && /* @__PURE__ */ d.jsx(It, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: s, target: "_blank", rel: "noopener noreferrer", children: o(gr.accessMacroarea) }) })
  ] });
}, QB = (e) => {
  const t = WB(e);
  return /* @__PURE__ */ d.jsx(KB, { ...t });
}, Mc = {
  emptyText: {
    key: "zai.widget.territory-relevance.empty-text",
    defaultValue: "Nenhum dado de relevância encontrado para este período"
  },
  accessMacroarea: {
    key: "zai.widget.territory-relevance.access-macroarea",
    defaultValue: "Acessar relevância"
  },
  relevanceIndex: {
    key: "zai.widget.territory-relevance.relevance-index",
    defaultValue: "Relevância"
  }
}, XB = ({
  territoryId: e,
  timeRange: t = "30"
} = {}) => {
  const { t: n } = Fe(), { workspaceId: r } = pt(), s = Lr(), [i, a] = de(null), [o, u] = de(!1), [c, l] = de(!1), h = ie(() => {
    if (!e || !r) return "";
    const b = eb(r, e, "performance"), T = Ul(t);
    return T ? `${b}?uploadDate=${T}` : b;
  }, [e, r, t]), m = ne(async () => {
    if (!(!e || !r)) {
      u(!0), l(!1);
      try {
        const b = await s.getTerritoryRelevanceData({
          territoryId: e,
          timeRange: t
        });
        a(b);
      } catch {
        l(!0), a(null);
      } finally {
        u(!1);
      }
    }
  }, [e, t, r, s]);
  xe(() => {
    m();
  }, [m]);
  const p = ie(() => i?.sparkline ? [
    {
      name: n(Mc.relevanceIndex),
      color: Be.winnin,
      series: i.sparkline.map((b) => b.value)
    }
  ] : [], [i, n]), E = ie(() => i?.sparkline ? i.sparkline.map((b) => Wn.formatDate(b.date, "MMM, DD YYYY")) : [], [i]), g = ie(() => p.length === 0 || p.flatMap((b) => b.series).every((b) => b === 0), [p]), _ = ie(() => {
    if (!t) return "";
    if (t.includes(":")) {
      const [T, C] = t.split(":");
      return `${Wn.formatDate(T, "DD/MM/YYYY")} - ${Wn.formatDate(C, "DD/MM/YYYY")}`;
    }
    const b = Number(t);
    return isNaN(b) ? "" : dd(b, n);
  }, [t, n]);
  return {
    isLoading: o,
    isError: c,
    isEmpty: g,
    refetch: m,
    chartEntities: p,
    chartLabels: E,
    macroareaURL: h,
    subtitle: _
  };
}, JB = () => /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-4 h-96 w-full", children: [
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg h-8 w-3/4" }),
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg flex-1 w-full" })
] }), ZB = ({
  chartEntities: e,
  chartLabels: t,
  isError: n,
  isEmpty: r,
  isLoading: s,
  macroareaURL: i,
  refetch: a,
  subtitle: o
}) => {
  const { t: u } = Fe(), c = ar();
  return /* @__PURE__ */ d.jsxs("div", { className: "w-full flex flex-col gap-6", children: [
    o && /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: o }),
    /* @__PURE__ */ d.jsx(
      Mr,
      {
        isLoading: s,
        isError: n,
        isEmpty: r,
        loadingComponent: /* @__PURE__ */ d.jsx(JB, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ss, { name: "chart", refetch: a }),
        emptyComponent: /* @__PURE__ */ d.jsx("p", { className: "text-neutral-500 font-bold text-center", children: u(Mc.emptyText) }),
        children: /* @__PURE__ */ d.jsx(
          sn.LineChart,
          {
            legend: { type: "default", toggleHideDisabled: !0 },
            entities: e,
            xAxisLabels: t,
            tooltip: {
              type: "default",
              valueFormatType: "default",
              formatter: (l) => Wt(l, 2)
            },
            yAxisOptions: { labelFormatType: "default" },
            customOptions: {
              yAxis: {
                labels: {
                  formatter: function({ value: l }) {
                    return Wt(Number(l), 0);
                  }
                }
              }
            },
            theme: c,
            height: 400
          }
        )
      }
    ),
    !n && i && /* @__PURE__ */ d.jsx(It, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: i, target: "_blank", rel: "noopener noreferrer", children: u(Mc.accessMacroarea) }) })
  ] });
}, eU = (e) => {
  const t = XB(e);
  return /* @__PURE__ */ d.jsx(ZB, { ...t });
}, tU = ({ type: e, uri: t }) => {
  if (e === "share-of-attention") {
    const n = ut(t, {
      path: at.SHARE_OF_ATTENTION,
      exact: !0
    });
    if (n?.params) {
      const a = n.params;
      return /* @__PURE__ */ d.jsx(zu, { ...a });
    }
    const r = ut(t, {
      path: at.SHARE_OF_ATTENTION_V3,
      exact: !0
    });
    if (r?.params) {
      const a = r.params;
      return /* @__PURE__ */ d.jsx(zu, { ...a });
    }
    const i = ut(t, {
      path: at.SHARE_OF_ATTENTION_V2,
      exact: !0
    })?.params;
    return /* @__PURE__ */ d.jsx(zu, { ...i });
  }
  if (e === "shares") {
    let n = ut(t, {
      path: at.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2,
      exact: !0
    });
    n || (n = ut(t, {
      path: at.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS,
      exact: !0
    }));
    const r = n?.params, s = r?.territoryType ? r : { ...r, territoryType: "grouped" };
    return /* @__PURE__ */ d.jsx(QB, { ...s });
  }
  if (e === "territory-performance") {
    const r = ut(t, {
      path: at.GET_TERRITORY_PERFORMANCE_RESOURCE,
      exact: !0
    })?.params, s = r?.territoryId?.split(".")?.[0]?.trim(), i = r?.territoryId?.split(".")?.[1]?.trim();
    return !!!(s && s in Dl) || !i ? null : /* @__PURE__ */ d.jsx(eU, { ...r });
  }
  if (e === "brand-engagement-over-time") {
    const r = ut(t, {
      path: at.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE,
      exact: !0
    })?.params;
    return /* @__PURE__ */ d.jsx(tB, { ...r });
  }
  if (e === "post") {
    const r = ut(t, {
      path: at.POST,
      exact: !0
    })?.params, s = `${r?.provider}:${r?.id}`;
    return !r?.provider || !r?.id ? null : /* @__PURE__ */ d.jsx(OB, { postId: s });
  }
  if (e === "creator") {
    const r = ut(t, {
      path: at.CREATOR,
      exact: !0
    })?.params, s = `${r?.provider}:${r?.id}`;
    return !r?.provider || !r?.id ? null : /* @__PURE__ */ d.jsx(dB, { creatorId: s, performanceInMonths: 1 });
  }
  return /* @__PURE__ */ d.jsx("div", { className: "my-5 text-red-500", children: /* @__PURE__ */ d.jsx("p", { children: "Widget type not recognized" }) });
}, nU = () => {
  const { language: e } = vi(), t = ar();
  return /* @__PURE__ */ d.jsx(
    wM,
    {
      remarkPlugins: [iT],
      rehypePlugins: [L_],
      className: le("aui-md pseudo-element-after-first-running", `theme-${t}`, { [e]: !!e }),
      components: dT
    }
  );
};
he(nU);
const rU = ({ text: e, status: t }) => {
  const { language: n } = vi(), r = ar();
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-status": t?.type,
      className: le("aui-md pseudo-element-after-first-running", `theme-${r}`, { [n]: !!n }),
      children: /* @__PURE__ */ d.jsx(Kb, { remarkPlugins: [iT], rehypePlugins: [L_], components: dT, children: e })
    }
  );
}, lT = he(rU), sU = ({ language: e, code: t }) => {
  const { isCopied: n, copyToClipboard: r } = iU(), s = () => {
    !t || n || r(t);
  };
  return /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-between gap-4 rounded-t-lg bg-zinc-100 dark:bg-zinc-900 px-4 py-2 text-sm font-semibold text-foreground", children: [
    /* @__PURE__ */ d.jsx("span", { className: "lowercase [&>span]:text-xs", children: e }),
    /* @__PURE__ */ d.jsxs(qt, { tooltip: "Copy", onClick: s, children: [
      !n && /* @__PURE__ */ d.jsx(Cl, {}),
      n && /* @__PURE__ */ d.jsx(So, {})
    ] })
  ] });
}, iU = ({
  copiedDuration: e = 3e3
} = {}) => {
  const [t, n] = de(!1);
  return { isCopied: t, copyToClipboard: (s) => {
    s && navigator.clipboard.writeText(s).then(() => {
      n(!0), setTimeout(() => n(!1), e);
    });
  } };
}, dT = dM({
  h1: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h1",
    {
      className: le("mb-8 scroll-m-20 text-4xl font-extrabold tracking-tight last:mb-0 clear-left", e),
      ...t
    }
  ),
  h2: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h2",
    {
      className: le(
        "mb-4 mt-8 scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    }
  ),
  h3: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h3",
    {
      className: le(
        "mb-4 mt-6 scroll-m-20 text-2xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    }
  ),
  h4: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h4",
    {
      className: le(
        "mb-4 mt-6 scroll-m-20 text-xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    }
  ),
  h5: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("h5", { className: le("my-4 text-lg font-semibold first:mt-0 last:mb-0 clear-left", e), ...t }),
  h6: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("h6", { className: le("my-4 font-semibold first:mt-0 last:mb-0 clear-left", e), ...t }),
  p: ({ className: e, ...t }) => (
    // Prevent elements be a descendant of <p>
    /* @__PURE__ */ d.jsx("div", { className: le("mb-5 mt-5 leading-7 first:mt-0 last:mb-0 clear-left", e), ...t })
  ),
  a: ({ className: e, ...t }) => /* @__PURE__ */ d.jsxs(
    "a",
    {
      target: "_blank",
      rel: "noopener noreferrer",
      className: le(
        `
            text-primary
            font-medium
            text-sm
            py-0.5
            px-1.5
            border
            border-neutral-200
            dark:border-neutral-500
            bg-white
            dark:bg-neutral-800
            rounded-full
            whitespace-nowrap
            inline-flex
            items-center
            gap-0.5
            max-w-36
            hover:border-neutral-300
            dark:hover:border-neutral-400
            hover:bg-neutral-50
            dark:hover:bg-neutral-700
            hover:[&>span]:inline-flex
            clear-left
            `,
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: "truncate", children: t.children }),
        /* @__PURE__ */ d.jsx("span", { className: "hidden", children: /* @__PURE__ */ d.jsx(Qv, { size: 16 }) })
      ]
    }
  ),
  blockquote: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("blockquote", { className: le("border-l-2 pl-6 italic clear-left", e), ...t }),
  ul: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("ul", { className: le("my-5 ml-6 list-disc [&>li]:mt-2 clear-left", e), ...t }),
  ol: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("ol", { className: le("my-5 ml-6 list-decimal [&>li]:mt-2 clear-left", e), ...t }),
  li: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("li", { className: le("clear-left", e), ...t }),
  hr: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("hr", { className: le("my-5 border-b clear-left", e), ...t }),
  table: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("div", { className: "overflow-x-auto clear-left", children: /* @__PURE__ */ d.jsx("table", { className: le("my-5 w-full border-separate border-spacing-0 overflow-y-auto", e), ...t }) }),
  th: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "th",
    {
      className: le(
        "bg-muted px-4 py-2 text-left font-bold first:rounded-tl-lg last:rounded-tr-lg [&[align=center]]:text-center [&[align=right]]:text-right",
        e
      ),
      ...t
    }
  ),
  td: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "td",
    {
      className: le(
        "border-b border-l px-4 py-2 text-left last:border-r [&[align=center]]:text-center [&[align=right]]:text-right",
        e
      ),
      ...t
    }
  ),
  tr: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "tr",
    {
      className: le(
        "m-0 border-b p-0 first:border-t [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg",
        e
      ),
      ...t
    }
  ),
  sup: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("sup", { className: le("[&>a]:text-xs [&>a]:no-underline clear-left", e), ...t }),
  pre: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "pre",
    {
      className: le(
        "overflow-x-auto rounded-b-lg bg-zinc-100 dark:bg-black p-4 text-foreground dark:text-white clear-left",
        e
      ),
      ...t
    }
  ),
  code: function({ className: t, ...n }) {
    const r = Qb();
    return /* @__PURE__ */ d.jsx("code", { className: le(!r && "bg-muted rounded border font-semibold clear-left", t), ...n });
  },
  embed: (e) => {
    const t = e["data-type"], n = e["data-uri"];
    return /* @__PURE__ */ d.jsx(tU, { type: t, uri: n });
  },
  CodeHeader: sU
}), qa = class qa {
};
qa.formatSoaDataUniverse = ({
  country: t,
  category: n,
  startDate: r,
  endDate: s
}) => {
  const i = [];
  return t && i.push(`Country: ${t}`), n && i.push(`Category: ${n}`), r && s && i.push(`Period: ${r} - ${s}`), i.length ? `Share of Attention - ${i.join(", ")}` : "";
}, qa.formatBrandSchema = ({
  brandName: t,
  provider: n,
  timeRangeInDays: r
}) => {
  const s = [];
  t && s.push(`${t}`);
  const i = Ol[n];
  return i && s.push(`${i}`), r && s.push(`Last ${r} days`), s.length ? `Brand (Engagement, Content, Views) - ${s.join(", ")}` : "";
};
let Ga = qa;
const aU = () => {
  const e = J((I) => I?.message?.content), t = J((I) => I?.message?.status?.type), n = ie(() => e?.filter((I) => I.type === "tool-call") || [], [e]), r = n?.some((I) => Zi.SHARE_OF_ATTENTION.some((O) => ut(I?.argsText, { path: O, exact: !0 }) !== null)), s = n?.some((I) => Zi.BRAND.some((O) => ut(I?.argsText, { path: O, exact: !0 }) !== null)), i = n?.find((I) => Zi.SHARE_OF_ATTENTION.some((O) => ut(I?.argsText, { path: O, exact: !0 }) !== null)), a = n?.find((I) => Zi.BRAND.some((O) => ut(I?.argsText, { path: O, exact: !0 }) !== null)), o = i?.result?.[0]?.data, u = i?.argsText ? ut(i?.argsText, {
    path: te.SHARE_OF_ATTENTION
  }) : null, c = o?.category, l = u?.params?.period, h = {
    daily: "dailySOA",
    weekly: "weeklySOA",
    monthly: "monthlySOA"
  }, m = h[l] || h.monthly, p = o?.myBrand?.[m] || [], E = p?.[0], g = p?.[p.length - 1], _ = a?.result?.[0]?.data?.getWorkspace?.workspaceBrand?.name, b = a?.argsText ? ut(a?.argsText, {
    path: te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS
  }) : null, T = E?.date ? Wn.formatDate(E.date) : "", C = g?.date ? Wn.formatDate(g.date) : "", R = r ? Ga.formatSoaDataUniverse({
    country: c?.country,
    category: c?.name,
    startDate: T,
    endDate: C
  }) : "", D = s ? Ga.formatBrandSchema({
    brandName: _,
    provider: b?.params?.provider,
    timeRangeInDays: b?.params?.timeRangeInDays
  }) : "";
  return ie(
    () => ({
      hasSoaToolCall: r,
      hasBrandToolCall: s,
      soaDataUniverse: R,
      brandDataUniverse: D,
      statusType: t
    }),
    [D, s, r, R, t]
  );
}, oU = ({
  hasSoaToolCall: e,
  hasBrandToolCall: t,
  soaDataUniverse: n,
  brandDataUniverse: r,
  statusType: s
}) => {
  const i = e && n, a = t && r;
  return !i && !a || s !== "complete" ? null : /* @__PURE__ */ d.jsxs("div", { className: "my-4 text-base text-muted-foreground", children: [
    /* @__PURE__ */ d.jsx("p", { children: "Data Universe:" }),
    i && /* @__PURE__ */ d.jsx("p", { children: n }),
    a && /* @__PURE__ */ d.jsx("p", { children: r })
  ] });
}, uU = () => {
  const e = aU();
  return /* @__PURE__ */ d.jsx(oU, { ...e });
}, hT = he(uU), ua = {
  dialogTitle: {
    key: "feedback-custom-dialog.title",
    defaultValue: "O que deu errado na sua experiência?"
  },
  dialogTextareaFeedback: {
    key: "feedback-custom-dialog.textarea-feedback",
    defaultValue: "(Opcional) Insira seu feedback aqui..."
  },
  dialogSendButton: {
    key: "feedback-custom-dialog.send-button",
    defaultValue: "Enviar"
  },
  dialogCancelButton: {
    key: "feedback-custom-dialog.cancel-button",
    defaultValue: "Cancelar"
  }
}, cU = he(({ onClose: e, onSend: t, t: n }) => /* @__PURE__ */ d.jsxs("div", { className: "feedback-custom-dialog fixed top-0 left-0 w-full h-full z-50 p-4 flex items-center justify-center", children: [
  /* @__PURE__ */ d.jsx(
    "div",
    {
      onClick: e,
      className: "feedback-custom-dialog-overlay absolute top-0 left-0 w-full h-full bg-black opacity-50"
    }
  ),
  /* @__PURE__ */ d.jsxs("div", { className: "feedback-custom-dialog-content relative bg-[#2E2E2E] max-w-[650px] w-full  border border-[#F1F4FA1A] p-8 flex flex-col gap-8 rounded-lg", children: [
    /* @__PURE__ */ d.jsx("h2", { className: "font-semibold text-3xl", children: n(ua.dialogTitle) }),
    /* @__PURE__ */ d.jsxs("form", { onSubmit: t, className: "feedback-custom-dialog-form flex flex-col gap-8", children: [
      /* @__PURE__ */ d.jsx("div", { className: "feedback-custom-dialog-form-row", children: /* @__PURE__ */ d.jsx(
        "textarea",
        {
          name: "textarea-feedback",
          id: "textarea-feedback",
          placeholder: n(ua.dialogTextareaFeedback),
          className: "w-full h-[109px] resize-none p-2 border bg-[#363636] border-[#E1E5ED1A] rounded-sm text-sm text-white placeholder-white"
        }
      ) }),
      /* @__PURE__ */ d.jsxs("div", { className: "feedback-custom-dialog-form-actions flex align-center justify-end gap-4", children: [
        /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "button",
            onClick: e,
            className: "feedback-custom-dialog-form-action-cancel py-2 px-4 rounded-sm text-sm text-white cursor-pointer",
            children: n(ua.dialogCancelButton)
          }
        ),
        /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "submit",
            className: "feedback-custom-dialog-form-action-send py-2 px-4 rounded-sm bg-white text-sm text-black cursor-pointer",
            children: n(ua.dialogSendButton)
          }
        )
      ] })
    ] })
  ] })
] })), lU = ({ type: e, workspaceId: t, threadId: n, hasDialog: r }) => {
  const [s, i] = de(!1), a = Ke(null), o = e === "positive" ? "Like" : "Dislike", u = ne(
    ({ message: E } = {}) => {
      const g = {
        workspaceId: t,
        thread: n,
        feedback: e
      };
      E && (g.message = E), br.track(Er.feedback, g);
    },
    [n, e, t]
  ), c = ({ active: E, element: g }) => {
    if (g.disabled = E, !E) {
      g.classList.add("text-[#4C5567]", "hover:text-[#4C5567]"), g.classList.remove("text-[#D0B2FF]", "hover:text-[#D0B2FF]", "hover:text-accent-foreground");
      return;
    }
    g.classList.add("text-[#D0B2FF]", "hover:text-[#D0B2FF]"), g.classList.remove("hover:text-accent-foreground", "disabled:opacity-50");
  }, l = () => {
    const E = a.current, g = document.querySelector(
      `[data-feedback-button-type="${e === "positive" ? "negative" : "positive"}"]`
    );
    return {
      currentButton: E,
      oppositeButton: g
    };
  };
  return {
    buttonRef: a,
    handleClick: () => {
      const { currentButton: E, oppositeButton: g } = l();
      if (r) {
        i(!0);
        return;
      }
      g && c({ active: !1, element: g }), c({ active: !0, element: E }), u();
    },
    tooltipMessage: o,
    showDialog: s,
    onDialogClose: () => i(!1),
    onDialogSend: (E) => {
      E.preventDefault();
      const { currentButton: g, oppositeButton: _ } = l(), T = new FormData(E.currentTarget).get("textarea-feedback").trim();
      _ && c({ active: !1, element: _ }), c({ active: !0, element: g }), u({ message: T }), i(!1);
    }
  };
}, fT = Je(
  ({
    IconComponent: e,
    TooltipIconButtonComponent: t,
    DialogComponent: n,
    tooltipMessage: r,
    type: s,
    showDialog: i,
    handleClick: a,
    onDialogClose: o,
    onDialogSend: u,
    t: c
  }, l) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(
      t,
      {
        ref: l,
        tooltip: r,
        onClick: a,
        "data-feedback-button-type": s,
        children: /* @__PURE__ */ d.jsx(e, {})
      }
    ),
    i && /* @__PURE__ */ d.jsx(n, { t: c, onClose: o, onSend: u })
  ] })
);
fT.displayName = "FeedbackCustomView";
const dU = he(fT), Bp = he(({ type: e, hasDialog: t = !1 }) => {
  const { workspaceId: n } = pt(), r = J((u) => u?.threadListItem?.remoteId), { t: s } = Fe(), { buttonRef: i, ...a } = lU({
    type: e,
    hasDialog: t,
    threadId: r,
    workspaceId: n
  }), o = e === "positive" ? dN : cN;
  return /* @__PURE__ */ d.jsx(
    dU,
    {
      ...a,
      ref: i,
      TooltipIconButtonComponent: qt,
      IconComponent: o,
      DialogComponent: cU,
      type: e,
      t: s
    }
  );
}), hU = {
  analyze: Yk,
  plan: qk,
  execute_step: Wk,
  validate_step: Qk,
  synthesize: Zh,
  // `clarify` is never rendered (filtered out at accumulation time); mapped to
  // synthesize as a defensive fallback so the type stays exhaustive.
  clarify: Zh
}, fU = {
  thinking: {
    key: "zai.progress-steps.thinking",
    defaultValue: "Pensando..."
  }
}, pU = () => {
  const { t: e } = Fe(), t = J((o) => o?.message?.content), n = J((o) => o?.message?.status), s = J((o) => o?.message?.metadata?.custom)?.zaiProgress, i = ie(() => {
    const o = t?.findLast((c) => c.type === "text"), u = !!o && (o.text?.trim().length ?? 0) > 0;
    return n?.type === "running" && !u;
  }, [t, n?.type]), a = ie(() => s?.entries?.length ? s.entries.map((o) => ({
    id: o.key,
    node: o.node,
    text: o.text,
    icon: hU[o.node],
    state: o.key === s.activeKey ? "active" : "done"
  })) : [], [s?.activeKey, s?.entries]);
  return {
    isVisible: i,
    header: e(fU.thinking),
    steps: a
  };
}, mU = () => {
  const { workspaceId: e } = pt(), t = J((r) => r?.message?.content);
  return ie(() => {
    const r = t?.filter((a) => a.type === "tool-call");
    return !r || r.length === 0 ? [] : r.map((a) => {
      const o = a?.argsText;
      if (!o) return null;
      for (const u of Object.values(te)) {
        const c = ut(o, { path: u, exact: !0 });
        if (c) {
          const l = Jn[u];
          if (!l)
            return null;
          const h = { ...c.params };
          if (h.territoryId) {
            const [g, _] = h.territoryId.split("."), b = Dl[g];
            h.territoryType = b, h.entityId = _, delete h.territoryId;
          }
          const m = aR(l), p = {};
          m.includes("panelId") && e && (p.panelId = e);
          for (const g of m)
            if (g === "tab" && h.territoryType && h.territoryType in ls ? p.tab = ls[h.territoryType] : g !== "panelId" && h[g] && (p[g] = h[g]), !p[g])
              return null;
          const E = En(l, p);
          return {
            uri: o,
            href: E,
            path: u,
            params: c.params
          };
        }
      }
      return null;
    }).filter((a) => a !== null).reduce(
      (a, o) => {
        const u = o?.uri;
        return a.ids?.includes(u) ? a : {
          ids: [...a.ids, u],
          sources: [...a.sources, o]
        };
      },
      {
        ids: [],
        sources: []
      }
    ).sources;
  }, [t, e]);
}, gU = () => {
  const { language: e } = vi(), t = Ml(), [n, r] = de(!1), [s, i] = de(!1), [a, o] = de([]), u = ne(async () => {
    try {
      r(!0), i(!1);
      const c = await t.getPrePrompts(e || "en");
      o(c);
    } catch {
      i(!0);
    } finally {
      r(!1);
    }
  }, [e, t]);
  return xe(() => {
    u();
  }, [u]), {
    isLoading: n,
    isError: s,
    data: a
  };
}, EU = (e, t, n = 18) => {
  const [r, s] = de(t ? "" : e);
  return xe(() => {
    if (!t) {
      s(e);
      return;
    }
    s("");
    let i = 0;
    const a = setInterval(() => {
      i += 1, s(e.slice(0, i)), i >= e.length && clearInterval(a);
    }, n);
    return () => clearInterval(a);
  }, [e, t, n]), r;
}, bU = ({ step: e }) => {
  const t = e.icon, n = e.state === "active", r = EU(e.text, n);
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: le("flex items-start gap-2 text-sm", n ? "text-foreground font-bold" : "text-muted-foreground"),
      children: [
        /* @__PURE__ */ d.jsx(t, { className: le("size-5 shrink-0", n && "text-purple-600 dark:text-purple-300") }),
        /* @__PURE__ */ d.jsx("span", { className: "leading-6", children: r })
      ]
    }
  );
}, _U = ({ isVisible: e, header: t, steps: n }) => e ? /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-4 my-3", role: "status", "aria-live": "polite", "aria-atomic": "true", children: [
  /* @__PURE__ */ d.jsx("p", { className: "animate-pulse font-bold text-sm text-foreground", children: t }),
  n.length > 0 && /* @__PURE__ */ d.jsx("div", { className: "flex flex-col gap-4", children: n.map((r) => /* @__PURE__ */ d.jsx(bU, { step: r }, r.id)) })
] }) : null, pT = he(() => {
  const e = pU();
  return /* @__PURE__ */ d.jsx(_U, { ...e });
}), TU = () => {
  const e = mU();
  return {
    sources: ie(() => {
      const n = e.reduce(
        (r, s) => (s && (r[s.href] || (r[s.href] = s)), r),
        {}
      );
      return Object.values(n);
    }, [e])
  };
};
function AU(e, t = 50) {
  if (e?.length <= t) return e;
  const n = Math.floor(t / 2);
  return `${e?.slice(0, n)}...${e?.slice(-n)}`;
}
const yU = ({ sources: e }) => !e || e.length <= 0 ? null : /* @__PURE__ */ d.jsxs(vl, { children: [
  /* @__PURE__ */ d.jsx(Nl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(
    It,
    {
      variant: "outline",
      className: `
            text-primary
            font-medium
            text-sm
            py-0.5
            pr-2
            pl-1.5
            border
            border-neutral-300
            bg-neutral-100
            rounded-full
            whitespace-nowrap
            inline-flex
            items-center
            max-w-36
            hover:border-neutral-400
            hover:bg-neutral-200
            hover:[&>span]:inline-flex
            h-auto
          `,
      children: [
        /* @__PURE__ */ d.jsx(Jv, { size: 16 }),
        "Sources"
      ]
    }
  ) }),
  /* @__PURE__ */ d.jsxs(
    kl,
    {
      side: "top",
      align: "start",
      className: "border rounded-xl border-neutral-200 dark:border-neutral-500 bg-white dark:bg-neutral-800 w-fit max-w-xl",
      children: [
        /* @__PURE__ */ d.jsx("h4", { className: "text-sm text-muted-foreground mb-2", children: "Sources" }),
        /* @__PURE__ */ d.jsx("div", { className: "max-h-60 overflow-y-auto", children: e.map((t, n) => /* @__PURE__ */ d.jsxs(
          "a",
          {
            href: t.href,
            className: "flex items-center gap-1 hover:underline visited:text-purple-300",
            target: "_blank",
            rel: "noopener noreferrer",
            title: t.href,
            children: [
              /* @__PURE__ */ d.jsx(eN, { className: "shrink-0", size: 16 }),
              /* @__PURE__ */ d.jsx("span", { className: "truncate", children: AU(t.href) })
            ]
          },
          `source-item-${t.href}-${n}`
        )) })
      ]
    }
  )
] }), mT = () => {
  const e = TU();
  return /* @__PURE__ */ d.jsx(yU, { ...e });
}, gT = (e) => Object.values(te).find((n) => ut(e, { path: n, exact: !0 }) !== null) || null, xU = {
  default: {
    key: "zai.tool.default.reasoning",
    defaultValue: "Processando informações"
  }
}, Up = {
  my_brand: {
    key: "zai.tool.my-brand.reasoning",
    defaultValue: "Buscando informações da sua marca"
  },
  my_competitors: {
    key: "zai.tool.my-competitors.reasoning",
    defaultValue: "Buscando marcas concorrentes"
  },
  share_of_engagement: {
    key: "zai.tool.share-of-engagement-content-and-views.reasoning",
    defaultValue: "Analisando o engajamento da sua marca"
  },
  key_findings: {
    key: "zai.tool.key-findings.reasoning",
    defaultValue: "Coletando insights principais da sua marca"
  },
  share_of_attention: {
    key: "zai.tool.share-of-attention.reasoning",
    defaultValue: "Acessando o Share of Attention"
  },
  trending_territories: {
    key: "zai.tool.trending-territories.reasoning",
    defaultValue: "Identificando territórios em alta"
  },
  territory_resource: {
    key: "zai.tool.territory-resource.reasoning",
    defaultValue: "Carregando informações do território"
  },
  territory_tags: {
    key: "zai.tool.territory-tags.reasoning",
    defaultValue: "Buscando principais tags do território"
  },
  territory_niches: {
    key: "zai.tool.territory-niches.reasoning",
    defaultValue: "Identificando nichos do território"
  },
  territory_formats: {
    key: "zai.tool.territory-formats.reasoning",
    defaultValue: "Analisando formatos mais utilizados"
  },
  territory_creators: {
    key: "zai.tool.territory-creators.reasoning",
    defaultValue: "Buscando criadores relevantes no território"
  },
  territory_videos: {
    key: "zai.tool.territory-videos.reasoning",
    defaultValue: "Carregando vídeos do território"
  },
  territory_performance: {
    key: "zai.tool.territory-performance.reasoning",
    defaultValue: "Extraindo métricas do território"
  },
  territory_affinities: {
    key: "zai.tool.territory-affinities.reasoning",
    defaultValue: "Calculando afinidade com o território"
  },
  territory_audience: {
    key: "zai.tool.territory-audience.reasoning",
    defaultValue: "Analisando o público do território"
  },
  deep_analysis: {
    key: "zai.tool.deep-analysis.reasoning",
    defaultValue: "Realizando análise aprofundada do território"
  }
}, Fp = {
  my_brand: {
    key: "zai.tool.my-brand.resolved",
    defaultValue: "Informações da sua marca foram avaliadas"
  },
  my_competitors: {
    key: "zai.tool.my-competitors.resolved",
    defaultValue: "Marcas concorrentes interpretadas"
  },
  share_of_engagement: {
    key: "zai.tool.share-of-engagement-content-and-views.resolved",
    defaultValue: "Análise de engajamento concluída com sucesso"
  },
  key_findings: {
    key: "zai.tool.key-findings.resolved",
    defaultValue: "Insights principais coletados"
  },
  share_of_attention: {
    key: "zai.tool.share-of-attention.resolved",
    defaultValue: "Acessei o Share of Attention"
  },
  trending_territories: {
    key: "zai.tool.trending-territories.resolved",
    defaultValue: "Territórios em alta identificados"
  },
  territory_resource: {
    key: "zai.tool.territory-resource.resolved",
    defaultValue: "Informações do território carregadas"
  },
  territory_tags: {
    key: "zai.tool.territory-tags.resolved",
    defaultValue: "Tags principais carregadas"
  },
  territory_niches: {
    key: "zai.tool.territory-niches.resolved",
    defaultValue: "Nichos identificados"
  },
  territory_formats: {
    key: "zai.tool.territory-formats.resolved",
    defaultValue: "Formatos analisados"
  },
  territory_creators: {
    key: "zai.tool.territory-creators.resolved",
    defaultValue: "Criadores relevantes encontrados"
  },
  territory_videos: {
    key: "zai.tool.territory-videos.resolved",
    defaultValue: "Vídeos carregados"
  },
  territory_performance: {
    key: "zai.tool.territory-performance.resolved",
    defaultValue: "Métricas extraídas com sucesso"
  },
  territory_affinities: {
    key: "zai.tool.territory-affinities.resolved",
    defaultValue: "Afinidade calculada"
  },
  territory_audience: {
    key: "zai.tool.territory-audience.resolved",
    defaultValue: "Público analisado"
  },
  deep_analysis: {
    key: "zai.tool.deep-analysis.resolved",
    defaultValue: "Análise aprofundada concluída"
  }
}, CU = {
  [te.GET_MY_BRAND]: "my_brand",
  [te.GET_MY_COMPETITORS]: "my_competitors",
  [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]: "share_of_engagement",
  [te.GET_KEY_FINDINGS]: "key_findings",
  [te.SHARE_OF_ATTENTION]: "share_of_attention",
  [te.SHARE_OF_ATTENTION_V2]: "share_of_attention",
  [te.GET_TRENDING_TERRITORIES]: "trending_territories",
  [te.GET_TERRITORY_RESOURCE]: "territory_resource",
  [te.GET_TERRITORY_TAGS_RESOURCE]: "territory_tags",
  [te.GET_TERRITORY_NICHES_RESOURCE]: "territory_niches",
  [te.GET_TERRITORY_FORMATS_RESOURCE]: "territory_formats",
  [te.GET_TERRITORY_CREATORS_RESOURCE]: "territory_creators",
  [te.GET_TERRITORY_VIDEOS_RESOURCE]: "territory_videos",
  [te.GET_TERRITORY_PERFORMANCE_RESOURCE]: "territory_performance",
  [te.GET_TERRITORY_AFFINITIES_RESOURCE]: "territory_affinities",
  [te.GET_TERRITORY_AUDIENCE_RESOURCE]: "territory_audience",
  [te.DEEP_ANALYSIS_RESOURCE]: "deep_analysis"
}, SU = () => {
  const { t: e } = Fe(), t = J((r) => r?.message?.content);
  return ie(() => {
    const r = t?.filter((s) => s.type === "tool-call");
    return r?.length ? r.map((s) => {
      const i = gT(s.argsText || "");
      if (!i) return s;
      const a = CU[i] || "default", o = Up[a] ? e(Up[a]) : e(xU.default), u = Fp[a] ? e(Fp[a]) : void 0;
      return {
        ...s,
        toolUri: i,
        reasoningText: o,
        resolvedText: u
      };
    }) : [];
  }, [t, e]);
}, jp = {
  checkedSources: {
    key: "zai.tool-group.checked-sources",
    defaultValue: "Chequei as fontes de dados"
  },
  processingUnknownTool: {
    key: "zai.tool-group.processing-unknown-tool",
    defaultValue: "Processando informações"
  }
}, IU = () => {
  const { t: e } = Fe(), t = SU(), n = J((c) => c?.message?.content), r = J((c) => c?.message?.status), s = t.length > 0, i = ie(() => {
    const c = n?.findLast((h) => h.type === "text");
    return c && c.text?.trim().length > 0 ? !1 : r?.type === "running";
  }, [n, r?.type]), a = t?.filter((c) => gT(c.argsText || "") !== null), o = a && a.length > 0 ? a[a.length - 1] : void 0;
  return { title: ie(() => i ? o?.reasoningText || o?.argsText || e(jp.processingUnknownTool) : e(jp.checkedSources), [e, i, o?.reasoningText, o?.argsText]), toolCalls: a, isRunning: i, hasToolCalls: s };
}, wU = ({ isRunning: e, toolCalls: t }) => {
  const n = e ? t?.slice(0, -1) : t, r = ie(() => n ? Array.from(new Map(n.map((i) => [i.toolUri, i])).values()) : [], [n?.length]);
  return {
    checkedToolsCount: r ? r.length : 0,
    uniqueToolCalls: r
  };
}, vU = {
  thought: {
    key: "zai.checked-tools.thought",
    defaultValue: "Pensamento"
  }
}, NU = ({ uniqueToolCalls: e, checkedToolsCount: t }) => {
  const { t: n } = Fe();
  return /* @__PURE__ */ d.jsxs(vl, { children: [
    /* @__PURE__ */ d.jsx(Nl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(
      It,
      {
        variant: "outline",
        disabled: t === 0,
        className: `
            text-primary
            font-normal
            text-base
            py-0.5
            pr-2
            pl-1.5
            border
            border-neutral-200
            bg-white
            rounded-full
            whitespace-nowrap
            inline-flex
            gap-1
            items-center
            max-w-36
            hover:border-neutral-300
            hover:bg-neutral-50
            hover:[&>span]:inline-flex
            h-auto
          `,
        children: [
          /* @__PURE__ */ d.jsx($h, { className: "size-5 text-purple-600 dark:text-purple-300" }),
          t
        ]
      }
    ) }),
    /* @__PURE__ */ d.jsxs(
      kl,
      {
        side: "top",
        align: "start",
        className: "border rounded-xl border-neutral-200 dark:border-neutral-500 bg-white dark:bg-neutral-800 w-fit max-w-xl",
        children: [
          /* @__PURE__ */ d.jsx("h4", { className: "text-sm text-muted-foreground mb-2", children: n(vU.thought) }),
          /* @__PURE__ */ d.jsx("div", { className: "max-h-60 overflow-y-auto", children: e.map((r) => /* @__PURE__ */ d.jsxs(
            "div",
            {
              className: "flex items-center gap-2 my-3 text-purple-600 dark:text-purple-300",
              children: [
                /* @__PURE__ */ d.jsx($h, { size: 20 }),
                /* @__PURE__ */ d.jsx("p", { children: r.resolvedText })
              ]
            },
            `reasoning-text-${r.toolCallId}`
          )) })
        ]
      }
    )
  ] });
}, kU = (e) => {
  const t = wU(e);
  return /* @__PURE__ */ d.jsx(NU, { ...t });
}, RU = ({ title: e, isRunning: t, toolCalls: n, hasToolCalls: r }) => r ? /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-2 my-3 text-purple-600 dark:text-purple-300", children: [
  t && /* @__PURE__ */ d.jsx("span", { className: "animate-spin size-5 border-2 border-purple-600 dark:border-purple-300 rounded-full border-t-transparent" }),
  /* @__PURE__ */ d.jsx("p", { children: e }),
  /* @__PURE__ */ d.jsx(kU, { toolCalls: n, isRunning: t })
] }) : null, PU = () => {
  const e = IU();
  return /* @__PURE__ */ d.jsx(RU, { ...e });
}, ET = he(PU), pd = ({ className: e, ...t }) => /* @__PURE__ */ d.jsxs(
  J0,
  {
    hideWhenSingleBranch: !0,
    className: le("text-muted-foreground inline-flex items-center text-xs", e),
    ...t,
    children: [
      /* @__PURE__ */ d.jsx(Uw, { asChild: !0, children: /* @__PURE__ */ d.jsx(qt, { tooltip: "Previous", children: /* @__PURE__ */ d.jsx(AE, {}) }) }),
      /* @__PURE__ */ d.jsxs("span", { className: "font-medium", children: [
        /* @__PURE__ */ d.jsx(X0, {}),
        " / ",
        /* @__PURE__ */ d.jsx(Q0, {})
      ] }),
      /* @__PURE__ */ d.jsx(Hw, { asChild: !0, children: /* @__PURE__ */ d.jsx(qt, { tooltip: "Next", children: /* @__PURE__ */ d.jsx($v, {}) }) })
    ]
  }
), OU = () => /* @__PURE__ */ d.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", width: "16", height: "16", children: /* @__PURE__ */ d.jsx("rect", { width: "10", height: "10", x: "3", y: "3", rx: "2" }) }), $p = (e) => /* @__PURE__ */ d.jsx(
  qt,
  {
    variant: "default",
    side: "top",
    className: `
        my-3
        size-8
        p-2
        transition-opacity
        ease-in
        text-white
        bg-gradient-to-br
        from-purple-600
        to-violet-900
        hover:from-purple-700
        hover:to-purple-900
      `,
    ...e
  }
), DU = () => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
  /* @__PURE__ */ d.jsx(di, { running: !1, children: /* @__PURE__ */ d.jsx(eE, { asChild: !0, children: /* @__PURE__ */ d.jsx($p, { tooltip: "Send", children: /* @__PURE__ */ d.jsx(oN, {}) }) }) }),
  /* @__PURE__ */ d.jsx(di, { running: !0, children: /* @__PURE__ */ d.jsx(nE, { asChild: !0, children: /* @__PURE__ */ d.jsx($p, { tooltip: "Cancel", children: /* @__PURE__ */ d.jsx(OU, {}) }) }) })
] }), bT = () => {
  const { t: e } = Fe();
  return /* @__PURE__ */ d.jsxs(
    bl,
    {
      className: `
        focus-within:border-ring/20
        flex
        w-full
        flex-wrap
        items-center
        rounded-2xl
        border
        bg-white
        dark:bg-neutral-800
        px-3
        shadow-sm
        transition-colors
        ease-in
      `,
      children: [
        /* @__PURE__ */ d.jsx("div", { className: "flex items-center my-3", children: /* @__PURE__ */ d.jsx(qE, { className: "size-7 text-neutral-500 dark:text-[#FFFFFF80]" }) }),
        /* @__PURE__ */ d.jsx(
          Tl,
          {
            rows: 1,
            autoFocus: !0,
            placeholder: e($t.placeholder),
            className: `
          placeholder:text-muted-foreground
          max-h-40
          flex-grow
          resize-none
          border-none
          bg-transparent
          px-2
          py-4
          text-sm
          outline-none
          focus:ring-0
          disabled:cursor-not-allowed
        `
          }
        ),
        /* @__PURE__ */ d.jsx(DU, {})
      ]
    }
  );
}, _T = () => /* @__PURE__ */ d.jsxs(bl, { className: "bg-muted my-4 flex w-full max-w-[var(--thread-max-width)] flex-col gap-2 rounded-xl", children: [
  /* @__PURE__ */ d.jsx(Tl, { className: "text-foreground flex h-8 w-full resize-none bg-transparent p-4 pb-0 outline-none" }),
  /* @__PURE__ */ d.jsxs("div", { className: "mx-3 mb-3 flex items-center justify-center gap-2 self-end", children: [
    /* @__PURE__ */ d.jsx(nE, { asChild: !0, children: /* @__PURE__ */ d.jsx(It, { variant: "ghost", children: "Cancel" }) }),
    /* @__PURE__ */ d.jsx(eE, { asChild: !0, children: /* @__PURE__ */ d.jsx(It, { children: "Send" }) })
  ] })
] }), LU = () => /* @__PURE__ */ d.jsx(
  ao,
  {
    hideWhenRunning: !0,
    autohide: "not-last",
    className: "flex flex-col items-end col-start-1 row-start-2 mr-3 mt-2.5",
    children: /* @__PURE__ */ d.jsx(dC, { asChild: !0 })
  }
), TT = () => /* @__PURE__ */ d.jsxs(
  xo,
  {
    className: `
        flex
        justify-end
        gap-y-2
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
    children: [
      /* @__PURE__ */ d.jsx(LU, {}),
      /* @__PURE__ */ d.jsx(
        "div",
        {
          className: `
          bg-muted
          text-foreground
          max-w-[min(calc(var(--thread-max-width)*0.8),70%)]
          break-words
          rounded-lg
          py-2
          px-3
        `,
          children: /* @__PURE__ */ d.jsx(Co, {})
        }
      ),
      /* @__PURE__ */ d.jsx(pd, { className: "col-span-full col-start-1 row-start-3 -mr-1 justify-end" })
    ]
  }
), AT = ({ className: e }) => {
  const t = J((a) => a?.thread?.isLoading), { t: n } = Fe(), { isLoading: r, data: s } = gU(), i = t || r;
  return /* @__PURE__ */ d.jsx(
    yl,
    {
      className: le("box-border flex h-full flex-col overflow-hidden rounded-xl", e),
      style: {
        "--thread-max-width": "42rem"
      },
      children: /* @__PURE__ */ d.jsxs(xl, { className: "flex h-full flex-col items-center overflow-y-scroll scroll-smooth px-4 pt-8 mb-19", children: [
        i && /* @__PURE__ */ d.jsx("div", { className: "flex flex-grow items-center justify-center", children: n($t.loading) }),
        !i && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsx(BU, { suggestions: s }),
          /* @__PURE__ */ d.jsx(MU, {}),
          /* @__PURE__ */ d.jsx(di, { empty: !1, children: /* @__PURE__ */ d.jsx("div", { className: "min-h-8 flex-grow" }) }),
          /* @__PURE__ */ d.jsxs("div", { className: "absolute self-center-safe bottom-0 mt-3 flex w-full max-w-[var(--thread-max-width)] flex-col items-center justify-end rounded-t-lg bg-inherit px-4 pb-9 z-[10]", children: [
            /* @__PURE__ */ d.jsx(HU, {}),
            /* @__PURE__ */ d.jsx(bT, {})
          ] })
        ] })
      ] })
    }
  );
}, MU = () => {
  const e = J((r) => r?.thread?.messages?.length), [t, n] = de(!1);
  return rs(() => {
    n(!0);
  }, []), !t || e === 0 ? null : /* @__PURE__ */ d.jsx(d.Fragment, { children: Array.from({ length: e }, (r, s) => /* @__PURE__ */ d.jsx(
    Qc,
    {
      index: s,
      components: {
        UserMessage: TT,
        EditComposer: _T,
        AssistantMessage: jU
      }
    },
    s
  )) });
}, HU = () => {
  const { t: e } = Fe();
  return /* @__PURE__ */ d.jsx(pE, { asChild: !0, children: /* @__PURE__ */ d.jsx(
    qt,
    {
      tooltip: e($t.scrollToBottom),
      variant: "outline",
      side: "top",
      className: "absolute -top-8 rounded-full disabled:invisible",
      children: /* @__PURE__ */ d.jsx(_E, {})
    }
  ) });
}, BU = ({ suggestions: e }) => {
  const { t } = Fe();
  return /* @__PURE__ */ d.jsx(hE, { children: /* @__PURE__ */ d.jsxs("div", { className: "flex w-full max-w-[var(--thread-max-width)] flex-grow flex-col justify-center gap-9", children: [
    /* @__PURE__ */ d.jsx("div", { className: "flex w-full flex-col items-center justify-center", children: /* @__PURE__ */ d.jsx("p", { className: "mt-4 font-semibold text-3xl", children: t($t.welcomeMessage) }) }),
    /* @__PURE__ */ d.jsx(UU, { suggestions: e })
  ] }) });
}, UU = ({ suggestions: e }) => /* @__PURE__ */ d.jsx("div", { className: "mt-3 flex w-full items-stretch justify-center gap-4 flex-wrap", children: e.map((t, n) => /* @__PURE__ */ d.jsx(
  FU,
  {
    id: t.id,
    prompt: t.text,
    method: "replace",
    autoSend: !0,
    children: t.text
  },
  `thread-welcome-suggestion-item-${n}`
)) }), FU = ({ id: e, prompt: t, method: n = "replace", autoSend: r = !1, children: s }) => {
  const { setIsPrePrompt: i } = _s(), { setQuickPromptId: a } = Rl();
  return /* @__PURE__ */ d.jsx(
    Iv,
    {
      onClick: () => {
        i(!0), a(e ? String(e) : null);
      },
      prompt: t,
      method: n,
      autoSend: r,
      asChild: !0,
      children: /* @__PURE__ */ d.jsxs(It, { variant: "purple-gradient", size: "lg", className: "h-11 rounded-xl font-normal", children: [
        /* @__PURE__ */ d.jsx(Kk, {}),
        s
      ] })
    }
  );
}, jU = () => {
  const { t: e } = Fe(), t = J((n) => n?.message?.status?.type === "complete");
  return /* @__PURE__ */ d.jsxs(
    xo,
    {
      className: `
        grid
        grid-cols-[auto_auto_1fr]
        grid-rows-[auto_1fr]
        relative
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `
          text-foreground
          max-w-[var(--thread-max-width)]
          break-words
          leading-7
          col-span-2
          col-start-2
          row-start-1
          my-1.5
        `,
            children: [
              /* @__PURE__ */ d.jsx(pT, {}),
              /* @__PURE__ */ d.jsx(ET, {}),
              /* @__PURE__ */ d.jsx(
                Co,
                {
                  components: {
                    Text: lT,
                    ToolGroup: () => null,
                    tools: {
                      Fallback: void 0
                    }
                  }
                }
              ),
              t && /* @__PURE__ */ d.jsx(hT, {}),
              /* @__PURE__ */ d.jsx(Al, { children: /* @__PURE__ */ d.jsx("div", { className: "rounded-lg p-2 text-sm bg-red-500/10 border border-red-500/20", children: /* @__PURE__ */ d.jsx("p", { children: e($t.somethingWentWrong) }) }) })
            ]
          }
        ),
        /* @__PURE__ */ d.jsx($U, {}),
        /* @__PURE__ */ d.jsx(pd, { className: "col-start-2 row-start-2 -ml-2 mr-2" })
      ]
    }
  );
}, $U = () => {
  const { t: e } = Fe();
  return /* @__PURE__ */ d.jsxs(
    ao,
    {
      hideWhenRunning: !0,
      autohide: "never",
      autohideFloat: "single-branch",
      className: "items-center text-neutral-200 flex gap-1 col-start-3 row-start-2 -ml-1 data-[floating]:bg-background data-[floating]:absolute data-[floating]:rounded-md data-[floating]:border data-[floating]:p-1 data-[floating]:shadow-sm",
      children: [
        /* @__PURE__ */ d.jsx(Jt, { hasContent: !0, children: /* @__PURE__ */ d.jsx(Fl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(qt, { tooltip: e($t.copy), children: [
          /* @__PURE__ */ d.jsx(Jt, { copied: !0, children: /* @__PURE__ */ d.jsx(So, {}) }),
          /* @__PURE__ */ d.jsx(Jt, { copied: !1, children: /* @__PURE__ */ d.jsx(Cl, {}) })
        ] }) }) }),
        /* @__PURE__ */ d.jsxs(Jt, { last: !0, children: [
          /* @__PURE__ */ d.jsx(sg, { asChild: !0, children: /* @__PURE__ */ d.jsx(qt, { tooltip: "Refresh", children: /* @__PURE__ */ d.jsx(yE, {}) }) }),
          /* @__PURE__ */ d.jsxs(Jt, { hasContent: !0, children: [
            /* @__PURE__ */ d.jsx(ag, { asChild: !0, children: /* @__PURE__ */ d.jsx(Bp, { type: "positive" }) }),
            /* @__PURE__ */ d.jsx(og, { asChild: !0, children: /* @__PURE__ */ d.jsx(Bp, { type: "negative", hasDialog: !0 }) })
          ] })
        ] }),
        /* @__PURE__ */ d.jsx(mT, {})
      ]
    }
  );
}, Cn = {
  threadId: "thread_id",
  threadPrompt: "thread_prompt",
  threadPromptPage: "thread_prompt_page",
  quickPromptId: "quick_prompt_id"
}, zU = ({ children: e }) => {
  const t = J((O) => O?.threadListItem?.remoteId), n = J((O) => O?.threads?.threadIds), r = J((O) => O?.threads?.isLoading), s = J((O) => O?.thread?.isLoading), i = Re(), a = Vp(), { search: o, pathname: u } = WT(), c = ie(() => new URLSearchParams(o), [o]), l = c.get(Cn.threadId), h = c.get(Cn.threadPrompt), m = c.get(Cn.threadPromptPage), p = c.get(Cn.quickPromptId), E = Ke(!0), { setIsPrePrompt: g, setPage: _ } = _s(), { setQuickPromptId: b } = Rl(), [T, C] = de(!1), R = ne(() => {
    const O = `${u}?${c.toString()}`;
    a.replace(O);
  }, [a, c, u]), D = ne(() => {
    c.delete(Cn.threadPrompt), c.delete(Cn.threadPromptPage), c.delete(Cn.quickPromptId);
  }, [c]), I = ne(async () => {
    if (h)
      return new Promise((O) => {
        m && _({ page: m }), p && b(p), g(!0), E.current = !1, i.threads().switchToNewThread(), setTimeout(() => {
          i.thread().append({
            role: "user",
            content: [{ type: "text", text: h }]
          }), setTimeout(O, 100);
        }, 100);
      });
  }, [m, p, h, g, i, _, b]);
  return xe(() => {
    !r && !n.length || C(!0);
  }, [r, n]), xe(() => {
    s || !t || t === l || h || (E.current = !1, c.set(Cn.threadId, t), R());
  }, [t, s, l, c, u, R, h]), xe(() => {
    const O = n.find((U) => U === l);
    !E.current || !l || !i || !O || h || (E.current = !1, i.threads().switchToThread(O));
  }, [i, l, n, h]), xe(() => {
    !i || r || !T || !h || I().then(() => {
      D(), R();
    }).catch((O) => {
      console.error("INITIAL PROMPT BY URL", O);
    });
  }, [
    i,
    T,
    I,
    r,
    h,
    u,
    c,
    D,
    R
  ]), /* @__PURE__ */ d.jsx(d.Fragment, { children: e });
}, VU = he(zU), YU = "zai-chat:modal-upload-open", GU = "zai-chat:modal-info-open", zp = "zai-chat:file-count-refetch", WU = () => {
  const e = Ke(null), t = ne(() => {
    window.dispatchEvent(new CustomEvent(YU));
  }, []), n = ne(() => {
    window.dispatchEvent(new CustomEvent(GU));
  }, []);
  return xe(() => {
    const r = () => {
      e.current?.refetch();
    };
    return window.addEventListener(zp, r), () => {
      window.removeEventListener(zp, r);
    };
  }, []), {
    handleModalUploadOpen: t,
    handleModalInfoOpen: n,
    fileUploadRef: e
  };
};
function UF({ isZaiRagEnabled: e }) {
  const { assistantUiIsReady: t } = pt(), { handleModalUploadOpen: n, handleModalInfoOpen: r, fileUploadRef: s } = WU(), { setOrigin: i } = _s();
  return xe(() => {
    i({ origin: "center-stage" });
  }, [i]), /* @__PURE__ */ d.jsx("main", { id: "zai-chat-center-stage", className: "zai-chat-package dark", style: { height: "100%" }, children: /* @__PURE__ */ d.jsx(fd, { theme: "dark", children: /* @__PURE__ */ d.jsx(wl, { theme: "dark", children: t && /* @__PURE__ */ d.jsx(VU, { children: /* @__PURE__ */ d.jsxs(
    Hk,
    {
      className: "h-full min-h-0 relative",
      style: {
        "--sidebar-width": "calc(328px + 2rem)"
      },
      children: [
        /* @__PURE__ */ d.jsx(Xk, { isZaiRagEnabled: e }),
        e && /* @__PURE__ */ d.jsx("div", { className: "absolute bottom-0 px-4 pb-4", style: { width: "var(--sidebar-width)" }, children: /* @__PURE__ */ d.jsx(
          hb,
          {
            onButtonClick: n,
            onInfoClick: r,
            ref: s
          }
        ) }),
        /* @__PURE__ */ d.jsx(Uk, { className: "bg-transparent", children: /* @__PURE__ */ d.jsx("div", { className: "grid h-full p-4 pl-0", children: /* @__PURE__ */ d.jsx(wo, { children: /* @__PURE__ */ d.jsx(AT, { className: "bg-background" }) }) }) })
      ]
    }
  ) }) }) }) });
}
const qU = he(({ isOpen: e, children: t }) => /* @__PURE__ */ d.jsx("div", { className: "aside-modal-view-container", "data-open": e, "aria-hidden": !e, children: t })), KU = he(({ children: e, isOpen: t }) => /* @__PURE__ */ d.jsx(qU, { isOpen: t, children: e })), QU = he(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "button-arrow", onClick: e, children: /* @__PURE__ */ d.jsx(t, { width: 28, height: 28 }) })), XU = he(({ handleClick: e }) => /* @__PURE__ */ d.jsx(QU, { handleClick: e, Icon: AE })), JU = he(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "button-expand", onClick: e, children: /* @__PURE__ */ d.jsx(t, {}) })), ZU = he(({ handleClick: e }) => /* @__PURE__ */ d.jsx(JU, { handleClick: e, Icon: nN })), eF = he(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "menu-hamburger", onClick: e, children: /* @__PURE__ */ d.jsx(t, {}) })), tF = he(({ handleClick: e }) => /* @__PURE__ */ d.jsx(eF, { handleClick: e, Icon: Mv })), nF = he(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "button-x", onClick: e, children: /* @__PURE__ */ d.jsx(t, { width: 28, height: 28 }) })), rF = he(({ handleClick: e }) => /* @__PURE__ */ d.jsx(nF, { handleClick: e, Icon: xE })), sF = he(
  ({ handleButtonMenuClick: e, handleItemClick: t, CloseComponent: n }) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-aside-header", children: /* @__PURE__ */ d.jsx(n, { handleClick: () => e({ isOpen: !1 }) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-aside-content", children: /* @__PURE__ */ d.jsx(YE, { handleItemClick: t }) })
  ] })
), iF = () => /* @__PURE__ */ d.jsx(wo, { children: /* @__PURE__ */ d.jsx(AT, {}) }), aF = he(iF), oF = he(
  ({
    handleButtonCloseClick: e,
    handleButtonMenuClick: t,
    handleButtonRedirectClick: n,
    LogoComponent: r,
    MenuComponent: s,
    CloseComponent: i,
    RedirectComponent: a
  }) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-header-box-left", children: /* @__PURE__ */ d.jsx(s, { handleClick: () => t({ isOpen: !0 }) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-header-box-middle", children: /* @__PURE__ */ d.jsx(r, {}) }),
    /* @__PURE__ */ d.jsxs("div", { className: "side-modal-view-header-box-right", children: [
      /* @__PURE__ */ d.jsx(a, { handleClick: n }),
      /* @__PURE__ */ d.jsx(i, { handleClick: e })
    ] })
  ] })
), uF = ({
  isAsideModalOpen: e,
  setIsAsideModalOpen: t,
  threadId: n,
  mixpanelSetOrigin: r
}) => {
  const s = Vp(), [i, a] = de({
    isAsideContentOpen: !1
  });
  xe(() => {
    e && (br.track(Er.sideChatOpen), r({ origin: "side-chat" }));
  }, [e, r]);
  const o = ne(
    ({ isOpen: h }) => a((m) => ({ ...m, isAsideContentOpen: h })),
    []
  ), u = ne(() => {
    br.track(Er.sideChatClose), t(!1);
  }, [t]), c = ne(
    () => s.push(`/zai${n ? `?${Cn.threadId}=${n}` : ""}`),
    [s, n]
  ), l = ne(
    () => a((h) => ({ ...h, isAsideContentOpen: !1 })),
    [a]
  );
  return {
    sideChatStates: i,
    handles: {
      sideChat: {
        handleButtonMenuClick: o,
        handleButtonCloseClick: u,
        handleButtonRedirectClick: c,
        handleThreadListItemClick: l
      }
    }
  };
}, cF = he(
  ({
    ContentComponent: e,
    AsideContentComponent: t,
    AsideCloseComponent: n,
    HeaderComponent: r,
    HeaderLogoComponent: s,
    HeaderMenuComponent: i,
    HeaderCloseComponent: a,
    HeaderRedirectComponent: o,
    ...u
  }) => /* @__PURE__ */ d.jsxs("div", { className: "side-modal-view-container", children: [
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-header", children: /* @__PURE__ */ d.jsx(
      r,
      {
        handleButtonCloseClick: u.handleButtonCloseClick,
        handleButtonMenuClick: u.handleButtonMenuClick,
        handleButtonRedirectClick: u.handleButtonRedirectClick,
        LogoComponent: s,
        MenuComponent: i,
        CloseComponent: a,
        RedirectComponent: o
      }
    ) }),
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-content h-full flex flex-col overflow-y-scroll", children: /* @__PURE__ */ d.jsx(e, {}) }),
    /* @__PURE__ */ d.jsx(
      "div",
      {
        className: "side-modal-view-aside",
        "data-open": u.isAsideContentOpen,
        "aria-hidden": !u.isAsideContentOpen,
        children: /* @__PURE__ */ d.jsx(
          t,
          {
            handleButtonMenuClick: u.handleButtonMenuClick,
            handleItemClick: u.handleThreadListItemClick,
            CloseComponent: n
          }
        )
      }
    )
  ] })
), lF = he(({ isAsideModalOpen: e, setIsAsideModalOpen: t }) => {
  const n = J((i) => i?.threadListItem?.remoteId), { setOrigin: r } = _s(), s = uF({
    isAsideModalOpen: e,
    setIsAsideModalOpen: t,
    threadId: n,
    mixpanelSetOrigin: r
  });
  return /* @__PURE__ */ d.jsx(KU, { isOpen: e, children: /* @__PURE__ */ d.jsx(
    cF,
    {
      ...s.handles.sideChat,
      ...s.sideChatStates,
      HeaderComponent: oF,
      HeaderLogoComponent: KE,
      HeaderMenuComponent: tF,
      HeaderCloseComponent: rF,
      HeaderRedirectComponent: ZU,
      ContentComponent: aF,
      AsideContentComponent: sF,
      AsideCloseComponent: XU
    }
  ) });
});
function FF({ isOpen: e, onOpenChange: t }) {
  const { assistantUiIsReady: n } = pt();
  return /* @__PURE__ */ d.jsx("main", { className: "zai-chat-package dark", children: /* @__PURE__ */ d.jsx(fd, { theme: "dark", children: /* @__PURE__ */ d.jsx(wl, { theme: "dark", children: n && /* @__PURE__ */ d.jsx(lF, { isAsideModalOpen: e, setIsAsideModalOpen: t }) }) }) });
}
const ca = 100, dF = (e) => {
  const {
    contextKey: t,
    threadPrompt: n,
    skipResponseInteraction: r,
    mixpanelSetOrigin: s,
    mixpanelSetIsProactiveMessage: i,
    currentAssistUiThreadId: a,
    currentSectionThreadId: o,
    setCurrentSectionThreadId: u,
    getLastSentPrompt: c,
    setLastSentPrompt: l,
    assistRuntime: h
  } = e, [m, p] = de(!1), [E, g] = de(!1), _ = Ke(!1), b = ie(
    () => n !== c(t),
    [t, c, n]
  );
  return xe(() => {
    !m || !a || u({ contextKey: t, id: a });
  }, [t, m, a, u]), xe(() => {
    if (_.current && !b || (_.current = !0, s({ origin: t }), g(!0), !b && a && o && a === o))
      return;
    if (!b && o) {
      h.threads().switchToThread(o);
      return;
    }
    if (b && o) {
      i(!0), h.threads().switchToThread(o);
      let C;
      const R = setTimeout(() => {
        h.thread().cancelRun(), C = setTimeout(() => {
          h.thread().append({
            role: "user",
            content: [{ type: "text", text: n }],
            runConfig: { custom: { skipResponseInteraction: r } }
          }), l({ contextKey: t, prompt: n });
        }, ca);
      }, ca);
      return () => {
        clearTimeout(R), clearTimeout(C);
      };
    }
    h.threads().switchToNewThread();
    const T = setTimeout(() => {
      i(!0), h.thread().append({
        role: "user",
        content: [{ type: "text", text: n }],
        runConfig: { custom: { skipResponseInteraction: r } }
      }), l({ contextKey: t, prompt: n }), setTimeout(() => p(!0), ca);
    }, ca);
    return () => clearTimeout(T);
  }, [
    t,
    n,
    r,
    a,
    o,
    b,
    s,
    i,
    h,
    l
  ]), {
    shouldRender: E
  };
}, hF = {
  promptTitle: {
    key: "zai.section.heading-title",
    defaultValue: "Conversa com assistente..."
  }
}, fF = 1, pF = ({ className: e, welcomeMessage: t }) => {
  const n = J((s) => s?.thread?.isLoading), { t: r } = Fe();
  return /* @__PURE__ */ d.jsx(
    yl,
    {
      className: le("box-border flex h-full flex-col overflow-hidden rounded-xl relative", e),
      style: { "--thread-max-width": "100%" },
      children: /* @__PURE__ */ d.jsxs(xl, { className: "flex h-full flex-col items-center overflow-y-scroll scroll-smooth px-4 pt-8 mb-32", children: [
        n && /* @__PURE__ */ d.jsx("div", { className: "flex flex-grow items-center justify-center", children: t || r($t.loading) }),
        !n && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsx("h3", { className: "text-lg font-semibold mb-3 w-full", children: t || r(hF.promptTitle) }),
          /* @__PURE__ */ d.jsx(mF, {}),
          /* @__PURE__ */ d.jsx(di, { empty: !1, children: /* @__PURE__ */ d.jsx("div", { className: "min-h-8 flex-grow" }) }),
          /* @__PURE__ */ d.jsxs("div", { className: "fixed self-center-safe bottom-0 flex w-full max-w-[68rem] flex-col items-center justify-end rounded-t-lg bg-inherit px-4 pb-7 z-[10]", children: [
            /* @__PURE__ */ d.jsx(gF, {}),
            /* @__PURE__ */ d.jsx(bT, {})
          ] }),
          /* @__PURE__ */ d.jsx(
            "div",
            {
              "aria-hidden": "true",
              className: "fixed bottom-0 left-0 right-0 h-30 bg-gradient-to-t from-background via-background/80 to-transparent pointer-events-none z-[5]"
            }
          )
        ] })
      ] })
    }
  );
}, mF = () => {
  const e = J((r) => r?.thread?.messages?.length), [t, n] = de(!1);
  return rs(() => {
    n(!0);
  }, []), !t || e === 0 ? null : /* @__PURE__ */ d.jsx(d.Fragment, { children: Array.from({ length: e }, (r, s) => s < fF ? null : /* @__PURE__ */ d.jsx(
    Qc,
    {
      index: s,
      components: {
        UserMessage: TT,
        EditComposer: _T,
        AssistantMessage: EF
      }
    },
    s
  )) });
}, gF = () => {
  const { t: e } = Fe();
  return /* @__PURE__ */ d.jsx(pE, { asChild: !0, children: /* @__PURE__ */ d.jsx(
    qt,
    {
      tooltip: e($t.scrollToBottom),
      variant: "outline",
      side: "top",
      className: "absolute -top-8 rounded-full disabled:invisible",
      children: /* @__PURE__ */ d.jsx(_E, {})
    }
  ) });
}, EF = () => {
  const { t: e } = Fe(), t = J((n) => n?.message?.status?.type === "complete");
  return /* @__PURE__ */ d.jsxs(
    xo,
    {
      className: `
        grid
        grid-cols-[auto_auto_1fr]
        grid-rows-[auto_1fr]
        relative
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `
          text-foreground
          max-w-[var(--thread-max-width)]
          break-words
          leading-7
          col-span-2
          col-start-2
          row-start-1
          my-1.5
        `,
            children: [
              /* @__PURE__ */ d.jsx(pT, {}),
              /* @__PURE__ */ d.jsx(ET, {}),
              /* @__PURE__ */ d.jsx(
                Co,
                {
                  components: {
                    Text: lT,
                    ToolGroup: () => null,
                    tools: {
                      Fallback: void 0
                    }
                  }
                }
              ),
              t && /* @__PURE__ */ d.jsx(hT, {}),
              /* @__PURE__ */ d.jsx(Al, { children: /* @__PURE__ */ d.jsx("div", { className: "rounded-lg p-2 text-sm bg-red-500/10 border border-red-500/20", children: /* @__PURE__ */ d.jsx("p", { children: e($t.somethingWentWrong) }) }) })
            ]
          }
        ),
        /* @__PURE__ */ d.jsx(bF, {}),
        /* @__PURE__ */ d.jsx(pd, { className: "col-start-2 row-start-2 -ml-2 mr-2" })
      ]
    }
  );
}, bF = () => {
  const { t: e } = Fe();
  return /* @__PURE__ */ d.jsxs(
    ao,
    {
      hideWhenRunning: !0,
      autohide: "never",
      autohideFloat: "single-branch",
      className: "items-center text-muted-foreground flex gap-1 col-start-3 row-start-2 -ml-1 data-[floating]:bg-background data-[floating]:absolute data-[floating]:rounded-md data-[floating]:border data-[floating]:p-1 data-[floating]:shadow-sm",
      children: [
        /* @__PURE__ */ d.jsx(Jt, { hasContent: !0, children: /* @__PURE__ */ d.jsx(Fl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(qt, { tooltip: e($t.copy), children: [
          /* @__PURE__ */ d.jsx(Jt, { copied: !0, children: /* @__PURE__ */ d.jsx(So, {}) }),
          /* @__PURE__ */ d.jsx(Jt, { copied: !1, children: /* @__PURE__ */ d.jsx(Cl, {}) })
        ] }) }) }),
        /* @__PURE__ */ d.jsx(Jt, { last: !0, children: /* @__PURE__ */ d.jsx(sg, { asChild: !0, children: /* @__PURE__ */ d.jsx(qt, { tooltip: "Refresh", children: /* @__PURE__ */ d.jsx(yE, {}) }) }) }),
        /* @__PURE__ */ d.jsx(mT, {})
      ]
    }
  );
}, _F = (e) => /* @__PURE__ */ d.jsx(wo, { children: /* @__PURE__ */ d.jsx(pF, { welcomeMessage: e.welcomeMessage }) }), TF = ({
  contextKey: e,
  threadPrompt: t,
  theme: n = "light",
  welcomeMessage: r,
  skipResponseInteraction: s
}) => {
  const { setOrigin: i, setIsProactiveMessage: a } = _s(), o = Re(), u = J((E) => E?.threadListItem?.remoteId), { getCurrentThreadId: c, setCurrentThreadId: l, getLastPrompt: h, setLastPrompt: m } = VE(), { shouldRender: p } = dF({
    contextKey: e,
    threadPrompt: t,
    skipResponseInteraction: s,
    mixpanelSetOrigin: i,
    mixpanelSetIsProactiveMessage: a,
    currentAssistUiThreadId: u,
    currentSectionThreadId: c(e),
    setCurrentSectionThreadId: l,
    getLastSentPrompt: h,
    setLastSentPrompt: m,
    assistRuntime: o
  });
  return p ? /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `zai-chat-package ${n}`,
      style: { flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column", position: "relative" },
      children: /* @__PURE__ */ d.jsx(fd, { theme: n, children: /* @__PURE__ */ d.jsx(wl, { theme: n, children: /* @__PURE__ */ d.jsx(_F, { welcomeMessage: r }) }) })
    }
  ) : null;
}, jF = (e) => {
  const { assistantUiIsReady: t } = pt();
  return t ? /* @__PURE__ */ d.jsx(TF, { ...e }) : null;
};
export {
  zp as ZAI_CHAT_FILE_COUNT_REFETCH_EVENT,
  GU as ZAI_CHAT_MODAL_INFO_OPEN_EVENT,
  YU as ZAI_CHAT_MODAL_UPLOAD_OPEN_EVENT,
  BF as ZaiChatAccessProvider,
  UF as ZaiChatCenterStage,
  jF as ZaiChatSection,
  FF as ZaiChatSideChat
};
